[
  {
    "_id": "1",
    "school_code": "689016",
    "school_name_1": "Monseigneur-Scheffer",
    "admin_body_number": "689000",
    "admin_body_name": "Centre de services scolaire du Littoral",
    "area_name": "Côte-Nord ",
    "étudiants": "53",
    "langue": "français",
    "secteur": "public",
    "rang": "126",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "47.2",
    "rang_2024": "126/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "69.8",
    "lens_2024": "63.3",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "88.8",
    "lsec_2024": "80.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "80.4",
    "scie_2024": "78.3",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "80.0",
    "math_2024": "83.2",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "5.8",
    "echec_2024": "15.4",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "3.3",
    "sures_2024": "4.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "22.2",
    "prog_2024": "0.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "7.7",
    "cote_2024": "6.9",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Monseigneur-Scheffer",
    "nom_court": "École Monseigneur-Scheffer",
    "adresse": "20, rue Mgr-Scheffer",
    "municipalite": "Blanc-Sablon",
    "code_postal": "G0G 1W0",
    "lat": 51.41444,
    "lng": -57.18719
  },
  {
    "_id": "2",
    "school_code": "711021",
    "school_name_1": "Armand-Saint-Onge",
    "admin_body_number": "711000",
    "admin_body_name": "Centre de services scolaire des Monts-et-Marées",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "728",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "14.6",
    "ehdaa_2024": "39.1",
    "rang_2024": "217/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "73.3",
    "lens_2019": "71.2",
    "lens_2022": "66.4",
    "lens_2023": "69.9",
    "lens_2024": "68.2",
    "lens_trend": "—",
    "lsec_2018": "80.1",
    "lsec_2019": "80.4",
    "lsec_2022": "78.8",
    "lsec_2023": "81.0",
    "lsec_2024": "81.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.8",
    "scie_2019": "75.9",
    "scie_2022": "70.8",
    "scie_2023": "76.7",
    "scie_2024": "71.6",
    "scie_trend": "—",
    "math_2018": "69.0",
    "math_2019": "70.9",
    "math_2022": "72.5",
    "math_2023": "74.7",
    "math_2024": "71.5",
    "math_trend": "—",
    "echec_2018": "14.7",
    "echec_2019": "15.4",
    "echec_2022": "19.6",
    "echec_2023": "15.0",
    "echec_2024": "15.7",
    "echec_trend": "—",
    "sures_2018": "4.4",
    "sures_2019": "4.5",
    "sures_2022": "5.7",
    "sures_2023": "2.4",
    "sures_2024": "2.8",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 4.1",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 1.9",
    "ecart_sexes_lens_2023": "F 6.6",
    "ecart_sexes_lens_2024": "M 1.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.4",
    "ecart_sexes_math_2019": "F 1.7",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "M 6.7",
    "ecart_sexes_math_2024": "M 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.0",
    "prog_2019": "33.0",
    "prog_2022": "31.0",
    "prog_2023": "35.6",
    "prog_2024": "30.8",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.5",
    "cote_2022": "5.5",
    "cote_2023": "5.8",
    "cote_2024": "6.0",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Secondaire Armand-Saint-Onge",
    "nom_court": "École Secondaire Armand-Saint-Onge",
    "adresse": "95, avenue du Parc",
    "municipalite": "Amqui",
    "code_postal": "G5J 2L8",
    "lat": 48.46066,
    "lng": -67.43888
  },
  {
    "_id": "3",
    "school_code": "711059",
    "school_name_1": "Matane",
    "admin_body_number": "711000",
    "admin_body_name": "Centre de services scolaire des Monts-et-Marées",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "901",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "11",
    "ehdaa_2024": "28",
    "rang_2024": "277/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "67.7",
    "lens_2019": "68.9",
    "lens_2022": "63.9",
    "lens_2023": "71.2",
    "lens_2024": "70.8",
    "lens_trend": "112233",
    "lsec_2018": "79.1",
    "lsec_2019": "79.7",
    "lsec_2022": "76.5",
    "lsec_2023": "76.7",
    "lsec_2024": "77.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.1",
    "scie_2019": "71.8",
    "scie_2022": "75.8",
    "scie_2023": "78.3",
    "scie_2024": "72.0",
    "scie_trend": "—",
    "math_2018": "72.5",
    "math_2019": "69.9",
    "math_2022": "73.2",
    "math_2023": "73.7",
    "math_2024": "73.9",
    "math_trend": "—",
    "echec_2018": "15.2",
    "echec_2019": "18.1",
    "echec_2022": "18.5",
    "echec_2023": "10.6",
    "echec_2024": "12.7",
    "echec_trend": "112233",
    "sures_2018": "3.8",
    "sures_2019": "5.5",
    "sures_2022": "5.0",
    "sures_2023": "2.6",
    "sures_2024": "5.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.3",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "M 0.7",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 12.7",
    "ecart_sexes_math_2019": "F 9.0",
    "ecart_sexes_math_2022": "M 10.5",
    "ecart_sexes_math_2023": "F 4.1",
    "ecart_sexes_math_2024": "F 4.5",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "28.5",
    "prog_2019": "34.5",
    "prog_2022": "33.1",
    "prog_2023": "36.2",
    "prog_2024": "31.4",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "4.8",
    "cote_2022": "5.0",
    "cote_2023": "6.0",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Matane",
    "nom_court": "École secondaire de Matane",
    "adresse": "455, avenue Saint-Rédempteur",
    "municipalite": "Matane",
    "code_postal": "G4W 1K7",
    "lat": 48.842,
    "lng": -67.50889
  },
  {
    "_id": "4",
    "school_code": "712003",
    "school_name_1": "Paul-Hubert",
    "admin_body_number": "712000",
    "admin_body_name": "Centre de services scolaire des Phares",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "1677",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "8",
    "ehdaa_2024": "35.8",
    "rang_2024": "238/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "72.3",
    "lens_2019": "73.8",
    "lens_2022": "68.8",
    "lens_2023": "71.2",
    "lens_2024": "70.7",
    "lens_trend": "—",
    "lsec_2018": "76.6",
    "lsec_2019": "77.2",
    "lsec_2022": "79.8",
    "lsec_2023": "78.6",
    "lsec_2024": "79.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.1",
    "scie_2019": "69.1",
    "scie_2022": "70.5",
    "scie_2023": "76.6",
    "scie_2024": "71.2",
    "scie_trend": "—",
    "math_2018": "70.4",
    "math_2019": "70.3",
    "math_2022": "72.6",
    "math_2023": "73.9",
    "math_2024": "74.3",
    "math_trend": "—",
    "echec_2018": "15.4",
    "echec_2019": "17.8",
    "echec_2022": "18.3",
    "echec_2023": "13.9",
    "echec_2024": "16.6",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "2.9",
    "sures_2022": "3.6",
    "sures_2023": "0.7",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 6.5",
    "ecart_sexes_lens_2024": "F 4.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.3",
    "ecart_sexes_math_2019": "F 4.3",
    "ecart_sexes_math_2022": "F 0.5",
    "ecart_sexes_math_2023": "F 2.0",
    "ecart_sexes_math_2024": "F 4.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.1",
    "prog_2019": "27.2",
    "prog_2022": "21.2",
    "prog_2023": "27.3",
    "prog_2024": "28.8",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.2",
    "cote_2022": "6.1",
    "cote_2023": "6.2",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Paul-Hubert",
    "nom_court": "École Paul-Hubert",
    "adresse": "250, boulevard Arthur-Buies Ouest",
    "municipalite": "Rimouski",
    "code_postal": "G5L 7A7",
    "lat": 48.43522,
    "lng": -68.51999
  },
  {
    "_id": "5",
    "school_code": "712005",
    "school_name_1": "du le Mistral",
    "admin_body_number": "712000",
    "admin_body_name": "Centre de services scolaire des Phares",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "835",
    "langue": "français",
    "secteur": "public",
    "rang": "387",
    "rang_5_ans": "396",
    "index": "0.1",
    "en_retard_2024": "12.1",
    "ehdaa_2024": "41.8",
    "rang_2024": "387/470",
    "rang_2019_2024": "396/432",
    "lens_2018": "65.6",
    "lens_2019": "70.2",
    "lens_2022": "64.6",
    "lens_2023": "65.2",
    "lens_2024": "64.0",
    "lens_trend": "—",
    "lsec_2018": "74.4",
    "lsec_2019": "78.3",
    "lsec_2022": "74.6",
    "lsec_2023": "72.7",
    "lsec_2024": "74.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.9",
    "scie_2019": "65.7",
    "scie_2022": "62.6",
    "scie_2023": "68.7",
    "scie_2024": "63.3",
    "scie_trend": "—",
    "math_2018": "59.5",
    "math_2019": "65.4",
    "math_2022": "73.0",
    "math_2023": "68.0",
    "math_2024": "77.2",
    "math_trend": "112233",
    "echec_2018": "25.3",
    "echec_2019": "22.0",
    "echec_2022": "29.6",
    "echec_2023": "24.6",
    "echec_2024": "24.2",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "3.7",
    "sures_2022": "3.8",
    "sures_2023": "3.7",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.5",
    "ecart_sexes_lens_2019": "F 6.6",
    "ecart_sexes_lens_2022": "F 7.1",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 8.5",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 9.0",
    "ecart_sexes_math_2023": "M 2.9",
    "ecart_sexes_math_2024": "F 7.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.8",
    "prog_2019": "45.4",
    "prog_2022": "43.8",
    "prog_2023": "53.7",
    "prog_2024": "46.7",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "4.2",
    "cote_2022": "4.1",
    "cote_2023": "3.7",
    "cote_2024": "4.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École du Mistral",
    "nom_court": "École du Mistral",
    "adresse": "254, avenue Ross",
    "municipalite": "Mont-Joli",
    "code_postal": "G5H 3M4",
    "lat": 48.58266,
    "lng": -68.19935
  },
  {
    "_id": "6",
    "school_code": "713013",
    "school_name_1": "Vallée-des-Lacs",
    "admin_body_number": "713000",
    "admin_body_name": "Centre de services scolaire du Fleuve-et-des-Lacs",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "88",
    "langue": "français",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "33",
    "rang_2024": "112/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "nd",
    "lens_2024": "74.0",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "nd",
    "lsec_2024": "79.4",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "nd",
    "scie_2024": "69.3",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "nd",
    "math_2024": "79.9",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "nd",
    "echec_2024": "13.3",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "nd",
    "sures_2024": "2.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "nd",
    "prog_2024": "33.3",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "nd",
    "cote_2024": "7.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de la Vallée-des-Lacs",
    "nom_court": "École de la Vallée-des-Lacs",
    "adresse": "149, rue Saint-Joseph",
    "municipalite": "Saint-Michel-du-Squatec",
    "code_postal": "G0L 4H0",
    "lat": 47.88281,
    "lng": -68.71967
  },
  {
    "_id": "7",
    "school_code": "713020",
    "school_name_1": "Dégelis",
    "admin_body_number": "713000",
    "admin_body_name": "Centre de services scolaire du Fleuve-et-des-Lacs",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "264",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "19.1",
    "ehdaa_2024": "33",
    "rang_2024": "182/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "78.8",
    "lens_2019": "71.1",
    "lens_2022": "59.4",
    "lens_2023": "66.6",
    "lens_2024": "63.9",
    "lens_trend": "—",
    "lsec_2018": "76.4",
    "lsec_2019": "74.4",
    "lsec_2022": "71.9",
    "lsec_2023": "78.5",
    "lsec_2024": "81.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.7",
    "scie_2019": "75.0",
    "scie_2022": "71.3",
    "scie_2023": "73.6",
    "scie_2024": "75.7",
    "scie_trend": "—",
    "math_2018": "72.5",
    "math_2019": "73.7",
    "math_2022": "76.2",
    "math_2023": "72.6",
    "math_2024": "78.6",
    "math_trend": "—",
    "echec_2018": "6.3",
    "echec_2019": "11.8",
    "echec_2022": "27.1",
    "echec_2023": "16.6",
    "echec_2024": "11.7",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "3.2",
    "sures_2022": "7.1",
    "sures_2023": "4.5",
    "sures_2024": "5.3",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 7.0",
    "ecart_sexes_lens_2024": "F 0.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "29.5",
    "prog_2019": "18.4",
    "prog_2022": "21.9",
    "prog_2023": "43.6",
    "prog_2024": "22.1",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "5.8",
    "cote_2022": "3.6",
    "cote_2023": "4.8",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Dégelis",
    "nom_court": "École secondaire de Dégelis",
    "adresse": "385, avenue Principale",
    "municipalite": "Dégelis",
    "code_postal": "G5T 1L3",
    "lat": 47.54979,
    "lng": -68.64474
  },
  {
    "_id": "8",
    "school_code": "713121",
    "school_name_1": "Cabano",
    "admin_body_number": "713000",
    "admin_body_name": "Centre de services scolaire du Fleuve-et-des-Lacs",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "383",
    "langue": "français",
    "secteur": "public",
    "rang": "294",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "14.5",
    "ehdaa_2024": "36",
    "rang_2024": "294/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "69.3",
    "lens_2019": "71.6",
    "lens_2022": "60.6",
    "lens_2023": "68.3",
    "lens_2024": "64.6",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "80.3",
    "lsec_2022": "78.9",
    "lsec_2023": "80.1",
    "lsec_2024": "81.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.2",
    "scie_2019": "70.6",
    "scie_2022": "63.2",
    "scie_2023": "69.8",
    "scie_2024": "65.4",
    "scie_trend": "—",
    "math_2018": "77.4",
    "math_2019": "76.1",
    "math_2022": "58.7",
    "math_2023": "75.9",
    "math_2024": "75.3",
    "math_trend": "—",
    "echec_2018": "9.8",
    "echec_2019": "11.5",
    "echec_2022": "37.1",
    "echec_2023": "12.8",
    "echec_2024": "21.2",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "1.1",
    "sures_2022": "6.6",
    "sures_2023": "1.9",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 5.5",
    "ecart_sexes_lens_2022": "F 2.8",
    "ecart_sexes_lens_2023": "F 5.7",
    "ecart_sexes_lens_2024": "F 1.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.1",
    "ecart_sexes_math_2019": "M 0.3",
    "ecart_sexes_math_2022": "F 20.4",
    "ecart_sexes_math_2023": "F 11.6",
    "ecart_sexes_math_2024": "M 7.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.2",
    "prog_2019": "18.4",
    "prog_2022": "21.7",
    "prog_2023": "34.9",
    "prog_2024": "24.8",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.8",
    "cote_2022": "3.6",
    "cote_2023": "5.7",
    "cote_2024": "5.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Cabano",
    "nom_court": "École secondaire de Cabano",
    "adresse": "120, boulevard Phil-Latulippe",
    "municipalite": "Témiscouata-sur-le-Lac",
    "code_postal": "G0L 1E0",
    "lat": 47.67865,
    "lng": -68.88413
  },
  {
    "_id": "9",
    "school_code": "713127",
    "school_name_1": "Trois-Pistoles",
    "admin_body_number": "713000",
    "admin_body_name": "Centre de services scolaire du Fleuve-et-des-Lacs",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "335",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "9.9",
    "ehdaa_2024": "38.2",
    "rang_2024": "238/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "72.4",
    "lens_2019": "69.7",
    "lens_2022": "59.6",
    "lens_2023": "67.0",
    "lens_2024": "65.3",
    "lens_trend": "—",
    "lsec_2018": "79.7",
    "lsec_2019": "79.4",
    "lsec_2022": "83.3",
    "lsec_2023": "85.3",
    "lsec_2024": "81.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.1",
    "scie_2019": "72.3",
    "scie_2022": "69.3",
    "scie_2023": "74.2",
    "scie_2024": "75.1",
    "scie_trend": "—",
    "math_2018": "74.0",
    "math_2019": "76.2",
    "math_2022": "68.1",
    "math_2023": "69.7",
    "math_2024": "77.6",
    "math_trend": "—",
    "echec_2018": "9.6",
    "echec_2019": "15.5",
    "echec_2022": "26.8",
    "echec_2023": "16.7",
    "echec_2024": "14.8",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "4.2",
    "sures_2022": "7.6",
    "sures_2023": "3.5",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.0",
    "ecart_sexes_lens_2019": "F 0.5",
    "ecart_sexes_lens_2022": "F 9.7",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 2.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 9.4",
    "ecart_sexes_math_2022": "M 3.1",
    "ecart_sexes_math_2023": "M 6.3",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.0",
    "prog_2019": "17.3",
    "prog_2022": "26.7",
    "prog_2023": "34.4",
    "prog_2024": "33.1",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "5.8",
    "cote_2022": "4.7",
    "cote_2023": "5.5",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Trois-Pistoles",
    "nom_court": "École secondaire de Trois-Pistoles",
    "adresse": "455, rue Jenkin",
    "municipalite": "Trois-Pistoles",
    "code_postal": "G0L 4K0",
    "lat": 48.1194,
    "lng": -69.17519
  },
  {
    "_id": "10",
    "school_code": "713132",
    "school_name_1": "Transcontinental",
    "admin_body_number": "713000",
    "admin_body_name": "Centre de services scolaire du Fleuve-et-des-Lacs",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "193",
    "langue": "français",
    "secteur": "public",
    "rang": "69",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "13.3",
    "ehdaa_2024": "46.1",
    "rang_2024": "69/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "68.0",
    "lens_2019": "73.3",
    "lens_2022": "67.8",
    "lens_2023": "64.4",
    "lens_2024": "69.9",
    "lens_trend": "—",
    "lsec_2018": "80.1",
    "lsec_2019": "77.2",
    "lsec_2022": "78.1",
    "lsec_2023": "78.9",
    "lsec_2024": "85.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.6",
    "scie_2019": "76.5",
    "scie_2022": "70.6",
    "scie_2023": "75.8",
    "scie_2024": "76.7",
    "scie_trend": "—",
    "math_2018": "67.3",
    "math_2019": "78.2",
    "math_2022": "72.1",
    "math_2023": "71.5",
    "math_2024": "82.7",
    "math_trend": "—",
    "echec_2018": "16.6",
    "echec_2019": "7.3",
    "echec_2022": "16.4",
    "echec_2023": "16.7",
    "echec_2024": "6.0",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "0.2",
    "sures_2022": "2.0",
    "sures_2023": "1.5",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 18.2",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 3.1",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 6.0",
    "ecart_sexes_math_2022": "F 10.6",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 4.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "28.2",
    "prog_2019": "41.9",
    "prog_2022": "44.9",
    "prog_2023": "33.9",
    "prog_2024": "23.3",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "6.7",
    "cote_2022": "5.0",
    "cote_2023": "5.5",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Transcontinental",
    "nom_court": "École secondaire du Transcontinental",
    "adresse": "685, rang Notre-Dame-des-Champs",
    "municipalite": "Pohénégamook",
    "code_postal": "G0L 1J0",
    "lat": 47.47692,
    "lng": -69.15807
  },
  {
    "_id": "11",
    "school_code": "714021",
    "school_name_1": "Rivière-du-Loup",
    "admin_body_number": "714000",
    "admin_body_name": "Centre de services scolaire de Kamouraska-Rivière-du-Loup",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "1607",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "9.2",
    "ehdaa_2024": "34",
    "rang_2024": "149/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "71.4",
    "lens_2019": "70.1",
    "lens_2022": "68.9",
    "lens_2023": "70.0",
    "lens_2024": "70.4",
    "lens_trend": "—",
    "lsec_2018": "77.6",
    "lsec_2019": "78.0",
    "lsec_2022": "81.9",
    "lsec_2023": "82.1",
    "lsec_2024": "82.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.7",
    "scie_2019": "71.2",
    "scie_2022": "66.6",
    "scie_2023": "75.3",
    "scie_2024": "68.1",
    "scie_trend": "—",
    "math_2018": "76.7",
    "math_2019": "74.6",
    "math_2022": "75.4",
    "math_2023": "75.7",
    "math_2024": "79.7",
    "math_trend": "—",
    "echec_2018": "11.6",
    "echec_2019": "15.2",
    "echec_2022": "17.2",
    "echec_2023": "12.0",
    "echec_2024": "13.5",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "1.6",
    "sures_2022": "2.5",
    "sures_2023": "0.8",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.1",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 5.5",
    "ecart_sexes_lens_2023": "F 4.3",
    "ecart_sexes_lens_2024": "F 4.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.5",
    "ecart_sexes_math_2019": "F 12.5",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "M 1.6",
    "ecart_sexes_math_2024": "F 5.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.1",
    "prog_2019": "21.1",
    "prog_2022": "19.7",
    "prog_2023": "23.5",
    "prog_2024": "20.2",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "5.5",
    "cote_2022": "6.3",
    "cote_2023": "6.6",
    "cote_2024": "6.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Rivière-du-Loup",
    "nom_court": "École secondaire de Rivière-du-Loup",
    "adresse": "320, rue Saint-Pierre",
    "municipalite": "Rivière-du-Loup",
    "code_postal": "G5R 3V3",
    "lat": 47.82707,
    "lng": -69.54309
  },
  {
    "_id": "12",
    "school_code": "714022",
    "school_name_1": "Chanoine-Beaudet",
    "admin_body_number": "714000",
    "admin_body_name": "Centre de services scolaire de Kamouraska-Rivière-du-Loup",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "351",
    "langue": "français",
    "secteur": "public",
    "rang": "69",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "11.8",
    "ehdaa_2024": "50.4",
    "rang_2024": "69/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "65.4",
    "lens_2019": "69.8",
    "lens_2022": "70.0",
    "lens_2023": "74.7",
    "lens_2024": "75.3",
    "lens_trend": "112233",
    "lsec_2018": "75.9",
    "lsec_2019": "80.1",
    "lsec_2022": "81.2",
    "lsec_2023": "82.7",
    "lsec_2024": "75.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.4",
    "scie_2019": "82.4",
    "scie_2022": "75.0",
    "scie_2023": "79.3",
    "scie_2024": "81.2",
    "scie_trend": "—",
    "math_2018": "71.1",
    "math_2019": "77.3",
    "math_2022": "84.8",
    "math_2023": "73.8",
    "math_2024": "84.8",
    "math_trend": "—",
    "echec_2018": "14.1",
    "echec_2019": "10.6",
    "echec_2022": "9.6",
    "echec_2023": "7.6",
    "echec_2024": "5.0",
    "echec_trend": "112233",
    "sures_2018": "2.3",
    "sures_2019": "0.8",
    "sures_2022": "1.8",
    "sures_2023": "0.6",
    "sures_2024": "0.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "M 0.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 9.2",
    "ecart_sexes_math_2022": "M 3.7",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "F 6.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "38.0",
    "prog_2019": "52.8",
    "prog_2022": "24.7",
    "prog_2023": "24.1",
    "prog_2024": "27.1",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "6.1",
    "cote_2022": "7.0",
    "cote_2023": "7.3",
    "cote_2024": "7.9",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Chanoine-Beaudet",
    "nom_court": "École secondaire Chanoine-Beaudet",
    "adresse": "525, avenue de l'Église",
    "municipalite": "Saint-Pascal",
    "code_postal": "G0L 3Y0",
    "lat": 47.52879,
    "lng": -69.80599
  },
  {
    "_id": "13",
    "school_code": "714023",
    "school_name_1": "La Pocatière",
    "admin_body_number": "714000",
    "admin_body_name": "Centre de services scolaire de Kamouraska-Rivière-du-Loup",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "432",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "9.5",
    "ehdaa_2024": "41",
    "rang_2024": "323/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "67.1",
    "lens_2019": "66.7",
    "lens_2022": "68.6",
    "lens_2023": "68.1",
    "lens_2024": "68.8",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "77.6",
    "lsec_2022": "84.2",
    "lsec_2023": "83.7",
    "lsec_2024": "82.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.1",
    "scie_2019": "67.5",
    "scie_2022": "68.5",
    "scie_2023": "71.6",
    "scie_2024": "65.3",
    "scie_trend": "—",
    "math_2018": "69.4",
    "math_2019": "72.7",
    "math_2022": "70.5",
    "math_2023": "76.7",
    "math_2024": "67.3",
    "math_trend": "—",
    "echec_2018": "15.8",
    "echec_2019": "19.1",
    "echec_2022": "19.2",
    "echec_2023": "15.6",
    "echec_2024": "21.2",
    "echec_trend": "—",
    "sures_2018": "1.6",
    "sures_2019": "3.5",
    "sures_2022": "2.4",
    "sures_2023": "3.4",
    "sures_2024": "6.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.6",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "F 0.8",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 3.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.6",
    "ecart_sexes_math_2019": "F 15.0",
    "ecart_sexes_math_2022": "F 12.6",
    "ecart_sexes_math_2023": "M 3.4",
    "ecart_sexes_math_2024": "M 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.9",
    "prog_2019": "27.9",
    "prog_2022": "15.9",
    "prog_2023": "32.7",
    "prog_2024": "29.7",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "4.7",
    "cote_2022": "6.5",
    "cote_2023": "5.9",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente La Pocatière",
    "nom_court": "École polyvalente La Pocatière",
    "adresse": "950, 12e Avenue Boulevard Dallaire",
    "municipalite": "La Pocatière",
    "code_postal": "G0R 1Z0",
    "lat": 47.36892,
    "lng": -70.02484
  },
  {
    "_id": "14",
    "school_code": "721016",
    "school_name_1": "Cité étudiante",
    "admin_body_number": "721000",
    "admin_body_name": "Centre de services scolaire du Pays-des-Bleuets",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "703",
    "langue": "français",
    "secteur": "public",
    "rang": "458",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "12.2",
    "ehdaa_2024": "41.7",
    "rang_2024": "458/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "66.1",
    "lens_2019": "69.6",
    "lens_2022": "64.1",
    "lens_2023": "68.7",
    "lens_2024": "59.3",
    "lens_trend": "—",
    "lsec_2018": "77.7",
    "lsec_2019": "72.5",
    "lsec_2022": "74.9",
    "lsec_2023": "74.8",
    "lsec_2024": "75.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.1",
    "scie_2019": "71.6",
    "scie_2022": "69.0",
    "scie_2023": "75.1",
    "scie_2024": "59.4",
    "scie_trend": "—",
    "math_2018": "64.5",
    "math_2019": "73.1",
    "math_2022": "66.5",
    "math_2023": "67.1",
    "math_2024": "74.9",
    "math_trend": "—",
    "echec_2018": "23.5",
    "echec_2019": "15.8",
    "echec_2022": "26.1",
    "echec_2023": "18.8",
    "echec_2024": "33.8",
    "echec_trend": "—",
    "sures_2018": "4.0",
    "sures_2019": "2.6",
    "sures_2022": "4.4",
    "sures_2023": "2.6",
    "sures_2024": "6.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.5",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "M 0.4",
    "ecart_sexes_lens_2023": "F 2.6",
    "ecart_sexes_lens_2024": "F 8.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.6",
    "ecart_sexes_math_2019": "F 6.3",
    "ecart_sexes_math_2022": "F 11.7",
    "ecart_sexes_math_2023": "M 5.2",
    "ecart_sexes_math_2024": "F 4.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.7",
    "prog_2019": "43.6",
    "prog_2022": "43.2",
    "prog_2023": "44.6",
    "prog_2024": "40.3",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "4.3",
    "cote_2022": "4.0",
    "cote_2023": "4.7",
    "cote_2024": "2.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Cité étudiante",
    "nom_court": "École Cité étudiante",
    "adresse": "171, boulevard de La Jeunesse",
    "municipalite": "Roberval",
    "code_postal": "G8H 2N9",
    "lat": 48.50147,
    "lng": -72.23111
  },
  {
    "_id": "15",
    "school_code": "721039",
    "school_name_1": "Quatre-Vents",
    "admin_body_number": "721000",
    "admin_body_name": "Centre de services scolaire du Pays-des-Bleuets",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "775",
    "langue": "français",
    "secteur": "public",
    "rang": "132",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "6.3",
    "ehdaa_2024": "37.9",
    "rang_2024": "132/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "71.4",
    "lens_2019": "69.1",
    "lens_2022": "70.1",
    "lens_2023": "72.5",
    "lens_2024": "73.7",
    "lens_trend": "112233",
    "lsec_2018": "74.3",
    "lsec_2019": "74.2",
    "lsec_2022": "74.8",
    "lsec_2023": "78.2",
    "lsec_2024": "78.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.2",
    "scie_2019": "75.8",
    "scie_2022": "75.6",
    "scie_2023": "80.4",
    "scie_2024": "73.6",
    "scie_trend": "—",
    "math_2018": "72.5",
    "math_2019": "80.8",
    "math_2022": "78.8",
    "math_2023": "79.2",
    "math_2024": "83.8",
    "math_trend": "—",
    "echec_2018": "13.1",
    "echec_2019": "15.6",
    "echec_2022": "14.4",
    "echec_2023": "9.5",
    "echec_2024": "7.5",
    "echec_trend": "112233",
    "sures_2018": "0.6",
    "sures_2019": "2.0",
    "sures_2022": "1.9",
    "sures_2023": "0.9",
    "sures_2024": "0.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.9",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 6.9",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.5",
    "ecart_sexes_math_2019": "F 2.7",
    "ecart_sexes_math_2022": "F 5.2",
    "ecart_sexes_math_2023": "M 3.6",
    "ecart_sexes_math_2024": "F 5.1",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "34.6",
    "prog_2019": "38.1",
    "prog_2022": "34.2",
    "prog_2023": "45.7",
    "prog_2024": "44.4",
    "prog_trend": "998855",
    "cote_2018": "5.8",
    "cote_2019": "5.5",
    "cote_2022": "6.1",
    "cote_2023": "6.3",
    "cote_2024": "6.8",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente des Quatre-Vents",
    "nom_court": "Polyvalente des Quatre-Vents",
    "adresse": "1099, boulevard Hamel",
    "municipalite": "Saint-Félicien",
    "code_postal": "G8K 2R4",
    "lat": 48.64648,
    "lng": -72.444
  },
  {
    "_id": "16",
    "school_code": "721061",
    "school_name_1": "Normandin",
    "admin_body_number": "721000",
    "admin_body_name": "Centre de services scolaire du Pays-des-Bleuets",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "487",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "12.7",
    "ehdaa_2024": "28.3",
    "rang_2024": "348/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "67.2",
    "lens_2019": "70.2",
    "lens_2022": "71.1",
    "lens_2023": "71.1",
    "lens_2024": "69.5",
    "lens_trend": "—",
    "lsec_2018": "76.2",
    "lsec_2019": "77.0",
    "lsec_2022": "78.4",
    "lsec_2023": "78.2",
    "lsec_2024": "77.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.6",
    "scie_2019": "73.3",
    "scie_2022": "66.7",
    "scie_2023": "75.4",
    "scie_2024": "67.1",
    "scie_trend": "—",
    "math_2018": "74.7",
    "math_2019": "74.0",
    "math_2022": "65.4",
    "math_2023": "73.9",
    "math_2024": "70.3",
    "math_trend": "—",
    "echec_2018": "13.9",
    "echec_2019": "15.1",
    "echec_2022": "23.6",
    "echec_2023": "12.4",
    "echec_2024": "21.4",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "2.5",
    "sures_2022": "7.1",
    "sures_2023": "2.5",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.3",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 4.2",
    "ecart_sexes_lens_2023": "F 8.5",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.1",
    "ecart_sexes_math_2019": "M 0.3",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "M 12.3",
    "ecart_sexes_math_2024": "M 8.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "16.5",
    "prog_2019": "26.3",
    "prog_2022": "21.6",
    "prog_2023": "31.6",
    "prog_2024": "26.3",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "5.9",
    "cote_2022": "5.3",
    "cote_2023": "5.6",
    "cote_2024": "4.9",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Polyvalente de Normandin",
    "nom_court": "Polyvalente de Normandin",
    "adresse": "1285, avenue du Rocher",
    "municipalite": "Normandin",
    "code_postal": "G8M 3X4",
    "lat": 48.83808,
    "lng": -72.52345
  },
  {
    "_id": "17",
    "school_code": "721085",
    "school_name_1": "Jean-Dolbeau",
    "admin_body_number": "721000",
    "admin_body_name": "Centre de services scolaire du Pays-des-Bleuets",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "868",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "42.2",
    "rang_2024": "367/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "70.5",
    "lens_2019": "69.3",
    "lens_2022": "65.4",
    "lens_2023": "68.0",
    "lens_2024": "63.6",
    "lens_trend": "—",
    "lsec_2018": "81.2",
    "lsec_2019": "83.1",
    "lsec_2022": "82.3",
    "lsec_2023": "83.2",
    "lsec_2024": "81.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.4",
    "scie_2019": "66.0",
    "scie_2022": "64.4",
    "scie_2023": "67.9",
    "scie_2024": "66.4",
    "scie_trend": "—",
    "math_2018": "71.4",
    "math_2019": "72.9",
    "math_2022": "65.2",
    "math_2023": "72.7",
    "math_2024": "69.7",
    "math_trend": "—",
    "echec_2018": "17.0",
    "echec_2019": "19.0",
    "echec_2022": "28.6",
    "echec_2023": "19.0",
    "echec_2024": "25.3",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "1.3",
    "sures_2022": "3.2",
    "sures_2023": "2.3",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 7.3",
    "ecart_sexes_lens_2022": "F 2.0",
    "ecart_sexes_lens_2023": "F 3.6",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.9",
    "ecart_sexes_math_2019": "F 4.3",
    "ecart_sexes_math_2022": "M 1.4",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "M 0.9",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "38.1",
    "prog_2019": "38.5",
    "prog_2022": "33.6",
    "prog_2023": "42.5",
    "prog_2024": "38.8",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "5.1",
    "cote_2022": "4.8",
    "cote_2023": "5.2",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Grandes-Rivières",
    "nom_court": "École secondaire des Grandes-Rivières",
    "adresse": "300, avenue Jean-Dolbeau",
    "municipalite": "Dolbeau-Mistassini",
    "code_postal": "G8L 2T7",
    "lat": 48.87051,
    "lng": -72.22874
  },
  {
    "_id": "18",
    "school_code": "722002",
    "school_name_1": "Camille-Lavoie",
    "admin_body_number": "722000",
    "admin_body_name": "Centre de services scolaire du Lac-Saint-Jean",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "733",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "111",
    "index": "0.1",
    "en_retard_2024": "5.9",
    "ehdaa_2024": "32.6",
    "rang_2024": "199/470",
    "rang_2019_2024": "111/432",
    "lens_2018": "73.7",
    "lens_2019": "73.4",
    "lens_2022": "66.5",
    "lens_2023": "73.8",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "82.5",
    "lsec_2019": "80.5",
    "lsec_2022": "82.7",
    "lsec_2023": "79.7",
    "lsec_2024": "80.4",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.7",
    "scie_2019": "81.3",
    "scie_2022": "76.0",
    "scie_2023": "81.0",
    "scie_2024": "75.4",
    "scie_trend": "998855",
    "math_2018": "80.0",
    "math_2019": "82.1",
    "math_2022": "77.9",
    "math_2023": "82.4",
    "math_2024": "81.6",
    "math_trend": "—",
    "echec_2018": "7.6",
    "echec_2019": "7.0",
    "echec_2022": "15.4",
    "echec_2023": "7.6",
    "echec_2024": "12.5",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.0",
    "sures_2022": "2.2",
    "sures_2023": "1.1",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.0",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 4.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.0",
    "ecart_sexes_math_2019": "F 4.8",
    "ecart_sexes_math_2022": "M 0.7",
    "ecart_sexes_math_2023": "F 6.3",
    "ecart_sexes_math_2024": "F 9.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "15.9",
    "prog_2019": "8.7",
    "prog_2022": "25.5",
    "prog_2023": "36.6",
    "prog_2024": "40.2",
    "prog_trend": "998855",
    "cote_2018": "7.7",
    "cote_2019": "7.9",
    "cote_2022": "6.7",
    "cote_2023": "7.0",
    "cote_2024": "6.2",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Camille-Lavoie",
    "nom_court": "École secondaire Camille-Lavoie",
    "adresse": "500, avenue des Métiers Sud",
    "municipalite": "Alma",
    "code_postal": "G8B 3C4",
    "lat": 48.54346,
    "lng": -71.65597
  },
  {
    "_id": "19",
    "school_code": "722003",
    "school_name_1": "Wilbrod-Dufour",
    "admin_body_number": "722000",
    "admin_body_name": "Centre de services scolaire du Lac-Saint-Jean",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "1185",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "26.4",
    "rang_2024": "348/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "63.2",
    "lens_2019": "63.4",
    "lens_2022": "61.3",
    "lens_2023": "67.6",
    "lens_2024": "64.8",
    "lens_trend": "112233",
    "lsec_2018": "76.1",
    "lsec_2019": "80.1",
    "lsec_2022": "81.3",
    "lsec_2023": "81.8",
    "lsec_2024": "79.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.2",
    "scie_2019": "64.9",
    "scie_2022": "67.5",
    "scie_2023": "71.5",
    "scie_2024": "68.2",
    "scie_trend": "—",
    "math_2018": "69.0",
    "math_2019": "69.4",
    "math_2022": "64.1",
    "math_2023": "68.2",
    "math_2024": "68.8",
    "math_trend": "998855",
    "echec_2018": "23.5",
    "echec_2019": "24.6",
    "echec_2022": "30.3",
    "echec_2023": "17.9",
    "echec_2024": "23.7",
    "echec_trend": "—",
    "sures_2018": "2.4",
    "sures_2019": "3.4",
    "sures_2022": "5.6",
    "sures_2023": "1.9",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.5",
    "ecart_sexes_lens_2019": "F 8.9",
    "ecart_sexes_lens_2022": "F 9.5",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 2.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.2",
    "ecart_sexes_math_2019": "F 13.6",
    "ecart_sexes_math_2022": "M 1.4",
    "ecart_sexes_math_2023": "M 7.0",
    "ecart_sexes_math_2024": "M 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.6",
    "prog_2019": "40.6",
    "prog_2022": "28.5",
    "prog_2023": "44.1",
    "prog_2024": "27.8",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "3.3",
    "cote_2022": "4.4",
    "cote_2023": "4.9",
    "cote_2024": "4.9",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Pavillon Wilbrod-Dufour",
    "nom_court": "Pavillon Wilbrod-Dufour",
    "adresse": "850, avenue Bégin Sud",
    "municipalite": "Alma",
    "code_postal": "G8B 2X6",
    "lat": 48.53992,
    "lng": -71.65444
  },
  {
    "_id": "20",
    "school_code": "722004",
    "school_name_1": "Curé-Hébert",
    "admin_body_number": "722000",
    "admin_body_name": "Centre de services scolaire du Lac-Saint-Jean",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "454",
    "langue": "français",
    "secteur": "public",
    "rang": "447",
    "rang_5_ans": "425",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "29.1",
    "rang_2024": "447/470",
    "rang_2019_2024": "425/432",
    "lens_2018": "63.7",
    "lens_2019": "66.0",
    "lens_2022": "61.9",
    "lens_2023": "67.9",
    "lens_2024": "61.7",
    "lens_trend": "—",
    "lsec_2018": "73.8",
    "lsec_2019": "73.4",
    "lsec_2022": "79.0",
    "lsec_2023": "73.0",
    "lsec_2024": "74.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.7",
    "scie_2019": "62.8",
    "scie_2022": "63.7",
    "scie_2023": "71.0",
    "scie_2024": "62.3",
    "scie_trend": "—",
    "math_2018": "53.8",
    "math_2019": "55.3",
    "math_2022": "67.9",
    "math_2023": "60.7",
    "math_2024": "68.9",
    "math_trend": "—",
    "echec_2018": "34.0",
    "echec_2019": "38.6",
    "echec_2022": "29.9",
    "echec_2023": "26.6",
    "echec_2024": "32.3",
    "echec_trend": "—",
    "sures_2018": "9.9",
    "sures_2019": "8.6",
    "sures_2022": "6.9",
    "sures_2023": "3.8",
    "sures_2024": "3.9",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 15.0",
    "ecart_sexes_lens_2019": "F 12.0",
    "ecart_sexes_lens_2022": "F 11.8",
    "ecart_sexes_lens_2023": "F 8.3",
    "ecart_sexes_lens_2024": "F 10.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.1",
    "ecart_sexes_math_2019": "F 6.3",
    "ecart_sexes_math_2022": "F 9.6",
    "ecart_sexes_math_2023": "F 2.0",
    "ecart_sexes_math_2024": "F 3.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.3",
    "prog_2019": "29.7",
    "prog_2022": "16.8",
    "prog_2023": "29.7",
    "prog_2024": "26.0",
    "prog_trend": "—",
    "cote_2018": "1.3",
    "cote_2019": "1.5",
    "cote_2022": "4.1",
    "cote_2023": "4.1",
    "cote_2024": "3.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Curé-Hébert",
    "nom_court": "École Curé-Hébert",
    "adresse": "250, rue Turgeon",
    "municipalite": "Hébertville",
    "code_postal": "G8N 1S1",
    "lat": 48.39117,
    "lng": -71.67896
  },
  {
    "_id": "21",
    "school_code": "722009",
    "school_name_1": "Jean-Gauthier",
    "admin_body_number": "722000",
    "admin_body_name": "Centre de services scolaire du Lac-Saint-Jean",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "476",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "15.1",
    "ehdaa_2024": "37.4",
    "rang_2024": "310/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "59.1",
    "lens_2019": "64.9",
    "lens_2022": "63.5",
    "lens_2023": "68.0",
    "lens_2024": "62.6",
    "lens_trend": "—",
    "lsec_2018": "73.8",
    "lsec_2019": "80.8",
    "lsec_2022": "76.4",
    "lsec_2023": "78.3",
    "lsec_2024": "77.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "62.5",
    "scie_2022": "64.3",
    "scie_2023": "69.9",
    "scie_2024": "64.8",
    "scie_trend": "—",
    "math_2018": "65.4",
    "math_2019": "71.5",
    "math_2022": "71.9",
    "math_2023": "74.4",
    "math_2024": "81.4",
    "math_trend": "112233",
    "echec_2018": "29.6",
    "echec_2019": "24.0",
    "echec_2022": "27.0",
    "echec_2023": "17.2",
    "echec_2024": "25.5",
    "echec_trend": "—",
    "sures_2018": "7.8",
    "sures_2019": "5.3",
    "sures_2022": "2.7",
    "sures_2023": "0.6",
    "sures_2024": "2.5",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 10.7",
    "ecart_sexes_lens_2019": "F 5.1",
    "ecart_sexes_lens_2022": "F 6.6",
    "ecart_sexes_lens_2023": "F 8.2",
    "ecart_sexes_lens_2024": "F 9.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.3",
    "ecart_sexes_math_2019": "F 8.1",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 0.9",
    "ecart_sexes_math_2024": "M 7.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.4",
    "prog_2019": "47.9",
    "prog_2022": "32.8",
    "prog_2023": "35.0",
    "prog_2024": "22.7",
    "prog_trend": "—",
    "cote_2018": "2.8",
    "cote_2019": "4.0",
    "cote_2022": "4.8",
    "cote_2023": "5.8",
    "cote_2024": "5.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Jean-Gauthier",
    "nom_court": "École Jean-Gauthier",
    "adresse": "441, rue Joseph-W.-Fleury",
    "municipalite": "Alma",
    "code_postal": "G8E 2L1",
    "lat": 48.63954,
    "lng": -71.69605
  },
  {
    "_id": "22",
    "school_code": "723145",
    "school_name_1": "Charles-Gravel",
    "admin_body_number": "723000",
    "admin_body_name": "Centre de services scolaire des Rives-du-Saguenay",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "1619",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "18.8",
    "ehdaa_2024": "40.1",
    "rang_2024": "348/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "67.7",
    "lens_2019": "66.6",
    "lens_2022": "63.3",
    "lens_2023": "65.1",
    "lens_2024": "63.1",
    "lens_trend": "—",
    "lsec_2018": "78.5",
    "lsec_2019": "76.6",
    "lsec_2022": "74.5",
    "lsec_2023": "81.2",
    "lsec_2024": "79.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.1",
    "scie_2019": "70.8",
    "scie_2022": "68.7",
    "scie_2023": "71.8",
    "scie_2024": "68.5",
    "scie_trend": "—",
    "math_2018": "68.5",
    "math_2019": "70.4",
    "math_2022": "74.8",
    "math_2023": "73.8",
    "math_2024": "76.1",
    "math_trend": "—",
    "echec_2018": "17.4",
    "echec_2019": "19.6",
    "echec_2022": "21.0",
    "echec_2023": "18.1",
    "echec_2024": "21.5",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "3.3",
    "sures_2022": "4.0",
    "sures_2023": "2.7",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.4",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 8.6",
    "ecart_sexes_lens_2023": "F 6.9",
    "ecart_sexes_lens_2024": "F 6.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.0",
    "ecart_sexes_math_2019": "F 2.5",
    "ecart_sexes_math_2022": "F 2.7",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "F 3.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.4",
    "prog_2019": "34.6",
    "prog_2022": "23.2",
    "prog_2023": "35.6",
    "prog_2024": "32.2",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "4.5",
    "cote_2022": "5.0",
    "cote_2023": "5.2",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Charles-Gravel",
    "nom_court": "École secondaire Charles-Gravel",
    "adresse": "350, rue Saint-Gérard",
    "municipalite": "Saguenay",
    "code_postal": "G7G 1J2",
    "lat": 48.44371,
    "lng": -71.06806
  },
  {
    "_id": "23",
    "school_code": "723172",
    "school_name_1": "Fréchette",
    "admin_body_number": "723000",
    "admin_body_name": "Centre de services scolaire des Rives-du-Saguenay",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "94",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "8.3",
    "ehdaa_2024": "35.1",
    "rang_2024": "335/470",
    "rang_2019_2024": "nd",
    "lens_2018": "70.2",
    "lens_2019": "69.9",
    "lens_2022": "61.4",
    "lens_2023": "nd",
    "lens_2024": "61.2",
    "lens_trend": "nd",
    "lsec_2018": "77.1",
    "lsec_2019": "82.0",
    "lsec_2022": "84.3",
    "lsec_2023": "nd",
    "lsec_2024": "78.7",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.2",
    "scie_2019": "58.6",
    "scie_2022": "71.6",
    "scie_2023": "nd",
    "scie_2024": "71.3",
    "scie_trend": "nd",
    "math_2018": "79.4",
    "math_2019": "64.0",
    "math_2022": "75.4",
    "math_2023": "nd",
    "math_2024": "73.2",
    "math_trend": "nd",
    "echec_2018": "8.1",
    "echec_2019": "26.2",
    "echec_2022": "17.6",
    "echec_2023": "nd",
    "echec_2024": "27.6",
    "echec_trend": "nd",
    "sures_2018": "6.3",
    "sures_2019": "7.6",
    "sures_2022": "6.2",
    "sures_2023": "nd",
    "sures_2024": "2.4",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "17.0",
    "prog_2019": "37.8",
    "prog_2022": "18.8",
    "prog_2023": "nd",
    "prog_2024": "11.1",
    "prog_trend": "nd",
    "cote_2018": "5.8",
    "cote_2019": "3.4",
    "cote_2022": "6.1",
    "cote_2023": "nd",
    "cote_2024": "5.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École primaire et secondaire Fréchette",
    "nom_court": "École primaire et secondaire Fréchette",
    "adresse": "37, rue St-Jean-Baptiste",
    "municipalite": "L'Anse-Saint-Jean",
    "code_postal": "G0V 1J0",
    "lat": 48.19998,
    "lng": -70.23955
  },
  {
    "_id": "24",
    "school_code": "723173",
    "school_name_1": "des Grandes-Marées",
    "admin_body_number": "723000",
    "admin_body_name": "Centre de services scolaire des Rives-du-Saguenay",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "839",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "20.4",
    "ehdaa_2024": "25.6",
    "rang_2024": "390/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "68.6",
    "lens_2019": "68.3",
    "lens_2022": "61.6",
    "lens_2023": "64.5",
    "lens_2024": "63.5",
    "lens_trend": "—",
    "lsec_2018": "81.1",
    "lsec_2019": "78.2",
    "lsec_2022": "76.9",
    "lsec_2023": "76.5",
    "lsec_2024": "76.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.8",
    "scie_2019": "64.8",
    "scie_2022": "64.8",
    "scie_2023": "68.7",
    "scie_2024": "64.5",
    "scie_trend": "—",
    "math_2018": "66.9",
    "math_2019": "71.2",
    "math_2022": "62.0",
    "math_2023": "64.5",
    "math_2024": "72.3",
    "math_trend": "—",
    "echec_2018": "21.0",
    "echec_2019": "22.0",
    "echec_2022": "32.1",
    "echec_2023": "27.1",
    "echec_2024": "23.4",
    "echec_trend": "—",
    "sures_2018": "5.0",
    "sures_2019": "3.4",
    "sures_2022": "4.3",
    "sures_2023": "3.8",
    "sures_2024": "2.5",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 10.2",
    "ecart_sexes_lens_2019": "F 2.3",
    "ecart_sexes_lens_2022": "F 4.5",
    "ecart_sexes_lens_2023": "F 4.1",
    "ecart_sexes_lens_2024": "F 0.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.6",
    "ecart_sexes_math_2019": "F 4.7",
    "ecart_sexes_math_2022": "F 1.9",
    "ecart_sexes_math_2023": "F 3.5",
    "ecart_sexes_math_2024": "F 6.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.4",
    "prog_2019": "20.4",
    "prog_2022": "26.9",
    "prog_2023": "32.0",
    "prog_2024": "38.7",
    "prog_trend": "—",
    "cote_2018": "4.1",
    "cote_2019": "4.7",
    "cote_2022": "4.2",
    "cote_2023": "4.0",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Grandes-Marées",
    "nom_court": "École secondaire des Grandes-Marées",
    "adresse": "1802, avenue John-Kane",
    "municipalite": "Saguenay",
    "code_postal": "G7B 1K2",
    "lat": 48.32361,
    "lng": -70.88405
  },
  {
    "_id": "25",
    "school_code": "723175",
    "school_name_1": "de l'Odyssée",
    "admin_body_number": "723000",
    "admin_body_name": "Centre de services scolaire des Rives-du-Saguenay",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "2084",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "13.6",
    "ehdaa_2024": "28.6",
    "rang_2024": "323/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "68.8",
    "lens_2019": "67.8",
    "lens_2022": "64.0",
    "lens_2023": "66.9",
    "lens_2024": "64.7",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "80.4",
    "lsec_2022": "78.9",
    "lsec_2023": "80.6",
    "lsec_2024": "77.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.9",
    "scie_2019": "76.8",
    "scie_2022": "72.2",
    "scie_2023": "75.2",
    "scie_2024": "69.9",
    "scie_trend": "998855",
    "math_2018": "70.5",
    "math_2019": "74.2",
    "math_2022": "74.7",
    "math_2023": "73.5",
    "math_2024": "74.1",
    "math_trend": "—",
    "echec_2018": "14.4",
    "echec_2019": "13.9",
    "echec_2022": "18.8",
    "echec_2023": "16.9",
    "echec_2024": "20.5",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.3",
    "sures_2022": "2.6",
    "sures_2023": "2.1",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 5.2",
    "ecart_sexes_lens_2022": "F 3.4",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.5",
    "ecart_sexes_math_2019": "F 2.2",
    "ecart_sexes_math_2022": "M 3.4",
    "ecart_sexes_math_2023": "F 0.8",
    "ecart_sexes_math_2024": "M 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.3",
    "prog_2019": "34.6",
    "prog_2022": "23.2",
    "prog_2023": "32.9",
    "prog_2024": "32.7",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.8",
    "cote_2022": "6.0",
    "cote_2023": "5.5",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Odyssée",
    "nom_court": "École secondaire de l'Odyssée",
    "adresse": "985, rue Bégin",
    "municipalite": "Saguenay",
    "code_postal": "G7H 4P1",
    "lat": 48.41227,
    "lng": -71.06569
  },
  {
    "_id": "26",
    "school_code": "724002",
    "school_name_1": "Arvida",
    "admin_body_number": "724000",
    "admin_body_name": "Centre de services scolaire De La Jonquière",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "1427",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "10.9",
    "ehdaa_2024": "21.4",
    "rang_2024": "277/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "69.3",
    "lens_2019": "68.4",
    "lens_2022": "65.9",
    "lens_2023": "65.7",
    "lens_2024": "65.5",
    "lens_trend": "—",
    "lsec_2018": "75.4",
    "lsec_2019": "77.1",
    "lsec_2022": "76.8",
    "lsec_2023": "78.3",
    "lsec_2024": "81.2",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.3",
    "scie_2019": "70.3",
    "scie_2022": "67.2",
    "scie_2023": "72.8",
    "scie_2024": "70.8",
    "scie_trend": "—",
    "math_2018": "64.3",
    "math_2019": "71.5",
    "math_2022": "75.3",
    "math_2023": "71.3",
    "math_2024": "73.5",
    "math_trend": "—",
    "echec_2018": "22.1",
    "echec_2019": "18.4",
    "echec_2022": "20.1",
    "echec_2023": "16.6",
    "echec_2024": "18.3",
    "echec_trend": "112233",
    "sures_2018": "3.7",
    "sures_2019": "0.9",
    "sures_2022": "2.5",
    "sures_2023": "2.6",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 2.4",
    "ecart_sexes_lens_2023": "F 3.7",
    "ecart_sexes_lens_2024": "F 5.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.5",
    "ecart_sexes_math_2019": "F 1.6",
    "ecart_sexes_math_2022": "M 0.3",
    "ecart_sexes_math_2023": "F 7.1",
    "ecart_sexes_math_2024": "F 3.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.7",
    "prog_2019": "24.9",
    "prog_2022": "16.6",
    "prog_2023": "21.6",
    "prog_2024": "22.4",
    "prog_trend": "—",
    "cote_2018": "4.4",
    "cote_2019": "5.3",
    "cote_2022": "5.9",
    "cote_2023": "5.4",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente Arvida",
    "nom_court": "École polyvalente Arvida",
    "adresse": "2215, boulevard Mellon",
    "municipalite": "Saguenay",
    "code_postal": "G7S 3G4",
    "lat": 48.41373,
    "lng": -71.1804
  },
  {
    "_id": "27",
    "school_code": "724003",
    "school_name_1": "Kénogami",
    "admin_body_number": "724000",
    "admin_body_name": "Centre de services scolaire De La Jonquière",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "1900",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "30.4",
    "rang_2024": "367/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "72.2",
    "lens_2019": "73.9",
    "lens_2022": "68.1",
    "lens_2023": "66.1",
    "lens_2024": "63.7",
    "lens_trend": "998855",
    "lsec_2018": "81.7",
    "lsec_2019": "81.3",
    "lsec_2022": "80.3",
    "lsec_2023": "83.4",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.4",
    "scie_2019": "78.7",
    "scie_2022": "72.8",
    "scie_2023": "69.6",
    "scie_2024": "67.9",
    "scie_trend": "—",
    "math_2018": "71.5",
    "math_2019": "73.3",
    "math_2022": "73.1",
    "math_2023": "68.1",
    "math_2024": "77.6",
    "math_trend": "—",
    "echec_2018": "11.2",
    "echec_2019": "10.5",
    "echec_2022": "21.9",
    "echec_2023": "22.8",
    "echec_2024": "22.5",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "1.6",
    "sures_2022": "3.9",
    "sures_2023": "1.4",
    "sures_2024": "4.3",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.8",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 2.5",
    "ecart_sexes_lens_2023": "F 7.8",
    "ecart_sexes_lens_2024": "F 5.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.4",
    "ecart_sexes_math_2019": "F 2.3",
    "ecart_sexes_math_2022": "F 11.5",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "19.8",
    "prog_2019": "23.3",
    "prog_2022": "26.6",
    "prog_2023": "19.4",
    "prog_2024": "46.4",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "6.8",
    "cote_2022": "5.6",
    "cote_2023": "5.5",
    "cote_2024": "4.7",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire des Bâtisseurs",
    "nom_court": "École secondaire des Bâtisseurs",
    "adresse": "1954, rue des Étudiants",
    "municipalite": "Saguenay",
    "code_postal": "G7X 4B1",
    "lat": 48.42493,
    "lng": -71.22845
  },
  {
    "_id": "28",
    "school_code": "731001",
    "school_name_1": "Saint-Aubin",
    "admin_body_number": "731000",
    "admin_body_name": "Centre de services scolaire de Charlevoix",
    "area_name": "Capitale-Nationale ",
    "étudiants": "583",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "6",
    "ehdaa_2024": "30",
    "rang_2024": "238/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "76.3",
    "lens_2019": "74.2",
    "lens_2022": "71.2",
    "lens_2023": "69.1",
    "lens_2024": "71.2",
    "lens_trend": "—",
    "lsec_2018": "77.4",
    "lsec_2019": "79.0",
    "lsec_2022": "76.6",
    "lsec_2023": "75.8",
    "lsec_2024": "76.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "74.9",
    "scie_2022": "78.7",
    "scie_2023": "72.1",
    "scie_2024": "66.7",
    "scie_trend": "—",
    "math_2018": "75.8",
    "math_2019": "78.7",
    "math_2022": "76.5",
    "math_2023": "73.0",
    "math_2024": "78.9",
    "math_trend": "—",
    "echec_2018": "8.3",
    "echec_2019": "8.4",
    "echec_2022": "9.4",
    "echec_2023": "19.7",
    "echec_2024": "19.2",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.0",
    "sures_2022": "2.0",
    "sures_2023": "1.2",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.5",
    "ecart_sexes_lens_2019": "F 11.4",
    "ecart_sexes_lens_2022": "F 6.2",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.8",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "F 6.1",
    "ecart_sexes_math_2023": "M 3.3",
    "ecart_sexes_math_2024": "F 4.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.2",
    "prog_2019": "27.4",
    "prog_2022": "26.3",
    "prog_2023": "24.7",
    "prog_2024": "21.4",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "6.8",
    "cote_2022": "6.9",
    "cote_2023": "5.5",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Centre éducatif Saint-Aubin",
    "nom_court": "Centre éducatif Saint-Aubin",
    "adresse": "200-101, rue Saint-Aubin",
    "municipalite": "Baie-Saint-Paul",
    "code_postal": "G3Z 2R2",
    "lat": 47.43992,
    "lng": -70.51453
  },
  {
    "_id": "29",
    "school_code": "731002",
    "school_name_1": "du Plateau",
    "admin_body_number": "731000",
    "admin_body_name": "Centre de services scolaire de Charlevoix",
    "area_name": "Capitale-Nationale ",
    "étudiants": "669",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "3",
    "ehdaa_2024": "36.9",
    "rang_2024": "207/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "69.1",
    "lens_2019": "70.7",
    "lens_2022": "67.7",
    "lens_2023": "64.6",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "76.6",
    "lsec_2019": "81.7",
    "lsec_2022": "77.6",
    "lsec_2023": "78.4",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.3",
    "scie_2019": "72.5",
    "scie_2022": "66.7",
    "scie_2023": "75.2",
    "scie_2024": "71.5",
    "scie_trend": "—",
    "math_2018": "74.9",
    "math_2019": "81.3",
    "math_2022": "72.3",
    "math_2023": "77.5",
    "math_2024": "82.0",
    "math_trend": "—",
    "echec_2018": "11.2",
    "echec_2019": "9.9",
    "echec_2022": "19.6",
    "echec_2023": "18.2",
    "echec_2024": "13.6",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.0",
    "sures_2022": "3.3",
    "sures_2023": "1.3",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.8",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "F 4.3",
    "ecart_sexes_lens_2023": "F 12.4",
    "ecart_sexes_lens_2024": "F 4.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.6",
    "ecart_sexes_math_2019": "M 3.7",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "F 7.1",
    "ecart_sexes_math_2024": "F 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.9",
    "prog_2019": "21.5",
    "prog_2022": "25.9",
    "prog_2023": "36.0",
    "prog_2024": "31.5",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "7.0",
    "cote_2022": "5.5",
    "cote_2023": "5.0",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Plateau",
    "nom_court": "École secondaire du Plateau",
    "adresse": "88, rue des Cimes",
    "municipalite": "La Malbaie",
    "code_postal": "G5A 1T3",
    "lat": 47.65209,
    "lng": -70.1565
  },
  {
    "_id": "30",
    "school_code": "732157",
    "school_name_1": "Cardinal-Roy",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1017",
    "langue": "français",
    "secteur": "public",
    "rang": "96",
    "rang_5_ans": "59",
    "index": "0.1",
    "en_retard_2024": "1.4",
    "ehdaa_2024": "20.6",
    "rang_2024": "96/470",
    "rang_2019_2024": "59/432",
    "lens_2018": "74.9",
    "lens_2019": "72.6",
    "lens_2022": "71.6",
    "lens_2023": "75.0",
    "lens_2024": "71.7",
    "lens_trend": "—",
    "lsec_2018": "84.6",
    "lsec_2019": "85.2",
    "lsec_2022": "86.9",
    "lsec_2023": "87.9",
    "lsec_2024": "88.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.6",
    "scie_2019": "78.6",
    "scie_2022": "82.9",
    "scie_2023": "83.7",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "78.9",
    "math_2019": "78.7",
    "math_2022": "79.4",
    "math_2023": "80.1",
    "math_2024": "73.8",
    "math_trend": "998855",
    "echec_2018": "6.5",
    "echec_2019": "8.1",
    "echec_2022": "7.5",
    "echec_2023": "5.2",
    "echec_2024": "9.3",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "1.4",
    "sures_2022": "1.1",
    "sures_2023": "1.0",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "F 2.5",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.1",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "F 5.5",
    "ecart_sexes_math_2023": "F 9.6",
    "ecart_sexes_math_2024": "F 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "6.3",
    "prog_2019": "8.5",
    "prog_2022": "5.0",
    "prog_2023": "5.3",
    "prog_2024": "7.0",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "7.8",
    "cote_2022": "8.5",
    "cote_2023": "8.2",
    "cote_2024": "7.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Cardinal-Roy",
    "nom_court": "École Cardinal-Roy",
    "adresse": "50, rue du Cardinal-Maurice-Roy",
    "municipalite": "Québec",
    "code_postal": "G1K 8S9",
    "lat": 46.81857,
    "lng": -71.23732
  },
  {
    "_id": "31",
    "school_code": "732159",
    "school_name_1": "Jean-de-Brébeuf",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "735",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "411",
    "index": "0.1",
    "en_retard_2024": "30.6",
    "ehdaa_2024": "28",
    "rang_2024": "420/470",
    "rang_2019_2024": "411/432",
    "lens_2018": "69.2",
    "lens_2019": "63.6",
    "lens_2022": "63.5",
    "lens_2023": "65.1",
    "lens_2024": "56.0",
    "lens_trend": "—",
    "lsec_2018": "76.4",
    "lsec_2019": "80.9",
    "lsec_2022": "80.6",
    "lsec_2023": "81.7",
    "lsec_2024": "79.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.5",
    "scie_2019": "61.1",
    "scie_2022": "59.2",
    "scie_2023": "60.4",
    "scie_2024": "66.0",
    "scie_trend": "—",
    "math_2018": "70.4",
    "math_2019": "62.1",
    "math_2022": "59.7",
    "math_2023": "65.5",
    "math_2024": "70.9",
    "math_trend": "—",
    "echec_2018": "24.2",
    "echec_2019": "32.4",
    "echec_2022": "34.7",
    "echec_2023": "29.1",
    "echec_2024": "28.9",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "3.8",
    "sures_2022": "6.8",
    "sures_2023": "2.9",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 2.5",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 0.7",
    "ecart_sexes_lens_2024": "F 0.3",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 5.9",
    "ecart_sexes_math_2019": "F 5.9",
    "ecart_sexes_math_2022": "M 3.6",
    "ecart_sexes_math_2023": "M 2.1",
    "ecart_sexes_math_2024": "F 0.1",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "43.4",
    "prog_2019": "43.6",
    "prog_2022": "35.8",
    "prog_2023": "40.3",
    "prog_2024": "41.1",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "2.9",
    "cote_2022": "3.7",
    "cote_2023": "4.1",
    "cote_2024": "4.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Jean-de-Brébeuf",
    "nom_court": "École Jean-de-Brébeuf",
    "adresse": "1640, 8e Avenue",
    "municipalite": "Québec",
    "code_postal": "G1J 3N5",
    "lat": 46.83241,
    "lng": -71.22958
  },
  {
    "_id": "32",
    "school_code": "732160",
    "school_name_1": "Joseph-François-Perrault",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "735",
    "langue": "français",
    "secteur": "public",
    "rang": "120",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "12.2",
    "ehdaa_2024": "23.5",
    "rang_2024": "120/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "72.6",
    "lens_2019": "72.1",
    "lens_2022": "67.5",
    "lens_2023": "70.4",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "76.5",
    "lsec_2019": "78.5",
    "lsec_2022": "84.6",
    "lsec_2023": "78.5",
    "lsec_2024": "80.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.4",
    "scie_2019": "74.8",
    "scie_2022": "73.8",
    "scie_2023": "77.6",
    "scie_2024": "76.2",
    "scie_trend": "—",
    "math_2018": "70.1",
    "math_2019": "75.1",
    "math_2022": "73.9",
    "math_2023": "74.7",
    "math_2024": "79.9",
    "math_trend": "—",
    "echec_2018": "16.7",
    "echec_2019": "11.5",
    "echec_2022": "18.0",
    "echec_2023": "12.7",
    "echec_2024": "13.2",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "2.4",
    "sures_2022": "2.9",
    "sures_2023": "1.7",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 7.9",
    "ecart_sexes_lens_2022": "F 7.1",
    "ecart_sexes_lens_2023": "F 7.0",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.5",
    "ecart_sexes_math_2019": "F 6.8",
    "ecart_sexes_math_2022": "M 5.9",
    "ecart_sexes_math_2023": "M 1.0",
    "ecart_sexes_math_2024": "M 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "24.2",
    "prog_2019": "29.9",
    "prog_2022": "14.3",
    "prog_2023": "17.9",
    "prog_2024": "14.6",
    "prog_trend": "112233",
    "cote_2018": "6.2",
    "cote_2019": "6.1",
    "cote_2022": "7.0",
    "cote_2023": "6.5",
    "cote_2024": "7.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Joseph-François-Perrault",
    "nom_court": "École Joseph-François-Perrault",
    "adresse": "140, chemin Sainte-Foy",
    "municipalite": "Québec",
    "code_postal": "G1R 1T2",
    "lat": 46.80603,
    "lng": -71.22916
  },
  {
    "_id": "33",
    "school_code": "732161",
    "school_name_1": "La Camaradière",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1465",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "12.7",
    "ehdaa_2024": "36.7",
    "rang_2024": "409/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "68.7",
    "lens_2019": "67.5",
    "lens_2022": "65.5",
    "lens_2023": "66.2",
    "lens_2024": "63.3",
    "lens_trend": "—",
    "lsec_2018": "80.6",
    "lsec_2019": "80.7",
    "lsec_2022": "80.6",
    "lsec_2023": "75.4",
    "lsec_2024": "77.0",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.8",
    "scie_2019": "70.3",
    "scie_2022": "65.9",
    "scie_2023": "67.2",
    "scie_2024": "67.2",
    "scie_trend": "—",
    "math_2018": "75.3",
    "math_2019": "71.1",
    "math_2022": "68.3",
    "math_2023": "70.2",
    "math_2024": "71.4",
    "math_trend": "998855",
    "echec_2018": "17.4",
    "echec_2019": "18.9",
    "echec_2022": "25.2",
    "echec_2023": "23.9",
    "echec_2024": "24.4",
    "echec_trend": "998855",
    "sures_2018": "0.4",
    "sures_2019": "1.8",
    "sures_2022": "0.9",
    "sures_2023": "1.4",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "M 0.5",
    "ecart_sexes_lens_2022": "F 3.5",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 3.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "M 2.1",
    "ecart_sexes_math_2022": "F 5.3",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "44.5",
    "prog_2019": "41.6",
    "prog_2022": "34.0",
    "prog_2023": "37.3",
    "prog_2024": "44.8",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.1",
    "cote_2022": "5.1",
    "cote_2023": "4.5",
    "cote_2024": "4.2",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire La Camaradière",
    "nom_court": "École secondaire La Camaradière",
    "adresse": "3400, boulevard Neuvialle",
    "municipalite": "Québec",
    "code_postal": "G1P 3A8",
    "lat": 46.81636,
    "lng": -71.31459
  },
  {
    "_id": "34",
    "school_code": "732164",
    "school_name_1": "de Neufchâtel",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "2020",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "11.2",
    "ehdaa_2024": "39.5",
    "rang_2024": "169/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "75.0",
    "lens_2019": "72.6",
    "lens_2022": "73.1",
    "lens_2023": "74.3",
    "lens_2024": "72.5",
    "lens_trend": "—",
    "lsec_2018": "77.3",
    "lsec_2019": "72.0",
    "lsec_2022": "75.0",
    "lsec_2023": "74.1",
    "lsec_2024": "74.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.7",
    "scie_2019": "71.6",
    "scie_2022": "66.9",
    "scie_2023": "76.9",
    "scie_2024": "72.8",
    "scie_trend": "—",
    "math_2018": "68.5",
    "math_2019": "73.4",
    "math_2022": "76.4",
    "math_2023": "74.1",
    "math_2024": "79.7",
    "math_trend": "—",
    "echec_2018": "16.8",
    "echec_2019": "18.2",
    "echec_2022": "19.0",
    "echec_2023": "13.6",
    "echec_2024": "14.4",
    "echec_trend": "112233",
    "sures_2018": "0.6",
    "sures_2019": "2.1",
    "sures_2022": "3.3",
    "sures_2023": "2.7",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 5.7",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 6.4",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.6",
    "ecart_sexes_math_2019": "F 10.1",
    "ecart_sexes_math_2022": "M 4.9",
    "ecart_sexes_math_2023": "F 4.9",
    "ecart_sexes_math_2024": "F 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.7",
    "prog_2019": "32.5",
    "prog_2022": "17.1",
    "prog_2023": "19.9",
    "prog_2024": "21.6",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "4.9",
    "cote_2022": "5.9",
    "cote_2023": "6.1",
    "cote_2024": "6.4",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire de Neufchâtel",
    "nom_court": "École secondaire de Neufchâtel",
    "adresse": "3600, avenue Chauveau",
    "municipalite": "Québec",
    "code_postal": "G2C 1A1",
    "lat": 46.83633,
    "lng": -71.34535
  },
  {
    "_id": "35",
    "school_code": "732165",
    "school_name_1": "Roger-Comtois",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "2164",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "377",
    "index": "0.1",
    "en_retard_2024": "15.5",
    "ehdaa_2024": "36.6",
    "rang_2024": "409/470",
    "rang_2019_2024": "377/432",
    "lens_2018": "67.7",
    "lens_2019": "66.9",
    "lens_2022": "63.8",
    "lens_2023": "64.9",
    "lens_2024": "65.3",
    "lens_trend": "—",
    "lsec_2018": "74.5",
    "lsec_2019": "75.3",
    "lsec_2022": "75.0",
    "lsec_2023": "67.4",
    "lsec_2024": "72.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.5",
    "scie_2019": "65.4",
    "scie_2022": "67.0",
    "scie_2023": "71.8",
    "scie_2024": "65.9",
    "scie_trend": "—",
    "math_2018": "66.3",
    "math_2019": "69.5",
    "math_2022": "70.1",
    "math_2023": "69.2",
    "math_2024": "71.6",
    "math_trend": "—",
    "echec_2018": "21.9",
    "echec_2019": "22.8",
    "echec_2022": "25.0",
    "echec_2023": "25.8",
    "echec_2024": "23.5",
    "echec_trend": "—",
    "sures_2018": "2.4",
    "sures_2019": "3.0",
    "sures_2022": "3.6",
    "sures_2023": "3.4",
    "sures_2024": "5.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.7",
    "ecart_sexes_lens_2019": "F 6.4",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 6.6",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.2",
    "ecart_sexes_math_2019": "F 7.3",
    "ecart_sexes_math_2022": "F 1.5",
    "ecart_sexes_math_2023": "F 6.6",
    "ecart_sexes_math_2024": "F 3.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.4",
    "prog_2019": "29.1",
    "prog_2022": "19.8",
    "prog_2023": "25.6",
    "prog_2024": "28.1",
    "prog_trend": "—",
    "cote_2018": "4.4",
    "cote_2019": "4.1",
    "cote_2022": "5.2",
    "cote_2023": "3.9",
    "cote_2024": "4.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Roger-Comtois",
    "nom_court": "École secondaire Roger-Comtois",
    "adresse": "158, boulevard des Étudiants",
    "municipalite": "Québec",
    "code_postal": "G2A 1N8",
    "lat": 46.85426,
    "lng": -71.36572
  },
  {
    "_id": "36",
    "school_code": "732167",
    "school_name_1": "Vanier",
    "admin_body_number": "732000",
    "admin_body_name": "Centre de services scolaire de la Capitale",
    "area_name": "Capitale-Nationale ",
    "étudiants": "425",
    "langue": "français",
    "secteur": "public",
    "rang": "439",
    "rang_5_ans": "419",
    "index": "0.1",
    "en_retard_2024": "32.3",
    "ehdaa_2024": "41.2",
    "rang_2024": "439/470",
    "rang_2019_2024": "419/432",
    "lens_2018": "71.6",
    "lens_2019": "71.3",
    "lens_2022": "56.0",
    "lens_2023": "66.2",
    "lens_2024": "58.8",
    "lens_trend": "—",
    "lsec_2018": "73.2",
    "lsec_2019": "76.9",
    "lsec_2022": "77.1",
    "lsec_2023": "77.6",
    "lsec_2024": "76.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.5",
    "scie_2019": "65.4",
    "scie_2022": "65.2",
    "scie_2023": "66.9",
    "scie_2024": "61.1",
    "scie_trend": "998855",
    "math_2018": "62.5",
    "math_2019": "60.2",
    "math_2022": "57.9",
    "math_2023": "63.8",
    "math_2024": "72.7",
    "math_trend": "—",
    "echec_2018": "22.5",
    "echec_2019": "22.3",
    "echec_2022": "42.3",
    "echec_2023": "18.1",
    "echec_2024": "31.8",
    "echec_trend": "—",
    "sures_2018": "4.2",
    "sures_2019": "5.4",
    "sures_2022": "7.9",
    "sures_2023": "6.4",
    "sures_2024": "5.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "M 8.1",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 3.8",
    "ecart_sexes_math_2022": "M 5.6",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "65.4",
    "prog_2019": "69.3",
    "prog_2022": "56.7",
    "prog_2023": "82.3",
    "prog_2024": "57.3",
    "prog_trend": "—",
    "cote_2018": "3.0",
    "cote_2019": "3.7",
    "cote_2022": "2.5",
    "cote_2023": "3.2",
    "cote_2024": "3.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Vanier",
    "nom_court": "École secondaire Vanier",
    "adresse": "700, boulevard Wilfrid-Hamel",
    "municipalite": "Québec",
    "code_postal": "G1M 2P9",
    "lat": 46.81433,
    "lng": -71.25459
  },
  {
    "_id": "37",
    "school_code": "733002",
    "school_name_1": "des Pionniers",
    "admin_body_number": "733000",
    "admin_body_name": "Centre de services scolaire des Découvreurs",
    "area_name": "Capitale-Nationale ",
    "étudiants": "523",
    "langue": "français",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "9.2",
    "ehdaa_2024": "28.3",
    "rang_2024": "112/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "61.6",
    "lens_2019": "65.5",
    "lens_2022": "68.4",
    "lens_2023": "69.5",
    "lens_2024": "71.5",
    "lens_trend": "112233",
    "lsec_2018": "73.5",
    "lsec_2019": "74.3",
    "lsec_2022": "77.7",
    "lsec_2023": "76.6",
    "lsec_2024": "80.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.2",
    "scie_2019": "73.2",
    "scie_2022": "70.7",
    "scie_2023": "76.0",
    "scie_2024": "73.1",
    "scie_trend": "112233",
    "math_2018": "74.1",
    "math_2019": "78.8",
    "math_2022": "79.5",
    "math_2023": "76.3",
    "math_2024": "80.0",
    "math_trend": "—",
    "echec_2018": "17.0",
    "echec_2019": "17.3",
    "echec_2022": "15.3",
    "echec_2023": "9.8",
    "echec_2024": "10.5",
    "echec_trend": "112233",
    "sures_2018": "2.3",
    "sures_2019": "1.1",
    "sures_2022": "2.6",
    "sures_2023": "2.4",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.8",
    "ecart_sexes_math_2019": "M 2.8",
    "ecart_sexes_math_2022": "F 3.0",
    "ecart_sexes_math_2023": "F 2.0",
    "ecart_sexes_math_2024": "F 0.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "11.3",
    "prog_2019": "25.4",
    "prog_2022": "6.1",
    "prog_2023": "17.5",
    "prog_2024": "21.6",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "5.5",
    "cote_2022": "6.8",
    "cote_2023": "6.4",
    "cote_2024": "7.1",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École des Pionniers",
    "nom_court": "École des Pionniers",
    "adresse": "130, rue Jean-Juneau",
    "municipalite": "Saint-Augustin-de-Desmaures",
    "code_postal": "G3A 2P2",
    "lat": 46.74235,
    "lng": -71.45556
  },
  {
    "_id": "38",
    "school_code": "733030",
    "school_name_1": "de L'Ancienne-Lorette",
    "admin_body_number": "733000",
    "admin_body_name": "Centre de services scolaire des Découvreurs",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1217",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "7.9",
    "ehdaa_2024": "33.9",
    "rang_2024": "207/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "69.0",
    "lens_2019": "69.6",
    "lens_2022": "65.6",
    "lens_2023": "72.3",
    "lens_2024": "68.5",
    "lens_trend": "—",
    "lsec_2018": "83.2",
    "lsec_2019": "80.7",
    "lsec_2022": "85.3",
    "lsec_2023": "82.7",
    "lsec_2024": "82.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.7",
    "scie_2019": "69.5",
    "scie_2022": "71.3",
    "scie_2023": "76.8",
    "scie_2024": "68.5",
    "scie_trend": "—",
    "math_2018": "69.8",
    "math_2019": "74.3",
    "math_2022": "76.5",
    "math_2023": "75.3",
    "math_2024": "75.7",
    "math_trend": "—",
    "echec_2018": "16.6",
    "echec_2019": "16.0",
    "echec_2022": "19.0",
    "echec_2023": "9.4",
    "echec_2024": "17.9",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "0.9",
    "sures_2022": "3.4",
    "sures_2023": "1.5",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.4",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 5.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.6",
    "ecart_sexes_math_2019": "F 9.0",
    "ecart_sexes_math_2022": "F 7.9",
    "ecart_sexes_math_2023": "F 0.6",
    "ecart_sexes_math_2024": "F 4.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.3",
    "prog_2019": "21.9",
    "prog_2022": "19.2",
    "prog_2023": "19.9",
    "prog_2024": "20.6",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "5.8",
    "cote_2022": "6.3",
    "cote_2023": "7.0",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire polyvalente de L'Ancienne-Lorette",
    "nom_court": "Polyvalente de L'Ancienne-Lorette",
    "adresse": "1801, rue Notre-Dame",
    "municipalite": "L'Ancienne-Lorette",
    "code_postal": "G2E 3C6",
    "lat": 46.80995,
    "lng": -71.36116
  },
  {
    "_id": "39",
    "school_code": "733031",
    "school_name_1": "De Rochebelle",
    "admin_body_number": "733000",
    "admin_body_name": "Centre de services scolaire des Découvreurs",
    "area_name": "Capitale-Nationale ",
    "étudiants": "2171",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "12.9",
    "ehdaa_2024": "27",
    "rang_2024": "182/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "71.5",
    "lens_2019": "72.2",
    "lens_2022": "69.3",
    "lens_2023": "69.4",
    "lens_2024": "66.5",
    "lens_trend": "—",
    "lsec_2018": "77.4",
    "lsec_2019": "78.3",
    "lsec_2022": "78.6",
    "lsec_2023": "79.1",
    "lsec_2024": "78.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.6",
    "scie_2019": "80.1",
    "scie_2022": "76.4",
    "scie_2023": "77.8",
    "scie_2024": "76.2",
    "scie_trend": "—",
    "math_2018": "71.9",
    "math_2019": "78.2",
    "math_2022": "76.4",
    "math_2023": "81.1",
    "math_2024": "81.2",
    "math_trend": "—",
    "echec_2018": "14.9",
    "echec_2019": "10.9",
    "echec_2022": "15.8",
    "echec_2023": "12.9",
    "echec_2024": "15.4",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.4",
    "sures_2022": "2.3",
    "sures_2023": "1.6",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 4.0",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.3",
    "ecart_sexes_math_2019": "F 5.2",
    "ecart_sexes_math_2022": "F 10.3",
    "ecart_sexes_math_2023": "F 1.7",
    "ecart_sexes_math_2024": "F 4.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "14.7",
    "prog_2019": "22.3",
    "prog_2022": "10.7",
    "prog_2023": "22.1",
    "prog_2024": "22.1",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.8",
    "cote_2022": "6.5",
    "cote_2023": "6.7",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire De Rochebelle",
    "nom_court": "École secondaire De Rochebelle",
    "adresse": "1095, avenue de Rochebelle",
    "municipalite": "Québec",
    "code_postal": "G1V 4P8",
    "lat": 46.7693,
    "lng": -71.29963
  },
  {
    "_id": "40",
    "school_code": "733032",
    "school_name_1": "Collège des Compagnons",
    "admin_body_number": "733000",
    "admin_body_name": "Centre de services scolaire des Découvreurs",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1451",
    "langue": "français",
    "secteur": "public",
    "rang": "103",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "9.8",
    "ehdaa_2024": "28.3",
    "rang_2024": "103/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "66.4",
    "lens_2019": "71.8",
    "lens_2022": "67.0",
    "lens_2023": "72.1",
    "lens_2024": "70.0",
    "lens_trend": "112233",
    "lsec_2018": "75.0",
    "lsec_2019": "77.7",
    "lsec_2022": "81.0",
    "lsec_2023": "80.3",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.7",
    "scie_2019": "76.0",
    "scie_2022": "79.1",
    "scie_2023": "82.0",
    "scie_2024": "74.0",
    "scie_trend": "—",
    "math_2018": "73.8",
    "math_2019": "74.6",
    "math_2022": "82.0",
    "math_2023": "82.2",
    "math_2024": "78.5",
    "math_trend": "—",
    "echec_2018": "14.0",
    "echec_2019": "11.0",
    "echec_2022": "9.4",
    "echec_2023": "6.1",
    "echec_2024": "10.0",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "0.5",
    "sures_2022": "2.1",
    "sures_2023": "0.7",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.0",
    "ecart_sexes_lens_2019": "M 0.3",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 3.6",
    "ecart_sexes_lens_2024": "M 1.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.7",
    "ecart_sexes_math_2019": "F 0.1",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "M 1.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "15.5",
    "prog_2019": "15.2",
    "prog_2022": "6.6",
    "prog_2023": "9.6",
    "prog_2024": "4.8",
    "prog_trend": "112233",
    "cote_2018": "5.5",
    "cote_2019": "6.8",
    "cote_2022": "7.5",
    "cote_2023": "7.6",
    "cote_2024": "7.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège des Compagnons",
    "nom_court": "Collège des Compagnons",
    "adresse": "3643, avenue des Compagnons",
    "municipalite": "Québec",
    "code_postal": "G1X 3Z6",
    "lat": 46.75904,
    "lng": -71.32905
  },
  {
    "_id": "41",
    "school_code": "734051",
    "school_name_1": "Samuel-De Champlain",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1159",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "28.2",
    "ehdaa_2024": "36.3",
    "rang_2024": "310/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "71.6",
    "lens_2019": "69.5",
    "lens_2022": "61.6",
    "lens_2023": "63.4",
    "lens_2024": "61.3",
    "lens_trend": "998855",
    "lsec_2018": "77.4",
    "lsec_2019": "78.8",
    "lsec_2022": "78.7",
    "lsec_2023": "78.3",
    "lsec_2024": "79.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.7",
    "scie_2019": "67.9",
    "scie_2022": "67.3",
    "scie_2023": "67.0",
    "scie_2024": "69.4",
    "scie_trend": "—",
    "math_2018": "71.5",
    "math_2019": "76.6",
    "math_2022": "71.3",
    "math_2023": "69.6",
    "math_2024": "77.0",
    "math_trend": "—",
    "echec_2018": "12.5",
    "echec_2019": "15.1",
    "echec_2022": "24.9",
    "echec_2023": "25.4",
    "echec_2024": "20.1",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.2",
    "sures_2022": "2.0",
    "sures_2023": "3.2",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "M 0.8",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 3.2",
    "ecart_sexes_math_2019": "F 5.0",
    "ecart_sexes_math_2022": "F 1.9",
    "ecart_sexes_math_2023": "F 0.2",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "52.2",
    "prog_2019": "48.0",
    "prog_2022": "43.7",
    "prog_2023": "39.3",
    "prog_2024": "37.9",
    "prog_trend": "112233",
    "cote_2018": "5.4",
    "cote_2019": "5.4",
    "cote_2022": "4.7",
    "cote_2023": "4.4",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Samuel-De Champlain",
    "nom_court": "École Samuel-De Champlain",
    "adresse": "2740, avenue Saint-David",
    "municipalite": "Québec",
    "code_postal": "G1E 4K7",
    "lat": 46.86056,
    "lng": -71.20985
  },
  {
    "_id": "42",
    "school_code": "734052",
    "school_name_1": "de la Seigneurie",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1773",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "3.8",
    "ehdaa_2024": "17.4",
    "rang_2024": "137/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "73.3",
    "lens_2019": "72.7",
    "lens_2022": "67.7",
    "lens_2023": "69.0",
    "lens_2024": "66.2",
    "lens_trend": "998855",
    "lsec_2018": "76.7",
    "lsec_2019": "75.3",
    "lsec_2022": "82.0",
    "lsec_2023": "78.5",
    "lsec_2024": "78.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.0",
    "scie_2019": "72.1",
    "scie_2022": "71.1",
    "scie_2023": "77.7",
    "scie_2024": "74.9",
    "scie_trend": "—",
    "math_2018": "76.9",
    "math_2019": "76.9",
    "math_2022": "75.3",
    "math_2023": "72.7",
    "math_2024": "75.1",
    "math_trend": "998855",
    "echec_2018": "11.2",
    "echec_2019": "13.7",
    "echec_2022": "17.8",
    "echec_2023": "15.1",
    "echec_2024": "15.6",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.2",
    "sures_2022": "1.7",
    "sures_2023": "1.3",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 10.7",
    "ecart_sexes_math_2019": "F 5.0",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 2.2",
    "ecart_sexes_math_2024": "F 0.9",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "17.4",
    "prog_2019": "23.8",
    "prog_2022": "16.9",
    "prog_2023": "19.7",
    "prog_2024": "18.8",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "6.3",
    "cote_2022": "6.8",
    "cote_2023": "6.5",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de la Seigneurie",
    "nom_court": "École de la Seigneurie",
    "adresse": "645, avenue du Cénacle",
    "municipalite": "Québec",
    "code_postal": "G1E 1B3",
    "lat": 46.87344,
    "lng": -71.19181
  },
  {
    "_id": "43",
    "school_code": "734057",
    "school_name_1": "Charlesbourg",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1891",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "11.7",
    "ehdaa_2024": "23.8",
    "rang_2024": "149/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "69.8",
    "lens_2019": "70.9",
    "lens_2022": "63.9",
    "lens_2023": "67.0",
    "lens_2024": "65.1",
    "lens_trend": "—",
    "lsec_2018": "76.7",
    "lsec_2019": "79.8",
    "lsec_2022": "79.4",
    "lsec_2023": "81.3",
    "lsec_2024": "83.2",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.3",
    "scie_2019": "71.1",
    "scie_2022": "73.4",
    "scie_2023": "79.1",
    "scie_2024": "70.1",
    "scie_trend": "—",
    "math_2018": "72.2",
    "math_2019": "76.8",
    "math_2022": "77.4",
    "math_2023": "76.1",
    "math_2024": "79.1",
    "math_trend": "—",
    "echec_2018": "16.9",
    "echec_2019": "15.3",
    "echec_2022": "17.3",
    "echec_2023": "14.0",
    "echec_2024": "18.7",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.3",
    "sures_2022": "2.9",
    "sures_2023": "0.3",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.0",
    "ecart_sexes_lens_2019": "F 4.2",
    "ecart_sexes_lens_2022": "F 7.2",
    "ecart_sexes_lens_2023": "F 5.3",
    "ecart_sexes_lens_2024": "F 1.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.6",
    "ecart_sexes_math_2019": "F 14.2",
    "ecart_sexes_math_2022": "F 7.2",
    "ecart_sexes_math_2023": "F 11.5",
    "ecart_sexes_math_2024": "F 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.5",
    "prog_2019": "43.1",
    "prog_2022": "29.0",
    "prog_2023": "35.0",
    "prog_2024": "31.7",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "5.8",
    "cote_2022": "6.0",
    "cote_2023": "6.2",
    "cote_2024": "6.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente de Charlesbourg",
    "nom_court": "Polyvalente de Charlesbourg",
    "adresse": "900, rue de la Sorbonne",
    "municipalite": "Québec",
    "code_postal": "G1H 1H1",
    "lat": 46.86391,
    "lng": -71.25478
  },
  {
    "_id": "44",
    "school_code": "734060",
    "school_name_1": "de la Courvilloise",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1610",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "25.8",
    "rang_2024": "182/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "69.6",
    "lens_2019": "69.9",
    "lens_2022": "68.5",
    "lens_2023": "69.2",
    "lens_2024": "66.0",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "75.5",
    "lsec_2022": "77.5",
    "lsec_2023": "76.4",
    "lsec_2024": "81.3",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.7",
    "scie_2019": "72.5",
    "scie_2022": "69.6",
    "scie_2023": "76.6",
    "scie_2024": "70.3",
    "scie_trend": "—",
    "math_2018": "77.0",
    "math_2019": "77.1",
    "math_2022": "75.1",
    "math_2023": "76.5",
    "math_2024": "80.9",
    "math_trend": "—",
    "echec_2018": "13.6",
    "echec_2019": "12.7",
    "echec_2022": "20.0",
    "echec_2023": "15.0",
    "echec_2024": "18.7",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "1.7",
    "sures_2022": "1.5",
    "sures_2023": "1.1",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.9",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 4.3",
    "ecart_sexes_lens_2023": "F 5.7",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.5",
    "ecart_sexes_math_2019": "F 0.8",
    "ecart_sexes_math_2022": "F 9.2",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 2.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.0",
    "prog_2019": "31.9",
    "prog_2022": "17.1",
    "prog_2023": "29.3",
    "prog_2024": "28.4",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "6.2",
    "cote_2022": "6.2",
    "cote_2023": "6.2",
    "cote_2024": "6.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École de la Courvilloise",
    "nom_court": "École de la Courvilloise",
    "adresse": "2265, avenue Larue",
    "municipalite": "Québec",
    "code_postal": "G1C 1J9",
    "lat": 46.89053,
    "lng": -71.16272
  },
  {
    "_id": "45",
    "school_code": "734061",
    "school_name_1": "du Mont-Sainte-Anne",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1116",
    "langue": "français",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "11.5",
    "ehdaa_2024": "27.9",
    "rang_2024": "252/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "69.6",
    "lens_2019": "69.3",
    "lens_2022": "64.1",
    "lens_2023": "64.8",
    "lens_2024": "61.7",
    "lens_trend": "998855",
    "lsec_2018": "77.1",
    "lsec_2019": "74.4",
    "lsec_2022": "75.2",
    "lsec_2023": "77.4",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.9",
    "scie_2019": "75.7",
    "scie_2022": "70.6",
    "scie_2023": "78.3",
    "scie_2024": "78.7",
    "scie_trend": "—",
    "math_2018": "76.5",
    "math_2019": "79.7",
    "math_2022": "68.8",
    "math_2023": "75.2",
    "math_2024": "80.5",
    "math_trend": "—",
    "echec_2018": "11.3",
    "echec_2019": "11.3",
    "echec_2022": "25.3",
    "echec_2023": "14.4",
    "echec_2024": "17.5",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "1.5",
    "sures_2022": "7.1",
    "sures_2023": "4.3",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.9",
    "ecart_sexes_lens_2019": "F 7.5",
    "ecart_sexes_lens_2022": "F 8.8",
    "ecart_sexes_lens_2023": "F 5.3",
    "ecart_sexes_lens_2024": "F 6.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.1",
    "ecart_sexes_math_2019": "F 12.0",
    "ecart_sexes_math_2022": "F 0.1",
    "ecart_sexes_math_2023": "M 10.9",
    "ecart_sexes_math_2024": "F 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.6",
    "prog_2019": "22.9",
    "prog_2022": "23.5",
    "prog_2023": "29.4",
    "prog_2024": "23.6",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "5.9",
    "cote_2022": "4.8",
    "cote_2023": "5.3",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École du Mont-Sainte-Anne",
    "nom_court": "École du Mont-Sainte-Anne",
    "adresse": "10975, boulevard Sainte-Anne",
    "municipalite": "Beaupré",
    "code_postal": "G0A 1E0",
    "lat": 47.03963,
    "lng": -70.89907
  },
  {
    "_id": "46",
    "school_code": "734065",
    "school_name_1": "le Sommet",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1333",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "15.8",
    "ehdaa_2024": "29.6",
    "rang_2024": "335/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "69.5",
    "lens_2019": "67.8",
    "lens_2022": "64.2",
    "lens_2023": "66.6",
    "lens_2024": "64.3",
    "lens_trend": "—",
    "lsec_2018": "76.4",
    "lsec_2019": "75.5",
    "lsec_2022": "76.2",
    "lsec_2023": "74.8",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.3",
    "scie_2019": "63.6",
    "scie_2022": "69.3",
    "scie_2023": "73.8",
    "scie_2024": "68.8",
    "scie_trend": "112233",
    "math_2018": "67.7",
    "math_2019": "72.0",
    "math_2022": "74.4",
    "math_2023": "76.3",
    "math_2024": "76.7",
    "math_trend": "—",
    "echec_2018": "20.7",
    "echec_2019": "22.5",
    "echec_2022": "24.6",
    "echec_2023": "16.9",
    "echec_2024": "20.4",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.2",
    "sures_2022": "3.0",
    "sures_2023": "2.0",
    "sures_2024": "3.3",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 4.9",
    "ecart_sexes_lens_2022": "F 8.3",
    "ecart_sexes_lens_2023": "M 2.6",
    "ecart_sexes_lens_2024": "F 9.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.8",
    "ecart_sexes_math_2019": "F 9.0",
    "ecart_sexes_math_2022": "F 3.6",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "F 6.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.3",
    "prog_2019": "28.9",
    "prog_2022": "23.9",
    "prog_2023": "42.9",
    "prog_2024": "41.2",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "4.9",
    "cote_2022": "5.5",
    "cote_2023": "5.6",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Le Sommet",
    "nom_court": "École Le Sommet",
    "adresse": "120, rue de la Polyvalente",
    "municipalite": "Québec",
    "code_postal": "G2N 1G8",
    "lat": 46.91423,
    "lng": -71.32848
  },
  {
    "_id": "47",
    "school_code": "734066",
    "school_name_1": "des Sentiers",
    "admin_body_number": "734000",
    "admin_body_name": "Centre de services scolaire des Premières-Seigneuries",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1294",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "11",
    "ehdaa_2024": "26.4",
    "rang_2024": "260/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "71.3",
    "lens_2019": "70.6",
    "lens_2022": "66.0",
    "lens_2023": "68.7",
    "lens_2024": "65.2",
    "lens_trend": "998855",
    "lsec_2018": "79.1",
    "lsec_2019": "76.4",
    "lsec_2022": "79.7",
    "lsec_2023": "79.9",
    "lsec_2024": "81.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "71.3",
    "scie_2022": "71.5",
    "scie_2023": "73.8",
    "scie_2024": "71.2",
    "scie_trend": "—",
    "math_2018": "80.0",
    "math_2019": "79.5",
    "math_2022": "73.1",
    "math_2023": "76.3",
    "math_2024": "75.3",
    "math_trend": "998855",
    "echec_2018": "9.2",
    "echec_2019": "14.0",
    "echec_2022": "20.9",
    "echec_2023": "12.4",
    "echec_2024": "20.9",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.5",
    "sures_2022": "2.7",
    "sures_2023": "1.8",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.9",
    "ecart_sexes_lens_2019": "F 6.2",
    "ecart_sexes_lens_2022": "F 8.9",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 9.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.4",
    "ecart_sexes_math_2019": "F 11.4",
    "ecart_sexes_math_2022": "F 7.8",
    "ecart_sexes_math_2023": "F 4.1",
    "ecart_sexes_math_2024": "F 9.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.8",
    "prog_2019": "14.3",
    "prog_2022": "10.8",
    "prog_2023": "24.0",
    "prog_2024": "23.0",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.3",
    "cote_2022": "6.2",
    "cote_2023": "6.5",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École des Sentiers",
    "nom_court": "École des Sentiers",
    "adresse": "1090, chemin de Château-Bigot",
    "municipalite": "Québec",
    "code_postal": "G2L 1G1",
    "lat": 46.886,
    "lng": -71.26824
  },
  {
    "_id": "48",
    "school_code": "735010",
    "school_name_1": "Donnacona",
    "admin_body_number": "735000",
    "admin_body_name": "Centre de services scolaire de Portneuf",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1181",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "20",
    "ehdaa_2024": "26.9",
    "rang_2024": "277/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "71.8",
    "lens_2019": "73.6",
    "lens_2022": "69.9",
    "lens_2023": "72.2",
    "lens_2024": "65.2",
    "lens_trend": "—",
    "lsec_2018": "74.1",
    "lsec_2019": "71.2",
    "lsec_2022": "78.2",
    "lsec_2023": "73.5",
    "lsec_2024": "76.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.0",
    "scie_2019": "78.4",
    "scie_2022": "75.9",
    "scie_2023": "76.6",
    "scie_2024": "74.7",
    "scie_trend": "—",
    "math_2018": "73.6",
    "math_2019": "75.8",
    "math_2022": "80.6",
    "math_2023": "76.6",
    "math_2024": "82.3",
    "math_trend": "—",
    "echec_2018": "13.7",
    "echec_2019": "12.8",
    "echec_2022": "11.6",
    "echec_2023": "14.2",
    "echec_2024": "15.7",
    "echec_trend": "—",
    "sures_2018": "1.4",
    "sures_2019": "1.2",
    "sures_2022": "1.7",
    "sures_2023": "2.4",
    "sures_2024": "4.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 3.2",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.4",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "M 1.6",
    "ecart_sexes_math_2023": "F 9.6",
    "ecart_sexes_math_2024": "F 2.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "24.4",
    "prog_2019": "22.4",
    "prog_2022": "29.9",
    "prog_2023": "27.9",
    "prog_2024": "37.6",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "6.2",
    "cote_2022": "6.8",
    "cote_2023": "5.9",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Donnacona",
    "nom_court": "École secondaire de Donnacona",
    "adresse": "320, rue de l'Église",
    "municipalite": "Donnacona",
    "code_postal": "G3M 2A1",
    "lat": 46.67897,
    "lng": -71.72714
  },
  {
    "_id": "49",
    "school_code": "735013",
    "school_name_1": "Louis-Jobin",
    "admin_body_number": "735000",
    "admin_body_name": "Centre de services scolaire de Portneuf",
    "area_name": "Capitale-Nationale ",
    "étudiants": "778",
    "langue": "français",
    "secteur": "public",
    "rang": "417",
    "rang_5_ans": "391",
    "index": "0.1",
    "en_retard_2024": "20",
    "ehdaa_2024": "35.3",
    "rang_2024": "417/470",
    "rang_2019_2024": "391/432",
    "lens_2018": "72.1",
    "lens_2019": "66.8",
    "lens_2022": "64.8",
    "lens_2023": "66.0",
    "lens_2024": "64.0",
    "lens_trend": "—",
    "lsec_2018": "71.3",
    "lsec_2019": "68.4",
    "lsec_2022": "79.3",
    "lsec_2023": "75.9",
    "lsec_2024": "82.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.6",
    "scie_2019": "71.1",
    "scie_2022": "66.9",
    "scie_2023": "72.3",
    "scie_2024": "65.8",
    "scie_trend": "—",
    "math_2018": "66.1",
    "math_2019": "71.1",
    "math_2022": "62.5",
    "math_2023": "67.7",
    "math_2024": "71.7",
    "math_trend": "—",
    "echec_2018": "17.8",
    "echec_2019": "24.3",
    "echec_2022": "26.5",
    "echec_2023": "23.9",
    "echec_2024": "25.6",
    "echec_trend": "—",
    "sures_2018": "3.7",
    "sures_2019": "5.0",
    "sures_2022": "7.5",
    "sures_2023": "6.6",
    "sures_2024": "7.5",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 1.5",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 0.5",
    "ecart_sexes_lens_2023": "E",
    "ecart_sexes_lens_2024": "F 10.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.3",
    "ecart_sexes_math_2019": "F 8.0",
    "ecart_sexes_math_2022": "F 13.7",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "F 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.7",
    "prog_2019": "44.0",
    "prog_2022": "30.5",
    "prog_2023": "46.5",
    "prog_2024": "43.6",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "3.5",
    "cote_2022": "4.3",
    "cote_2023": "4.2",
    "cote_2024": "4.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Louis-Jobin",
    "nom_court": "École secondaire Louis-Jobin",
    "adresse": "400, boulevard Cloutier",
    "municipalite": "Saint-Raymond",
    "code_postal": "G3L 3M8",
    "lat": 46.89371,
    "lng": -71.81942
  },
  {
    "_id": "50",
    "school_code": "735014",
    "school_name_1": "Saint-Marc",
    "admin_body_number": "735000",
    "admin_body_name": "Centre de services scolaire de Portneuf",
    "area_name": "Capitale-Nationale ",
    "étudiants": "573",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "8.7",
    "ehdaa_2024": "25.8",
    "rang_2024": "229/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "74.6",
    "lens_2019": "75.2",
    "lens_2022": "70.2",
    "lens_2023": "74.3",
    "lens_2024": "68.0",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "73.2",
    "lsec_2022": "77.1",
    "lsec_2023": "75.0",
    "lsec_2024": "74.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "68.9",
    "scie_2022": "69.9",
    "scie_2023": "72.8",
    "scie_2024": "69.9",
    "scie_trend": "—",
    "math_2018": "82.6",
    "math_2019": "78.5",
    "math_2022": "80.9",
    "math_2023": "81.1",
    "math_2024": "86.0",
    "math_trend": "—",
    "echec_2018": "7.5",
    "echec_2019": "16.4",
    "echec_2022": "12.9",
    "echec_2023": "11.9",
    "echec_2024": "16.3",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "3.0",
    "sures_2022": "0.9",
    "sures_2023": "0.5",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.5",
    "ecart_sexes_lens_2019": "F 2.7",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 10.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.5",
    "ecart_sexes_math_2019": "F 4.6",
    "ecart_sexes_math_2022": "M 1.9",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.0",
    "prog_2019": "18.2",
    "prog_2022": "23.3",
    "prog_2023": "28.1",
    "prog_2024": "24.5",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "5.6",
    "cote_2022": "6.7",
    "cote_2023": "6.7",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Saint-Marc",
    "nom_court": "École secondaire de Saint-Marc",
    "adresse": "1600, boulevard Bona-Dussault",
    "municipalite": "Saint-Marc-des-Carrières",
    "code_postal": "G0A 4B0",
    "lat": 46.68754,
    "lng": -72.06133
  },
  {
    "_id": "51",
    "school_code": "741017",
    "school_name_1": "Avenues-Nouvelles",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "251",
    "langue": "français",
    "secteur": "public",
    "rang": "464",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "83.3",
    "ehdaa_2024": "63.7",
    "rang_2024": "464/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "60.7",
    "lens_2023": "59.1",
    "lens_2024": "59.3",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "74.9",
    "lsec_2023": "73.1",
    "lsec_2024": "74.7",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "53.6",
    "scie_2023": "56.4",
    "scie_2024": "52.4",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "52.3",
    "math_2023": "61.1",
    "math_2024": "70.2",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "44.0",
    "echec_2023": "41.9",
    "echec_2024": "35.0",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "8.3",
    "sures_2023": "5.7",
    "sures_2024": "3.6",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 13.2",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "M 1.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 2.7",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "80.0",
    "prog_2023": "84.0",
    "prog_2024": "85.2",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "0.7",
    "cote_2023": "0.7",
    "cote_2024": "1.5",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Avenues-Nouvelles",
    "nom_court": "École Avenues-Nouvelles",
    "adresse": "60, rue Jean-Noël-Trudel",
    "municipalite": "Trois-Rivières",
    "code_postal": "G8T 5W3",
    "lat": 46.36182,
    "lng": -72.50671
  },
  {
    "_id": "52",
    "school_code": "741108",
    "school_name_1": "L'Escale",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "658",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "19.8",
    "ehdaa_2024": "39.2",
    "rang_2024": "420/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "72.8",
    "lens_2019": "70.6",
    "lens_2022": "70.3",
    "lens_2023": "73.3",
    "lens_2024": "71.1",
    "lens_trend": "—",
    "lsec_2018": "80.7",
    "lsec_2019": "79.6",
    "lsec_2022": "81.8",
    "lsec_2023": "84.6",
    "lsec_2024": "78.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.8",
    "scie_2019": "75.0",
    "scie_2022": "75.4",
    "scie_2023": "73.8",
    "scie_2024": "69.8",
    "scie_trend": "—",
    "math_2018": "65.7",
    "math_2019": "67.3",
    "math_2022": "73.0",
    "math_2023": "68.5",
    "math_2024": "57.5",
    "math_trend": "—",
    "echec_2018": "13.1",
    "echec_2019": "16.8",
    "echec_2022": "12.3",
    "echec_2023": "16.0",
    "echec_2024": "27.7",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "0.6",
    "sures_2022": "1.9",
    "sures_2023": "2.4",
    "sures_2024": "6.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.1",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 4.9",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "M 0.5",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 3.3",
    "ecart_sexes_math_2019": "F 9.3",
    "ecart_sexes_math_2022": "M 4.1",
    "ecart_sexes_math_2023": "F 0.6",
    "ecart_sexes_math_2024": "M 4.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "8.4",
    "prog_2019": "19.1",
    "prog_2022": "15.7",
    "prog_2023": "17.7",
    "prog_2024": "23.1",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "5.4",
    "cote_2022": "7.0",
    "cote_2023": "6.6",
    "cote_2024": "4.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire l'Escale",
    "nom_court": "École secondaire l'Escale",
    "adresse": "391, rue De La Mennais",
    "municipalite": "Louiseville",
    "code_postal": "J5V 1T5",
    "lat": 46.24962,
    "lng": -72.94944
  },
  {
    "_id": "53",
    "school_code": "741109",
    "school_name_1": "Les Estacades",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "2601",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "12.8",
    "ehdaa_2024": "30.6",
    "rang_2024": "360/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "68.5",
    "lens_2019": "67.4",
    "lens_2022": "64.4",
    "lens_2023": "64.4",
    "lens_2024": "62.9",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "81.2",
    "lsec_2022": "81.3",
    "lsec_2023": "81.1",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.1",
    "scie_2019": "69.7",
    "scie_2022": "66.8",
    "scie_2023": "74.0",
    "scie_2024": "70.1",
    "scie_trend": "—",
    "math_2018": "67.5",
    "math_2019": "66.5",
    "math_2022": "68.8",
    "math_2023": "65.5",
    "math_2024": "69.6",
    "math_trend": "—",
    "echec_2018": "19.8",
    "echec_2019": "20.1",
    "echec_2022": "24.4",
    "echec_2023": "22.1",
    "echec_2024": "23.7",
    "echec_trend": "—",
    "sures_2018": "2.8",
    "sures_2019": "1.4",
    "sures_2022": "1.8",
    "sures_2023": "2.9",
    "sures_2024": "4.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 4.1",
    "ecart_sexes_lens_2023": "F 1.1",
    "ecart_sexes_lens_2024": "F 2.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "F 4.9",
    "ecart_sexes_math_2022": "F 1.0",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 3.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.7",
    "prog_2019": "31.2",
    "prog_2022": "17.3",
    "prog_2023": "31.0",
    "prog_2024": "24.9",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "5.4",
    "cote_2022": "5.8",
    "cote_2023": "5.1",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie les Estacades",
    "nom_court": "Académie les Estacades",
    "adresse": "501, rue des Érables",
    "municipalite": "Trois-Rivières",
    "code_postal": "G8T 5J2",
    "lat": 46.37003,
    "lng": -72.515
  },
  {
    "_id": "54",
    "school_code": "741110",
    "school_name_1": "des Pionniers",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "1704",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "18.2",
    "ehdaa_2024": "36",
    "rang_2024": "149/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "71.1",
    "lens_2019": "69.7",
    "lens_2022": "64.5",
    "lens_2023": "68.5",
    "lens_2024": "69.3",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "82.7",
    "lsec_2022": "82.4",
    "lsec_2023": "82.2",
    "lsec_2024": "79.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.3",
    "scie_2019": "71.2",
    "scie_2022": "70.0",
    "scie_2023": "77.9",
    "scie_2024": "76.4",
    "scie_trend": "—",
    "math_2018": "73.0",
    "math_2019": "70.2",
    "math_2022": "72.5",
    "math_2023": "76.5",
    "math_2024": "81.7",
    "math_trend": "—",
    "echec_2018": "13.9",
    "echec_2019": "19.3",
    "echec_2022": "21.1",
    "echec_2023": "13.6",
    "echec_2024": "10.8",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.4",
    "sures_2022": "4.3",
    "sures_2023": "0.3",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 7.5",
    "ecart_sexes_lens_2022": "F 3.8",
    "ecart_sexes_lens_2023": "F 1.8",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.9",
    "ecart_sexes_math_2019": "F 6.4",
    "ecart_sexes_math_2022": "M 5.4",
    "ecart_sexes_math_2023": "M 5.1",
    "ecart_sexes_math_2024": "F 4.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.8",
    "prog_2019": "27.2",
    "prog_2022": "27.1",
    "prog_2023": "31.5",
    "prog_2024": "33.4",
    "prog_trend": "998855",
    "cote_2018": "6.2",
    "cote_2019": "5.4",
    "cote_2022": "5.7",
    "cote_2023": "6.6",
    "cote_2024": "6.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Pionniers",
    "nom_court": "École secondaire des Pionniers",
    "adresse": "1725, boulevard du Carmel",
    "municipalite": "Trois-Rivières",
    "code_postal": "G8Z 3R8",
    "lat": 46.35177,
    "lng": -72.56109
  },
  {
    "_id": "55",
    "school_code": "741111",
    "school_name_1": "Chavigny",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "1946",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "16.9",
    "ehdaa_2024": "37.8",
    "rang_2024": "335/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "69.7",
    "lens_2019": "70.3",
    "lens_2022": "66.3",
    "lens_2023": "68.7",
    "lens_2024": "66.6",
    "lens_trend": "—",
    "lsec_2018": "75.9",
    "lsec_2019": "76.3",
    "lsec_2022": "75.8",
    "lsec_2023": "79.9",
    "lsec_2024": "76.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.6",
    "scie_2019": "67.8",
    "scie_2022": "67.8",
    "scie_2023": "72.7",
    "scie_2024": "67.0",
    "scie_trend": "—",
    "math_2018": "62.2",
    "math_2019": "69.8",
    "math_2022": "73.9",
    "math_2023": "70.1",
    "math_2024": "75.9",
    "math_trend": "—",
    "echec_2018": "23.6",
    "echec_2019": "20.6",
    "echec_2022": "21.7",
    "echec_2023": "17.6",
    "echec_2024": "19.1",
    "echec_trend": "112233",
    "sures_2018": "4.7",
    "sures_2019": "2.8",
    "sures_2022": "4.4",
    "sures_2023": "2.0",
    "sures_2024": "3.1",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 2.9",
    "ecart_sexes_lens_2019": "F 6.2",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 3.0",
    "ecart_sexes_lens_2024": "F 6.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 3.7",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 3.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.5",
    "prog_2019": "34.1",
    "prog_2022": "24.3",
    "prog_2023": "29.3",
    "prog_2024": "31.3",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "4.6",
    "cote_2022": "5.4",
    "cote_2023": "5.7",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Chavigny",
    "nom_court": "École Chavigny",
    "adresse": "365, rue Chavigny",
    "municipalite": "Trois-Rivières",
    "code_postal": "G9B 1A7",
    "lat": 46.31297,
    "lng": -72.58455
  },
  {
    "_id": "56",
    "school_code": "741112",
    "school_name_1": "le Tremplin",
    "admin_body_number": "741000",
    "admin_body_name": "Centre de services scolaire du Chemin-du-Roy",
    "area_name": "Mauricie ",
    "étudiants": "357",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "14.5",
    "ehdaa_2024": "42.6",
    "rang_2024": "360/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "72.7",
    "lens_2019": "71.6",
    "lens_2022": "63.4",
    "lens_2023": "72.5",
    "lens_2024": "66.6",
    "lens_trend": "—",
    "lsec_2018": "72.6",
    "lsec_2019": "75.6",
    "lsec_2022": "78.4",
    "lsec_2023": "82.9",
    "lsec_2024": "81.8",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.5",
    "scie_2019": "74.4",
    "scie_2022": "69.6",
    "scie_2023": "79.0",
    "scie_2024": "71.0",
    "scie_trend": "—",
    "math_2018": "58.4",
    "math_2019": "74.4",
    "math_2022": "64.7",
    "math_2023": "67.2",
    "math_2024": "63.9",
    "math_trend": "—",
    "echec_2018": "16.7",
    "echec_2019": "10.6",
    "echec_2022": "24.3",
    "echec_2023": "13.3",
    "echec_2024": "20.8",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.2",
    "sures_2022": "5.1",
    "sures_2023": "1.6",
    "sures_2024": "4.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 1.3",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 9.3",
    "ecart_sexes_lens_2023": "F 1.9",
    "ecart_sexes_lens_2024": "F 7.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.5",
    "ecart_sexes_math_2019": "F 7.3",
    "ecart_sexes_math_2022": "F 15.2",
    "ecart_sexes_math_2023": "F 2.8",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.2",
    "prog_2019": "21.7",
    "prog_2022": "18.2",
    "prog_2023": "35.7",
    "prog_2024": "27.0",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "6.1",
    "cote_2022": "4.8",
    "cote_2023": "6.4",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École le Tremplin",
    "nom_court": "École le Tremplin",
    "adresse": "100, Rivière-à-Veillet",
    "municipalite": "Sainte-Geneviève-de-Batiscan",
    "code_postal": "G0X 2R0",
    "lat": 46.5436,
    "lng": -72.34383
  },
  {
    "_id": "57",
    "school_code": "742097",
    "school_name_1": "Val-Mauricie",
    "admin_body_number": "742000",
    "admin_body_name": "Centre de services scolaire de l'Énergie",
    "area_name": "Mauricie ",
    "étudiants": "1025",
    "langue": "français",
    "secteur": "public",
    "rang": "126",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "7.6",
    "ehdaa_2024": "34.8",
    "rang_2024": "126/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "73.1",
    "lens_2019": "73.1",
    "lens_2022": "69.6",
    "lens_2023": "70.3",
    "lens_2024": "66.4",
    "lens_trend": "998855",
    "lsec_2018": "77.0",
    "lsec_2019": "80.2",
    "lsec_2022": "80.3",
    "lsec_2023": "80.4",
    "lsec_2024": "80.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.6",
    "scie_2019": "73.4",
    "scie_2022": "76.7",
    "scie_2023": "76.7",
    "scie_2024": "72.3",
    "scie_trend": "—",
    "math_2018": "73.9",
    "math_2019": "76.8",
    "math_2022": "80.6",
    "math_2023": "78.1",
    "math_2024": "82.1",
    "math_trend": "—",
    "echec_2018": "11.7",
    "echec_2019": "10.3",
    "echec_2022": "10.9",
    "echec_2023": "13.2",
    "echec_2024": "14.2",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.2",
    "sures_2022": "1.2",
    "sures_2023": "0.9",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.1",
    "ecart_sexes_lens_2019": "F 6.3",
    "ecart_sexes_lens_2022": "F 3.0",
    "ecart_sexes_lens_2023": "F 0.5",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.1",
    "ecart_sexes_math_2019": "F 16.2",
    "ecart_sexes_math_2022": "F 2.9",
    "ecart_sexes_math_2023": "M 1.7",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.0",
    "prog_2019": "20.6",
    "prog_2022": "27.9",
    "prog_2023": "25.5",
    "prog_2024": "19.3",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "6.7",
    "cote_2022": "7.2",
    "cote_2023": "7.0",
    "cote_2024": "6.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Val-Mauricie",
    "nom_court": "École secondaire Val-Mauricie",
    "adresse": "1200, rue Val-Mauricie",
    "municipalite": "Shawinigan",
    "code_postal": "G9P 2L9",
    "lat": 46.52237,
    "lng": -72.75884
  },
  {
    "_id": "58",
    "school_code": "742100",
    "school_name_1": "des Chutes",
    "admin_body_number": "742000",
    "admin_body_name": "Centre de services scolaire de l'Énergie",
    "area_name": "Mauricie ",
    "étudiants": "853",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "18.4",
    "ehdaa_2024": "29.4",
    "rang_2024": "199/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "65.8",
    "lens_2019": "70.3",
    "lens_2022": "66.0",
    "lens_2023": "67.2",
    "lens_2024": "66.3",
    "lens_trend": "—",
    "lsec_2018": "81.4",
    "lsec_2019": "80.3",
    "lsec_2022": "73.4",
    "lsec_2023": "75.5",
    "lsec_2024": "79.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.2",
    "scie_2019": "66.9",
    "scie_2022": "69.1",
    "scie_2023": "74.0",
    "scie_2024": "69.1",
    "scie_trend": "—",
    "math_2018": "80.5",
    "math_2019": "80.4",
    "math_2022": "81.2",
    "math_2023": "80.4",
    "math_2024": "86.9",
    "math_trend": "—",
    "echec_2018": "12.2",
    "echec_2019": "14.4",
    "echec_2022": "21.1",
    "echec_2023": "14.1",
    "echec_2024": "16.2",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.7",
    "sures_2022": "1.6",
    "sures_2023": "0.8",
    "sures_2024": "1.9",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.3",
    "ecart_sexes_lens_2019": "F 6.1",
    "ecart_sexes_lens_2022": "F 3.9",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.5",
    "ecart_sexes_math_2019": "F 0.9",
    "ecart_sexes_math_2022": "F 0.4",
    "ecart_sexes_math_2023": "M 3.8",
    "ecart_sexes_math_2024": "F 3.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.3",
    "prog_2019": "31.0",
    "prog_2022": "51.8",
    "prog_2023": "44.5",
    "prog_2024": "36.8",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "6.3",
    "cote_2022": "5.1",
    "cote_2023": "5.8",
    "cote_2024": "6.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Chutes",
    "nom_court": "École secondaire des Chutes",
    "adresse": "5285, avenue Albert-Tessier",
    "municipalite": "Shawinigan",
    "code_postal": "G9N 6T9",
    "lat": 46.57528,
    "lng": -72.73347
  },
  {
    "_id": "59",
    "school_code": "742105",
    "school_name_1": "Paul-Le Jeune",
    "admin_body_number": "742000",
    "admin_body_name": "Centre de services scolaire de l'Énergie",
    "area_name": "Mauricie ",
    "étudiants": "585",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "18.5",
    "ehdaa_2024": "34.5",
    "rang_2024": "217/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "69.0",
    "lens_2019": "69.0",
    "lens_2022": "66.5",
    "lens_2023": "67.1",
    "lens_2024": "68.3",
    "lens_trend": "—",
    "lsec_2018": "82.5",
    "lsec_2019": "85.1",
    "lsec_2022": "86.8",
    "lsec_2023": "84.1",
    "lsec_2024": "84.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "72.2",
    "scie_2022": "68.7",
    "scie_2023": "75.0",
    "scie_2024": "73.4",
    "scie_trend": "—",
    "math_2018": "66.8",
    "math_2019": "71.3",
    "math_2022": "70.0",
    "math_2023": "72.6",
    "math_2024": "67.2",
    "math_trend": "—",
    "echec_2018": "15.1",
    "echec_2019": "15.3",
    "echec_2022": "19.9",
    "echec_2023": "14.2",
    "echec_2024": "18.8",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "3.5",
    "sures_2022": "5.0",
    "sures_2023": "3.5",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.2",
    "ecart_sexes_lens_2019": "F 9.6",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 2.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 15.5",
    "ecart_sexes_math_2019": "F 6.1",
    "ecart_sexes_math_2022": "F 0.8",
    "ecart_sexes_math_2023": "M 1.0",
    "ecart_sexes_math_2024": "F 12.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.9",
    "prog_2019": "22.8",
    "prog_2022": "21.1",
    "prog_2023": "19.5",
    "prog_2024": "27.7",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.9",
    "cote_2022": "6.5",
    "cote_2023": "6.4",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Paul-Le Jeune",
    "nom_court": "École secondaire Paul-Le Jeune",
    "adresse": "405, boulevard Saint-Joseph",
    "municipalite": "Saint-Tite",
    "code_postal": "G0X 3H0",
    "lat": 46.73074,
    "lng": -72.56133
  },
  {
    "_id": "60",
    "school_code": "742106",
    "school_name_1": "du Rocher",
    "admin_body_number": "742000",
    "admin_body_name": "Centre de services scolaire de l'Énergie",
    "area_name": "Mauricie ",
    "étudiants": "751",
    "langue": "français",
    "secteur": "public",
    "rang": "294",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "24.8",
    "ehdaa_2024": "25.7",
    "rang_2024": "294/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "69.0",
    "lens_2019": "69.4",
    "lens_2022": "64.3",
    "lens_2023": "65.6",
    "lens_2024": "61.0",
    "lens_trend": "998855",
    "lsec_2018": "79.6",
    "lsec_2019": "78.9",
    "lsec_2022": "77.5",
    "lsec_2023": "75.5",
    "lsec_2024": "78.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.4",
    "scie_2019": "73.6",
    "scie_2022": "67.5",
    "scie_2023": "71.2",
    "scie_2024": "68.3",
    "scie_trend": "—",
    "math_2018": "74.5",
    "math_2019": "78.2",
    "math_2022": "77.8",
    "math_2023": "71.6",
    "math_2024": "77.7",
    "math_trend": "—",
    "echec_2018": "11.6",
    "echec_2019": "14.0",
    "echec_2022": "19.7",
    "echec_2023": "20.8",
    "echec_2024": "23.7",
    "echec_trend": "998855",
    "sures_2018": "2.0",
    "sures_2019": "1.7",
    "sures_2022": "2.5",
    "sures_2023": "1.1",
    "sures_2024": "1.4",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 5.5",
    "ecart_sexes_lens_2019": "F 7.1",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 6.1",
    "ecart_sexes_lens_2024": "F 0.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.8",
    "ecart_sexes_math_2019": "F 1.9",
    "ecart_sexes_math_2022": "F 13.8",
    "ecart_sexes_math_2023": "M 4.3",
    "ecart_sexes_math_2024": "F 6.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.2",
    "prog_2019": "20.0",
    "prog_2022": "33.5",
    "prog_2023": "22.1",
    "prog_2024": "36.0",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.4",
    "cote_2022": "5.4",
    "cote_2023": "5.4",
    "cote_2024": "5.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Rocher",
    "nom_court": "École secondaire du Rocher",
    "adresse": "300, 7e Rue",
    "municipalite": "Shawinigan",
    "code_postal": "G9T 4M7",
    "lat": 46.6133,
    "lng": -72.6902
  },
  {
    "_id": "61",
    "school_code": "742118",
    "school_name_1": "Champagnat",
    "admin_body_number": "742000",
    "admin_body_name": "Centre de services scolaire de l'Énergie",
    "area_name": "Mauricie ",
    "étudiants": "452",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "18.9",
    "ehdaa_2024": "40",
    "rang_2024": "376/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "69.0",
    "lens_2019": "69.2",
    "lens_2022": "66.3",
    "lens_2023": "65.1",
    "lens_2024": "60.3",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "80.7",
    "lsec_2022": "80.5",
    "lsec_2023": "79.8",
    "lsec_2024": "79.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.4",
    "scie_2019": "76.4",
    "scie_2022": "70.1",
    "scie_2023": "75.1",
    "scie_2024": "66.5",
    "scie_trend": "998855",
    "math_2018": "83.8",
    "math_2019": "77.6",
    "math_2022": "81.1",
    "math_2023": "78.3",
    "math_2024": "82.8",
    "math_trend": "—",
    "echec_2018": "11.1",
    "echec_2019": "9.9",
    "echec_2022": "17.1",
    "echec_2023": "15.5",
    "echec_2024": "22.1",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "2.9",
    "sures_2022": "2.1",
    "sures_2023": "2.7",
    "sures_2024": "5.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 0.3",
    "ecart_sexes_lens_2022": "F 2.1",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 6.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 13.5",
    "ecart_sexes_math_2022": "M 3.7",
    "ecart_sexes_math_2023": "F 5.5",
    "ecart_sexes_math_2024": "F 7.5",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "12.3",
    "prog_2019": "35.2",
    "prog_2022": "24.9",
    "prog_2023": "18.1",
    "prog_2024": "19.0",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.1",
    "cote_2022": "6.4",
    "cote_2023": "6.1",
    "cote_2024": "4.6",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Champagnat",
    "nom_court": "École secondaire Champagnat",
    "adresse": "600, rue Desbiens",
    "municipalite": "La Tuque",
    "code_postal": "G9X 2K1",
    "lat": 47.43686,
    "lng": -72.7752
  },
  {
    "_id": "62",
    "school_code": "751005",
    "school_name_1": "La Frontalière",
    "admin_body_number": "751000",
    "admin_body_name": "Centre de services scolaire des Hauts-Cantons",
    "area_name": "Estrie ",
    "étudiants": "737",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "8.5",
    "ehdaa_2024": "31.1",
    "rang_2024": "182/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "75.9",
    "lens_2019": "72.8",
    "lens_2022": "71.5",
    "lens_2023": "73.7",
    "lens_2024": "69.4",
    "lens_trend": "—",
    "lsec_2018": "80.7",
    "lsec_2019": "78.9",
    "lsec_2022": "81.1",
    "lsec_2023": "79.5",
    "lsec_2024": "80.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.5",
    "scie_2019": "71.1",
    "scie_2022": "71.8",
    "scie_2023": "74.6",
    "scie_2024": "73.4",
    "scie_trend": "112233",
    "math_2018": "76.5",
    "math_2019": "76.0",
    "math_2022": "74.5",
    "math_2023": "72.5",
    "math_2024": "79.0",
    "math_trend": "—",
    "echec_2018": "12.2",
    "echec_2019": "13.4",
    "echec_2022": "14.8",
    "echec_2023": "11.8",
    "echec_2024": "15.1",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.8",
    "sures_2022": "1.0",
    "sures_2023": "0.7",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.1",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "F 2.8",
    "ecart_sexes_lens_2023": "F 7.7",
    "ecart_sexes_lens_2024": "F 6.5",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 2.3",
    "ecart_sexes_math_2019": "F 10.6",
    "ecart_sexes_math_2022": "M 1.9",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "45.7",
    "prog_2019": "30.7",
    "prog_2022": "38.9",
    "prog_2023": "30.7",
    "prog_2024": "38.5",
    "prog_trend": "—",
    "cote_2018": "6.3",
    "cote_2019": "6.1",
    "cote_2022": "6.6",
    "cote_2023": "6.5",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École La Frontalière",
    "nom_court": "École La Frontalière",
    "adresse": "311, rue Saint-Paul Est",
    "municipalite": "Coaticook",
    "code_postal": "J1A 1G1",
    "lat": 45.14099,
    "lng": -71.80092
  },
  {
    "_id": "63",
    "school_code": "751006",
    "school_name_1": "Montignac",
    "admin_body_number": "751000",
    "admin_body_name": "Centre de services scolaire des Hauts-Cantons",
    "area_name": "Estrie ",
    "étudiants": "961",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "20.7",
    "ehdaa_2024": "31.5",
    "rang_2024": "238/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "73.0",
    "lens_2019": "76.1",
    "lens_2022": "70.8",
    "lens_2023": "74.4",
    "lens_2024": "72.8",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "77.4",
    "lsec_2022": "77.5",
    "lsec_2023": "80.7",
    "lsec_2024": "75.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.0",
    "scie_2019": "75.3",
    "scie_2022": "70.4",
    "scie_2023": "74.8",
    "scie_2024": "71.2",
    "scie_trend": "998855",
    "math_2018": "76.8",
    "math_2019": "74.6",
    "math_2022": "78.5",
    "math_2023": "80.0",
    "math_2024": "81.5",
    "math_trend": "—",
    "echec_2018": "8.6",
    "echec_2019": "11.6",
    "echec_2022": "15.6",
    "echec_2023": "10.9",
    "echec_2024": "15.6",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "0.1",
    "sures_2022": "1.8",
    "sures_2023": "0.0",
    "sures_2024": "0.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.3",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 0.8",
    "ecart_sexes_lens_2024": "F 4.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.9",
    "ecart_sexes_math_2019": "F 3.4",
    "ecart_sexes_math_2022": "F 8.3",
    "ecart_sexes_math_2023": "M 3.0",
    "ecart_sexes_math_2024": "M 0.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "38.7",
    "prog_2019": "46.6",
    "prog_2022": "44.4",
    "prog_2023": "47.3",
    "prog_2024": "45.8",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "6.1",
    "cote_2022": "5.7",
    "cote_2023": "6.4",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Montignac",
    "nom_court": "Polyvalente Montignac",
    "adresse": "3409, rue Laval",
    "municipalite": "Lac-Mégantic",
    "code_postal": "G6B 1A5",
    "lat": 45.5884,
    "lng": -70.91127
  },
  {
    "_id": "64",
    "school_code": "751007",
    "school_name_1": "Louis-Saint-Laurent",
    "admin_body_number": "751000",
    "admin_body_name": "Centre de services scolaire des Hauts-Cantons",
    "area_name": "Estrie ",
    "étudiants": "695",
    "langue": "français",
    "secteur": "public",
    "rang": "294",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "17.6",
    "ehdaa_2024": "38",
    "rang_2024": "294/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "66.4",
    "lens_2019": "71.8",
    "lens_2022": "69.6",
    "lens_2023": "65.5",
    "lens_2024": "67.6",
    "lens_trend": "—",
    "lsec_2018": "77.6",
    "lsec_2019": "79.8",
    "lsec_2022": "73.2",
    "lsec_2023": "76.6",
    "lsec_2024": "77.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.5",
    "scie_2019": "75.1",
    "scie_2022": "71.1",
    "scie_2023": "79.0",
    "scie_2024": "73.9",
    "scie_trend": "—",
    "math_2018": "72.3",
    "math_2019": "70.6",
    "math_2022": "76.3",
    "math_2023": "77.8",
    "math_2024": "77.5",
    "math_trend": "—",
    "echec_2018": "14.7",
    "echec_2019": "16.0",
    "echec_2022": "18.4",
    "echec_2023": "13.0",
    "echec_2024": "15.2",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "1.3",
    "sures_2022": "1.8",
    "sures_2023": "1.7",
    "sures_2024": "0.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.2",
    "ecart_sexes_lens_2019": "F 1.3",
    "ecart_sexes_lens_2022": "F 13.4",
    "ecart_sexes_lens_2023": "F 9.6",
    "ecart_sexes_lens_2024": "F 9.0",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 1.1",
    "ecart_sexes_math_2019": "F 3.6",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "F 4.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "56.4",
    "prog_2019": "39.7",
    "prog_2022": "56.4",
    "prog_2023": "56.0",
    "prog_2024": "50.4",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "5.8",
    "cote_2022": "4.5",
    "cote_2023": "5.3",
    "cote_2024": "5.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Louis-Saint-Laurent",
    "nom_court": "Polyvalente Louis-Saint-Laurent",
    "adresse": "188, rue Kennedy",
    "municipalite": "East Angus",
    "code_postal": "J0B 1R0",
    "lat": 45.49122,
    "lng": -71.6518
  },
  {
    "_id": "65",
    "school_code": "751008",
    "school_name_1": "La MFR",
    "admin_body_number": "751000",
    "admin_body_name": "Centre de services scolaire des Hauts-Cantons",
    "area_name": "Estrie ",
    "étudiants": "84",
    "langue": "français",
    "secteur": "public",
    "rang": "442",
    "rang_5_ans": "414",
    "index": "0.1",
    "en_retard_2024": "28.6",
    "ehdaa_2024": "54.8",
    "rang_2024": "442/470",
    "rang_2019_2024": "414/432",
    "lens_2018": "55.7",
    "lens_2019": "56.2",
    "lens_2022": "47.4",
    "lens_2023": "52.1",
    "lens_2024": "55.3",
    "lens_trend": "—",
    "lsec_2018": "72.8",
    "lsec_2019": "71.7",
    "lsec_2022": "67.5",
    "lsec_2023": "64.5",
    "lsec_2024": "68.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.7",
    "scie_2019": "79.6",
    "scie_2022": "66.9",
    "scie_2023": "77.2",
    "scie_2024": "71.6",
    "scie_trend": "—",
    "math_2018": "74.8",
    "math_2019": "79.6",
    "math_2022": "69.5",
    "math_2023": "85.1",
    "math_2024": "77.6",
    "math_trend": "—",
    "echec_2018": "24.4",
    "echec_2019": "23.4",
    "echec_2022": "38.3",
    "echec_2023": "24.1",
    "echec_2024": "26.7",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "1.0",
    "sures_2022": "6.0",
    "sures_2023": "6.8",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 7.6",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "20.0",
    "prog_2019": "22.6",
    "prog_2022": "18.6",
    "prog_2023": "32.8",
    "prog_2024": "29.2",
    "prog_trend": "998855",
    "cote_2018": "4.5",
    "cote_2019": "4.8",
    "cote_2022": "2.2",
    "cote_2023": "3.2",
    "cote_2024": "3.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Maison familiale rurale du Granit",
    "nom_court": "M.F.R. du Granit",
    "adresse": "105, rue du Couvent",
    "municipalite": "Saint-Romain",
    "code_postal": "G0Y 1L0",
    "lat": 45.78521,
    "lng": -71.09181
  },
  {
    "_id": "66",
    "school_code": "752116",
    "school_name_1": "du Triolet",
    "admin_body_number": "752000",
    "admin_body_name": "Centre de services scolaire de la Région-de-Sherbrooke",
    "area_name": "Estrie ",
    "étudiants": "2471",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "8.7",
    "ehdaa_2024": "28.6",
    "rang_2024": "137/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "73.0",
    "lens_2019": "70.0",
    "lens_2022": "67.7",
    "lens_2023": "68.3",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "72.1",
    "lsec_2019": "73.5",
    "lsec_2022": "79.4",
    "lsec_2023": "79.0",
    "lsec_2024": "77.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.1",
    "scie_2019": "73.2",
    "scie_2022": "70.0",
    "scie_2023": "75.6",
    "scie_2024": "73.8",
    "scie_trend": "—",
    "math_2018": "76.5",
    "math_2019": "76.0",
    "math_2022": "74.7",
    "math_2023": "80.2",
    "math_2024": "80.4",
    "math_trend": "—",
    "echec_2018": "12.0",
    "echec_2019": "16.0",
    "echec_2022": "18.6",
    "echec_2023": "13.1",
    "echec_2024": "12.5",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.1",
    "sures_2022": "3.2",
    "sures_2023": "1.2",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 5.0",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.0",
    "ecart_sexes_math_2019": "M 1.5",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "M 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.0",
    "prog_2019": "18.9",
    "prog_2022": "19.3",
    "prog_2023": "19.1",
    "prog_2024": "19.8",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.8",
    "cote_2022": "6.2",
    "cote_2023": "6.7",
    "cote_2024": "6.7",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École du Triolet",
    "nom_court": "École du Triolet",
    "adresse": "2965, boulevard de l'Université",
    "municipalite": "Sherbrooke",
    "code_postal": "J1K 2X6",
    "lat": 45.38185,
    "lng": -71.94635
  },
  {
    "_id": "67",
    "school_code": "752117",
    "school_name_1": "de la Montée",
    "admin_body_number": "752000",
    "admin_body_name": "Centre de services scolaire de la Région-de-Sherbrooke",
    "area_name": "Estrie ",
    "étudiants": "1760",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "22",
    "ehdaa_2024": "34.9",
    "rang_2024": "299/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "70.4",
    "lens_2019": "66.9",
    "lens_2022": "65.5",
    "lens_2023": "67.7",
    "lens_2024": "67.6",
    "lens_trend": "—",
    "lsec_2018": "72.9",
    "lsec_2019": "78.1",
    "lsec_2022": "77.4",
    "lsec_2023": "74.3",
    "lsec_2024": "74.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.8",
    "scie_2019": "76.8",
    "scie_2022": "73.7",
    "scie_2023": "71.7",
    "scie_2024": "65.2",
    "scie_trend": "—",
    "math_2018": "73.3",
    "math_2019": "79.1",
    "math_2022": "73.7",
    "math_2023": "74.2",
    "math_2024": "81.6",
    "math_trend": "—",
    "echec_2018": "16.9",
    "echec_2019": "12.4",
    "echec_2022": "19.3",
    "echec_2023": "18.0",
    "echec_2024": "19.5",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "0.7",
    "sures_2022": "2.2",
    "sures_2023": "0.7",
    "sures_2024": "2.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.5",
    "ecart_sexes_lens_2019": "F 2.9",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "M 1.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 6.5",
    "ecart_sexes_math_2022": "M 0.9",
    "ecart_sexes_math_2023": "F 6.0",
    "ecart_sexes_math_2024": "F 0.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.0",
    "prog_2019": "43.2",
    "prog_2022": "35.2",
    "prog_2023": "36.6",
    "prog_2024": "42.6",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "6.0",
    "cote_2022": "5.7",
    "cote_2023": "5.3",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de la Montée",
    "nom_court": "École secondaire de la Montée",
    "adresse": "940, rue de la Sainte-Famille",
    "municipalite": "Sherbrooke",
    "code_postal": "J1E 1V1",
    "lat": 45.40986,
    "lng": -71.868
  },
  {
    "_id": "68",
    "school_code": "752124",
    "school_name_1": "Mitchell - Montcalm",
    "admin_body_number": "752000",
    "admin_body_name": "Centre de services scolaire de la Région-de-Sherbrooke",
    "area_name": "Estrie ",
    "étudiants": "1569",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "12.4",
    "ehdaa_2024": "24.9",
    "rang_2024": "217/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "72.4",
    "lens_2019": "74.2",
    "lens_2022": "69.4",
    "lens_2023": "73.3",
    "lens_2024": "69.2",
    "lens_trend": "—",
    "lsec_2018": "80.2",
    "lsec_2019": "81.2",
    "lsec_2022": "82.6",
    "lsec_2023": "85.0",
    "lsec_2024": "84.0",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "74.1",
    "scie_2022": "74.0",
    "scie_2023": "80.9",
    "scie_2024": "71.9",
    "scie_trend": "—",
    "math_2018": "77.4",
    "math_2019": "78.5",
    "math_2022": "79.0",
    "math_2023": "76.8",
    "math_2024": "77.3",
    "math_trend": "998855",
    "echec_2018": "12.4",
    "echec_2019": "11.6",
    "echec_2022": "13.6",
    "echec_2023": "10.4",
    "echec_2024": "16.7",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.8",
    "sures_2022": "3.1",
    "sures_2023": "1.0",
    "sures_2024": "3.4",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 6.0",
    "ecart_sexes_lens_2019": "F 1.6",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 6.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.4",
    "ecart_sexes_math_2019": "F 10.0",
    "ecart_sexes_math_2022": "M 0.5",
    "ecart_sexes_math_2023": "F 1.8",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "23.3",
    "prog_2019": "25.2",
    "prog_2022": "23.4",
    "prog_2023": "29.5",
    "prog_2024": "28.2",
    "prog_trend": "998855",
    "cote_2018": "6.8",
    "cote_2019": "6.7",
    "cote_2022": "6.9",
    "cote_2023": "7.2",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Mitchell - Montcalm",
    "nom_court": "École Mitchell - Montcalm",
    "adresse": "2050, boulevard Portland",
    "municipalite": "Sherbrooke",
    "code_postal": "J1J 1T9",
    "lat": 45.40313,
    "lng": -71.92405
  },
  {
    "_id": "69",
    "school_code": "752148",
    "school_name_1": "du Phare",
    "admin_body_number": "752000",
    "admin_body_name": "Centre de services scolaire de la Région-de-Sherbrooke",
    "area_name": "Estrie ",
    "étudiants": "1215",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "23.9",
    "ehdaa_2024": "37.8",
    "rang_2024": "360/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "69.2",
    "lens_2019": "71.1",
    "lens_2022": "67.1",
    "lens_2023": "61.2",
    "lens_2024": "62.7",
    "lens_trend": "—",
    "lsec_2018": "73.5",
    "lsec_2019": "76.1",
    "lsec_2022": "79.3",
    "lsec_2023": "82.0",
    "lsec_2024": "80.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "70.5",
    "scie_2022": "66.5",
    "scie_2023": "72.5",
    "scie_2024": "70.3",
    "scie_trend": "—",
    "math_2018": "72.2",
    "math_2019": "72.0",
    "math_2022": "64.7",
    "math_2023": "74.4",
    "math_2024": "77.1",
    "math_trend": "—",
    "echec_2018": "19.5",
    "echec_2019": "18.7",
    "echec_2022": "25.1",
    "echec_2023": "23.2",
    "echec_2024": "20.1",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "1.1",
    "sures_2022": "4.7",
    "sures_2023": "2.5",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 9.8",
    "ecart_sexes_math_2019": "M 2.6",
    "ecart_sexes_math_2022": "F 7.3",
    "ecart_sexes_math_2023": "M 2.5",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.5",
    "prog_2019": "34.4",
    "prog_2022": "21.4",
    "prog_2023": "41.1",
    "prog_2024": "44.4",
    "prog_trend": "—",
    "cote_2018": "4.7",
    "cote_2019": "5.2",
    "cote_2022": "4.8",
    "cote_2023": "4.7",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École internationale du Phare",
    "nom_court": "École internationale du Phare",
    "adresse": "405, rue Sara",
    "municipalite": "Sherbrooke",
    "code_postal": "J1H 5S6",
    "lat": 45.37938,
    "lng": -71.8902
  },
  {
    "_id": "70",
    "school_code": "753012",
    "school_name_1": "de L'Escale",
    "admin_body_number": "753000",
    "admin_body_name": "Centre de services scolaire des Sommets",
    "area_name": "Estrie ",
    "étudiants": "618",
    "langue": "français",
    "secteur": "public",
    "rang": "430",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "22.8",
    "ehdaa_2024": "44.2",
    "rang_2024": "430/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "66.7",
    "lens_2019": "64.6",
    "lens_2022": "62.9",
    "lens_2023": "61.9",
    "lens_2024": "58.6",
    "lens_trend": "—",
    "lsec_2018": "73.6",
    "lsec_2019": "77.0",
    "lsec_2022": "74.3",
    "lsec_2023": "79.2",
    "lsec_2024": "80.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.1",
    "scie_2019": "72.2",
    "scie_2022": "72.6",
    "scie_2023": "78.3",
    "scie_2024": "66.3",
    "scie_trend": "—",
    "math_2018": "71.7",
    "math_2019": "73.3",
    "math_2022": "73.7",
    "math_2023": "72.7",
    "math_2024": "74.4",
    "math_trend": "—",
    "echec_2018": "19.4",
    "echec_2019": "17.7",
    "echec_2022": "21.9",
    "echec_2023": "18.2",
    "echec_2024": "26.5",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "1.2",
    "sures_2022": "3.7",
    "sures_2023": "3.2",
    "sures_2024": "4.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.6",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 9.6",
    "ecart_sexes_lens_2024": "F 12.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 18.6",
    "ecart_sexes_math_2019": "F 7.2",
    "ecart_sexes_math_2022": "F 13.6",
    "ecart_sexes_math_2023": "M 4.9",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "42.1",
    "prog_2019": "37.6",
    "prog_2022": "27.0",
    "prog_2023": "28.3",
    "prog_2024": "39.2",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.6",
    "cote_2022": "5.1",
    "cote_2023": "5.0",
    "cote_2024": "3.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Escale",
    "nom_court": "École secondaire de l'Escale",
    "adresse": "430, 5e Avenue",
    "municipalite": "Val-des-Sources",
    "code_postal": "J1T 1X2",
    "lat": 45.77328,
    "lng": -71.92967
  },
  {
    "_id": "71",
    "school_code": "753027",
    "school_name_1": "de la Ruche",
    "admin_body_number": "753000",
    "admin_body_name": "Centre de services scolaire des Sommets",
    "area_name": "Estrie ",
    "étudiants": "1794",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "14",
    "ehdaa_2024": "37",
    "rang_2024": "260/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "67.2",
    "lens_2019": "70.7",
    "lens_2022": "65.5",
    "lens_2023": "69.2",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "78.7",
    "lsec_2019": "82.2",
    "lsec_2022": "81.6",
    "lsec_2023": "84.2",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.7",
    "scie_2019": "75.8",
    "scie_2022": "74.2",
    "scie_2023": "77.3",
    "scie_2024": "70.8",
    "scie_trend": "—",
    "math_2018": "71.2",
    "math_2019": "73.3",
    "math_2022": "75.4",
    "math_2023": "79.9",
    "math_2024": "73.4",
    "math_trend": "—",
    "echec_2018": "15.8",
    "echec_2019": "11.3",
    "echec_2022": "17.5",
    "echec_2023": "11.2",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.3",
    "sures_2022": "1.3",
    "sures_2023": "0.4",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 5.1",
    "ecart_sexes_lens_2024": "F 4.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.3",
    "ecart_sexes_math_2019": "M 3.6",
    "ecart_sexes_math_2022": "F 1.0",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.5",
    "prog_2019": "36.8",
    "prog_2022": "30.8",
    "prog_2023": "41.7",
    "prog_2024": "27.5",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "6.5",
    "cote_2022": "6.3",
    "cote_2023": "6.8",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de la Ruche",
    "nom_court": "École secondaire de la Ruche",
    "adresse": "1255, boulevard des Étudiants",
    "municipalite": "Magog",
    "code_postal": "J1X 3Y6",
    "lat": 45.27773,
    "lng": -72.14122
  },
  {
    "_id": "72",
    "school_code": "753053",
    "school_name_1": "l'Odyssée",
    "admin_body_number": "753000",
    "admin_body_name": "Centre de services scolaire des Sommets",
    "area_name": "Estrie ",
    "étudiants": "273",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "21.6",
    "ehdaa_2024": "58.2",
    "rang_2024": "310/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "60.6",
    "lens_2023": "67.4",
    "lens_2024": "65.0",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "81.2",
    "lsec_2023": "79.4",
    "lsec_2024": "81.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "69.2",
    "scie_2023": "69.4",
    "scie_2024": "67.9",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "64.8",
    "math_2023": "71.2",
    "math_2024": "68.3",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "29.3",
    "echec_2023": "14.0",
    "echec_2024": "20.3",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "7.4",
    "sures_2023": "2.0",
    "sures_2024": "2.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 13.1",
    "ecart_sexes_lens_2023": "F 7.8",
    "ecart_sexes_lens_2024": "E",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 0.3",
    "ecart_sexes_math_2023": "F 2.2",
    "ecart_sexes_math_2024": "F 0.7",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "42.0",
    "prog_2023": "52.2",
    "prog_2024": "43.7",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "4.2",
    "cote_2023": "5.1",
    "cote_2024": "5.2",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de l'Odyssée",
    "nom_court": "École secondaire de l'Odyssée",
    "adresse": "900, rue Montcalm",
    "municipalite": "Valcourt",
    "code_postal": "J0E 2L0",
    "lat": 45.4959,
    "lng": -72.31737
  },
  {
    "_id": "73",
    "school_code": "753057",
    "school_name_1": "du Tournesol",
    "admin_body_number": "753000",
    "admin_body_name": "Centre de services scolaire des Sommets",
    "area_name": "Estrie ",
    "étudiants": "665",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "12.2",
    "ehdaa_2024": "43.2",
    "rang_2024": "348/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "67.7",
    "lens_2019": "69.6",
    "lens_2022": "67.5",
    "lens_2023": "68.5",
    "lens_2024": "65.6",
    "lens_trend": "—",
    "lsec_2018": "80.7",
    "lsec_2019": "83.1",
    "lsec_2022": "81.5",
    "lsec_2023": "83.3",
    "lsec_2024": "82.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.9",
    "scie_2019": "73.1",
    "scie_2022": "71.0",
    "scie_2023": "74.3",
    "scie_2024": "70.5",
    "scie_trend": "—",
    "math_2018": "66.3",
    "math_2019": "71.9",
    "math_2022": "63.5",
    "math_2023": "62.6",
    "math_2024": "65.4",
    "math_trend": "998855",
    "echec_2018": "20.7",
    "echec_2019": "13.6",
    "echec_2022": "19.8",
    "echec_2023": "17.6",
    "echec_2024": "23.3",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "1.0",
    "sures_2022": "4.2",
    "sures_2023": "2.5",
    "sures_2024": "4.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 2.1",
    "ecart_sexes_lens_2023": "M 1.9",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 9.4",
    "ecart_sexes_math_2019": "F 10.5",
    "ecart_sexes_math_2022": "M 0.3",
    "ecart_sexes_math_2023": "M 2.7",
    "ecart_sexes_math_2024": "M 5.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "49.2",
    "prog_2019": "39.3",
    "prog_2022": "34.1",
    "prog_2023": "33.7",
    "prog_2024": "30.6",
    "prog_trend": "112233",
    "cote_2018": "4.6",
    "cote_2019": "6.0",
    "cote_2022": "5.7",
    "cote_2023": "5.4",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Tournesol",
    "nom_court": "École secondaire du Tournesol",
    "adresse": "250, rue Saint-Georges",
    "municipalite": "Windsor",
    "code_postal": "J1S 1K4",
    "lat": 45.5731,
    "lng": -71.9953
  },
  {
    "_id": "74",
    "school_code": "759001",
    "school_name_1": "Wiinibekuu",
    "admin_body_number": "759000",
    "admin_body_name": "Commission scolaire crie",
    "area_name": "Nord-du-Québec ",
    "étudiants": "274",
    "langue": "anglais",
    "secteur": "public",
    "rang": "469",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "47.4",
    "ehdaa_2024": "6.9",
    "rang_2024": "469/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "47.7",
    "lens_2024": "58.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "40.9",
    "lsec_2024": "30.2",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "38.0",
    "scie_2024": "43.4",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "32.6",
    "math_2024": "26.6",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "78.6",
    "echec_2024": "74.2",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "24.6",
    "sures_2024": "14.0",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "M 2.3",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "77.0",
    "prog_2024": "72.3",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "0.0",
    "cote_2024": "0.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Wiinibekuu School",
    "nom_court": "École Wiinibekuu School",
    "adresse": "31, rue Smokey Hill",
    "municipalite": "Waskaganish",
    "code_postal": "J0M 1R0",
    "lat": 51.48528,
    "lng": -78.74675
  },
  {
    "_id": "75",
    "school_code": "759006",
    "school_name_1": "Voyageur Memorial",
    "admin_body_number": "759000",
    "admin_body_name": "Commission scolaire crie",
    "area_name": "Nord-du-Québec ",
    "étudiants": "364",
    "langue": "français, anglais",
    "secteur": "public",
    "rang": "468",
    "rang_5_ans": "432",
    "index": "0.1",
    "en_retard_2024": "51.1",
    "ehdaa_2024": "6.6",
    "rang_2024": "468/470",
    "rang_2019_2024": "432/432",
    "lens_2018": "65.7",
    "lens_2019": "52.1",
    "lens_2022": "56.5",
    "lens_2023": "63.0",
    "lens_2024": "60.3",
    "lens_trend": "—",
    "lsec_2018": "60.4",
    "lsec_2019": "51.2",
    "lsec_2022": "42.3",
    "lsec_2023": "45.1",
    "lsec_2024": "53.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "46.2",
    "scie_2019": "51.2",
    "scie_2022": "36.2",
    "scie_2023": "43.8",
    "scie_2024": "52.6",
    "scie_trend": "—",
    "math_2018": "21.9",
    "math_2019": "34.6",
    "math_2022": "16.9",
    "math_2023": "39.2",
    "math_2024": "56.1",
    "math_trend": "112233",
    "echec_2018": "69.9",
    "echec_2019": "65.6",
    "echec_2022": "80.0",
    "echec_2023": "63.5",
    "echec_2024": "49.0",
    "echec_trend": "—",
    "sures_2018": "11.0",
    "sures_2019": "8.0",
    "sures_2022": "19.8",
    "sures_2023": "7.1",
    "sures_2024": "4.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 11.9",
    "ecart_sexes_lens_2023": "F 12.4",
    "ecart_sexes_lens_2024": "F 7.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "M 3.9",
    "ecart_sexes_math_2024": "F 7.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "93.8",
    "prog_2019": "83.7",
    "prog_2022": "67.5",
    "prog_2023": "94.8",
    "prog_2024": "93.4",
    "prog_trend": "—",
    "cote_2018": "0.0",
    "cote_2019": "0.0",
    "cote_2022": "0.0",
    "cote_2023": "0.0",
    "cote_2024": "0.4",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Mémoriale Voyageur",
    "nom_court": "École Voyageur Memorial Secondary School",
    "adresse": "232, boulevard Mistissini",
    "municipalite": "Mistissini",
    "code_postal": "G0W 1C0",
    "lat": 50.41948,
    "lng": -73.87417
  },
  {
    "_id": "76",
    "school_code": "759009",
    "school_name_1": "James Bay Eeyou",
    "admin_body_number": "759000",
    "admin_body_name": "Commission scolaire crie",
    "area_name": "Nord-du-Québec ",
    "étudiants": "539",
    "langue": "anglais",
    "secteur": "public",
    "rang": "469",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "28.3",
    "ehdaa_2024": "7.1",
    "rang_2024": "469/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "53.2",
    "lens_2024": "56.9",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "45.7",
    "lsec_2024": "57.2",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "42.0",
    "scie_2024": "44.8",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "43.6",
    "math_2024": "36.7",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "66.2",
    "echec_2024": "66.6",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "9.7",
    "sures_2024": "13.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "M 6.7",
    "ecart_sexes_lens_2024": "M 3.1",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 16.7",
    "ecart_sexes_math_2024": "M 17.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "88.9",
    "prog_2024": "69.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "0.0",
    "cote_2024": "0.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École James Bay Eeyou School",
    "nom_court": "École James Bay Eeyou School",
    "adresse": "36 Industrial Road",
    "municipalite": "Chisasibi",
    "code_postal": "J0M 1E0",
    "lat": 53.77013,
    "lng": -78.87835
  },
  {
    "_id": "77",
    "school_code": "761070",
    "school_name_1": "Daniel-Johnson",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "932",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "391",
    "index": "0.1",
    "en_retard_2024": "23.4",
    "ehdaa_2024": "30.7",
    "rang_2024": "367/470",
    "rang_2019_2024": "391/432",
    "lens_2018": "66.3",
    "lens_2019": "65.7",
    "lens_2022": "65.1",
    "lens_2023": "66.0",
    "lens_2024": "62.9",
    "lens_trend": "—",
    "lsec_2018": "75.3",
    "lsec_2019": "75.1",
    "lsec_2022": "76.2",
    "lsec_2023": "77.6",
    "lsec_2024": "78.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.1",
    "scie_2019": "56.8",
    "scie_2022": "68.9",
    "scie_2023": "65.3",
    "scie_2024": "63.2",
    "scie_trend": "—",
    "math_2018": "59.9",
    "math_2019": "60.0",
    "math_2022": "78.3",
    "math_2023": "70.5",
    "math_2024": "66.9",
    "math_trend": "—",
    "echec_2018": "28.1",
    "echec_2019": "34.5",
    "echec_2022": "19.0",
    "echec_2023": "21.5",
    "echec_2024": "28.1",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "3.7",
    "sures_2022": "0.3",
    "sures_2023": "0.4",
    "sures_2024": "2.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.0",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 1.2",
    "ecart_sexes_lens_2024": "M 1.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.3",
    "ecart_sexes_math_2019": "F 1.9",
    "ecart_sexes_math_2022": "F 10.7",
    "ecart_sexes_math_2023": "F 1.6",
    "ecart_sexes_math_2024": "M 2.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "49.0",
    "prog_2019": "53.5",
    "prog_2022": "45.9",
    "prog_2023": "44.4",
    "prog_2024": "38.3",
    "prog_trend": "—",
    "cote_2018": "3.4",
    "cote_2019": "2.5",
    "cote_2022": "5.3",
    "cote_2023": "5.3",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Daniel-Johnson",
    "nom_court": "École secondaire Daniel-Johnson",
    "adresse": "1200, boulevard du Tricentenaire",
    "municipalite": "Montréal",
    "code_postal": "H1B 3A8",
    "lat": 45.65049,
    "lng": -73.4972
  },
  {
    "_id": "78",
    "school_code": "761071",
    "school_name_1": "Pointe-aux-Trembles",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "1629",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "12.1",
    "ehdaa_2024": "32.8",
    "rang_2024": "149/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "72.6",
    "lens_2019": "70.3",
    "lens_2022": "68.3",
    "lens_2023": "70.4",
    "lens_2024": "68.1",
    "lens_trend": "—",
    "lsec_2018": "77.3",
    "lsec_2019": "73.9",
    "lsec_2022": "77.7",
    "lsec_2023": "77.4",
    "lsec_2024": "80.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.6",
    "scie_2019": "72.4",
    "scie_2022": "73.7",
    "scie_2023": "75.0",
    "scie_2024": "74.6",
    "scie_trend": "—",
    "math_2018": "78.1",
    "math_2019": "76.6",
    "math_2022": "79.3",
    "math_2023": "77.8",
    "math_2024": "81.8",
    "math_trend": "—",
    "echec_2018": "9.3",
    "echec_2019": "16.0",
    "echec_2022": "14.9",
    "echec_2023": "14.1",
    "echec_2024": "13.0",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "1.0",
    "sures_2022": "2.3",
    "sures_2023": "0.5",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.9",
    "ecart_sexes_lens_2019": "F 6.3",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.5",
    "ecart_sexes_math_2019": "F 4.4",
    "ecart_sexes_math_2022": "M 0.2",
    "ecart_sexes_math_2023": "F 4.5",
    "ecart_sexes_math_2024": "F 7.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.4",
    "prog_2019": "21.4",
    "prog_2022": "29.3",
    "prog_2023": "25.2",
    "prog_2024": "25.3",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "5.9",
    "cote_2022": "6.5",
    "cote_2023": "6.4",
    "cote_2024": "6.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de la Pointe-aux-Trembles",
    "nom_court": "École secondaire Pointe-aux-Trembles",
    "adresse": "15200, rue Sherbrooke Est",
    "municipalite": "Montréal",
    "code_postal": "H1A 3P9",
    "lat": 45.68506,
    "lng": -73.49777
  },
  {
    "_id": "79",
    "school_code": "761075",
    "school_name_1": "Antoine-de-Saint-Exupéry",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "3184",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "16.3",
    "ehdaa_2024": "23.7",
    "rang_2024": "277/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "66.8",
    "lens_2019": "68.7",
    "lens_2022": "64.0",
    "lens_2023": "64.6",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "79.5",
    "lsec_2019": "80.4",
    "lsec_2022": "76.6",
    "lsec_2023": "78.2",
    "lsec_2024": "77.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "71.9",
    "scie_2022": "66.0",
    "scie_2023": "73.5",
    "scie_2024": "69.0",
    "scie_trend": "—",
    "math_2018": "71.3",
    "math_2019": "70.0",
    "math_2022": "71.3",
    "math_2023": "73.7",
    "math_2024": "74.0",
    "math_trend": "—",
    "echec_2018": "16.8",
    "echec_2019": "17.7",
    "echec_2022": "24.2",
    "echec_2023": "19.4",
    "echec_2024": "19.1",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.6",
    "sures_2022": "4.2",
    "sures_2023": "1.3",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 0.1",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 0.9",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.2",
    "ecart_sexes_math_2019": "F 5.1",
    "ecart_sexes_math_2022": "F 4.5",
    "ecart_sexes_math_2023": "F 1.3",
    "ecart_sexes_math_2024": "F 3.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.1",
    "prog_2019": "27.3",
    "prog_2022": "23.0",
    "prog_2023": "28.7",
    "prog_2024": "34.9",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "5.7",
    "cote_2022": "5.0",
    "cote_2023": "5.7",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Antoine-de-Saint-Exupéry",
    "nom_court": "École secondaire Antoine-de-St-Exupéry",
    "adresse": "5150, boulevard Robert",
    "municipalite": "Montréal",
    "code_postal": "H1R 1P9",
    "lat": 45.58463,
    "lng": -73.60169
  },
  {
    "_id": "80",
    "school_code": "761078",
    "school_name_1": "École sec. Anjou",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "1808",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "22",
    "ehdaa_2024": "32.6",
    "rang_2024": "390/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "65.2",
    "lens_2019": "68.7",
    "lens_2022": "59.0",
    "lens_2023": "62.9",
    "lens_2024": "61.4",
    "lens_trend": "—",
    "lsec_2018": "74.7",
    "lsec_2019": "78.4",
    "lsec_2022": "80.2",
    "lsec_2023": "84.0",
    "lsec_2024": "82.3",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.0",
    "scie_2019": "65.3",
    "scie_2022": "68.1",
    "scie_2023": "69.7",
    "scie_2024": "64.0",
    "scie_trend": "—",
    "math_2018": "72.6",
    "math_2019": "74.1",
    "math_2022": "71.5",
    "math_2023": "70.7",
    "math_2024": "70.9",
    "math_trend": "998855",
    "echec_2018": "21.7",
    "echec_2019": "20.3",
    "echec_2022": "26.0",
    "echec_2023": "23.8",
    "echec_2024": "27.9",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.0",
    "sures_2022": "1.7",
    "sures_2023": "1.5",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 0.6",
    "ecart_sexes_lens_2022": "F 0.6",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.6",
    "ecart_sexes_math_2019": "F 6.6",
    "ecart_sexes_math_2022": "F 6.9",
    "ecart_sexes_math_2023": "F 1.5",
    "ecart_sexes_math_2024": "F 5.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.2",
    "prog_2019": "49.0",
    "prog_2022": "32.7",
    "prog_2023": "50.4",
    "prog_2024": "39.3",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "4.8",
    "cote_2022": "5.1",
    "cote_2023": "4.6",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Anjou",
    "nom_court": "École secondaire Anjou",
    "adresse": "8205, rue Fonteneau",
    "municipalite": "Montréal",
    "code_postal": "H1K 4E1",
    "lat": 45.60205,
    "lng": -73.54168
  },
  {
    "_id": "81",
    "school_code": "761083",
    "school_name_1": "Jean-Grou",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "1201",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "21.3",
    "ehdaa_2024": "29.2",
    "rang_2024": "399/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "67.4",
    "lens_2019": "66.3",
    "lens_2022": "64.1",
    "lens_2023": "66.2",
    "lens_2024": "64.2",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "76.6",
    "lsec_2022": "78.1",
    "lsec_2023": "77.0",
    "lsec_2024": "75.5",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.0",
    "scie_2019": "69.8",
    "scie_2022": "68.7",
    "scie_2023": "68.1",
    "scie_2024": "63.9",
    "scie_trend": "998855",
    "math_2018": "67.9",
    "math_2019": "71.5",
    "math_2022": "73.7",
    "math_2023": "67.6",
    "math_2024": "69.1",
    "math_trend": "—",
    "echec_2018": "18.3",
    "echec_2019": "17.3",
    "echec_2022": "20.7",
    "echec_2023": "22.2",
    "echec_2024": "25.0",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.3",
    "sures_2022": "0.7",
    "sures_2023": "0.2",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 1.4",
    "ecart_sexes_lens_2022": "F 2.3",
    "ecart_sexes_lens_2023": "F 3.9",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.3",
    "ecart_sexes_math_2019": "F 2.7",
    "ecart_sexes_math_2022": "F 2.2",
    "ecart_sexes_math_2023": "M 0.3",
    "ecart_sexes_math_2024": "F 4.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.4",
    "prog_2019": "45.9",
    "prog_2022": "24.5",
    "prog_2023": "39.3",
    "prog_2024": "36.8",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.4",
    "cote_2022": "5.9",
    "cote_2023": "4.8",
    "cote_2024": "4.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Jean-Grou",
    "nom_court": "École secondaire Jean-Grou",
    "adresse": "12725, boulevard Rodolphe-Forget",
    "municipalite": "Montréal",
    "code_postal": "H1E 6P6",
    "lat": 45.65139,
    "lng": -73.58087
  },
  {
    "_id": "82",
    "school_code": "761090",
    "school_name_1": "Calixa-Lavallée",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "2032",
    "langue": "français",
    "secteur": "public",
    "rang": "445",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "33",
    "ehdaa_2024": "33",
    "rang_2024": "445/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "64.0",
    "lens_2019": "64.3",
    "lens_2022": "58.7",
    "lens_2023": "60.5",
    "lens_2024": "60.5",
    "lens_trend": "—",
    "lsec_2018": "71.6",
    "lsec_2019": "75.3",
    "lsec_2022": "78.0",
    "lsec_2023": "72.5",
    "lsec_2024": "71.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.6",
    "scie_2019": "72.6",
    "scie_2022": "68.3",
    "scie_2023": "66.3",
    "scie_2024": "60.6",
    "scie_trend": "—",
    "math_2018": "66.7",
    "math_2019": "72.4",
    "math_2022": "66.4",
    "math_2023": "69.9",
    "math_2024": "74.5",
    "math_trend": "—",
    "echec_2018": "24.7",
    "echec_2019": "19.0",
    "echec_2022": "29.4",
    "echec_2023": "27.0",
    "echec_2024": "30.7",
    "echec_trend": "—",
    "sures_2018": "2.8",
    "sures_2019": "1.4",
    "sures_2022": "4.3",
    "sures_2023": "2.3",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.4",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "M 0.5",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.7",
    "ecart_sexes_math_2019": "F 7.7",
    "ecart_sexes_math_2022": "M 2.3",
    "ecart_sexes_math_2023": "F 0.4",
    "ecart_sexes_math_2024": "F 4.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "58.9",
    "prog_2019": "50.9",
    "prog_2022": "37.4",
    "prog_2023": "35.4",
    "prog_2024": "44.1",
    "prog_trend": "—",
    "cote_2018": "3.3",
    "cote_2019": "4.4",
    "cote_2022": "4.2",
    "cote_2023": "4.1",
    "cote_2024": "3.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Calixa-Lavallée",
    "nom_court": "École secondaire Calixa-Lavallée",
    "adresse": "11411, avenue Pelletier",
    "municipalite": "Montréal",
    "code_postal": "H1H 3S3",
    "lat": 45.5975,
    "lng": -73.63841
  },
  {
    "_id": "83",
    "school_code": "761092",
    "school_name_1": "Henri-Bourassa",
    "admin_body_number": "761000",
    "admin_body_name": "Centre de services scolaire de la Pointe-de-l'Île",
    "area_name": "Montréal ",
    "étudiants": "2295",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "15.2",
    "ehdaa_2024": "21.2",
    "rang_2024": "299/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "71.2",
    "lens_2019": "71.7",
    "lens_2022": "66.4",
    "lens_2023": "68.1",
    "lens_2024": "64.8",
    "lens_trend": "998855",
    "lsec_2018": "82.9",
    "lsec_2019": "81.1",
    "lsec_2022": "83.3",
    "lsec_2023": "83.3",
    "lsec_2024": "77.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.3",
    "scie_2019": "77.3",
    "scie_2022": "75.0",
    "scie_2023": "74.4",
    "scie_2024": "67.8",
    "scie_trend": "—",
    "math_2018": "75.8",
    "math_2019": "74.7",
    "math_2022": "74.2",
    "math_2023": "72.5",
    "math_2024": "68.4",
    "math_trend": "998855",
    "echec_2018": "12.8",
    "echec_2019": "11.3",
    "echec_2022": "17.6",
    "echec_2023": "17.8",
    "echec_2024": "24.0",
    "echec_trend": "998855",
    "sures_2018": "0.3",
    "sures_2019": "0.6",
    "sures_2022": "1.0",
    "sures_2023": "0.3",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 1.7",
    "ecart_sexes_lens_2022": "F 3.5",
    "ecart_sexes_lens_2023": "F 3.5",
    "ecart_sexes_lens_2024": "M 0.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.9",
    "ecart_sexes_math_2019": "F 3.5",
    "ecart_sexes_math_2022": "M 2.4",
    "ecart_sexes_math_2023": "F 5.7",
    "ecart_sexes_math_2024": "F 0.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.2",
    "prog_2019": "31.2",
    "prog_2022": "18.2",
    "prog_2023": "21.5",
    "prog_2024": "26.1",
    "prog_trend": "—",
    "cote_2018": "7.0",
    "cote_2019": "6.8",
    "cote_2022": "7.0",
    "cote_2023": "6.5",
    "cote_2024": "5.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Henri-Bourassa",
    "nom_court": "École secondaire Henri-Bourassa",
    "adresse": "6051, boulevard Maurice-Duplessis",
    "municipalite": "Montréal",
    "code_postal": "H1G 1Y6",
    "lat": 45.61428,
    "lng": -73.62209
  },
  {
    "_id": "84",
    "school_code": "762127",
    "school_name_1": "FACE",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "384",
    "langue": "français",
    "secteur": "public",
    "rang": "126",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "2.7",
    "ehdaa_2024": "25.3",
    "rang_2024": "126/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "68.0",
    "lens_2019": "72.8",
    "lens_2022": "60.6",
    "lens_2023": "63.3",
    "lens_2024": "66.5",
    "lens_trend": "—",
    "lsec_2018": "83.0",
    "lsec_2019": "88.2",
    "lsec_2022": "84.5",
    "lsec_2023": "87.1",
    "lsec_2024": "84.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "71.5",
    "scie_2022": "72.8",
    "scie_2023": "76.5",
    "scie_2024": "75.4",
    "scie_trend": "—",
    "math_2018": "74.8",
    "math_2019": "72.4",
    "math_2022": "78.7",
    "math_2023": "74.8",
    "math_2024": "78.4",
    "math_trend": "—",
    "echec_2018": "16.4",
    "echec_2019": "15.1",
    "echec_2022": "17.9",
    "echec_2023": "17.0",
    "echec_2024": "12.9",
    "echec_trend": "—",
    "sures_2018": "4.4",
    "sures_2019": "2.0",
    "sures_2022": "5.5",
    "sures_2023": "5.0",
    "sures_2024": "4.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 15.8",
    "ecart_sexes_lens_2019": "F 9.6",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 4.2",
    "ecart_sexes_math_2019": "F 1.6",
    "ecart_sexes_math_2022": "M 5.3",
    "ecart_sexes_math_2023": "M 4.1",
    "ecart_sexes_math_2024": "M 0.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "16.0",
    "prog_2019": "14.3",
    "prog_2022": "6.3",
    "prog_2023": "13.3",
    "prog_2024": "13.5",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "6.6",
    "cote_2022": "6.7",
    "cote_2023": "6.1",
    "cote_2024": "6.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École FACE",
    "nom_court": "École Face",
    "adresse": "3449, rue University",
    "municipalite": "Montréal",
    "code_postal": "H3A 2A8",
    "lat": 45.506043,
    "lng": -73.575211
  },
  {
    "_id": "85",
    "school_code": "762248",
    "school_name_1": "Éc. le Vitrail",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "110",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "10.5",
    "ehdaa_2024": "44.5",
    "rang_2024": "182/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "66.5",
    "lens_2022": "72.2",
    "lens_2023": "68.0",
    "lens_2024": "74.8",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "75.1",
    "lsec_2022": "79.8",
    "lsec_2023": "77.1",
    "lsec_2024": "81.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "71.3",
    "scie_2022": "65.3",
    "scie_2023": "71.6",
    "scie_2024": "68.2",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "62.9",
    "math_2022": "53.2",
    "math_2023": "75.4",
    "math_2024": "83.1",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "23.3",
    "echec_2022": "29.8",
    "echec_2023": "16.6",
    "echec_2024": "15.8",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "6.5",
    "sures_2022": "12.4",
    "sures_2023": "1.4",
    "sures_2024": "2.7",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "47.4",
    "prog_2022": "25.0",
    "prog_2023": "25.8",
    "prog_2024": "40.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "3.4",
    "cote_2022": "3.9",
    "cote_2023": "6.0",
    "cote_2024": "6.3",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Le Vitrail",
    "nom_court": "École Le Vitrail",
    "adresse": "5927, rue Boyer",
    "municipalite": "Montréal",
    "code_postal": "H2S 2H8",
    "lat": 45.53509,
    "lng": -73.59727
  },
  {
    "_id": "86",
    "school_code": "762252",
    "school_name_1": "Louise-Trichet",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "604",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "13.8",
    "ehdaa_2024": "27.6",
    "rang_2024": "156/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "73.1",
    "lens_2019": "75.8",
    "lens_2022": "68.1",
    "lens_2023": "68.7",
    "lens_2024": "67.7",
    "lens_trend": "—",
    "lsec_2018": "87.8",
    "lsec_2019": "83.5",
    "lsec_2022": "69.1",
    "lsec_2023": "71.2",
    "lsec_2024": "75.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.4",
    "scie_2019": "66.4",
    "scie_2022": "69.0",
    "scie_2023": "70.4",
    "scie_2024": "68.0",
    "scie_trend": "112233",
    "math_2018": "71.8",
    "math_2019": "75.1",
    "math_2022": "76.4",
    "math_2023": "78.2",
    "math_2024": "75.0",
    "math_trend": "—",
    "echec_2018": "17.5",
    "echec_2019": "15.6",
    "echec_2022": "21.3",
    "echec_2023": "16.1",
    "echec_2024": "18.2",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.8",
    "sures_2022": "0.7",
    "sures_2023": "0.4",
    "sures_2024": "0.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 1.7",
    "ecart_sexes_lens_2023": "M 2.0",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "M 6.3",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "21.7",
    "prog_2019": "30.7",
    "prog_2022": "20.5",
    "prog_2023": "23.8",
    "prog_2024": "14.9",
    "prog_trend": "—",
    "cote_2018": "7.0",
    "cote_2019": "7.1",
    "cote_2022": "6.1",
    "cote_2023": "6.4",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Louise-Trichet",
    "nom_court": "École Louise-Trichet",
    "adresse": "2800, boulevard Lapointe",
    "municipalite": "Montréal",
    "code_postal": "H1L 5M1",
    "lat": 45.59782,
    "lng": -73.52542
  },
  {
    "_id": "87",
    "school_code": "762253",
    "school_name_1": "Dunton",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "727",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "21.4",
    "ehdaa_2024": "41.5",
    "rang_2024": "420/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "69.1",
    "lens_2019": "71.2",
    "lens_2022": "67.4",
    "lens_2023": "65.1",
    "lens_2024": "63.5",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "77.9",
    "lsec_2022": "76.8",
    "lsec_2023": "79.2",
    "lsec_2024": "79.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.1",
    "scie_2019": "69.6",
    "scie_2022": "66.7",
    "scie_2023": "72.0",
    "scie_2024": "66.0",
    "scie_trend": "—",
    "math_2018": "69.9",
    "math_2019": "67.4",
    "math_2022": "65.9",
    "math_2023": "67.3",
    "math_2024": "69.4",
    "math_trend": "—",
    "echec_2018": "16.2",
    "echec_2019": "18.6",
    "echec_2022": "24.8",
    "echec_2023": "19.5",
    "echec_2024": "24.0",
    "echec_trend": "998855",
    "sures_2018": "0.4",
    "sures_2019": "0.9",
    "sures_2022": "2.4",
    "sures_2023": "3.2",
    "sures_2024": "3.7",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 6.2",
    "ecart_sexes_lens_2019": "F 6.1",
    "ecart_sexes_lens_2022": "F 1.0",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 4.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.3",
    "ecart_sexes_math_2019": "M 0.6",
    "ecart_sexes_math_2022": "M 3.7",
    "ecart_sexes_math_2023": "M 3.6",
    "ecart_sexes_math_2024": "F 18.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "44.2",
    "prog_2019": "33.4",
    "prog_2022": "24.6",
    "prog_2023": "31.7",
    "prog_2024": "30.9",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "5.1",
    "cote_2022": "5.2",
    "cote_2023": "4.7",
    "cote_2024": "4.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Dunton",
    "nom_court": "Académie Dunton",
    "adresse": "5555, rue De Boucherville",
    "municipalite": "Montréal",
    "code_postal": "H1K 4B6",
    "lat": 45.59624,
    "lng": -73.54387
  },
  {
    "_id": "88",
    "school_code": "762254",
    "school_name_1": "Louis-Riel",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1466",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "26.3",
    "rang_2024": "260/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "69.2",
    "lens_2019": "70.6",
    "lens_2022": "66.0",
    "lens_2023": "66.3",
    "lens_2024": "66.7",
    "lens_trend": "—",
    "lsec_2018": "76.3",
    "lsec_2019": "77.8",
    "lsec_2022": "77.6",
    "lsec_2023": "77.1",
    "lsec_2024": "74.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.3",
    "scie_2019": "69.6",
    "scie_2022": "70.6",
    "scie_2023": "74.6",
    "scie_2024": "71.8",
    "scie_trend": "112233",
    "math_2018": "77.2",
    "math_2019": "76.9",
    "math_2022": "75.1",
    "math_2023": "70.4",
    "math_2024": "78.6",
    "math_trend": "—",
    "echec_2018": "15.3",
    "echec_2019": "16.2",
    "echec_2022": "19.6",
    "echec_2023": "21.3",
    "echec_2024": "18.5",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "1.1",
    "sures_2023": "1.3",
    "sures_2024": "0.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 2.7",
    "ecart_sexes_lens_2019": "F 1.2",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 3.7",
    "ecart_sexes_lens_2024": "F 3.5",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 2.8",
    "ecart_sexes_math_2019": "F 8.3",
    "ecart_sexes_math_2022": "F 6.7",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "M 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.6",
    "prog_2019": "31.9",
    "prog_2022": "24.7",
    "prog_2023": "32.1",
    "prog_2024": "35.4",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "5.9",
    "cote_2022": "5.9",
    "cote_2023": "5.1",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Louis-Riel",
    "nom_court": "École Louis-Riel",
    "adresse": "5850, avenue de Carignan",
    "municipalite": "Montréal",
    "code_postal": "H1M 2V4",
    "lat": 45.58359,
    "lng": -73.55607
  },
  {
    "_id": "89",
    "school_code": "762256",
    "school_name_1": "Édouard-Montpetit",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1375",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "396",
    "index": "0.1",
    "en_retard_2024": "18.6",
    "ehdaa_2024": "30.5",
    "rang_2024": "399/470",
    "rang_2019_2024": "396/432",
    "lens_2018": "67.3",
    "lens_2019": "69.0",
    "lens_2022": "65.0",
    "lens_2023": "65.7",
    "lens_2024": "66.0",
    "lens_trend": "—",
    "lsec_2018": "79.3",
    "lsec_2019": "79.6",
    "lsec_2022": "81.8",
    "lsec_2023": "80.7",
    "lsec_2024": "82.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.8",
    "scie_2019": "65.2",
    "scie_2022": "63.3",
    "scie_2023": "65.0",
    "scie_2024": "60.4",
    "scie_trend": "—",
    "math_2018": "61.5",
    "math_2019": "67.7",
    "math_2022": "56.8",
    "math_2023": "65.2",
    "math_2024": "67.7",
    "math_trend": "—",
    "echec_2018": "27.4",
    "echec_2019": "22.6",
    "echec_2022": "33.5",
    "echec_2023": "29.2",
    "echec_2024": "28.4",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "1.4",
    "sures_2022": "9.0",
    "sures_2023": "3.3",
    "sures_2024": "4.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.2",
    "ecart_sexes_lens_2019": "M 0.1",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "M 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.6",
    "ecart_sexes_math_2019": "M 4.1",
    "ecart_sexes_math_2022": "M 2.8",
    "ecart_sexes_math_2023": "M 4.6",
    "ecart_sexes_math_2024": "F 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.4",
    "prog_2019": "31.1",
    "prog_2022": "37.0",
    "prog_2023": "39.5",
    "prog_2024": "33.3",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "4.9",
    "cote_2022": "3.5",
    "cote_2023": "3.8",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Édouard-Montpetit",
    "nom_court": "École Édouard-Montpetit",
    "adresse": "6200, avenue Pierre-De Coubertin",
    "municipalite": "Montréal",
    "code_postal": "H1N 1S4",
    "lat": 45.57651,
    "lng": -73.53565
  },
  {
    "_id": "90",
    "school_code": "762258",
    "school_name_1": "Marguerite-De Lajemmerais",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1084",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "16.1",
    "ehdaa_2024": "33.2",
    "rang_2024": "409/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "68.1",
    "lens_2019": "72.3",
    "lens_2022": "66.0",
    "lens_2023": "63.0",
    "lens_2024": "68.8",
    "lens_trend": "—",
    "lsec_2018": "81.0",
    "lsec_2019": "81.6",
    "lsec_2022": "80.8",
    "lsec_2023": "86.7",
    "lsec_2024": "88.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.9",
    "scie_2019": "63.0",
    "scie_2022": "63.8",
    "scie_2023": "63.5",
    "scie_2024": "59.0",
    "scie_trend": "—",
    "math_2018": "67.6",
    "math_2019": "69.5",
    "math_2022": "72.7",
    "math_2023": "72.3",
    "math_2024": "65.7",
    "math_trend": "—",
    "echec_2018": "23.3",
    "echec_2019": "22.7",
    "echec_2022": "24.7",
    "echec_2023": "26.5",
    "echec_2024": "32.4",
    "echec_trend": "—",
    "sures_2018": "3.8",
    "sures_2019": "2.7",
    "sures_2022": "2.1",
    "sures_2023": "2.4",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 13.7",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 1.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 7.8",
    "ecart_sexes_math_2024": "M 5.3",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "23.2",
    "prog_2019": "16.8",
    "prog_2022": "16.9",
    "prog_2023": "29.7",
    "prog_2024": "31.9",
    "prog_trend": "—",
    "cote_2018": "4.5",
    "cote_2019": "5.2",
    "cote_2022": "5.5",
    "cote_2023": "4.4",
    "cote_2024": "4.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Marguerite-De Lajemmerais",
    "nom_court": "École Marguerite-De Lajemmerais",
    "adresse": "5555, rue Sherbrooke Est",
    "municipalite": "Montréal",
    "code_postal": "H1N 1A2",
    "lat": 45.57177,
    "lng": -73.55213
  },
  {
    "_id": "91",
    "school_code": "762259",
    "school_name_1": "Chomedey-De-Maisonneuve",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "529",
    "langue": "français",
    "secteur": "public",
    "rang": "461",
    "rang_5_ans": "429",
    "index": "0.1",
    "en_retard_2024": "20.3",
    "ehdaa_2024": "57.8",
    "rang_2024": "461/470",
    "rang_2019_2024": "429/432",
    "lens_2018": "58.3",
    "lens_2019": "61.0",
    "lens_2022": "60.7",
    "lens_2023": "64.8",
    "lens_2024": "61.9",
    "lens_trend": "112233",
    "lsec_2018": "68.7",
    "lsec_2019": "77.5",
    "lsec_2022": "78.3",
    "lsec_2023": "78.3",
    "lsec_2024": "77.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.3",
    "scie_2019": "65.6",
    "scie_2022": "60.9",
    "scie_2023": "68.8",
    "scie_2024": "64.0",
    "scie_trend": "—",
    "math_2018": "53.1",
    "math_2019": "62.7",
    "math_2022": "49.2",
    "math_2023": "59.8",
    "math_2024": "57.9",
    "math_trend": "—",
    "echec_2018": "39.1",
    "echec_2019": "32.2",
    "echec_2022": "40.1",
    "echec_2023": "26.1",
    "echec_2024": "31.9",
    "echec_trend": "—",
    "sures_2018": "7.7",
    "sures_2019": "8.3",
    "sures_2022": "11.3",
    "sures_2023": "5.9",
    "sures_2024": "5.9",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "M 0.2",
    "ecart_sexes_lens_2019": "M 2.5",
    "ecart_sexes_lens_2022": "F 4.0",
    "ecart_sexes_lens_2023": "F 8.0",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.8",
    "ecart_sexes_math_2019": "M 8.0",
    "ecart_sexes_math_2022": "M 9.2",
    "ecart_sexes_math_2023": "F 8.7",
    "ecart_sexes_math_2024": "F 4.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "58.5",
    "prog_2019": "70.2",
    "prog_2022": "36.5",
    "prog_2023": "51.5",
    "prog_2024": "56.3",
    "prog_trend": "—",
    "cote_2018": "0.9",
    "cote_2019": "1.3",
    "cote_2022": "2.1",
    "cote_2023": "2.9",
    "cote_2024": "2.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Chomedey-De Maisonneuve",
    "nom_court": "École Chomedey-De Maisonneuve",
    "adresse": "1860, avenue Morgan",
    "municipalite": "Montréal",
    "code_postal": "H1V 2R2",
    "lat": 45.55253,
    "lng": -73.54663
  },
  {
    "_id": "92",
    "school_code": "762262",
    "school_name_1": "Joseph-François-Perrault",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1476",
    "langue": "français",
    "secteur": "public",
    "rang": "120",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "6.4",
    "ehdaa_2024": "23.4",
    "rang_2024": "120/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "71.8",
    "lens_2019": "72.7",
    "lens_2022": "68.0",
    "lens_2023": "68.2",
    "lens_2024": "69.6",
    "lens_trend": "—",
    "lsec_2018": "77.6",
    "lsec_2019": "77.8",
    "lsec_2022": "79.7",
    "lsec_2023": "81.0",
    "lsec_2024": "80.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.0",
    "scie_2019": "74.2",
    "scie_2022": "74.9",
    "scie_2023": "77.0",
    "scie_2024": "73.7",
    "scie_trend": "—",
    "math_2018": "78.6",
    "math_2019": "79.5",
    "math_2022": "73.6",
    "math_2023": "78.6",
    "math_2024": "82.5",
    "math_trend": "—",
    "echec_2018": "11.7",
    "echec_2019": "12.1",
    "echec_2022": "16.1",
    "echec_2023": "13.6",
    "echec_2024": "12.7",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.1",
    "sures_2022": "2.7",
    "sures_2023": "1.2",
    "sures_2024": "2.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 6.5",
    "ecart_sexes_lens_2019": "F 6.0",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 2.6",
    "ecart_sexes_lens_2024": "F 3.1",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 1.9",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 3.1",
    "ecart_sexes_math_2023": "F 0.4",
    "ecart_sexes_math_2024": "M 0.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.7",
    "prog_2019": "19.9",
    "prog_2022": "12.7",
    "prog_2023": "26.2",
    "prog_2024": "20.5",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "6.8",
    "cote_2022": "6.6",
    "cote_2023": "6.6",
    "cote_2024": "7.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Joseph-François-Perrault",
    "nom_court": "École Joseph-François-Perrault",
    "adresse": "7450, rue François-Perrault",
    "municipalite": "Montréal",
    "code_postal": "H2A 1L9",
    "lat": 45.56328,
    "lng": -73.60002
  },
  {
    "_id": "93",
    "school_code": "762263",
    "school_name_1": "Louis-Joseph-Papineau",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1523",
    "langue": "français",
    "secteur": "public",
    "rang": "459",
    "rang_5_ans": "422",
    "index": "0.1",
    "en_retard_2024": "36.1",
    "ehdaa_2024": "31.2",
    "rang_2024": "459/470",
    "rang_2019_2024": "422/432",
    "lens_2018": "66.6",
    "lens_2019": "66.8",
    "lens_2022": "58.6",
    "lens_2023": "63.8",
    "lens_2024": "59.3",
    "lens_trend": "—",
    "lsec_2018": "74.8",
    "lsec_2019": "71.5",
    "lsec_2022": "74.2",
    "lsec_2023": "75.5",
    "lsec_2024": "76.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.1",
    "scie_2019": "63.9",
    "scie_2022": "65.7",
    "scie_2023": "67.1",
    "scie_2024": "63.3",
    "scie_trend": "—",
    "math_2018": "64.5",
    "math_2019": "60.5",
    "math_2022": "60.6",
    "math_2023": "61.5",
    "math_2024": "59.9",
    "math_trend": "—",
    "echec_2018": "28.2",
    "echec_2019": "32.5",
    "echec_2022": "34.1",
    "echec_2023": "30.8",
    "echec_2024": "35.1",
    "echec_trend": "—",
    "sures_2018": "1.4",
    "sures_2019": "4.6",
    "sures_2022": "5.5",
    "sures_2023": "2.0",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.9",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "M 1.1",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.7",
    "ecart_sexes_math_2019": "M 2.1",
    "ecart_sexes_math_2022": "M 2.8",
    "ecart_sexes_math_2023": "M 2.1",
    "ecart_sexes_math_2024": "F 2.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.9",
    "prog_2019": "50.0",
    "prog_2022": "41.3",
    "prog_2023": "56.9",
    "prog_2024": "54.3",
    "prog_trend": "998855",
    "cote_2018": "3.9",
    "cote_2019": "2.5",
    "cote_2022": "3.4",
    "cote_2023": "3.5",
    "cote_2024": "2.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Louis-Joseph-Papineau",
    "nom_court": "École Louis-Joseph-Papineau",
    "adresse": "2901, rue de Louvain Est",
    "municipalite": "Montréal",
    "code_postal": "H1Z 1J7",
    "lat": 45.57132,
    "lng": -73.63394
  },
  {
    "_id": "94",
    "school_code": "762264",
    "school_name_1": "Pierre-Dupuy",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "358",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "26.2",
    "ehdaa_2024": "45.8",
    "rang_2024": "299/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "70.2",
    "lens_2019": "65.6",
    "lens_2022": "56.3",
    "lens_2023": "54.8",
    "lens_2024": "61.6",
    "lens_trend": "—",
    "lsec_2018": "81.8",
    "lsec_2019": "77.0",
    "lsec_2022": "78.1",
    "lsec_2023": "82.6",
    "lsec_2024": "84.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.0",
    "scie_2019": "63.0",
    "scie_2022": "60.6",
    "scie_2023": "73.9",
    "scie_2024": "74.8",
    "scie_trend": "112233",
    "math_2018": "73.2",
    "math_2019": "73.4",
    "math_2022": "69.0",
    "math_2023": "72.2",
    "math_2024": "75.8",
    "math_trend": "—",
    "echec_2018": "19.8",
    "echec_2019": "24.9",
    "echec_2022": "37.3",
    "echec_2023": "20.0",
    "echec_2024": "17.3",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.0",
    "sures_2022": "3.8",
    "sures_2023": "3.2",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 6.4",
    "ecart_sexes_lens_2024": "F 0.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 10.9",
    "ecart_sexes_math_2022": "F 10.9",
    "ecart_sexes_math_2023": "M 15.0",
    "ecart_sexes_math_2024": "M 2.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "66.5",
    "prog_2019": "39.7",
    "prog_2022": "34.9",
    "prog_2023": "48.3",
    "prog_2024": "59.7",
    "prog_trend": "—",
    "cote_2018": "4.5",
    "cote_2019": "4.0",
    "cote_2022": "3.5",
    "cote_2023": "4.1",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Pierre-Dupuy",
    "nom_court": "École Pierre-Dupuy",
    "adresse": "2000, rue Parthenais",
    "municipalite": "Montréal",
    "code_postal": "H2K 3S9",
    "lat": 45.52922,
    "lng": -73.55769
  },
  {
    "_id": "95",
    "school_code": "762265",
    "school_name_1": "Jeanne-Mance",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1198",
    "langue": "français",
    "secteur": "public",
    "rang": "437",
    "rang_5_ans": "399",
    "index": "0.1",
    "en_retard_2024": "23",
    "ehdaa_2024": "46.2",
    "rang_2024": "437/470",
    "rang_2019_2024": "399/432",
    "lens_2018": "68.1",
    "lens_2019": "67.1",
    "lens_2022": "58.8",
    "lens_2023": "64.9",
    "lens_2024": "65.6",
    "lens_trend": "—",
    "lsec_2018": "75.7",
    "lsec_2019": "82.5",
    "lsec_2022": "82.7",
    "lsec_2023": "84.1",
    "lsec_2024": "86.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.2",
    "scie_2019": "69.1",
    "scie_2022": "61.0",
    "scie_2023": "62.7",
    "scie_2024": "61.3",
    "scie_trend": "—",
    "math_2018": "66.0",
    "math_2019": "71.3",
    "math_2022": "62.6",
    "math_2023": "67.8",
    "math_2024": "67.4",
    "math_trend": "—",
    "echec_2018": "23.2",
    "echec_2019": "21.9",
    "echec_2022": "33.3",
    "echec_2023": "25.6",
    "echec_2024": "33.3",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "1.8",
    "sures_2022": "8.3",
    "sures_2023": "3.7",
    "sures_2024": "5.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.6",
    "ecart_sexes_lens_2019": "F 6.8",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 5.4",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.1",
    "ecart_sexes_math_2019": "F 4.7",
    "ecart_sexes_math_2022": "M 4.2",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "F 0.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "44.9",
    "prog_2019": "36.3",
    "prog_2022": "30.5",
    "prog_2023": "48.4",
    "prog_2024": "42.3",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.7",
    "cote_2022": "3.8",
    "cote_2023": "4.0",
    "cote_2024": "3.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Jeanne-Mance",
    "nom_court": "École Jeanne-Mance",
    "adresse": "4240, rue de Bordeaux",
    "municipalite": "Montréal",
    "code_postal": "H2H 1Z5",
    "lat": 45.53229,
    "lng": -73.56991
  },
  {
    "_id": "96",
    "school_code": "762267",
    "school_name_1": "De Roberval",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "566",
    "langue": "français",
    "secteur": "public",
    "rang": "21",
    "rang_5_ans": "30",
    "index": "0.1",
    "en_retard_2024": "0.9",
    "ehdaa_2024": "4.1",
    "rang_2024": "21/470",
    "rang_2019_2024": "30/432",
    "lens_2018": "80.5",
    "lens_2019": "77.4",
    "lens_2022": "73.9",
    "lens_2023": "75.3",
    "lens_2024": "75.4",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "77.3",
    "lsec_2022": "80.1",
    "lsec_2023": "81.4",
    "lsec_2024": "82.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.7",
    "scie_2019": "83.5",
    "scie_2022": "83.1",
    "scie_2023": "89.2",
    "scie_2024": "86.2",
    "scie_trend": "112233",
    "math_2018": "79.2",
    "math_2019": "81.9",
    "math_2022": "88.4",
    "math_2023": "89.7",
    "math_2024": "91.6",
    "math_trend": "112233",
    "echec_2018": "5.5",
    "echec_2019": "4.4",
    "echec_2022": "5.8",
    "echec_2023": "2.0",
    "echec_2024": "3.5",
    "echec_trend": "112233",
    "sures_2018": "0.3",
    "sures_2019": "1.4",
    "sures_2022": "1.9",
    "sures_2023": "1.3",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 4.4",
    "ecart_sexes_lens_2022": "F 0.8",
    "ecart_sexes_lens_2023": "M 0.1",
    "ecart_sexes_lens_2024": "M 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.6",
    "ecart_sexes_math_2019": "M 0.6",
    "ecart_sexes_math_2022": "M 5.7",
    "ecart_sexes_math_2023": "M 1.3",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.1",
    "prog_2019": "1.3",
    "prog_2022": "2.4",
    "prog_2023": "5.6",
    "prog_2024": "0.9",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.4",
    "cote_2022": "8.7",
    "cote_2023": "9.0",
    "cote_2024": "9.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Académie De Roberval",
    "nom_court": "Académie De Roberval",
    "adresse": "1275, rue Jarry Est",
    "municipalite": "Montréal",
    "code_postal": "H2P 1W9",
    "lat": 45.55021,
    "lng": -73.62529
  },
  {
    "_id": "97",
    "school_code": "762268",
    "school_name_1": "Père-Marquette",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1369",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "9.9",
    "ehdaa_2024": "38.7",
    "rang_2024": "367/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "70.5",
    "lens_2019": "71.3",
    "lens_2022": "69.3",
    "lens_2023": "69.3",
    "lens_2024": "68.2",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "75.2",
    "lsec_2022": "75.4",
    "lsec_2023": "78.1",
    "lsec_2024": "73.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.9",
    "scie_2019": "66.8",
    "scie_2022": "66.9",
    "scie_2023": "70.2",
    "scie_2024": "64.8",
    "scie_trend": "—",
    "math_2018": "64.8",
    "math_2019": "73.5",
    "math_2022": "73.2",
    "math_2023": "72.1",
    "math_2024": "73.7",
    "math_trend": "—",
    "echec_2018": "26.3",
    "echec_2019": "19.2",
    "echec_2022": "20.1",
    "echec_2023": "18.4",
    "echec_2024": "21.1",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "1.6",
    "sures_2022": "4.5",
    "sures_2023": "3.4",
    "sures_2024": "4.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 2.9",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 5.3",
    "ecart_sexes_lens_2024": "F 0.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.1",
    "ecart_sexes_math_2019": "F 4.5",
    "ecart_sexes_math_2022": "F 2.1",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "M 5.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.7",
    "prog_2019": "36.3",
    "prog_2022": "16.3",
    "prog_2023": "23.6",
    "prog_2024": "31.7",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "4.9",
    "cote_2022": "5.7",
    "cote_2023": "5.5",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Père-Marquette",
    "nom_court": "École Père-Marquette",
    "adresse": "6030, rue Marquette",
    "municipalite": "Montréal",
    "code_postal": "H2G 2Y2",
    "lat": 45.54089,
    "lng": -73.59338
  },
  {
    "_id": "98",
    "school_code": "762269",
    "school_name_1": "Georges-Vanier",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1126",
    "langue": "français",
    "secteur": "public",
    "rang": "430",
    "rang_5_ans": "399",
    "index": "0.1",
    "en_retard_2024": "25.3",
    "ehdaa_2024": "40.6",
    "rang_2024": "430/470",
    "rang_2019_2024": "399/432",
    "lens_2018": "66.6",
    "lens_2019": "67.5",
    "lens_2022": "59.5",
    "lens_2023": "65.5",
    "lens_2024": "67.5",
    "lens_trend": "—",
    "lsec_2018": "82.1",
    "lsec_2019": "83.8",
    "lsec_2022": "80.1",
    "lsec_2023": "88.9",
    "lsec_2024": "87.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.8",
    "scie_2019": "63.1",
    "scie_2022": "61.8",
    "scie_2023": "62.9",
    "scie_2024": "59.7",
    "scie_trend": "—",
    "math_2018": "64.7",
    "math_2019": "65.3",
    "math_2022": "60.6",
    "math_2023": "69.7",
    "math_2024": "64.6",
    "math_trend": "—",
    "echec_2018": "24.7",
    "echec_2019": "25.7",
    "echec_2022": "36.9",
    "echec_2023": "26.1",
    "echec_2024": "32.2",
    "echec_trend": "—",
    "sures_2018": "4.5",
    "sures_2019": "4.2",
    "sures_2022": "6.2",
    "sures_2023": "4.7",
    "sures_2024": "6.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.0",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 4.1",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "M 10.3",
    "ecart_sexes_math_2023": "M 1.1",
    "ecart_sexes_math_2024": "F 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "38.7",
    "prog_2019": "46.2",
    "prog_2022": "33.9",
    "prog_2023": "42.4",
    "prog_2024": "31.8",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "4.0",
    "cote_2022": "3.5",
    "cote_2023": "4.6",
    "cote_2024": "3.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Georges-Vanier",
    "nom_court": "École Georges-Vanier",
    "adresse": "1205, rue Jarry Est",
    "municipalite": "Montréal",
    "code_postal": "H2P 1W9",
    "lat": 45.55021,
    "lng": -73.62529
  },
  {
    "_id": "99",
    "school_code": "762271",
    "school_name_1": "Sophie-Barat",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1713",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "9.6",
    "ehdaa_2024": "17.5",
    "rang_2024": "217/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "70.4",
    "lens_2019": "73.6",
    "lens_2022": "67.6",
    "lens_2023": "69.7",
    "lens_2024": "70.5",
    "lens_trend": "—",
    "lsec_2018": "82.7",
    "lsec_2019": "83.5",
    "lsec_2022": "78.4",
    "lsec_2023": "80.4",
    "lsec_2024": "78.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.5",
    "scie_2019": "70.7",
    "scie_2022": "68.6",
    "scie_2023": "70.1",
    "scie_2024": "68.1",
    "scie_trend": "—",
    "math_2018": "79.9",
    "math_2019": "79.0",
    "math_2022": "76.7",
    "math_2023": "69.5",
    "math_2024": "74.9",
    "math_trend": "998855",
    "echec_2018": "14.3",
    "echec_2019": "12.8",
    "echec_2022": "18.8",
    "echec_2023": "20.6",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.5",
    "sures_2022": "1.3",
    "sures_2023": "0.6",
    "sures_2024": "1.1",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "M 0.3",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "F 3.4",
    "ecart_sexes_lens_2023": "F 4.0",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 7.0",
    "ecart_sexes_math_2022": "F 1.4",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.6",
    "prog_2019": "16.1",
    "prog_2022": "17.8",
    "prog_2023": "22.7",
    "prog_2024": "26.1",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "6.9",
    "cote_2022": "6.4",
    "cote_2023": "5.7",
    "cote_2024": "6.0",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Sophie-Barat",
    "nom_court": "École Sophie-Barat",
    "adresse": "1239, boulevard Gouin Est",
    "municipalite": "Montréal",
    "code_postal": "H2C 1B3",
    "lat": 45.562,
    "lng": -73.66745
  },
  {
    "_id": "100",
    "school_code": "762274",
    "school_name_1": "Robert-Gravel",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "467",
    "langue": "français",
    "secteur": "public",
    "rang": "40",
    "rang_5_ans": "64",
    "index": "0.1",
    "en_retard_2024": "5.3",
    "ehdaa_2024": "19.5",
    "rang_2024": "40/470",
    "rang_2019_2024": "64/432",
    "lens_2018": "71.1",
    "lens_2019": "71.4",
    "lens_2022": "69.7",
    "lens_2023": "71.6",
    "lens_2024": "71.8",
    "lens_trend": "112233",
    "lsec_2018": "87.3",
    "lsec_2019": "86.9",
    "lsec_2022": "93.9",
    "lsec_2023": "91.5",
    "lsec_2024": "93.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.6",
    "scie_2019": "76.2",
    "scie_2022": "74.0",
    "scie_2023": "78.0",
    "scie_2024": "74.9",
    "scie_trend": "—",
    "math_2018": "84.2",
    "math_2019": "77.8",
    "math_2022": "81.1",
    "math_2023": "71.8",
    "math_2024": "85.8",
    "math_trend": "—",
    "echec_2018": "4.4",
    "echec_2019": "8.5",
    "echec_2022": "9.1",
    "echec_2023": "13.7",
    "echec_2024": "9.0",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.3",
    "sures_2022": "2.4",
    "sures_2023": "3.4",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.9",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.1",
    "ecart_sexes_math_2019": "M 2.0",
    "ecart_sexes_math_2022": "F 6.3",
    "ecart_sexes_math_2023": "M 7.9",
    "ecart_sexes_math_2024": "M 4.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "15.4",
    "prog_2019": "13.4",
    "prog_2022": "10.2",
    "prog_2023": "8.7",
    "prog_2024": "5.2",
    "prog_trend": "112233",
    "cote_2018": "7.8",
    "cote_2019": "7.7",
    "cote_2022": "8.3",
    "cote_2023": "7.1",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Robert-Gravel",
    "nom_court": "École Robert-Gravel",
    "adresse": "38, avenue Fairmount Est",
    "municipalite": "Montréal",
    "code_postal": "H2T 1C9",
    "lat": 45.52463,
    "lng": -73.59371
  },
  {
    "_id": "101",
    "school_code": "762278",
    "school_name_1": "Lucien-Pagé",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1515",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "24.3",
    "ehdaa_2024": "31.9",
    "rang_2024": "420/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "66.7",
    "lens_2019": "67.7",
    "lens_2022": "58.2",
    "lens_2023": "61.9",
    "lens_2024": "61.6",
    "lens_trend": "—",
    "lsec_2018": "87.3",
    "lsec_2019": "84.8",
    "lsec_2022": "80.0",
    "lsec_2023": "77.1",
    "lsec_2024": "78.7",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.2",
    "scie_2019": "62.1",
    "scie_2022": "55.7",
    "scie_2023": "62.0",
    "scie_2024": "59.3",
    "scie_trend": "—",
    "math_2018": "66.4",
    "math_2019": "66.9",
    "math_2022": "75.3",
    "math_2023": "69.4",
    "math_2024": "78.9",
    "math_trend": "—",
    "echec_2018": "25.0",
    "echec_2019": "26.5",
    "echec_2022": "32.0",
    "echec_2023": "29.0",
    "echec_2024": "27.6",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "3.6",
    "sures_2022": "6.6",
    "sures_2023": "3.0",
    "sures_2024": "5.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.3",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 5.5",
    "ecart_sexes_lens_2023": "M 1.6",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.8",
    "ecart_sexes_math_2019": "F 0.3",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "F 1.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "57.3",
    "prog_2019": "43.3",
    "prog_2022": "29.3",
    "prog_2023": "48.6",
    "prog_2024": "40.7",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.0",
    "cote_2022": "4.1",
    "cote_2023": "3.6",
    "cote_2024": "4.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Lucien-Pagé",
    "nom_court": "École Lucien-Pagé",
    "adresse": "8200, boulevard Saint-Laurent",
    "municipalite": "Montréal",
    "code_postal": "H2P 2L8",
    "lat": 45.53846,
    "lng": -73.63361
  },
  {
    "_id": "102",
    "school_code": "762281",
    "school_name_1": "Évangéline",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "867",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "21.5",
    "ehdaa_2024": "23.4",
    "rang_2024": "367/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "71.4",
    "lens_2019": "69.2",
    "lens_2022": "60.1",
    "lens_2023": "64.5",
    "lens_2024": "63.4",
    "lens_trend": "—",
    "lsec_2018": "82.7",
    "lsec_2019": "83.5",
    "lsec_2022": "87.1",
    "lsec_2023": "86.6",
    "lsec_2024": "79.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.6",
    "scie_2019": "68.7",
    "scie_2022": "69.3",
    "scie_2023": "69.7",
    "scie_2024": "63.5",
    "scie_trend": "—",
    "math_2018": "65.4",
    "math_2019": "71.2",
    "math_2022": "67.1",
    "math_2023": "72.5",
    "math_2024": "74.0",
    "math_trend": "—",
    "echec_2018": "23.0",
    "echec_2019": "18.5",
    "echec_2022": "28.1",
    "echec_2023": "20.1",
    "echec_2024": "27.1",
    "echec_trend": "—",
    "sures_2018": "3.5",
    "sures_2019": "2.9",
    "sures_2022": "5.9",
    "sures_2023": "1.9",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 4.4",
    "ecart_sexes_lens_2022": "F 6.1",
    "ecart_sexes_lens_2023": "F 3.2",
    "ecart_sexes_lens_2024": "F 7.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.4",
    "ecart_sexes_math_2019": "F 5.9",
    "ecart_sexes_math_2022": "M 0.8",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "M 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.6",
    "prog_2019": "31.4",
    "prog_2022": "21.7",
    "prog_2023": "42.1",
    "prog_2024": "40.7",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.8",
    "cote_2022": "5.6",
    "cote_2023": "5.7",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École La Dauversière-Évangéline",
    "nom_court": "École La Dauversière-Évangéline",
    "adresse": "11600, boulevard de l'Acadie",
    "municipalite": "Montréal",
    "code_postal": "H3M 2T2",
    "lat": 45.53636,
    "lng": -73.68917
  },
  {
    "_id": "103",
    "school_code": "762284",
    "school_name_1": "École internationale de Montréal",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "560",
    "langue": "français",
    "secteur": "public",
    "rang": "1",
    "rang_5_ans": "2",
    "index": "0.1",
    "en_retard_2024": "1.8",
    "ehdaa_2024": "nd",
    "rang_2024": "1/470",
    "rang_2019_2024": "2/432",
    "lens_2018": "80.4",
    "lens_2019": "80.6",
    "lens_2022": "77.3",
    "lens_2023": "77.1",
    "lens_2024": "73.4",
    "lens_trend": "998855",
    "lsec_2018": "96.2",
    "lsec_2019": "97.5",
    "lsec_2022": "97.4",
    "lsec_2023": "97.2",
    "lsec_2024": "96.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.8",
    "scie_2019": "84.3",
    "scie_2022": "88.0",
    "scie_2023": "88.1",
    "scie_2024": "89.9",
    "scie_trend": "—",
    "math_2018": "84.6",
    "math_2019": "87.4",
    "math_2022": "92.1",
    "math_2023": "91.1",
    "math_2024": "93.1",
    "math_trend": "112233",
    "echec_2018": "1.8",
    "echec_2019": "4.1",
    "echec_2022": "2.5",
    "echec_2023": "2.2",
    "echec_2024": "4.3",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "0.4",
    "sures_2023": "0.5",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.1",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "F 4.3",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.9",
    "ecart_sexes_math_2019": "M 2.5",
    "ecart_sexes_math_2022": "M 4.4",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "M 2.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.7",
    "prog_2019": "1.8",
    "prog_2022": "0.9",
    "prog_2023": "2.8",
    "prog_2024": "1.7",
    "prog_trend": "112233",
    "cote_2018": "9.7",
    "cote_2019": "10.0",
    "cote_2022": "10.0",
    "cote_2023": "9.7",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École internationale de Montréal",
    "nom_court": "École internationale de Montréal",
    "adresse": "11, chemin de la Côte-Saint-Antoine",
    "municipalite": "Montréal",
    "code_postal": "H3Y 2H7",
    "lat": 45.48676,
    "lng": -73.59576
  },
  {
    "_id": "104",
    "school_code": "762286",
    "school_name_1": "Saint-Henri",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1208",
    "langue": "français",
    "secteur": "public",
    "rang": "449",
    "rang_5_ans": "411",
    "index": "0.1",
    "en_retard_2024": "42.5",
    "ehdaa_2024": "35.2",
    "rang_2024": "449/470",
    "rang_2019_2024": "411/432",
    "lens_2018": "61.9",
    "lens_2019": "58.1",
    "lens_2022": "57.4",
    "lens_2023": "56.4",
    "lens_2024": "56.4",
    "lens_trend": "—",
    "lsec_2018": "72.6",
    "lsec_2019": "70.5",
    "lsec_2022": "74.4",
    "lsec_2023": "79.0",
    "lsec_2024": "74.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.1",
    "scie_2019": "67.1",
    "scie_2022": "66.7",
    "scie_2023": "69.0",
    "scie_2024": "62.2",
    "scie_trend": "—",
    "math_2018": "64.7",
    "math_2019": "71.2",
    "math_2022": "72.0",
    "math_2023": "66.3",
    "math_2024": "67.1",
    "math_trend": "—",
    "echec_2018": "29.6",
    "echec_2019": "27.2",
    "echec_2022": "28.1",
    "echec_2023": "29.3",
    "echec_2024": "36.2",
    "echec_trend": "—",
    "sures_2018": "3.5",
    "sures_2019": "3.5",
    "sures_2022": "5.4",
    "sures_2023": "4.3",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.2",
    "ecart_sexes_lens_2019": "F 1.2",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 7.2",
    "ecart_sexes_lens_2024": "F 2.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 6.0",
    "ecart_sexes_math_2019": "F 1.9",
    "ecart_sexes_math_2022": "F 9.6",
    "ecart_sexes_math_2023": "F 0.2",
    "ecart_sexes_math_2024": "M 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "51.3",
    "prog_2019": "42.5",
    "prog_2022": "38.0",
    "prog_2023": "43.8",
    "prog_2024": "49.1",
    "prog_trend": "—",
    "cote_2018": "3.2",
    "cote_2019": "3.8",
    "cote_2022": "4.2",
    "cote_2023": "4.0",
    "cote_2024": "3.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Henri",
    "nom_court": "École Saint-Henri",
    "adresse": "4115, rue Saint-Jacques ",
    "municipalite": "Montréal",
    "code_postal": "H4C 1J3",
    "lat": 45.47446,
    "lng": -73.59173
  },
  {
    "_id": "105",
    "school_code": "762287",
    "school_name_1": "Honoré-Mercier",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "736",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "391",
    "index": "0.1",
    "en_retard_2024": "20.4",
    "ehdaa_2024": "33.8",
    "rang_2024": "390/470",
    "rang_2019_2024": "391/432",
    "lens_2018": "63.7",
    "lens_2019": "68.3",
    "lens_2022": "64.9",
    "lens_2023": "66.0",
    "lens_2024": "66.3",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "77.4",
    "lsec_2022": "80.5",
    "lsec_2023": "82.4",
    "lsec_2024": "83.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.6",
    "scie_2019": "67.8",
    "scie_2022": "60.7",
    "scie_2023": "68.5",
    "scie_2024": "63.2",
    "scie_trend": "—",
    "math_2018": "62.5",
    "math_2019": "67.2",
    "math_2022": "63.7",
    "math_2023": "68.5",
    "math_2024": "70.8",
    "math_trend": "—",
    "echec_2018": "30.0",
    "echec_2019": "21.2",
    "echec_2022": "35.1",
    "echec_2023": "24.9",
    "echec_2024": "26.5",
    "echec_trend": "—",
    "sures_2018": "5.2",
    "sures_2019": "1.9",
    "sures_2022": "6.2",
    "sures_2023": "1.5",
    "sures_2024": "1.1",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 13.2",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 8.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.9",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 6.0",
    "ecart_sexes_math_2023": "M 2.0",
    "ecart_sexes_math_2024": "M 9.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.8",
    "prog_2019": "38.7",
    "prog_2022": "24.7",
    "prog_2023": "43.4",
    "prog_2024": "40.0",
    "prog_trend": "—",
    "cote_2018": "3.6",
    "cote_2019": "4.4",
    "cote_2022": "3.9",
    "cote_2023": "4.7",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Honoré-Mercier",
    "nom_court": "École Honoré-Mercier",
    "adresse": "1935, boulevard Desmarchais",
    "municipalite": "Montréal",
    "code_postal": "H4E 2B9",
    "lat": 45.45605,
    "lng": -73.59171
  },
  {
    "_id": "106",
    "school_code": "762288",
    "school_name_1": "La Voie",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "1113",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "19.9",
    "ehdaa_2024": "26.1",
    "rang_2024": "207/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "65.8",
    "lens_2019": "65.9",
    "lens_2022": "63.2",
    "lens_2023": "68.6",
    "lens_2024": "66.0",
    "lens_trend": "112233",
    "lsec_2018": "85.3",
    "lsec_2019": "79.8",
    "lsec_2022": "77.7",
    "lsec_2023": "83.2",
    "lsec_2024": "84.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.3",
    "scie_2019": "73.1",
    "scie_2022": "72.1",
    "scie_2023": "75.7",
    "scie_2024": "73.2",
    "scie_trend": "—",
    "math_2018": "73.3",
    "math_2019": "75.6",
    "math_2022": "61.6",
    "math_2023": "71.8",
    "math_2024": "72.0",
    "math_trend": "—",
    "echec_2018": "16.9",
    "echec_2019": "17.0",
    "echec_2022": "28.6",
    "echec_2023": "16.5",
    "echec_2024": "18.3",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "2.6",
    "sures_2022": "6.9",
    "sures_2023": "1.7",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.1",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 1.1",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.4",
    "ecart_sexes_math_2019": "F 2.2",
    "ecart_sexes_math_2022": "M 5.3",
    "ecart_sexes_math_2023": "F 6.4",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.9",
    "prog_2019": "30.7",
    "prog_2022": "15.8",
    "prog_2023": "20.3",
    "prog_2024": "31.9",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.0",
    "cote_2022": "4.9",
    "cote_2023": "6.4",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École La Voie",
    "nom_court": "École La Voie",
    "adresse": "6755, rue Lavoie",
    "municipalite": "Montréal",
    "code_postal": "H3W 2K8",
    "lat": 45.49974,
    "lng": -73.6406
  },
  {
    "_id": "107",
    "school_code": "762291",
    "school_name_1": "Saint-Luc",
    "admin_body_number": "762000",
    "admin_body_name": "Centre de services scolaire de Montréal",
    "area_name": "Montréal ",
    "étudiants": "2196",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "18.3",
    "ehdaa_2024": "29.6",
    "rang_2024": "310/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "68.3",
    "lens_2019": "67.7",
    "lens_2022": "62.0",
    "lens_2023": "64.4",
    "lens_2024": "62.3",
    "lens_trend": "998855",
    "lsec_2018": "91.6",
    "lsec_2019": "87.8",
    "lsec_2022": "90.0",
    "lsec_2023": "89.5",
    "lsec_2024": "89.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.8",
    "scie_2019": "75.9",
    "scie_2022": "63.2",
    "scie_2023": "68.1",
    "scie_2024": "64.0",
    "scie_trend": "—",
    "math_2018": "76.6",
    "math_2019": "77.4",
    "math_2022": "66.9",
    "math_2023": "67.2",
    "math_2024": "77.5",
    "math_trend": "—",
    "echec_2018": "11.3",
    "echec_2019": "12.6",
    "echec_2022": "29.2",
    "echec_2023": "25.9",
    "echec_2024": "25.2",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "5.1",
    "sures_2023": "2.0",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.3",
    "ecart_sexes_lens_2019": "F 1.2",
    "ecart_sexes_lens_2022": "F 0.5",
    "ecart_sexes_lens_2023": "F 2.5",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.9",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "M 0.1",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "F 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.7",
    "prog_2019": "22.5",
    "prog_2022": "23.4",
    "prog_2023": "44.9",
    "prog_2024": "32.2",
    "prog_trend": "—",
    "cote_2018": "7.2",
    "cote_2019": "7.5",
    "cote_2022": "5.5",
    "cote_2023": "4.8",
    "cote_2024": "5.2",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Saint-Luc",
    "nom_court": "École Saint-Luc",
    "adresse": "6300, chemin de la Côte-Saint-Luc",
    "municipalite": "Montréal",
    "code_postal": "H3X 2H4",
    "lat": 45.48224,
    "lng": -73.62968
  },
  {
    "_id": "108",
    "school_code": "763037",
    "school_name_1": "École du Sas",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "355",
    "langue": "français",
    "secteur": "public",
    "rang": "437",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "72.1",
    "rang_2024": "437/470",
    "rang_2019_2024": "nd",
    "lens_2018": "59.6",
    "lens_2019": "62.1",
    "lens_2022": "57.5",
    "lens_2023": "nd",
    "lens_2024": "59.1",
    "lens_trend": "nd",
    "lsec_2018": "84.0",
    "lsec_2019": "74.1",
    "lsec_2022": "81.3",
    "lsec_2023": "nd",
    "lsec_2024": "83.9",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.4",
    "scie_2019": "58.9",
    "scie_2022": "50.7",
    "scie_2023": "nd",
    "scie_2024": "61.5",
    "scie_trend": "nd",
    "math_2018": "68.4",
    "math_2019": "73.9",
    "math_2022": "69.4",
    "math_2023": "nd",
    "math_2024": "71.1",
    "math_trend": "nd",
    "echec_2018": "28.4",
    "echec_2019": "29.7",
    "echec_2022": "36.1",
    "echec_2023": "nd",
    "echec_2024": "29.9",
    "echec_trend": "nd",
    "sures_2018": "4.4",
    "sures_2019": "3.1",
    "sures_2022": "8.8",
    "sures_2023": "nd",
    "sures_2024": "3.8",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "M 0.4",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "M 1.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 12.9",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "F 7.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "55.6",
    "prog_2019": "89.9",
    "prog_2022": "63.2",
    "prog_2023": "nd",
    "prog_2024": "47.0",
    "prog_trend": "nd",
    "cote_2018": "3.1",
    "cote_2019": "2.0",
    "cote_2022": "2.1",
    "cote_2023": "nd",
    "cote_2024": "3.6",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École du Sas",
    "nom_court": "École du Sas",
    "adresse": "500, boulevard Dollard",
    "municipalite": "Montréal",
    "code_postal": "H2V 3G2",
    "lat": 45.51635,
    "lng": -73.6102
  },
  {
    "_id": "109",
    "school_code": "763038",
    "school_name_1": "Mont-Royal",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "968",
    "langue": "français",
    "secteur": "public",
    "rang": "69",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "9.7",
    "ehdaa_2024": "19.2",
    "rang_2024": "69/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "75.9",
    "lens_2019": "75.5",
    "lens_2022": "71.9",
    "lens_2023": "72.8",
    "lens_2024": "70.9",
    "lens_trend": "998855",
    "lsec_2018": "84.9",
    "lsec_2019": "79.1",
    "lsec_2022": "86.8",
    "lsec_2023": "85.7",
    "lsec_2024": "84.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.3",
    "scie_2019": "82.3",
    "scie_2022": "82.1",
    "scie_2023": "84.7",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "84.3",
    "math_2019": "85.5",
    "math_2022": "79.5",
    "math_2023": "81.0",
    "math_2024": "83.6",
    "math_trend": "—",
    "echec_2018": "4.9",
    "echec_2019": "4.1",
    "echec_2022": "9.7",
    "echec_2023": "9.8",
    "echec_2024": "10.3",
    "echec_trend": "998855",
    "sures_2018": "0.3",
    "sures_2019": "1.6",
    "sures_2022": "2.5",
    "sures_2023": "1.2",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.3",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 0.7",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.8",
    "ecart_sexes_math_2019": "F 2.2",
    "ecart_sexes_math_2022": "F 7.1",
    "ecart_sexes_math_2023": "F 4.4",
    "ecart_sexes_math_2024": "F 3.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "7.6",
    "prog_2019": "2.2",
    "prog_2022": "6.6",
    "prog_2023": "7.6",
    "prog_2024": "6.7",
    "prog_trend": "—",
    "cote_2018": "8.6",
    "cote_2019": "8.6",
    "cote_2022": "8.2",
    "cote_2023": "7.8",
    "cote_2024": "7.9",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Mont-Royal",
    "nom_court": "École Mont-Royal",
    "adresse": "50, avenue Montgomery",
    "municipalite": "Mont-Royal",
    "code_postal": "H3R 2B3",
    "lat": 45.51338,
    "lng": -73.63807
  },
  {
    "_id": "110",
    "school_code": "763040",
    "school_name_1": "Paul-Gérin-Lajoie-d'Outremont",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1045",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "11.8",
    "ehdaa_2024": "23.7",
    "rang_2024": "310/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "71.2",
    "lens_2019": "68.1",
    "lens_2022": "64.6",
    "lens_2023": "68.0",
    "lens_2024": "64.0",
    "lens_trend": "—",
    "lsec_2018": "83.4",
    "lsec_2019": "84.4",
    "lsec_2022": "87.4",
    "lsec_2023": "86.5",
    "lsec_2024": "84.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.8",
    "scie_2019": "71.7",
    "scie_2022": "70.1",
    "scie_2023": "72.6",
    "scie_2024": "68.6",
    "scie_trend": "—",
    "math_2018": "77.3",
    "math_2019": "78.9",
    "math_2022": "82.0",
    "math_2023": "79.8",
    "math_2024": "74.5",
    "math_trend": "—",
    "echec_2018": "13.2",
    "echec_2019": "11.8",
    "echec_2022": "16.9",
    "echec_2023": "13.3",
    "echec_2024": "21.1",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "0.8",
    "sures_2022": "2.6",
    "sures_2023": "3.0",
    "sures_2024": "3.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "M 0.1",
    "ecart_sexes_lens_2019": "M 2.3",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 0.7",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.8",
    "ecart_sexes_math_2019": "F 1.9",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "F 0.5",
    "ecart_sexes_math_2024": "F 5.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "42.4",
    "prog_2019": "29.3",
    "prog_2022": "21.0",
    "prog_2023": "28.8",
    "prog_2024": "36.7",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.6",
    "cote_2022": "6.8",
    "cote_2023": "6.6",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Paul-Gérin-Lajoie-d'Outremont",
    "nom_court": "École Paul-Gérin-Lajoie-d'Outremont",
    "adresse": "475, avenue Bloomfield",
    "municipalite": "Montréal",
    "code_postal": "H2V 3R9",
    "lat": 45.51978,
    "lng": -73.60547
  },
  {
    "_id": "111",
    "school_code": "763041",
    "school_name_1": "Saint-Laurent",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "2094",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "28.8",
    "ehdaa_2024": "24.8",
    "rang_2024": "335/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "66.9",
    "lens_2019": "64.9",
    "lens_2022": "63.6",
    "lens_2023": "63.2",
    "lens_2024": "58.4",
    "lens_trend": "—",
    "lsec_2018": "90.8",
    "lsec_2019": "83.9",
    "lsec_2022": "83.7",
    "lsec_2023": "84.4",
    "lsec_2024": "82.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.4",
    "scie_2019": "66.0",
    "scie_2022": "68.2",
    "scie_2023": "70.4",
    "scie_2024": "67.0",
    "scie_trend": "—",
    "math_2018": "69.3",
    "math_2019": "72.4",
    "math_2022": "73.3",
    "math_2023": "76.0",
    "math_2024": "81.4",
    "math_trend": "112233",
    "echec_2018": "20.9",
    "echec_2019": "21.3",
    "echec_2022": "23.3",
    "echec_2023": "19.9",
    "echec_2024": "23.8",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "1.5",
    "sures_2022": "2.8",
    "sures_2023": "1.4",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.1",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.0",
    "ecart_sexes_math_2019": "M 3.4",
    "ecart_sexes_math_2022": "F 0.3",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "F 0.1",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "44.8",
    "prog_2019": "37.7",
    "prog_2022": "27.3",
    "prog_2023": "38.5",
    "prog_2024": "35.6",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.1",
    "cote_2022": "5.8",
    "cote_2023": "5.6",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Laurent",
    "nom_court": "École Saint-Laurent",
    "adresse": "2395, boulevard Thimens",
    "municipalite": "Montréal",
    "code_postal": "H4R 1T4",
    "lat": 45.50809,
    "lng": -73.68527
  },
  {
    "_id": "112",
    "school_code": "763042",
    "school_name_1": "Pierre-Laporte",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1448",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "10.6",
    "ehdaa_2024": "19.2",
    "rang_2024": "217/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "70.9",
    "lens_2019": "75.1",
    "lens_2022": "60.7",
    "lens_2023": "66.1",
    "lens_2024": "65.3",
    "lens_trend": "—",
    "lsec_2018": "84.8",
    "lsec_2019": "82.6",
    "lsec_2022": "77.3",
    "lsec_2023": "80.5",
    "lsec_2024": "77.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.2",
    "scie_2019": "84.5",
    "scie_2022": "70.1",
    "scie_2023": "79.2",
    "scie_2024": "75.5",
    "scie_trend": "—",
    "math_2018": "74.1",
    "math_2019": "81.4",
    "math_2022": "63.1",
    "math_2023": "77.9",
    "math_2024": "79.2",
    "math_trend": "—",
    "echec_2018": "10.3",
    "echec_2019": "4.4",
    "echec_2022": "29.0",
    "echec_2023": "14.3",
    "echec_2024": "17.0",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.0",
    "sures_2022": "8.6",
    "sures_2023": "1.4",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 1.6",
    "ecart_sexes_lens_2022": "F 5.5",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 0.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.5",
    "ecart_sexes_math_2019": "F 4.1",
    "ecart_sexes_math_2022": "F 5.7",
    "ecart_sexes_math_2023": "F 0.4",
    "ecart_sexes_math_2024": "F 6.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.9",
    "prog_2019": "29.7",
    "prog_2022": "13.2",
    "prog_2023": "23.3",
    "prog_2024": "24.0",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "8.1",
    "cote_2022": "4.3",
    "cote_2023": "6.4",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Pierre-Laporte",
    "nom_court": "École Pierre-Laporte",
    "adresse": "1101, chemin Rockland",
    "municipalite": "Mont-Royal",
    "code_postal": "H3P 2X8",
    "lat": 45.52348,
    "lng": -73.63726
  },
  {
    "_id": "113",
    "school_code": "763136",
    "school_name_1": "Collège Saint-Louis",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "950",
    "langue": "français",
    "secteur": "public",
    "rang": "1",
    "rang_5_ans": "1",
    "index": "0.1",
    "en_retard_2024": "2.2",
    "ehdaa_2024": "3.4",
    "rang_2024": "1/470",
    "rang_2019_2024": "1/432",
    "lens_2018": "78.7",
    "lens_2019": "80.9",
    "lens_2022": "78.1",
    "lens_2023": "80.8",
    "lens_2024": "79.4",
    "lens_trend": "112233",
    "lsec_2018": "89.4",
    "lsec_2019": "91.6",
    "lsec_2022": "90.3",
    "lsec_2023": "89.0",
    "lsec_2024": "89.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.2",
    "scie_2019": "86.7",
    "scie_2022": "88.5",
    "scie_2023": "91.9",
    "scie_2024": "90.4",
    "scie_trend": "112233",
    "math_2018": "88.2",
    "math_2019": "91.7",
    "math_2022": "93.8",
    "math_2023": "94.7",
    "math_2024": "93.9",
    "math_trend": "112233",
    "echec_2018": "1.8",
    "echec_2019": "0.6",
    "echec_2022": "1.6",
    "echec_2023": "0.9",
    "echec_2024": "1.1",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.5",
    "sures_2022": "1.0",
    "sures_2023": "0.8",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 1.2",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 6.2",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.1",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "F 0.5",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "F 3.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.5",
    "prog_2019": "0.0",
    "prog_2022": "1.1",
    "prog_2023": "0.5",
    "prog_2024": "0.5",
    "prog_trend": "—",
    "cote_2018": "9.8",
    "cote_2019": "10.0",
    "cote_2022": "10.0",
    "cote_2023": "10.0",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Louis",
    "nom_court": "Collège Saint-Louis",
    "adresse": "275, 36e Avenue",
    "municipalite": "Montréal",
    "code_postal": "H8T 2A4",
    "lat": 45.43639,
    "lng": -73.6977
  },
  {
    "_id": "114",
    "school_code": "763138",
    "school_name_1": "Cavelier-De LaSalle",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1830",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "22.2",
    "ehdaa_2024": "31.6",
    "rang_2024": "310/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "68.1",
    "lens_2019": "65.7",
    "lens_2022": "57.6",
    "lens_2023": "60.6",
    "lens_2024": "62.9",
    "lens_trend": "—",
    "lsec_2018": "76.6",
    "lsec_2019": "74.7",
    "lsec_2022": "82.1",
    "lsec_2023": "78.8",
    "lsec_2024": "83.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.0",
    "scie_2019": "69.9",
    "scie_2022": "61.7",
    "scie_2023": "67.2",
    "scie_2024": "67.0",
    "scie_trend": "—",
    "math_2018": "70.7",
    "math_2019": "71.0",
    "math_2022": "70.5",
    "math_2023": "75.2",
    "math_2024": "77.8",
    "math_trend": "—",
    "echec_2018": "18.3",
    "echec_2019": "21.0",
    "echec_2022": "32.5",
    "echec_2023": "26.3",
    "echec_2024": "22.3",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "1.1",
    "sures_2022": "7.2",
    "sures_2023": "3.4",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 1.0",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 0.9",
    "ecart_sexes_lens_2024": "M 1.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.0",
    "ecart_sexes_math_2019": "M 2.6",
    "ecart_sexes_math_2022": "M 0.5",
    "ecart_sexes_math_2023": "M 4.6",
    "ecart_sexes_math_2024": "M 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.7",
    "prog_2019": "46.2",
    "prog_2022": "26.4",
    "prog_2023": "37.4",
    "prog_2024": "45.7",
    "prog_trend": "—",
    "cote_2018": "4.9",
    "cote_2019": "4.4",
    "cote_2022": "4.3",
    "cote_2023": "4.3",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Cavelier-De LaSalle",
    "nom_court": "École Cavelier-De LaSalle",
    "adresse": "9199, rue Centrale",
    "municipalite": "Montréal",
    "code_postal": "H8R 2J9",
    "lat": 45.41802,
    "lng": -73.6405
  },
  {
    "_id": "115",
    "school_code": "763139",
    "school_name_1": "Dalbé-Viau",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1055",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "20.4",
    "ehdaa_2024": "39.1",
    "rang_2024": "390/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "66.5",
    "lens_2019": "66.3",
    "lens_2022": "56.9",
    "lens_2023": "58.8",
    "lens_2024": "59.5",
    "lens_trend": "998855",
    "lsec_2018": "86.1",
    "lsec_2019": "87.7",
    "lsec_2022": "89.3",
    "lsec_2023": "88.7",
    "lsec_2024": "88.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.6",
    "scie_2019": "65.3",
    "scie_2022": "64.3",
    "scie_2023": "67.3",
    "scie_2024": "65.1",
    "scie_trend": "—",
    "math_2018": "73.6",
    "math_2019": "73.3",
    "math_2022": "67.7",
    "math_2023": "64.5",
    "math_2024": "67.1",
    "math_trend": "998855",
    "echec_2018": "18.4",
    "echec_2019": "20.6",
    "echec_2022": "31.1",
    "echec_2023": "30.0",
    "echec_2024": "28.4",
    "echec_trend": "998855",
    "sures_2018": "0.5",
    "sures_2019": "2.0",
    "sures_2022": "5.7",
    "sures_2023": "3.5",
    "sures_2024": "3.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 4.6",
    "ecart_sexes_lens_2022": "F 3.6",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.9",
    "ecart_sexes_math_2019": "F 7.3",
    "ecart_sexes_math_2022": "M 12.8",
    "ecart_sexes_math_2023": "F 8.1",
    "ecart_sexes_math_2024": "F 3.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.6",
    "prog_2019": "30.1",
    "prog_2022": "28.2",
    "prog_2023": "40.0",
    "prog_2024": "50.4",
    "prog_trend": "998855",
    "cote_2018": "5.9",
    "cote_2019": "5.7",
    "cote_2022": "4.7",
    "cote_2023": "4.1",
    "cote_2024": "4.4",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Dalbé-Viau",
    "nom_court": "École Dalbé-Viau",
    "adresse": "740, rue Esther-Blondin",
    "municipalite": "Montréal",
    "code_postal": "H8S 4C4",
    "lat": 45.44306,
    "lng": -73.67927
  },
  {
    "_id": "116",
    "school_code": "763142",
    "school_name_1": "Monseigneur-Richard",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1487",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "22.7",
    "ehdaa_2024": "35.3",
    "rang_2024": "137/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "69.0",
    "lens_2019": "69.5",
    "lens_2022": "66.7",
    "lens_2023": "67.7",
    "lens_2024": "66.8",
    "lens_trend": "—",
    "lsec_2018": "86.1",
    "lsec_2019": "86.5",
    "lsec_2022": "85.3",
    "lsec_2023": "83.3",
    "lsec_2024": "84.6",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.4",
    "scie_2019": "65.2",
    "scie_2022": "69.6",
    "scie_2023": "71.7",
    "scie_2024": "67.9",
    "scie_trend": "—",
    "math_2018": "73.5",
    "math_2019": "73.0",
    "math_2022": "77.6",
    "math_2023": "79.2",
    "math_2024": "84.7",
    "math_trend": "112233",
    "echec_2018": "19.7",
    "echec_2019": "18.9",
    "echec_2022": "16.8",
    "echec_2023": "13.1",
    "echec_2024": "15.7",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "2.4",
    "sures_2022": "3.0",
    "sures_2023": "1.0",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.4",
    "ecart_sexes_lens_2019": "M 0.2",
    "ecart_sexes_lens_2022": "F 1.0",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 0.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.9",
    "ecart_sexes_math_2019": "M 2.7",
    "ecart_sexes_math_2022": "F 1.0",
    "ecart_sexes_math_2023": "M 3.0",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "44.3",
    "prog_2019": "37.5",
    "prog_2022": "16.7",
    "prog_2023": "28.7",
    "prog_2024": "30.3",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "5.9",
    "cote_2022": "7.2",
    "cote_2023": "6.6",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Monseigneur-Richard",
    "nom_court": "École Monseigneur-Richard",
    "adresse": "3000, boulevard Gaétan-Laberge",
    "municipalite": "Montréal",
    "code_postal": "H4G 3C1",
    "lat": 45.47014,
    "lng": -73.56037
  },
  {
    "_id": "117",
    "school_code": "763236",
    "school_name_1": "des Sources",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1541",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "11.7",
    "ehdaa_2024": "35",
    "rang_2024": "277/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "66.9",
    "lens_2019": "68.5",
    "lens_2022": "62.7",
    "lens_2023": "62.1",
    "lens_2024": "64.0",
    "lens_trend": "—",
    "lsec_2018": "82.9",
    "lsec_2019": "85.7",
    "lsec_2022": "80.7",
    "lsec_2023": "85.8",
    "lsec_2024": "81.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.5",
    "scie_2019": "73.1",
    "scie_2022": "69.2",
    "scie_2023": "71.3",
    "scie_2024": "72.5",
    "scie_trend": "—",
    "math_2018": "77.8",
    "math_2019": "78.0",
    "math_2022": "79.0",
    "math_2023": "71.7",
    "math_2024": "75.9",
    "math_trend": "998855",
    "echec_2018": "17.8",
    "echec_2019": "13.6",
    "echec_2022": "20.7",
    "echec_2023": "23.1",
    "echec_2024": "22.0",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "1.3",
    "sures_2022": "5.7",
    "sures_2023": "3.2",
    "sures_2024": "3.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.5",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 3.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.4",
    "ecart_sexes_math_2019": "M 0.1",
    "ecart_sexes_math_2022": "M 0.4",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.9",
    "prog_2019": "25.7",
    "prog_2022": "16.3",
    "prog_2023": "22.3",
    "prog_2024": "27.2",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "6.6",
    "cote_2022": "5.9",
    "cote_2023": "5.5",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École des Sources",
    "nom_court": "École des Sources",
    "adresse": "2900, chemin Lake",
    "municipalite": "Dollard-des-Ormeaux",
    "code_postal": "H9B 2P1",
    "lat": 45.49031,
    "lng": -73.8122
  },
  {
    "_id": "118",
    "school_code": "763240",
    "school_name_1": "Félix-Leclerc",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1271",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "114",
    "index": "0.1",
    "en_retard_2024": "22.3",
    "ehdaa_2024": "21",
    "rang_2024": "156/470",
    "rang_2019_2024": "114/432",
    "lens_2018": "66.0",
    "lens_2019": "68.9",
    "lens_2022": "63.2",
    "lens_2023": "65.4",
    "lens_2024": "67.1",
    "lens_trend": "—",
    "lsec_2018": "85.2",
    "lsec_2019": "85.6",
    "lsec_2022": "85.4",
    "lsec_2023": "81.2",
    "lsec_2024": "75.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.8",
    "scie_2019": "74.9",
    "scie_2022": "78.4",
    "scie_2023": "83.3",
    "scie_2024": "75.7",
    "scie_trend": "—",
    "math_2018": "81.7",
    "math_2019": "82.2",
    "math_2022": "84.0",
    "math_2023": "82.5",
    "math_2024": "81.8",
    "math_trend": "—",
    "echec_2018": "9.9",
    "echec_2019": "10.0",
    "echec_2022": "14.9",
    "echec_2023": "11.9",
    "echec_2024": "13.9",
    "echec_trend": "998855",
    "sures_2018": "0.6",
    "sures_2019": "0.3",
    "sures_2022": "1.7",
    "sures_2023": "0.9",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 2.8",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 1.8",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.9",
    "ecart_sexes_math_2019": "F 5.4",
    "ecart_sexes_math_2022": "M 2.2",
    "ecart_sexes_math_2023": "F 0.5",
    "ecart_sexes_math_2024": "M 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.1",
    "prog_2019": "29.2",
    "prog_2022": "23.0",
    "prog_2023": "21.4",
    "prog_2024": "24.7",
    "prog_trend": "—",
    "cote_2018": "7.0",
    "cote_2019": "7.1",
    "cote_2022": "7.2",
    "cote_2023": "7.2",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Félix-Leclerc",
    "nom_court": "École Félix-Leclerc",
    "adresse": "311, rue Inglewood",
    "municipalite": "Pointe-Claire",
    "code_postal": "H9R 2Z8",
    "lat": 45.44856,
    "lng": -73.82716
  },
  {
    "_id": "119",
    "school_code": "763241",
    "school_name_1": "Dorval-Jean XXIII",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "1309",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "16",
    "ehdaa_2024": "30.6",
    "rang_2024": "238/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "66.6",
    "lens_2019": "68.2",
    "lens_2022": "62.2",
    "lens_2023": "63.3",
    "lens_2024": "65.8",
    "lens_trend": "—",
    "lsec_2018": "78.8",
    "lsec_2019": "82.6",
    "lsec_2022": "83.6",
    "lsec_2023": "81.2",
    "lsec_2024": "83.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.7",
    "scie_2019": "72.1",
    "scie_2022": "67.8",
    "scie_2023": "74.9",
    "scie_2024": "73.1",
    "scie_trend": "—",
    "math_2018": "75.1",
    "math_2019": "75.5",
    "math_2022": "76.3",
    "math_2023": "74.1",
    "math_2024": "72.9",
    "math_trend": "998855",
    "echec_2018": "14.1",
    "echec_2019": "15.1",
    "echec_2022": "21.1",
    "echec_2023": "19.3",
    "echec_2024": "17.4",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "0.4",
    "sures_2022": "3.7",
    "sures_2023": "1.7",
    "sures_2024": "2.9",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "M 1.3",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 1.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.0",
    "ecart_sexes_math_2019": "F 5.4",
    "ecart_sexes_math_2022": "M 2.1",
    "ecart_sexes_math_2023": "F 3.9",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.4",
    "prog_2019": "35.2",
    "prog_2022": "21.2",
    "prog_2023": "28.5",
    "prog_2024": "37.0",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "6.0",
    "cote_2022": "6.1",
    "cote_2023": "5.5",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Dorval-Jean XXIII",
    "nom_court": "École Dorval-Jean XXIII",
    "adresse": "1301, avenue Dawson",
    "municipalite": "Dorval",
    "code_postal": "H9S 1Y3",
    "lat": 45.44348,
    "lng": -73.75709
  },
  {
    "_id": "120",
    "school_code": "763243",
    "school_name_1": "Saint-Georges",
    "admin_body_number": "763000",
    "admin_body_name": "Centre de services scolaire Marguerite-Bourgeoys",
    "area_name": "Montréal ",
    "étudiants": "776",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "11.8",
    "ehdaa_2024": "28.9",
    "rang_2024": "299/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "69.3",
    "lens_2019": "66.0",
    "lens_2022": "64.3",
    "lens_2023": "66.6",
    "lens_2024": "64.7",
    "lens_trend": "—",
    "lsec_2018": "76.3",
    "lsec_2019": "77.2",
    "lsec_2022": "76.0",
    "lsec_2023": "73.4",
    "lsec_2024": "76.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.8",
    "scie_2019": "73.9",
    "scie_2022": "75.2",
    "scie_2023": "76.2",
    "scie_2024": "70.4",
    "scie_trend": "—",
    "math_2018": "74.7",
    "math_2019": "77.8",
    "math_2022": "78.0",
    "math_2023": "76.9",
    "math_2024": "76.5",
    "math_trend": "—",
    "echec_2018": "17.4",
    "echec_2019": "15.4",
    "echec_2022": "19.3",
    "echec_2023": "19.2",
    "echec_2024": "20.5",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "1.9",
    "sures_2022": "2.0",
    "sures_2023": "3.0",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 4.6",
    "ecart_sexes_lens_2022": "F 4.2",
    "ecart_sexes_lens_2023": "F 5.4",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 1.6",
    "ecart_sexes_math_2019": "F 6.7",
    "ecart_sexes_math_2022": "F 1.6",
    "ecart_sexes_math_2023": "F 5.0",
    "ecart_sexes_math_2024": "F 4.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.0",
    "prog_2019": "17.3",
    "prog_2022": "8.3",
    "prog_2023": "22.0",
    "prog_2024": "18.3",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "5.8",
    "cote_2022": "6.3",
    "cote_2023": "5.5",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Georges",
    "nom_court": "École Saint-Georges",
    "adresse": "3, avenue Pearson",
    "municipalite": "Senneville",
    "code_postal": "H9X 3P7",
    "lat": 45.41335,
    "lng": -73.9517
  },
  {
    "_id": "121",
    "school_code": "771022",
    "school_name_1": "Nicolas-Gatineau",
    "admin_body_number": "771000",
    "admin_body_name": "Centre de services scolaire des Draveurs",
    "area_name": "Outaouais ",
    "étudiants": "3223",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "15.8",
    "ehdaa_2024": "36.4",
    "rang_2024": "229/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "65.5",
    "lens_2019": "68.6",
    "lens_2022": "63.0",
    "lens_2023": "63.8",
    "lens_2024": "64.7",
    "lens_trend": "—",
    "lsec_2018": "82.3",
    "lsec_2019": "79.4",
    "lsec_2022": "83.1",
    "lsec_2023": "79.9",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.0",
    "scie_2019": "67.3",
    "scie_2022": "66.8",
    "scie_2023": "68.9",
    "scie_2024": "69.5",
    "scie_trend": "—",
    "math_2018": "71.7",
    "math_2019": "74.1",
    "math_2022": "68.8",
    "math_2023": "71.8",
    "math_2024": "78.3",
    "math_trend": "—",
    "echec_2018": "20.0",
    "echec_2019": "18.1",
    "echec_2022": "24.4",
    "echec_2023": "22.7",
    "echec_2024": "18.7",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.3",
    "sures_2022": "1.9",
    "sures_2023": "1.5",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 5.2",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 2.6",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.4",
    "ecart_sexes_math_2019": "F 2.3",
    "ecart_sexes_math_2022": "M 1.8",
    "ecart_sexes_math_2023": "F 3.2",
    "ecart_sexes_math_2024": "F 0.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.9",
    "prog_2019": "36.7",
    "prog_2022": "15.1",
    "prog_2023": "30.5",
    "prog_2024": "27.6",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "5.4",
    "cote_2022": "5.8",
    "cote_2023": "5.0",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Polyvalente Nicolas-Gatineau",
    "nom_court": "Polyvalente Nicolas-Gatineau",
    "adresse": "360, boulevard La Vérendrye Est",
    "municipalite": "Gatineau",
    "code_postal": "J8P 6K7",
    "lat": 45.49859,
    "lng": -75.64571
  },
  {
    "_id": "122",
    "school_code": "771033",
    "school_name_1": "de L'Érablière",
    "admin_body_number": "771000",
    "admin_body_name": "Centre de services scolaire des Draveurs",
    "area_name": "Outaouais ",
    "étudiants": "1239",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "13.1",
    "ehdaa_2024": "45",
    "rang_2024": "238/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "67.9",
    "lens_2019": "67.8",
    "lens_2022": "65.4",
    "lens_2023": "65.2",
    "lens_2024": "64.6",
    "lens_trend": "—",
    "lsec_2018": "78.1",
    "lsec_2019": "79.1",
    "lsec_2022": "79.3",
    "lsec_2023": "81.9",
    "lsec_2024": "80.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.1",
    "scie_2019": "64.2",
    "scie_2022": "72.6",
    "scie_2023": "71.5",
    "scie_2024": "68.8",
    "scie_trend": "—",
    "math_2018": "75.3",
    "math_2019": "76.0",
    "math_2022": "78.3",
    "math_2023": "74.1",
    "math_2024": "79.6",
    "math_trend": "—",
    "echec_2018": "20.2",
    "echec_2019": "17.3",
    "echec_2022": "14.9",
    "echec_2023": "19.5",
    "echec_2024": "18.9",
    "echec_trend": "—",
    "sures_2018": "2.4",
    "sures_2019": "2.9",
    "sures_2022": "3.0",
    "sures_2023": "3.5",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 0.5",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 4.5",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.3",
    "ecart_sexes_math_2019": "F 2.3",
    "ecart_sexes_math_2022": "F 0.5",
    "ecart_sexes_math_2023": "M 2.3",
    "ecart_sexes_math_2024": "M 1.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.6",
    "prog_2019": "22.3",
    "prog_2022": "13.0",
    "prog_2023": "18.7",
    "prog_2024": "20.4",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "5.3",
    "cote_2022": "6.8",
    "cote_2023": "5.7",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Polyvalente de l'Érablière",
    "nom_court": "Polyvalente de l'Érablière",
    "adresse": "500, rue de Cannes",
    "municipalite": "Gatineau",
    "code_postal": "J8V 1J6",
    "lat": 45.49368,
    "lng": -75.73971
  },
  {
    "_id": "123",
    "school_code": "771035",
    "school_name_1": "Le Carrefour",
    "admin_body_number": "771000",
    "admin_body_name": "Centre de services scolaire des Draveurs",
    "area_name": "Outaouais ",
    "étudiants": "1763",
    "langue": "français",
    "secteur": "public",
    "rang": "126",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "39.3",
    "rang_2024": "126/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "71.0",
    "lens_2019": "70.7",
    "lens_2022": "70.4",
    "lens_2023": "71.5",
    "lens_2024": "70.1",
    "lens_trend": "—",
    "lsec_2018": "77.7",
    "lsec_2019": "79.3",
    "lsec_2022": "84.5",
    "lsec_2023": "83.6",
    "lsec_2024": "82.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "69.6",
    "scie_2022": "69.9",
    "scie_2023": "78.0",
    "scie_2024": "74.0",
    "scie_trend": "—",
    "math_2018": "72.4",
    "math_2019": "75.4",
    "math_2022": "78.8",
    "math_2023": "78.5",
    "math_2024": "82.6",
    "math_trend": "112233",
    "echec_2018": "15.3",
    "echec_2019": "14.9",
    "echec_2022": "16.2",
    "echec_2023": "11.7",
    "echec_2024": "13.5",
    "echec_trend": "112233",
    "sures_2018": "0.0",
    "sures_2019": "0.9",
    "sures_2022": "1.8",
    "sures_2023": "0.0",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 6.0",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 5.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.4",
    "ecart_sexes_math_2019": "F 5.6",
    "ecart_sexes_math_2022": "F 6.3",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "F 0.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.6",
    "prog_2019": "30.1",
    "prog_2022": "55.2",
    "prog_2023": "15.5",
    "prog_2024": "27.5",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.7",
    "cote_2022": "5.7",
    "cote_2023": "7.1",
    "cote_2024": "6.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Le Carrefour",
    "nom_court": "Polyvalente Le Carrefour",
    "adresse": "50, chemin de la Savane",
    "municipalite": "Gatineau",
    "code_postal": "J8T 3N2",
    "lat": 45.47316,
    "lng": -75.69675
  },
  {
    "_id": "124",
    "school_code": "771038",
    "school_name_1": "du Versant",
    "admin_body_number": "771000",
    "admin_body_name": "Centre de services scolaire des Draveurs",
    "area_name": "Outaouais ",
    "étudiants": "1163",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "24.1",
    "ehdaa_2024": "33.8",
    "rang_2024": "156/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "70.5",
    "lens_2019": "72.0",
    "lens_2022": "66.7",
    "lens_2023": "67.6",
    "lens_2024": "68.7",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "77.6",
    "lsec_2022": "78.6",
    "lsec_2023": "76.5",
    "lsec_2024": "77.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.9",
    "scie_2019": "70.6",
    "scie_2022": "69.9",
    "scie_2023": "76.6",
    "scie_2024": "73.2",
    "scie_trend": "112233",
    "math_2018": "68.9",
    "math_2019": "73.2",
    "math_2022": "74.6",
    "math_2023": "73.3",
    "math_2024": "82.3",
    "math_trend": "112233",
    "echec_2018": "16.8",
    "echec_2019": "14.2",
    "echec_2022": "17.9",
    "echec_2023": "15.5",
    "echec_2024": "11.5",
    "echec_trend": "112233",
    "sures_2018": "0.6",
    "sures_2019": "0.8",
    "sures_2022": "2.8",
    "sures_2023": "2.0",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.6",
    "ecart_sexes_lens_2019": "F 6.8",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 2.2",
    "ecart_sexes_lens_2024": "F 6.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.3",
    "ecart_sexes_math_2019": "F 3.6",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.9",
    "prog_2019": "23.1",
    "prog_2022": "11.7",
    "prog_2023": "17.8",
    "prog_2024": "28.8",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.9",
    "cote_2022": "6.5",
    "cote_2023": "6.2",
    "cote_2024": "6.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire du Versant",
    "nom_court": "École secondaire du Versant",
    "adresse": "808, boulevard de la Cité",
    "municipalite": "Gatineau",
    "code_postal": "J8R 3S8",
    "lat": 45.49391,
    "lng": -75.68054
  },
  {
    "_id": "125",
    "school_code": "772040",
    "school_name_1": "Nouvelle-Ère",
    "admin_body_number": "772000",
    "admin_body_name": "Centre de services scolaire des Portages-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "787",
    "langue": "français",
    "secteur": "public",
    "rang": "447",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "25.7",
    "ehdaa_2024": "47.6",
    "rang_2024": "447/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "59.8",
    "lens_2024": "61.6",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "74.4",
    "lsec_2024": "75.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "67.1",
    "scie_2024": "64.3",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "67.1",
    "math_2024": "65.8",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "32.0",
    "echec_2024": "29.4",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "3.4",
    "sures_2024": "6.2",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "M 1.6",
    "ecart_sexes_lens_2024": "M 0.5",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 4.1",
    "ecart_sexes_math_2024": "M 6.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "32.2",
    "prog_2024": "37.4",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "3.6",
    "cote_2024": "3.2",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de la Nouvelle-Ère",
    "nom_court": "École secondaire de la Nouvelle-Ère",
    "adresse": "400 rue Fraser",
    "municipalite": "Gatineau",
    "code_postal": "J9J 4G1",
    "lat": 45.39812,
    "lng": -75.82575
  },
  {
    "_id": "126",
    "school_code": "772042",
    "school_name_1": "des Lacs",
    "admin_body_number": "772000",
    "admin_body_name": "Centre de services scolaire des Portages-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "225",
    "langue": "français",
    "secteur": "public",
    "rang": "86",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "24",
    "ehdaa_2024": "59.1",
    "rang_2024": "86/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "61.4",
    "lens_2019": "64.3",
    "lens_2022": "64.3",
    "lens_2023": "66.9",
    "lens_2024": "74.3",
    "lens_trend": "112233",
    "lsec_2018": "83.3",
    "lsec_2019": "81.6",
    "lsec_2022": "82.7",
    "lsec_2023": "88.2",
    "lsec_2024": "90.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.0",
    "scie_2019": "69.5",
    "scie_2022": "71.6",
    "scie_2023": "76.5",
    "scie_2024": "71.8",
    "scie_trend": "112233",
    "math_2018": "69.6",
    "math_2019": "69.3",
    "math_2022": "68.2",
    "math_2023": "70.3",
    "math_2024": "76.1",
    "math_trend": "112233",
    "echec_2018": "28.6",
    "echec_2019": "17.5",
    "echec_2022": "21.7",
    "echec_2023": "14.6",
    "echec_2024": "10.7",
    "echec_trend": "112233",
    "sures_2018": "2.8",
    "sures_2019": "0.8",
    "sures_2022": "5.8",
    "sures_2023": "3.0",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 5.7",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 1.5",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 9.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "38.3",
    "prog_2019": "28.9",
    "prog_2022": "24.3",
    "prog_2023": "45.9",
    "prog_2024": "17.9",
    "prog_trend": "—",
    "cote_2018": "3.7",
    "cote_2019": "5.8",
    "cote_2022": "6.0",
    "cote_2023": "6.2",
    "cote_2024": "7.7",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire des Lacs",
    "nom_court": "École secondaire des Lacs",
    "adresse": "32, chemin Passe-Partout",
    "municipalite": "La Pêche",
    "code_postal": "J0X 2W0",
    "lat": 45.64352,
    "lng": -76.03756
  },
  {
    "_id": "127",
    "school_code": "772044",
    "school_name_1": "Grande-Rivière",
    "admin_body_number": "772000",
    "admin_body_name": "Centre de services scolaire des Portages-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "1684",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "14",
    "ehdaa_2024": "43.2",
    "rang_2024": "149/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "66.8",
    "lens_2019": "66.4",
    "lens_2022": "66.9",
    "lens_2023": "66.5",
    "lens_2024": "63.8",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "79.3",
    "lsec_2022": "80.7",
    "lsec_2023": "79.0",
    "lsec_2024": "80.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.4",
    "scie_2019": "71.4",
    "scie_2022": "72.0",
    "scie_2023": "74.9",
    "scie_2024": "73.7",
    "scie_trend": "112233",
    "math_2018": "74.9",
    "math_2019": "78.5",
    "math_2022": "79.9",
    "math_2023": "80.3",
    "math_2024": "82.1",
    "math_trend": "—",
    "echec_2018": "16.7",
    "echec_2019": "17.0",
    "echec_2022": "16.2",
    "echec_2023": "15.5",
    "echec_2024": "17.2",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "2.0",
    "sures_2022": "2.5",
    "sures_2023": "1.9",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.5",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 0.8",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 3.8",
    "ecart_sexes_math_2019": "F 2.6",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "F 0.1",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "36.3",
    "prog_2019": "29.1",
    "prog_2022": "23.7",
    "prog_2023": "20.1",
    "prog_2024": "24.3",
    "prog_trend": "112233",
    "cote_2018": "5.1",
    "cote_2019": "5.8",
    "cote_2022": "6.6",
    "cote_2023": "6.5",
    "cote_2024": "6.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Grande-Rivière",
    "nom_court": "École secondaire Grande-Rivière",
    "adresse": "100, rue Broad",
    "municipalite": "Gatineau",
    "code_postal": "J9H 6A9",
    "lat": 45.40446,
    "lng": -75.84359
  },
  {
    "_id": "128",
    "school_code": "772046",
    "school_name_1": "Mont-Bleu",
    "admin_body_number": "772000",
    "admin_body_name": "Centre de services scolaire des Portages-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "1417",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "21.6",
    "ehdaa_2024": "50.7",
    "rang_2024": "199/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "69.4",
    "lens_2019": "68.7",
    "lens_2022": "66.5",
    "lens_2023": "69.9",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "74.8",
    "lsec_2019": "76.1",
    "lsec_2022": "75.7",
    "lsec_2023": "75.5",
    "lsec_2024": "75.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.2",
    "scie_2019": "72.1",
    "scie_2022": "69.6",
    "scie_2023": "73.7",
    "scie_2024": "70.9",
    "scie_trend": "—",
    "math_2018": "73.7",
    "math_2019": "74.5",
    "math_2022": "74.7",
    "math_2023": "75.9",
    "math_2024": "80.7",
    "math_trend": "—",
    "echec_2018": "16.5",
    "echec_2019": "14.7",
    "echec_2022": "17.3",
    "echec_2023": "14.9",
    "echec_2024": "13.5",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.1",
    "sures_2022": "1.4",
    "sures_2023": "0.0",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.3",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 4.0",
    "ecart_sexes_lens_2023": "F 3.6",
    "ecart_sexes_lens_2024": "F 1.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.1",
    "ecart_sexes_math_2019": "M 2.4",
    "ecart_sexes_math_2022": "F 2.8",
    "ecart_sexes_math_2023": "M 3.7",
    "ecart_sexes_math_2024": "F 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.4",
    "prog_2019": "36.3",
    "prog_2022": "21.2",
    "prog_2023": "29.6",
    "prog_2024": "27.7",
    "prog_trend": "112233",
    "cote_2018": "5.4",
    "cote_2019": "5.8",
    "cote_2022": "6.0",
    "cote_2023": "5.9",
    "cote_2024": "6.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Mont-Bleu",
    "nom_court": "École secondaire Mont-Bleu",
    "adresse": "389, boulevard de la Cité des Jeunes",
    "municipalite": "Gatineau",
    "code_postal": "J8Z 1W6",
    "lat": 45.46189,
    "lng": -75.77111
  },
  {
    "_id": "129",
    "school_code": "772048",
    "school_name_1": "de L'Île",
    "admin_body_number": "772000",
    "admin_body_name": "Centre de services scolaire des Portages-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "1239",
    "langue": "français",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "19.2",
    "ehdaa_2024": "41.2",
    "rang_2024": "252/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "72.4",
    "lens_2019": "72.6",
    "lens_2022": "68.4",
    "lens_2023": "68.7",
    "lens_2024": "66.3",
    "lens_trend": "998855",
    "lsec_2018": "78.5",
    "lsec_2019": "76.1",
    "lsec_2022": "78.1",
    "lsec_2023": "78.4",
    "lsec_2024": "76.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.8",
    "scie_2019": "69.8",
    "scie_2022": "72.0",
    "scie_2023": "73.6",
    "scie_2024": "75.1",
    "scie_trend": "—",
    "math_2018": "68.8",
    "math_2019": "69.6",
    "math_2022": "71.5",
    "math_2023": "69.8",
    "math_2024": "73.0",
    "math_trend": "—",
    "echec_2018": "15.4",
    "echec_2019": "17.7",
    "echec_2022": "20.0",
    "echec_2023": "17.0",
    "echec_2024": "19.1",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "2.1",
    "sures_2022": "3.2",
    "sures_2023": "3.1",
    "sures_2024": "4.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "M 1.0",
    "ecart_sexes_lens_2023": "F 5.5",
    "ecart_sexes_lens_2024": "F 0.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.8",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 2.7",
    "ecart_sexes_math_2023": "M 5.9",
    "ecart_sexes_math_2024": "M 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.2",
    "prog_2019": "29.8",
    "prog_2022": "21.6",
    "prog_2023": "30.9",
    "prog_2024": "26.0",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "5.4",
    "cote_2022": "6.1",
    "cote_2023": "5.3",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Île",
    "nom_court": "École secondaire de l'Île",
    "adresse": "255, rue Saint-Rédempteur",
    "municipalite": "Gatineau",
    "code_postal": "J8X 2T4",
    "lat": 45.43602,
    "lng": -75.72422
  },
  {
    "_id": "130",
    "school_code": "773010",
    "school_name_1": "Louis-Joseph-Papineau",
    "admin_body_number": "773000",
    "admin_body_name": "Centre de services scolaire au Coeur-des-Vallées",
    "area_name": "Outaouais ",
    "étudiants": "587",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "16.3",
    "ehdaa_2024": "36.8",
    "rang_2024": "238/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "68.0",
    "lens_2019": "70.8",
    "lens_2022": "62.5",
    "lens_2023": "67.8",
    "lens_2024": "66.0",
    "lens_trend": "—",
    "lsec_2018": "75.2",
    "lsec_2019": "84.1",
    "lsec_2022": "79.3",
    "lsec_2023": "84.1",
    "lsec_2024": "83.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.4",
    "scie_2019": "74.5",
    "scie_2022": "65.7",
    "scie_2023": "74.8",
    "scie_2024": "70.4",
    "scie_trend": "—",
    "math_2018": "65.2",
    "math_2019": "74.6",
    "math_2022": "60.8",
    "math_2023": "69.7",
    "math_2024": "77.4",
    "math_trend": "—",
    "echec_2018": "20.2",
    "echec_2019": "10.6",
    "echec_2022": "31.4",
    "echec_2023": "17.3",
    "echec_2024": "17.3",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "0.0",
    "sures_2022": "7.2",
    "sures_2023": "1.2",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "F 6.5",
    "ecart_sexes_lens_2023": "F 0.4",
    "ecart_sexes_lens_2024": "F 8.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 6.1",
    "ecart_sexes_math_2022": "F 11.6",
    "ecart_sexes_math_2023": "F 6.0",
    "ecart_sexes_math_2024": "F 2.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.7",
    "prog_2019": "51.3",
    "prog_2022": "43.4",
    "prog_2023": "41.6",
    "prog_2024": "33.2",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "6.4",
    "cote_2022": "3.4",
    "cote_2023": "5.8",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Louis-Joseph-Papineau",
    "nom_court": "École secondaire Louis-Joseph-Papineau",
    "adresse": "378, rue Papineau",
    "municipalite": "Papineauville",
    "code_postal": "J0V 1R0",
    "lat": 45.61726,
    "lng": -75.02731
  },
  {
    "_id": "131",
    "school_code": "773030",
    "school_name_1": "Hormisdas-Gamelin",
    "admin_body_number": "773000",
    "admin_body_name": "Centre de services scolaire au Coeur-des-Vallées",
    "area_name": "Outaouais ",
    "étudiants": "1651",
    "langue": "français",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "14.2",
    "ehdaa_2024": "42.1",
    "rang_2024": "252/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "69.3",
    "lens_2019": "70.9",
    "lens_2022": "66.7",
    "lens_2023": "67.3",
    "lens_2024": "64.5",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "77.4",
    "lsec_2022": "77.4",
    "lsec_2023": "80.2",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.7",
    "scie_2019": "70.9",
    "scie_2022": "70.2",
    "scie_2023": "71.7",
    "scie_2024": "67.4",
    "scie_trend": "—",
    "math_2018": "79.2",
    "math_2019": "77.0",
    "math_2022": "79.6",
    "math_2023": "78.2",
    "math_2024": "84.5",
    "math_trend": "—",
    "echec_2018": "13.0",
    "echec_2019": "12.0",
    "echec_2022": "15.5",
    "echec_2023": "14.7",
    "echec_2024": "17.8",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.3",
    "sures_2022": "0.4",
    "sures_2023": "0.3",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 2.7",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 4.8",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 6.9",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 0.6",
    "ecart_sexes_math_2024": "F 7.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.7",
    "prog_2019": "27.2",
    "prog_2022": "31.0",
    "prog_2023": "34.7",
    "prog_2024": "29.6",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "6.3",
    "cote_2022": "6.3",
    "cote_2023": "6.1",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École  secondaire Hormisdas-Gamelin",
    "nom_court": "École secondaire Hormisdas-Gamelin",
    "adresse": "580, rue Maclaren Est",
    "municipalite": "Gatineau",
    "code_postal": "J8L 2W1",
    "lat": 45.58805,
    "lng": -75.39956
  },
  {
    "_id": "132",
    "school_code": "774001",
    "school_name_1": "Sieur-de-Coulonge",
    "admin_body_number": "774000",
    "admin_body_name": "Centre de services scolaire des Hauts-Bois-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "288",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "21.4",
    "ehdaa_2024": "50",
    "rang_2024": "367/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "56.4",
    "lens_2019": "68.8",
    "lens_2022": "56.9",
    "lens_2023": "62.0",
    "lens_2024": "61.6",
    "lens_trend": "—",
    "lsec_2018": "83.9",
    "lsec_2019": "94.4",
    "lsec_2022": "87.1",
    "lsec_2023": "92.5",
    "lsec_2024": "90.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.8",
    "scie_2019": "76.6",
    "scie_2022": "70.4",
    "scie_2023": "71.7",
    "scie_2024": "66.6",
    "scie_trend": "—",
    "math_2018": "74.1",
    "math_2019": "71.7",
    "math_2022": "74.4",
    "math_2023": "60.1",
    "math_2024": "69.5",
    "math_trend": "—",
    "echec_2018": "24.4",
    "echec_2019": "9.9",
    "echec_2022": "28.6",
    "echec_2023": "29.4",
    "echec_2024": "25.6",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "0.8",
    "sures_2022": "6.6",
    "sures_2023": "3.2",
    "sures_2024": "3.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.0",
    "ecart_sexes_math_2019": "F 18.2",
    "ecart_sexes_math_2022": "M 5.4",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "F 7.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "65.2",
    "prog_2019": "31.2",
    "prog_2022": "28.2",
    "prog_2023": "46.7",
    "prog_2024": "35.1",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "6.8",
    "cote_2022": "5.1",
    "cote_2023": "4.1",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Sieur-de-Coulonge",
    "nom_court": "École secondaire Sieur-de-Coulonge",
    "adresse": "250, chemin de la Chute",
    "municipalite": "Mansfield-et-Pontefract",
    "code_postal": "J0X 1R0",
    "lat": 45.73519,
    "lng": -76.60176
  },
  {
    "_id": "133",
    "school_code": "774003",
    "school_name_1": "du Coeur-de-la-Gatineau",
    "admin_body_number": "774000",
    "admin_body_name": "Centre de services scolaire des Hauts-Bois-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "171",
    "langue": "français",
    "secteur": "public",
    "rang": "463",
    "rang_5_ans": "427",
    "index": "0.1",
    "en_retard_2024": "23.5",
    "ehdaa_2024": "53.2",
    "rang_2024": "463/470",
    "rang_2019_2024": "427/432",
    "lens_2018": "62.9",
    "lens_2019": "58.5",
    "lens_2022": "53.2",
    "lens_2023": "60.3",
    "lens_2024": "58.5",
    "lens_trend": "—",
    "lsec_2018": "67.7",
    "lsec_2019": "76.7",
    "lsec_2022": "72.6",
    "lsec_2023": "67.5",
    "lsec_2024": "67.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.0",
    "scie_2019": "62.4",
    "scie_2022": "68.3",
    "scie_2023": "75.5",
    "scie_2024": "71.5",
    "scie_trend": "—",
    "math_2018": "67.0",
    "math_2019": "64.8",
    "math_2022": "58.3",
    "math_2023": "70.5",
    "math_2024": "62.0",
    "math_trend": "—",
    "echec_2018": "22.9",
    "echec_2019": "29.5",
    "echec_2022": "43.3",
    "echec_2023": "23.4",
    "echec_2024": "33.8",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "3.0",
    "sures_2022": "8.2",
    "sures_2023": "3.2",
    "sures_2024": "7.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 2.5",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 8.4",
    "ecart_sexes_math_2022": "F 6.7",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "49.9",
    "prog_2019": "33.2",
    "prog_2022": "29.8",
    "prog_2023": "49.8",
    "prog_2024": "36.4",
    "prog_trend": "—",
    "cote_2018": "3.4",
    "cote_2019": "3.0",
    "cote_2022": "2.2",
    "cote_2023": "2.7",
    "cote_2024": "1.7",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École du Coeur-de-la-Gatineau",
    "nom_court": "École du Coeur-de-la-Gatineau",
    "adresse": "11, chemin de Blue Sea",
    "municipalite": "Gracefield",
    "code_postal": "J0X 1W0",
    "lat": 46.09138,
    "lng": -76.05619
  },
  {
    "_id": "134",
    "school_code": "774005",
    "school_name_1": "La Cité étudiante",
    "admin_body_number": "774000",
    "admin_body_name": "Centre de services scolaire des Hauts-Bois-de-l'Outaouais",
    "area_name": "Outaouais ",
    "étudiants": "432",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "24.3",
    "ehdaa_2024": "45.8",
    "rang_2024": "238/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "66.1",
    "lens_2019": "66.1",
    "lens_2022": "67.8",
    "lens_2023": "65.6",
    "lens_2024": "61.5",
    "lens_trend": "—",
    "lsec_2018": "71.0",
    "lsec_2019": "69.9",
    "lsec_2022": "77.5",
    "lsec_2023": "82.2",
    "lsec_2024": "84.7",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.6",
    "scie_2019": "70.1",
    "scie_2022": "65.4",
    "scie_2023": "68.0",
    "scie_2024": "70.2",
    "scie_trend": "—",
    "math_2018": "64.9",
    "math_2019": "73.0",
    "math_2022": "69.3",
    "math_2023": "64.0",
    "math_2024": "73.7",
    "math_trend": "—",
    "echec_2018": "28.1",
    "echec_2019": "19.8",
    "echec_2022": "22.3",
    "echec_2023": "27.7",
    "echec_2024": "19.0",
    "echec_trend": "—",
    "sures_2018": "6.6",
    "sures_2019": "4.6",
    "sures_2022": "4.2",
    "sures_2023": "5.5",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.4",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 10.0",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "M 0.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.4",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "F 8.2",
    "ecart_sexes_math_2023": "M 2.5",
    "ecart_sexes_math_2024": "M 4.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "44.0",
    "prog_2019": "36.9",
    "prog_2022": "24.9",
    "prog_2023": "34.3",
    "prog_2024": "35.8",
    "prog_trend": "—",
    "cote_2018": "2.7",
    "cote_2019": "4.4",
    "cote_2022": "5.2",
    "cote_2023": "4.5",
    "cote_2024": "5.8",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École de la Cité étudiante de la Haute-Gatineau",
    "nom_court": "Cité étudiante de la Haute-Gatineau",
    "adresse": "211, rue Henri-Bourassa",
    "municipalite": "Maniwaki",
    "code_postal": "J9E 1E4",
    "lat": 46.38838,
    "lng": -75.97985
  },
  {
    "_id": "135",
    "school_code": "781049",
    "school_name_1": "Marcel-Raymond",
    "admin_body_number": "781000",
    "admin_body_name": "Centre de services scolaire du Lac-Témiscamingue",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "364",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "24.2",
    "rang_2024": "335/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "71.3",
    "lens_2019": "73.3",
    "lens_2022": "69.5",
    "lens_2023": "70.8",
    "lens_2024": "64.4",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "83.2",
    "lsec_2022": "82.3",
    "lsec_2023": "83.0",
    "lsec_2024": "81.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.4",
    "scie_2019": "75.3",
    "scie_2022": "76.0",
    "scie_2023": "74.4",
    "scie_2024": "68.2",
    "scie_trend": "998855",
    "math_2018": "77.2",
    "math_2019": "71.9",
    "math_2022": "70.3",
    "math_2023": "70.1",
    "math_2024": "74.5",
    "math_trend": "—",
    "echec_2018": "9.4",
    "echec_2019": "11.4",
    "echec_2022": "12.7",
    "echec_2023": "15.6",
    "echec_2024": "23.2",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.8",
    "sures_2022": "2.3",
    "sures_2023": "2.9",
    "sures_2024": "3.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 7.2",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "M 0.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 24.2",
    "ecart_sexes_math_2019": "F 5.7",
    "ecart_sexes_math_2022": "M 1.5",
    "ecart_sexes_math_2023": "F 5.9",
    "ecart_sexes_math_2024": "F 1.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.3",
    "prog_2019": "25.7",
    "prog_2022": "39.8",
    "prog_2023": "33.1",
    "prog_2024": "50.3",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "6.5",
    "cote_2022": "6.2",
    "cote_2023": "6.0",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Marcel-Raymond",
    "nom_court": "École Marcel-Raymond",
    "adresse": "45, rue Notre-Dame Est",
    "municipalite": "Lorrainville",
    "code_postal": "J0Z 2R0",
    "lat": 47.35463,
    "lng": -79.34925
  },
  {
    "_id": "136",
    "school_code": "781067",
    "school_name_1": "Rivière-des-Quinze",
    "admin_body_number": "781000",
    "admin_body_name": "Centre de services scolaire du Lac-Témiscamingue",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "277",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "8.9",
    "ehdaa_2024": "27.1",
    "rang_2024": "399/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "68.3",
    "lens_2019": "59.3",
    "lens_2022": "57.0",
    "lens_2023": "68.0",
    "lens_2024": "60.3",
    "lens_trend": "—",
    "lsec_2018": "82.3",
    "lsec_2019": "80.3",
    "lsec_2022": "75.9",
    "lsec_2023": "78.5",
    "lsec_2024": "77.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.4",
    "scie_2019": "74.8",
    "scie_2022": "72.1",
    "scie_2023": "74.9",
    "scie_2024": "69.0",
    "scie_trend": "—",
    "math_2018": "70.4",
    "math_2019": "79.6",
    "math_2022": "75.1",
    "math_2023": "74.3",
    "math_2024": "75.3",
    "math_trend": "—",
    "echec_2018": "13.2",
    "echec_2019": "14.2",
    "echec_2022": "23.9",
    "echec_2023": "9.8",
    "echec_2024": "22.2",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "2.6",
    "sures_2022": "3.2",
    "sures_2023": "0.6",
    "sures_2024": "2.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 4.4",
    "ecart_sexes_lens_2022": "F 8.9",
    "ecart_sexes_lens_2023": "M 0.1",
    "ecart_sexes_lens_2024": "F 13.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 6.3",
    "ecart_sexes_math_2019": "F 1.2",
    "ecart_sexes_math_2022": "M 1.7",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "F 13.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.9",
    "prog_2019": "19.5",
    "prog_2022": "32.6",
    "prog_2023": "50.3",
    "prog_2024": "30.8",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "6.2",
    "cote_2022": "4.6",
    "cote_2023": "6.0",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Rivière-des-Quinze",
    "nom_court": "École Rivière-des-Quinze",
    "adresse": "15, rue Desjardins",
    "municipalite": "Notre-Dame-du-Nord",
    "code_postal": "J0Z 3B0",
    "lat": 47.59106,
    "lng": -79.49032
  },
  {
    "_id": "137",
    "school_code": "782018",
    "school_name_1": "La Source",
    "admin_body_number": "782000",
    "admin_body_name": "Centre de services scolaire de Rouyn-Noranda",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "929",
    "langue": "français",
    "secteur": "public",
    "rang": "294",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "7.2",
    "ehdaa_2024": "42.3",
    "rang_2024": "294/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "68.4",
    "lens_2023": "68.1",
    "lens_2024": "68.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "77.4",
    "lsec_2023": "80.8",
    "lsec_2024": "80.1",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "71.2",
    "scie_2023": "74.6",
    "scie_2024": "66.9",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "79.6",
    "math_2023": "78.5",
    "math_2024": "77.8",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "15.4",
    "echec_2023": "16.3",
    "echec_2024": "18.7",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "2.4",
    "sures_2023": "0.1",
    "sures_2024": "1.8",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 3.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 7.1",
    "ecart_sexes_math_2023": "F 5.3",
    "ecart_sexes_math_2024": "F 2.4",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "25.5",
    "prog_2023": "25.1",
    "prog_2024": "41.4",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "6.5",
    "cote_2023": "6.4",
    "cote_2024": "5.4",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École La Source",
    "nom_court": "École La Source",
    "adresse": "9, 10e Rue",
    "municipalite": "Rouyn-Noranda",
    "code_postal": "J9X 2C5",
    "lat": 48.23483,
    "lng": -79.00848
  },
  {
    "_id": "138",
    "school_code": "782019",
    "school_name_1": "D'Iberville",
    "admin_body_number": "782000",
    "admin_body_name": "Centre de services scolaire de Rouyn-Noranda",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "1330",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "4.1",
    "ehdaa_2024": "36.4",
    "rang_2024": "323/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "68.1",
    "lens_2019": "71.2",
    "lens_2022": "68.7",
    "lens_2023": "65.4",
    "lens_2024": "62.0",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "79.5",
    "lsec_2022": "82.0",
    "lsec_2023": "84.2",
    "lsec_2024": "81.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.0",
    "scie_2019": "72.5",
    "scie_2022": "70.6",
    "scie_2023": "74.2",
    "scie_2024": "71.9",
    "scie_trend": "—",
    "math_2018": "71.3",
    "math_2019": "70.9",
    "math_2022": "73.0",
    "math_2023": "73.8",
    "math_2024": "78.1",
    "math_trend": "—",
    "echec_2018": "16.7",
    "echec_2019": "15.8",
    "echec_2022": "21.1",
    "echec_2023": "16.6",
    "echec_2024": "19.3",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.5",
    "sures_2022": "0.8",
    "sures_2023": "2.4",
    "sures_2024": "3.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.6",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "F 7.9",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 3.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.5",
    "ecart_sexes_math_2019": "F 6.6",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "F 0.1",
    "ecart_sexes_math_2024": "F 9.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.0",
    "prog_2019": "37.7",
    "prog_2022": "19.3",
    "prog_2023": "40.7",
    "prog_2024": "34.2",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "5.5",
    "cote_2022": "6.4",
    "cote_2023": "5.7",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École D'Iberville",
    "nom_court": "École D'Iberville",
    "adresse": "275, avenue Forbes",
    "municipalite": "Rouyn-Noranda",
    "code_postal": "J9X 5C9",
    "lat": 48.23483,
    "lng": -79.00848
  },
  {
    "_id": "139",
    "school_code": "783023",
    "school_name_1": "d'Amos",
    "admin_body_number": "783000",
    "admin_body_name": "Centre de services scolaire Harricana",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "1387",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "35.6",
    "rang_2024": "310/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "69.9",
    "lens_2019": "74.0",
    "lens_2022": "66.0",
    "lens_2023": "70.0",
    "lens_2024": "69.9",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "79.6",
    "lsec_2022": "78.5",
    "lsec_2023": "76.1",
    "lsec_2024": "81.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.0",
    "scie_2019": "68.6",
    "scie_2022": "68.3",
    "scie_2023": "73.8",
    "scie_2024": "69.2",
    "scie_trend": "112233",
    "math_2018": "70.6",
    "math_2019": "66.8",
    "math_2022": "70.2",
    "math_2023": "70.4",
    "math_2024": "71.8",
    "math_trend": "—",
    "echec_2018": "20.4",
    "echec_2019": "18.4",
    "echec_2022": "24.8",
    "echec_2023": "19.6",
    "echec_2024": "19.4",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.1",
    "sures_2022": "2.8",
    "sures_2023": "1.8",
    "sures_2024": "2.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.3",
    "ecart_sexes_lens_2019": "F 6.2",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.5",
    "ecart_sexes_math_2019": "F 6.8",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 4.3",
    "ecart_sexes_math_2024": "F 10.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.7",
    "prog_2019": "35.3",
    "prog_2022": "37.5",
    "prog_2023": "41.4",
    "prog_2024": "35.5",
    "prog_trend": "—",
    "cote_2018": "4.9",
    "cote_2019": "5.1",
    "cote_2022": "5.0",
    "cote_2023": "4.8",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire d'Amos",
    "nom_court": "École secondaire d'Amos",
    "adresse": "850, 1 Rue Est",
    "municipalite": "Amos",
    "code_postal": "J9T 2H8",
    "lat": 48.57711,
    "lng": -78.11302
  },
  {
    "_id": "140",
    "school_code": "784023",
    "school_name_1": "La Concorde",
    "admin_body_number": "784000",
    "admin_body_name": "Centre de services scolaire de l'Or-et-des-Bois",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "185",
    "langue": "français",
    "secteur": "public",
    "rang": "433",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "9.5",
    "ehdaa_2024": "46.5",
    "rang_2024": "433/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "64.2",
    "lens_2019": "70.1",
    "lens_2022": "62.2",
    "lens_2023": "65.5",
    "lens_2024": "65.8",
    "lens_trend": "—",
    "lsec_2018": "76.1",
    "lsec_2019": "72.4",
    "lsec_2022": "73.6",
    "lsec_2023": "74.4",
    "lsec_2024": "74.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.2",
    "scie_2019": "69.5",
    "scie_2022": "72.9",
    "scie_2023": "69.7",
    "scie_2024": "66.0",
    "scie_trend": "—",
    "math_2018": "63.4",
    "math_2019": "67.5",
    "math_2022": "70.6",
    "math_2023": "60.0",
    "math_2024": "63.1",
    "math_trend": "—",
    "echec_2018": "33.2",
    "echec_2019": "14.1",
    "echec_2022": "25.7",
    "echec_2023": "28.6",
    "echec_2024": "32.1",
    "echec_trend": "—",
    "sures_2018": "4.4",
    "sures_2019": "3.0",
    "sures_2022": "3.7",
    "sures_2023": "2.8",
    "sures_2024": "1.4",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 1.3",
    "ecart_sexes_lens_2023": "M 0.6",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 5.8",
    "ecart_sexes_math_2023": "M 15.6",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "46.3",
    "prog_2019": "49.3",
    "prog_2022": "39.2",
    "prog_2023": "38.4",
    "prog_2024": "32.4",
    "prog_trend": "112233",
    "cote_2018": "2.7",
    "cote_2019": "4.6",
    "cote_2022": "5.0",
    "cote_2023": "3.3",
    "cote_2024": "3.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire La Concorde",
    "nom_court": "École secondaire La Concorde",
    "adresse": "40, route 386",
    "municipalite": "Senneterre",
    "code_postal": "J0Y 2M0",
    "lat": 48.39033,
    "lng": -77.25241
  },
  {
    "_id": "141",
    "school_code": "784024",
    "school_name_1": "le Tremplin",
    "admin_body_number": "784000",
    "admin_body_name": "Centre de services scolaire de l'Or-et-des-Bois",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "406",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "14.1",
    "ehdaa_2024": "30.5",
    "rang_2024": "229/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "70.8",
    "lens_2019": "69.5",
    "lens_2022": "62.3",
    "lens_2023": "61.7",
    "lens_2024": "58.4",
    "lens_trend": "998855",
    "lsec_2018": "76.2",
    "lsec_2019": "80.3",
    "lsec_2022": "80.2",
    "lsec_2023": "83.7",
    "lsec_2024": "80.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.8",
    "scie_2019": "77.1",
    "scie_2022": "68.3",
    "scie_2023": "75.6",
    "scie_2024": "71.4",
    "scie_trend": "—",
    "math_2018": "66.4",
    "math_2019": "72.7",
    "math_2022": "67.9",
    "math_2023": "71.4",
    "math_2024": "78.6",
    "math_trend": "—",
    "echec_2018": "17.9",
    "echec_2019": "13.2",
    "echec_2022": "26.7",
    "echec_2023": "20.6",
    "echec_2024": "22.7",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "0.1",
    "sures_2022": "2.0",
    "sures_2023": "1.3",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.1",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 4.6",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "F 4.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.9",
    "ecart_sexes_math_2019": "F 4.5",
    "ecart_sexes_math_2022": "M 4.3",
    "ecart_sexes_math_2023": "F 2.5",
    "ecart_sexes_math_2024": "M 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.3",
    "prog_2019": "40.7",
    "prog_2022": "20.0",
    "prog_2023": "40.2",
    "prog_2024": "21.3",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "6.2",
    "cote_2022": "5.7",
    "cote_2023": "5.7",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Le Tremplin",
    "nom_court": "École secondaire Le Tremplin",
    "adresse": "701, rue des Érables",
    "municipalite": "Malartic",
    "code_postal": "J0Y 1Z0",
    "lat": 48.14156,
    "lng": -78.12048
  },
  {
    "_id": "142",
    "school_code": "784025",
    "school_name_1": "Le Carrefour",
    "admin_body_number": "784000",
    "admin_body_name": "Centre de services scolaire de l'Or-et-des-Bois",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "1153",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "8",
    "ehdaa_2024": "30.5",
    "rang_2024": "360/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "65.4",
    "lens_2019": "67.3",
    "lens_2022": "65.4",
    "lens_2023": "69.5",
    "lens_2024": "66.1",
    "lens_trend": "112233",
    "lsec_2018": "77.4",
    "lsec_2019": "80.6",
    "lsec_2022": "73.3",
    "lsec_2023": "76.5",
    "lsec_2024": "77.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.2",
    "scie_2019": "69.3",
    "scie_2022": "72.7",
    "scie_2023": "73.6",
    "scie_2024": "66.6",
    "scie_trend": "—",
    "math_2018": "72.1",
    "math_2019": "71.7",
    "math_2022": "75.2",
    "math_2023": "70.3",
    "math_2024": "75.2",
    "math_trend": "—",
    "echec_2018": "19.0",
    "echec_2019": "19.7",
    "echec_2022": "21.0",
    "echec_2023": "17.5",
    "echec_2024": "22.6",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.6",
    "sures_2022": "1.1",
    "sures_2023": "0.9",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 7.7",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.7",
    "ecart_sexes_math_2019": "F 7.6",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "M 2.6",
    "ecart_sexes_math_2024": "F 7.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "49.2",
    "prog_2019": "49.9",
    "prog_2022": "33.0",
    "prog_2023": "39.0",
    "prog_2024": "31.9",
    "prog_trend": "112233",
    "cote_2018": "4.6",
    "cote_2019": "4.4",
    "cote_2022": "5.5",
    "cote_2023": "5.3",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Le Carrefour",
    "nom_court": "Polyvalente Le Carrefour",
    "adresse": "125, rue Self",
    "municipalite": "Val-d'Or",
    "code_postal": "J9P 3N2",
    "lat": 48.09362,
    "lng": -77.78779
  },
  {
    "_id": "143",
    "school_code": "785003",
    "school_name_1": "Polyno",
    "admin_body_number": "785000",
    "admin_body_name": "Centre de services scolaire du Lac-Abitibi",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "879",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "13",
    "ehdaa_2024": "34.7",
    "rang_2024": "277/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "74.0",
    "lens_2019": "73.5",
    "lens_2022": "66.8",
    "lens_2023": "69.2",
    "lens_2024": "65.3",
    "lens_trend": "998855",
    "lsec_2018": "77.4",
    "lsec_2019": "77.6",
    "lsec_2022": "80.2",
    "lsec_2023": "79.2",
    "lsec_2024": "78.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.1",
    "scie_2019": "69.9",
    "scie_2022": "68.5",
    "scie_2023": "71.7",
    "scie_2024": "69.3",
    "scie_trend": "112233",
    "math_2018": "70.0",
    "math_2019": "69.5",
    "math_2022": "74.2",
    "math_2023": "75.6",
    "math_2024": "79.4",
    "math_trend": "112233",
    "echec_2018": "16.5",
    "echec_2019": "18.5",
    "echec_2022": "21.8",
    "echec_2023": "16.0",
    "echec_2024": "19.9",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "3.0",
    "sures_2022": "3.2",
    "sures_2023": "1.7",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.9",
    "ecart_sexes_lens_2019": "F 5.9",
    "ecart_sexes_lens_2022": "F 7.1",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 0.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.2",
    "ecart_sexes_math_2019": "F 4.7",
    "ecart_sexes_math_2022": "F 4.3",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "M 1.6",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "39.4",
    "prog_2019": "33.0",
    "prog_2022": "35.7",
    "prog_2023": "46.2",
    "prog_2024": "41.4",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.2",
    "cote_2022": "5.4",
    "cote_2023": "5.6",
    "cote_2024": "5.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Cité étudiante Polyno",
    "nom_court": "Cité étudiante Polyno",
    "adresse": "500, rue Principale",
    "municipalite": "La Sarre",
    "code_postal": "J9Z 2A2",
    "lat": 48.79621,
    "lng": -79.20692
  },
  {
    "_id": "144",
    "school_code": "791044",
    "school_name_1": "Serge-Bouchard",
    "admin_body_number": "791000",
    "admin_body_name": "Centre de services scolaire de l'Estuaire",
    "area_name": "Côte-Nord ",
    "étudiants": "724",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "7",
    "ehdaa_2024": "47.4",
    "rang_2024": "199/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "74.8",
    "lens_2019": "74.7",
    "lens_2022": "73.7",
    "lens_2023": "72.8",
    "lens_2024": "70.4",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "75.8",
    "lsec_2022": "81.2",
    "lsec_2023": "79.1",
    "lsec_2024": "77.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.8",
    "scie_2019": "71.2",
    "scie_2022": "72.7",
    "scie_2023": "71.8",
    "scie_2024": "72.3",
    "scie_trend": "—",
    "math_2018": "68.4",
    "math_2019": "72.0",
    "math_2022": "81.0",
    "math_2023": "77.8",
    "math_2024": "84.4",
    "math_trend": "112233",
    "echec_2018": "19.6",
    "echec_2019": "15.0",
    "echec_2022": "9.6",
    "echec_2023": "15.6",
    "echec_2024": "13.1",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "0.0",
    "sures_2022": "0.3",
    "sures_2023": "0.2",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.8",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "M 1.1",
    "ecart_sexes_lens_2023": "F 8.7",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 19.8",
    "ecart_sexes_math_2019": "F 13.4",
    "ecart_sexes_math_2022": "F 9.3",
    "ecart_sexes_math_2023": "M 2.8",
    "ecart_sexes_math_2024": "M 5.5",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "46.4",
    "prog_2019": "46.2",
    "prog_2022": "40.3",
    "prog_2023": "42.0",
    "prog_2024": "40.6",
    "prog_trend": "—",
    "cote_2018": "4.3",
    "cote_2019": "5.3",
    "cote_2022": "6.8",
    "cote_2023": "5.5",
    "cote_2024": "6.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Serge-Bouchard",
    "nom_court": "École secondaire Serge-Bouchard",
    "adresse": "640, boulevard Blanche",
    "municipalite": "Baie-Comeau",
    "code_postal": "G5C 2B3",
    "lat": 49.18928,
    "lng": -68.25802
  },
  {
    "_id": "145",
    "school_code": "791046",
    "school_name_1": "des Rivières",
    "admin_body_number": "791000",
    "admin_body_name": "Centre de services scolaire de l'Estuaire",
    "area_name": "Côte-Nord ",
    "étudiants": "208",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "21.1",
    "ehdaa_2024": "48.6",
    "rang_2024": "238/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "82.8",
    "lens_2019": "73.6",
    "lens_2022": "62.0",
    "lens_2023": "69.9",
    "lens_2024": "64.1",
    "lens_trend": "—",
    "lsec_2018": "76.1",
    "lsec_2019": "77.7",
    "lsec_2022": "80.3",
    "lsec_2023": "76.7",
    "lsec_2024": "80.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.9",
    "scie_2019": "76.3",
    "scie_2022": "68.9",
    "scie_2023": "75.6",
    "scie_2024": "74.4",
    "scie_trend": "—",
    "math_2018": "70.2",
    "math_2019": "75.2",
    "math_2022": "71.4",
    "math_2023": "76.0",
    "math_2024": "83.3",
    "math_trend": "112233",
    "echec_2018": "4.5",
    "echec_2019": "7.6",
    "echec_2022": "25.2",
    "echec_2023": "16.2",
    "echec_2024": "17.1",
    "echec_trend": "998855",
    "sures_2018": "0.2",
    "sures_2019": "0.0",
    "sures_2022": "2.8",
    "sures_2023": "1.3",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 6.1",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "17.8",
    "prog_2019": "39.0",
    "prog_2022": "31.5",
    "prog_2023": "51.4",
    "prog_2024": "33.3",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "6.7",
    "cote_2022": "5.2",
    "cote_2023": "5.5",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente des Rivières",
    "nom_court": "Polyvalente des Rivières",
    "adresse": "16A, 5e Avenue",
    "municipalite": "Forestville",
    "code_postal": "G0T 1E0",
    "lat": 48.74229,
    "lng": -69.0794
  },
  {
    "_id": "146",
    "school_code": "791058",
    "school_name_1": "des Baies",
    "admin_body_number": "791000",
    "admin_body_name": "Centre de services scolaire de l'Estuaire",
    "area_name": "Côte-Nord ",
    "étudiants": "603",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "9.5",
    "ehdaa_2024": "37.1",
    "rang_2024": "376/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "68.5",
    "lens_2019": "66.1",
    "lens_2022": "66.5",
    "lens_2023": "65.0",
    "lens_2024": "65.9",
    "lens_trend": "—",
    "lsec_2018": "71.7",
    "lsec_2019": "76.7",
    "lsec_2022": "72.9",
    "lsec_2023": "74.0",
    "lsec_2024": "76.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.0",
    "scie_2019": "66.8",
    "scie_2022": "70.4",
    "scie_2023": "68.6",
    "scie_2024": "69.4",
    "scie_trend": "—",
    "math_2018": "75.1",
    "math_2019": "76.6",
    "math_2022": "77.1",
    "math_2023": "74.6",
    "math_2024": "81.0",
    "math_trend": "—",
    "echec_2018": "15.4",
    "echec_2019": "19.6",
    "echec_2022": "21.4",
    "echec_2023": "22.1",
    "echec_2024": "22.4",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "2.2",
    "sures_2022": "5.9",
    "sures_2023": "4.9",
    "sures_2024": "3.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 11.7",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 11.6",
    "ecart_sexes_lens_2023": "F 8.2",
    "ecart_sexes_lens_2024": "F 12.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.2",
    "ecart_sexes_math_2019": "M 1.2",
    "ecart_sexes_math_2022": "F 24.9",
    "ecart_sexes_math_2023": "M 4.9",
    "ecart_sexes_math_2024": "F 4.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "38.7",
    "prog_2019": "29.5",
    "prog_2022": "25.3",
    "prog_2023": "34.9",
    "prog_2024": "35.2",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "4.9",
    "cote_2022": "4.0",
    "cote_2023": "4.1",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente des Baies",
    "nom_court": "Polyvalente des Baies",
    "adresse": "40, avenue Michel-Hémon",
    "municipalite": "Baie-Comeau",
    "code_postal": "G4Z 2K4",
    "lat": 49.20828,
    "lng": -68.16601
  },
  {
    "_id": "147",
    "school_code": "791059",
    "school_name_1": "des Berges",
    "admin_body_number": "791000",
    "admin_body_name": "Centre de services scolaire de l'Estuaire",
    "area_name": "Côte-Nord ",
    "étudiants": "277",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "15.4",
    "ehdaa_2024": "20.2",
    "rang_2024": "169/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "76.4",
    "lens_2019": "70.7",
    "lens_2022": "71.8",
    "lens_2023": "70.1",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "72.7",
    "lsec_2019": "72.7",
    "lsec_2022": "79.8",
    "lsec_2023": "78.3",
    "lsec_2024": "79.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.4",
    "scie_2019": "77.0",
    "scie_2022": "78.5",
    "scie_2023": "82.4",
    "scie_2024": "77.2",
    "scie_trend": "998855",
    "math_2018": "70.0",
    "math_2019": "71.6",
    "math_2022": "78.3",
    "math_2023": "82.5",
    "math_2024": "83.2",
    "math_trend": "112233",
    "echec_2018": "12.9",
    "echec_2019": "13.5",
    "echec_2022": "11.4",
    "echec_2023": "9.7",
    "echec_2024": "11.4",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.0",
    "sures_2022": "1.3",
    "sures_2023": "0.6",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 0.8",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 9.3",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 0.8",
    "ecart_sexes_math_2022": "M 12.0",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "F 2.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "27.6",
    "prog_2019": "17.4",
    "prog_2022": "20.0",
    "prog_2023": "31.2",
    "prog_2024": "26.9",
    "prog_trend": "—",
    "cote_2018": "6.3",
    "cote_2019": "6.4",
    "cote_2022": "7.3",
    "cote_2023": "6.9",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente des Berges",
    "nom_court": "Polyvalente des Berges",
    "adresse": "433, rue de la Mer",
    "municipalite": "Les Bergeronnes",
    "code_postal": "G0T 1G0",
    "lat": 48.23977,
    "lng": -69.54257
  },
  {
    "_id": "148",
    "school_code": "792003",
    "school_name_1": "Horizon-Blanc",
    "admin_body_number": "792000",
    "admin_body_name": "Centre de services scolaire du Fer",
    "area_name": "Côte-Nord ",
    "étudiants": "136",
    "langue": "français",
    "secteur": "public",
    "rang": "427",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "42.6",
    "rang_2024": "427/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "64.2",
    "lens_2019": "67.5",
    "lens_2022": "69.1",
    "lens_2023": "59.9",
    "lens_2024": "52.1",
    "lens_trend": "—",
    "lsec_2018": "74.1",
    "lsec_2019": "78.7",
    "lsec_2022": "82.0",
    "lsec_2023": "77.8",
    "lsec_2024": "71.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.2",
    "scie_2019": "72.0",
    "scie_2022": "74.0",
    "scie_2023": "72.6",
    "scie_2024": "68.1",
    "scie_trend": "998855",
    "math_2018": "71.4",
    "math_2019": "79.5",
    "math_2022": "76.8",
    "math_2023": "81.7",
    "math_2024": "80.9",
    "math_trend": "—",
    "echec_2018": "19.4",
    "echec_2019": "5.7",
    "echec_2022": "13.4",
    "echec_2023": "24.3",
    "echec_2024": "26.9",
    "echec_trend": "—",
    "sures_2018": "5.8",
    "sures_2019": "1.5",
    "sures_2022": "4.3",
    "sures_2023": "3.5",
    "sures_2024": "5.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "21.7",
    "prog_2019": "30.7",
    "prog_2022": "5.0",
    "prog_2023": "15.5",
    "prog_2024": "27.8",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "6.6",
    "cote_2022": "7.6",
    "cote_2023": "5.9",
    "cote_2024": "3.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Horizon-Blanc",
    "nom_court": "Polyvalente Horizon-Blanc",
    "adresse": "130, rue Le Carrefour",
    "municipalite": "Fermont",
    "code_postal": "G0G 1J0",
    "lat": 52.79645,
    "lng": -67.09066
  },
  {
    "_id": "149",
    "school_code": "792047",
    "school_name_1": "Jean-du-Nord / Manikoutai",
    "admin_body_number": "792000",
    "admin_body_name": "Centre de services scolaire du Fer",
    "area_name": "Côte-Nord ",
    "étudiants": "1147",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "10.6",
    "ehdaa_2024": "36.1",
    "rang_2024": "169/470",
    "rang_2019_2024": "nd",
    "lens_2018": "74.8",
    "lens_2019": "73.6",
    "lens_2022": "nd",
    "lens_2023": "75.2",
    "lens_2024": "72.7",
    "lens_trend": "nd",
    "lsec_2018": "78.3",
    "lsec_2019": "77.3",
    "lsec_2022": "nd",
    "lsec_2023": "79.3",
    "lsec_2024": "84.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.5",
    "scie_2019": "68.9",
    "scie_2022": "nd",
    "scie_2023": "70.4",
    "scie_2024": "66.2",
    "scie_trend": "nd",
    "math_2018": "69.7",
    "math_2019": "72.2",
    "math_2022": "nd",
    "math_2023": "65.8",
    "math_2024": "71.9",
    "math_trend": "nd",
    "echec_2018": "19.6",
    "echec_2019": "18.7",
    "echec_2022": "nd",
    "echec_2023": "20.1",
    "echec_2024": "17.4",
    "echec_trend": "nd",
    "sures_2018": "0.1",
    "sures_2019": "0.1",
    "sures_2022": "nd",
    "sures_2023": "1.9",
    "sures_2024": "0.2",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "F 5.7",
    "ecart_sexes_lens_2019": "F 7.5",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 3.9",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 11.7",
    "ecart_sexes_math_2019": "F 4.4",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 2.2",
    "ecart_sexes_math_2024": "M 1.4",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "31.4",
    "prog_2019": "21.2",
    "prog_2022": "nd",
    "prog_2023": "37.5",
    "prog_2024": "25.1",
    "prog_trend": "nd",
    "cote_2018": "5.2",
    "cote_2019": "5.5",
    "cote_2022": "nd",
    "cote_2023": "5.2",
    "cote_2024": "6.4",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Jean-du-Nord / Manikoutai",
    "nom_court": "École Jean-du-Nord / Manikoutai",
    "adresse": "110, rue Comeau",
    "municipalite": "Sept-Îles",
    "code_postal": "G4R 1J4",
    "lat": 50.2208,
    "lng": -66.36823
  },
  {
    "_id": "150",
    "school_code": "792049",
    "school_name_1": "L'Abri",
    "admin_body_number": "792000",
    "admin_body_name": "Centre de services scolaire du Fer",
    "area_name": "Côte-Nord ",
    "étudiants": "385",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "21.5",
    "ehdaa_2024": "49.1",
    "rang_2024": "399/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "71.1",
    "lens_2019": "70.8",
    "lens_2022": "71.2",
    "lens_2023": "67.7",
    "lens_2024": "62.4",
    "lens_trend": "—",
    "lsec_2018": "72.4",
    "lsec_2019": "71.6",
    "lsec_2022": "76.2",
    "lsec_2023": "72.4",
    "lsec_2024": "74.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.7",
    "scie_2019": "73.3",
    "scie_2022": "62.2",
    "scie_2023": "67.8",
    "scie_2024": "65.8",
    "scie_trend": "—",
    "math_2018": "68.9",
    "math_2019": "66.6",
    "math_2022": "68.4",
    "math_2023": "71.3",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "21.1",
    "echec_2019": "17.4",
    "echec_2022": "24.4",
    "echec_2023": "22.0",
    "echec_2024": "23.1",
    "echec_trend": "—",
    "sures_2018": "4.3",
    "sures_2019": "3.6",
    "sures_2022": "7.3",
    "sures_2023": "3.1",
    "sures_2024": "4.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.6",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 4.9",
    "ecart_sexes_lens_2023": "F 9.1",
    "ecart_sexes_lens_2024": "M 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.8",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "F 2.5",
    "ecart_sexes_math_2023": "M 3.7",
    "ecart_sexes_math_2024": "M 5.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "11.9",
    "prog_2019": "25.2",
    "prog_2022": "33.5",
    "prog_2023": "25.0",
    "prog_2024": "31.3",
    "prog_trend": "—",
    "cote_2018": "4.7",
    "cote_2019": "4.6",
    "cote_2022": "4.6",
    "cote_2023": "4.6",
    "cote_2024": "4.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Centre éducatif l'Abri",
    "nom_court": "Centre éducatif l'Abri",
    "adresse": "18, boulevard des Îles",
    "municipalite": "Port-Cartier",
    "code_postal": "G5B 2N4",
    "lat": 50.02151,
    "lng": -66.88509
  },
  {
    "_id": "151",
    "school_code": "793001",
    "school_name_1": "Monseigneur-Labrie",
    "admin_body_number": "793000",
    "admin_body_name": "Centre de services scolaire de la Moyenne-Côte-Nord",
    "area_name": "Côte-Nord ",
    "étudiants": "234",
    "langue": "français",
    "secteur": "public",
    "rang": "454",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "28.9",
    "ehdaa_2024": "51.3",
    "rang_2024": "454/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "63.5",
    "lens_2019": "68.5",
    "lens_2022": "65.0",
    "lens_2023": "67.2",
    "lens_2024": "57.4",
    "lens_trend": "—",
    "lsec_2018": "69.5",
    "lsec_2019": "71.9",
    "lsec_2022": "73.1",
    "lsec_2023": "77.7",
    "lsec_2024": "75.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.2",
    "scie_2019": "75.6",
    "scie_2022": "77.6",
    "scie_2023": "74.3",
    "scie_2024": "65.7",
    "scie_trend": "—",
    "math_2018": "76.5",
    "math_2019": "77.3",
    "math_2022": "80.0",
    "math_2023": "75.6",
    "math_2024": "74.1",
    "math_trend": "—",
    "echec_2018": "18.9",
    "echec_2019": "14.8",
    "echec_2022": "14.2",
    "echec_2023": "15.4",
    "echec_2024": "33.8",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "3.3",
    "sures_2022": "3.6",
    "sures_2023": "3.3",
    "sures_2024": "7.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 6.8",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 7.6",
    "ecart_sexes_lens_2024": "M 1.7",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 8.9",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 2.8",
    "ecart_sexes_math_2024": "M 7.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "23.7",
    "prog_2019": "41.2",
    "prog_2022": "26.5",
    "prog_2023": "35.4",
    "prog_2024": "37.9",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "4.4",
    "cote_2022": "6.1",
    "cote_2023": "5.4",
    "cote_2024": "2.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Monseigneur-Labrie",
    "nom_court": "École Monseigneur-Labrie",
    "adresse": "1239, rue de la Digue",
    "municipalite": "Havre-Saint-Pierre",
    "code_postal": "G0G 1P0",
    "lat": 50.24613,
    "lng": -63.59666
  },
  {
    "_id": "152",
    "school_code": "801003",
    "school_name_1": "La Porte-du-Nord",
    "admin_body_number": "801000",
    "admin_body_name": "Centre de services scolaire de la Baie-James",
    "area_name": "Nord-du-Québec ",
    "étudiants": "386",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "11.5",
    "ehdaa_2024": "32.1",
    "rang_2024": "238/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "75.7",
    "lens_2019": "75.4",
    "lens_2022": "65.9",
    "lens_2023": "71.1",
    "lens_2024": "67.8",
    "lens_trend": "—",
    "lsec_2018": "79.7",
    "lsec_2019": "78.7",
    "lsec_2022": "80.1",
    "lsec_2023": "79.1",
    "lsec_2024": "79.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.2",
    "scie_2019": "81.3",
    "scie_2022": "77.2",
    "scie_2023": "78.1",
    "scie_2024": "74.4",
    "scie_trend": "998855",
    "math_2018": "76.8",
    "math_2019": "68.4",
    "math_2022": "66.0",
    "math_2023": "71.8",
    "math_2024": "71.8",
    "math_trend": "—",
    "echec_2018": "6.8",
    "echec_2019": "11.9",
    "echec_2022": "19.2",
    "echec_2023": "13.3",
    "echec_2024": "17.0",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "2.8",
    "sures_2023": "0.3",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.2",
    "ecart_sexes_lens_2019": "F 8.9",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 7.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 6.7",
    "ecart_sexes_math_2019": "M 3.5",
    "ecart_sexes_math_2022": "M 2.6",
    "ecart_sexes_math_2023": "F 5.8",
    "ecart_sexes_math_2024": "M 5.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.9",
    "prog_2019": "30.3",
    "prog_2022": "22.3",
    "prog_2023": "40.0",
    "prog_2024": "23.3",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "6.5",
    "cote_2022": "6.1",
    "cote_2023": "6.0",
    "cote_2024": "5.8",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École La Porte-du-Nord",
    "nom_court": "École La Porte-du-Nord",
    "adresse": "265, rue Lanctôt",
    "municipalite": "Chibougamau",
    "code_postal": "G8P 1C1",
    "lat": 49.91918,
    "lng": -74.37286
  },
  {
    "_id": "153",
    "school_code": "801014",
    "school_name_1": "Le Delta",
    "admin_body_number": "801000",
    "admin_body_name": "Centre de services scolaire de la Baie-James",
    "area_name": "Nord-du-Québec ",
    "étudiants": "89",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "42.7",
    "rang_2024": "399/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "67.6",
    "lens_2019": "64.7",
    "lens_2022": "72.3",
    "lens_2023": "62.1",
    "lens_2024": "64.5",
    "lens_trend": "—",
    "lsec_2018": "77.8",
    "lsec_2019": "72.5",
    "lsec_2022": "80.7",
    "lsec_2023": "75.0",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.6",
    "scie_2019": "65.8",
    "scie_2022": "63.5",
    "scie_2023": "67.2",
    "scie_2024": "62.5",
    "scie_trend": "—",
    "math_2018": "60.3",
    "math_2019": "71.4",
    "math_2022": "67.1",
    "math_2023": "72.1",
    "math_2024": "69.7",
    "math_trend": "—",
    "echec_2018": "24.7",
    "echec_2019": "21.6",
    "echec_2022": "20.0",
    "echec_2023": "18.0",
    "echec_2024": "27.2",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "2.1",
    "sures_2022": "1.1",
    "sures_2023": "0.2",
    "sures_2024": "0.0",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "31.3",
    "prog_2019": "18.1",
    "prog_2022": "19.0",
    "prog_2023": "24.7",
    "prog_2024": "33.3",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "4.3",
    "cote_2022": "6.3",
    "cote_2023": "5.0",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Le Delta",
    "nom_court": "École Le Delta",
    "adresse": "100, rue Rupert",
    "municipalite": "Matagami",
    "code_postal": "J0Y 2A0",
    "lat": 49.76059,
    "lng": -77.62829
  },
  {
    "_id": "154",
    "school_code": "801016",
    "school_name_1": "La Taïga",
    "admin_body_number": "801000",
    "admin_body_name": "Centre de services scolaire de la Baie-James",
    "area_name": "Nord-du-Québec ",
    "étudiants": "119",
    "langue": "français",
    "secteur": "public",
    "rang": "442",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "4.5",
    "ehdaa_2024": "35.3",
    "rang_2024": "442/470",
    "rang_2019_2024": "nd",
    "lens_2018": "63.2",
    "lens_2019": "nd",
    "lens_2022": "59.6",
    "lens_2023": "60.7",
    "lens_2024": "56.4",
    "lens_trend": "nd",
    "lsec_2018": "75.7",
    "lsec_2019": "nd",
    "lsec_2022": "73.5",
    "lsec_2023": "75.9",
    "lsec_2024": "77.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.8",
    "scie_2019": "nd",
    "scie_2022": "67.0",
    "scie_2023": "72.8",
    "scie_2024": "70.5",
    "scie_trend": "nd",
    "math_2018": "58.7",
    "math_2019": "nd",
    "math_2022": "66.8",
    "math_2023": "77.5",
    "math_2024": "77.5",
    "math_trend": "nd",
    "echec_2018": "27.2",
    "echec_2019": "nd",
    "echec_2022": "28.0",
    "echec_2023": "14.5",
    "echec_2024": "26.6",
    "echec_trend": "nd",
    "sures_2018": "6.7",
    "sures_2019": "nd",
    "sures_2022": "10.2",
    "sures_2023": "4.0",
    "sures_2024": "5.4",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "29.4",
    "prog_2019": "nd",
    "prog_2022": "4.8",
    "prog_2023": "14.1",
    "prog_2024": "45.5",
    "prog_trend": "nd",
    "cote_2018": "3.0",
    "cote_2019": "nd",
    "cote_2022": "4.2",
    "cote_2023": "5.7",
    "cote_2024": "3.4",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École La Taïga",
    "nom_court": "École La Taïga",
    "adresse": "140, rue Principale Nord",
    "municipalite": "Lebel-sur-Quévillon",
    "code_postal": "J0Y 1X0",
    "lat": 49.05453,
    "lng": -76.97564
  },
  {
    "_id": "155",
    "school_code": "811002",
    "school_name_1": "des Îles",
    "admin_body_number": "811000",
    "admin_body_name": "Centre de services scolaire des Îles",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "411",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "8.6",
    "ehdaa_2024": "35",
    "rang_2024": "156/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "75.4",
    "lens_2019": "77.4",
    "lens_2022": "76.8",
    "lens_2023": "72.9",
    "lens_2024": "69.3",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "73.8",
    "lsec_2022": "76.7",
    "lsec_2023": "75.7",
    "lsec_2024": "79.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.0",
    "scie_2019": "79.0",
    "scie_2022": "78.0",
    "scie_2023": "78.9",
    "scie_2024": "75.3",
    "scie_trend": "998855",
    "math_2018": "70.0",
    "math_2019": "69.3",
    "math_2022": "79.3",
    "math_2023": "73.6",
    "math_2024": "78.2",
    "math_trend": "—",
    "echec_2018": "11.8",
    "echec_2019": "11.3",
    "echec_2022": "8.0",
    "echec_2023": "10.6",
    "echec_2024": "13.6",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "1.3",
    "sures_2022": "2.3",
    "sures_2023": "2.4",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.7",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 7.6",
    "ecart_sexes_lens_2024": "F 7.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 3.4",
    "ecart_sexes_math_2022": "M 5.5",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.9",
    "prog_2019": "18.6",
    "prog_2022": "33.9",
    "prog_2023": "24.1",
    "prog_2024": "16.5",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "6.4",
    "cote_2022": "6.9",
    "cote_2023": "6.2",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Polyvalente des Îles",
    "nom_court": "École Polyvalente des Îles",
    "adresse": "30, chemin de la Martinique",
    "municipalite": "Les Îles-de-la-Madeleine",
    "code_postal": "G4T 3R7",
    "lat": 47.37144,
    "lng": -61.9155
  },
  {
    "_id": "156",
    "school_code": "812001",
    "school_name_1": "Saint-Norbert",
    "admin_body_number": "812000",
    "admin_body_name": "Centre de services scolaire des Chic-Chocs",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "65",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "5.9",
    "ehdaa_2024": "53.8",
    "rang_2024": "260/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "70.0",
    "lens_2023": "nd",
    "lens_2024": "68.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "74.3",
    "lsec_2023": "nd",
    "lsec_2024": "82.9",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "64.6",
    "scie_2023": "nd",
    "scie_2024": "73.2",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "55.5",
    "math_2023": "nd",
    "math_2024": "82.1",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "33.4",
    "echec_2023": "nd",
    "echec_2024": "16.3",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "10.6",
    "sures_2023": "nd",
    "sures_2024": "6.6",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "6.7",
    "prog_2023": "nd",
    "prog_2024": "37.8",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "3.7",
    "cote_2023": "nd",
    "cote_2024": "5.6",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École de l'Escabelle - Saint-Norbert",
    "nom_court": "École de l'Escabelle",
    "adresse": "27, rue des Écoliers",
    "municipalite": "Cap-Chat",
    "code_postal": "G0J 1E0",
    "lat": 49.09443,
    "lng": -66.69048
  },
  {
    "_id": "157",
    "school_code": "812006",
    "school_name_1": "Gabriel-Le Courtois",
    "admin_body_number": "812000",
    "admin_body_name": "Centre de services scolaire des Chic-Chocs",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "318",
    "langue": "français",
    "secteur": "public",
    "rang": "417",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "16.2",
    "ehdaa_2024": "47.8",
    "rang_2024": "417/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "72.2",
    "lens_2019": "75.4",
    "lens_2022": "61.9",
    "lens_2023": "66.3",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "78.8",
    "lsec_2019": "81.7",
    "lsec_2022": "67.8",
    "lsec_2023": "72.5",
    "lsec_2024": "86.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.5",
    "scie_2019": "66.5",
    "scie_2022": "63.3",
    "scie_2023": "68.1",
    "scie_2024": "60.3",
    "scie_trend": "998855",
    "math_2018": "75.2",
    "math_2019": "70.7",
    "math_2022": "70.0",
    "math_2023": "66.7",
    "math_2024": "75.2",
    "math_trend": "—",
    "echec_2018": "11.8",
    "echec_2019": "18.6",
    "echec_2022": "32.0",
    "echec_2023": "32.4",
    "echec_2024": "22.5",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "4.8",
    "sures_2022": "7.4",
    "sures_2023": "4.0",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 10.0",
    "ecart_sexes_lens_2024": "F 8.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 4.5",
    "ecart_sexes_math_2023": "F 17.0",
    "ecart_sexes_math_2024": "M 10.3",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "35.9",
    "prog_2019": "22.1",
    "prog_2022": "21.6",
    "prog_2023": "42.7",
    "prog_2024": "47.8",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.5",
    "cote_2022": "3.5",
    "cote_2023": "2.2",
    "cote_2024": "4.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de Gabriel-Le Courtois",
    "nom_court": "École de Gabriel-Le Courtois",
    "adresse": "170, boulevard Sainte-Anne Ouest",
    "municipalite": "Sainte-Anne-des-Monts",
    "code_postal": "G4V 1R8",
    "lat": 49.12244,
    "lng": -66.49402
  },
  {
    "_id": "158",
    "school_code": "812034",
    "school_name_1": "Antoine-Roy",
    "admin_body_number": "812000",
    "admin_body_name": "Centre de services scolaire des Chic-Chocs",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "188",
    "langue": "français",
    "secteur": "public",
    "rang": "445",
    "rang_5_ans": "424",
    "index": "0.1",
    "en_retard_2024": "7.1",
    "ehdaa_2024": "36.2",
    "rang_2024": "445/470",
    "rang_2019_2024": "424/432",
    "lens_2018": "65.8",
    "lens_2019": "69.5",
    "lens_2022": "61.4",
    "lens_2023": "60.9",
    "lens_2024": "65.3",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "79.8",
    "lsec_2022": "81.5",
    "lsec_2023": "83.4",
    "lsec_2024": "77.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.1",
    "scie_2019": "62.0",
    "scie_2022": "61.9",
    "scie_2023": "73.0",
    "scie_2024": "66.4",
    "scie_trend": "—",
    "math_2018": "46.4",
    "math_2019": "49.8",
    "math_2022": "52.1",
    "math_2023": "64.2",
    "math_2024": "61.6",
    "math_trend": "—",
    "echec_2018": "38.0",
    "echec_2019": "31.8",
    "echec_2022": "36.4",
    "echec_2023": "26.0",
    "echec_2024": "26.4",
    "echec_trend": "112233",
    "sures_2018": "14.7",
    "sures_2019": "9.6",
    "sures_2022": "12.5",
    "sures_2023": "9.8",
    "sures_2024": "10.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "M 3.6",
    "ecart_sexes_lens_2023": "F 13.8",
    "ecart_sexes_lens_2024": "F 10.2",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 10.3",
    "ecart_sexes_math_2023": "F 10.0",
    "ecart_sexes_math_2024": "F 3.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "10.0",
    "prog_2019": "17.9",
    "prog_2022": "23.9",
    "prog_2023": "34.6",
    "prog_2024": "27.2",
    "prog_trend": "998855",
    "cote_2018": "1.7",
    "cote_2019": "3.0",
    "cote_2022": "3.5",
    "cote_2023": "3.4",
    "cote_2024": "3.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Antoine-Roy",
    "nom_court": "École Antoine-Roy",
    "adresse": "110, boulevard Renard Est",
    "municipalite": "Gaspé",
    "code_postal": "G4X 5H8",
    "lat": 48.98965,
    "lng": -64.37978
  },
  {
    "_id": "159",
    "school_code": "812040",
    "school_name_1": "C.-E.-Pouliot",
    "admin_body_number": "812000",
    "admin_body_name": "Centre de services scolaire des Chic-Chocs",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "482",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "4.6",
    "ehdaa_2024": "34.9",
    "rang_2024": "260/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "63.6",
    "lens_2019": "68.1",
    "lens_2022": "63.5",
    "lens_2023": "61.8",
    "lens_2024": "63.4",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "79.1",
    "lsec_2022": "80.3",
    "lsec_2023": "80.3",
    "lsec_2024": "82.4",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.0",
    "scie_2019": "72.0",
    "scie_2022": "71.4",
    "scie_2023": "74.4",
    "scie_2024": "73.4",
    "scie_trend": "—",
    "math_2018": "64.7",
    "math_2019": "63.0",
    "math_2022": "73.6",
    "math_2023": "73.1",
    "math_2024": "78.7",
    "math_trend": "—",
    "echec_2018": "22.4",
    "echec_2019": "20.7",
    "echec_2022": "23.7",
    "echec_2023": "23.2",
    "echec_2024": "18.2",
    "echec_trend": "112233",
    "sures_2018": "6.2",
    "sures_2019": "6.8",
    "sures_2022": "9.1",
    "sures_2023": "7.1",
    "sures_2024": "7.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 12.4",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 10.5",
    "ecart_sexes_lens_2023": "F 10.3",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "F 9.0",
    "ecart_sexes_math_2022": "F 6.9",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "M 4.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "17.1",
    "prog_2019": "34.6",
    "prog_2022": "22.7",
    "prog_2023": "25.8",
    "prog_2024": "28.0",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "3.9",
    "cote_2022": "5.0",
    "cote_2023": "4.7",
    "cote_2024": "5.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École C.-E.-Pouliot",
    "nom_court": "École C.-E.-Pouliot",
    "adresse": "85, boulevard de Gaspé",
    "municipalite": "Gaspé",
    "code_postal": "G4X 2T8",
    "lat": 48.83689,
    "lng": -64.47757
  },
  {
    "_id": "160",
    "school_code": "813007",
    "school_name_1": "du Littoral",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "233",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "3.1",
    "ehdaa_2024": "33.5",
    "rang_2024": "376/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "71.7",
    "lens_2019": "72.5",
    "lens_2022": "64.1",
    "lens_2023": "56.9",
    "lens_2024": "65.7",
    "lens_trend": "—",
    "lsec_2018": "78.7",
    "lsec_2019": "75.8",
    "lsec_2022": "81.4",
    "lsec_2023": "71.7",
    "lsec_2024": "81.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.6",
    "scie_2019": "76.8",
    "scie_2022": "61.5",
    "scie_2023": "81.9",
    "scie_2024": "68.1",
    "scie_trend": "—",
    "math_2018": "84.5",
    "math_2019": "81.9",
    "math_2022": "70.1",
    "math_2023": "81.6",
    "math_2024": "83.5",
    "math_trend": "—",
    "echec_2018": "9.4",
    "echec_2019": "8.6",
    "echec_2022": "28.2",
    "echec_2023": "18.3",
    "echec_2024": "20.1",
    "echec_trend": "998855",
    "sures_2018": "1.1",
    "sures_2019": "0.2",
    "sures_2022": "3.1",
    "sures_2023": "0.1",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 14.5",
    "ecart_sexes_lens_2022": "F 12.0",
    "ecart_sexes_lens_2023": "F 13.6",
    "ecart_sexes_lens_2024": "F 8.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 1.9",
    "ecart_sexes_math_2022": "M 19.4",
    "ecart_sexes_math_2023": "F 3.9",
    "ecart_sexes_math_2024": "F 4.4",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "17.3",
    "prog_2019": "34.4",
    "prog_2022": "46.7",
    "prog_2023": "49.9",
    "prog_2024": "61.7",
    "prog_trend": "998855",
    "cote_2018": "7.0",
    "cote_2019": "6.4",
    "cote_2022": "3.7",
    "cote_2023": "4.4",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Littoral",
    "nom_court": "École du Littoral",
    "adresse": "188, rue du Carrefour",
    "municipalite": "Grande-Rivière",
    "code_postal": "G0C 1V0",
    "lat": 48.40311,
    "lng": -64.49745
  },
  {
    "_id": "161",
    "school_code": "813012",
    "school_name_1": "Monseigneur Sévigny",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "327",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "377",
    "index": "0.1",
    "en_retard_2024": "13.5",
    "ehdaa_2024": "36.1",
    "rang_2024": "409/470",
    "rang_2019_2024": "377/432",
    "lens_2018": "64.7",
    "lens_2019": "69.1",
    "lens_2022": "55.0",
    "lens_2023": "56.1",
    "lens_2024": "56.4",
    "lens_trend": "—",
    "lsec_2018": "78.0",
    "lsec_2019": "76.0",
    "lsec_2022": "78.8",
    "lsec_2023": "81.9",
    "lsec_2024": "78.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "73.7",
    "scie_2022": "72.8",
    "scie_2023": "69.7",
    "scie_2024": "67.4",
    "scie_trend": "—",
    "math_2018": "75.0",
    "math_2019": "78.7",
    "math_2022": "77.2",
    "math_2023": "63.7",
    "math_2024": "80.8",
    "math_trend": "—",
    "echec_2018": "20.0",
    "echec_2019": "11.9",
    "echec_2022": "25.8",
    "echec_2023": "30.9",
    "echec_2024": "20.8",
    "echec_trend": "—",
    "sures_2018": "4.7",
    "sures_2019": "1.8",
    "sures_2022": "4.4",
    "sures_2023": "4.1",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 11.5",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 14.5",
    "ecart_sexes_lens_2023": "F 8.2",
    "ecart_sexes_lens_2024": "F 13.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 15.7",
    "ecart_sexes_math_2019": "F 8.6",
    "ecart_sexes_math_2022": "F 7.3",
    "ecart_sexes_math_2023": "F 5.9",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "33.7",
    "prog_2019": "31.3",
    "prog_2022": "24.0",
    "prog_2023": "39.1",
    "prog_2024": "54.3",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "5.7",
    "cote_2022": "4.7",
    "cote_2023": "3.3",
    "cote_2024": "4.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente Monseigneur Sévigny",
    "nom_court": "École polyvalente Mgr Sévigny",
    "adresse": "155, rue Monseigneur Ross",
    "municipalite": "Chandler",
    "code_postal": "G0C 1K0",
    "lat": 48.35498,
    "lng": -64.68583
  },
  {
    "_id": "162",
    "school_code": "813022",
    "school_name_1": "Paspébiac",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "230",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "8.6",
    "ehdaa_2024": "43.5",
    "rang_2024": "260/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "72.7",
    "lens_2019": "71.5",
    "lens_2022": "66.7",
    "lens_2023": "62.0",
    "lens_2024": "67.7",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "77.7",
    "lsec_2022": "83.1",
    "lsec_2023": "82.1",
    "lsec_2024": "81.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.9",
    "scie_2019": "75.8",
    "scie_2022": "70.7",
    "scie_2023": "78.0",
    "scie_2024": "71.0",
    "scie_trend": "—",
    "math_2018": "71.9",
    "math_2019": "80.8",
    "math_2022": "73.3",
    "math_2023": "79.5",
    "math_2024": "73.0",
    "math_trend": "—",
    "echec_2018": "14.4",
    "echec_2019": "7.9",
    "echec_2022": "18.7",
    "echec_2023": "16.3",
    "echec_2024": "17.9",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.4",
    "sures_2022": "3.8",
    "sures_2023": "1.1",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.9",
    "ecart_sexes_lens_2019": "M 1.3",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 8.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "M 8.5",
    "ecart_sexes_math_2022": "M 5.3",
    "ecart_sexes_math_2023": "M 8.4",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.8",
    "prog_2019": "17.9",
    "prog_2022": "9.9",
    "prog_2023": "47.3",
    "prog_2024": "35.7",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "7.0",
    "cote_2022": "6.5",
    "cote_2023": "5.5",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente de Paspébiac",
    "nom_court": "École polyvalente de Paspébiac",
    "adresse": "158, Chapados",
    "municipalite": "Paspébiac",
    "code_postal": "G0C 2K0",
    "lat": 48.03438,
    "lng": -65.23976
  },
  {
    "_id": "163",
    "school_code": "813027",
    "school_name_1": "aux Quatre-Vents",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "296",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "2.4",
    "ehdaa_2024": "31.8",
    "rang_2024": "199/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "69.7",
    "lens_2019": "72.0",
    "lens_2022": "63.7",
    "lens_2023": "68.2",
    "lens_2024": "64.6",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "81.0",
    "lsec_2022": "75.5",
    "lsec_2023": "80.7",
    "lsec_2024": "77.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.4",
    "scie_2019": "75.3",
    "scie_2022": "78.1",
    "scie_2023": "81.5",
    "scie_2024": "78.7",
    "scie_trend": "112233",
    "math_2018": "70.1",
    "math_2019": "74.0",
    "math_2022": "68.3",
    "math_2023": "70.5",
    "math_2024": "80.4",
    "math_trend": "—",
    "echec_2018": "15.6",
    "echec_2019": "13.4",
    "echec_2022": "21.7",
    "echec_2023": "15.6",
    "echec_2024": "15.8",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.6",
    "sures_2022": "3.8",
    "sures_2023": "2.6",
    "sures_2024": "0.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 10.9",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 18.7",
    "ecart_sexes_math_2022": "F 20.1",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "M 8.3",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "36.3",
    "prog_2019": "22.6",
    "prog_2022": "20.1",
    "prog_2023": "33.2",
    "prog_2024": "33.0",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "5.8",
    "cote_2022": "5.2",
    "cote_2023": "6.1",
    "cote_2024": "6.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École aux Quatre-Vents",
    "nom_court": "École aux Quatre-Vents",
    "adresse": "143, avenue Louisbourg",
    "municipalite": "Bonaventure",
    "code_postal": "G0C 1E0",
    "lat": 48.05186,
    "lng": -65.4866
  },
  {
    "_id": "164",
    "school_code": "813036",
    "school_name_1": "Antoine-Bernard",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "525",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "10.1",
    "ehdaa_2024": "35.4",
    "rang_2024": "260/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "70.5",
    "lens_2019": "73.4",
    "lens_2022": "69.4",
    "lens_2023": "68.3",
    "lens_2024": "67.1",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "78.8",
    "lsec_2022": "78.8",
    "lsec_2023": "83.4",
    "lsec_2024": "78.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.1",
    "scie_2019": "70.0",
    "scie_2022": "75.9",
    "scie_2023": "80.3",
    "scie_2024": "70.9",
    "scie_trend": "—",
    "math_2018": "69.6",
    "math_2019": "75.3",
    "math_2022": "77.5",
    "math_2023": "71.7",
    "math_2024": "71.8",
    "math_trend": "—",
    "echec_2018": "14.0",
    "echec_2019": "16.8",
    "echec_2022": "13.1",
    "echec_2023": "13.8",
    "echec_2024": "21.5",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "0.7",
    "sures_2022": "1.3",
    "sures_2023": "2.1",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 1.4",
    "ecart_sexes_lens_2022": "F 0.8",
    "ecart_sexes_lens_2023": "F 6.3",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.7",
    "ecart_sexes_math_2019": "F 7.4",
    "ecart_sexes_math_2022": "M 6.5",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "F 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.2",
    "prog_2019": "27.4",
    "prog_2022": "28.2",
    "prog_2023": "22.4",
    "prog_2024": "24.1",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "6.1",
    "cote_2022": "6.7",
    "cote_2023": "6.6",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Antoine-Bernard",
    "nom_court": "École Antoine-Bernard",
    "adresse": "15, rue Comeau",
    "municipalite": "Carleton-sur-Mer",
    "code_postal": "G0C 1J0",
    "lat": 48.10418,
    "lng": -66.11625
  },
  {
    "_id": "165",
    "school_code": "813042",
    "school_name_1": "des Deux-Rivières",
    "admin_body_number": "813000",
    "admin_body_name": "Centre de services scolaire René-Lévesque",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "138",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "45.7",
    "rang_2024": "390/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "66.7",
    "lens_2019": "65.7",
    "lens_2022": "62.5",
    "lens_2023": "68.6",
    "lens_2024": "55.1",
    "lens_trend": "—",
    "lsec_2018": "80.5",
    "lsec_2019": "75.1",
    "lsec_2022": "80.4",
    "lsec_2023": "83.4",
    "lsec_2024": "85.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.0",
    "scie_2019": "63.8",
    "scie_2022": "66.5",
    "scie_2023": "71.3",
    "scie_2024": "66.8",
    "scie_trend": "—",
    "math_2018": "69.7",
    "math_2019": "69.7",
    "math_2022": "66.9",
    "math_2023": "70.2",
    "math_2024": "77.2",
    "math_trend": "—",
    "echec_2018": "19.3",
    "echec_2019": "25.2",
    "echec_2022": "24.8",
    "echec_2023": "18.8",
    "echec_2024": "21.9",
    "echec_trend": "—",
    "sures_2018": "5.4",
    "sures_2019": "4.6",
    "sures_2022": "6.7",
    "sures_2023": "5.6",
    "sures_2024": "5.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "4.8",
    "prog_2019": "15.8",
    "prog_2022": "30.9",
    "prog_2023": "27.1",
    "prog_2024": "51.2",
    "prog_trend": "998855",
    "cote_2018": "5.5",
    "cote_2019": "3.8",
    "cote_2022": "4.6",
    "cote_2023": "5.5",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École des Deux-Rivières",
    "nom_court": "École des Deux-Rivières",
    "adresse": "12, boulevard Perron Est",
    "municipalite": "Matapédia",
    "code_postal": "G0J 1V0",
    "lat": 47.97676,
    "lng": -66.93822
  },
  {
    "_id": "166",
    "school_code": "821216",
    "school_name_1": "Saint-Anselme",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "455",
    "langue": "français",
    "secteur": "public",
    "rang": "439",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "30.4",
    "ehdaa_2024": "36.9",
    "rang_2024": "439/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "68.3",
    "lens_2019": "66.6",
    "lens_2022": "63.6",
    "lens_2023": "64.2",
    "lens_2024": "60.4",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "79.0",
    "lsec_2022": "77.4",
    "lsec_2023": "74.5",
    "lsec_2024": "75.4",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.7",
    "scie_2019": "67.3",
    "scie_2022": "68.3",
    "scie_2023": "69.8",
    "scie_2024": "68.8",
    "scie_trend": "—",
    "math_2018": "76.4",
    "math_2019": "69.2",
    "math_2022": "68.8",
    "math_2023": "75.3",
    "math_2024": "71.1",
    "math_trend": "—",
    "echec_2018": "12.9",
    "echec_2019": "24.4",
    "echec_2022": "23.9",
    "echec_2023": "19.9",
    "echec_2024": "25.2",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "2.7",
    "sures_2022": "3.4",
    "sures_2023": "2.6",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 11.0",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 11.8",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 9.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.6",
    "ecart_sexes_math_2019": "F 4.9",
    "ecart_sexes_math_2022": "F 4.1",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "F 13.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "19.6",
    "prog_2019": "20.3",
    "prog_2022": "28.6",
    "prog_2023": "40.2",
    "prog_2024": "40.7",
    "prog_trend": "998855",
    "cote_2018": "6.1",
    "cote_2019": "5.1",
    "cote_2022": "4.8",
    "cote_2023": "5.0",
    "cote_2024": "3.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire de Saint-Anselme",
    "nom_court": "École secondaire de Saint-Anselme",
    "adresse": "825, route Bégin",
    "municipalite": "Saint-Anselme",
    "code_postal": "G0R 2N0",
    "lat": 46.63029,
    "lng": -70.96635
  },
  {
    "_id": "167",
    "school_code": "821227",
    "school_name_1": "Saint-Charles",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "507",
    "langue": "français",
    "secteur": "public",
    "rang": "103",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "8.8",
    "ehdaa_2024": "26.2",
    "rang_2024": "103/470",
    "rang_2019_2024": "nd",
    "lens_2018": "68.7",
    "lens_2019": "70.8",
    "lens_2022": "nd",
    "lens_2023": "71.8",
    "lens_2024": "67.5",
    "lens_trend": "nd",
    "lsec_2018": "78.7",
    "lsec_2019": "75.4",
    "lsec_2022": "nd",
    "lsec_2023": "86.1",
    "lsec_2024": "84.1",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.0",
    "scie_2019": "70.7",
    "scie_2022": "nd",
    "scie_2023": "77.2",
    "scie_2024": "75.4",
    "scie_trend": "nd",
    "math_2018": "73.0",
    "math_2019": "71.1",
    "math_2022": "nd",
    "math_2023": "82.7",
    "math_2024": "80.7",
    "math_trend": "nd",
    "echec_2018": "16.9",
    "echec_2019": "17.2",
    "echec_2022": "nd",
    "echec_2023": "6.0",
    "echec_2024": "11.4",
    "echec_trend": "nd",
    "sures_2018": "1.0",
    "sures_2019": "1.3",
    "sures_2022": "nd",
    "sures_2023": "0.3",
    "sures_2024": "2.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "F 2.9",
    "ecart_sexes_lens_2019": "F 7.8",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 5.4",
    "ecart_sexes_lens_2024": "M 1.1",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 8.4",
    "ecart_sexes_math_2019": "M 0.2",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 1.9",
    "ecart_sexes_math_2024": "F 2.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "18.8",
    "prog_2019": "26.6",
    "prog_2022": "nd",
    "prog_2023": "25.9",
    "prog_2024": "19.2",
    "prog_trend": "nd",
    "cote_2018": "5.8",
    "cote_2019": "5.6",
    "cote_2022": "nd",
    "cote_2023": "7.8",
    "cote_2024": "7.3",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de Saint-Charles",
    "nom_court": "École secondaire de Saint-Charles",
    "adresse": "24, avenue Saint-Georges",
    "municipalite": "Saint-Charles-de-Bellechasse",
    "code_postal": "G0R 2T0",
    "lat": 46.77412,
    "lng": -70.9419
  },
  {
    "_id": "168",
    "school_code": "821237",
    "school_name_1": "Saint-Damien",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "353",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "11.8",
    "ehdaa_2024": "27.5",
    "rang_2024": "156/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "74.3",
    "lens_2019": "72.5",
    "lens_2022": "67.6",
    "lens_2023": "68.8",
    "lens_2024": "71.5",
    "lens_trend": "—",
    "lsec_2018": "73.7",
    "lsec_2019": "74.9",
    "lsec_2022": "76.5",
    "lsec_2023": "77.9",
    "lsec_2024": "75.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.3",
    "scie_2019": "76.6",
    "scie_2022": "77.1",
    "scie_2023": "76.3",
    "scie_2024": "73.5",
    "scie_trend": "—",
    "math_2018": "83.1",
    "math_2019": "76.9",
    "math_2022": "77.9",
    "math_2023": "68.8",
    "math_2024": "68.4",
    "math_trend": "998855",
    "echec_2018": "4.4",
    "echec_2019": "7.4",
    "echec_2022": "12.0",
    "echec_2023": "13.7",
    "echec_2024": "16.0",
    "echec_trend": "998855",
    "sures_2018": "1.0",
    "sures_2019": "1.3",
    "sures_2022": "1.5",
    "sures_2023": "3.3",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.3",
    "ecart_sexes_lens_2019": "M 2.3",
    "ecart_sexes_lens_2022": "F 4.8",
    "ecart_sexes_lens_2023": "F 2.9",
    "ecart_sexes_lens_2024": "F 3.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.8",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 2.4",
    "ecart_sexes_math_2023": "F 6.7",
    "ecart_sexes_math_2024": "M 2.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.4",
    "prog_2019": "2.0",
    "prog_2022": "12.0",
    "prog_2023": "8.7",
    "prog_2024": "9.4",
    "prog_trend": "—",
    "cote_2018": "7.7",
    "cote_2019": "7.3",
    "cote_2022": "6.9",
    "cote_2023": "6.2",
    "cote_2024": "6.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire de Saint-Damien",
    "nom_court": "École secondaire de Saint-Damien",
    "adresse": "70, route Saint-Gérard",
    "municipalite": "Saint-Damien-de-Buckland",
    "code_postal": "G0R 2Y0",
    "lat": 46.6287,
    "lng": -70.66723
  },
  {
    "_id": "169",
    "school_code": "821247",
    "school_name_1": "Louis-Jacques-Casault",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "787",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "17.1",
    "ehdaa_2024": "26.8",
    "rang_2024": "299/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "74.4",
    "lens_2019": "73.7",
    "lens_2022": "72.1",
    "lens_2023": "72.0",
    "lens_2024": "67.3",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "76.2",
    "lsec_2022": "78.9",
    "lsec_2023": "74.8",
    "lsec_2024": "73.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.6",
    "scie_2019": "72.0",
    "scie_2022": "66.4",
    "scie_2023": "69.9",
    "scie_2024": "66.4",
    "scie_trend": "—",
    "math_2018": "78.3",
    "math_2019": "76.1",
    "math_2022": "78.5",
    "math_2023": "76.9",
    "math_2024": "81.4",
    "math_trend": "—",
    "echec_2018": "12.8",
    "echec_2019": "15.2",
    "echec_2022": "16.4",
    "echec_2023": "16.5",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "1.6",
    "sures_2022": "3.4",
    "sures_2023": "2.1",
    "sures_2024": "4.3",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 9.9",
    "ecart_sexes_lens_2022": "F 6.2",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.6",
    "ecart_sexes_math_2019": "F 5.6",
    "ecart_sexes_math_2022": "F 7.0",
    "ecart_sexes_math_2023": "F 8.0",
    "ecart_sexes_math_2024": "F 3.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.9",
    "prog_2019": "21.5",
    "prog_2022": "34.3",
    "prog_2023": "28.2",
    "prog_2024": "26.9",
    "prog_trend": "—",
    "cote_2018": "6.3",
    "cote_2019": "5.9",
    "cote_2022": "5.8",
    "cote_2023": "5.7",
    "cote_2024": "5.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Louis-Jacques-Casault",
    "nom_court": "École secondaire Louis-Jacques-Casault",
    "adresse": "141, boulevard Taché Est",
    "municipalite": "Montmagny",
    "code_postal": "G5V 1B9",
    "lat": 46.9849,
    "lng": -70.55828
  },
  {
    "_id": "170",
    "school_code": "821251",
    "school_name_1": "Bon-Pasteur",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "342",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "399",
    "index": "0.1",
    "en_retard_2024": "13.6",
    "ehdaa_2024": "29.2",
    "rang_2024": "376/470",
    "rang_2019_2024": "399/432",
    "lens_2018": "65.4",
    "lens_2019": "64.1",
    "lens_2022": "62.7",
    "lens_2023": "63.0",
    "lens_2024": "58.2",
    "lens_trend": "—",
    "lsec_2018": "73.2",
    "lsec_2019": "76.6",
    "lsec_2022": "77.8",
    "lsec_2023": "73.6",
    "lsec_2024": "73.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.3",
    "scie_2019": "66.8",
    "scie_2022": "65.7",
    "scie_2023": "69.9",
    "scie_2024": "63.4",
    "scie_trend": "112233",
    "math_2018": "63.1",
    "math_2019": "70.5",
    "math_2022": "64.1",
    "math_2023": "69.6",
    "math_2024": "75.3",
    "math_trend": "—",
    "echec_2018": "29.7",
    "echec_2019": "23.2",
    "echec_2022": "28.5",
    "echec_2023": "26.0",
    "echec_2024": "26.0",
    "echec_trend": "—",
    "sures_2018": "5.4",
    "sures_2019": "4.4",
    "sures_2022": "6.2",
    "sures_2023": "2.4",
    "sures_2024": "5.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.3",
    "ecart_sexes_lens_2019": "F 7.2",
    "ecart_sexes_lens_2022": "F 16.3",
    "ecart_sexes_lens_2023": "F 7.6",
    "ecart_sexes_lens_2024": "F 5.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.6",
    "ecart_sexes_math_2019": "M 7.2",
    "ecart_sexes_math_2022": "F 5.8",
    "ecart_sexes_math_2023": "M 3.8",
    "ecart_sexes_math_2024": "M 1.1",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "41.5",
    "prog_2019": "27.3",
    "prog_2022": "20.4",
    "prog_2023": "30.8",
    "prog_2024": "18.3",
    "prog_trend": "112233",
    "cote_2018": "2.6",
    "cote_2019": "4.2",
    "cote_2022": "4.1",
    "cote_2023": "4.5",
    "cote_2024": "4.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Bon-Pasteur",
    "nom_court": "École secondaire Bon-Pasteur",
    "adresse": "166, chemin des Pionniers Ouest",
    "municipalite": "L'Islet",
    "code_postal": "G0R 2B0",
    "lat": 47.11966,
    "lng": -70.37695
  },
  {
    "_id": "171",
    "school_code": "821261",
    "school_name_1": "Saint-Paul",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "133",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "17.4",
    "ehdaa_2024": "35.3",
    "rang_2024": "335/470",
    "rang_2019_2024": "nd",
    "lens_2018": "64.9",
    "lens_2019": "nd",
    "lens_2022": "59.4",
    "lens_2023": "58.6",
    "lens_2024": "68.2",
    "lens_trend": "nd",
    "lsec_2018": "72.7",
    "lsec_2019": "nd",
    "lsec_2022": "75.5",
    "lsec_2023": "72.0",
    "lsec_2024": "75.4",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.1",
    "scie_2019": "nd",
    "scie_2022": "66.3",
    "scie_2023": "71.7",
    "scie_2024": "69.4",
    "scie_trend": "nd",
    "math_2018": "71.8",
    "math_2019": "nd",
    "math_2022": "60.9",
    "math_2023": "73.4",
    "math_2024": "80.5",
    "math_trend": "nd",
    "echec_2018": "17.4",
    "echec_2019": "nd",
    "echec_2022": "25.9",
    "echec_2023": "25.2",
    "echec_2024": "21.4",
    "echec_trend": "nd",
    "sures_2018": "3.5",
    "sures_2019": "nd",
    "sures_2022": "5.2",
    "sures_2023": "5.3",
    "sures_2024": "2.7",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "M 0.6",
    "ecart_sexes_lens_2024": "M 2.1",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "F 8.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "33.1",
    "prog_2019": "nd",
    "prog_2022": "15.0",
    "prog_2023": "56.3",
    "prog_2024": "54.7",
    "prog_trend": "nd",
    "cote_2018": "4.7",
    "cote_2019": "nd",
    "cote_2022": "4.9",
    "cote_2023": "3.8",
    "cote_2024": "5.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de Saint-Paul",
    "nom_court": "École secondaire de Saint-Paul",
    "adresse": "420, route 283",
    "municipalite": "Saint-Paul-de-Montminy",
    "code_postal": "G0R 3Y0",
    "lat": 46.74311,
    "lng": -70.33262
  },
  {
    "_id": "172",
    "school_code": "821277",
    "school_name_1": "de la Rencontre",
    "admin_body_number": "821000",
    "admin_body_name": "Centre de services scolaire de la Côte-du-Sud",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "261",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "11.1",
    "ehdaa_2024": "30.7",
    "rang_2024": "409/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "70.0",
    "lens_2019": "66.6",
    "lens_2022": "66.0",
    "lens_2023": "64.0",
    "lens_2024": "62.2",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "74.5",
    "lsec_2022": "76.6",
    "lsec_2023": "75.3",
    "lsec_2024": "75.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.7",
    "scie_2019": "77.0",
    "scie_2022": "74.1",
    "scie_2023": "73.1",
    "scie_2024": "66.7",
    "scie_trend": "998855",
    "math_2018": "76.3",
    "math_2019": "76.7",
    "math_2022": "74.3",
    "math_2023": "68.8",
    "math_2024": "69.0",
    "math_trend": "998855",
    "echec_2018": "14.1",
    "echec_2019": "12.3",
    "echec_2022": "14.6",
    "echec_2023": "22.4",
    "echec_2024": "24.5",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "3.6",
    "sures_2022": "1.9",
    "sures_2023": "2.0",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 10.0",
    "ecart_sexes_lens_2023": "F 6.7",
    "ecart_sexes_lens_2024": "F 8.7",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 9.1",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "M 11.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "20.3",
    "prog_2019": "44.0",
    "prog_2022": "29.9",
    "prog_2023": "16.3",
    "prog_2024": "25.8",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "5.3",
    "cote_2022": "5.9",
    "cote_2023": "5.3",
    "cote_2024": "4.2",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire de la Rencontre",
    "nom_court": "École secondaire de la Rencontre",
    "adresse": "240, rue Saint-Pierre",
    "municipalite": "Saint-Pamphile",
    "code_postal": "G0R 3X0",
    "lat": 46.96006,
    "lng": -69.79104
  },
  {
    "_id": "173",
    "school_code": "822040",
    "school_name_1": "Disraeli",
    "admin_body_number": "822000",
    "admin_body_name": "Centre de services scolaire des Appalaches",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "568",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "417",
    "index": "0.1",
    "en_retard_2024": "23.9",
    "ehdaa_2024": "23.8",
    "rang_2024": "409/470",
    "rang_2019_2024": "417/432",
    "lens_2018": "67.0",
    "lens_2019": "66.9",
    "lens_2022": "64.4",
    "lens_2023": "66.1",
    "lens_2024": "68.8",
    "lens_trend": "112233",
    "lsec_2018": "79.0",
    "lsec_2019": "73.3",
    "lsec_2022": "78.8",
    "lsec_2023": "74.2",
    "lsec_2024": "80.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.1",
    "scie_2019": "62.6",
    "scie_2022": "66.1",
    "scie_2023": "70.7",
    "scie_2024": "65.3",
    "scie_trend": "112233",
    "math_2018": "64.5",
    "math_2019": "68.0",
    "math_2022": "54.3",
    "math_2023": "68.5",
    "math_2024": "67.5",
    "math_trend": "—",
    "echec_2018": "29.6",
    "echec_2019": "26.2",
    "echec_2022": "30.2",
    "echec_2023": "18.5",
    "echec_2024": "25.5",
    "echec_trend": "112233",
    "sures_2018": "4.5",
    "sures_2019": "4.3",
    "sures_2022": "5.7",
    "sures_2023": "2.0",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 11.6",
    "ecart_sexes_lens_2019": "M 1.6",
    "ecart_sexes_lens_2022": "F 11.6",
    "ecart_sexes_lens_2023": "F 2.1",
    "ecart_sexes_lens_2024": "F 4.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 11.7",
    "ecart_sexes_math_2019": "F 17.3",
    "ecart_sexes_math_2022": "M 11.5",
    "ecart_sexes_math_2023": "F 7.2",
    "ecart_sexes_math_2024": "M 7.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.3",
    "prog_2019": "34.7",
    "prog_2022": "50.6",
    "prog_2023": "61.8",
    "prog_2024": "38.2",
    "prog_trend": "—",
    "cote_2018": "2.8",
    "cote_2019": "3.0",
    "cote_2022": "3.0",
    "cote_2023": "4.1",
    "cote_2024": "4.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente de Disraeli",
    "nom_court": "Polyvalente de Disraeli",
    "adresse": "950, rue Saint-Gérard",
    "municipalite": "Disraeli",
    "code_postal": "G0N 1E0",
    "lat": 45.9091,
    "lng": -71.35245
  },
  {
    "_id": "174",
    "school_code": "822042",
    "school_name_1": "Black Lake",
    "admin_body_number": "822000",
    "admin_body_name": "Centre de services scolaire des Appalaches",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "453",
    "langue": "français",
    "secteur": "public",
    "rang": "132",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "3.4",
    "ehdaa_2024": "17.4",
    "rang_2024": "132/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "71.5",
    "lens_2019": "72.5",
    "lens_2022": "67.6",
    "lens_2023": "72.2",
    "lens_2024": "73.7",
    "lens_trend": "112233",
    "lsec_2018": "73.0",
    "lsec_2019": "75.3",
    "lsec_2022": "82.7",
    "lsec_2023": "83.1",
    "lsec_2024": "83.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.8",
    "scie_2019": "73.2",
    "scie_2022": "65.4",
    "scie_2023": "79.4",
    "scie_2024": "74.0",
    "scie_trend": "—",
    "math_2018": "68.9",
    "math_2019": "79.0",
    "math_2022": "60.6",
    "math_2023": "74.8",
    "math_2024": "73.6",
    "math_trend": "—",
    "echec_2018": "19.2",
    "echec_2019": "12.3",
    "echec_2022": "25.7",
    "echec_2023": "10.6",
    "echec_2024": "11.8",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "1.6",
    "sures_2022": "6.1",
    "sures_2023": "1.8",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 4.5",
    "ecart_sexes_lens_2023": "F 4.3",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 13.4",
    "ecart_sexes_math_2019": "F 5.2",
    "ecart_sexes_math_2022": "M 2.2",
    "ecart_sexes_math_2023": "F 3.0",
    "ecart_sexes_math_2024": "F 4.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.1",
    "prog_2019": "23.1",
    "prog_2022": "14.8",
    "prog_2023": "30.9",
    "prog_2024": "21.7",
    "prog_trend": "—",
    "cote_2018": "4.9",
    "cote_2019": "6.3",
    "cote_2022": "5.4",
    "cote_2023": "6.7",
    "cote_2024": "6.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente de Black Lake",
    "nom_court": "Polyvalente de Black Lake",
    "adresse": "499, rue Saint-Désiré",
    "municipalite": "Thetford Mines",
    "code_postal": "G6H 1L7",
    "lat": 46.04782,
    "lng": -71.36256
  },
  {
    "_id": "175",
    "school_code": "822045",
    "school_name_1": "Thetford Mines",
    "admin_body_number": "822000",
    "admin_body_name": "Centre de services scolaire des Appalaches",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "1080",
    "langue": "français",
    "secteur": "public",
    "rang": "367",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "14.2",
    "ehdaa_2024": "24",
    "rang_2024": "367/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "66.1",
    "lens_2019": "65.4",
    "lens_2022": "66.6",
    "lens_2023": "66.8",
    "lens_2024": "63.4",
    "lens_trend": "—",
    "lsec_2018": "79.0",
    "lsec_2019": "80.9",
    "lsec_2022": "78.0",
    "lsec_2023": "76.7",
    "lsec_2024": "76.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.1",
    "scie_2019": "66.9",
    "scie_2022": "69.0",
    "scie_2023": "71.6",
    "scie_2024": "69.0",
    "scie_trend": "—",
    "math_2018": "67.2",
    "math_2019": "69.7",
    "math_2022": "68.8",
    "math_2023": "68.4",
    "math_2024": "72.0",
    "math_trend": "—",
    "echec_2018": "22.3",
    "echec_2019": "24.4",
    "echec_2022": "21.8",
    "echec_2023": "22.5",
    "echec_2024": "23.9",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.2",
    "sures_2022": "3.4",
    "sures_2023": "2.5",
    "sures_2024": "2.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.0",
    "ecart_sexes_lens_2019": "F 7.9",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 6.7",
    "ecart_sexes_lens_2024": "F 5.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 10.8",
    "ecart_sexes_math_2019": "F 11.6",
    "ecart_sexes_math_2022": "F 4.2",
    "ecart_sexes_math_2023": "M 5.1",
    "ecart_sexes_math_2024": "F 5.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "45.2",
    "prog_2019": "41.8",
    "prog_2022": "20.5",
    "prog_2023": "21.8",
    "prog_2024": "28.0",
    "prog_trend": "112233",
    "cote_2018": "3.9",
    "cote_2019": "4.0",
    "cote_2022": "5.6",
    "cote_2023": "4.9",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente de Thetford Mines",
    "nom_court": "Polyvalente de Thetford Mines",
    "adresse": "561, rue Saint-Patrick",
    "municipalite": "Thetford Mines",
    "code_postal": "G6G 5W1",
    "lat": 46.08528,
    "lng": -71.29038
  },
  {
    "_id": "176",
    "school_code": "823017",
    "school_name_1": "Veilleux",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "1063",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "6.7",
    "ehdaa_2024": "20.3",
    "rang_2024": "323/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "70.6",
    "lens_2019": "71.6",
    "lens_2022": "65.6",
    "lens_2023": "63.1",
    "lens_2024": "62.6",
    "lens_trend": "998855",
    "lsec_2018": "79.9",
    "lsec_2019": "76.7",
    "lsec_2022": "84.2",
    "lsec_2023": "84.6",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.0",
    "scie_2019": "70.0",
    "scie_2022": "67.0",
    "scie_2023": "70.5",
    "scie_2024": "69.8",
    "scie_trend": "—",
    "math_2018": "66.7",
    "math_2019": "68.2",
    "math_2022": "63.9",
    "math_2023": "66.9",
    "math_2024": "77.7",
    "math_trend": "—",
    "echec_2018": "19.6",
    "echec_2019": "19.7",
    "echec_2022": "26.1",
    "echec_2023": "25.0",
    "echec_2024": "22.5",
    "echec_trend": "—",
    "sures_2018": "3.4",
    "sures_2019": "3.8",
    "sures_2022": "8.5",
    "sures_2023": "6.8",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.3",
    "ecart_sexes_lens_2019": "F 5.9",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 11.3",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.2",
    "ecart_sexes_math_2019": "F 1.4",
    "ecart_sexes_math_2022": "M 2.0",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "F 2.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "22.6",
    "prog_2019": "27.1",
    "prog_2022": "14.8",
    "prog_2023": "20.1",
    "prog_2024": "27.4",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "4.7",
    "cote_2022": "5.0",
    "cote_2023": "4.2",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Veilleux",
    "nom_court": "École secondaire Veilleux",
    "adresse": "695, avenue Robert-Cliche",
    "municipalite": "Saint-Joseph-de-Beauce",
    "code_postal": "G0S 2V0",
    "lat": 46.31497,
    "lng": -70.87964
  },
  {
    "_id": "177",
    "school_code": "823018",
    "school_name_1": "Saint-François",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "703",
    "langue": "français",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "3.6",
    "ehdaa_2024": "18.5",
    "rang_2024": "199/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "70.5",
    "lens_2019": "68.7",
    "lens_2022": "68.2",
    "lens_2023": "68.2",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "83.8",
    "lsec_2019": "77.4",
    "lsec_2022": "85.4",
    "lsec_2023": "82.3",
    "lsec_2024": "78.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.3",
    "scie_2019": "78.1",
    "scie_2022": "78.5",
    "scie_2023": "82.6",
    "scie_2024": "72.3",
    "scie_trend": "—",
    "math_2018": "79.2",
    "math_2019": "78.6",
    "math_2022": "75.3",
    "math_2023": "80.0",
    "math_2024": "78.2",
    "math_trend": "—",
    "echec_2018": "8.9",
    "echec_2019": "12.4",
    "echec_2022": "17.4",
    "echec_2023": "14.6",
    "echec_2024": "17.8",
    "echec_trend": "998855",
    "sures_2018": "2.3",
    "sures_2019": "2.0",
    "sures_2022": "4.2",
    "sures_2023": "3.1",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.6",
    "ecart_sexes_lens_2019": "M 0.9",
    "ecart_sexes_lens_2022": "F 8.8",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.2",
    "ecart_sexes_math_2019": "M 1.6",
    "ecart_sexes_math_2022": "F 5.8",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "23.2",
    "prog_2019": "12.1",
    "prog_2022": "12.1",
    "prog_2023": "17.9",
    "prog_2024": "12.7",
    "prog_trend": "—",
    "cote_2018": "7.0",
    "cote_2019": "6.7",
    "cote_2022": "6.9",
    "cote_2023": "6.7",
    "cote_2024": "6.2",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Polyvalente Saint-François",
    "nom_court": "Polyvalente Saint-François",
    "adresse": "228, avenue Lambert",
    "municipalite": "Beauceville",
    "code_postal": "G5X 3N9",
    "lat": 46.21065,
    "lng": -70.77895
  },
  {
    "_id": "178",
    "school_code": "823022",
    "school_name_1": "Saint-Georges",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "1777",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "7.5",
    "ehdaa_2024": "28.7",
    "rang_2024": "260/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "66.7",
    "lens_2019": "67.3",
    "lens_2022": "67.0",
    "lens_2023": "68.4",
    "lens_2024": "67.5",
    "lens_trend": "112233",
    "lsec_2018": "77.4",
    "lsec_2019": "81.5",
    "lsec_2022": "78.8",
    "lsec_2023": "81.8",
    "lsec_2024": "79.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.0",
    "scie_2019": "64.2",
    "scie_2022": "66.0",
    "scie_2023": "74.0",
    "scie_2024": "68.2",
    "scie_trend": "—",
    "math_2018": "69.9",
    "math_2019": "73.2",
    "math_2022": "78.7",
    "math_2023": "74.6",
    "math_2024": "83.2",
    "math_trend": "—",
    "echec_2018": "20.1",
    "echec_2019": "21.1",
    "echec_2022": "19.0",
    "echec_2023": "14.7",
    "echec_2024": "17.4",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "4.0",
    "sures_2022": "3.7",
    "sures_2023": "1.8",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.7",
    "ecart_sexes_lens_2019": "F 4.6",
    "ecart_sexes_lens_2022": "F 8.7",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 7.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.0",
    "ecart_sexes_math_2019": "F 6.4",
    "ecart_sexes_math_2022": "F 0.4",
    "ecart_sexes_math_2023": "E",
    "ecart_sexes_math_2024": "F 4.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "43.9",
    "prog_2019": "40.3",
    "prog_2022": "30.7",
    "prog_2023": "40.2",
    "prog_2024": "27.1",
    "prog_trend": "112233",
    "cote_2018": "4.3",
    "cote_2019": "4.4",
    "cote_2022": "5.6",
    "cote_2023": "5.8",
    "cote_2024": "5.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente de Saint-Georges",
    "nom_court": "Polyvalente de Saint-Georges",
    "adresse": "2121, 119e Rue Est",
    "municipalite": "Saint-Georges",
    "code_postal": "G5Y 5S1",
    "lat": 46.12935,
    "lng": -70.66126
  },
  {
    "_id": "179",
    "school_code": "823045",
    "school_name_1": "des Abénaquis",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "427",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "8.2",
    "ehdaa_2024": "35.4",
    "rang_2024": "323/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "69.3",
    "lens_2019": "66.9",
    "lens_2022": "66.0",
    "lens_2023": "65.2",
    "lens_2024": "65.0",
    "lens_trend": "—",
    "lsec_2018": "74.8",
    "lsec_2019": "77.7",
    "lsec_2022": "80.1",
    "lsec_2023": "78.8",
    "lsec_2024": "82.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.9",
    "scie_2019": "72.7",
    "scie_2022": "67.7",
    "scie_2023": "74.7",
    "scie_2024": "69.2",
    "scie_trend": "—",
    "math_2018": "63.3",
    "math_2019": "70.6",
    "math_2022": "63.5",
    "math_2023": "72.9",
    "math_2024": "76.4",
    "math_trend": "—",
    "echec_2018": "24.0",
    "echec_2019": "21.9",
    "echec_2022": "24.5",
    "echec_2023": "17.8",
    "echec_2024": "18.8",
    "echec_trend": "112233",
    "sures_2018": "6.0",
    "sures_2019": "5.0",
    "sures_2022": "9.4",
    "sures_2023": "4.3",
    "sures_2024": "6.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.3",
    "ecart_sexes_lens_2019": "F 1.7",
    "ecart_sexes_lens_2022": "F 6.5",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 9.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 7.6",
    "ecart_sexes_math_2019": "M 4.4",
    "ecart_sexes_math_2022": "M 6.7",
    "ecart_sexes_math_2023": "M 3.2",
    "ecart_sexes_math_2024": "M 3.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.9",
    "prog_2019": "39.6",
    "prog_2022": "27.4",
    "prog_2023": "24.1",
    "prog_2024": "27.7",
    "prog_trend": "112233",
    "cote_2018": "3.3",
    "cote_2019": "4.1",
    "cote_2022": "4.5",
    "cote_2023": "5.4",
    "cote_2024": "5.1",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente des Abénaquis",
    "nom_court": "Polyvalente des Abénaquis",
    "adresse": "2105, 25e Avenue",
    "municipalite": "Saint-Prosper",
    "code_postal": "G0M 1Y0",
    "lat": 46.21799,
    "lng": -70.48354
  },
  {
    "_id": "180",
    "school_code": "823046",
    "school_name_1": "des Appalaches",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "344",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "11.6",
    "ehdaa_2024": "19.8",
    "rang_2024": "348/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "71.5",
    "lens_2019": "66.5",
    "lens_2022": "72.8",
    "lens_2023": "67.2",
    "lens_2024": "63.2",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "79.3",
    "lsec_2022": "85.8",
    "lsec_2023": "79.0",
    "lsec_2024": "82.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.5",
    "scie_2019": "73.3",
    "scie_2022": "60.9",
    "scie_2023": "73.2",
    "scie_2024": "70.7",
    "scie_trend": "—",
    "math_2018": "64.3",
    "math_2019": "68.4",
    "math_2022": "64.4",
    "math_2023": "73.3",
    "math_2024": "77.7",
    "math_trend": "112233",
    "echec_2018": "18.2",
    "echec_2019": "19.0",
    "echec_2022": "26.9",
    "echec_2023": "17.3",
    "echec_2024": "18.2",
    "echec_trend": "—",
    "sures_2018": "4.9",
    "sures_2019": "6.9",
    "sures_2022": "10.1",
    "sures_2023": "3.3",
    "sures_2024": "5.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 13.8",
    "ecart_sexes_lens_2019": "F 8.1",
    "ecart_sexes_lens_2022": "F 6.6",
    "ecart_sexes_lens_2023": "F 5.5",
    "ecart_sexes_lens_2024": "F 9.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 10.1",
    "ecart_sexes_math_2019": "F 10.4",
    "ecart_sexes_math_2022": "F 6.1",
    "ecart_sexes_math_2023": "F 5.6",
    "ecart_sexes_math_2024": "F 8.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.5",
    "prog_2019": "26.4",
    "prog_2022": "18.3",
    "prog_2023": "23.6",
    "prog_2024": "32.3",
    "prog_trend": "—",
    "cote_2018": "4.5",
    "cote_2019": "4.0",
    "cote_2022": "4.7",
    "cote_2023": "5.4",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École des Appalaches",
    "nom_court": "École des Appalaches",
    "adresse": "135, boulevard Lessard",
    "municipalite": "Sainte-Justine",
    "code_postal": "G0R 1Y0",
    "lat": 46.40676,
    "lng": -70.36034
  },
  {
    "_id": "181",
    "school_code": "823074",
    "school_name_1": "Benoît-Vachon",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "1812",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "11.6",
    "ehdaa_2024": "31.2",
    "rang_2024": "260/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "70.1",
    "lens_2019": "69.4",
    "lens_2022": "68.7",
    "lens_2023": "69.6",
    "lens_2024": "66.9",
    "lens_trend": "—",
    "lsec_2018": "78.7",
    "lsec_2019": "78.2",
    "lsec_2022": "79.7",
    "lsec_2023": "76.1",
    "lsec_2024": "76.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.2",
    "scie_2019": "68.6",
    "scie_2022": "71.2",
    "scie_2023": "75.9",
    "scie_2024": "72.3",
    "scie_trend": "112233",
    "math_2018": "71.1",
    "math_2019": "71.7",
    "math_2022": "74.9",
    "math_2023": "76.3",
    "math_2024": "77.5",
    "math_trend": "—",
    "echec_2018": "18.1",
    "echec_2019": "19.5",
    "echec_2022": "17.8",
    "echec_2023": "14.4",
    "echec_2024": "16.8",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "2.3",
    "sures_2022": "2.2",
    "sures_2023": "1.2",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.7",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 7.1",
    "ecart_sexes_lens_2023": "F 4.1",
    "ecart_sexes_lens_2024": "F 6.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "F 5.5",
    "ecart_sexes_math_2022": "F 1.8",
    "ecart_sexes_math_2023": "F 4.4",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.2",
    "prog_2019": "36.0",
    "prog_2022": "20.4",
    "prog_2023": "30.4",
    "prog_2024": "23.5",
    "prog_trend": "112233",
    "cote_2018": "4.8",
    "cote_2019": "4.7",
    "cote_2022": "6.2",
    "cote_2023": "5.9",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Benoît-Vachon",
    "nom_court": "Polyvalente Benoît-Vachon",
    "adresse": "919, route Saint-Martin",
    "municipalite": "Sainte-Marie",
    "code_postal": "G6E 1E6",
    "lat": 46.45535,
    "lng": -71.0256
  },
  {
    "_id": "182",
    "school_code": "823095",
    "school_name_1": "Bélanger",
    "admin_body_number": "823000",
    "admin_body_name": "Centre de services scolaire de la Beauce-Etchemin",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "708",
    "langue": "français",
    "secteur": "public",
    "rang": "417",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "12.8",
    "ehdaa_2024": "24.3",
    "rang_2024": "417/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "67.1",
    "lens_2019": "68.7",
    "lens_2022": "64.2",
    "lens_2023": "62.8",
    "lens_2024": "63.9",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "80.5",
    "lsec_2022": "81.3",
    "lsec_2023": "79.0",
    "lsec_2024": "82.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.6",
    "scie_2019": "66.9",
    "scie_2022": "63.1",
    "scie_2023": "71.3",
    "scie_2024": "63.8",
    "scie_trend": "—",
    "math_2018": "72.6",
    "math_2019": "71.7",
    "math_2022": "75.7",
    "math_2023": "68.9",
    "math_2024": "70.7",
    "math_trend": "—",
    "echec_2018": "17.9",
    "echec_2019": "18.9",
    "echec_2022": "26.6",
    "echec_2023": "23.1",
    "echec_2024": "25.0",
    "echec_trend": "998855",
    "sures_2018": "2.3",
    "sures_2019": "3.0",
    "sures_2022": "5.1",
    "sures_2023": "5.1",
    "sures_2024": "4.9",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "F 1.3",
    "ecart_sexes_lens_2022": "F 9.1",
    "ecart_sexes_lens_2023": "F 5.1",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.8",
    "ecart_sexes_math_2019": "M 2.2",
    "ecart_sexes_math_2022": "F 8.7",
    "ecart_sexes_math_2023": "F 0.6",
    "ecart_sexes_math_2024": "F 10.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.6",
    "prog_2019": "23.9",
    "prog_2022": "27.8",
    "prog_2023": "27.1",
    "prog_2024": "39.2",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "5.3",
    "cote_2022": "4.7",
    "cote_2023": "4.7",
    "cote_2024": "4.1",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Polyvalente Bélanger",
    "nom_court": "Polyvalente Bélanger",
    "adresse": "30 A, chemin de la Polyvalente",
    "municipalite": "Saint-Martin",
    "code_postal": "G0M 1B0",
    "lat": 45.95691,
    "lng": -70.64982
  },
  {
    "_id": "183",
    "school_code": "824214",
    "school_name_1": "Pointe-Lévy",
    "admin_body_number": "824000",
    "admin_body_name": "Centre de services scolaire des Navigateurs",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "2343",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "12.9",
    "ehdaa_2024": "15.8",
    "rang_2024": "217/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "69.8",
    "lens_2019": "70.1",
    "lens_2022": "66.3",
    "lens_2023": "68.6",
    "lens_2024": "66.7",
    "lens_trend": "—",
    "lsec_2018": "81.9",
    "lsec_2019": "78.6",
    "lsec_2022": "76.6",
    "lsec_2023": "76.7",
    "lsec_2024": "77.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.9",
    "scie_2019": "73.1",
    "scie_2022": "73.0",
    "scie_2023": "76.9",
    "scie_2024": "69.9",
    "scie_trend": "—",
    "math_2018": "72.5",
    "math_2019": "72.5",
    "math_2022": "71.7",
    "math_2023": "75.1",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "15.3",
    "echec_2019": "14.3",
    "echec_2022": "20.7",
    "echec_2023": "15.1",
    "echec_2024": "18.7",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.8",
    "sures_2022": "2.4",
    "sures_2023": "1.2",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 5.5",
    "ecart_sexes_lens_2022": "F 4.6",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.8",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "M 2.4",
    "ecart_sexes_math_2023": "F 2.8",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.2",
    "prog_2019": "24.7",
    "prog_2022": "17.0",
    "prog_2023": "23.0",
    "prog_2024": "21.7",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "6.0",
    "cote_2022": "6.0",
    "cote_2023": "6.3",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Pointe-Lévy",
    "nom_court": "École Pointe-Lévy",
    "adresse": "55, rue des Commandeurs",
    "municipalite": "Lévis",
    "code_postal": "G6V 6P5",
    "lat": 46.80291,
    "lng": -71.17327
  },
  {
    "_id": "184",
    "school_code": "824220",
    "school_name_1": "les Etchemins",
    "admin_body_number": "824000",
    "admin_body_name": "Centre de services scolaire des Navigateurs",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "1684",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "9.9",
    "ehdaa_2024": "30.5",
    "rang_2024": "229/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "69.1",
    "lens_2019": "69.1",
    "lens_2022": "68.2",
    "lens_2023": "69.7",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "75.4",
    "lsec_2022": "79.4",
    "lsec_2023": "80.0",
    "lsec_2024": "77.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.6",
    "scie_2019": "68.3",
    "scie_2022": "68.9",
    "scie_2023": "72.0",
    "scie_2024": "69.8",
    "scie_trend": "—",
    "math_2018": "72.9",
    "math_2019": "74.3",
    "math_2022": "77.5",
    "math_2023": "77.1",
    "math_2024": "77.7",
    "math_trend": "—",
    "echec_2018": "15.7",
    "echec_2019": "18.9",
    "echec_2022": "16.8",
    "echec_2023": "14.9",
    "echec_2024": "18.0",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.7",
    "sures_2022": "1.8",
    "sures_2023": "1.1",
    "sures_2024": "2.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 6.1",
    "ecart_sexes_lens_2019": "F 9.1",
    "ecart_sexes_lens_2022": "F 7.3",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.5",
    "ecart_sexes_math_2019": "F 2.0",
    "ecart_sexes_math_2022": "F 5.0",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "33.1",
    "prog_2019": "40.4",
    "prog_2022": "24.5",
    "prog_2023": "29.6",
    "prog_2024": "26.9",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "4.8",
    "cote_2022": "6.1",
    "cote_2023": "6.2",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire les Etchemins",
    "nom_court": "École secondaire les Etchemins",
    "adresse": "3724, avenue des Églises",
    "municipalite": "Lévis",
    "code_postal": "G6X 1X4",
    "lat": 46.72001,
    "lng": -71.26982
  },
  {
    "_id": "185",
    "school_code": "824260",
    "school_name_1": "Beaurivage",
    "admin_body_number": "824000",
    "admin_body_name": "Centre de services scolaire des Navigateurs",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "970",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "11.3",
    "ehdaa_2024": "27.1",
    "rang_2024": "137/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "73.3",
    "lens_2019": "75.7",
    "lens_2022": "68.9",
    "lens_2023": "71.4",
    "lens_2024": "72.0",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "79.6",
    "lsec_2022": "75.2",
    "lsec_2023": "75.1",
    "lsec_2024": "78.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.4",
    "scie_2019": "73.4",
    "scie_2022": "67.4",
    "scie_2023": "76.8",
    "scie_2024": "69.9",
    "scie_trend": "—",
    "math_2018": "70.5",
    "math_2019": "71.8",
    "math_2022": "71.5",
    "math_2023": "77.0",
    "math_2024": "79.0",
    "math_trend": "112233",
    "echec_2018": "12.9",
    "echec_2019": "10.5",
    "echec_2022": "21.1",
    "echec_2023": "10.5",
    "echec_2024": "12.5",
    "echec_trend": "—",
    "sures_2018": "1.6",
    "sures_2019": "1.4",
    "sures_2022": "4.0",
    "sures_2023": "1.8",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 6.3",
    "ecart_sexes_lens_2024": "F 1.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.2",
    "ecart_sexes_math_2019": "F 0.9",
    "ecart_sexes_math_2022": "F 3.0",
    "ecart_sexes_math_2023": "M 2.1",
    "ecart_sexes_math_2024": "M 1.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.3",
    "prog_2019": "17.2",
    "prog_2022": "25.9",
    "prog_2023": "26.5",
    "prog_2024": "30.8",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "7.0",
    "cote_2022": "5.5",
    "cote_2023": "6.3",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Beaurivage",
    "nom_court": "École Beaurivage",
    "adresse": "1134, rue du Centenaire",
    "municipalite": "Saint-Agapit",
    "code_postal": "G0S 1Z0",
    "lat": 46.56375,
    "lng": -71.43918
  },
  {
    "_id": "186",
    "school_code": "824270",
    "school_name_1": "Pamphile-Le May",
    "admin_body_number": "824000",
    "admin_body_name": "Centre de services scolaire des Navigateurs",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "674",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "10.5",
    "ehdaa_2024": "27.2",
    "rang_2024": "238/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "67.6",
    "lens_2019": "69.2",
    "lens_2022": "64.9",
    "lens_2023": "65.5",
    "lens_2024": "64.4",
    "lens_trend": "—",
    "lsec_2018": "73.8",
    "lsec_2019": "73.7",
    "lsec_2022": "73.4",
    "lsec_2023": "76.4",
    "lsec_2024": "75.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.3",
    "scie_2019": "73.4",
    "scie_2022": "69.7",
    "scie_2023": "75.8",
    "scie_2024": "72.2",
    "scie_trend": "—",
    "math_2018": "72.8",
    "math_2019": "72.8",
    "math_2022": "77.4",
    "math_2023": "78.6",
    "math_2024": "83.3",
    "math_trend": "112233",
    "echec_2018": "18.4",
    "echec_2019": "17.9",
    "echec_2022": "18.0",
    "echec_2023": "16.1",
    "echec_2024": "16.5",
    "echec_trend": "112233",
    "sures_2018": "2.9",
    "sures_2019": "2.5",
    "sures_2022": "3.6",
    "sures_2023": "3.6",
    "sures_2024": "4.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.7",
    "ecart_sexes_lens_2019": "F 9.6",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 8.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.6",
    "ecart_sexes_math_2019": "F 7.2",
    "ecart_sexes_math_2022": "M 6.0",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "F 0.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.2",
    "prog_2019": "40.2",
    "prog_2022": "16.1",
    "prog_2023": "40.3",
    "prog_2024": "28.8",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "5.0",
    "cote_2022": "5.7",
    "cote_2023": "5.7",
    "cote_2024": "5.8",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Pamphile-Le May",
    "nom_court": "École secondaire Pamphile-Le May",
    "adresse": "6380, rue Garneau",
    "municipalite": "Sainte-Croix",
    "code_postal": "G0S 2H0",
    "lat": 46.62169,
    "lng": -71.74418
  },
  {
    "_id": "187",
    "school_code": "831102",
    "school_name_1": "Curé-Antoine-Labelle",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "2730",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "13.2",
    "ehdaa_2024": "43",
    "rang_2024": "299/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "67.8",
    "lens_2019": "66.5",
    "lens_2022": "66.1",
    "lens_2023": "64.4",
    "lens_2024": "65.0",
    "lens_trend": "—",
    "lsec_2018": "79.1",
    "lsec_2019": "80.5",
    "lsec_2022": "79.9",
    "lsec_2023": "79.2",
    "lsec_2024": "79.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.7",
    "scie_2019": "65.2",
    "scie_2022": "66.0",
    "scie_2023": "68.5",
    "scie_2024": "63.3",
    "scie_trend": "—",
    "math_2018": "73.3",
    "math_2019": "72.6",
    "math_2022": "77.2",
    "math_2023": "77.3",
    "math_2024": "75.9",
    "math_trend": "—",
    "echec_2018": "17.7",
    "echec_2019": "20.6",
    "echec_2022": "19.3",
    "echec_2023": "19.3",
    "echec_2024": "22.0",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.7",
    "sures_2022": "0.7",
    "sures_2023": "0.3",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.4",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 5.7",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.9",
    "ecart_sexes_math_2019": "F 3.0",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.1",
    "prog_2019": "29.1",
    "prog_2022": "22.9",
    "prog_2023": "30.6",
    "prog_2024": "31.8",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "5.2",
    "cote_2022": "6.2",
    "cote_2023": "5.6",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Curé-Antoine-Labelle",
    "nom_court": "École Curé-Antoine-Labelle",
    "adresse": "216, boulevard Marc-Aurèle-Fortin",
    "municipalite": "Laval",
    "code_postal": "H7L 1Z5",
    "lat": 45.60375,
    "lng": -73.78218
  },
  {
    "_id": "188",
    "school_code": "831105",
    "school_name_1": "Horizon Jeunesse",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "1382",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "13.7",
    "ehdaa_2024": "37.9",
    "rang_2024": "217/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "68.7",
    "lens_2019": "70.0",
    "lens_2022": "68.6",
    "lens_2023": "69.9",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "80.2",
    "lsec_2019": "80.3",
    "lsec_2022": "80.3",
    "lsec_2023": "81.8",
    "lsec_2024": "82.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.7",
    "scie_2019": "70.7",
    "scie_2022": "68.0",
    "scie_2023": "72.1",
    "scie_2024": "66.8",
    "scie_trend": "998855",
    "math_2018": "73.3",
    "math_2019": "75.6",
    "math_2022": "76.2",
    "math_2023": "74.5",
    "math_2024": "78.2",
    "math_trend": "—",
    "echec_2018": "15.0",
    "echec_2019": "15.7",
    "echec_2022": "18.1",
    "echec_2023": "16.7",
    "echec_2024": "16.2",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "0.3",
    "sures_2023": "0.0",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 5.1",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 3.5",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.0",
    "ecart_sexes_math_2019": "F 2.5",
    "ecart_sexes_math_2022": "M 0.8",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "M 0.1",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "35.9",
    "prog_2019": "34.1",
    "prog_2022": "33.7",
    "prog_2023": "37.5",
    "prog_2024": "32.9",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "5.9",
    "cote_2022": "6.2",
    "cote_2023": "6.0",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Horizon Jeunesse",
    "nom_court": "École Horizon Jeunesse",
    "adresse": "155, boulevard Sainte-Rose Est",
    "municipalite": "Laval",
    "code_postal": "H7H 1P2",
    "lat": 45.62685,
    "lng": -73.76057
  },
  {
    "_id": "189",
    "school_code": "831107",
    "school_name_1": "Leblanc",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "1624",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "17.2",
    "ehdaa_2024": "40.6",
    "rang_2024": "277/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "65.2",
    "lens_2019": "69.7",
    "lens_2022": "63.8",
    "lens_2023": "66.3",
    "lens_2024": "59.4",
    "lens_trend": "—",
    "lsec_2018": "81.5",
    "lsec_2019": "77.8",
    "lsec_2022": "78.9",
    "lsec_2023": "80.2",
    "lsec_2024": "79.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.8",
    "scie_2019": "75.9",
    "scie_2022": "76.4",
    "scie_2023": "71.9",
    "scie_2024": "71.6",
    "scie_trend": "—",
    "math_2018": "75.1",
    "math_2019": "71.4",
    "math_2022": "74.1",
    "math_2023": "72.0",
    "math_2024": "76.1",
    "math_trend": "—",
    "echec_2018": "12.9",
    "echec_2019": "12.8",
    "echec_2022": "18.6",
    "echec_2023": "18.3",
    "echec_2024": "20.9",
    "echec_trend": "998855",
    "sures_2018": "0.9",
    "sures_2019": "0.9",
    "sures_2022": "4.0",
    "sures_2023": "2.1",
    "sures_2024": "3.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 6.7",
    "ecart_sexes_lens_2019": "F 7.7",
    "ecart_sexes_lens_2022": "F 3.9",
    "ecart_sexes_lens_2023": "F 3.5",
    "ecart_sexes_lens_2024": "E",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 3.9",
    "ecart_sexes_math_2019": "M 0.1",
    "ecart_sexes_math_2022": "F 2.2",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.0",
    "prog_2019": "29.1",
    "prog_2022": "14.0",
    "prog_2023": "20.6",
    "prog_2024": "21.4",
    "prog_trend": "112233",
    "cote_2018": "5.9",
    "cote_2019": "6.0",
    "cote_2022": "6.4",
    "cote_2023": "5.7",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Leblanc",
    "nom_court": "École Leblanc",
    "adresse": "1750, montée Masson",
    "municipalite": "Laval",
    "code_postal": "H7C 0K4",
    "lat": 45.64937,
    "lng": -73.64081
  },
  {
    "_id": "190",
    "school_code": "831108",
    "school_name_1": "Georges-Vanier",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "1261",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "21.4",
    "ehdaa_2024": "43.4",
    "rang_2024": "348/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "71.1",
    "lens_2019": "71.3",
    "lens_2022": "70.9",
    "lens_2023": "70.7",
    "lens_2024": "71.5",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "77.6",
    "lsec_2022": "82.5",
    "lsec_2023": "81.0",
    "lsec_2024": "82.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.2",
    "scie_2019": "69.0",
    "scie_2022": "73.6",
    "scie_2023": "73.6",
    "scie_2024": "67.0",
    "scie_trend": "—",
    "math_2018": "69.8",
    "math_2019": "67.5",
    "math_2022": "76.2",
    "math_2023": "73.3",
    "math_2024": "73.5",
    "math_trend": "—",
    "echec_2018": "17.9",
    "echec_2019": "16.0",
    "echec_2022": "10.8",
    "echec_2023": "15.4",
    "echec_2024": "18.8",
    "echec_trend": "—",
    "sures_2018": "4.7",
    "sures_2019": "3.5",
    "sures_2022": "3.0",
    "sures_2023": "2.5",
    "sures_2024": "3.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.9",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 2.1",
    "ecart_sexes_lens_2023": "F 1.7",
    "ecart_sexes_lens_2024": "F 5.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.9",
    "ecart_sexes_math_2019": "M 5.5",
    "ecart_sexes_math_2022": "M 2.2",
    "ecart_sexes_math_2023": "M 2.8",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "47.9",
    "prog_2019": "52.9",
    "prog_2022": "42.8",
    "prog_2023": "41.9",
    "prog_2024": "57.8",
    "prog_trend": "—",
    "cote_2018": "4.5",
    "cote_2019": "4.5",
    "cote_2022": "6.5",
    "cote_2023": "5.8",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Georges-Vanier",
    "nom_court": "École Georges-Vanier",
    "adresse": "3995, boulevard Lévesque Est",
    "municipalite": "Laval",
    "code_postal": "H7E 2R3",
    "lat": 45.59904,
    "lng": -73.65363
  },
  {
    "_id": "191",
    "school_code": "831114",
    "school_name_1": "Mont-de-La Salle",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "2114",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "25.8",
    "ehdaa_2024": "38.2",
    "rang_2024": "399/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "68.4",
    "lens_2019": "67.3",
    "lens_2022": "58.0",
    "lens_2023": "62.6",
    "lens_2024": "62.5",
    "lens_trend": "—",
    "lsec_2018": "79.6",
    "lsec_2019": "80.0",
    "lsec_2022": "78.0",
    "lsec_2023": "79.1",
    "lsec_2024": "80.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.8",
    "scie_2019": "64.7",
    "scie_2022": "66.8",
    "scie_2023": "67.8",
    "scie_2024": "64.4",
    "scie_trend": "—",
    "math_2018": "63.8",
    "math_2019": "77.5",
    "math_2022": "75.7",
    "math_2023": "70.5",
    "math_2024": "72.0",
    "math_trend": "—",
    "echec_2018": "24.1",
    "echec_2019": "19.4",
    "echec_2022": "27.7",
    "echec_2023": "24.0",
    "echec_2024": "26.8",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.2",
    "sures_2022": "4.7",
    "sures_2023": "2.6",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.3",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "F 4.1",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "M 1.5",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "M 1.2",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "F 8.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "40.5",
    "prog_2019": "37.2",
    "prog_2022": "33.9",
    "prog_2023": "40.6",
    "prog_2024": "32.9",
    "prog_trend": "—",
    "cote_2018": "4.3",
    "cote_2019": "5.3",
    "cote_2022": "4.7",
    "cote_2023": "4.6",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Mont-de-La Salle",
    "nom_court": "École Mont-de-La Salle",
    "adresse": "125, boulevard des Prairies",
    "municipalite": "Laval",
    "code_postal": "H7N 2T6",
    "lat": 45.55487,
    "lng": -73.68892
  },
  {
    "_id": "192",
    "school_code": "831119",
    "school_name_1": "Saint-Maxime",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "2413",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "29.2",
    "ehdaa_2024": "30.1",
    "rang_2024": "323/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "65.8",
    "lens_2019": "67.4",
    "lens_2022": "64.1",
    "lens_2023": "62.6",
    "lens_2024": "63.7",
    "lens_trend": "—",
    "lsec_2018": "84.5",
    "lsec_2019": "81.6",
    "lsec_2022": "86.5",
    "lsec_2023": "82.4",
    "lsec_2024": "81.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.2",
    "scie_2019": "65.0",
    "scie_2022": "62.1",
    "scie_2023": "70.8",
    "scie_2024": "65.9",
    "scie_trend": "—",
    "math_2018": "69.0",
    "math_2019": "73.9",
    "math_2022": "74.8",
    "math_2023": "76.6",
    "math_2024": "74.9",
    "math_trend": "—",
    "echec_2018": "21.3",
    "echec_2019": "21.7",
    "echec_2022": "24.2",
    "echec_2023": "19.1",
    "echec_2024": "20.7",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "1.2",
    "sures_2022": "3.0",
    "sures_2023": "1.1",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.2",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.3",
    "ecart_sexes_math_2019": "F 4.8",
    "ecart_sexes_math_2022": "F 2.1",
    "ecart_sexes_math_2023": "F 3.1",
    "ecart_sexes_math_2024": "F 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.3",
    "prog_2019": "35.6",
    "prog_2022": "27.6",
    "prog_2023": "32.8",
    "prog_2024": "38.9",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "4.9",
    "cote_2022": "5.6",
    "cote_2023": "5.6",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Maxime",
    "nom_court": "École Saint-Maxime",
    "adresse": "3680, boulevard Lévesque Ouest",
    "municipalite": "Laval",
    "code_postal": "H7V 1E8",
    "lat": 45.5353,
    "lng": -73.73536
  },
  {
    "_id": "193",
    "school_code": "831150",
    "school_name_1": "École d'éducation internationale",
    "admin_body_number": "831000",
    "admin_body_name": "Centre de services scolaire de Laval",
    "area_name": "Laval ",
    "étudiants": "1505",
    "langue": "français",
    "secteur": "public",
    "rang": "15",
    "rang_5_ans": "14",
    "index": "0.1",
    "en_retard_2024": "1",
    "ehdaa_2024": "3.3",
    "rang_2024": "15/470",
    "rang_2019_2024": "14/432",
    "lens_2018": "78.2",
    "lens_2019": "79.6",
    "lens_2022": "75.6",
    "lens_2023": "77.1",
    "lens_2024": "76.8",
    "lens_trend": "—",
    "lsec_2018": "87.0",
    "lsec_2019": "87.0",
    "lsec_2022": "86.1",
    "lsec_2023": "87.8",
    "lsec_2024": "89.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "89.6",
    "scie_2019": "86.0",
    "scie_2022": "91.6",
    "scie_2023": "92.7",
    "scie_2024": "88.8",
    "scie_trend": "—",
    "math_2018": "85.6",
    "math_2019": "87.2",
    "math_2022": "90.4",
    "math_2023": "90.2",
    "math_2024": "88.9",
    "math_trend": "—",
    "echec_2018": "2.0",
    "echec_2019": "2.2",
    "echec_2022": "2.7",
    "echec_2023": "2.1",
    "echec_2024": "1.9",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "0.8",
    "sures_2022": "3.1",
    "sures_2023": "1.4",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 4.8",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.2",
    "ecart_sexes_math_2019": "F 2.0",
    "ecart_sexes_math_2022": "F 3.8",
    "ecart_sexes_math_2023": "M 1.4",
    "ecart_sexes_math_2024": "M 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.3",
    "prog_2019": "1.0",
    "prog_2022": "1.7",
    "prog_2023": "0.7",
    "prog_2024": "1.3",
    "prog_trend": "—",
    "cote_2018": "9.4",
    "cote_2019": "9.6",
    "cote_2022": "9.4",
    "cote_2023": "9.3",
    "cote_2024": "9.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École d'éducation internationale de Laval",
    "nom_court": "École éduc. inter. de Laval",
    "adresse": "5075, chemin du Souvenir",
    "municipalite": "Laval",
    "code_postal": "H7W 1E1",
    "lat": 45.53504,
    "lng": -73.77777
  },
  {
    "_id": "194",
    "school_code": "841008",
    "school_name_1": "du Coteau",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1175",
    "langue": "français",
    "secteur": "public",
    "rang": "427",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "19.8",
    "ehdaa_2024": "46.5",
    "rang_2024": "427/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "67.8",
    "lens_2019": "68.2",
    "lens_2022": "63.2",
    "lens_2023": "67.8",
    "lens_2024": "63.9",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "82.0",
    "lsec_2022": "79.0",
    "lsec_2023": "74.9",
    "lsec_2024": "81.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.1",
    "scie_2019": "68.7",
    "scie_2022": "58.1",
    "scie_2023": "66.3",
    "scie_2024": "58.6",
    "scie_trend": "998855",
    "math_2018": "68.9",
    "math_2019": "71.3",
    "math_2022": "61.3",
    "math_2023": "67.5",
    "math_2024": "69.2",
    "math_trend": "—",
    "echec_2018": "18.3",
    "echec_2019": "19.1",
    "echec_2022": "32.3",
    "echec_2023": "22.8",
    "echec_2024": "29.0",
    "echec_trend": "998855",
    "sures_2018": "1.4",
    "sures_2019": "0.3",
    "sures_2022": "4.3",
    "sures_2023": "2.3",
    "sures_2024": "3.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 1.5",
    "ecart_sexes_lens_2022": "F 2.5",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.3",
    "ecart_sexes_math_2019": "F 5.4",
    "ecart_sexes_math_2022": "F 4.2",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "M 2.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.0",
    "prog_2019": "33.4",
    "prog_2022": "30.5",
    "prog_2023": "33.9",
    "prog_2024": "38.3",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.4",
    "cote_2022": "4.0",
    "cote_2023": "4.4",
    "cote_2024": "3.9",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire du Coteau",
    "nom_court": "École secondaire du Coteau",
    "adresse": "2121, rue de l'Alizé",
    "municipalite": "Mascouche",
    "code_postal": "J7L 4C9",
    "lat": 45.74884,
    "lng": -73.63466
  },
  {
    "_id": "195",
    "school_code": "841027",
    "school_name_1": "Jean-Baptiste-Meilleur",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1896",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "5.1",
    "ehdaa_2024": "24.5",
    "rang_2024": "137/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "71.5",
    "lens_2019": "71.4",
    "lens_2022": "72.2",
    "lens_2023": "70.6",
    "lens_2024": "71.9",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "79.1",
    "lsec_2022": "83.3",
    "lsec_2023": "76.7",
    "lsec_2024": "80.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.0",
    "scie_2019": "73.9",
    "scie_2022": "72.6",
    "scie_2023": "76.7",
    "scie_2024": "71.2",
    "scie_trend": "—",
    "math_2018": "75.6",
    "math_2019": "77.1",
    "math_2022": "73.7",
    "math_2023": "76.7",
    "math_2024": "78.7",
    "math_trend": "—",
    "echec_2018": "11.2",
    "echec_2019": "13.7",
    "echec_2022": "16.1",
    "echec_2023": "15.1",
    "echec_2024": "14.6",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.9",
    "sures_2022": "0.7",
    "sures_2023": "1.3",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.7",
    "ecart_sexes_lens_2019": "F 6.1",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.1",
    "ecart_sexes_math_2019": "F 0.3",
    "ecart_sexes_math_2022": "M 0.8",
    "ecart_sexes_math_2023": "F 3.0",
    "ecart_sexes_math_2024": "F 5.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "16.3",
    "prog_2019": "19.1",
    "prog_2022": "16.6",
    "prog_2023": "22.7",
    "prog_2024": "20.2",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.5",
    "cote_2022": "7.1",
    "cote_2023": "6.3",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Jean-Baptiste-Meilleur",
    "nom_court": "École secondaire Jean-Baptiste-Meilleur",
    "adresse": "777, boulevard Iberville",
    "municipalite": "Repentigny",
    "code_postal": "J5Y 1A2",
    "lat": 45.76234,
    "lng": -73.43501
  },
  {
    "_id": "196",
    "school_code": "841031",
    "school_name_1": "Paul-Arseneau",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1523",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "4.1",
    "ehdaa_2024": "41.4",
    "rang_2024": "229/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "74.0",
    "lens_2019": "71.9",
    "lens_2022": "67.3",
    "lens_2023": "69.9",
    "lens_2024": "67.5",
    "lens_trend": "998855",
    "lsec_2018": "78.9",
    "lsec_2019": "79.1",
    "lsec_2022": "78.5",
    "lsec_2023": "81.7",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.9",
    "scie_2019": "70.5",
    "scie_2022": "70.7",
    "scie_2023": "75.1",
    "scie_2024": "68.3",
    "scie_trend": "998855",
    "math_2018": "64.0",
    "math_2019": "73.8",
    "math_2022": "75.0",
    "math_2023": "75.0",
    "math_2024": "79.1",
    "math_trend": "—",
    "echec_2018": "14.7",
    "echec_2019": "14.4",
    "echec_2022": "19.3",
    "echec_2023": "12.9",
    "echec_2024": "16.8",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "0.5",
    "sures_2022": "3.0",
    "sures_2023": "0.2",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 7.1",
    "ecart_sexes_lens_2022": "F 7.2",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 0.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.4",
    "ecart_sexes_math_2019": "F 9.7",
    "ecart_sexes_math_2022": "F 6.0",
    "ecart_sexes_math_2023": "F 5.9",
    "ecart_sexes_math_2024": "F 7.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "24.3",
    "prog_2019": "34.0",
    "prog_2022": "30.7",
    "prog_2023": "36.8",
    "prog_2024": "24.6",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.8",
    "cote_2022": "5.7",
    "cote_2023": "6.2",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Paul-Arseneau",
    "nom_court": "École secondaire Paul-Arseneau",
    "adresse": "170, boulevard Hector-Papin",
    "municipalite": "L'Assomption",
    "code_postal": "J5W 3L1",
    "lat": 45.81946,
    "lng": -73.43217
  },
  {
    "_id": "197",
    "school_code": "841038",
    "school_name_1": "l'Horizon",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1135",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "18.8",
    "ehdaa_2024": "46.9",
    "rang_2024": "310/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "64.5",
    "lens_2019": "68.2",
    "lens_2022": "64.3",
    "lens_2023": "68.6",
    "lens_2024": "66.0",
    "lens_trend": "112233",
    "lsec_2018": "78.1",
    "lsec_2019": "77.8",
    "lsec_2022": "73.7",
    "lsec_2023": "78.4",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.4",
    "scie_2019": "64.6",
    "scie_2022": "66.8",
    "scie_2023": "70.3",
    "scie_2024": "62.7",
    "scie_trend": "—",
    "math_2018": "64.7",
    "math_2019": "75.2",
    "math_2022": "74.8",
    "math_2023": "70.5",
    "math_2024": "79.3",
    "math_trend": "—",
    "echec_2018": "27.0",
    "echec_2019": "22.3",
    "echec_2022": "23.2",
    "echec_2023": "16.3",
    "echec_2024": "22.8",
    "echec_trend": "—",
    "sures_2018": "3.1",
    "sures_2019": "4.3",
    "sures_2022": "4.7",
    "sures_2023": "0.8",
    "sures_2024": "3.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.3",
    "ecart_sexes_lens_2019": "F 4.2",
    "ecart_sexes_lens_2022": "F 1.4",
    "ecart_sexes_lens_2023": "M 1.4",
    "ecart_sexes_lens_2024": "F 0.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 5.3",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 0.4",
    "ecart_sexes_math_2023": "F 2.5",
    "ecart_sexes_math_2024": "F 4.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "22.9",
    "prog_2019": "29.7",
    "prog_2022": "24.8",
    "prog_2023": "26.6",
    "prog_2024": "23.9",
    "prog_trend": "—",
    "cote_2018": "3.8",
    "cote_2019": "4.5",
    "cote_2022": "4.9",
    "cote_2023": "5.8",
    "cote_2024": "5.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire l'Horizon",
    "nom_court": "École secondaire l'Horizon",
    "adresse": "239, boulevard J.-A. Paré",
    "municipalite": "Repentigny",
    "code_postal": "J5Z 4M6",
    "lat": 45.76372,
    "lng": -73.47847
  },
  {
    "_id": "198",
    "school_code": "841041",
    "school_name_1": "Félix-Leclerc",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "2132",
    "langue": "français",
    "secteur": "public",
    "rang": "120",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "6.6",
    "ehdaa_2024": "28.8",
    "rang_2024": "120/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "73.6",
    "lens_2019": "73.1",
    "lens_2022": "68.3",
    "lens_2023": "69.4",
    "lens_2024": "68.6",
    "lens_trend": "998855",
    "lsec_2018": "79.8",
    "lsec_2019": "79.9",
    "lsec_2022": "81.8",
    "lsec_2023": "81.2",
    "lsec_2024": "83.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.7",
    "scie_2019": "71.1",
    "scie_2022": "66.3",
    "scie_2023": "73.4",
    "scie_2024": "74.1",
    "scie_trend": "—",
    "math_2018": "67.6",
    "math_2019": "72.7",
    "math_2022": "71.0",
    "math_2023": "77.7",
    "math_2024": "82.6",
    "math_trend": "112233",
    "echec_2018": "15.6",
    "echec_2019": "14.5",
    "echec_2022": "22.8",
    "echec_2023": "14.6",
    "echec_2024": "12.1",
    "echec_trend": "112233",
    "sures_2018": "1.2",
    "sures_2019": "0.2",
    "sures_2022": "3.2",
    "sures_2023": "1.4",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.6",
    "ecart_sexes_math_2019": "F 3.0",
    "ecart_sexes_math_2022": "F 2.9",
    "ecart_sexes_math_2023": "F 3.0",
    "ecart_sexes_math_2024": "F 6.2",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "23.2",
    "prog_2019": "17.1",
    "prog_2022": "15.3",
    "prog_2023": "18.4",
    "prog_2024": "16.2",
    "prog_trend": "112233",
    "cote_2018": "6.0",
    "cote_2019": "6.3",
    "cote_2022": "6.1",
    "cote_2023": "6.4",
    "cote_2024": "7.0",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Félix-Leclerc",
    "nom_court": "École secondaire Félix-Leclerc",
    "adresse": "250, boulevard Louis Philippe Picard",
    "municipalite": "Repentigny",
    "code_postal": "J5Y 3W9",
    "lat": 45.79103,
    "lng": -73.41177
  },
  {
    "_id": "199",
    "school_code": "841050",
    "school_name_1": "de l'Amitié",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "540",
    "langue": "français",
    "secteur": "public",
    "rang": "430",
    "rang_5_ans": "417",
    "index": "0.1",
    "en_retard_2024": "9.3",
    "ehdaa_2024": "42.4",
    "rang_2024": "430/470",
    "rang_2019_2024": "417/432",
    "lens_2018": "65.3",
    "lens_2019": "63.4",
    "lens_2022": "58.1",
    "lens_2023": "64.1",
    "lens_2024": "60.2",
    "lens_trend": "—",
    "lsec_2018": "72.8",
    "lsec_2019": "71.8",
    "lsec_2022": "75.6",
    "lsec_2023": "76.1",
    "lsec_2024": "78.2",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.1",
    "scie_2019": "63.6",
    "scie_2022": "59.3",
    "scie_2023": "60.9",
    "scie_2024": "62.1",
    "scie_trend": "—",
    "math_2018": "71.9",
    "math_2019": "66.4",
    "math_2022": "59.8",
    "math_2023": "64.3",
    "math_2024": "74.5",
    "math_trend": "—",
    "echec_2018": "20.9",
    "echec_2019": "30.2",
    "echec_2022": "38.8",
    "echec_2023": "30.7",
    "echec_2024": "29.5",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "2.9",
    "sures_2022": "6.0",
    "sures_2023": "2.4",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.7",
    "ecart_sexes_lens_2019": "F 1.4",
    "ecart_sexes_lens_2022": "F 0.1",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.6",
    "ecart_sexes_math_2019": "F 2.7",
    "ecart_sexes_math_2022": "F 0.8",
    "ecart_sexes_math_2023": "M 3.1",
    "ecart_sexes_math_2024": "M 7.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.9",
    "prog_2019": "31.6",
    "prog_2022": "35.4",
    "prog_2023": "49.8",
    "prog_2024": "33.4",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "3.1",
    "cote_2022": "3.0",
    "cote_2023": "2.9",
    "cote_2024": "3.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Amitié",
    "nom_court": "École secondaire de l'Amitié",
    "adresse": "1600, boulevard de l'Ange-Gardien Nord",
    "municipalite": "L'Assomption",
    "code_postal": "J5W 5H1",
    "lat": 45.85605,
    "lng": -73.43495
  },
  {
    "_id": "200",
    "school_code": "841105",
    "school_name_1": "le Prélude",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1094",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "10.9",
    "ehdaa_2024": "42",
    "rang_2024": "335/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "69.3",
    "lens_2019": "70.7",
    "lens_2022": "62.6",
    "lens_2023": "63.0",
    "lens_2024": "66.0",
    "lens_trend": "—",
    "lsec_2018": "77.5",
    "lsec_2019": "80.3",
    "lsec_2022": "80.3",
    "lsec_2023": "81.9",
    "lsec_2024": "82.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.9",
    "scie_2019": "63.3",
    "scie_2022": "62.7",
    "scie_2023": "60.9",
    "scie_2024": "57.3",
    "scie_trend": "998855",
    "math_2018": "74.7",
    "math_2019": "74.6",
    "math_2022": "72.1",
    "math_2023": "70.8",
    "math_2024": "76.3",
    "math_trend": "998855",
    "echec_2018": "13.3",
    "echec_2019": "18.7",
    "echec_2022": "27.2",
    "echec_2023": "27.0",
    "echec_2024": "26.5",
    "echec_trend": "998855",
    "sures_2018": "0.1",
    "sures_2019": "0.8",
    "sures_2022": "1.4",
    "sures_2023": "0.3",
    "sures_2024": "0.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.4",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 6.1",
    "ecart_sexes_lens_2023": "M 4.9",
    "ecart_sexes_lens_2024": "F 1.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.2",
    "ecart_sexes_math_2019": "F 3.5",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 5.8",
    "ecart_sexes_math_2024": "F 2.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.4",
    "prog_2019": "26.5",
    "prog_2022": "25.5",
    "prog_2023": "32.5",
    "prog_2024": "32.7",
    "prog_trend": "998855",
    "cote_2018": "5.9",
    "cote_2019": "5.6",
    "cote_2022": "5.2",
    "cote_2023": "4.5",
    "cote_2024": "5.0",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Le Prélude",
    "nom_court": "École secondaire Le Prélude",
    "adresse": "2995, avenue des Ancêtres",
    "municipalite": "Mascouche",
    "code_postal": "J7K 1X6",
    "lat": 45.74555,
    "lng": -73.60455
  },
  {
    "_id": "201",
    "school_code": "841108",
    "school_name_1": "Des Rives",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1320",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "17.1",
    "ehdaa_2024": "30.7",
    "rang_2024": "156/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "73.0",
    "lens_2019": "73.7",
    "lens_2022": "67.8",
    "lens_2023": "71.1",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "76.4",
    "lsec_2019": "80.0",
    "lsec_2022": "79.4",
    "lsec_2023": "78.1",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.6",
    "scie_2019": "70.6",
    "scie_2022": "70.0",
    "scie_2023": "77.1",
    "scie_2024": "76.0",
    "scie_trend": "112233",
    "math_2018": "66.2",
    "math_2019": "72.8",
    "math_2022": "70.8",
    "math_2023": "69.9",
    "math_2024": "78.2",
    "math_trend": "—",
    "echec_2018": "17.3",
    "echec_2019": "14.0",
    "echec_2022": "20.9",
    "echec_2023": "13.7",
    "echec_2024": "13.1",
    "echec_trend": "112233",
    "sures_2018": "2.1",
    "sures_2019": "0.1",
    "sures_2022": "3.8",
    "sures_2023": "1.1",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.4",
    "ecart_sexes_math_2019": "F 2.0",
    "ecart_sexes_math_2022": "F 2.2",
    "ecart_sexes_math_2023": "F 6.4",
    "ecart_sexes_math_2024": "F 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.9",
    "prog_2019": "30.1",
    "prog_2022": "10.4",
    "prog_2023": "16.5",
    "prog_2024": "21.1",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "6.2",
    "cote_2022": "6.3",
    "cote_2023": "6.2",
    "cote_2024": "6.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Des Rives",
    "nom_court": "École secondaire Des Rives",
    "adresse": "400, Montée Dumais",
    "municipalite": "Terrebonne",
    "code_postal": "J6W 5W9",
    "lat": 45.70793,
    "lng": -73.57844
  },
  {
    "_id": "202",
    "school_code": "841112",
    "school_name_1": "Armand-Corbeil",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1953",
    "langue": "français",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "114",
    "index": "0.1",
    "en_retard_2024": "3.6",
    "ehdaa_2024": "25",
    "rang_2024": "112/470",
    "rang_2019_2024": "114/432",
    "lens_2018": "75.4",
    "lens_2019": "73.6",
    "lens_2022": "68.3",
    "lens_2023": "72.5",
    "lens_2024": "68.1",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "81.3",
    "lsec_2022": "81.6",
    "lsec_2023": "83.5",
    "lsec_2024": "82.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.8",
    "scie_2019": "70.3",
    "scie_2022": "69.7",
    "scie_2023": "76.3",
    "scie_2024": "75.0",
    "scie_trend": "—",
    "math_2018": "78.6",
    "math_2019": "77.4",
    "math_2022": "82.9",
    "math_2023": "82.5",
    "math_2024": "88.4",
    "math_trend": "—",
    "echec_2018": "8.6",
    "echec_2019": "13.2",
    "echec_2022": "15.1",
    "echec_2023": "10.7",
    "echec_2024": "11.7",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "2.3",
    "sures_2022": "3.4",
    "sures_2023": "0.7",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.4",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 9.2",
    "ecart_sexes_lens_2023": "F 8.2",
    "ecart_sexes_lens_2024": "F 4.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.5",
    "ecart_sexes_math_2019": "M 0.5",
    "ecart_sexes_math_2022": "F 2.6",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "14.4",
    "prog_2019": "12.9",
    "prog_2022": "13.8",
    "prog_2023": "21.7",
    "prog_2024": "17.6",
    "prog_trend": "—",
    "cote_2018": "7.3",
    "cote_2019": "6.6",
    "cote_2022": "6.7",
    "cote_2023": "7.1",
    "cote_2024": "7.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Armand-Corbeil",
    "nom_court": "École secondaire Armand-Corbeil",
    "adresse": "795, rue John-F.-Kennedy",
    "municipalite": "Terrebonne",
    "code_postal": "J6W 1X2",
    "lat": 45.70682,
    "lng": -73.64144
  },
  {
    "_id": "203",
    "school_code": "841131",
    "school_name_1": "de l'Odyssée",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "1264",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "47.7",
    "rang_2024": "348/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "69.5",
    "lens_2019": "69.5",
    "lens_2022": "63.6",
    "lens_2023": "65.8",
    "lens_2024": "65.9",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "77.0",
    "lsec_2022": "76.5",
    "lsec_2023": "77.8",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.9",
    "scie_2019": "62.0",
    "scie_2022": "58.2",
    "scie_2023": "66.5",
    "scie_2024": "60.2",
    "scie_trend": "—",
    "math_2018": "73.5",
    "math_2019": "75.1",
    "math_2022": "73.8",
    "math_2023": "71.3",
    "math_2024": "73.5",
    "math_trend": "998855",
    "echec_2018": "18.1",
    "echec_2019": "20.1",
    "echec_2022": "28.3",
    "echec_2023": "21.6",
    "echec_2024": "24.7",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.0",
    "sures_2022": "1.8",
    "sures_2023": "0.4",
    "sures_2024": "0.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.4",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 1.5",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.1",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 3.6",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "F 7.1",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "38.7",
    "prog_2019": "29.7",
    "prog_2022": "29.0",
    "prog_2023": "32.7",
    "prog_2024": "24.9",
    "prog_trend": "112233",
    "cote_2018": "5.2",
    "cote_2019": "5.2",
    "cote_2022": "4.7",
    "cote_2023": "5.0",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Odyssée",
    "nom_court": "École secondaire de l'Odyssée",
    "adresse": "2201, rue de la Jonquille",
    "municipalite": "Terrebonne",
    "code_postal": "J7M 1Y8",
    "lat": 45.76813,
    "lng": -73.72645
  },
  {
    "_id": "204",
    "school_code": "841134",
    "school_name_1": "des Trois-Saisons",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "956",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "9.2",
    "ehdaa_2024": "28.8",
    "rang_2024": "137/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "73.0",
    "lens_2019": "72.0",
    "lens_2022": "66.0",
    "lens_2023": "71.1",
    "lens_2024": "68.6",
    "lens_trend": "—",
    "lsec_2018": "81.1",
    "lsec_2019": "80.3",
    "lsec_2022": "82.1",
    "lsec_2023": "87.7",
    "lsec_2024": "87.8",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.6",
    "scie_2019": "68.5",
    "scie_2022": "73.0",
    "scie_2023": "73.2",
    "scie_2024": "69.8",
    "scie_trend": "—",
    "math_2018": "62.8",
    "math_2019": "70.0",
    "math_2022": "69.8",
    "math_2023": "73.0",
    "math_2024": "78.2",
    "math_trend": "112233",
    "echec_2018": "18.8",
    "echec_2019": "17.5",
    "echec_2022": "19.6",
    "echec_2023": "15.9",
    "echec_2024": "15.7",
    "echec_trend": "112233",
    "sures_2018": "1.9",
    "sures_2019": "0.6",
    "sures_2022": "3.9",
    "sures_2023": "1.3",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 1.2",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 1.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.7",
    "ecart_sexes_math_2019": "F 7.0",
    "ecart_sexes_math_2022": "M 2.0",
    "ecart_sexes_math_2023": "M 1.8",
    "ecart_sexes_math_2024": "F 3.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.9",
    "prog_2019": "31.4",
    "prog_2022": "23.5",
    "prog_2023": "26.5",
    "prog_2024": "22.1",
    "prog_trend": "112233",
    "cote_2018": "5.2",
    "cote_2019": "5.5",
    "cote_2022": "6.1",
    "cote_2023": "6.6",
    "cote_2024": "6.7",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire des Trois-Saisons",
    "nom_court": "École secondaire des Trois-Saisons",
    "adresse": "1658, boulevard des Seigneurs",
    "municipalite": "Terrebonne",
    "code_postal": "J6X 4T1",
    "lat": 45.71399,
    "lng": -73.67162
  },
  {
    "_id": "205",
    "school_code": "841299",
    "school_name_1": "Programme intégré secondaire",
    "admin_body_number": "841000",
    "admin_body_name": "Centre de services scolaire des Affluents",
    "area_name": "Lanaudière ",
    "étudiants": "308",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "7.8",
    "ehdaa_2024": "51.3",
    "rang_2024": "299/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "nd",
    "lens_2024": "63.6",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "nd",
    "lsec_2024": "81.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "nd",
    "scie_2024": "65.4",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "nd",
    "math_2024": "73.7",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "nd",
    "echec_2024": "22.2",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "nd",
    "sures_2024": "3.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 2.6",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 1.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "nd",
    "prog_2024": "19.2",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "nd",
    "cote_2024": "5.3",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École de programme intégré secondaire",
    "nom_court": "École de programme intégré secondaire",
    "adresse": "120, rue Valmont",
    "municipalite": "Repentigny",
    "code_postal": "J5Y 1N9",
    "lat": 45.76234,
    "lng": -73.43501
  },
  {
    "_id": "206",
    "school_code": "842009",
    "school_name_1": "du Havre-Jeunesse",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "1005",
    "langue": "français",
    "secteur": "public",
    "rang": "433",
    "rang_5_ans": "416",
    "index": "0.1",
    "en_retard_2024": "21.5",
    "ehdaa_2024": "46.5",
    "rang_2024": "433/470",
    "rang_2019_2024": "416/432",
    "lens_2018": "66.1",
    "lens_2019": "64.1",
    "lens_2022": "61.5",
    "lens_2023": "65.1",
    "lens_2024": "66.7",
    "lens_trend": "112233",
    "lsec_2018": "69.2",
    "lsec_2019": "72.7",
    "lsec_2022": "71.7",
    "lsec_2023": "71.3",
    "lsec_2024": "76.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.4",
    "scie_2019": "69.7",
    "scie_2022": "65.2",
    "scie_2023": "68.5",
    "scie_2024": "61.9",
    "scie_trend": "998855",
    "math_2018": "65.3",
    "math_2019": "73.3",
    "math_2022": "53.0",
    "math_2023": "72.0",
    "math_2024": "69.7",
    "math_trend": "—",
    "echec_2018": "22.4",
    "echec_2019": "19.7",
    "echec_2022": "36.0",
    "echec_2023": "26.7",
    "echec_2024": "27.1",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "0.2",
    "sures_2022": "2.7",
    "sures_2023": "1.2",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.0",
    "ecart_sexes_lens_2019": "F 16.2",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 9.3",
    "ecart_sexes_math_2022": "F 1.6",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "M 9.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "56.6",
    "prog_2019": "49.7",
    "prog_2022": "44.3",
    "prog_2023": "51.1",
    "prog_2024": "44.6",
    "prog_trend": "112233",
    "cote_2018": "3.2",
    "cote_2019": "3.7",
    "cote_2022": "2.8",
    "cote_2023": "3.9",
    "cote_2024": "3.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Havre-Jeunesse",
    "nom_court": "École secondaire du Havre-Jeunesse",
    "adresse": "2175, rue du Domaine-Malo",
    "municipalite": "Sainte-Julienne",
    "code_postal": "J0K 2T0",
    "lat": 45.95622,
    "lng": -73.72117
  },
  {
    "_id": "207",
    "school_code": "842012",
    "school_name_1": "de la Rive",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "643",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "411",
    "index": "0.1",
    "en_retard_2024": "8.3",
    "ehdaa_2024": "27.4",
    "rang_2024": "277/470",
    "rang_2019_2024": "411/432",
    "lens_2018": "68.7",
    "lens_2019": "64.4",
    "lens_2022": "57.5",
    "lens_2023": "61.8",
    "lens_2024": "63.3",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "75.8",
    "lsec_2022": "72.9",
    "lsec_2023": "77.7",
    "lsec_2024": "80.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.6",
    "scie_2019": "60.9",
    "scie_2022": "66.8",
    "scie_2023": "72.4",
    "scie_2024": "64.8",
    "scie_trend": "—",
    "math_2018": "63.3",
    "math_2019": "51.4",
    "math_2022": "61.2",
    "math_2023": "68.6",
    "math_2024": "82.1",
    "math_trend": "—",
    "echec_2018": "24.3",
    "echec_2019": "36.3",
    "echec_2022": "36.2",
    "echec_2023": "22.4",
    "echec_2024": "19.2",
    "echec_trend": "—",
    "sures_2018": "4.2",
    "sures_2019": "7.5",
    "sures_2022": "4.4",
    "sures_2023": "0.7",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.7",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 4.9",
    "ecart_sexes_lens_2023": "F 6.0",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.8",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "F 12.4",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "F 6.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "54.2",
    "prog_2019": "34.6",
    "prog_2022": "19.7",
    "prog_2023": "43.9",
    "prog_2024": "25.3",
    "prog_trend": "—",
    "cote_2018": "3.1",
    "cote_2019": "1.6",
    "cote_2022": "3.5",
    "cote_2023": "4.6",
    "cote_2024": "5.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire de la Rive",
    "nom_court": "École secondaire de la Rive",
    "adresse": "60, rue Douaire-de-Bondy",
    "municipalite": "Lavaltrie",
    "code_postal": "J5T 1G7",
    "lat": 45.87117,
    "lng": -73.29131
  },
  {
    "_id": "208",
    "school_code": "842098",
    "school_name_1": "de L'Achigan",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "1305",
    "langue": "français",
    "secteur": "public",
    "rang": "454",
    "rang_5_ans": "419",
    "index": "0.1",
    "en_retard_2024": "19.1",
    "ehdaa_2024": "35.2",
    "rang_2024": "454/470",
    "rang_2019_2024": "419/432",
    "lens_2018": "63.9",
    "lens_2019": "64.6",
    "lens_2022": "63.6",
    "lens_2023": "64.9",
    "lens_2024": "64.7",
    "lens_trend": "112233",
    "lsec_2018": "72.7",
    "lsec_2019": "71.6",
    "lsec_2022": "74.2",
    "lsec_2023": "71.8",
    "lsec_2024": "72.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.6",
    "scie_2019": "62.8",
    "scie_2022": "58.0",
    "scie_2023": "67.6",
    "scie_2024": "59.7",
    "scie_trend": "—",
    "math_2018": "66.7",
    "math_2019": "65.6",
    "math_2022": "55.9",
    "math_2023": "59.9",
    "math_2024": "60.8",
    "math_trend": "998855",
    "echec_2018": "23.5",
    "echec_2019": "26.2",
    "echec_2022": "38.3",
    "echec_2023": "30.1",
    "echec_2024": "33.0",
    "echec_trend": "998855",
    "sures_2018": "0.9",
    "sures_2019": "1.9",
    "sures_2022": "6.5",
    "sures_2023": "2.6",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.2",
    "ecart_sexes_lens_2019": "F 3.0",
    "ecart_sexes_lens_2022": "F 1.7",
    "ecart_sexes_lens_2023": "F 0.2",
    "ecart_sexes_lens_2024": "M 1.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.8",
    "ecart_sexes_math_2019": "F 9.7",
    "ecart_sexes_math_2022": "M 0.9",
    "ecart_sexes_math_2023": "M 7.4",
    "ecart_sexes_math_2024": "F 3.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.9",
    "prog_2019": "34.2",
    "prog_2022": "45.8",
    "prog_2023": "41.8",
    "prog_2024": "41.7",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "3.2",
    "cote_2022": "2.7",
    "cote_2023": "3.2",
    "cote_2024": "2.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Achigan",
    "nom_court": "École secondaire de l'Achigan",
    "adresse": "60, montée Rémi-Henri",
    "municipalite": "Saint-Roch-de-l'Achigan",
    "code_postal": "J0K 3H0",
    "lat": 45.86284,
    "lng": -73.59504
  },
  {
    "_id": "209",
    "school_code": "842103",
    "school_name_1": "Thérèse-Martin",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "1876",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "17.7",
    "ehdaa_2024": "32.4",
    "rang_2024": "277/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "67.6",
    "lens_2019": "71.4",
    "lens_2022": "67.0",
    "lens_2023": "68.5",
    "lens_2024": "67.5",
    "lens_trend": "—",
    "lsec_2018": "75.1",
    "lsec_2019": "79.3",
    "lsec_2022": "74.9",
    "lsec_2023": "78.5",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.1",
    "scie_2019": "70.7",
    "scie_2022": "69.4",
    "scie_2023": "74.4",
    "scie_2024": "71.2",
    "scie_trend": "112233",
    "math_2018": "76.6",
    "math_2019": "78.3",
    "math_2022": "74.0",
    "math_2023": "74.0",
    "math_2024": "75.1",
    "math_trend": "998855",
    "echec_2018": "17.0",
    "echec_2019": "13.2",
    "echec_2022": "22.7",
    "echec_2023": "17.5",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.6",
    "sures_2022": "0.9",
    "sures_2023": "0.7",
    "sures_2024": "0.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 7.5",
    "ecart_sexes_lens_2022": "F 9.8",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.4",
    "ecart_sexes_math_2019": "F 3.4",
    "ecart_sexes_math_2022": "F 7.7",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "F 3.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.6",
    "prog_2019": "36.0",
    "prog_2022": "31.7",
    "prog_2023": "44.5",
    "prog_2024": "44.6",
    "prog_trend": "998855",
    "cote_2018": "5.4",
    "cote_2019": "5.9",
    "cote_2022": "5.0",
    "cote_2023": "5.4",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Thérèse-Martin",
    "nom_court": "École secondaire Thérèse-Martin",
    "adresse": "916, rue Ladouceur",
    "municipalite": "Joliette",
    "code_postal": "J6E 3W7",
    "lat": 46.03054,
    "lng": -73.42466
  },
  {
    "_id": "210",
    "school_code": "842104",
    "school_name_1": "Pierre-de-Lestage",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "871",
    "langue": "français",
    "secteur": "public",
    "rang": "451",
    "rang_5_ans": "419",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "33",
    "rang_2024": "451/470",
    "rang_2019_2024": "419/432",
    "lens_2018": "71.8",
    "lens_2019": "68.4",
    "lens_2022": "61.5",
    "lens_2023": "67.2",
    "lens_2024": "69.0",
    "lens_trend": "—",
    "lsec_2018": "74.1",
    "lsec_2019": "74.5",
    "lsec_2022": "71.1",
    "lsec_2023": "76.4",
    "lsec_2024": "73.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.2",
    "scie_2019": "64.1",
    "scie_2022": "56.1",
    "scie_2023": "63.7",
    "scie_2024": "58.0",
    "scie_trend": "—",
    "math_2018": "69.6",
    "math_2019": "68.5",
    "math_2022": "46.4",
    "math_2023": "65.5",
    "math_2024": "65.1",
    "math_trend": "—",
    "echec_2018": "15.4",
    "echec_2019": "27.1",
    "echec_2022": "49.7",
    "echec_2023": "27.3",
    "echec_2024": "30.1",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.4",
    "sures_2022": "9.5",
    "sures_2023": "3.3",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 0.6",
    "ecart_sexes_lens_2022": "F 3.8",
    "ecart_sexes_lens_2023": "F 7.7",
    "ecart_sexes_lens_2024": "F 6.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 11.3",
    "ecart_sexes_math_2019": "F 16.3",
    "ecart_sexes_math_2022": "F 1.6",
    "ecart_sexes_math_2023": "F 6.7",
    "ecart_sexes_math_2024": "F 13.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "40.8",
    "prog_2019": "39.9",
    "prog_2022": "39.5",
    "prog_2023": "44.6",
    "prog_2024": "41.4",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "3.5",
    "cote_2022": "1.2",
    "cote_2023": "3.3",
    "cote_2024": "2.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Pierre-de-Lestage",
    "nom_court": "École secondaire Pierre-de-Lestage",
    "adresse": "881, rue Pierre-de-Lestage",
    "municipalite": "Berthierville",
    "code_postal": "J0K 1A0",
    "lat": 46.0831,
    "lng": -73.19524
  },
  {
    "_id": "211",
    "school_code": "842105",
    "school_name_1": "Barthélemy-Joliette",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "1528",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "371",
    "index": "0.1",
    "en_retard_2024": "12.7",
    "ehdaa_2024": "36.9",
    "rang_2024": "182/470",
    "rang_2019_2024": "371/432",
    "lens_2018": "70.0",
    "lens_2019": "66.7",
    "lens_2022": "66.6",
    "lens_2023": "67.4",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "74.7",
    "lsec_2019": "74.5",
    "lsec_2022": "77.3",
    "lsec_2023": "79.6",
    "lsec_2024": "82.4",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.7",
    "scie_2019": "65.2",
    "scie_2022": "67.7",
    "scie_2023": "78.7",
    "scie_2024": "73.4",
    "scie_trend": "112233",
    "math_2018": "61.1",
    "math_2019": "64.4",
    "math_2022": "62.6",
    "math_2023": "69.0",
    "math_2024": "78.9",
    "math_trend": "112233",
    "echec_2018": "25.6",
    "echec_2019": "26.7",
    "echec_2022": "25.5",
    "echec_2023": "16.0",
    "echec_2024": "14.6",
    "echec_trend": "112233",
    "sures_2018": "2.3",
    "sures_2019": "3.0",
    "sures_2022": "4.0",
    "sures_2023": "1.5",
    "sures_2024": "1.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "M 0.2",
    "ecart_sexes_lens_2022": "F 1.3",
    "ecart_sexes_lens_2023": "F 5.4",
    "ecart_sexes_lens_2024": "F 5.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.9",
    "ecart_sexes_math_2019": "F 9.8",
    "ecart_sexes_math_2022": "F 0.1",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "M 0.3",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "45.3",
    "prog_2019": "42.9",
    "prog_2022": "45.7",
    "prog_2023": "36.9",
    "prog_2024": "33.1",
    "prog_trend": "—",
    "cote_2018": "3.1",
    "cote_2019": "3.1",
    "cote_2022": "4.4",
    "cote_2023": "5.5",
    "cote_2024": "6.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Barthélemy-Joliette",
    "nom_court": "École Barthélemy-Joliette",
    "adresse": "345, rue Sir-Mathias-Tellier Sud",
    "municipalite": "Joliette",
    "code_postal": "J6E 6E6",
    "lat": 46.03103,
    "lng": -73.42282
  },
  {
    "_id": "212",
    "school_code": "842107",
    "school_name_1": "des Montagnes",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "106",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "12.5",
    "ehdaa_2024": "14.2",
    "rang_2024": "360/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "66.5",
    "lens_2019": "66.3",
    "lens_2022": "59.9",
    "lens_2023": "64.7",
    "lens_2024": "62.3",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "80.6",
    "lsec_2022": "76.0",
    "lsec_2023": "78.1",
    "lsec_2024": "79.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.5",
    "scie_2019": "75.2",
    "scie_2022": "68.4",
    "scie_2023": "79.3",
    "scie_2024": "70.7",
    "scie_trend": "—",
    "math_2018": "74.7",
    "math_2019": "61.1",
    "math_2022": "64.7",
    "math_2023": "66.0",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "16.9",
    "echec_2019": "19.1",
    "echec_2022": "32.1",
    "echec_2023": "17.9",
    "echec_2024": "15.5",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "1.2",
    "sures_2022": "3.4",
    "sures_2023": "2.6",
    "sures_2024": "4.7",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "43.9",
    "prog_2019": "21.1",
    "prog_2022": "41.3",
    "prog_2023": "31.4",
    "prog_2024": "36.8",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.1",
    "cote_2022": "3.6",
    "cote_2023": "5.0",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Montagnes",
    "nom_court": "École secondaire des Montagnes",
    "adresse": "290, rue Brassard",
    "municipalite": "Saint-Michel-des-Saints",
    "code_postal": "J0K 3B0",
    "lat": 46.67473,
    "lng": -73.91347
  },
  {
    "_id": "213",
    "school_code": "842108",
    "school_name_1": "Bermon",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "285",
    "langue": "français",
    "secteur": "public",
    "rang": "466",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "19.5",
    "ehdaa_2024": "46",
    "rang_2024": "466/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "63.6",
    "lens_2023": "63.9",
    "lens_2024": "58.7",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "75.0",
    "lsec_2023": "75.0",
    "lsec_2024": "75.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "58.2",
    "scie_2023": "57.2",
    "scie_2024": "65.1",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "61.0",
    "math_2023": "45.8",
    "math_2024": "60.0",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "31.7",
    "echec_2023": "46.2",
    "echec_2024": "36.4",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "6.1",
    "sures_2023": "10.3",
    "sures_2024": "7.4",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 8.9",
    "ecart_sexes_lens_2023": "F 2.1",
    "ecart_sexes_lens_2024": "F 7.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "F 7.6",
    "ecart_sexes_math_2024": "F 6.4",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "26.0",
    "prog_2023": "30.1",
    "prog_2024": "61.2",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "3.7",
    "cote_2023": "0.9",
    "cote_2024": "1.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Bermon",
    "nom_court": "École secondaire Bermon",
    "adresse": "1919, 6e Rang",
    "municipalite": "Saint-Gabriel-de-Brandon",
    "code_postal": "J0K 2N0",
    "lat": 46.30214,
    "lng": -73.40079
  },
  {
    "_id": "214",
    "school_code": "842109",
    "school_name_1": "des Chutes",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "732",
    "langue": "français",
    "secteur": "public",
    "rang": "457",
    "rang_5_ans": "425",
    "index": "0.1",
    "en_retard_2024": "19.3",
    "ehdaa_2024": "46",
    "rang_2024": "457/470",
    "rang_2019_2024": "425/432",
    "lens_2018": "59.0",
    "lens_2019": "68.3",
    "lens_2022": "61.9",
    "lens_2023": "68.9",
    "lens_2024": "64.1",
    "lens_trend": "—",
    "lsec_2018": "72.2",
    "lsec_2019": "74.7",
    "lsec_2022": "77.0",
    "lsec_2023": "72.2",
    "lsec_2024": "73.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "61.7",
    "scie_2019": "60.7",
    "scie_2022": "60.3",
    "scie_2023": "63.7",
    "scie_2024": "61.9",
    "scie_trend": "112233",
    "math_2018": "71.0",
    "math_2019": "71.4",
    "math_2022": "49.8",
    "math_2023": "68.5",
    "math_2024": "64.0",
    "math_trend": "—",
    "echec_2018": "31.8",
    "echec_2019": "24.6",
    "echec_2022": "41.8",
    "echec_2023": "30.7",
    "echec_2024": "30.7",
    "echec_trend": "—",
    "sures_2018": "3.0",
    "sures_2019": "2.9",
    "sures_2022": "6.4",
    "sures_2023": "2.2",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 8.7",
    "ecart_sexes_lens_2022": "F 9.3",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 8.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.1",
    "ecart_sexes_math_2019": "F 11.2",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "F 5.2",
    "ecart_sexes_math_2024": "F 5.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.5",
    "prog_2019": "47.1",
    "prog_2022": "45.3",
    "prog_2023": "47.8",
    "prog_2024": "40.0",
    "prog_trend": "—",
    "cote_2018": "2.8",
    "cote_2019": "3.1",
    "cote_2022": "2.2",
    "cote_2023": "3.4",
    "cote_2024": "2.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Chutes",
    "nom_court": "École secondaire des Chutes",
    "adresse": "3144, 18e Avenue",
    "municipalite": "Rawdon",
    "code_postal": "J0K 1S0",
    "lat": 46.05113,
    "lng": -73.72604
  },
  {
    "_id": "215",
    "school_code": "842199",
    "school_name_1": "de L'Érablière",
    "admin_body_number": "842000",
    "admin_body_name": "Centre de services scolaire des Samares",
    "area_name": "Lanaudière ",
    "étudiants": "1023",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "11.7",
    "ehdaa_2024": "42.5",
    "rang_2024": "182/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "70.6",
    "lens_2019": "67.4",
    "lens_2022": "70.0",
    "lens_2023": "72.2",
    "lens_2024": "68.5",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "75.8",
    "lsec_2022": "81.5",
    "lsec_2023": "82.4",
    "lsec_2024": "80.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "74.1",
    "scie_2022": "71.1",
    "scie_2023": "76.7",
    "scie_2024": "74.8",
    "scie_trend": "112233",
    "math_2018": "72.5",
    "math_2019": "71.4",
    "math_2022": "74.7",
    "math_2023": "78.0",
    "math_2024": "73.7",
    "math_trend": "—",
    "echec_2018": "15.0",
    "echec_2019": "17.8",
    "echec_2022": "15.6",
    "echec_2023": "9.7",
    "echec_2024": "14.6",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "1.0",
    "sures_2022": "1.3",
    "sures_2023": "0.4",
    "sures_2024": "0.8",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 2.4",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 8.2",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "E    ",
    "ecart_sexes_math_2019": "M 0.2",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 7.5",
    "ecart_sexes_math_2024": "M 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.6",
    "prog_2019": "28.6",
    "prog_2022": "34.9",
    "prog_2023": "24.9",
    "prog_2024": "19.4",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.3",
    "cote_2022": "6.4",
    "cote_2023": "6.8",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de l'Érablière",
    "nom_court": "École secondaire de l'Érablière",
    "adresse": "5211, rue Principale",
    "municipalite": "Saint-Félix-de-Valois",
    "code_postal": "J0K 2M0",
    "lat": 46.16763,
    "lng": -73.43326
  },
  {
    "_id": "216",
    "school_code": "851102",
    "school_name_1": "Oka",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1248",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "9.2",
    "ehdaa_2024": "41.1",
    "rang_2024": "323/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "72.9",
    "lens_2019": "72.8",
    "lens_2022": "67.3",
    "lens_2023": "72.0",
    "lens_2024": "68.1",
    "lens_trend": "—",
    "lsec_2018": "82.9",
    "lsec_2019": "80.2",
    "lsec_2022": "82.2",
    "lsec_2023": "83.2",
    "lsec_2024": "75.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.3",
    "scie_2019": "74.4",
    "scie_2022": "67.3",
    "scie_2023": "67.7",
    "scie_2024": "64.4",
    "scie_trend": "998855",
    "math_2018": "72.1",
    "math_2019": "72.8",
    "math_2022": "72.4",
    "math_2023": "72.9",
    "math_2024": "76.1",
    "math_trend": "—",
    "echec_2018": "13.4",
    "echec_2019": "13.4",
    "echec_2022": "22.1",
    "echec_2023": "18.5",
    "echec_2024": "19.8",
    "echec_trend": "998855",
    "sures_2018": "2.2",
    "sures_2019": "1.7",
    "sures_2022": "4.8",
    "sures_2023": "2.0",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 9.0",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.6",
    "ecart_sexes_math_2019": "F 0.1",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "F 0.2",
    "ecart_sexes_math_2024": "M 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.2",
    "prog_2019": "24.2",
    "prog_2022": "23.2",
    "prog_2023": "30.4",
    "prog_2024": "29.0",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "6.4",
    "cote_2022": "5.6",
    "cote_2023": "5.6",
    "cote_2024": "5.1",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire d'Oka",
    "nom_court": "École secondaire d'Oka",
    "adresse": "1700, chemin d'Oka",
    "municipalite": "Oka",
    "code_postal": "J0N 1E0",
    "lat": 45.48915,
    "lng": -74.0333
  },
  {
    "_id": "217",
    "school_code": "851104",
    "school_name_1": "Saint-Gabriel",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "990",
    "langue": "français",
    "secteur": "public",
    "rang": "132",
    "rang_5_ans": "106",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "17.9",
    "rang_2024": "132/470",
    "rang_2019_2024": "106/432",
    "lens_2018": "75.6",
    "lens_2019": "74.6",
    "lens_2022": "69.4",
    "lens_2023": "73.9",
    "lens_2024": "70.6",
    "lens_trend": "—",
    "lsec_2018": "77.6",
    "lsec_2019": "80.2",
    "lsec_2022": "89.0",
    "lsec_2023": "90.1",
    "lsec_2024": "82.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.2",
    "scie_2019": "77.5",
    "scie_2022": "73.7",
    "scie_2023": "80.3",
    "scie_2024": "77.5",
    "scie_trend": "—",
    "math_2018": "75.0",
    "math_2019": "71.1",
    "math_2022": "80.3",
    "math_2023": "79.7",
    "math_2024": "77.9",
    "math_trend": "—",
    "echec_2018": "6.8",
    "echec_2019": "8.8",
    "echec_2022": "10.3",
    "echec_2023": "6.0",
    "echec_2024": "9.5",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "0.5",
    "sures_2022": "1.5",
    "sures_2023": "0.1",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.9",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 8.4",
    "ecart_sexes_lens_2024": "F 4.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "F 8.2",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "F 5.6",
    "ecart_sexes_math_2024": "F 5.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "17.2",
    "prog_2019": "20.0",
    "prog_2022": "19.5",
    "prog_2023": "22.8",
    "prog_2024": "22.0",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "6.7",
    "cote_2022": "7.5",
    "cote_2023": "7.8",
    "cote_2024": "6.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Gabriel",
    "nom_court": "École Saint-Gabriel",
    "adresse": "8, rue Tassé",
    "municipalite": "Sainte-Thérèse",
    "code_postal": "J7E 1V3",
    "lat": 45.64106,
    "lng": -73.83842
  },
  {
    "_id": "218",
    "school_code": "851105",
    "school_name_1": "Polyvalente Sainte-Thérèse",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "2090",
    "langue": "français",
    "secteur": "public",
    "rang": "103",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "6",
    "ehdaa_2024": "36.2",
    "rang_2024": "103/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "71.1",
    "lens_2019": "70.7",
    "lens_2022": "68.5",
    "lens_2023": "68.9",
    "lens_2024": "69.1",
    "lens_trend": "—",
    "lsec_2018": "74.9",
    "lsec_2019": "79.1",
    "lsec_2022": "82.0",
    "lsec_2023": "85.3",
    "lsec_2024": "85.3",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.2",
    "scie_2019": "71.9",
    "scie_2022": "69.9",
    "scie_2023": "73.4",
    "scie_2024": "71.5",
    "scie_trend": "—",
    "math_2018": "76.4",
    "math_2019": "72.5",
    "math_2022": "81.7",
    "math_2023": "82.0",
    "math_2024": "84.4",
    "math_trend": "—",
    "echec_2018": "13.6",
    "echec_2019": "16.8",
    "echec_2022": "15.2",
    "echec_2023": "12.8",
    "echec_2024": "12.4",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "0.6",
    "sures_2022": "1.9",
    "sures_2023": "0.7",
    "sures_2024": "0.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 2.0",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 3.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "E    ",
    "ecart_sexes_math_2019": "F 6.1",
    "ecart_sexes_math_2022": "F 4.5",
    "ecart_sexes_math_2023": "M 2.6",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "24.9",
    "prog_2019": "25.9",
    "prog_2022": "18.3",
    "prog_2023": "21.3",
    "prog_2024": "20.6",
    "prog_trend": "112233",
    "cote_2018": "6.1",
    "cote_2019": "5.7",
    "cote_2022": "7.0",
    "cote_2023": "7.0",
    "cote_2024": "7.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Polyvalente Sainte-Thérèse",
    "nom_court": "Polyvalente Sainte-Thérèse",
    "adresse": "401, boulevard du Domaine",
    "municipalite": "Sainte-Thérèse",
    "code_postal": "J7E 4S4",
    "lat": 45.64973,
    "lng": -73.8265
  },
  {
    "_id": "219",
    "school_code": "851106",
    "school_name_1": "Lucille-Teasdale",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1154",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "8.5",
    "ehdaa_2024": "37.6",
    "rang_2024": "169/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "69.9",
    "lens_2019": "70.8",
    "lens_2022": "66.5",
    "lens_2023": "67.8",
    "lens_2024": "70.9",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "78.2",
    "lsec_2022": "80.1",
    "lsec_2023": "79.3",
    "lsec_2024": "82.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "72.4",
    "scie_2022": "68.1",
    "scie_2023": "72.4",
    "scie_2024": "66.9",
    "scie_trend": "998855",
    "math_2018": "66.5",
    "math_2019": "76.7",
    "math_2022": "80.3",
    "math_2023": "78.2",
    "math_2024": "78.3",
    "math_trend": "—",
    "echec_2018": "18.1",
    "echec_2019": "12.6",
    "echec_2022": "18.4",
    "echec_2023": "16.3",
    "echec_2024": "17.3",
    "echec_trend": "—",
    "sures_2018": "2.4",
    "sures_2019": "1.0",
    "sures_2022": "2.4",
    "sures_2023": "1.3",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.6",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 1.8",
    "ecart_sexes_lens_2023": "F 6.4",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.6",
    "ecart_sexes_math_2019": "F 6.7",
    "ecart_sexes_math_2022": "F 4.2",
    "ecart_sexes_math_2023": "F 5.4",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.0",
    "prog_2019": "23.1",
    "prog_2022": "20.9",
    "prog_2023": "23.1",
    "prog_2024": "19.9",
    "prog_trend": "112233",
    "cote_2018": "5.4",
    "cote_2019": "6.3",
    "cote_2022": "6.4",
    "cote_2023": "5.9",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Lucille-Teasdale",
    "nom_court": "École secondaire Lucille-Teasdale",
    "adresse": "1275, boulevard Céloron",
    "municipalite": "Blainville",
    "code_postal": "J7C 5A8",
    "lat": 45.69839,
    "lng": -73.89859
  },
  {
    "_id": "220",
    "school_code": "851108",
    "school_name_1": "Henri-Dunant",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "850",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "7.5",
    "ehdaa_2024": "41.3",
    "rang_2024": "156/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "68.9",
    "lens_2019": "67.4",
    "lens_2022": "64.3",
    "lens_2023": "64.2",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "79.2",
    "lsec_2022": "78.0",
    "lsec_2023": "75.2",
    "lsec_2024": "79.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.2",
    "scie_2019": "71.3",
    "scie_2022": "72.0",
    "scie_2023": "72.8",
    "scie_2024": "71.6",
    "scie_trend": "—",
    "math_2018": "68.2",
    "math_2019": "76.7",
    "math_2022": "76.2",
    "math_2023": "74.9",
    "math_2024": "83.9",
    "math_trend": "—",
    "echec_2018": "18.1",
    "echec_2019": "17.0",
    "echec_2022": "17.9",
    "echec_2023": "20.2",
    "echec_2024": "14.9",
    "echec_trend": "—",
    "sures_2018": "3.8",
    "sures_2019": "2.0",
    "sures_2022": "3.3",
    "sures_2023": "2.3",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.9",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 2.5",
    "ecart_sexes_math_2019": "F 9.8",
    "ecart_sexes_math_2022": "F 4.6",
    "ecart_sexes_math_2023": "F 5.4",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.7",
    "prog_2019": "21.6",
    "prog_2022": "18.8",
    "prog_2023": "28.6",
    "prog_2024": "25.2",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "5.4",
    "cote_2022": "6.2",
    "cote_2023": "5.1",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Henri-Dunant",
    "nom_court": "École secondaire Henri-Dunant",
    "adresse": "200, rue Marie-Chapleau",
    "municipalite": "Blainville",
    "code_postal": "J7C 5Y8",
    "lat": 45.66612,
    "lng": -73.8832
  },
  {
    "_id": "221",
    "school_code": "851143",
    "school_name_1": "des Patriotes",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1895",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "12.3",
    "ehdaa_2024": "39.1",
    "rang_2024": "335/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "64.7",
    "lens_2019": "68.5",
    "lens_2022": "64.1",
    "lens_2023": "66.1",
    "lens_2024": "64.2",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "81.7",
    "lsec_2022": "79.9",
    "lsec_2023": "79.1",
    "lsec_2024": "82.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.5",
    "scie_2019": "72.1",
    "scie_2022": "63.8",
    "scie_2023": "69.7",
    "scie_2024": "61.1",
    "scie_trend": "—",
    "math_2018": "77.4",
    "math_2019": "77.0",
    "math_2022": "79.0",
    "math_2023": "77.2",
    "math_2024": "82.3",
    "math_trend": "—",
    "echec_2018": "18.2",
    "echec_2019": "15.1",
    "echec_2022": "22.1",
    "echec_2023": "18.0",
    "echec_2024": "23.8",
    "echec_trend": "—",
    "sures_2018": "1.6",
    "sures_2019": "1.5",
    "sures_2022": "3.7",
    "sures_2023": "2.6",
    "sures_2024": "4.6",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.4",
    "ecart_sexes_lens_2019": "F 5.9",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 7.5",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.5",
    "ecart_sexes_math_2019": "F 2.0",
    "ecart_sexes_math_2022": "E",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.7",
    "prog_2019": "35.3",
    "prog_2022": "26.5",
    "prog_2023": "33.7",
    "prog_2024": "34.3",
    "prog_trend": "—",
    "cote_2018": "4.6",
    "cote_2019": "5.8",
    "cote_2022": "5.5",
    "cote_2023": "5.2",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Patriotes",
    "nom_court": "École secondaire des Patriotes",
    "adresse": "99, rue Grignon",
    "municipalite": "Saint-Eustache",
    "code_postal": "J7P 4S4",
    "lat": 45.57479,
    "lng": -73.90686
  },
  {
    "_id": "222",
    "school_code": "851144",
    "school_name_1": "Deux-Montagnes",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "2103",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "8.4",
    "ehdaa_2024": "28.5",
    "rang_2024": "277/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "69.6",
    "lens_2019": "70.1",
    "lens_2022": "64.1",
    "lens_2023": "65.5",
    "lens_2024": "65.7",
    "lens_trend": "—",
    "lsec_2018": "88.2",
    "lsec_2019": "87.7",
    "lsec_2022": "84.9",
    "lsec_2023": "86.1",
    "lsec_2024": "85.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "70.5",
    "scie_2022": "67.0",
    "scie_2023": "73.2",
    "scie_2024": "68.1",
    "scie_trend": "—",
    "math_2018": "74.8",
    "math_2019": "68.8",
    "math_2022": "73.1",
    "math_2023": "75.5",
    "math_2024": "79.0",
    "math_trend": "—",
    "echec_2018": "11.9",
    "echec_2019": "19.2",
    "echec_2022": "22.8",
    "echec_2023": "17.7",
    "echec_2024": "20.1",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "2.7",
    "sures_2022": "4.2",
    "sures_2023": "2.1",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.9",
    "ecart_sexes_lens_2019": "F 5.1",
    "ecart_sexes_lens_2022": "F 5.4",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 9.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.7",
    "ecart_sexes_math_2019": "F 0.1",
    "ecart_sexes_math_2022": "M 2.0",
    "ecart_sexes_math_2023": "M 3.3",
    "ecart_sexes_math_2024": "F 4.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.2",
    "prog_2019": "31.8",
    "prog_2022": "18.1",
    "prog_2023": "29.1",
    "prog_2024": "27.5",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "5.5",
    "cote_2022": "5.9",
    "cote_2023": "5.9",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Deux-Montagnes",
    "nom_court": "Polyvalente Deux-Montagnes",
    "adresse": "500, chemin des Anciens",
    "municipalite": "Deux-Montagnes",
    "code_postal": "J7R 6A7",
    "lat": 45.54662,
    "lng": -73.90653
  },
  {
    "_id": "223",
    "school_code": "851171",
    "school_name_1": "Jean-Jacques-Rousseau",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1229",
    "langue": "français",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "15.5",
    "ehdaa_2024": "43.8",
    "rang_2024": "299/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "66.6",
    "lens_2019": "64.8",
    "lens_2022": "61.8",
    "lens_2023": "64.6",
    "lens_2024": "63.0",
    "lens_trend": "—",
    "lsec_2018": "79.7",
    "lsec_2019": "78.1",
    "lsec_2022": "83.3",
    "lsec_2023": "83.1",
    "lsec_2024": "79.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.6",
    "scie_2019": "66.6",
    "scie_2022": "59.9",
    "scie_2023": "71.3",
    "scie_2024": "65.4",
    "scie_trend": "—",
    "math_2018": "67.9",
    "math_2019": "66.6",
    "math_2022": "72.9",
    "math_2023": "74.0",
    "math_2024": "77.1",
    "math_trend": "—",
    "echec_2018": "21.8",
    "echec_2019": "26.2",
    "echec_2022": "28.3",
    "echec_2023": "18.5",
    "echec_2024": "21.9",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "2.2",
    "sures_2022": "5.3",
    "sures_2023": "2.1",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.2",
    "ecart_sexes_lens_2019": "F 2.6",
    "ecart_sexes_lens_2022": "F 5.0",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.3",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "M 6.2",
    "ecart_sexes_math_2023": "M 1.0",
    "ecart_sexes_math_2024": "M 3.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "45.1",
    "prog_2019": "33.5",
    "prog_2022": "22.4",
    "prog_2023": "26.8",
    "prog_2024": "26.0",
    "prog_trend": "112233",
    "cote_2018": "4.2",
    "cote_2019": "4.3",
    "cote_2022": "4.8",
    "cote_2023": "5.7",
    "cote_2024": "5.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Jean-Jacques-Rousseau",
    "nom_court": "École secondaire Jean-Jacques-Rousseau",
    "adresse": "2700, rue Jean-Charles-Bonenfant",
    "municipalite": "Boisbriand",
    "code_postal": "J7H 1P1",
    "lat": 45.61516,
    "lng": -73.85534
  },
  {
    "_id": "224",
    "school_code": "851172",
    "school_name_1": "du Harfang",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1151",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "14.6",
    "ehdaa_2024": "33",
    "rang_2024": "348/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "66.1",
    "lens_2019": "65.4",
    "lens_2022": "63.8",
    "lens_2023": "63.9",
    "lens_2024": "63.1",
    "lens_trend": "—",
    "lsec_2018": "74.6",
    "lsec_2019": "75.6",
    "lsec_2022": "81.9",
    "lsec_2023": "85.2",
    "lsec_2024": "77.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.1",
    "scie_2019": "67.8",
    "scie_2022": "70.7",
    "scie_2023": "76.2",
    "scie_2024": "63.9",
    "scie_trend": "—",
    "math_2018": "73.3",
    "math_2019": "76.5",
    "math_2022": "75.5",
    "math_2023": "73.6",
    "math_2024": "76.2",
    "math_trend": "—",
    "echec_2018": "15.3",
    "echec_2019": "17.3",
    "echec_2022": "19.2",
    "echec_2023": "17.0",
    "echec_2024": "24.4",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.2",
    "sures_2022": "0.7",
    "sures_2023": "1.2",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.2",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 5.0",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 5.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.1",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 1.4",
    "ecart_sexes_math_2023": "F 6.5",
    "ecart_sexes_math_2024": "M 1.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "42.4",
    "prog_2019": "33.2",
    "prog_2022": "35.2",
    "prog_2023": "34.4",
    "prog_2024": "28.9",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.1",
    "cote_2022": "6.0",
    "cote_2023": "5.9",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Harfang",
    "nom_court": "École secondaire du Harfang",
    "adresse": "140, rue des Saisons",
    "municipalite": "Sainte-Anne-des-Plaines",
    "code_postal": "J5N 3X5",
    "lat": 45.76224,
    "lng": -73.81767
  },
  {
    "_id": "225",
    "school_code": "851173",
    "school_name_1": "Rive-Nord",
    "admin_body_number": "851000",
    "admin_body_name": "Centre de services scolaire des Mille-Îles",
    "area_name": "Laurentides ",
    "étudiants": "1207",
    "langue": "français",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "89",
    "index": "0.1",
    "en_retard_2024": "4.9",
    "ehdaa_2024": "23.1",
    "rang_2024": "112/470",
    "rang_2019_2024": "89/432",
    "lens_2018": "72.1",
    "lens_2019": "74.1",
    "lens_2022": "66.6",
    "lens_2023": "69.1",
    "lens_2024": "65.9",
    "lens_trend": "—",
    "lsec_2018": "79.3",
    "lsec_2019": "80.4",
    "lsec_2022": "83.9",
    "lsec_2023": "80.5",
    "lsec_2024": "81.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.8",
    "scie_2019": "80.4",
    "scie_2022": "75.2",
    "scie_2023": "79.6",
    "scie_2024": "79.0",
    "scie_trend": "—",
    "math_2018": "83.4",
    "math_2019": "83.2",
    "math_2022": "83.3",
    "math_2023": "85.0",
    "math_2024": "84.1",
    "math_trend": "—",
    "echec_2018": "6.9",
    "echec_2019": "8.2",
    "echec_2022": "14.9",
    "echec_2023": "10.9",
    "echec_2024": "10.3",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "0.5",
    "sures_2022": "3.2",
    "sures_2023": "1.7",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 6.9",
    "ecart_sexes_lens_2023": "F 6.2",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 0.5",
    "ecart_sexes_math_2022": "F 2.8",
    "ecart_sexes_math_2023": "F 2.0",
    "ecart_sexes_math_2024": "F 3.3",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "12.0",
    "prog_2019": "9.0",
    "prog_2022": "10.6",
    "prog_2023": "16.3",
    "prog_2024": "12.0",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "8.1",
    "cote_2022": "7.2",
    "cote_2023": "7.1",
    "cote_2024": "7.1",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Rive-Nord",
    "nom_court": "École secondaire Rive-Nord",
    "adresse": "400, rue Joseph-Paquette",
    "municipalite": "Bois-des-Filion",
    "code_postal": "J6Z 4P7",
    "lat": 45.67021,
    "lng": -73.76001
  },
  {
    "_id": "226",
    "school_code": "852004",
    "school_name_1": "Émilien-Frenette",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "974",
    "langue": "français",
    "secteur": "public",
    "rang": "59",
    "rang_5_ans": "89",
    "index": "0.1",
    "en_retard_2024": "16.9",
    "ehdaa_2024": "20.7",
    "rang_2024": "59/470",
    "rang_2019_2024": "89/432",
    "lens_2018": "75.0",
    "lens_2019": "72.7",
    "lens_2022": "71.6",
    "lens_2023": "74.7",
    "lens_2024": "73.7",
    "lens_trend": "—",
    "lsec_2018": "80.3",
    "lsec_2019": "81.2",
    "lsec_2022": "77.2",
    "lsec_2023": "78.3",
    "lsec_2024": "79.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.9",
    "scie_2019": "73.2",
    "scie_2022": "78.9",
    "scie_2023": "80.5",
    "scie_2024": "76.5",
    "scie_trend": "—",
    "math_2018": "78.0",
    "math_2019": "81.0",
    "math_2022": "84.4",
    "math_2023": "83.1",
    "math_2024": "87.9",
    "math_trend": "112233",
    "echec_2018": "9.7",
    "echec_2019": "8.4",
    "echec_2022": "7.3",
    "echec_2023": "5.9",
    "echec_2024": "8.1",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.0",
    "sures_2022": "0.7",
    "sures_2023": "0.7",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.6",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 1.7",
    "ecart_sexes_lens_2023": "F 6.1",
    "ecart_sexes_lens_2024": "F 1.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.2",
    "ecart_sexes_math_2019": "F 1.6",
    "ecart_sexes_math_2022": "M 2.5",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.2",
    "prog_2019": "20.0",
    "prog_2022": "21.8",
    "prog_2023": "21.8",
    "prog_2024": "14.2",
    "prog_trend": "112233",
    "cote_2018": "6.9",
    "cote_2019": "7.3",
    "cote_2022": "7.6",
    "cote_2023": "7.6",
    "cote_2024": "8.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Émilien-Frenette",
    "nom_court": "École secondaire Émilien-Frenette",
    "adresse": "109, rue Marie-Victorin",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Y 2G7",
    "lat": 45.77865,
    "lng": -74.01151
  },
  {
    "_id": "227",
    "school_code": "852008",
    "school_name_1": "Saint-Stanislas",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "682",
    "langue": "français",
    "secteur": "public",
    "rang": "91",
    "rang_5_ans": "93",
    "index": "0.1",
    "en_retard_2024": "14.4",
    "ehdaa_2024": "27.1",
    "rang_2024": "91/470",
    "rang_2019_2024": "93/432",
    "lens_2018": "72.6",
    "lens_2019": "75.0",
    "lens_2022": "73.0",
    "lens_2023": "72.3",
    "lens_2024": "72.2",
    "lens_trend": "—",
    "lsec_2018": "76.6",
    "lsec_2019": "75.5",
    "lsec_2022": "79.6",
    "lsec_2023": "79.8",
    "lsec_2024": "78.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.0",
    "scie_2019": "81.9",
    "scie_2022": "73.1",
    "scie_2023": "80.2",
    "scie_2024": "72.7",
    "scie_trend": "—",
    "math_2018": "82.0",
    "math_2019": "85.8",
    "math_2022": "73.4",
    "math_2023": "68.9",
    "math_2024": "81.9",
    "math_trend": "—",
    "echec_2018": "7.0",
    "echec_2019": "4.4",
    "echec_2022": "12.2",
    "echec_2023": "11.0",
    "echec_2024": "8.9",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.0",
    "sures_2022": "0.0",
    "sures_2023": "0.0",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.2",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "M 0.7",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 5.8",
    "ecart_sexes_math_2019": "F 2.5",
    "ecart_sexes_math_2022": "M 10.4",
    "ecart_sexes_math_2023": "M 5.1",
    "ecart_sexes_math_2024": "F 4.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "9.2",
    "prog_2019": "9.2",
    "prog_2022": "12.0",
    "prog_2023": "11.7",
    "prog_2024": "11.3",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "8.2",
    "cote_2022": "7.2",
    "cote_2023": "6.9",
    "cote_2024": "7.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Stanislas",
    "nom_court": "École secondaire Saint-Stanislas",
    "adresse": "680, 9e Rue",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Z 2Y9",
    "lat": 45.76363,
    "lng": -73.99089
  },
  {
    "_id": "228",
    "school_code": "852010",
    "school_name_1": "Saint-Jérôme",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "3408",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "11.6",
    "ehdaa_2024": "25.7",
    "rang_2024": "137/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "73.5",
    "lens_2019": "74.3",
    "lens_2022": "66.1",
    "lens_2023": "68.4",
    "lens_2024": "67.6",
    "lens_trend": "—",
    "lsec_2018": "80.9",
    "lsec_2019": "81.0",
    "lsec_2022": "80.1",
    "lsec_2023": "79.0",
    "lsec_2024": "80.0",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.9",
    "scie_2019": "79.6",
    "scie_2022": "72.3",
    "scie_2023": "77.1",
    "scie_2024": "72.2",
    "scie_trend": "998855",
    "math_2018": "78.8",
    "math_2019": "79.4",
    "math_2022": "73.5",
    "math_2023": "78.0",
    "math_2024": "85.1",
    "math_trend": "—",
    "echec_2018": "6.5",
    "echec_2019": "6.3",
    "echec_2022": "18.0",
    "echec_2023": "12.4",
    "echec_2024": "14.1",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.2",
    "sures_2022": "3.3",
    "sures_2023": "1.2",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 2.6",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 3.7",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.6",
    "ecart_sexes_math_2019": "F 2.1",
    "ecart_sexes_math_2022": "M 1.2",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "M 0.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.9",
    "prog_2019": "21.9",
    "prog_2022": "23.6",
    "prog_2023": "29.5",
    "prog_2024": "32.3",
    "prog_trend": "998855",
    "cote_2018": "7.4",
    "cote_2019": "7.8",
    "cote_2022": "6.1",
    "cote_2023": "6.5",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente Saint-Jérôme",
    "nom_court": "École polyvalente Saint-Jérôme",
    "adresse": "535, rue Filion",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Z 1J6",
    "lat": 45.7881122,
    "lng": -73.9938836
  },
  {
    "_id": "229",
    "school_code": "852011",
    "school_name_1": "Cap-Jeunesse",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "1576",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "14.4",
    "ehdaa_2024": "31.1",
    "rang_2024": "348/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "69.8",
    "lens_2019": "70.7",
    "lens_2022": "67.3",
    "lens_2023": "66.8",
    "lens_2024": "68.2",
    "lens_trend": "—",
    "lsec_2018": "74.1",
    "lsec_2019": "76.4",
    "lsec_2022": "75.8",
    "lsec_2023": "76.4",
    "lsec_2024": "74.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.8",
    "scie_2019": "70.6",
    "scie_2022": "66.2",
    "scie_2023": "64.5",
    "scie_2024": "65.7",
    "scie_trend": "—",
    "math_2018": "77.3",
    "math_2019": "74.5",
    "math_2022": "76.2",
    "math_2023": "70.3",
    "math_2024": "75.4",
    "math_trend": "998855",
    "echec_2018": "10.7",
    "echec_2019": "14.9",
    "echec_2022": "22.1",
    "echec_2023": "24.9",
    "echec_2024": "21.6",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "3.2",
    "sures_2023": "2.7",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.4",
    "ecart_sexes_lens_2019": "F 0.4",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.1",
    "ecart_sexes_math_2019": "F 6.3",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "F 4.0",
    "ecart_sexes_math_2024": "F 3.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.0",
    "prog_2019": "42.8",
    "prog_2022": "24.1",
    "prog_2023": "29.2",
    "prog_2024": "37.9",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.5",
    "cote_2022": "5.7",
    "cote_2023": "4.4",
    "cote_2024": "4.9",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Cap-Jeunesse",
    "nom_court": "École secondaire Cap-Jeunesse",
    "adresse": "600, 36e Avenue",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Z 5W2",
    "lat": 45.77352,
    "lng": -73.97873
  },
  {
    "_id": "230",
    "school_code": "852041",
    "school_name_1": "des Hauts-Sommets",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "1076",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "14.9",
    "ehdaa_2024": "32.8",
    "rang_2024": "217/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "76.0",
    "lens_2019": "71.9",
    "lens_2022": "68.3",
    "lens_2023": "70.2",
    "lens_2024": "67.1",
    "lens_trend": "998855",
    "lsec_2018": "80.2",
    "lsec_2019": "78.3",
    "lsec_2022": "78.2",
    "lsec_2023": "77.4",
    "lsec_2024": "75.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "75.1",
    "scie_2022": "67.0",
    "scie_2023": "77.1",
    "scie_2024": "70.7",
    "scie_trend": "—",
    "math_2018": "73.9",
    "math_2019": "78.2",
    "math_2022": "68.2",
    "math_2023": "77.0",
    "math_2024": "81.1",
    "math_trend": "—",
    "echec_2018": "10.0",
    "echec_2019": "10.3",
    "echec_2022": "21.4",
    "echec_2023": "12.7",
    "echec_2024": "17.3",
    "echec_trend": "998855",
    "sures_2018": "0.5",
    "sures_2019": "0.3",
    "sures_2022": "4.5",
    "sures_2023": "0.0",
    "sures_2024": "0.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 4.2",
    "ecart_sexes_lens_2022": "F 0.4",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.1",
    "ecart_sexes_math_2019": "F 4.4",
    "ecart_sexes_math_2022": "M 2.5",
    "ecart_sexes_math_2023": "M 1.9",
    "ecart_sexes_math_2024": "E",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "11.5",
    "prog_2019": "16.3",
    "prog_2022": "32.8",
    "prog_2023": "26.8",
    "prog_2024": "24.6",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "6.8",
    "cote_2022": "5.1",
    "cote_2023": "6.2",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire des Hauts-Sommets",
    "nom_court": "École secondaire des Hauts-Sommets",
    "adresse": "1000, 112e Avenue",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Y 5C2",
    "lat": 45.80649,
    "lng": -73.99546
  },
  {
    "_id": "231",
    "school_code": "852042",
    "school_name_1": "Mirabel",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "875",
    "langue": "français",
    "secteur": "public",
    "rang": "120",
    "rang_5_ans": "111",
    "index": "0.1",
    "en_retard_2024": "12.6",
    "ehdaa_2024": "27.2",
    "rang_2024": "120/470",
    "rang_2019_2024": "111/432",
    "lens_2018": "71.1",
    "lens_2019": "72.7",
    "lens_2022": "71.2",
    "lens_2023": "78.0",
    "lens_2024": "69.6",
    "lens_trend": "—",
    "lsec_2018": "73.5",
    "lsec_2019": "75.4",
    "lsec_2022": "75.7",
    "lsec_2023": "80.7",
    "lsec_2024": "75.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.2",
    "scie_2019": "76.4",
    "scie_2022": "75.0",
    "scie_2023": "77.5",
    "scie_2024": "73.8",
    "scie_trend": "—",
    "math_2018": "75.0",
    "math_2019": "81.1",
    "math_2022": "84.1",
    "math_2023": "78.0",
    "math_2024": "84.8",
    "math_trend": "—",
    "echec_2018": "13.2",
    "echec_2019": "8.7",
    "echec_2022": "11.2",
    "echec_2023": "7.4",
    "echec_2024": "13.9",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.1",
    "sures_2022": "0.6",
    "sures_2023": "0.1",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.9",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 6.3",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 1.7",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 1.5",
    "ecart_sexes_math_2019": "M 0.8",
    "ecart_sexes_math_2022": "M 6.2",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "14.5",
    "prog_2019": "19.5",
    "prog_2022": "10.6",
    "prog_2023": "8.8",
    "prog_2024": "12.8",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "7.0",
    "cote_2022": "7.2",
    "cote_2023": "7.9",
    "cote_2024": "7.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Mirabel",
    "nom_court": "École secondaire de Mirabel",
    "adresse": "17777, rue Du Val-d'Espoir",
    "municipalite": "Mirabel",
    "code_postal": "J7J 1V7",
    "lat": 45.71022,
    "lng": -73.93212
  },
  {
    "_id": "232",
    "school_code": "852059",
    "school_name_1": "Lavigne",
    "admin_body_number": "852000",
    "admin_body_name": "Centre de services scolaire de la Rivière-du-Nord",
    "area_name": "Laurentides ",
    "étudiants": "1119",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "14",
    "ehdaa_2024": "40.8",
    "rang_2024": "399/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "68.7",
    "lens_2019": "68.8",
    "lens_2022": "61.3",
    "lens_2023": "66.5",
    "lens_2024": "63.8",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "73.7",
    "lsec_2022": "76.1",
    "lsec_2023": "74.3",
    "lsec_2024": "75.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.0",
    "scie_2019": "72.4",
    "scie_2022": "70.5",
    "scie_2023": "71.3",
    "scie_2024": "66.8",
    "scie_trend": "—",
    "math_2018": "63.6",
    "math_2019": "74.8",
    "math_2022": "70.3",
    "math_2023": "69.5",
    "math_2024": "73.0",
    "math_trend": "—",
    "echec_2018": "19.7",
    "echec_2019": "14.3",
    "echec_2022": "23.9",
    "echec_2023": "19.8",
    "echec_2024": "22.1",
    "echec_trend": "—",
    "sures_2018": "2.6",
    "sures_2019": "1.6",
    "sures_2022": "4.1",
    "sures_2023": "0.8",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.3",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 12.0",
    "ecart_sexes_lens_2023": "F 7.4",
    "ecart_sexes_lens_2024": "F 9.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 8.4",
    "ecart_sexes_math_2019": "F 5.3",
    "ecart_sexes_math_2022": "M 0.5",
    "ecart_sexes_math_2023": "F 5.7",
    "ecart_sexes_math_2024": "F 5.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "38.7",
    "prog_2019": "43.9",
    "prog_2022": "28.5",
    "prog_2023": "41.4",
    "prog_2024": "42.2",
    "prog_trend": "—",
    "cote_2018": "4.4",
    "cote_2019": "5.2",
    "cote_2022": "4.8",
    "cote_2023": "4.8",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École polyvalente Lavigne",
    "nom_court": "École polyvalente Lavigne",
    "adresse": "452, avenue d'Argenteuil",
    "municipalite": "Lachute",
    "code_postal": "J8H 1W9",
    "lat": 45.63904,
    "lng": -74.35074
  },
  {
    "_id": "233",
    "school_code": "853001",
    "school_name_1": "Curé-Mercure",
    "admin_body_number": "853000",
    "admin_body_name": "Centre de services scolaire des Laurentides",
    "area_name": "Laurentides ",
    "étudiants": "938",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "6.5",
    "ehdaa_2024": "34.6",
    "rang_2024": "169/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "71.6",
    "lens_2019": "69.9",
    "lens_2022": "61.6",
    "lens_2023": "71.6",
    "lens_2024": "67.8",
    "lens_trend": "—",
    "lsec_2018": "80.2",
    "lsec_2019": "77.8",
    "lsec_2022": "81.1",
    "lsec_2023": "83.2",
    "lsec_2024": "85.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.6",
    "scie_2019": "63.5",
    "scie_2022": "69.2",
    "scie_2023": "71.3",
    "scie_2024": "67.8",
    "scie_trend": "—",
    "math_2018": "71.7",
    "math_2019": "73.8",
    "math_2022": "75.3",
    "math_2023": "70.2",
    "math_2024": "78.2",
    "math_trend": "—",
    "echec_2018": "16.6",
    "echec_2019": "20.4",
    "echec_2022": "21.8",
    "echec_2023": "16.2",
    "echec_2024": "15.4",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "1.3",
    "sures_2022": "3.5",
    "sures_2023": "1.3",
    "sures_2024": "0.7",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 7.8",
    "ecart_sexes_lens_2019": "F 6.1",
    "ecart_sexes_lens_2022": "F 6.9",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 7.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.9",
    "ecart_sexes_math_2019": "F 9.6",
    "ecart_sexes_math_2022": "M 1.6",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "M 5.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.8",
    "prog_2019": "35.8",
    "prog_2022": "21.8",
    "prog_2023": "34.9",
    "prog_2024": "19.0",
    "prog_trend": "112233",
    "cote_2018": "5.3",
    "cote_2019": "5.2",
    "cote_2022": "5.7",
    "cote_2023": "5.9",
    "cote_2024": "6.4",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire Curé-Mercure",
    "nom_court": "École secondaire Curé-Mercure",
    "adresse": "700, boulevard Docteur-Gervais",
    "municipalite": "Mont-Tremblant",
    "code_postal": "J8E 2T3",
    "lat": 46.12426,
    "lng": -74.58326
  },
  {
    "_id": "234",
    "school_code": "853002",
    "school_name_1": "Augustin-Norbert-Morin",
    "admin_body_number": "853000",
    "admin_body_name": "Centre de services scolaire des Laurentides",
    "area_name": "Laurentides ",
    "étudiants": "1228",
    "langue": "français",
    "secteur": "public",
    "rang": "109",
    "rang_5_ans": "106",
    "index": "0.1",
    "en_retard_2024": "5.2",
    "ehdaa_2024": "30.4",
    "rang_2024": "109/470",
    "rang_2019_2024": "106/432",
    "lens_2018": "70.5",
    "lens_2019": "74.3",
    "lens_2022": "70.3",
    "lens_2023": "72.0",
    "lens_2024": "70.9",
    "lens_trend": "—",
    "lsec_2018": "78.0",
    "lsec_2019": "85.0",
    "lsec_2022": "83.9",
    "lsec_2023": "86.2",
    "lsec_2024": "84.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.6",
    "scie_2019": "76.1",
    "scie_2022": "71.5",
    "scie_2023": "76.3",
    "scie_2024": "68.9",
    "scie_trend": "998855",
    "math_2018": "79.3",
    "math_2019": "85.1",
    "math_2022": "77.2",
    "math_2023": "78.7",
    "math_2024": "81.3",
    "math_trend": "—",
    "echec_2018": "10.2",
    "echec_2019": "7.0",
    "echec_2022": "14.5",
    "echec_2023": "11.6",
    "echec_2024": "12.6",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.3",
    "sures_2022": "0.7",
    "sures_2023": "0.1",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 0.7",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.4",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 1.9",
    "ecart_sexes_math_2023": "F 6.2",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "24.1",
    "prog_2019": "34.3",
    "prog_2022": "24.1",
    "prog_2023": "25.5",
    "prog_2024": "17.2",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "7.7",
    "cote_2022": "7.2",
    "cote_2023": "7.1",
    "cote_2024": "7.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Augustin-Norbert-Morin",
    "nom_court": "École sec. Augustin-Norbert-Morin",
    "adresse": "258, boulevard Sainte-Adèle",
    "municipalite": "Sainte-Adèle",
    "code_postal": "J8B 0K6",
    "lat": 45.93683,
    "lng": -74.13494
  },
  {
    "_id": "235",
    "school_code": "853028",
    "school_name_1": "Monts",
    "admin_body_number": "853000",
    "admin_body_name": "Centre de services scolaire des Laurentides",
    "area_name": "Laurentides ",
    "étudiants": "972",
    "langue": "français",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "10.6",
    "ehdaa_2024": "38.7",
    "rang_2024": "137/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "75.5",
    "lens_2019": "75.7",
    "lens_2022": "71.1",
    "lens_2023": "72.8",
    "lens_2024": "68.9",
    "lens_trend": "998855",
    "lsec_2018": "78.2",
    "lsec_2019": "76.3",
    "lsec_2022": "76.5",
    "lsec_2023": "80.8",
    "lsec_2024": "79.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.8",
    "scie_2019": "79.8",
    "scie_2022": "74.8",
    "scie_2023": "78.9",
    "scie_2024": "74.6",
    "scie_trend": "998855",
    "math_2018": "74.6",
    "math_2019": "71.0",
    "math_2022": "75.7",
    "math_2023": "76.0",
    "math_2024": "80.7",
    "math_trend": "—",
    "echec_2018": "8.5",
    "echec_2019": "10.3",
    "echec_2022": "14.5",
    "echec_2023": "10.5",
    "echec_2024": "12.0",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.5",
    "sures_2022": "0.6",
    "sures_2023": "0.0",
    "sures_2024": "0.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.1",
    "ecart_sexes_lens_2019": "F 8.2",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "F 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.3",
    "ecart_sexes_math_2019": "F 4.8",
    "ecart_sexes_math_2022": "F 2.9",
    "ecart_sexes_math_2023": "F 3.4",
    "ecart_sexes_math_2024": "M 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.2",
    "prog_2019": "33.7",
    "prog_2022": "35.9",
    "prog_2023": "27.4",
    "prog_2024": "33.9",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.3",
    "cote_2022": "6.3",
    "cote_2023": "6.9",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente des Monts",
    "nom_court": "Polyvalente des Monts",
    "adresse": "101, rue Légaré",
    "municipalite": "Sainte-Agathe-des-Monts",
    "code_postal": "J8C 2T6",
    "lat": 46.0524,
    "lng": -74.27662
  },
  {
    "_id": "236",
    "school_code": "854017",
    "school_name_1": "Saint-Joseph",
    "admin_body_number": "854000",
    "admin_body_name": "Centre de services scolaire des Hautes-Laurentides",
    "area_name": "Laurentides ",
    "étudiants": "1357",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "6.9",
    "ehdaa_2024": "36.4",
    "rang_2024": "323/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "73.3",
    "lens_2019": "72.5",
    "lens_2022": "68.5",
    "lens_2023": "69.0",
    "lens_2024": "65.6",
    "lens_trend": "998855",
    "lsec_2018": "75.8",
    "lsec_2019": "78.7",
    "lsec_2022": "77.2",
    "lsec_2023": "77.6",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.0",
    "scie_2019": "73.6",
    "scie_2022": "72.6",
    "scie_2023": "75.5",
    "scie_2024": "71.3",
    "scie_trend": "998855",
    "math_2018": "73.7",
    "math_2019": "74.7",
    "math_2022": "73.5",
    "math_2023": "75.3",
    "math_2024": "73.5",
    "math_trend": "—",
    "echec_2018": "13.3",
    "echec_2019": "11.5",
    "echec_2022": "16.9",
    "echec_2023": "11.9",
    "echec_2024": "19.5",
    "echec_trend": "—",
    "sures_2018": "1.4",
    "sures_2019": "0.9",
    "sures_2022": "2.4",
    "sures_2023": "1.4",
    "sures_2024": "2.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.0",
    "ecart_sexes_lens_2019": "M 0.6",
    "ecart_sexes_lens_2022": "M 0.2",
    "ecart_sexes_lens_2023": "F 0.7",
    "ecart_sexes_lens_2024": "M 0.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.8",
    "ecart_sexes_math_2019": "F 5.8",
    "ecart_sexes_math_2022": "F 7.1",
    "ecart_sexes_math_2023": "F 3.2",
    "ecart_sexes_math_2024": "F 3.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.7",
    "prog_2019": "36.5",
    "prog_2022": "30.7",
    "prog_2023": "39.0",
    "prog_2024": "42.0",
    "prog_trend": "998855",
    "cote_2018": "6.1",
    "cote_2019": "6.3",
    "cote_2022": "6.0",
    "cote_2023": "6.2",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Polyvalente Saint-Joseph",
    "nom_court": "École Polyvalente Saint-Joseph",
    "adresse": "565, rue de la Montagne",
    "municipalite": "Mont-Laurier",
    "code_postal": "J9L 2C9",
    "lat": 46.54174,
    "lng": -75.47876
  },
  {
    "_id": "237",
    "school_code": "861005",
    "school_name_1": "Fernand-Lefebvre",
    "admin_body_number": "861000",
    "admin_body_name": "Centre de services scolaire de Sorel-Tracy",
    "area_name": "Montérégie ",
    "étudiants": "1093",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "12.2",
    "ehdaa_2024": "34.6",
    "rang_2024": "409/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "69.3",
    "lens_2019": "70.2",
    "lens_2022": "66.4",
    "lens_2023": "68.8",
    "lens_2024": "67.1",
    "lens_trend": "—",
    "lsec_2018": "74.6",
    "lsec_2019": "75.0",
    "lsec_2022": "77.9",
    "lsec_2023": "76.8",
    "lsec_2024": "73.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.4",
    "scie_2019": "67.0",
    "scie_2022": "65.7",
    "scie_2023": "67.6",
    "scie_2024": "63.7",
    "scie_trend": "—",
    "math_2018": "59.4",
    "math_2019": "70.1",
    "math_2022": "77.0",
    "math_2023": "68.5",
    "math_2024": "71.5",
    "math_trend": "—",
    "echec_2018": "27.0",
    "echec_2019": "19.2",
    "echec_2022": "20.7",
    "echec_2023": "23.1",
    "echec_2024": "25.8",
    "echec_trend": "—",
    "sures_2018": "4.2",
    "sures_2019": "1.1",
    "sures_2022": "3.0",
    "sures_2023": "2.7",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 5.2",
    "ecart_sexes_lens_2022": "F 8.4",
    "ecart_sexes_lens_2023": "F 3.2",
    "ecart_sexes_lens_2024": "F 2.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.6",
    "ecart_sexes_math_2019": "F 6.5",
    "ecart_sexes_math_2022": "F 5.2",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 0.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "43.8",
    "prog_2019": "42.9",
    "prog_2022": "33.3",
    "prog_2023": "33.3",
    "prog_2024": "37.1",
    "prog_trend": "112233",
    "cote_2018": "3.2",
    "cote_2019": "4.3",
    "cote_2022": "5.2",
    "cote_2023": "4.6",
    "cote_2024": "4.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Fernand-Lefebvre",
    "nom_court": "École secondaire Fernand-Lefebvre",
    "adresse": "265, rue de Ramesay",
    "municipalite": "Sorel-Tracy",
    "code_postal": "J3P 4A5",
    "lat": 46.03581,
    "lng": -73.10325
  },
  {
    "_id": "238",
    "school_code": "862002",
    "school_name_1": "Casavant",
    "admin_body_number": "862000",
    "admin_body_name": "Centre de services scolaire de Saint-Hyacinthe",
    "area_name": "Montérégie ",
    "étudiants": "1344",
    "langue": "français, anglais",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "13",
    "ehdaa_2024": "40.3",
    "rang_2024": "299/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "67.3",
    "lens_2019": "70.6",
    "lens_2022": "67.1",
    "lens_2023": "68.0",
    "lens_2024": "68.4",
    "lens_trend": "—",
    "lsec_2018": "79.7",
    "lsec_2019": "79.6",
    "lsec_2022": "79.4",
    "lsec_2023": "79.9",
    "lsec_2024": "78.5",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.0",
    "scie_2019": "64.1",
    "scie_2022": "63.9",
    "scie_2023": "68.1",
    "scie_2024": "63.7",
    "scie_trend": "—",
    "math_2018": "67.7",
    "math_2019": "72.8",
    "math_2022": "78.1",
    "math_2023": "72.9",
    "math_2024": "77.6",
    "math_trend": "—",
    "echec_2018": "20.3",
    "echec_2019": "20.6",
    "echec_2022": "23.0",
    "echec_2023": "19.1",
    "echec_2024": "21.1",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "1.0",
    "sures_2022": "3.1",
    "sures_2023": "1.2",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.1",
    "ecart_sexes_lens_2019": "F 2.3",
    "ecart_sexes_lens_2022": "F 7.1",
    "ecart_sexes_lens_2023": "F 6.7",
    "ecart_sexes_lens_2024": "F 5.3",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 1.6",
    "ecart_sexes_math_2019": "F 4.7",
    "ecart_sexes_math_2022": "F 2.8",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "F 8.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.9",
    "prog_2019": "39.3",
    "prog_2022": "27.9",
    "prog_2023": "22.4",
    "prog_2024": "21.9",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "4.9",
    "cote_2022": "5.4",
    "cote_2023": "5.4",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Casavant",
    "nom_court": "École secondaire Casavant",
    "adresse": "700 rue Girouard Est",
    "municipalite": "Saint-Hyacinthe",
    "code_postal": "J2S 2Y2",
    "lat": 45.63462,
    "lng": -72.94295
  },
  {
    "_id": "239",
    "school_code": "862004",
    "school_name_1": "Fadette",
    "admin_body_number": "862000",
    "admin_body_name": "Centre de services scolaire de Saint-Hyacinthe",
    "area_name": "Montérégie ",
    "étudiants": "1077",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "8.9",
    "ehdaa_2024": "23.8",
    "rang_2024": "207/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "67.6",
    "lens_2019": "66.3",
    "lens_2022": "68.2",
    "lens_2023": "66.1",
    "lens_2024": "66.9",
    "lens_trend": "—",
    "lsec_2018": "73.1",
    "lsec_2019": "73.2",
    "lsec_2022": "79.4",
    "lsec_2023": "77.6",
    "lsec_2024": "76.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.9",
    "scie_2019": "68.8",
    "scie_2022": "67.7",
    "scie_2023": "71.2",
    "scie_2024": "67.5",
    "scie_trend": "—",
    "math_2018": "66.5",
    "math_2019": "71.2",
    "math_2022": "78.2",
    "math_2023": "72.9",
    "math_2024": "80.5",
    "math_trend": "—",
    "echec_2018": "21.2",
    "echec_2019": "23.2",
    "echec_2022": "18.8",
    "echec_2023": "19.5",
    "echec_2024": "17.0",
    "echec_trend": "—",
    "sures_2018": "3.5",
    "sures_2019": "4.2",
    "sures_2022": "4.1",
    "sures_2023": "4.8",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.9",
    "ecart_sexes_lens_2019": "F 7.0",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 6.9",
    "ecart_sexes_lens_2024": "F 0.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.4",
    "ecart_sexes_math_2019": "F 6.9",
    "ecart_sexes_math_2022": "M 1.8",
    "ecart_sexes_math_2023": "F 5.7",
    "ecart_sexes_math_2024": "F 3.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "16.6",
    "prog_2019": "16.2",
    "prog_2022": "10.8",
    "prog_2023": "15.6",
    "prog_2024": "10.3",
    "prog_trend": "112233",
    "cote_2018": "4.6",
    "cote_2019": "4.2",
    "cote_2022": "6.5",
    "cote_2023": "5.0",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Fadette",
    "nom_court": "École secondaire Fadette",
    "adresse": "2250, avenue Mailhot",
    "municipalite": "Saint-Hyacinthe",
    "code_postal": "J2S 4G2",
    "lat": 45.63462,
    "lng": -72.94295
  },
  {
    "_id": "240",
    "school_code": "862005",
    "school_name_1": "Hyacinthe-Delorme",
    "admin_body_number": "862000",
    "admin_body_name": "Centre de services scolaire de Saint-Hyacinthe",
    "area_name": "Montérégie ",
    "étudiants": "2008",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "19.3",
    "ehdaa_2024": "41",
    "rang_2024": "310/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "75.6",
    "lens_2019": "74.8",
    "lens_2022": "68.2",
    "lens_2023": "69.6",
    "lens_2024": "70.0",
    "lens_trend": "—",
    "lsec_2018": "80.4",
    "lsec_2019": "80.9",
    "lsec_2022": "80.1",
    "lsec_2023": "78.3",
    "lsec_2024": "80.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.8",
    "scie_2019": "71.9",
    "scie_2022": "62.6",
    "scie_2023": "68.9",
    "scie_2024": "65.2",
    "scie_trend": "—",
    "math_2018": "67.6",
    "math_2019": "72.3",
    "math_2022": "67.2",
    "math_2023": "70.6",
    "math_2024": "79.8",
    "math_trend": "112233",
    "echec_2018": "16.6",
    "echec_2019": "15.0",
    "echec_2022": "27.6",
    "echec_2023": "19.6",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "0.3",
    "sures_2022": "3.7",
    "sures_2023": "1.1",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 1.3",
    "ecart_sexes_lens_2024": "F 3.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.9",
    "ecart_sexes_math_2019": "F 5.4",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "M 2.2",
    "ecart_sexes_math_2024": "F 8.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.5",
    "prog_2019": "31.5",
    "prog_2022": "35.1",
    "prog_2023": "40.0",
    "prog_2024": "41.7",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "6.3",
    "cote_2022": "4.8",
    "cote_2023": "5.2",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Hyacinthe-Delorme",
    "nom_court": "Polyvalente Hyacinthe-Delorme",
    "adresse": "2700, avenue T.-D.-Bouchard",
    "municipalite": "Saint-Hyacinthe",
    "code_postal": "J2S 7G2",
    "lat": 45.64146,
    "lng": -72.95142
  },
  {
    "_id": "241",
    "school_code": "862052",
    "school_name_1": "Robert-Ouimet",
    "admin_body_number": "862000",
    "admin_body_name": "Centre de services scolaire de Saint-Hyacinthe",
    "area_name": "Montérégie ",
    "étudiants": "817",
    "langue": "français",
    "secteur": "public",
    "rang": "387",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "17.2",
    "ehdaa_2024": "51",
    "rang_2024": "387/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "71.0",
    "lens_2019": "71.5",
    "lens_2022": "65.2",
    "lens_2023": "68.4",
    "lens_2024": "66.6",
    "lens_trend": "—",
    "lsec_2018": "72.5",
    "lsec_2019": "73.9",
    "lsec_2022": "73.5",
    "lsec_2023": "74.5",
    "lsec_2024": "74.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.1",
    "scie_2019": "72.8",
    "scie_2022": "65.8",
    "scie_2023": "73.3",
    "scie_2024": "69.1",
    "scie_trend": "—",
    "math_2018": "71.5",
    "math_2019": "75.0",
    "math_2022": "71.9",
    "math_2023": "76.5",
    "math_2024": "77.6",
    "math_trend": "—",
    "echec_2018": "14.8",
    "echec_2019": "11.5",
    "echec_2022": "21.8",
    "echec_2023": "15.1",
    "echec_2024": "17.2",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "0.8",
    "sures_2022": "4.2",
    "sures_2023": "1.5",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "M 0.1",
    "ecart_sexes_lens_2022": "F 1.7",
    "ecart_sexes_lens_2023": "M 4.0",
    "ecart_sexes_lens_2024": "F 7.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.7",
    "ecart_sexes_math_2019": "F 2.7",
    "ecart_sexes_math_2022": "M 11.2",
    "ecart_sexes_math_2023": "F 7.9",
    "ecart_sexes_math_2024": "M 2.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.3",
    "prog_2019": "41.8",
    "prog_2022": "40.9",
    "prog_2023": "44.8",
    "prog_2024": "56.1",
    "prog_trend": "998855",
    "cote_2018": "5.4",
    "cote_2019": "5.9",
    "cote_2022": "4.4",
    "cote_2023": "5.1",
    "cote_2024": "4.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Robert-Ouimet",
    "nom_court": "Polyvalente Robert-Ouimet",
    "adresse": "1450, 3e Avenue",
    "municipalite": "Acton Vale",
    "code_postal": "J0H 1A0",
    "lat": 45.65795,
    "lng": -72.57161
  },
  {
    "_id": "242",
    "school_code": "863005",
    "school_name_1": "Paul-Germain-Ostiguy",
    "admin_body_number": "863000",
    "admin_body_name": "Centre de services scolaire des Hautes-Rivières",
    "area_name": "Montérégie ",
    "étudiants": "758",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "399",
    "index": "0.1",
    "en_retard_2024": "15.5",
    "ehdaa_2024": "33",
    "rang_2024": "399/470",
    "rang_2019_2024": "399/432",
    "lens_2018": "67.4",
    "lens_2019": "68.5",
    "lens_2022": "66.2",
    "lens_2023": "67.7",
    "lens_2024": "63.8",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "82.0",
    "lsec_2022": "75.9",
    "lsec_2023": "83.9",
    "lsec_2024": "79.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.6",
    "scie_2019": "63.9",
    "scie_2022": "64.7",
    "scie_2023": "68.9",
    "scie_2024": "65.9",
    "scie_trend": "—",
    "math_2018": "68.0",
    "math_2019": "60.2",
    "math_2022": "60.2",
    "math_2023": "70.4",
    "math_2024": "78.4",
    "math_trend": "—",
    "echec_2018": "21.6",
    "echec_2019": "24.3",
    "echec_2022": "31.2",
    "echec_2023": "17.7",
    "echec_2024": "23.9",
    "echec_trend": "—",
    "sures_2018": "4.0",
    "sures_2019": "8.4",
    "sures_2022": "5.3",
    "sures_2023": "2.5",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.2",
    "ecart_sexes_lens_2019": "F 3.6",
    "ecart_sexes_lens_2022": "F 3.5",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "M 1.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.4",
    "ecart_sexes_math_2019": "M 3.3",
    "ecart_sexes_math_2022": "F 5.1",
    "ecart_sexes_math_2023": "F 8.3",
    "ecart_sexes_math_2024": "F 18.1",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "33.9",
    "prog_2019": "31.0",
    "prog_2022": "44.0",
    "prog_2023": "49.4",
    "prog_2024": "40.6",
    "prog_trend": "—",
    "cote_2018": "4.1",
    "cote_2019": "3.5",
    "cote_2022": "3.4",
    "cote_2023": "4.7",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Paul-Germain-Ostiguy",
    "nom_court": "École Paul-Germain-Ostiguy",
    "adresse": "1881, avenue Saint-Paul",
    "municipalite": "Saint-Césaire",
    "code_postal": "J0L 1T0",
    "lat": 45.41045,
    "lng": -73.01291
  },
  {
    "_id": "243",
    "school_code": "863057",
    "school_name_1": "Joséphine-Dandurand",
    "admin_body_number": "863000",
    "admin_body_name": "Centre de services scolaire des Hautes-Rivières",
    "area_name": "Montérégie ",
    "étudiants": "1126",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "377",
    "index": "0.1",
    "en_retard_2024": "13.5",
    "ehdaa_2024": "27.2",
    "rang_2024": "323/470",
    "rang_2019_2024": "377/432",
    "lens_2018": "68.7",
    "lens_2019": "65.2",
    "lens_2022": "63.0",
    "lens_2023": "68.4",
    "lens_2024": "65.8",
    "lens_trend": "—",
    "lsec_2018": "75.9",
    "lsec_2019": "79.8",
    "lsec_2022": "78.6",
    "lsec_2023": "80.4",
    "lsec_2024": "78.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.9",
    "scie_2019": "61.3",
    "scie_2022": "60.4",
    "scie_2023": "69.0",
    "scie_2024": "64.6",
    "scie_trend": "—",
    "math_2018": "68.4",
    "math_2019": "67.9",
    "math_2022": "65.9",
    "math_2023": "69.7",
    "math_2024": "76.0",
    "math_trend": "—",
    "echec_2018": "22.9",
    "echec_2019": "28.5",
    "echec_2022": "33.0",
    "echec_2023": "21.1",
    "echec_2024": "21.6",
    "echec_trend": "—",
    "sures_2018": "1.6",
    "sures_2019": "5.1",
    "sures_2022": "7.1",
    "sures_2023": "1.4",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.0",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 4.1",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.0",
    "ecart_sexes_math_2019": "F 2.6",
    "ecart_sexes_math_2022": "F 6.3",
    "ecart_sexes_math_2023": "M 4.0",
    "ecart_sexes_math_2024": "F 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.3",
    "prog_2019": "36.3",
    "prog_2022": "24.0",
    "prog_2023": "37.4",
    "prog_2024": "40.2",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "3.4",
    "cote_2022": "4.0",
    "cote_2023": "5.1",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Joséphine-Dandurand",
    "nom_court": "École Joséphine-Dandurand",
    "adresse": "90, rue Mackenzie-King",
    "municipalite": "Saint-Jean-sur-Richelieu",
    "code_postal": "J3B 5N9",
    "lat": 45.30273,
    "lng": -73.26499
  },
  {
    "_id": "244",
    "school_code": "863065",
    "school_name_1": "Marcel-Landry",
    "admin_body_number": "863000",
    "admin_body_name": "Centre de services scolaire des Hautes-Rivières",
    "area_name": "Montérégie ",
    "étudiants": "1732",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "16.1",
    "ehdaa_2024": "28.8",
    "rang_2024": "310/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "73.7",
    "lens_2019": "71.1",
    "lens_2022": "66.9",
    "lens_2023": "70.3",
    "lens_2024": "65.3",
    "lens_trend": "—",
    "lsec_2018": "80.9",
    "lsec_2019": "78.1",
    "lsec_2022": "84.5",
    "lsec_2023": "81.6",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.5",
    "scie_2019": "70.2",
    "scie_2022": "68.6",
    "scie_2023": "74.9",
    "scie_2024": "70.2",
    "scie_trend": "—",
    "math_2018": "72.9",
    "math_2019": "74.8",
    "math_2022": "71.0",
    "math_2023": "72.8",
    "math_2024": "75.3",
    "math_trend": "998855",
    "echec_2018": "11.7",
    "echec_2019": "17.6",
    "echec_2022": "23.6",
    "echec_2023": "16.3",
    "echec_2024": "21.1",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.6",
    "sures_2022": "4.1",
    "sures_2023": "1.7",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 5.7",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 6.9",
    "ecart_sexes_lens_2024": "F 8.7",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 3.9",
    "ecart_sexes_math_2019": "F 6.7",
    "ecart_sexes_math_2022": "M 5.1",
    "ecart_sexes_math_2023": "M 3.5",
    "ecart_sexes_math_2024": "M 3.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "22.8",
    "prog_2019": "32.8",
    "prog_2022": "28.3",
    "prog_2023": "29.4",
    "prog_2024": "23.9",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "5.3",
    "cote_2022": "5.5",
    "cote_2023": "5.9",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Marcel-Landry",
    "nom_court": "Polyvalente Marcel-Landry",
    "adresse": "365, avenue Landry",
    "municipalite": "Saint-Jean-sur-Richelieu",
    "code_postal": "J2X 2P6",
    "lat": 45.29465,
    "lng": -73.23461
  },
  {
    "_id": "245",
    "school_code": "863067",
    "school_name_1": "Chanoine-Armand-Racicot",
    "admin_body_number": "863000",
    "admin_body_name": "Centre de services scolaire des Hautes-Rivières",
    "area_name": "Montérégie ",
    "étudiants": "1506",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "17",
    "ehdaa_2024": "31.6",
    "rang_2024": "260/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "70.9",
    "lens_2019": "71.9",
    "lens_2022": "69.0",
    "lens_2023": "71.3",
    "lens_2024": "69.3",
    "lens_trend": "—",
    "lsec_2018": "81.7",
    "lsec_2019": "76.7",
    "lsec_2022": "77.0",
    "lsec_2023": "82.8",
    "lsec_2024": "80.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.6",
    "scie_2019": "69.3",
    "scie_2022": "64.0",
    "scie_2023": "70.1",
    "scie_2024": "64.3",
    "scie_trend": "—",
    "math_2018": "71.9",
    "math_2019": "72.9",
    "math_2022": "77.0",
    "math_2023": "77.5",
    "math_2024": "80.9",
    "math_trend": "112233",
    "echec_2018": "16.1",
    "echec_2019": "16.7",
    "echec_2022": "24.2",
    "echec_2023": "15.8",
    "echec_2024": "19.3",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "1.6",
    "sures_2022": "4.8",
    "sures_2023": "1.2",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 9.3",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.8",
    "ecart_sexes_math_2019": "F 3.6",
    "ecart_sexes_math_2022": "F 8.0",
    "ecart_sexes_math_2023": "F 3.2",
    "ecart_sexes_math_2024": "F 1.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "39.7",
    "prog_2019": "40.5",
    "prog_2022": "35.8",
    "prog_2023": "30.2",
    "prog_2024": "30.8",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "5.1",
    "cote_2022": "4.6",
    "cote_2023": "6.2",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente Chanoine-Armand-Racicot",
    "nom_court": "Polyv. Chanoine-Armand-Racicot",
    "adresse": "940, boulevard de Normandie",
    "municipalite": "Saint-Jean-sur-Richelieu",
    "code_postal": "J3A 1A7",
    "lat": 45.33306,
    "lng": -73.27677
  },
  {
    "_id": "246",
    "school_code": "863069",
    "school_name_1": "Monseigneur-Euclide-Théberge",
    "admin_body_number": "863000",
    "admin_body_name": "Centre de services scolaire des Hautes-Rivières",
    "area_name": "Montérégie ",
    "étudiants": "1301",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "13.3",
    "ehdaa_2024": "38.7",
    "rang_2024": "169/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "72.1",
    "lens_2019": "68.2",
    "lens_2022": "67.3",
    "lens_2023": "70.7",
    "lens_2024": "69.3",
    "lens_trend": "—",
    "lsec_2018": "80.3",
    "lsec_2019": "78.5",
    "lsec_2022": "82.0",
    "lsec_2023": "80.4",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.6",
    "scie_2019": "69.0",
    "scie_2022": "72.6",
    "scie_2023": "74.4",
    "scie_2024": "68.3",
    "scie_trend": "—",
    "math_2018": "71.6",
    "math_2019": "72.1",
    "math_2022": "77.4",
    "math_2023": "74.8",
    "math_2024": "79.8",
    "math_trend": "—",
    "echec_2018": "14.5",
    "echec_2019": "21.0",
    "echec_2022": "17.4",
    "echec_2023": "15.2",
    "echec_2024": "14.9",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.9",
    "sures_2022": "2.6",
    "sures_2023": "1.5",
    "sures_2024": "0.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 7.4",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.1",
    "ecart_sexes_math_2019": "F 10.2",
    "ecart_sexes_math_2022": "F 2.1",
    "ecart_sexes_math_2023": "F 1.5",
    "ecart_sexes_math_2024": "F 4.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.0",
    "prog_2019": "32.5",
    "prog_2022": "23.4",
    "prog_2023": "17.3",
    "prog_2024": "25.7",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "4.7",
    "cote_2022": "6.5",
    "cote_2023": "6.4",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Monseigneur-Euclide-Théberge",
    "nom_court": "École Mgr-Euclide-Théberge",
    "adresse": "677, rue Desjardins",
    "municipalite": "Marieville",
    "code_postal": "J3M 1R1",
    "lat": 45.43192,
    "lng": -73.14885
  },
  {
    "_id": "247",
    "school_code": "864218",
    "school_name_1": "Saint-Edmond",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "875",
    "langue": "français",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "18.2",
    "ehdaa_2024": "24.8",
    "rang_2024": "323/470",
    "rang_2019_2024": "nd",
    "lens_2018": "73.0",
    "lens_2019": "nd",
    "lens_2022": "63.1",
    "lens_2023": "66.2",
    "lens_2024": "65.7",
    "lens_trend": "nd",
    "lsec_2018": "84.9",
    "lsec_2019": "nd",
    "lsec_2022": "87.9",
    "lsec_2023": "85.5",
    "lsec_2024": "88.3",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.5",
    "scie_2019": "nd",
    "scie_2022": "65.3",
    "scie_2023": "68.6",
    "scie_2024": "61.5",
    "scie_trend": "nd",
    "math_2018": "79.0",
    "math_2019": "nd",
    "math_2022": "82.7",
    "math_2023": "72.5",
    "math_2024": "75.5",
    "math_trend": "nd",
    "echec_2018": "11.3",
    "echec_2019": "nd",
    "echec_2022": "22.8",
    "echec_2023": "20.3",
    "echec_2024": "24.9",
    "echec_trend": "nd",
    "sures_2018": "0.0",
    "sures_2019": "nd",
    "sures_2022": "3.8",
    "sures_2023": "1.5",
    "sures_2024": "2.4",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 0.3",
    "ecart_sexes_lens_2023": "F 3.5",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 4.2",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 5.6",
    "ecart_sexes_math_2023": "M 1.4",
    "ecart_sexes_math_2024": "F 4.1",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "21.7",
    "prog_2019": "nd",
    "prog_2022": "31.3",
    "prog_2023": "32.4",
    "prog_2024": "34.5",
    "prog_trend": "nd",
    "cote_2018": "7.0",
    "cote_2019": "nd",
    "cote_2022": "6.0",
    "cote_2023": "5.6",
    "cote_2024": "5.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Edmond",
    "nom_court": "École secondaire Saint-Edmond",
    "adresse": "346, rue Hubert",
    "municipalite": "Longueuil",
    "code_postal": "J4V 1S2",
    "lat": 45.48861,
    "lng": -73.48653
  },
  {
    "_id": "248",
    "school_code": "864240",
    "school_name_1": "Lucille-Teasdale",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "1105",
    "langue": "français",
    "secteur": "public",
    "rang": "15",
    "rang_5_ans": "18",
    "index": "0.1",
    "en_retard_2024": "2.4",
    "ehdaa_2024": "3.4",
    "rang_2024": "15/470",
    "rang_2019_2024": "18/432",
    "lens_2018": "75.2",
    "lens_2019": "77.1",
    "lens_2022": "79.2",
    "lens_2023": "76.5",
    "lens_2024": "73.8",
    "lens_trend": "—",
    "lsec_2018": "84.4",
    "lsec_2019": "92.1",
    "lsec_2022": "84.0",
    "lsec_2023": "88.4",
    "lsec_2024": "86.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.6",
    "scie_2019": "82.8",
    "scie_2022": "85.6",
    "scie_2023": "89.7",
    "scie_2024": "89.1",
    "scie_trend": "—",
    "math_2018": "85.1",
    "math_2019": "86.3",
    "math_2022": "90.3",
    "math_2023": "91.8",
    "math_2024": "92.1",
    "math_trend": "112233",
    "echec_2018": "4.6",
    "echec_2019": "3.7",
    "echec_2022": "3.0",
    "echec_2023": "3.3",
    "echec_2024": "2.8",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "0.7",
    "sures_2022": "2.1",
    "sures_2023": "1.3",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "F 2.8",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 0.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.6",
    "ecart_sexes_math_2019": "F 3.8",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "M 0.2",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "0.0",
    "prog_2019": "4.0",
    "prog_2022": "2.8",
    "prog_2023": "2.5",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "8.6",
    "cote_2019": "9.2",
    "cote_2022": "9.4",
    "cote_2023": "9.2",
    "cote_2024": "9.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École internationale Lucille-Teasdale",
    "nom_court": "École internationale Lucille-Teasdale",
    "adresse": "8350, boulevard Pelletier",
    "municipalite": "Brossard",
    "code_postal": "J4X 1M8",
    "lat": 45.44873,
    "lng": -73.47787
  },
  {
    "_id": "249",
    "school_code": "864271",
    "school_name_1": "l'Agora",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "371",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "7.4",
    "ehdaa_2024": "41.2",
    "rang_2024": "182/470",
    "rang_2019_2024": "nd",
    "lens_2018": "69.5",
    "lens_2019": "nd",
    "lens_2022": "65.0",
    "lens_2023": "61.4",
    "lens_2024": "65.2",
    "lens_trend": "nd",
    "lsec_2018": "85.5",
    "lsec_2019": "nd",
    "lsec_2022": "88.2",
    "lsec_2023": "86.2",
    "lsec_2024": "92.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.4",
    "scie_2019": "nd",
    "scie_2022": "64.6",
    "scie_2023": "70.8",
    "scie_2024": "69.9",
    "scie_trend": "nd",
    "math_2018": "70.4",
    "math_2019": "nd",
    "math_2022": "57.3",
    "math_2023": "61.5",
    "math_2024": "71.0",
    "math_trend": "nd",
    "echec_2018": "24.0",
    "echec_2019": "nd",
    "echec_2022": "32.5",
    "echec_2023": "24.6",
    "echec_2024": "18.9",
    "echec_trend": "nd",
    "sures_2018": "2.5",
    "sures_2019": "nd",
    "sures_2022": "5.9",
    "sures_2023": "5.9",
    "sures_2024": "3.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "F 10.0",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 8.4",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 5.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "M 3.8",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 0.7",
    "ecart_sexes_math_2023": "F 15.6",
    "ecart_sexes_math_2024": "M 6.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "36.3",
    "prog_2019": "nd",
    "prog_2022": "13.2",
    "prog_2023": "13.9",
    "prog_2024": "30.4",
    "prog_trend": "nd",
    "cote_2018": "5.0",
    "cote_2019": "nd",
    "cote_2022": "5.5",
    "cote_2023": "4.6",
    "cote_2024": "6.3",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de l'Agora",
    "nom_court": "École secondaire de l'Agora",
    "adresse": "1001, rue Du Centenaire",
    "municipalite": "Longueuil",
    "code_postal": "J4V 1B8",
    "lat": 45.48847,
    "lng": -73.45212
  },
  {
    "_id": "250",
    "school_code": "864275",
    "school_name_1": "André-Laurendeau",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "2607",
    "langue": "français",
    "secteur": "public",
    "rang": "294",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "12.3",
    "ehdaa_2024": "27.6",
    "rang_2024": "294/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "68.0",
    "lens_2019": "70.3",
    "lens_2022": "65.1",
    "lens_2023": "67.9",
    "lens_2024": "63.3",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "81.1",
    "lsec_2022": "78.7",
    "lsec_2023": "79.6",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.9",
    "scie_2019": "65.3",
    "scie_2022": "66.8",
    "scie_2023": "70.8",
    "scie_2024": "70.1",
    "scie_trend": "112233",
    "math_2018": "74.3",
    "math_2019": "71.4",
    "math_2022": "66.7",
    "math_2023": "69.9",
    "math_2024": "76.0",
    "math_trend": "—",
    "echec_2018": "20.3",
    "echec_2019": "21.5",
    "echec_2022": "29.2",
    "echec_2023": "20.8",
    "echec_2024": "21.7",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "1.3",
    "sures_2022": "4.5",
    "sures_2023": "2.7",
    "sures_2024": "3.9",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 2.0",
    "ecart_sexes_lens_2023": "F 4.0",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.9",
    "ecart_sexes_math_2019": "F 6.5",
    "ecart_sexes_math_2022": "F 7.1",
    "ecart_sexes_math_2023": "F 1.8",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.6",
    "prog_2019": "34.6",
    "prog_2022": "18.7",
    "prog_2023": "26.9",
    "prog_2024": "23.0",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "4.9",
    "cote_2022": "4.9",
    "cote_2023": "5.2",
    "cote_2024": "5.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École André-Laurendeau",
    "nom_court": "École André-Laurendeau",
    "adresse": "7450, boulevard Cousineau",
    "municipalite": "Longueuil",
    "code_postal": "J3Y 3L4",
    "lat": 45.48589,
    "lng": -73.39445
  },
  {
    "_id": "251",
    "school_code": "864276",
    "school_name_1": "Antoine-Brossard",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "2097",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "391",
    "index": "0.1",
    "en_retard_2024": "22.1",
    "ehdaa_2024": "30.3",
    "rang_2024": "420/470",
    "rang_2019_2024": "391/432",
    "lens_2018": "64.5",
    "lens_2019": "66.1",
    "lens_2022": "62.1",
    "lens_2023": "63.4",
    "lens_2024": "64.7",
    "lens_trend": "112233",
    "lsec_2018": "71.5",
    "lsec_2019": "75.5",
    "lsec_2022": "72.4",
    "lsec_2023": "74.2",
    "lsec_2024": "79.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.5",
    "scie_2019": "66.0",
    "scie_2022": "64.5",
    "scie_2023": "67.3",
    "scie_2024": "60.7",
    "scie_trend": "998855",
    "math_2018": "72.3",
    "math_2019": "73.6",
    "math_2022": "68.6",
    "math_2023": "70.3",
    "math_2024": "70.8",
    "math_trend": "998855",
    "echec_2018": "22.3",
    "echec_2019": "21.0",
    "echec_2022": "29.0",
    "echec_2023": "26.6",
    "echec_2024": "27.4",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.2",
    "sures_2022": "1.7",
    "sures_2023": "0.3",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.1",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.1",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "E",
    "ecart_sexes_math_2023": "M 2.1",
    "ecart_sexes_math_2024": "F 8.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "50.4",
    "prog_2019": "43.2",
    "prog_2022": "42.0",
    "prog_2023": "44.1",
    "prog_2024": "43.9",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "4.5",
    "cote_2022": "4.1",
    "cote_2023": "4.3",
    "cote_2024": "4.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Antoine-Brossard",
    "nom_court": "École Antoine-Brossard",
    "adresse": "3055, boulevard Rome",
    "municipalite": "Brossard",
    "code_postal": "J4Y 1S9",
    "lat": 45.45032,
    "lng": -73.45847
  },
  {
    "_id": "252",
    "school_code": "864278",
    "school_name_1": "Gérard-Filion",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "1948",
    "langue": "français",
    "secteur": "public",
    "rang": "462",
    "rang_5_ans": "428",
    "index": "0.1",
    "en_retard_2024": "35",
    "ehdaa_2024": "43.8",
    "rang_2024": "462/470",
    "rang_2019_2024": "428/432",
    "lens_2018": "62.6",
    "lens_2019": "65.8",
    "lens_2022": "57.3",
    "lens_2023": "58.8",
    "lens_2024": "57.2",
    "lens_trend": "—",
    "lsec_2018": "70.3",
    "lsec_2019": "75.7",
    "lsec_2022": "78.8",
    "lsec_2023": "74.7",
    "lsec_2024": "74.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.5",
    "scie_2019": "61.4",
    "scie_2022": "54.5",
    "scie_2023": "57.2",
    "scie_2024": "56.7",
    "scie_trend": "—",
    "math_2018": "68.9",
    "math_2019": "70.7",
    "math_2022": "55.9",
    "math_2023": "64.1",
    "math_2024": "63.7",
    "math_trend": "—",
    "echec_2018": "26.8",
    "echec_2019": "27.2",
    "echec_2022": "46.1",
    "echec_2023": "37.5",
    "echec_2024": "38.0",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.9",
    "sures_2022": "9.0",
    "sures_2023": "1.8",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 0.9",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 2.0",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.4",
    "ecart_sexes_math_2019": "F 2.7",
    "ecart_sexes_math_2022": "F 3.6",
    "ecart_sexes_math_2023": "M 1.7",
    "ecart_sexes_math_2024": "F 3.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "61.5",
    "prog_2019": "68.5",
    "prog_2022": "60.4",
    "prog_2023": "58.0",
    "prog_2024": "55.8",
    "prog_trend": "—",
    "cote_2018": "3.0",
    "cote_2019": "3.2",
    "cote_2022": "1.4",
    "cote_2023": "2.3",
    "cote_2024": "2.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Gérard-Filion",
    "nom_court": "École Gérard-Filion",
    "adresse": "1330, boulevard Curé-Poirier Ouest",
    "municipalite": "Longueuil",
    "code_postal": "J4K 2G8",
    "lat": 45.51207,
    "lng": -73.49147
  },
  {
    "_id": "253",
    "school_code": "864280",
    "school_name_1": "Jacques-Rousseau",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "2374",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "16.5",
    "ehdaa_2024": "35.3",
    "rang_2024": "376/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "65.7",
    "lens_2019": "68.2",
    "lens_2022": "62.0",
    "lens_2023": "65.7",
    "lens_2024": "63.2",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "75.4",
    "lsec_2022": "79.3",
    "lsec_2023": "78.0",
    "lsec_2024": "76.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.5",
    "scie_2019": "70.7",
    "scie_2022": "66.0",
    "scie_2023": "68.4",
    "scie_2024": "62.3",
    "scie_trend": "998855",
    "math_2018": "72.7",
    "math_2019": "75.0",
    "math_2022": "72.8",
    "math_2023": "69.4",
    "math_2024": "75.8",
    "math_trend": "—",
    "echec_2018": "18.8",
    "echec_2019": "19.0",
    "echec_2022": "29.5",
    "echec_2023": "25.8",
    "echec_2024": "26.5",
    "echec_trend": "998855",
    "sures_2018": "1.6",
    "sures_2019": "0.6",
    "sures_2022": "4.9",
    "sures_2023": "2.1",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.8",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "M 0.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.1",
    "ecart_sexes_math_2019": "M 1.4",
    "ecart_sexes_math_2022": "F 2.9",
    "ecart_sexes_math_2023": "F 3.8",
    "ecart_sexes_math_2024": "F 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.2",
    "prog_2019": "25.7",
    "prog_2022": "27.0",
    "prog_2023": "38.1",
    "prog_2024": "32.4",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "5.4",
    "cote_2022": "4.8",
    "cote_2023": "4.4",
    "cote_2024": "4.6",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Jacques-Rousseau",
    "nom_court": "École Jacques-Rousseau",
    "adresse": "444, rue de Gentilly Est",
    "municipalite": "Longueuil",
    "code_postal": "J4H 3X7",
    "lat": 45.53919,
    "lng": -73.49152
  },
  {
    "_id": "254",
    "school_code": "864284",
    "school_name_1": "Monseigneur-A.-M.-Parent",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "2225",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "19",
    "ehdaa_2024": "36.4",
    "rang_2024": "399/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "68.4",
    "lens_2019": "66.9",
    "lens_2022": "59.7",
    "lens_2023": "63.7",
    "lens_2024": "63.6",
    "lens_trend": "—",
    "lsec_2018": "76.4",
    "lsec_2019": "73.2",
    "lsec_2022": "73.8",
    "lsec_2023": "74.4",
    "lsec_2024": "75.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.1",
    "scie_2019": "68.9",
    "scie_2022": "67.0",
    "scie_2023": "70.5",
    "scie_2024": "66.2",
    "scie_trend": "—",
    "math_2018": "66.0",
    "math_2019": "67.7",
    "math_2022": "65.8",
    "math_2023": "75.7",
    "math_2024": "76.1",
    "math_trend": "—",
    "echec_2018": "24.6",
    "echec_2019": "24.9",
    "echec_2022": "31.7",
    "echec_2023": "22.4",
    "echec_2024": "23.1",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "2.3",
    "sures_2022": "6.6",
    "sures_2023": "1.4",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.8",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 3.5",
    "ecart_sexes_lens_2023": "F 0.5",
    "ecart_sexes_lens_2024": "M 0.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.8",
    "ecart_sexes_math_2019": "F 6.7",
    "ecart_sexes_math_2022": "F 7.4",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "M 3.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "56.9",
    "prog_2019": "59.3",
    "prog_2022": "44.6",
    "prog_2023": "51.5",
    "prog_2024": "56.9",
    "prog_trend": "—",
    "cote_2018": "4.1",
    "cote_2019": "3.3",
    "cote_2022": "3.2",
    "cote_2023": "4.7",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Monseigneur-A.-M.-Parent",
    "nom_court": "École sec. Monseigneur-A.-M.-Parent",
    "adresse": "3875, boulevard Grande-Allée",
    "municipalite": "Longueuil",
    "code_postal": "J4T 2V8",
    "lat": 45.4914,
    "lng": -73.46338
  },
  {
    "_id": "255",
    "school_code": "864287",
    "school_name_1": "Saint-Jean-Baptiste",
    "admin_body_number": "864000",
    "admin_body_name": "Centre de services scolaire Marie-Victorin",
    "area_name": "Montérégie ",
    "étudiants": "561",
    "langue": "français",
    "secteur": "public",
    "rang": "409",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "28.7",
    "ehdaa_2024": "33",
    "rang_2024": "409/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "66.2",
    "lens_2019": "66.8",
    "lens_2022": "57.6",
    "lens_2023": "60.5",
    "lens_2024": "63.5",
    "lens_trend": "—",
    "lsec_2018": "82.7",
    "lsec_2019": "85.4",
    "lsec_2022": "85.5",
    "lsec_2023": "84.7",
    "lsec_2024": "89.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.3",
    "scie_2019": "62.7",
    "scie_2022": "63.3",
    "scie_2023": "64.9",
    "scie_2024": "57.6",
    "scie_trend": "—",
    "math_2018": "67.0",
    "math_2019": "70.1",
    "math_2022": "60.3",
    "math_2023": "67.9",
    "math_2024": "67.0",
    "math_trend": "—",
    "echec_2018": "19.1",
    "echec_2019": "24.4",
    "echec_2022": "39.9",
    "echec_2023": "25.6",
    "echec_2024": "29.7",
    "echec_trend": "—",
    "sures_2018": "3.3",
    "sures_2019": "1.0",
    "sures_2022": "7.6",
    "sures_2023": "3.3",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "M 3.1",
    "ecart_sexes_lens_2022": "F 8.2",
    "ecart_sexes_lens_2023": "F 5.7",
    "ecart_sexes_lens_2024": "F 4.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.0",
    "ecart_sexes_math_2019": "M 5.7",
    "ecart_sexes_math_2022": "M 7.1",
    "ecart_sexes_math_2023": "F 3.5",
    "ecart_sexes_math_2024": "M 4.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.3",
    "prog_2019": "21.1",
    "prog_2022": "29.3",
    "prog_2023": "38.0",
    "prog_2024": "37.4",
    "prog_trend": "—",
    "cote_2018": "4.8",
    "cote_2019": "5.0",
    "cote_2022": "3.3",
    "cote_2023": "4.1",
    "cote_2024": "4.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Jean-Baptiste",
    "nom_court": "École Saint-Jean-Baptiste",
    "adresse": "700, rue Duvernay",
    "municipalite": "Longueuil",
    "code_postal": "J4K 4L1",
    "lat": 45.52458,
    "lng": -73.50894
  },
  {
    "_id": "256",
    "school_code": "865106",
    "school_name_1": "Polybel",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "1554",
    "langue": "français",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "13.4",
    "ehdaa_2024": "50.7",
    "rang_2024": "252/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "68.2",
    "lens_2019": "69.8",
    "lens_2022": "65.6",
    "lens_2023": "66.9",
    "lens_2024": "67.7",
    "lens_trend": "—",
    "lsec_2018": "73.2",
    "lsec_2019": "72.2",
    "lsec_2022": "80.4",
    "lsec_2023": "78.4",
    "lsec_2024": "80.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.4",
    "scie_2019": "70.2",
    "scie_2022": "67.3",
    "scie_2023": "72.0",
    "scie_2024": "69.0",
    "scie_trend": "—",
    "math_2018": "71.4",
    "math_2019": "69.4",
    "math_2022": "70.8",
    "math_2023": "69.0",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "18.6",
    "echec_2019": "18.8",
    "echec_2022": "24.8",
    "echec_2023": "19.6",
    "echec_2024": "16.8",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "2.0",
    "sures_2022": "2.4",
    "sures_2023": "0.8",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 10.8",
    "ecart_sexes_lens_2019": "F 8.0",
    "ecart_sexes_lens_2022": "F 3.0",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 4.5",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "M 3.1",
    "ecart_sexes_math_2023": "F 0.4",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "32.8",
    "prog_2019": "33.2",
    "prog_2022": "27.8",
    "prog_2023": "39.0",
    "prog_2024": "34.6",
    "prog_trend": "—",
    "cote_2018": "4.7",
    "cote_2019": "4.3",
    "cote_2022": "5.4",
    "cote_2023": "5.0",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Polybel",
    "nom_court": "École secondaire Polybel",
    "adresse": "725, rue De Lévis",
    "municipalite": "Beloeil",
    "code_postal": "J3G 2M1",
    "lat": 45.57161,
    "lng": -73.21804
  },
  {
    "_id": "257",
    "school_code": "865117",
    "school_name_1": "De Mortagne",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "2868",
    "langue": "français",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "125",
    "index": "0.1",
    "en_retard_2024": "5.1",
    "ehdaa_2024": "32.8",
    "rang_2024": "149/470",
    "rang_2019_2024": "125/432",
    "lens_2018": "73.4",
    "lens_2019": "74.9",
    "lens_2022": "69.0",
    "lens_2023": "70.2",
    "lens_2024": "67.3",
    "lens_trend": "998855",
    "lsec_2018": "81.3",
    "lsec_2019": "84.4",
    "lsec_2022": "84.0",
    "lsec_2023": "86.1",
    "lsec_2024": "84.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.8",
    "scie_2019": "73.5",
    "scie_2022": "71.7",
    "scie_2023": "74.8",
    "scie_2024": "70.9",
    "scie_trend": "—",
    "math_2018": "74.6",
    "math_2019": "75.0",
    "math_2022": "76.8",
    "math_2023": "77.3",
    "math_2024": "80.1",
    "math_trend": "—",
    "echec_2018": "11.9",
    "echec_2019": "12.5",
    "echec_2022": "14.7",
    "echec_2023": "13.3",
    "echec_2024": "15.9",
    "echec_trend": "—",
    "sures_2018": "1.4",
    "sures_2019": "1.4",
    "sures_2022": "3.9",
    "sures_2023": "1.0",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.9",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "M 0.2",
    "ecart_sexes_math_2023": "F 2.1",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.6",
    "prog_2019": "18.0",
    "prog_2022": "13.8",
    "prog_2023": "12.5",
    "prog_2024": "15.7",
    "prog_trend": "112233",
    "cote_2018": "6.5",
    "cote_2019": "7.0",
    "cote_2022": "7.0",
    "cote_2023": "7.1",
    "cote_2024": "6.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire De Mortagne",
    "nom_court": "École De Mortagne",
    "adresse": "955, boulevard De Montarville",
    "municipalite": "Boucherville",
    "code_postal": "J4B 1Z6",
    "lat": 45.5932,
    "lng": -73.43733
  },
  {
    "_id": "258",
    "school_code": "865174",
    "school_name_1": "Ozias-Leduc",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "1639",
    "langue": "français",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "8.6",
    "ehdaa_2024": "32",
    "rang_2024": "260/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "74.2",
    "lens_2019": "74.6",
    "lens_2022": "70.7",
    "lens_2023": "72.7",
    "lens_2024": "71.6",
    "lens_trend": "—",
    "lsec_2018": "83.9",
    "lsec_2019": "82.9",
    "lsec_2022": "84.1",
    "lsec_2023": "83.6",
    "lsec_2024": "81.6",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "70.8",
    "scie_2022": "72.3",
    "scie_2023": "73.5",
    "scie_2024": "70.9",
    "scie_trend": "—",
    "math_2018": "69.7",
    "math_2019": "66.2",
    "math_2022": "68.2",
    "math_2023": "67.2",
    "math_2024": "68.7",
    "math_trend": "—",
    "echec_2018": "13.0",
    "echec_2019": "18.2",
    "echec_2022": "17.3",
    "echec_2023": "19.0",
    "echec_2024": "19.9",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "1.9",
    "sures_2022": "2.2",
    "sures_2023": "2.2",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.0",
    "ecart_sexes_lens_2019": "F 4.8",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.1",
    "ecart_sexes_math_2019": "F 4.1",
    "ecart_sexes_math_2022": "M 4.3",
    "ecart_sexes_math_2023": "F 5.5",
    "ecart_sexes_math_2024": "F 5.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "23.7",
    "prog_2019": "16.0",
    "prog_2022": "12.8",
    "prog_2023": "16.0",
    "prog_2024": "18.5",
    "prog_trend": "—",
    "cote_2018": "6.4",
    "cote_2019": "5.9",
    "cote_2022": "6.6",
    "cote_2023": "6.0",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Ozias-Leduc",
    "nom_court": "École secondaire Ozias-Leduc",
    "adresse": "525, rue Jolliet",
    "municipalite": "Mont-Saint-Hilaire",
    "code_postal": "J3H 3N2",
    "lat": 45.56959,
    "lng": -73.20339
  },
  {
    "_id": "259",
    "school_code": "865225",
    "school_name_1": "du Mont-Bruno",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "2045",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "10.9",
    "ehdaa_2024": "48",
    "rang_2024": "376/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "65.4",
    "lens_2019": "70.0",
    "lens_2022": "65.0",
    "lens_2023": "64.3",
    "lens_2024": "63.9",
    "lens_trend": "—",
    "lsec_2018": "78.1",
    "lsec_2019": "76.9",
    "lsec_2022": "77.2",
    "lsec_2023": "80.0",
    "lsec_2024": "81.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.9",
    "scie_2019": "63.4",
    "scie_2022": "64.0",
    "scie_2023": "67.0",
    "scie_2024": "64.8",
    "scie_trend": "—",
    "math_2018": "69.9",
    "math_2019": "74.2",
    "math_2022": "70.7",
    "math_2023": "68.1",
    "math_2024": "71.6",
    "math_trend": "—",
    "echec_2018": "22.9",
    "echec_2019": "19.5",
    "echec_2022": "24.1",
    "echec_2023": "24.1",
    "echec_2024": "25.1",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "0.9",
    "sures_2022": "1.2",
    "sures_2023": "1.3",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 2.3",
    "ecart_sexes_lens_2022": "F 4.3",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 4.0",
    "ecart_sexes_math_2022": "F 3.7",
    "ecart_sexes_math_2023": "F 1.3",
    "ecart_sexes_math_2024": "F 6.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.5",
    "prog_2019": "33.1",
    "prog_2022": "29.9",
    "prog_2023": "35.7",
    "prog_2024": "34.5",
    "prog_trend": "—",
    "cote_2018": "4.2",
    "cote_2019": "5.0",
    "cote_2022": "5.2",
    "cote_2023": "4.6",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Mont-Bruno",
    "nom_court": "École secondaire du Mont-Bruno",
    "adresse": "221, boulevard Clairevue Est",
    "municipalite": "Saint-Bruno-de-Montarville",
    "code_postal": "J3V 5J3",
    "lat": 45.53403,
    "lng": -73.34051
  },
  {
    "_id": "260",
    "school_code": "865260",
    "school_name_1": "École d'éducation internationale",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "1264",
    "langue": "français",
    "secteur": "public",
    "rang": "35",
    "rang_5_ans": "14",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "5.4",
    "rang_2024": "35/470",
    "rang_2019_2024": "14/432",
    "lens_2018": "83.1",
    "lens_2019": "83.5",
    "lens_2022": "81.1",
    "lens_2023": "80.5",
    "lens_2024": "74.6",
    "lens_trend": "998855",
    "lsec_2018": "90.3",
    "lsec_2019": "90.0",
    "lsec_2022": "84.3",
    "lsec_2023": "82.9",
    "lsec_2024": "83.7",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.3",
    "scie_2019": "88.2",
    "scie_2022": "83.7",
    "scie_2023": "87.1",
    "scie_2024": "84.4",
    "scie_trend": "—",
    "math_2018": "86.0",
    "math_2019": "90.0",
    "math_2022": "89.7",
    "math_2023": "89.4",
    "math_2024": "87.0",
    "math_trend": "—",
    "echec_2018": "1.7",
    "echec_2019": "0.4",
    "echec_2022": "2.0",
    "echec_2023": "1.9",
    "echec_2024": "3.1",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.0",
    "sures_2022": "1.6",
    "sures_2023": "1.4",
    "sures_2024": "4.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 2.6",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "F 0.9",
    "ecart_sexes_math_2022": "F 0.3",
    "ecart_sexes_math_2023": "M 0.2",
    "ecart_sexes_math_2024": "F 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.4",
    "prog_2019": "1.6",
    "prog_2022": "0.4",
    "prog_2023": "1.2",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "10.0",
    "cote_2019": "10.0",
    "cote_2022": "9.6",
    "cote_2023": "9.2",
    "cote_2024": "8.6",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École d'éducation internationale",
    "nom_court": "École d'éducation internationale",
    "adresse": "720, rue Morin",
    "municipalite": "McMasterville",
    "code_postal": "J3G 1H1",
    "lat": 45.54881,
    "lng": -73.22871
  },
  {
    "_id": "261",
    "school_code": "865276",
    "school_name_1": "du Grand-Coteau",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "759",
    "langue": "français",
    "secteur": "public",
    "rang": "238",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "8.5",
    "ehdaa_2024": "41.5",
    "rang_2024": "238/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "68.6",
    "lens_2019": "67.7",
    "lens_2022": "66.8",
    "lens_2023": "71.1",
    "lens_2024": "61.8",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "78.6",
    "lsec_2022": "80.7",
    "lsec_2023": "79.0",
    "lsec_2024": "76.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.3",
    "scie_2019": "73.8",
    "scie_2022": "76.3",
    "scie_2023": "69.9",
    "scie_2024": "70.6",
    "scie_trend": "—",
    "math_2018": "63.6",
    "math_2019": "64.5",
    "math_2022": "66.1",
    "math_2023": "61.6",
    "math_2024": "77.3",
    "math_trend": "—",
    "echec_2018": "17.8",
    "echec_2019": "19.9",
    "echec_2022": "22.2",
    "echec_2023": "21.9",
    "echec_2024": "21.3",
    "echec_trend": "—",
    "sures_2018": "3.0",
    "sures_2019": "3.3",
    "sures_2022": "4.1",
    "sures_2023": "3.1",
    "sures_2024": "2.0",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 6.2",
    "ecart_sexes_lens_2019": "F 6.2",
    "ecart_sexes_lens_2022": "F 2.3",
    "ecart_sexes_lens_2023": "F 1.3",
    "ecart_sexes_lens_2024": "F 3.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.8",
    "ecart_sexes_math_2019": "F 5.6",
    "ecart_sexes_math_2022": "F 9.0",
    "ecart_sexes_math_2023": "F 0.1",
    "ecart_sexes_math_2024": "F 5.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.0",
    "prog_2019": "7.5",
    "prog_2022": "3.3",
    "prog_2023": "5.5",
    "prog_2024": "8.7",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "5.1",
    "cote_2022": "6.3",
    "cote_2023": "5.5",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Grand-Coteau",
    "nom_court": "École secondaire du Grand-Coteau",
    "adresse": "2020, rue Borduas",
    "municipalite": "Sainte-Julie",
    "code_postal": "J3E 2G2",
    "lat": 45.58098,
    "lng": -73.34598
  },
  {
    "_id": "262",
    "school_code": "865285",
    "school_name_1": "le Carrefour",
    "admin_body_number": "865000",
    "admin_body_name": "Centre de services scolaire des Patriotes",
    "area_name": "Montérégie ",
    "étudiants": "1268",
    "langue": "français",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "9.7",
    "ehdaa_2024": "41.2",
    "rang_2024": "376/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "65.8",
    "lens_2019": "64.5",
    "lens_2022": "66.0",
    "lens_2023": "66.8",
    "lens_2024": "66.1",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "77.0",
    "lsec_2022": "83.2",
    "lsec_2023": "78.2",
    "lsec_2024": "77.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.0",
    "scie_2019": "67.3",
    "scie_2022": "64.1",
    "scie_2023": "73.3",
    "scie_2024": "70.2",
    "scie_trend": "—",
    "math_2018": "67.0",
    "math_2019": "75.3",
    "math_2022": "67.2",
    "math_2023": "65.5",
    "math_2024": "68.2",
    "math_trend": "—",
    "echec_2018": "22.3",
    "echec_2019": "21.6",
    "echec_2022": "26.2",
    "echec_2023": "20.3",
    "echec_2024": "22.1",
    "echec_trend": "—",
    "sures_2018": "3.9",
    "sures_2019": "3.8",
    "sures_2022": "7.3",
    "sures_2023": "3.4",
    "sures_2024": "4.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 4.6",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 2.1",
    "ecart_sexes_lens_2024": "F 6.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "F 5.3",
    "ecart_sexes_math_2022": "F 3.8",
    "ecart_sexes_math_2023": "F 4.8",
    "ecart_sexes_math_2024": "M 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.5",
    "prog_2019": "23.9",
    "prog_2022": "15.7",
    "prog_2023": "27.9",
    "prog_2024": "25.4",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.5",
    "cote_2022": "5.1",
    "cote_2023": "4.9",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire le Carrefour",
    "nom_court": "École secondaire le Carrefour",
    "adresse": "123, chemin du Petit-Bois",
    "municipalite": "Varennes",
    "code_postal": "J3X 1P7",
    "lat": 45.67028,
    "lng": -73.42987
  },
  {
    "_id": "263",
    "school_code": "866050",
    "school_name_1": "l'Envolée",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "623",
    "langue": "français",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0.9",
    "ehdaa_2024": "14",
    "rang_2024": "112/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "76.0",
    "lens_2023": "75.0",
    "lens_2024": "71.5",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "78.3",
    "lsec_2023": "73.2",
    "lsec_2024": "70.2",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "81.3",
    "scie_2023": "82.1",
    "scie_2024": "78.7",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "83.4",
    "math_2023": "82.6",
    "math_2024": "82.2",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "3.5",
    "echec_2023": "6.0",
    "echec_2024": "9.2",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "2.6",
    "sures_2023": "2.2",
    "sures_2024": "2.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 3.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 3.6",
    "ecart_sexes_math_2023": "F 4.7",
    "ecart_sexes_math_2024": "M 4.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "1.1",
    "prog_2023": "1.1",
    "prog_2024": "3.4",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "8.3",
    "cote_2023": "7.7",
    "cote_2024": "7.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École l'Envolée",
    "nom_court": "École l'Envolée",
    "adresse": "549, rue Fournier",
    "municipalite": "Granby",
    "code_postal": "J2J 2K5",
    "lat": 45.40371,
    "lng": -72.75066
  },
  {
    "_id": "264",
    "school_code": "866051",
    "school_name_1": "de la Haute-Ville",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "1174",
    "langue": "français",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "14.8",
    "ehdaa_2024": "39.9",
    "rang_2024": "348/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "72.3",
    "lens_2019": "68.2",
    "lens_2022": "60.6",
    "lens_2023": "64.0",
    "lens_2024": "64.9",
    "lens_trend": "—",
    "lsec_2018": "75.2",
    "lsec_2019": "73.8",
    "lsec_2022": "75.0",
    "lsec_2023": "76.0",
    "lsec_2024": "73.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.4",
    "scie_2019": "69.9",
    "scie_2022": "71.4",
    "scie_2023": "74.1",
    "scie_2024": "70.2",
    "scie_trend": "—",
    "math_2018": "75.6",
    "math_2019": "78.0",
    "math_2022": "73.9",
    "math_2023": "71.6",
    "math_2024": "78.8",
    "math_trend": "—",
    "echec_2018": "11.8",
    "echec_2019": "16.2",
    "echec_2022": "20.8",
    "echec_2023": "17.2",
    "echec_2024": "19.1",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "1.4",
    "sures_2022": "3.8",
    "sures_2023": "0.9",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 5.3",
    "ecart_sexes_lens_2023": "F 0.6",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.0",
    "ecart_sexes_math_2019": "F 9.2",
    "ecart_sexes_math_2022": "F 7.2",
    "ecart_sexes_math_2023": "M 1.4",
    "ecart_sexes_math_2024": "M 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.0",
    "prog_2019": "30.8",
    "prog_2022": "39.8",
    "prog_2023": "48.8",
    "prog_2024": "47.8",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.1",
    "cote_2022": "4.7",
    "cote_2023": "5.1",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de la Haute-Ville",
    "nom_court": "École de la Haute-Ville",
    "adresse": "150, rue Lansdowne",
    "municipalite": "Granby",
    "code_postal": "J2G 4P4",
    "lat": 45.40555,
    "lng": -72.71619
  },
  {
    "_id": "265",
    "school_code": "866052",
    "school_name_1": "Joseph-Hermas-Leclerc",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "1578",
    "langue": "français",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "377",
    "index": "0.1",
    "en_retard_2024": "26.6",
    "ehdaa_2024": "39.6",
    "rang_2024": "390/470",
    "rang_2019_2024": "377/432",
    "lens_2018": "68.0",
    "lens_2019": "67.9",
    "lens_2022": "59.7",
    "lens_2023": "61.6",
    "lens_2024": "61.0",
    "lens_trend": "998855",
    "lsec_2018": "72.7",
    "lsec_2019": "77.7",
    "lsec_2022": "76.9",
    "lsec_2023": "79.4",
    "lsec_2024": "79.5",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.7",
    "scie_2019": "68.9",
    "scie_2022": "62.9",
    "scie_2023": "73.2",
    "scie_2024": "66.5",
    "scie_trend": "—",
    "math_2018": "70.7",
    "math_2019": "73.5",
    "math_2022": "61.7",
    "math_2023": "77.5",
    "math_2024": "73.7",
    "math_trend": "—",
    "echec_2018": "22.5",
    "echec_2019": "20.3",
    "echec_2022": "33.5",
    "echec_2023": "16.5",
    "echec_2024": "25.9",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "1.5",
    "sures_2022": "7.4",
    "sures_2023": "0.9",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.9",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 4.6",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 3.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.2",
    "ecart_sexes_math_2019": "F 4.9",
    "ecart_sexes_math_2022": "M 3.0",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "37.1",
    "prog_2019": "39.6",
    "prog_2022": "42.5",
    "prog_2023": "49.8",
    "prog_2024": "50.3",
    "prog_trend": "998855",
    "cote_2018": "4.1",
    "cote_2019": "4.9",
    "cote_2022": "3.1",
    "cote_2023": "5.3",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Joseph-Hermas-Leclerc",
    "nom_court": "École Joseph-Hermas-Leclerc",
    "adresse": "1111, rue Simonds Sud",
    "municipalite": "Granby",
    "code_postal": "J2G 9H7",
    "lat": 45.37679,
    "lng": -72.74413
  },
  {
    "_id": "266",
    "school_code": "866053",
    "school_name_1": "Wilfrid-Léger",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "586",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "345",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "42.5",
    "rang_2024": "360/470",
    "rang_2019_2024": "345/432",
    "lens_2018": "73.5",
    "lens_2019": "71.3",
    "lens_2022": "63.5",
    "lens_2023": "67.3",
    "lens_2024": "66.2",
    "lens_trend": "—",
    "lsec_2018": "80.4",
    "lsec_2019": "81.5",
    "lsec_2022": "75.9",
    "lsec_2023": "77.7",
    "lsec_2024": "76.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.6",
    "scie_2019": "68.8",
    "scie_2022": "67.0",
    "scie_2023": "71.5",
    "scie_2024": "68.6",
    "scie_trend": "112233",
    "math_2018": "68.3",
    "math_2019": "64.3",
    "math_2022": "68.3",
    "math_2023": "69.6",
    "math_2024": "75.4",
    "math_trend": "—",
    "echec_2018": "15.6",
    "echec_2019": "20.7",
    "echec_2022": "28.3",
    "echec_2023": "22.6",
    "echec_2024": "25.9",
    "echec_trend": "998855",
    "sures_2018": "2.6",
    "sures_2019": "3.1",
    "sures_2022": "6.0",
    "sures_2023": "1.7",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.8",
    "ecart_sexes_lens_2019": "F 4.9",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "F 12.6",
    "ecart_sexes_lens_2024": "F 4.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 9.1",
    "ecart_sexes_math_2019": "M 0.5",
    "ecart_sexes_math_2022": "M 13.7",
    "ecart_sexes_math_2023": "M 3.4",
    "ecart_sexes_math_2024": "M 7.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.5",
    "prog_2019": "23.8",
    "prog_2022": "19.5",
    "prog_2023": "27.2",
    "prog_2024": "24.7",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.1",
    "cote_2022": "4.4",
    "cote_2023": "4.7",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Wilfrid-Léger",
    "nom_court": "École Wilfrid-Léger",
    "adresse": "185, rue Lewis Ouest",
    "municipalite": "Waterloo",
    "code_postal": "J0E 2N0",
    "lat": 45.34208,
    "lng": -72.52817
  },
  {
    "_id": "267",
    "school_code": "866055",
    "school_name_1": "Jean-Jacques-Bertrand",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "921",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "10.4",
    "ehdaa_2024": "33.7",
    "rang_2024": "207/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "71.8",
    "lens_2019": "74.4",
    "lens_2022": "71.5",
    "lens_2023": "73.4",
    "lens_2024": "72.4",
    "lens_trend": "112233",
    "lsec_2018": "77.3",
    "lsec_2019": "79.7",
    "lsec_2022": "80.1",
    "lsec_2023": "76.9",
    "lsec_2024": "79.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.9",
    "scie_2019": "76.5",
    "scie_2022": "66.0",
    "scie_2023": "73.6",
    "scie_2024": "67.7",
    "scie_trend": "—",
    "math_2018": "70.6",
    "math_2019": "76.0",
    "math_2022": "71.3",
    "math_2023": "78.8",
    "math_2024": "76.7",
    "math_trend": "—",
    "echec_2018": "16.1",
    "echec_2019": "11.0",
    "echec_2022": "21.2",
    "echec_2023": "13.9",
    "echec_2024": "15.3",
    "echec_trend": "—",
    "sures_2018": "2.7",
    "sures_2019": "0.1",
    "sures_2022": "3.7",
    "sures_2023": "0.8",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.4",
    "ecart_sexes_lens_2019": "F 7.4",
    "ecart_sexes_lens_2022": "F 3.8",
    "ecart_sexes_lens_2023": "F 2.9",
    "ecart_sexes_lens_2024": "F 7.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.8",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "F 6.2",
    "ecart_sexes_math_2023": "F 5.3",
    "ecart_sexes_math_2024": "F 1.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "17.0",
    "prog_2019": "17.6",
    "prog_2022": "19.0",
    "prog_2023": "18.0",
    "prog_2024": "25.8",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "6.8",
    "cote_2022": "5.7",
    "cote_2023": "6.5",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Jean-Jacques-Bertrand",
    "nom_court": "École Jean-Jacques-Bertrand",
    "adresse": "255, rue Saint-André Sud",
    "municipalite": "Farnham",
    "code_postal": "J2N 2B8",
    "lat": 45.27497,
    "lng": -72.97733
  },
  {
    "_id": "268",
    "school_code": "866057",
    "school_name_1": "École Massey-Vanier",
    "admin_body_number": "866000",
    "admin_body_name": "Centre de services scolaire du Val-des-Cerfs",
    "area_name": "Estrie ",
    "étudiants": "1630",
    "langue": "français",
    "secteur": "public",
    "rang": "132",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "11.8",
    "ehdaa_2024": "34",
    "rang_2024": "132/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "71.0",
    "lens_2019": "71.7",
    "lens_2022": "66.8",
    "lens_2023": "70.5",
    "lens_2024": "68.4",
    "lens_trend": "—",
    "lsec_2018": "81.6",
    "lsec_2019": "78.9",
    "lsec_2022": "78.5",
    "lsec_2023": "83.2",
    "lsec_2024": "81.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.8",
    "scie_2019": "71.1",
    "scie_2022": "70.1",
    "scie_2023": "74.2",
    "scie_2024": "72.6",
    "scie_trend": "112233",
    "math_2018": "68.8",
    "math_2019": "74.7",
    "math_2022": "79.1",
    "math_2023": "73.2",
    "math_2024": "79.5",
    "math_trend": "—",
    "echec_2018": "14.6",
    "echec_2019": "13.8",
    "echec_2022": "15.6",
    "echec_2023": "11.8",
    "echec_2024": "10.7",
    "echec_trend": "112233",
    "sures_2018": "0.9",
    "sures_2019": "0.0",
    "sures_2022": "1.3",
    "sures_2023": "0.0",
    "sures_2024": "0.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 1.7",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 6.2",
    "ecart_sexes_lens_2023": "F 1.3",
    "ecart_sexes_lens_2024": "F 4.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.7",
    "ecart_sexes_math_2019": "F 7.8",
    "ecart_sexes_math_2022": "F 1.9",
    "ecart_sexes_math_2023": "E",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "26.9",
    "prog_2019": "27.1",
    "prog_2022": "29.2",
    "prog_2023": "34.7",
    "prog_2024": "26.8",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "6.0",
    "cote_2022": "6.1",
    "cote_2023": "6.5",
    "cote_2024": "6.8",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Massey-Vanier",
    "nom_court": "École Massey-Vanier",
    "adresse": "222, rue Mercier",
    "municipalite": "Cowansville",
    "code_postal": "J2K 3R9",
    "lat": 45.20706,
    "lng": -72.77245
  },
  {
    "_id": "269",
    "school_code": "867007",
    "school_name_1": "de la Magdeleine",
    "admin_body_number": "867000",
    "admin_body_name": "Centre de services scolaire des Grandes-Seigneuries",
    "area_name": "Montérégie ",
    "étudiants": "2293",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "10.4",
    "ehdaa_2024": "29.6",
    "rang_2024": "156/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "70.8",
    "lens_2019": "71.7",
    "lens_2022": "67.8",
    "lens_2023": "67.9",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "79.7",
    "lsec_2019": "78.2",
    "lsec_2022": "79.8",
    "lsec_2023": "79.2",
    "lsec_2024": "78.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "72.5",
    "scie_2022": "71.7",
    "scie_2023": "75.3",
    "scie_2024": "72.7",
    "scie_trend": "—",
    "math_2018": "77.9",
    "math_2019": "78.5",
    "math_2022": "81.4",
    "math_2023": "78.1",
    "math_2024": "77.0",
    "math_trend": "—",
    "echec_2018": "11.7",
    "echec_2019": "13.5",
    "echec_2022": "14.7",
    "echec_2023": "14.5",
    "echec_2024": "15.7",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.6",
    "sures_2022": "2.3",
    "sures_2023": "0.8",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.0",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "F 4.4",
    "ecart_sexes_math_2022": "F 4.0",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "M 1.4",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "21.5",
    "prog_2019": "24.6",
    "prog_2022": "17.4",
    "prog_2023": "21.2",
    "prog_2024": "21.4",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "6.5",
    "cote_2022": "6.8",
    "cote_2023": "6.4",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de la Magdeleine",
    "nom_court": "École de la Magdeleine",
    "adresse": "1100, boulevard Taschereau",
    "municipalite": "La Prairie",
    "code_postal": "J5R 1W8",
    "lat": 45.40411,
    "lng": -73.50209
  },
  {
    "_id": "270",
    "school_code": "867048",
    "school_name_1": "Louis-Philippe-Paré",
    "admin_body_number": "867000",
    "admin_body_name": "Centre de services scolaire des Grandes-Seigneuries",
    "area_name": "Montérégie ",
    "étudiants": "2262",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "13.4",
    "ehdaa_2024": "28.9",
    "rang_2024": "182/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "66.3",
    "lens_2019": "71.2",
    "lens_2022": "67.3",
    "lens_2023": "70.9",
    "lens_2024": "66.6",
    "lens_trend": "—",
    "lsec_2018": "75.7",
    "lsec_2019": "77.8",
    "lsec_2022": "79.8",
    "lsec_2023": "79.0",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.8",
    "scie_2019": "73.9",
    "scie_2022": "72.0",
    "scie_2023": "75.2",
    "scie_2024": "72.5",
    "scie_trend": "—",
    "math_2018": "79.8",
    "math_2019": "76.8",
    "math_2022": "79.9",
    "math_2023": "74.0",
    "math_2024": "78.3",
    "math_trend": "998855",
    "echec_2018": "14.6",
    "echec_2019": "10.9",
    "echec_2022": "14.8",
    "echec_2023": "15.0",
    "echec_2024": "16.6",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "0.3",
    "sures_2022": "1.6",
    "sures_2023": "0.7",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.4",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "F 4.5",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 2.0",
    "ecart_sexes_math_2019": "F 4.9",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "F 5.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.3",
    "prog_2019": "30.5",
    "prog_2022": "18.8",
    "prog_2023": "25.4",
    "prog_2024": "25.0",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "6.5",
    "cote_2022": "6.8",
    "cote_2023": "6.4",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Louis-Philippe-Paré",
    "nom_court": "École Louis-Philippe-Paré",
    "adresse": "235, boulevard Brisebois",
    "municipalite": "Châteauguay",
    "code_postal": "J6K 3X4",
    "lat": 45.34452,
    "lng": -73.76787
  },
  {
    "_id": "271",
    "school_code": "867065",
    "school_name_1": "Pierre-Bédard",
    "admin_body_number": "867000",
    "admin_body_name": "Centre de services scolaire des Grandes-Seigneuries",
    "area_name": "Montérégie ",
    "étudiants": "737",
    "langue": "français",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "19",
    "ehdaa_2024": "23.7",
    "rang_2024": "335/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "66.0",
    "lens_2019": "62.6",
    "lens_2022": "63.3",
    "lens_2023": "65.5",
    "lens_2024": "65.8",
    "lens_trend": "—",
    "lsec_2018": "81.0",
    "lsec_2019": "80.5",
    "lsec_2022": "79.2",
    "lsec_2023": "76.2",
    "lsec_2024": "77.6",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.0",
    "scie_2019": "72.2",
    "scie_2022": "60.6",
    "scie_2023": "70.4",
    "scie_2024": "68.6",
    "scie_trend": "—",
    "math_2018": "71.7",
    "math_2019": "76.1",
    "math_2022": "74.8",
    "math_2023": "76.4",
    "math_2024": "82.4",
    "math_trend": "112233",
    "echec_2018": "19.2",
    "echec_2019": "17.8",
    "echec_2022": "27.7",
    "echec_2023": "18.0",
    "echec_2024": "18.1",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "3.5",
    "sures_2022": "8.0",
    "sures_2023": "3.6",
    "sures_2024": "4.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.9",
    "ecart_sexes_lens_2019": "F 1.6",
    "ecart_sexes_lens_2022": "F 6.8",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.9",
    "ecart_sexes_math_2019": "F 5.5",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "F 7.9",
    "ecart_sexes_math_2024": "F 13.9",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "29.2",
    "prog_2019": "27.7",
    "prog_2022": "14.8",
    "prog_2023": "28.0",
    "prog_2024": "39.0",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.2",
    "cote_2022": "4.7",
    "cote_2023": "5.0",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École  Pierre-Bédard",
    "nom_court": "École  Pierre-Bédard",
    "adresse": "24, rue Saint-Sauveur",
    "municipalite": "Saint-Rémi",
    "code_postal": "J0L 2L0",
    "lat": 45.25588,
    "lng": -73.61552
  },
  {
    "_id": "272",
    "school_code": "867076",
    "school_name_1": "Louis-Cyr",
    "admin_body_number": "867000",
    "admin_body_name": "Centre de services scolaire des Grandes-Seigneuries",
    "area_name": "Montérégie ",
    "étudiants": "643",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "11.3",
    "ehdaa_2024": "37.5",
    "rang_2024": "169/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "74.2",
    "lens_2019": "74.6",
    "lens_2022": "68.6",
    "lens_2023": "73.8",
    "lens_2024": "66.7",
    "lens_trend": "—",
    "lsec_2018": "76.1",
    "lsec_2019": "78.9",
    "lsec_2022": "76.4",
    "lsec_2023": "77.8",
    "lsec_2024": "80.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.4",
    "scie_2019": "73.3",
    "scie_2022": "72.3",
    "scie_2023": "72.3",
    "scie_2024": "66.3",
    "scie_trend": "—",
    "math_2018": "80.9",
    "math_2019": "85.5",
    "math_2022": "87.1",
    "math_2023": "77.1",
    "math_2024": "85.1",
    "math_trend": "—",
    "echec_2018": "11.2",
    "echec_2019": "8.6",
    "echec_2022": "14.2",
    "echec_2023": "10.5",
    "echec_2024": "17.1",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "0.5",
    "sures_2022": "1.2",
    "sures_2023": "1.3",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.6",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 0.5",
    "ecart_sexes_lens_2023": "F 6.2",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.4",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "M 3.5",
    "ecart_sexes_math_2023": "M 0.5",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "19.1",
    "prog_2019": "14.6",
    "prog_2022": "28.9",
    "prog_2023": "23.1",
    "prog_2024": "21.7",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "7.5",
    "cote_2022": "6.7",
    "cote_2023": "6.6",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Louis-Cyr",
    "nom_court": "École Louis-Cyr",
    "adresse": "319, rue Saint-Louis",
    "municipalite": "Napierville",
    "code_postal": "J0J 1L0",
    "lat": 45.19148,
    "lng": -73.40444
  },
  {
    "_id": "273",
    "school_code": "868035",
    "school_name_1": "Patriotes-de-Beauharnois",
    "admin_body_number": "868000",
    "admin_body_name": "Centre de services scolaire de la Vallée-des-Tisserands",
    "area_name": "Montérégie ",
    "étudiants": "1036",
    "langue": "français",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "16.4",
    "ehdaa_2024": "41.4",
    "rang_2024": "217/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "66.0",
    "lens_2019": "66.6",
    "lens_2022": "66.1",
    "lens_2023": "66.9",
    "lens_2024": "67.0",
    "lens_trend": "112233",
    "lsec_2018": "81.2",
    "lsec_2019": "82.5",
    "lsec_2022": "82.5",
    "lsec_2023": "83.5",
    "lsec_2024": "83.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.9",
    "scie_2019": "66.9",
    "scie_2022": "62.7",
    "scie_2023": "71.2",
    "scie_2024": "68.6",
    "scie_trend": "—",
    "math_2018": "72.3",
    "math_2019": "79.1",
    "math_2022": "72.2",
    "math_2023": "74.2",
    "math_2024": "78.4",
    "math_trend": "—",
    "echec_2018": "20.3",
    "echec_2019": "20.0",
    "echec_2022": "24.4",
    "echec_2023": "15.4",
    "echec_2024": "16.2",
    "echec_trend": "112233",
    "sures_2018": "1.5",
    "sures_2019": "1.3",
    "sures_2022": "1.3",
    "sures_2023": "0.9",
    "sures_2024": "0.6",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 11.1",
    "ecart_sexes_lens_2019": "F 7.2",
    "ecart_sexes_lens_2022": "F 7.2",
    "ecart_sexes_lens_2023": "F 8.9",
    "ecart_sexes_lens_2024": "F 7.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.8",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 2.3",
    "ecart_sexes_math_2023": "M 9.1",
    "ecart_sexes_math_2024": "F 1.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.4",
    "prog_2019": "46.6",
    "prog_2022": "42.0",
    "prog_2023": "43.2",
    "prog_2024": "34.5",
    "prog_trend": "—",
    "cote_2018": "4.9",
    "cote_2019": "5.3",
    "cote_2022": "5.1",
    "cote_2023": "5.3",
    "cote_2024": "6.0",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire des Patriotes-de-Beauharnois",
    "nom_court": "École sec. Patriotes Beauharnois",
    "adresse": "250, rue Gagnon",
    "municipalite": "Beauharnois",
    "code_postal": "J6N 2W8",
    "lat": 45.30133,
    "lng": -73.86845
  },
  {
    "_id": "274",
    "school_code": "868039",
    "school_name_1": "de la Baie-Saint-François",
    "admin_body_number": "868000",
    "admin_body_name": "Centre de services scolaire de la Vallée-des-Tisserands",
    "area_name": "Montérégie ",
    "étudiants": "1568",
    "langue": "français",
    "secteur": "public",
    "rang": "399",
    "rang_5_ans": "391",
    "index": "0.1",
    "en_retard_2024": "17.9",
    "ehdaa_2024": "43.8",
    "rang_2024": "399/470",
    "rang_2019_2024": "391/432",
    "lens_2018": "64.9",
    "lens_2019": "64.7",
    "lens_2022": "61.8",
    "lens_2023": "63.6",
    "lens_2024": "64.3",
    "lens_trend": "112233",
    "lsec_2018": "74.4",
    "lsec_2019": "78.3",
    "lsec_2022": "72.9",
    "lsec_2023": "76.4",
    "lsec_2024": "79.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.8",
    "scie_2019": "72.1",
    "scie_2022": "63.6",
    "scie_2023": "70.7",
    "scie_2024": "62.5",
    "scie_trend": "—",
    "math_2018": "66.7",
    "math_2019": "76.3",
    "math_2022": "62.6",
    "math_2023": "70.9",
    "math_2024": "71.9",
    "math_trend": "—",
    "echec_2018": "25.2",
    "echec_2019": "14.1",
    "echec_2022": "33.0",
    "echec_2023": "24.4",
    "echec_2024": "26.9",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "2.3",
    "sures_2022": "5.5",
    "sures_2023": "2.8",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.3",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 4.3",
    "ecart_sexes_lens_2023": "F 3.7",
    "ecart_sexes_lens_2024": "F 0.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 2.2",
    "ecart_sexes_math_2022": "M 5.6",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 6.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "46.4",
    "prog_2019": "42.4",
    "prog_2022": "51.5",
    "prog_2023": "52.4",
    "prog_2024": "50.4",
    "prog_trend": "—",
    "cote_2018": "3.9",
    "cote_2019": "5.4",
    "cote_2022": "3.1",
    "cote_2023": "4.3",
    "cote_2024": "4.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École de la Baie-Saint-François",
    "nom_court": "École de la Baie-Saint-François",
    "adresse": "70, rue Louis VI Major",
    "municipalite": "Salaberry-de-Valleyfield",
    "code_postal": "J6T 3G2",
    "lat": 45.23997,
    "lng": -74.11294
  },
  {
    "_id": "275",
    "school_code": "868040",
    "school_name_1": "Arthur Pigeon",
    "admin_body_number": "868000",
    "admin_body_name": "Centre de services scolaire de la Vallée-des-Tisserands",
    "area_name": "Montérégie ",
    "étudiants": "671",
    "langue": "français",
    "secteur": "public",
    "rang": "439",
    "rang_5_ans": "414",
    "index": "0.1",
    "en_retard_2024": "18.8",
    "ehdaa_2024": "43.7",
    "rang_2024": "439/470",
    "rang_2019_2024": "414/432",
    "lens_2018": "59.4",
    "lens_2019": "61.9",
    "lens_2022": "60.6",
    "lens_2023": "62.0",
    "lens_2024": "60.5",
    "lens_trend": "—",
    "lsec_2018": "79.0",
    "lsec_2019": "79.8",
    "lsec_2022": "78.0",
    "lsec_2023": "80.8",
    "lsec_2024": "81.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.5",
    "scie_2019": "71.7",
    "scie_2022": "61.4",
    "scie_2023": "67.7",
    "scie_2024": "65.6",
    "scie_trend": "—",
    "math_2018": "64.4",
    "math_2019": "65.1",
    "math_2022": "59.0",
    "math_2023": "62.1",
    "math_2024": "66.4",
    "math_trend": "—",
    "echec_2018": "25.8",
    "echec_2019": "23.7",
    "echec_2022": "37.1",
    "echec_2023": "30.5",
    "echec_2024": "28.6",
    "echec_trend": "—",
    "sures_2018": "4.0",
    "sures_2019": "2.8",
    "sures_2022": "5.2",
    "sures_2023": "3.6",
    "sures_2024": "3.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.3",
    "ecart_sexes_lens_2019": "E",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 0.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 10.6",
    "ecart_sexes_math_2019": "M 2.2",
    "ecart_sexes_math_2022": "M 4.0",
    "ecart_sexes_math_2023": "F 4.4",
    "ecart_sexes_math_2024": "M 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.3",
    "prog_2019": "39.1",
    "prog_2022": "31.1",
    "prog_2023": "49.2",
    "prog_2024": "53.7",
    "prog_trend": "998855",
    "cote_2018": "3.6",
    "cote_2019": "4.2",
    "cote_2022": "3.4",
    "cote_2023": "3.2",
    "cote_2024": "3.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Arthur-Pigeon",
    "nom_court": "École Arthur-Pigeon",
    "adresse": "1, rue Arthur-Pigeon",
    "municipalite": "Huntingdon",
    "code_postal": "J0S 1H0",
    "lat": 45.08796,
    "lng": -74.1689
  },
  {
    "_id": "276",
    "school_code": "869003",
    "school_name_1": "Soulanges",
    "admin_body_number": "869000",
    "admin_body_name": "Centre de services scolaire des Trois-Lacs",
    "area_name": "Montérégie ",
    "étudiants": "867",
    "langue": "français",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "12.6",
    "ehdaa_2024": "30.1",
    "rang_2024": "252/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "65.7",
    "lens_2019": "66.7",
    "lens_2022": "63.5",
    "lens_2023": "68.8",
    "lens_2024": "62.4",
    "lens_trend": "—",
    "lsec_2018": "76.8",
    "lsec_2019": "77.8",
    "lsec_2022": "80.6",
    "lsec_2023": "81.2",
    "lsec_2024": "78.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.8",
    "scie_2019": "74.5",
    "scie_2022": "69.5",
    "scie_2023": "72.1",
    "scie_2024": "68.6",
    "scie_trend": "998855",
    "math_2018": "78.4",
    "math_2019": "77.7",
    "math_2022": "77.8",
    "math_2023": "71.1",
    "math_2024": "78.5",
    "math_trend": "998855",
    "echec_2018": "13.4",
    "echec_2019": "14.0",
    "echec_2022": "20.4",
    "echec_2023": "17.8",
    "echec_2024": "20.1",
    "echec_trend": "998855",
    "sures_2018": "1.5",
    "sures_2019": "1.2",
    "sures_2022": "3.1",
    "sures_2023": "1.7",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 2.2",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "M 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "F 3.8",
    "ecart_sexes_math_2022": "F 6.0",
    "ecart_sexes_math_2023": "M 1.0",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "22.5",
    "prog_2019": "19.4",
    "prog_2022": "22.4",
    "prog_2023": "26.6",
    "prog_2024": "21.8",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "6.1",
    "cote_2022": "5.9",
    "cote_2023": "5.9",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Soulanges",
    "nom_court": "École secondaire Soulanges",
    "adresse": "137, rue Sainte-Catherine",
    "municipalite": "Saint-Polycarpe",
    "code_postal": "J0P 1X0",
    "lat": 45.29729,
    "lng": -74.31002
  },
  {
    "_id": "277",
    "school_code": "869004",
    "school_name_1": "La Cité-des-Jeunes",
    "admin_body_number": "869000",
    "admin_body_name": "Centre de services scolaire des Trois-Lacs",
    "area_name": "Montérégie ",
    "étudiants": "2481",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "14.9",
    "ehdaa_2024": "29.2",
    "rang_2024": "182/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "65.5",
    "lens_2019": "72.4",
    "lens_2022": "67.2",
    "lens_2023": "68.7",
    "lens_2024": "63.8",
    "lens_trend": "—",
    "lsec_2018": "80.6",
    "lsec_2019": "80.9",
    "lsec_2022": "81.6",
    "lsec_2023": "82.8",
    "lsec_2024": "84.8",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.8",
    "scie_2019": "71.8",
    "scie_2022": "70.2",
    "scie_2023": "75.2",
    "scie_2024": "73.7",
    "scie_trend": "—",
    "math_2018": "69.2",
    "math_2019": "69.7",
    "math_2022": "76.8",
    "math_2023": "73.1",
    "math_2024": "82.2",
    "math_trend": "—",
    "echec_2018": "17.8",
    "echec_2019": "16.5",
    "echec_2022": "18.0",
    "echec_2023": "14.9",
    "echec_2024": "15.8",
    "echec_trend": "112233",
    "sures_2018": "1.8",
    "sures_2019": "0.9",
    "sures_2022": "2.3",
    "sures_2023": "1.1",
    "sures_2024": "2.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "F 5.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.9",
    "ecart_sexes_math_2019": "F 1.0",
    "ecart_sexes_math_2022": "F 2.3",
    "ecart_sexes_math_2023": "F 3.9",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.3",
    "prog_2019": "23.1",
    "prog_2022": "26.8",
    "prog_2023": "28.8",
    "prog_2024": "31.1",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "6.1",
    "cote_2022": "6.4",
    "cote_2023": "6.3",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de la Cité-des-Jeunes",
    "nom_court": "École secondaire de la Cité-des-Jeunes",
    "adresse": "400, avenue Saint-Charles",
    "municipalite": "Vaudreuil-Dorion",
    "code_postal": "J7V 6B1",
    "lat": 45.39375,
    "lng": -74.02808
  },
  {
    "_id": "278",
    "school_code": "869007",
    "school_name_1": "du Chêne-Bleu",
    "admin_body_number": "869000",
    "admin_body_name": "Centre de services scolaire des Trois-Lacs",
    "area_name": "Montérégie ",
    "étudiants": "1409",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "8.2",
    "ehdaa_2024": "22.5",
    "rang_2024": "182/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "72.0",
    "lens_2019": "70.8",
    "lens_2022": "67.6",
    "lens_2023": "66.3",
    "lens_2024": "65.3",
    "lens_trend": "998855",
    "lsec_2018": "83.7",
    "lsec_2019": "82.6",
    "lsec_2022": "84.9",
    "lsec_2023": "85.2",
    "lsec_2024": "85.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.7",
    "scie_2019": "72.8",
    "scie_2022": "73.4",
    "scie_2023": "77.9",
    "scie_2024": "74.8",
    "scie_trend": "—",
    "math_2018": "77.6",
    "math_2019": "76.6",
    "math_2022": "77.4",
    "math_2023": "74.7",
    "math_2024": "78.2",
    "math_trend": "998855",
    "echec_2018": "10.9",
    "echec_2019": "12.9",
    "echec_2022": "15.8",
    "echec_2023": "13.5",
    "echec_2024": "14.9",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "1.0",
    "sures_2022": "2.7",
    "sures_2023": "1.6",
    "sures_2024": "2.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 8.3",
    "ecart_sexes_lens_2022": "F 3.8",
    "ecart_sexes_lens_2023": "F 2.1",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.1",
    "ecart_sexes_math_2019": "M 2.3",
    "ecart_sexes_math_2022": "F 1.9",
    "ecart_sexes_math_2023": "F 9.2",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "22.4",
    "prog_2019": "19.8",
    "prog_2022": "11.8",
    "prog_2023": "22.1",
    "prog_2024": "26.7",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "6.5",
    "cote_2022": "7.2",
    "cote_2023": "6.5",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire du Chêne-Bleu",
    "nom_court": "École secondaire du Chêne-Bleu",
    "adresse": "225, boulevard Pincourt",
    "municipalite": "Pincourt",
    "code_postal": "J7W 9T2",
    "lat": 45.38486,
    "lng": -73.9718
  },
  {
    "_id": "279",
    "school_code": "871012",
    "school_name_1": "Jean-Nicolet",
    "admin_body_number": "871000",
    "admin_body_name": "Centre de services scolaire de la Riveraine",
    "area_name": "Centre-du-Québec ",
    "étudiants": "832",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "13.7",
    "ehdaa_2024": "34.7",
    "rang_2024": "207/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "68.8",
    "lens_2019": "72.5",
    "lens_2022": "64.6",
    "lens_2023": "68.2",
    "lens_2024": "67.4",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "75.7",
    "lsec_2022": "79.3",
    "lsec_2023": "78.2",
    "lsec_2024": "76.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.8",
    "scie_2019": "65.4",
    "scie_2022": "66.5",
    "scie_2023": "74.0",
    "scie_2024": "69.1",
    "scie_trend": "—",
    "math_2018": "76.7",
    "math_2019": "71.3",
    "math_2022": "74.8",
    "math_2023": "72.5",
    "math_2024": "85.1",
    "math_trend": "—",
    "echec_2018": "19.0",
    "echec_2019": "17.8",
    "echec_2022": "22.8",
    "echec_2023": "15.9",
    "echec_2024": "14.5",
    "echec_trend": "112233",
    "sures_2018": "0.0",
    "sures_2019": "1.4",
    "sures_2022": "1.9",
    "sures_2023": "1.0",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.1",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 4.1",
    "ecart_sexes_lens_2023": "F 0.5",
    "ecart_sexes_lens_2024": "F 2.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 2.3",
    "ecart_sexes_math_2022": "M 0.5",
    "ecart_sexes_math_2023": "F 6.1",
    "ecart_sexes_math_2024": "F 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.7",
    "prog_2019": "43.7",
    "prog_2022": "29.7",
    "prog_2023": "41.6",
    "prog_2024": "42.0",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "4.8",
    "cote_2022": "5.7",
    "cote_2023": "5.6",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Jean-Nicolet",
    "nom_court": "École secondaire Jean-Nicolet",
    "adresse": "497, rue de Monseigneur-Brunault",
    "municipalite": "Nicolet",
    "code_postal": "J3T 1Y6",
    "lat": 46.2335,
    "lng": -72.6194
  },
  {
    "_id": "280",
    "school_code": "871013",
    "school_name_1": "La Découverte",
    "admin_body_number": "871000",
    "admin_body_name": "Centre de services scolaire de la Riveraine",
    "area_name": "Centre-du-Québec ",
    "étudiants": "753",
    "langue": "français",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "12.1",
    "ehdaa_2024": "42.5",
    "rang_2024": "207/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "69.5",
    "lens_2019": "69.9",
    "lens_2022": "66.2",
    "lens_2023": "68.8",
    "lens_2024": "66.2",
    "lens_trend": "—",
    "lsec_2018": "73.5",
    "lsec_2019": "70.5",
    "lsec_2022": "75.3",
    "lsec_2023": "80.3",
    "lsec_2024": "81.7",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.1",
    "scie_2019": "69.7",
    "scie_2022": "66.5",
    "scie_2023": "74.9",
    "scie_2024": "72.3",
    "scie_trend": "—",
    "math_2018": "71.8",
    "math_2019": "72.6",
    "math_2022": "74.9",
    "math_2023": "75.4",
    "math_2024": "76.0",
    "math_trend": "—",
    "echec_2018": "18.3",
    "echec_2019": "15.1",
    "echec_2022": "18.7",
    "echec_2023": "15.5",
    "echec_2024": "15.0",
    "echec_trend": "112233",
    "sures_2018": "1.2",
    "sures_2019": "1.3",
    "sures_2022": "3.0",
    "sures_2023": "0.6",
    "sures_2024": "1.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 2.5",
    "ecart_sexes_lens_2022": "F 4.9",
    "ecart_sexes_lens_2023": "F 4.1",
    "ecart_sexes_lens_2024": "F 1.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.1",
    "ecart_sexes_math_2019": "F 2.4",
    "ecart_sexes_math_2022": "F 8.3",
    "ecart_sexes_math_2023": "F 3.2",
    "ecart_sexes_math_2024": "M 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "34.5",
    "prog_2019": "42.0",
    "prog_2022": "26.9",
    "prog_2023": "44.8",
    "prog_2024": "30.0",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "4.8",
    "cote_2022": "5.3",
    "cote_2023": "5.8",
    "cote_2024": "6.1",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire la Découverte",
    "nom_court": "École secondaire la Découverte",
    "adresse": "401, rue Germain",
    "municipalite": "Saint-Léonard-d'Aston",
    "code_postal": "J0C 1M0",
    "lat": 46.10583,
    "lng": -72.37671
  },
  {
    "_id": "281",
    "school_code": "871019",
    "school_name_1": "les Seigneuries",
    "admin_body_number": "871000",
    "admin_body_name": "Centre de services scolaire de la Riveraine",
    "area_name": "Centre-du-Québec ",
    "étudiants": "312",
    "langue": "français",
    "secteur": "public",
    "rang": "360",
    "rang_5_ans": "396",
    "index": "0.1",
    "en_retard_2024": "35.4",
    "ehdaa_2024": "38.8",
    "rang_2024": "360/470",
    "rang_2019_2024": "396/432",
    "lens_2018": "66.6",
    "lens_2019": "63.1",
    "lens_2022": "68.4",
    "lens_2023": "63.4",
    "lens_2024": "68.5",
    "lens_trend": "—",
    "lsec_2018": "75.1",
    "lsec_2019": "75.6",
    "lsec_2022": "80.5",
    "lsec_2023": "78.1",
    "lsec_2024": "81.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.5",
    "scie_2019": "65.8",
    "scie_2022": "66.9",
    "scie_2023": "71.4",
    "scie_2024": "71.0",
    "scie_trend": "112233",
    "math_2018": "70.8",
    "math_2019": "77.9",
    "math_2022": "54.2",
    "math_2023": "66.5",
    "math_2024": "68.7",
    "math_trend": "—",
    "echec_2018": "23.2",
    "echec_2019": "21.8",
    "echec_2022": "31.4",
    "echec_2023": "24.6",
    "echec_2024": "23.3",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "1.3",
    "sures_2022": "7.1",
    "sures_2023": "6.0",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 11.5",
    "ecart_sexes_lens_2023": "M 1.0",
    "ecart_sexes_lens_2024": "F 3.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 5.6",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "F 6.7",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "41.0",
    "prog_2019": "38.6",
    "prog_2022": "42.7",
    "prog_2023": "37.6",
    "prog_2024": "38.0",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.3",
    "cote_2022": "3.5",
    "cote_2023": "4.0",
    "cote_2024": "4.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire les Seigneuries",
    "nom_court": "École secondaire les Seigneuries",
    "adresse": "165, Route 218",
    "municipalite": "Saint-Pierre-les-Becquets",
    "code_postal": "G0X 2Z0",
    "lat": 46.49753,
    "lng": -72.19435
  },
  {
    "_id": "282",
    "school_code": "872056",
    "school_name_1": "Monique-Proulx",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "519",
    "langue": "français",
    "secteur": "public",
    "rang": "132",
    "rang_5_ans": "114",
    "index": "0.1",
    "en_retard_2024": "15.6",
    "ehdaa_2024": "31.4",
    "rang_2024": "132/470",
    "rang_2019_2024": "114/432",
    "lens_2018": "72.6",
    "lens_2019": "73.0",
    "lens_2022": "68.8",
    "lens_2023": "77.2",
    "lens_2024": "69.5",
    "lens_trend": "—",
    "lsec_2018": "83.9",
    "lsec_2019": "78.9",
    "lsec_2022": "79.5",
    "lsec_2023": "82.2",
    "lsec_2024": "81.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.3",
    "scie_2019": "73.4",
    "scie_2022": "75.3",
    "scie_2023": "75.5",
    "scie_2024": "69.3",
    "scie_trend": "—",
    "math_2018": "76.0",
    "math_2019": "76.7",
    "math_2022": "79.8",
    "math_2023": "78.9",
    "math_2024": "81.2",
    "math_trend": "—",
    "echec_2018": "10.0",
    "echec_2019": "10.4",
    "echec_2022": "15.7",
    "echec_2023": "8.8",
    "echec_2024": "12.5",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.4",
    "sures_2022": "1.5",
    "sures_2023": "1.0",
    "sures_2024": "3.1",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 2.3",
    "ecart_sexes_lens_2019": "F 4.9",
    "ecart_sexes_lens_2022": "F 9.6",
    "ecart_sexes_lens_2023": "F 0.8",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.6",
    "ecart_sexes_math_2019": "F 4.6",
    "ecart_sexes_math_2022": "F 1.1",
    "ecart_sexes_math_2023": "F 3.5",
    "ecart_sexes_math_2024": "M 2.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.0",
    "prog_2019": "18.4",
    "prog_2022": "19.3",
    "prog_2023": "14.7",
    "prog_2024": "13.8",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "6.6",
    "cote_2022": "6.7",
    "cote_2023": "7.8",
    "cote_2024": "6.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Monique-Proulx",
    "nom_court": "École secondaire Monique-Proulx",
    "adresse": "11, rue Sainte-Jeanne-d'Arc",
    "municipalite": "Warwick",
    "code_postal": "J0A 1M0",
    "lat": 45.93994,
    "lng": -71.9934
  },
  {
    "_id": "283",
    "school_code": "872066",
    "school_name_1": "Le tandem",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "720",
    "langue": "français",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "5.9",
    "ehdaa_2024": "29.9",
    "rang_2024": "182/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "71.7",
    "lens_2019": "74.5",
    "lens_2022": "72.1",
    "lens_2023": "70.0",
    "lens_2024": "71.7",
    "lens_trend": "—",
    "lsec_2018": "84.2",
    "lsec_2019": "73.6",
    "lsec_2022": "76.2",
    "lsec_2023": "76.1",
    "lsec_2024": "76.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.9",
    "scie_2019": "80.0",
    "scie_2022": "74.5",
    "scie_2023": "80.3",
    "scie_2024": "73.5",
    "scie_trend": "—",
    "math_2018": "78.7",
    "math_2019": "77.4",
    "math_2022": "70.2",
    "math_2023": "73.0",
    "math_2024": "76.2",
    "math_trend": "998855",
    "echec_2018": "7.0",
    "echec_2019": "11.5",
    "echec_2022": "17.2",
    "echec_2023": "10.3",
    "echec_2024": "12.8",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "1.0",
    "sures_2022": "2.8",
    "sures_2023": "0.0",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.7",
    "ecart_sexes_lens_2019": "E",
    "ecart_sexes_lens_2022": "F 6.3",
    "ecart_sexes_lens_2023": "F 1.7",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.0",
    "ecart_sexes_math_2019": "F 5.1",
    "ecart_sexes_math_2022": "M 4.6",
    "ecart_sexes_math_2023": "M 2.1",
    "ecart_sexes_math_2024": "F 14.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "7.2",
    "prog_2019": "18.9",
    "prog_2022": "6.1",
    "prog_2023": "13.0",
    "prog_2024": "9.6",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "7.0",
    "cote_2022": "6.5",
    "cote_2023": "6.9",
    "cote_2024": "6.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Le tandem Albert-Morissette",
    "nom_court": "École secondaire Le tandem",
    "adresse": "20, rue de l'Ermitage",
    "municipalite": "Victoriaville",
    "code_postal": "G6P 1J5",
    "lat": 46.05949,
    "lng": -71.96147
  },
  {
    "_id": "284",
    "school_code": "872067",
    "school_name_1": "Le boisé",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "2143",
    "langue": "français",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "14.6",
    "ehdaa_2024": "30.8",
    "rang_2024": "229/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "67.6",
    "lens_2019": "68.9",
    "lens_2022": "64.6",
    "lens_2023": "68.3",
    "lens_2024": "64.8",
    "lens_trend": "—",
    "lsec_2018": "79.5",
    "lsec_2019": "79.4",
    "lsec_2022": "79.7",
    "lsec_2023": "80.0",
    "lsec_2024": "80.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.9",
    "scie_2019": "74.7",
    "scie_2022": "72.4",
    "scie_2023": "75.2",
    "scie_2024": "71.8",
    "scie_trend": "—",
    "math_2018": "72.4",
    "math_2019": "71.8",
    "math_2022": "79.1",
    "math_2023": "74.7",
    "math_2024": "77.3",
    "math_trend": "—",
    "echec_2018": "16.5",
    "echec_2019": "15.6",
    "echec_2022": "15.9",
    "echec_2023": "14.4",
    "echec_2024": "17.9",
    "echec_trend": "—",
    "sures_2018": "2.9",
    "sures_2019": "2.2",
    "sures_2022": "4.0",
    "sures_2023": "1.3",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 4.9",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 1.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 9.7",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "M 2.9",
    "ecart_sexes_math_2023": "F 0.1",
    "ecart_sexes_math_2024": "M 3.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "22.8",
    "prog_2019": "21.4",
    "prog_2022": "19.7",
    "prog_2023": "23.3",
    "prog_2024": "22.3",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "5.8",
    "cote_2022": "6.3",
    "cote_2023": "6.3",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Le boisé",
    "nom_court": "École secondaire Le boisé",
    "adresse": "605, rue Notre-Dame Est",
    "municipalite": "Victoriaville",
    "code_postal": "G6P 6Y9",
    "lat": 46.06227,
    "lng": -71.94086
  },
  {
    "_id": "285",
    "school_code": "872069",
    "school_name_1": "La Samare",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "1112",
    "langue": "français",
    "secteur": "public",
    "rang": "169",
    "rang_5_ans": "125",
    "index": "0.1",
    "en_retard_2024": "10.8",
    "ehdaa_2024": "35.7",
    "rang_2024": "169/470",
    "rang_2019_2024": "125/432",
    "lens_2018": "71.2",
    "lens_2019": "70.2",
    "lens_2022": "64.2",
    "lens_2023": "67.6",
    "lens_2024": "65.3",
    "lens_trend": "998855",
    "lsec_2018": "87.5",
    "lsec_2019": "85.9",
    "lsec_2022": "85.7",
    "lsec_2023": "85.9",
    "lsec_2024": "85.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "71.4",
    "scie_2022": "72.3",
    "scie_2023": "70.7",
    "scie_2024": "69.5",
    "scie_trend": "—",
    "math_2018": "78.1",
    "math_2019": "80.2",
    "math_2022": "78.0",
    "math_2023": "71.4",
    "math_2024": "79.9",
    "math_trend": "—",
    "echec_2018": "8.4",
    "echec_2019": "9.3",
    "echec_2022": "20.4",
    "echec_2023": "19.7",
    "echec_2024": "16.6",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "2.6",
    "sures_2022": "2.3",
    "sures_2023": "3.1",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.0",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 5.7",
    "ecart_sexes_lens_2023": "F 7.8",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.7",
    "ecart_sexes_math_2019": "F 5.6",
    "ecart_sexes_math_2022": "M 0.9",
    "ecart_sexes_math_2023": "F 7.7",
    "ecart_sexes_math_2024": "F 6.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "10.8",
    "prog_2019": "15.7",
    "prog_2022": "11.4",
    "prog_2023": "29.6",
    "prog_2024": "26.6",
    "prog_trend": "998855",
    "cote_2018": "7.5",
    "cote_2019": "7.4",
    "cote_2022": "7.1",
    "cote_2023": "5.7",
    "cote_2024": "6.4",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Polyvalente La Samare",
    "nom_court": "École Polyvalente La Samare",
    "adresse": "1159, rue Saint-Jean",
    "municipalite": "Plessisville",
    "code_postal": "G6L 1E1",
    "lat": 46.21888,
    "lng": -71.78713
  },
  {
    "_id": "286",
    "school_code": "872070",
    "school_name_1": "Sainte-Marie",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "455",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "17.2",
    "ehdaa_2024": "36.3",
    "rang_2024": "277/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "69.5",
    "lens_2019": "69.2",
    "lens_2022": "62.1",
    "lens_2023": "65.9",
    "lens_2024": "66.5",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "80.5",
    "lsec_2022": "79.8",
    "lsec_2023": "79.9",
    "lsec_2024": "80.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.4",
    "scie_2019": "79.7",
    "scie_2022": "77.9",
    "scie_2023": "71.4",
    "scie_2024": "73.8",
    "scie_trend": "—",
    "math_2018": "75.5",
    "math_2019": "74.4",
    "math_2022": "73.5",
    "math_2023": "74.4",
    "math_2024": "72.0",
    "math_trend": "—",
    "echec_2018": "8.3",
    "echec_2019": "11.7",
    "echec_2022": "15.2",
    "echec_2023": "14.2",
    "echec_2024": "15.7",
    "echec_trend": "998855",
    "sures_2018": "0.7",
    "sures_2019": "0.0",
    "sures_2022": "2.9",
    "sures_2023": "2.9",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 0.3",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 8.1",
    "ecart_sexes_lens_2023": "M 4.8",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 5.2",
    "ecart_sexes_math_2019": "F 10.0",
    "ecart_sexes_math_2022": "F 12.9",
    "ecart_sexes_math_2023": "M 3.7",
    "ecart_sexes_math_2024": "F 5.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.2",
    "prog_2019": "24.0",
    "prog_2022": "29.9",
    "prog_2023": "31.3",
    "prog_2024": "42.0",
    "prog_trend": "998855",
    "cote_2018": "6.9",
    "cote_2019": "6.8",
    "cote_2022": "5.7",
    "cote_2023": "5.9",
    "cote_2024": "5.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Sainte-Marie",
    "nom_court": "École Sainte-Marie",
    "adresse": "75, rue Monseigneur-Poirier",
    "municipalite": "Princeville",
    "code_postal": "G6L 4S7",
    "lat": 46.17014,
    "lng": -71.87534
  },
  {
    "_id": "287",
    "school_code": "872071",
    "school_name_1": "Sainte-Anne",
    "admin_body_number": "872000",
    "admin_body_name": "Centre de services scolaire des Bois-Francs",
    "area_name": "Centre-du-Québec ",
    "étudiants": "134",
    "langue": "français",
    "secteur": "public",
    "rang": "86",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "25",
    "ehdaa_2024": "35.8",
    "rang_2024": "86/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "71.5",
    "lens_2019": "74.6",
    "lens_2022": "71.9",
    "lens_2023": "77.7",
    "lens_2024": "75.9",
    "lens_trend": "112233",
    "lsec_2018": "78.6",
    "lsec_2019": "77.5",
    "lsec_2022": "79.3",
    "lsec_2023": "79.0",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.2",
    "scie_2019": "73.8",
    "scie_2022": "78.1",
    "scie_2023": "74.2",
    "scie_2024": "70.5",
    "scie_trend": "—",
    "math_2018": "74.4",
    "math_2019": "76.5",
    "math_2022": "81.8",
    "math_2023": "64.0",
    "math_2024": "81.4",
    "math_trend": "—",
    "echec_2018": "6.9",
    "echec_2019": "2.5",
    "echec_2022": "4.8",
    "echec_2023": "15.0",
    "echec_2024": "4.6",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "1.2",
    "sures_2022": "3.5",
    "sures_2023": "3.0",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "10.0",
    "prog_2019": "11.1",
    "prog_2022": "6.7",
    "prog_2023": "22.8",
    "prog_2024": "37.5",
    "prog_trend": "998855",
    "cote_2018": "6.7",
    "cote_2019": "7.7",
    "cote_2022": "8.1",
    "cote_2023": "6.2",
    "cote_2024": "7.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Sainte-Anne",
    "nom_court": "École Sainte-Anne",
    "adresse": "111, 7e Avenue",
    "municipalite": "Daveluyville",
    "code_postal": "G0Z 1C0",
    "lat": 46.20314,
    "lng": -72.13953
  },
  {
    "_id": "288",
    "school_code": "873050",
    "school_name_1": "Jean-Raimbault",
    "admin_body_number": "873000",
    "admin_body_name": "Centre de services scolaire des Chênes",
    "area_name": "Centre-du-Québec ",
    "étudiants": "1291",
    "langue": "français",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "20.9",
    "ehdaa_2024": "41.3",
    "rang_2024": "310/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "69.4",
    "lens_2019": "70.3",
    "lens_2022": "64.8",
    "lens_2023": "67.2",
    "lens_2024": "64.0",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "81.6",
    "lsec_2022": "80.2",
    "lsec_2023": "77.9",
    "lsec_2024": "76.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.1",
    "scie_2019": "70.4",
    "scie_2022": "70.4",
    "scie_2023": "72.4",
    "scie_2024": "67.4",
    "scie_trend": "—",
    "math_2018": "72.1",
    "math_2019": "70.2",
    "math_2022": "73.5",
    "math_2023": "72.2",
    "math_2024": "77.8",
    "math_trend": "—",
    "echec_2018": "17.8",
    "echec_2019": "16.8",
    "echec_2022": "20.4",
    "echec_2023": "19.1",
    "echec_2024": "18.9",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "2.0",
    "sures_2022": "1.7",
    "sures_2023": "0.5",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.4",
    "ecart_sexes_lens_2019": "F 6.3",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 7.8",
    "ecart_sexes_math_2019": "F 6.2",
    "ecart_sexes_math_2022": "F 1.1",
    "ecart_sexes_math_2023": "F 3.8",
    "ecart_sexes_math_2024": "F 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.0",
    "prog_2019": "19.9",
    "prog_2022": "19.4",
    "prog_2023": "40.8",
    "prog_2024": "36.0",
    "prog_trend": "998855",
    "cote_2018": "5.5",
    "cote_2019": "5.7",
    "cote_2022": "6.1",
    "cote_2023": "5.2",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Jean-Raimbault",
    "nom_court": "École Jean-Raimbault",
    "adresse": "175, rue Pelletier",
    "municipalite": "Drummondville",
    "code_postal": "J2C 2W1",
    "lat": 45.87556,
    "lng": -72.50318
  },
  {
    "_id": "289",
    "school_code": "873053",
    "school_name_1": "Jeanne-Mance",
    "admin_body_number": "873000",
    "admin_body_name": "Centre de services scolaire des Chênes",
    "area_name": "Centre-du-Québec ",
    "étudiants": "1055",
    "langue": "français",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "9.7",
    "ehdaa_2024": "37.3",
    "rang_2024": "277/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "72.0",
    "lens_2019": "71.1",
    "lens_2022": "65.1",
    "lens_2023": "67.3",
    "lens_2024": "69.9",
    "lens_trend": "—",
    "lsec_2018": "75.5",
    "lsec_2019": "77.7",
    "lsec_2022": "85.1",
    "lsec_2023": "82.4",
    "lsec_2024": "84.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.2",
    "scie_2019": "63.2",
    "scie_2022": "64.4",
    "scie_2023": "71.3",
    "scie_2024": "65.6",
    "scie_trend": "—",
    "math_2018": "72.3",
    "math_2019": "68.6",
    "math_2022": "73.8",
    "math_2023": "72.0",
    "math_2024": "78.4",
    "math_trend": "—",
    "echec_2018": "15.9",
    "echec_2019": "23.1",
    "echec_2022": "24.6",
    "echec_2023": "18.5",
    "echec_2024": "16.7",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "2.4",
    "sures_2022": "5.2",
    "sures_2023": "2.6",
    "sures_2024": "4.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.0",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 7.6",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 9.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.1",
    "ecart_sexes_math_2019": "F 2.8",
    "ecart_sexes_math_2022": "F 11.9",
    "ecart_sexes_math_2023": "F 7.4",
    "ecart_sexes_math_2024": "F 3.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "20.2",
    "prog_2019": "21.5",
    "prog_2022": "22.5",
    "prog_2023": "28.7",
    "prog_2024": "33.7",
    "prog_trend": "998855",
    "cote_2018": "5.8",
    "cote_2019": "4.8",
    "cote_2022": "5.2",
    "cote_2023": "5.3",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Jeanne-Mance",
    "nom_court": "École Jeanne-Mance",
    "adresse": "45, avenue des Frères",
    "municipalite": "Drummondville",
    "code_postal": "J2B 6A2",
    "lat": 45.88061,
    "lng": -72.48002
  },
  {
    "_id": "290",
    "school_code": "873055",
    "school_name_1": "Marie-Rivier",
    "admin_body_number": "873000",
    "admin_body_name": "Centre de services scolaire des Chênes",
    "area_name": "Centre-du-Québec ",
    "étudiants": "1778",
    "langue": "français",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "8.7",
    "ehdaa_2024": "33",
    "rang_2024": "156/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "68.1",
    "lens_2019": "68.3",
    "lens_2022": "67.4",
    "lens_2023": "68.5",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "74.5",
    "lsec_2019": "75.3",
    "lsec_2022": "76.5",
    "lsec_2023": "77.9",
    "lsec_2024": "77.2",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.2",
    "scie_2019": "70.6",
    "scie_2022": "70.0",
    "scie_2023": "74.2",
    "scie_2024": "74.2",
    "scie_trend": "112233",
    "math_2018": "78.1",
    "math_2019": "78.3",
    "math_2022": "81.0",
    "math_2023": "80.0",
    "math_2024": "85.6",
    "math_trend": "112233",
    "echec_2018": "15.8",
    "echec_2019": "13.9",
    "echec_2022": "16.4",
    "echec_2023": "13.3",
    "echec_2024": "12.1",
    "echec_trend": "112233",
    "sures_2018": "1.4",
    "sures_2019": "0.9",
    "sures_2022": "2.4",
    "sures_2023": "2.1",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 0.9",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.2",
    "ecart_sexes_math_2019": "F 1.4",
    "ecart_sexes_math_2022": "M 2.4",
    "ecart_sexes_math_2023": "F 2.4",
    "ecart_sexes_math_2024": "F 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "28.3",
    "prog_2019": "32.2",
    "prog_2022": "13.5",
    "prog_2023": "23.0",
    "prog_2024": "27.7",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "5.8",
    "cote_2022": "6.5",
    "cote_2023": "6.4",
    "cote_2024": "6.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Marie-Rivier",
    "nom_court": "École Marie-Rivier",
    "adresse": "265, rue Saint-Félix",
    "municipalite": "Drummondville",
    "code_postal": "J2C 5M1",
    "lat": 45.89788,
    "lng": -72.50268
  },
  {
    "_id": "291",
    "school_code": "873057",
    "school_name_1": "La Poudrière",
    "admin_body_number": "873000",
    "admin_body_name": "Centre de services scolaire des Chênes",
    "area_name": "Centre-du-Québec ",
    "étudiants": "1534",
    "langue": "français",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "17",
    "ehdaa_2024": "46.6",
    "rang_2024": "420/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "69.0",
    "lens_2019": "68.1",
    "lens_2022": "63.2",
    "lens_2023": "68.2",
    "lens_2024": "65.2",
    "lens_trend": "—",
    "lsec_2018": "76.2",
    "lsec_2019": "82.5",
    "lsec_2022": "76.5",
    "lsec_2023": "79.4",
    "lsec_2024": "77.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.7",
    "scie_2019": "60.9",
    "scie_2022": "64.2",
    "scie_2023": "64.7",
    "scie_2024": "60.3",
    "scie_trend": "—",
    "math_2018": "66.9",
    "math_2019": "68.5",
    "math_2022": "67.9",
    "math_2023": "64.1",
    "math_2024": "73.8",
    "math_trend": "—",
    "echec_2018": "22.4",
    "echec_2019": "25.1",
    "echec_2022": "29.6",
    "echec_2023": "28.6",
    "echec_2024": "27.1",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "2.5",
    "sures_2022": "4.9",
    "sures_2023": "2.8",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.8",
    "ecart_sexes_lens_2019": "F 4.8",
    "ecart_sexes_lens_2022": "F 6.0",
    "ecart_sexes_lens_2023": "F 3.7",
    "ecart_sexes_lens_2024": "F 4.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.7",
    "ecart_sexes_math_2019": "F 1.2",
    "ecart_sexes_math_2022": "F 2.5",
    "ecart_sexes_math_2023": "F 5.3",
    "ecart_sexes_math_2024": "F 5.8",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "29.4",
    "prog_2019": "33.7",
    "prog_2022": "21.7",
    "prog_2023": "38.8",
    "prog_2024": "39.6",
    "prog_trend": "—",
    "cote_2018": "4.6",
    "cote_2019": "4.5",
    "cote_2022": "4.6",
    "cote_2023": "3.9",
    "cote_2024": "4.0",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École La Poudrière",
    "nom_court": "École La Poudrière",
    "adresse": "1125, boulevard Jean-de-Brébeuf",
    "municipalite": "Drummondville",
    "code_postal": "J2B 4T5",
    "lat": 45.86127,
    "lng": -72.47523
  },
  {
    "_id": "292",
    "school_code": "881002",
    "school_name_1": "Quebec",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Capitale-Nationale ",
    "étudiants": "430",
    "langue": "anglais",
    "secteur": "public",
    "rang": "433",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "13.5",
    "ehdaa_2024": "22.1",
    "rang_2024": "433/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "74.0",
    "lens_2019": "72.4",
    "lens_2022": "75.1",
    "lens_2023": "73.0",
    "lens_2024": "74.0",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "74.1",
    "lsec_2022": "75.8",
    "lsec_2023": "75.1",
    "lsec_2024": "72.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.6",
    "scie_2019": "68.9",
    "scie_2022": "67.6",
    "scie_2023": "72.1",
    "scie_2024": "61.6",
    "scie_trend": "—",
    "math_2018": "69.4",
    "math_2019": "68.2",
    "math_2022": "67.4",
    "math_2023": "69.9",
    "math_2024": "65.6",
    "math_trend": "—",
    "echec_2018": "12.2",
    "echec_2019": "19.5",
    "echec_2022": "17.6",
    "echec_2023": "19.4",
    "echec_2024": "26.7",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "1.1",
    "sures_2022": "2.4",
    "sures_2023": "3.2",
    "sures_2024": "5.6",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.3",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 6.1",
    "ecart_sexes_lens_2023": "F 9.3",
    "ecart_sexes_lens_2024": "F 5.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.7",
    "ecart_sexes_math_2019": "F 20.8",
    "ecart_sexes_math_2022": "M 3.2",
    "ecart_sexes_math_2023": "M 4.6",
    "ecart_sexes_math_2024": "M 8.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.6",
    "prog_2019": "25.5",
    "prog_2022": "11.2",
    "prog_2023": "34.6",
    "prog_2024": "57.8",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "4.8",
    "cote_2022": "6.4",
    "cote_2023": "5.1",
    "cote_2024": "3.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Québec High School",
    "nom_court": "École secondaire Q.H.S.",
    "adresse": "945, avenue Belvédère",
    "municipalite": "Québec",
    "code_postal": "G1S 3G2",
    "lat": 46.79798,
    "lng": -71.23937
  },
  {
    "_id": "293",
    "school_code": "881003",
    "school_name_1": "Dollard-des-Ormeaux",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Capitale-Nationale ",
    "étudiants": "175",
    "langue": "anglais",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "15.4",
    "ehdaa_2024": "18.9",
    "rang_2024": "323/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "76.0",
    "lens_2019": "78.0",
    "lens_2022": "71.6",
    "lens_2023": "72.4",
    "lens_2024": "74.8",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "80.9",
    "lsec_2022": "77.1",
    "lsec_2023": "81.4",
    "lsec_2024": "80.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.6",
    "scie_2019": "71.1",
    "scie_2022": "65.5",
    "scie_2023": "66.2",
    "scie_2024": "58.7",
    "scie_trend": "998855",
    "math_2018": "75.2",
    "math_2019": "67.7",
    "math_2022": "65.3",
    "math_2023": "72.8",
    "math_2024": "67.6",
    "math_trend": "—",
    "echec_2018": "11.9",
    "echec_2019": "10.3",
    "echec_2022": "21.1",
    "echec_2023": "15.3",
    "echec_2024": "22.9",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "0.5",
    "sures_2022": "3.2",
    "sures_2023": "2.0",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 10.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 18.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "25.2",
    "prog_2019": "9.5",
    "prog_2022": "26.9",
    "prog_2023": "17.7",
    "prog_2024": "14.3",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "7.2",
    "cote_2022": "5.3",
    "cote_2023": "6.1",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Dollard-des-Ormeaux",
    "nom_court": "École Dollard-des-Ormeaux",
    "adresse": "18, rue Ladas",
    "municipalite": "Shannon",
    "code_postal": "G3S 0B8",
    "lat": 46.89037,
    "lng": -71.50648
  },
  {
    "_id": "294",
    "school_code": "881005",
    "school_name_1": "St. Patrick",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Capitale-Nationale ",
    "étudiants": "637",
    "langue": "anglais",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "17.3",
    "ehdaa_2024": "9.7",
    "rang_2024": "156/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "72.7",
    "lens_2019": "72.1",
    "lens_2022": "74.9",
    "lens_2023": "79.0",
    "lens_2024": "73.6",
    "lens_trend": "—",
    "lsec_2018": "75.7",
    "lsec_2019": "74.3",
    "lsec_2022": "76.0",
    "lsec_2023": "75.7",
    "lsec_2024": "75.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.2",
    "scie_2019": "78.3",
    "scie_2022": "71.8",
    "scie_2023": "76.3",
    "scie_2024": "69.8",
    "scie_trend": "998855",
    "math_2018": "71.4",
    "math_2019": "73.0",
    "math_2022": "74.1",
    "math_2023": "70.3",
    "math_2024": "76.1",
    "math_trend": "—",
    "echec_2018": "12.8",
    "echec_2019": "12.1",
    "echec_2022": "15.3",
    "echec_2023": "16.5",
    "echec_2024": "17.9",
    "echec_trend": "998855",
    "sures_2018": "1.8",
    "sures_2019": "2.1",
    "sures_2022": "2.1",
    "sures_2023": "1.5",
    "sures_2024": "0.9",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 6.6",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "F 0.2",
    "ecart_sexes_lens_2023": "F 7.5",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 4.1",
    "ecart_sexes_math_2022": "F 1.6",
    "ecart_sexes_math_2023": "F 0.1",
    "ecart_sexes_math_2024": "F 2.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "11.6",
    "prog_2019": "23.5",
    "prog_2022": "10.9",
    "prog_2023": "11.4",
    "prog_2024": "11.8",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "6.0",
    "cote_2022": "7.0",
    "cote_2023": "6.7",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Patrick",
    "nom_court": "École secondaire Saint-Patrick",
    "adresse": "75, rue de Maisonneuve",
    "municipalite": "Québec",
    "code_postal": "G1R 2C4",
    "lat": 46.80465,
    "lng": -71.22376
  },
  {
    "_id": "295",
    "school_code": "881007",
    "school_name_1": "A.S. Johnson Memorial",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "99",
    "langue": "anglais",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "nd",
    "rang_2024": "199/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "76.9",
    "lens_2022": "71.8",
    "lens_2023": "nd",
    "lens_2024": "80.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "82.8",
    "lsec_2022": "75.7",
    "lsec_2023": "nd",
    "lsec_2024": "82.7",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "73.1",
    "scie_2022": "57.7",
    "scie_2023": "nd",
    "scie_2024": "57.8",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "69.9",
    "math_2022": "55.9",
    "math_2023": "nd",
    "math_2024": "75.6",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "12.4",
    "echec_2022": "27.7",
    "echec_2023": "nd",
    "echec_2024": "20.5",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "3.0",
    "sures_2022": "7.0",
    "sures_2023": "nd",
    "sures_2024": "2.8",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "39.8",
    "prog_2022": "40.5",
    "prog_2023": "nd",
    "prog_2024": "26.3",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.7",
    "cote_2022": "3.7",
    "cote_2023": "nd",
    "cote_2024": "6.2",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire A.S. Johnson Memorial",
    "nom_court": "École secondaire A.S. Johnson Memorial",
    "adresse": "919, rue Mooney Ouest",
    "municipalite": "Thetford Mines",
    "code_postal": "G6G 6H3",
    "lat": 46.07189,
    "lng": -71.3011
  },
  {
    "_id": "296",
    "school_code": "881015",
    "school_name_1": "Three Rivers",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Mauricie ",
    "étudiants": "169",
    "langue": "anglais",
    "secteur": "public",
    "rang": "199",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "13.6",
    "rang_2024": "199/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "67.9",
    "lens_2019": "70.1",
    "lens_2022": "78.5",
    "lens_2023": "77.7",
    "lens_2024": "74.9",
    "lens_trend": "—",
    "lsec_2018": "78.9",
    "lsec_2019": "72.6",
    "lsec_2022": "72.5",
    "lsec_2023": "77.6",
    "lsec_2024": "78.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.8",
    "scie_2019": "65.3",
    "scie_2022": "68.9",
    "scie_2023": "76.3",
    "scie_2024": "74.5",
    "scie_trend": "112233",
    "math_2018": "54.8",
    "math_2019": "57.5",
    "math_2022": "67.6",
    "math_2023": "76.1",
    "math_2024": "72.0",
    "math_trend": "—",
    "echec_2018": "17.5",
    "echec_2019": "30.3",
    "echec_2022": "27.5",
    "echec_2023": "11.2",
    "echec_2024": "13.1",
    "echec_trend": "—",
    "sures_2018": "4.7",
    "sures_2019": "5.7",
    "sures_2022": "4.2",
    "sures_2023": "1.8",
    "sures_2024": "1.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 8.9",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 13.6",
    "ecart_sexes_lens_2024": "F 10.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 11.1",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 10.3",
    "ecart_sexes_math_2024": "F 6.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "12.5",
    "prog_2019": "10.0",
    "prog_2022": "25.9",
    "prog_2023": "23.1",
    "prog_2024": "24.0",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "4.2",
    "cote_2022": "5.8",
    "cote_2023": "6.2",
    "cote_2024": "6.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie de Trois-Rivières",
    "nom_court": "Académie de Trois-Rivières",
    "adresse": "1875, rue Nicolas-Perrot",
    "municipalite": "Trois-Rivières",
    "code_postal": "G9A 1C5",
    "lat": 46.35918,
    "lng": -72.54816
  },
  {
    "_id": "297",
    "school_code": "881017",
    "school_name_1": "La Tuque Secondaire",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Mauricie ",
    "étudiants": "77",
    "langue": "anglais",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "31.2",
    "rang_2024": "217/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "nd",
    "lens_2024": "70.5",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "nd",
    "lsec_2024": "81.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "nd",
    "scie_2024": "61.2",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "nd",
    "math_2024": "75.6",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "nd",
    "echec_2024": "22.4",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "nd",
    "sures_2024": "1.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "nd",
    "prog_2024": "7.1",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "nd",
    "cote_2024": "6.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de La Tuque",
    "nom_court": "École secondaire de La Tuque",
    "adresse": "531, rue Saint-Maurice",
    "municipalite": "La Tuque",
    "code_postal": "G9X 3E9",
    "lat": 47.4396,
    "lng": -72.78749
  },
  {
    "_id": "298",
    "school_code": "881019",
    "school_name_1": "Riverside",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "159",
    "langue": "anglais",
    "secteur": "public",
    "rang": "454",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "18.2",
    "rang_2024": "454/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "69.1",
    "lens_2022": "65.7",
    "lens_2023": "69.0",
    "lens_2024": "66.7",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "76.5",
    "lsec_2022": "73.2",
    "lsec_2023": "66.9",
    "lsec_2024": "72.5",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "67.7",
    "scie_2022": "63.4",
    "scie_2023": "62.9",
    "scie_2024": "57.4",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "65.1",
    "math_2022": "66.8",
    "math_2023": "50.4",
    "math_2024": "56.7",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "21.8",
    "echec_2022": "25.1",
    "echec_2023": "44.7",
    "echec_2024": "38.7",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "4.0",
    "sures_2022": "6.6",
    "sures_2023": "11.0",
    "sures_2024": "7.9",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "8.0",
    "prog_2022": "48.5",
    "prog_2023": "36.1",
    "prog_2024": "36.7",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.3",
    "cote_2022": "3.8",
    "cote_2023": "2.1",
    "cote_2024": "2.8",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire régionale Riverside",
    "nom_court": "École régionale Riverside",
    "adresse": "1770, rue Joule",
    "municipalite": "Saguenay",
    "code_postal": "G7S 3B1",
    "lat": 48.43325,
    "lng": -71.18404
  },
  {
    "_id": "299",
    "school_code": "881021",
    "school_name_1": "MacLean Memorial",
    "admin_body_number": "881000",
    "admin_body_name": "Commission scolaire Central Québec",
    "area_name": "Nord-du-Québec ",
    "étudiants": "91",
    "langue": "anglais",
    "secteur": "public",
    "rang": "451",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "33.3",
    "ehdaa_2024": "nd",
    "rang_2024": "451/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "75.2",
    "lens_2022": "75.5",
    "lens_2023": "70.9",
    "lens_2024": "69.7",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "77.8",
    "lsec_2022": "58.4",
    "lsec_2023": "68.8",
    "lsec_2024": "69.2",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "61.7",
    "scie_2022": "48.2",
    "scie_2023": "55.6",
    "scie_2024": "47.1",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "62.5",
    "math_2022": "66.5",
    "math_2023": "65.8",
    "math_2024": "64.6",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "21.2",
    "echec_2022": "45.4",
    "echec_2023": "37.4",
    "echec_2024": "36.9",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "5.2",
    "sures_2022": "11.7",
    "sures_2023": "1.4",
    "sures_2024": "7.4",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "20.0",
    "prog_2022": "33.3",
    "prog_2023": "67.1",
    "prog_2024": "44.4",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.2",
    "cote_2022": "3.0",
    "cote_2023": "3.0",
    "cote_2024": "2.9",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École MacLean Memorial",
    "nom_court": "École MacLean Memorial",
    "adresse": "159, 5e Avenue",
    "municipalite": "Chibougamau",
    "code_postal": "G8P 2E6",
    "lat": 49.91522,
    "lng": -74.36641
  },
  {
    "_id": "300",
    "school_code": "882002",
    "school_name_1": "New Carlisle",
    "admin_body_number": "882000",
    "admin_body_name": "Commission scolaire Eastern Shores",
    "area_name": "Gaspésie--Îles-de-la-Madeleine ",
    "étudiants": "80",
    "langue": "anglais",
    "secteur": "public",
    "rang": "449",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "13.3",
    "ehdaa_2024": "33.8",
    "rang_2024": "449/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "69.5",
    "lens_2023": "nd",
    "lens_2024": "65.6",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "64.3",
    "lsec_2023": "nd",
    "lsec_2024": "63.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "65.8",
    "scie_2023": "nd",
    "scie_2024": "55.1",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "73.7",
    "math_2023": "nd",
    "math_2024": "66.7",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "27.9",
    "echec_2023": "nd",
    "echec_2024": "39.5",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "4.7",
    "sures_2023": "nd",
    "sures_2024": "3.8",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "38.8",
    "prog_2023": "nd",
    "prog_2024": "53.3",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "4.0",
    "cote_2023": "nd",
    "cote_2024": "3.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire de New Carlisle",
    "nom_court": "École secondaire de New Carlisle",
    "adresse": "177, boulevard Gérard-D.-Lévesque",
    "municipalite": "New Carlisle",
    "code_postal": "G0C 1Z0",
    "lat": 48.00953,
    "lng": -65.33802
  },
  {
    "_id": "301",
    "school_code": "883022",
    "school_name_1": "Alexander Galt",
    "admin_body_number": "883000",
    "admin_body_name": "Commission scolaire Eastern Townships",
    "area_name": "Estrie ",
    "étudiants": "839",
    "langue": "anglais",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "336",
    "index": "0.1",
    "en_retard_2024": "17.8",
    "ehdaa_2024": "46.5",
    "rang_2024": "376/470",
    "rang_2019_2024": "336/432",
    "lens_2018": "64.9",
    "lens_2019": "67.7",
    "lens_2022": "70.1",
    "lens_2023": "70.5",
    "lens_2024": "69.1",
    "lens_trend": "112233",
    "lsec_2018": "76.3",
    "lsec_2019": "77.1",
    "lsec_2022": "78.1",
    "lsec_2023": "77.6",
    "lsec_2024": "74.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.8",
    "scie_2019": "69.8",
    "scie_2022": "66.9",
    "scie_2023": "70.4",
    "scie_2024": "62.1",
    "scie_trend": "—",
    "math_2018": "61.2",
    "math_2019": "72.5",
    "math_2022": "62.1",
    "math_2023": "61.2",
    "math_2024": "65.8",
    "math_trend": "—",
    "echec_2018": "23.1",
    "echec_2019": "12.7",
    "echec_2022": "21.7",
    "echec_2023": "18.6",
    "echec_2024": "24.5",
    "echec_trend": "—",
    "sures_2018": "4.6",
    "sures_2019": "1.8",
    "sures_2022": "3.7",
    "sures_2023": "3.1",
    "sures_2024": "4.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 4.2",
    "ecart_sexes_lens_2022": "F 2.0",
    "ecart_sexes_lens_2023": "F 6.0",
    "ecart_sexes_lens_2024": "F 4.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 1.7",
    "ecart_sexes_math_2022": "M 2.1",
    "ecart_sexes_math_2023": "M 4.0",
    "ecart_sexes_math_2024": "F 4.4",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "28.8",
    "prog_2019": "26.7",
    "prog_2022": "27.8",
    "prog_2023": "31.1",
    "prog_2024": "31.6",
    "prog_trend": "—",
    "cote_2018": "4.4",
    "cote_2019": "5.4",
    "cote_2022": "5.4",
    "cote_2023": "4.9",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Alexander Galt",
    "nom_court": "École secondaire Alexander Galt",
    "adresse": "1700, rue Collège",
    "municipalite": "Sherbrooke",
    "code_postal": "J1M 0C8",
    "lat": 45.36463,
    "lng": -71.81527
  },
  {
    "_id": "302",
    "school_code": "883023",
    "school_name_1": "Massey-Vanier",
    "admin_body_number": "883000",
    "admin_body_name": "Commission scolaire Eastern Townships",
    "area_name": "Estrie ",
    "étudiants": "717",
    "langue": "anglais",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "27.4",
    "ehdaa_2024": "54.8",
    "rang_2024": "252/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "73.0",
    "lens_2019": "74.8",
    "lens_2022": "72.5",
    "lens_2023": "74.8",
    "lens_2024": "76.6",
    "lens_trend": "—",
    "lsec_2018": "75.8",
    "lsec_2019": "78.4",
    "lsec_2022": "74.7",
    "lsec_2023": "81.5",
    "lsec_2024": "74.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.2",
    "scie_2019": "66.2",
    "scie_2022": "67.1",
    "scie_2023": "74.2",
    "scie_2024": "66.3",
    "scie_trend": "—",
    "math_2018": "64.9",
    "math_2019": "64.0",
    "math_2022": "59.5",
    "math_2023": "64.5",
    "math_2024": "70.3",
    "math_trend": "—",
    "echec_2018": "20.5",
    "echec_2019": "20.5",
    "echec_2022": "26.0",
    "echec_2023": "17.6",
    "echec_2024": "17.9",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "2.5",
    "sures_2022": "3.0",
    "sures_2023": "1.1",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.8",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 2.6",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.3",
    "ecart_sexes_math_2019": "F 5.8",
    "ecart_sexes_math_2022": "F 6.3",
    "ecart_sexes_math_2023": "M 3.9",
    "ecart_sexes_math_2024": "M 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "41.8",
    "prog_2019": "37.6",
    "prog_2022": "57.2",
    "prog_2023": "44.7",
    "prog_2024": "46.0",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.4",
    "cote_2022": "4.3",
    "cote_2023": "5.7",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Massey-Vanier",
    "nom_court": "École secondaire Massey-Vanier",
    "adresse": "224, rue Mercier",
    "municipalite": "Cowansville",
    "code_postal": "J2K 5C3",
    "lat": 45.208696,
    "lng": -72.773946
  },
  {
    "_id": "303",
    "school_code": "883024",
    "school_name_1": "Richmond",
    "admin_body_number": "883000",
    "admin_body_name": "Commission scolaire Eastern Townships",
    "area_name": "Estrie ",
    "étudiants": "365",
    "langue": "anglais",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "16.9",
    "ehdaa_2024": "49",
    "rang_2024": "348/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "70.0",
    "lens_2019": "71.1",
    "lens_2022": "70.1",
    "lens_2023": "72.3",
    "lens_2024": "68.3",
    "lens_trend": "—",
    "lsec_2018": "77.5",
    "lsec_2019": "78.3",
    "lsec_2022": "72.5",
    "lsec_2023": "74.6",
    "lsec_2024": "76.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "61.5",
    "scie_2019": "65.4",
    "scie_2022": "59.3",
    "scie_2023": "67.1",
    "scie_2024": "62.0",
    "scie_trend": "—",
    "math_2018": "66.8",
    "math_2019": "62.9",
    "math_2022": "62.7",
    "math_2023": "64.3",
    "math_2024": "71.2",
    "math_trend": "—",
    "echec_2018": "23.9",
    "echec_2019": "19.0",
    "echec_2022": "28.0",
    "echec_2023": "22.3",
    "echec_2024": "24.8",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "1.9",
    "sures_2022": "5.0",
    "sures_2023": "2.5",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.5",
    "ecart_sexes_lens_2019": "F 4.9",
    "ecart_sexes_lens_2022": "F 1.1",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 7.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.5",
    "ecart_sexes_math_2019": "F 8.2",
    "ecart_sexes_math_2022": "F 6.5",
    "ecart_sexes_math_2023": "F 4.3",
    "ecart_sexes_math_2024": "M 1.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "12.8",
    "prog_2019": "16.3",
    "prog_2022": "17.9",
    "prog_2023": "18.8",
    "prog_2024": "17.9",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.3",
    "cote_2022": "4.8",
    "cote_2023": "5.3",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale de Richmond",
    "nom_court": "École secondaire de Richmond",
    "adresse": "375, rue Armstrong",
    "municipalite": "Richmond",
    "code_postal": "J0B 2H0",
    "lat": 45.65537,
    "lng": -72.13191
  },
  {
    "_id": "304",
    "school_code": "884001",
    "school_name_1": "St. John's",
    "admin_body_number": "884000",
    "admin_body_name": "Commission scolaire Riverside",
    "area_name": "Montérégie ",
    "étudiants": "299",
    "langue": "anglais",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "6",
    "ehdaa_2024": "35.1",
    "rang_2024": "335/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "67.5",
    "lens_2019": "72.2",
    "lens_2022": "68.9",
    "lens_2023": "74.7",
    "lens_2024": "68.9",
    "lens_trend": "—",
    "lsec_2018": "71.8",
    "lsec_2019": "76.4",
    "lsec_2022": "68.3",
    "lsec_2023": "71.8",
    "lsec_2024": "73.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.3",
    "scie_2019": "72.7",
    "scie_2022": "64.3",
    "scie_2023": "66.5",
    "scie_2024": "65.7",
    "scie_trend": "—",
    "math_2018": "69.5",
    "math_2019": "72.5",
    "math_2022": "61.7",
    "math_2023": "64.9",
    "math_2024": "63.7",
    "math_trend": "998855",
    "echec_2018": "23.7",
    "echec_2019": "14.6",
    "echec_2022": "32.8",
    "echec_2023": "24.2",
    "echec_2024": "24.8",
    "echec_trend": "—",
    "sures_2018": "1.7",
    "sures_2019": "1.1",
    "sures_2022": "11.3",
    "sures_2023": "6.0",
    "sures_2024": "5.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.4",
    "ecart_sexes_lens_2019": "F 5.2",
    "ecart_sexes_lens_2022": "F 1.3",
    "ecart_sexes_lens_2023": "F 12.8",
    "ecart_sexes_lens_2024": "F 7.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.3",
    "ecart_sexes_math_2019": "F 4.1",
    "ecart_sexes_math_2022": "F 9.2",
    "ecart_sexes_math_2023": "M 2.6",
    "ecart_sexes_math_2024": "M 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "25.7",
    "prog_2019": "29.6",
    "prog_2022": "7.3",
    "prog_2023": "20.0",
    "prog_2024": "13.4",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.8",
    "cote_2022": "4.4",
    "cote_2023": "4.9",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Saint-Johns",
    "nom_court": "École Saint-Johns",
    "adresse": "380, rue Saint-Michel",
    "municipalite": "Saint-Jean-sur-Richelieu",
    "code_postal": "J3B 1T4",
    "lat": 45.31472,
    "lng": -73.27029
  },
  {
    "_id": "305",
    "school_code": "884016",
    "school_name_1": "Heritage Regional",
    "admin_body_number": "884000",
    "admin_body_name": "Commission scolaire Riverside",
    "area_name": "Montérégie ",
    "étudiants": "1786",
    "langue": "anglais",
    "secteur": "public",
    "rang": "252",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "7.6",
    "ehdaa_2024": "35.7",
    "rang_2024": "252/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "71.6",
    "lens_2019": "74.6",
    "lens_2022": "73.6",
    "lens_2023": "75.8",
    "lens_2024": "73.1",
    "lens_trend": "—",
    "lsec_2018": "71.5",
    "lsec_2019": "72.7",
    "lsec_2022": "73.8",
    "lsec_2023": "76.5",
    "lsec_2024": "75.2",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.3",
    "scie_2019": "70.9",
    "scie_2022": "68.4",
    "scie_2023": "71.4",
    "scie_2024": "66.5",
    "scie_trend": "—",
    "math_2018": "78.1",
    "math_2019": "74.9",
    "math_2022": "76.5",
    "math_2023": "74.1",
    "math_2024": "79.1",
    "math_trend": "—",
    "echec_2018": "16.2",
    "echec_2019": "16.2",
    "echec_2022": "19.7",
    "echec_2023": "16.2",
    "echec_2024": "19.2",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "1.8",
    "sures_2022": "3.2",
    "sures_2023": "1.6",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 5.4",
    "ecart_sexes_lens_2022": "F 10.8",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 6.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.9",
    "ecart_sexes_math_2019": "F 1.0",
    "ecart_sexes_math_2022": "F 7.5",
    "ecart_sexes_math_2023": "F 10.1",
    "ecart_sexes_math_2024": "F 2.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.0",
    "prog_2019": "13.4",
    "prog_2022": "9.9",
    "prog_2023": "20.8",
    "prog_2024": "20.9",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "6.1",
    "cote_2022": "5.8",
    "cote_2023": "5.9",
    "cote_2024": "5.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Héritage",
    "nom_court": "École secondaire régionale Héritage",
    "adresse": "7445, Chemin Chambly",
    "municipalite": "Saint-Hubert",
    "code_postal": "J3Y 3S3",
    "lat": 45.49036,
    "lng": -73.39158
  },
  {
    "_id": "306",
    "school_code": "884032",
    "school_name_1": "Saint-Lambert International",
    "admin_body_number": "884000",
    "admin_body_name": "Commission scolaire Riverside",
    "area_name": "Montérégie ",
    "étudiants": "368",
    "langue": "anglais",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "12",
    "ehdaa_2024": "38.6",
    "rang_2024": "390/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "67.8",
    "lens_2019": "71.3",
    "lens_2022": "72.5",
    "lens_2023": "77.8",
    "lens_2024": "70.4",
    "lens_trend": "—",
    "lsec_2018": "65.9",
    "lsec_2019": "65.9",
    "lsec_2022": "64.4",
    "lsec_2023": "65.8",
    "lsec_2024": "67.4",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.1",
    "scie_2019": "64.5",
    "scie_2022": "68.0",
    "scie_2023": "74.6",
    "scie_2024": "67.6",
    "scie_trend": "—",
    "math_2018": "73.1",
    "math_2019": "65.1",
    "math_2022": "67.8",
    "math_2023": "69.7",
    "math_2024": "67.7",
    "math_trend": "—",
    "echec_2018": "25.4",
    "echec_2019": "28.9",
    "echec_2022": "29.2",
    "echec_2023": "22.9",
    "echec_2024": "29.1",
    "echec_trend": "—",
    "sures_2018": "4.6",
    "sures_2019": "4.7",
    "sures_2022": "5.3",
    "sures_2023": "3.7",
    "sures_2024": "3.8",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "M 2.0",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 0.4",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.7",
    "ecart_sexes_math_2019": "F 12.9",
    "ecart_sexes_math_2022": "M 1.3",
    "ecart_sexes_math_2023": "F 8.3",
    "ecart_sexes_math_2024": "F 1.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.6",
    "prog_2019": "28.6",
    "prog_2022": "15.0",
    "prog_2023": "28.7",
    "prog_2024": "35.4",
    "prog_trend": "—",
    "cote_2018": "4.1",
    "cote_2019": "3.6",
    "cote_2022": "5.3",
    "cote_2023": "5.4",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire internationale de Saint-Lambert",
    "nom_court": "École sec. internationale de St-Lambert",
    "adresse": "675, rue Green",
    "municipalite": "Saint-Lambert",
    "code_postal": "J4P 1V9",
    "lat": 45.50975,
    "lng": -73.50438
  },
  {
    "_id": "307",
    "school_code": "884035",
    "school_name_1": "Centennial",
    "admin_body_number": "884000",
    "admin_body_name": "Commission scolaire Riverside",
    "area_name": "Montérégie ",
    "étudiants": "1087",
    "langue": "anglais",
    "secteur": "public",
    "rang": "229",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "8.3",
    "ehdaa_2024": "35.1",
    "rang_2024": "229/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "73.3",
    "lens_2019": "74.3",
    "lens_2022": "76.0",
    "lens_2023": "75.4",
    "lens_2024": "73.3",
    "lens_trend": "—",
    "lsec_2018": "67.8",
    "lsec_2019": "73.0",
    "lsec_2022": "72.7",
    "lsec_2023": "71.3",
    "lsec_2024": "73.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.2",
    "scie_2019": "73.2",
    "scie_2022": "70.9",
    "scie_2023": "75.5",
    "scie_2024": "73.5",
    "scie_trend": "112233",
    "math_2018": "79.4",
    "math_2019": "84.3",
    "math_2022": "81.5",
    "math_2023": "81.7",
    "math_2024": "86.2",
    "math_trend": "—",
    "echec_2018": "16.1",
    "echec_2019": "12.0",
    "echec_2022": "19.3",
    "echec_2023": "14.0",
    "echec_2024": "15.7",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "1.3",
    "sures_2022": "3.1",
    "sures_2023": "1.9",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 6.4",
    "ecart_sexes_lens_2022": "F 8.2",
    "ecart_sexes_lens_2023": "F 9.8",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.2",
    "ecart_sexes_math_2019": "F 5.3",
    "ecart_sexes_math_2022": "F 7.5",
    "ecart_sexes_math_2023": "F 4.3",
    "ecart_sexes_math_2024": "F 1.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.7",
    "prog_2019": "20.9",
    "prog_2022": "14.9",
    "prog_2023": "20.5",
    "prog_2024": "27.7",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "6.3",
    "cote_2022": "6.2",
    "cote_2023": "6.1",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Centennial",
    "nom_court": "École secondaire régionale Centennial",
    "adresse": "880, rue Hudson",
    "municipalite": "Greenfield Park",
    "code_postal": "J4V 1H1",
    "lat": 45.49185,
    "lng": -73.44672
  },
  {
    "_id": "308",
    "school_code": "885181",
    "school_name_1": "Joliette",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Lanaudière ",
    "étudiants": "287",
    "langue": "anglais",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "27.3",
    "ehdaa_2024": "39.4",
    "rang_2024": "376/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "70.4",
    "lens_2019": "77.7",
    "lens_2022": "73.9",
    "lens_2023": "72.9",
    "lens_2024": "68.9",
    "lens_trend": "—",
    "lsec_2018": "80.7",
    "lsec_2019": "86.5",
    "lsec_2022": "69.7",
    "lsec_2023": "70.1",
    "lsec_2024": "65.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.0",
    "scie_2019": "67.0",
    "scie_2022": "66.0",
    "scie_2023": "62.0",
    "scie_2024": "63.2",
    "scie_trend": "—",
    "math_2018": "65.0",
    "math_2019": "65.9",
    "math_2022": "65.7",
    "math_2023": "57.3",
    "math_2024": "70.4",
    "math_trend": "—",
    "echec_2018": "18.8",
    "echec_2019": "19.3",
    "echec_2022": "28.1",
    "echec_2023": "31.9",
    "echec_2024": "26.2",
    "echec_trend": "—",
    "sures_2018": "2.8",
    "sures_2019": "0.9",
    "sures_2022": "2.3",
    "sures_2023": "5.7",
    "sures_2024": "3.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 6.6",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 7.0",
    "ecart_sexes_lens_2024": "F 3.5",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 14.7",
    "ecart_sexes_math_2019": "M 7.8",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "M 5.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "20.9",
    "prog_2019": "26.6",
    "prog_2022": "17.6",
    "prog_2023": "36.1",
    "prog_2024": "31.4",
    "prog_trend": "—",
    "cote_2018": "5.1",
    "cote_2019": "6.2",
    "cote_2022": "5.7",
    "cote_2023": "4.0",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Joliette",
    "nom_court": "École secondaire de Joliette",
    "adresse": "107, rue de Lorimier",
    "municipalite": "Joliette",
    "code_postal": "J6E 6E8",
    "lat": 46.01425,
    "lng": -73.45214
  },
  {
    "_id": "309",
    "school_code": "885183",
    "school_name_1": "Lake of Two Mountains",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Laurentides ",
    "étudiants": "442",
    "langue": "anglais",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "35.3",
    "rang_2024": "310/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "74.3",
    "lens_2019": "75.7",
    "lens_2022": "71.8",
    "lens_2023": "73.8",
    "lens_2024": "73.5",
    "lens_trend": "—",
    "lsec_2018": "71.2",
    "lsec_2019": "75.0",
    "lsec_2022": "74.5",
    "lsec_2023": "74.9",
    "lsec_2024": "70.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.9",
    "scie_2019": "65.3",
    "scie_2022": "66.6",
    "scie_2023": "61.0",
    "scie_2024": "63.7",
    "scie_trend": "—",
    "math_2018": "78.8",
    "math_2019": "75.3",
    "math_2022": "71.0",
    "math_2023": "62.4",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "18.7",
    "echec_2019": "17.9",
    "echec_2022": "21.5",
    "echec_2023": "28.1",
    "echec_2024": "23.4",
    "echec_trend": "—",
    "sures_2018": "2.6",
    "sures_2019": "2.9",
    "sures_2022": "4.3",
    "sures_2023": "5.5",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.9",
    "ecart_sexes_lens_2019": "F 6.2",
    "ecart_sexes_lens_2022": "F 6.9",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.8",
    "ecart_sexes_math_2019": "F 5.7",
    "ecart_sexes_math_2022": "F 2.5",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "M 16.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.7",
    "prog_2019": "30.9",
    "prog_2022": "21.6",
    "prog_2023": "22.5",
    "prog_2024": "21.4",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.5",
    "cote_2022": "5.4",
    "cote_2023": "4.8",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Lake of Two Mountains",
    "nom_court": "École secondaire Lake of Two Mountains",
    "adresse": "2105, rue Guy",
    "municipalite": "Deux-Montagnes",
    "code_postal": "J7R 1W6",
    "lat": 45.54105,
    "lng": -73.91371
  },
  {
    "_id": "310",
    "school_code": "885184",
    "school_name_1": "Laurentian",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Laurentides ",
    "étudiants": "588",
    "langue": "anglais",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "8.6",
    "ehdaa_2024": "29.6",
    "rang_2024": "335/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "73.3",
    "lens_2019": "74.4",
    "lens_2022": "75.2",
    "lens_2023": "75.1",
    "lens_2024": "71.0",
    "lens_trend": "998855",
    "lsec_2018": "75.9",
    "lsec_2019": "77.6",
    "lsec_2022": "72.8",
    "lsec_2023": "80.3",
    "lsec_2024": "78.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.2",
    "scie_2019": "65.0",
    "scie_2022": "60.5",
    "scie_2023": "66.5",
    "scie_2024": "64.4",
    "scie_trend": "—",
    "math_2018": "61.1",
    "math_2019": "72.0",
    "math_2022": "69.7",
    "math_2023": "61.5",
    "math_2024": "65.9",
    "math_trend": "—",
    "echec_2018": "25.3",
    "echec_2019": "14.5",
    "echec_2022": "26.1",
    "echec_2023": "21.5",
    "echec_2024": "23.6",
    "echec_trend": "—",
    "sures_2018": "5.4",
    "sures_2019": "2.7",
    "sures_2022": "6.9",
    "sures_2023": "5.8",
    "sures_2024": "5.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "E    ",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 5.9",
    "ecart_sexes_lens_2023": "F 11.2",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 12.5",
    "ecart_sexes_math_2022": "F 6.0",
    "ecart_sexes_math_2023": "M 8.9",
    "ecart_sexes_math_2024": "F 3.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "17.2",
    "prog_2019": "26.9",
    "prog_2022": "21.8",
    "prog_2023": "25.8",
    "prog_2024": "23.1",
    "prog_trend": "—",
    "cote_2018": "5.2",
    "cote_2019": "5.4",
    "cote_2022": "5.1",
    "cote_2023": "4.7",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Laurentian",
    "nom_court": "École secondaire régionale Laurentian",
    "adresse": "448, avenue Argenteuil",
    "municipalite": "Lachute",
    "code_postal": "J8H 1W9",
    "lat": 45.64013,
    "lng": -74.34785
  },
  {
    "_id": "311",
    "school_code": "885187",
    "school_name_1": "Rosemere",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Laurentides ",
    "étudiants": "1248",
    "langue": "anglais",
    "secteur": "public",
    "rang": "207",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "7.8",
    "ehdaa_2024": "31.3",
    "rang_2024": "207/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "72.4",
    "lens_2019": "74.0",
    "lens_2022": "69.4",
    "lens_2023": "71.1",
    "lens_2024": "73.7",
    "lens_trend": "—",
    "lsec_2018": "82.8",
    "lsec_2019": "81.9",
    "lsec_2022": "78.6",
    "lsec_2023": "78.4",
    "lsec_2024": "76.7",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.9",
    "scie_2019": "66.1",
    "scie_2022": "63.3",
    "scie_2023": "66.7",
    "scie_2024": "64.3",
    "scie_trend": "—",
    "math_2018": "73.3",
    "math_2019": "72.1",
    "math_2022": "61.1",
    "math_2023": "73.1",
    "math_2024": "74.5",
    "math_trend": "—",
    "echec_2018": "17.1",
    "echec_2019": "14.5",
    "echec_2022": "27.7",
    "echec_2023": "16.6",
    "echec_2024": "15.9",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "1.6",
    "sures_2022": "4.8",
    "sures_2023": "2.1",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.6",
    "ecart_sexes_lens_2019": "F 4.6",
    "ecart_sexes_lens_2022": "F 7.9",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "F 0.1",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "15.9",
    "prog_2019": "10.5",
    "prog_2022": "13.1",
    "prog_2023": "15.7",
    "prog_2024": "15.5",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.5",
    "cote_2022": "5.0",
    "cote_2023": "5.8",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Rosemère",
    "nom_court": "École secondaire de Rosemère",
    "adresse": "530, rue Northcote",
    "municipalite": "Rosemère",
    "code_postal": "J7A 1Y2",
    "lat": 45.64711,
    "lng": -73.78503
  },
  {
    "_id": "312",
    "school_code": "885189",
    "school_name_1": "Ste-Agathe",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Laurentides ",
    "étudiants": "123",
    "langue": "anglais",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "43.9",
    "rang_2024": "260/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "74.0",
    "lens_2022": "78.0",
    "lens_2023": "71.2",
    "lens_2024": "66.8",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "86.2",
    "lsec_2022": "77.2",
    "lsec_2023": "85.5",
    "lsec_2024": "85.9",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "71.5",
    "scie_2022": "63.5",
    "scie_2023": "77.6",
    "scie_2024": "65.5",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "64.4",
    "math_2022": "55.3",
    "math_2023": "80.7",
    "math_2024": "76.0",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "20.5",
    "echec_2022": "26.1",
    "echec_2023": "9.1",
    "echec_2024": "24.5",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "4.1",
    "sures_2022": "4.9",
    "sures_2023": "2.7",
    "sures_2024": "5.8",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 7.3",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "25.7",
    "prog_2022": "27.3",
    "prog_2023": "36.9",
    "prog_2024": "9.5",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.5",
    "cote_2022": "5.5",
    "cote_2023": "5.9",
    "cote_2024": "5.6",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "Académie de Sainte-Agathe",
    "nom_court": "Académie de Sainte-Agathe",
    "adresse": "26, rue Napoléon",
    "municipalite": "Sainte-Agathe-des-Monts",
    "code_postal": "J8C 1Z3",
    "lat": 46.05246,
    "lng": -74.29173
  },
  {
    "_id": "313",
    "school_code": "885190",
    "school_name_1": "Laval Senior",
    "admin_body_number": "885000",
    "admin_body_name": "Commission scolaire Sir-Wilfrid-Laurier",
    "area_name": "Laval ",
    "étudiants": "1300",
    "langue": "anglais",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "259",
    "index": "0.1",
    "en_retard_2024": "10.0",
    "ehdaa_2024": "25.5",
    "rang_2024": "260/470",
    "rang_2019_2024": "259/432",
    "lens_2018": "72.3",
    "lens_2019": "73.1",
    "lens_2022": "71.9",
    "lens_2023": "71.7",
    "lens_2024": "73.9",
    "lens_trend": "—",
    "lsec_2018": "72.7",
    "lsec_2019": "74.0",
    "lsec_2022": "72.4",
    "lsec_2023": "74.0",
    "lsec_2024": "70.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.1",
    "scie_2019": "67.9",
    "scie_2022": "64.1",
    "scie_2023": "69.6",
    "scie_2024": "65.7",
    "scie_trend": "—",
    "math_2018": "70.2",
    "math_2019": "73.0",
    "math_2022": "68.1",
    "math_2023": "66.2",
    "math_2024": "72.2",
    "math_trend": "—",
    "echec_2018": "18.6",
    "echec_2019": "16.4",
    "echec_2022": "22.1",
    "echec_2023": "19.5",
    "echec_2024": "20.3",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.9",
    "sures_2022": "4.5",
    "sures_2023": "2.0",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 8.6",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.3",
    "ecart_sexes_math_2019": "F 1.7",
    "ecart_sexes_math_2022": "F 7.7",
    "ecart_sexes_math_2023": "F 5.5",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.7",
    "prog_2019": "14.7",
    "prog_2022": "13.5",
    "prog_2023": "21.3",
    "prog_2024": "18.4",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "6.1",
    "cote_2022": "5.3",
    "cote_2023": "5.4",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Laval Senior",
    "nom_court": "École secondaire Laval Senior",
    "adresse": "3200, boulevard du Souvenir",
    "municipalite": "Laval",
    "code_postal": "H7V 1W9",
    "lat": 45.55248,
    "lng": -73.74215
  },
  {
    "_id": "314",
    "school_code": "886001",
    "school_name_1": "Philemon Wright",
    "admin_body_number": "886000",
    "admin_body_name": "Commission scolaire Western Québec",
    "area_name": "Outaouais ",
    "étudiants": "782",
    "langue": "anglais",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "11.5",
    "ehdaa_2024": "37.6",
    "rang_2024": "182/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "75.4",
    "lens_2019": "75.3",
    "lens_2022": "74.0",
    "lens_2023": "73.7",
    "lens_2024": "74.3",
    "lens_trend": "—",
    "lsec_2018": "76.3",
    "lsec_2019": "76.3",
    "lsec_2022": "73.6",
    "lsec_2023": "72.9",
    "lsec_2024": "74.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.3",
    "scie_2019": "74.2",
    "scie_2022": "70.1",
    "scie_2023": "73.7",
    "scie_2024": "70.8",
    "scie_trend": "—",
    "math_2018": "79.9",
    "math_2019": "83.4",
    "math_2022": "81.0",
    "math_2023": "84.1",
    "math_2024": "88.8",
    "math_trend": "112233",
    "echec_2018": "11.6",
    "echec_2019": "9.1",
    "echec_2022": "14.1",
    "echec_2023": "10.8",
    "echec_2024": "13.2",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.1",
    "sures_2022": "1.0",
    "sures_2023": "0.7",
    "sures_2024": "2.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 7.9",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 8.8",
    "ecart_sexes_lens_2023": "F 8.0",
    "ecart_sexes_lens_2024": "F 7.7",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 1.0",
    "ecart_sexes_math_2019": "F 4.5",
    "ecart_sexes_math_2022": "F 3.5",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "M 6.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "30.8",
    "prog_2019": "36.0",
    "prog_2022": "24.2",
    "prog_2023": "30.5",
    "prog_2024": "31.5",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.6",
    "cote_2022": "6.3",
    "cote_2023": "6.4",
    "cote_2024": "6.3",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Philemon Wright",
    "nom_court": "École secondaire Philemon Wright",
    "adresse": "80, rue Daniel Johnson",
    "municipalite": "Gatineau",
    "code_postal": "J8Z 1S3",
    "lat": 45.46595,
    "lng": -75.74889
  },
  {
    "_id": "315",
    "school_code": "886002",
    "school_name_1": "Pontiac",
    "admin_body_number": "886000",
    "admin_body_name": "Commission scolaire Western Québec",
    "area_name": "Outaouais ",
    "étudiants": "409",
    "langue": "anglais",
    "secteur": "public",
    "rang": "376",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "22.2",
    "ehdaa_2024": "43.5",
    "rang_2024": "376/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "72.2",
    "lens_2019": "69.6",
    "lens_2022": "70.5",
    "lens_2023": "72.6",
    "lens_2024": "72.9",
    "lens_trend": "—",
    "lsec_2018": "73.2",
    "lsec_2019": "70.9",
    "lsec_2022": "67.4",
    "lsec_2023": "69.2",
    "lsec_2024": "69.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.0",
    "scie_2019": "59.5",
    "scie_2022": "61.3",
    "scie_2023": "63.5",
    "scie_2024": "61.1",
    "scie_trend": "112233",
    "math_2018": "63.3",
    "math_2019": "55.6",
    "math_2022": "60.0",
    "math_2023": "66.4",
    "math_2024": "75.1",
    "math_trend": "—",
    "echec_2018": "28.3",
    "echec_2019": "38.5",
    "echec_2022": "34.5",
    "echec_2023": "26.0",
    "echec_2024": "27.2",
    "echec_trend": "—",
    "sures_2018": "1.8",
    "sures_2019": "1.5",
    "sures_2022": "3.3",
    "sures_2023": "0.9",
    "sures_2024": "1.5",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "M 1.5",
    "ecart_sexes_lens_2019": "F 1.0",
    "ecart_sexes_lens_2022": "F 11.1",
    "ecart_sexes_lens_2023": "F 3.2",
    "ecart_sexes_lens_2024": "F 6.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.3",
    "ecart_sexes_math_2019": "F 0.8",
    "ecart_sexes_math_2022": "M 4.2",
    "ecart_sexes_math_2023": "M 4.7",
    "ecart_sexes_math_2024": "M 13.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "40.3",
    "prog_2019": "42.8",
    "prog_2022": "28.0",
    "prog_2023": "49.3",
    "prog_2024": "49.0",
    "prog_trend": "—",
    "cote_2018": "4.5",
    "cote_2019": "3.8",
    "cote_2022": "4.2",
    "cote_2023": "4.6",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Pontiac",
    "nom_court": "École secondaire Pontiac",
    "adresse": "455, rue Maple",
    "municipalite": "Shawville",
    "code_postal": "J0X 2Y0",
    "lat": 45.60928,
    "lng": -76.4933
  },
  {
    "_id": "316",
    "school_code": "886004",
    "school_name_1": "D'Arcy McGee",
    "admin_body_number": "886000",
    "admin_body_name": "Commission scolaire Western Québec",
    "area_name": "Outaouais ",
    "étudiants": "670",
    "langue": "anglais",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "12.8",
    "ehdaa_2024": "39.9",
    "rang_2024": "182/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "76.1",
    "lens_2019": "73.1",
    "lens_2022": "74.0",
    "lens_2023": "73.8",
    "lens_2024": "74.5",
    "lens_trend": "—",
    "lsec_2018": "73.9",
    "lsec_2019": "72.3",
    "lsec_2022": "72.6",
    "lsec_2023": "73.3",
    "lsec_2024": "72.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "66.0",
    "scie_2019": "66.4",
    "scie_2022": "68.6",
    "scie_2023": "69.1",
    "scie_2024": "66.7",
    "scie_trend": "112233",
    "math_2018": "75.6",
    "math_2019": "77.9",
    "math_2022": "74.5",
    "math_2023": "75.5",
    "math_2024": "81.3",
    "math_trend": "—",
    "echec_2018": "15.5",
    "echec_2019": "16.5",
    "echec_2022": "17.4",
    "echec_2023": "17.9",
    "echec_2024": "16.0",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.1",
    "sures_2022": "1.0",
    "sures_2023": "0.3",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 2.5",
    "ecart_sexes_lens_2022": "F 8.8",
    "ecart_sexes_lens_2023": "F 5.3",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "M 0.2",
    "ecart_sexes_math_2022": "F 0.7",
    "ecart_sexes_math_2023": "F 5.9",
    "ecart_sexes_math_2024": "F 1.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "29.9",
    "prog_2019": "28.6",
    "prog_2022": "25.0",
    "prog_2023": "32.8",
    "prog_2024": "29.6",
    "prog_trend": "—",
    "cote_2018": "6.3",
    "cote_2019": "6.1",
    "cote_2022": "6.2",
    "cote_2023": "5.9",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire D'Arcy McGee",
    "nom_court": "École secondaire D'Arcy McGee",
    "adresse": "925, boulevard du Plateau",
    "municipalite": "Gatineau",
    "code_postal": "J9J 3G2",
    "lat": 45.42251,
    "lng": -75.8061
  },
  {
    "_id": "317",
    "school_code": "886006",
    "school_name_1": "Golden Valley",
    "admin_body_number": "886000",
    "admin_body_name": "Commission scolaire Western Québec",
    "area_name": "Abitibi-Témiscamingue ",
    "étudiants": "94",
    "langue": "anglais",
    "secteur": "public",
    "rang": "420",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "18.8",
    "ehdaa_2024": "40.4",
    "rang_2024": "420/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "74.3",
    "lens_2024": "73.8",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "83.7",
    "lsec_2024": "74.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "61.2",
    "scie_2024": "54.2",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "61.8",
    "math_2024": "74.3",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "32.0",
    "echec_2024": "29.2",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "6.6",
    "sures_2024": "8.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "70.4",
    "prog_2024": "45.5",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "3.4",
    "cote_2024": "4.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Golden Valley",
    "nom_court": "École Golden Valley",
    "adresse": "980, 7e Rue",
    "municipalite": "Val-d'Or",
    "code_postal": "J9P 3P8",
    "lat": 48.0992,
    "lng": -77.78973
  },
  {
    "_id": "318",
    "school_code": "886012",
    "school_name_1": "Saint-Michael",
    "admin_body_number": "886000",
    "admin_body_name": "Commission scolaire Western Québec",
    "area_name": "Outaouais ",
    "étudiants": "196",
    "langue": "anglais",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "51.5",
    "rang_2024": "260/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "69.5",
    "lens_2022": "71.8",
    "lens_2023": "72.7",
    "lens_2024": "73.0",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "76.7",
    "lsec_2022": "76.0",
    "lsec_2023": "71.2",
    "lsec_2024": "70.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "65.6",
    "scie_2022": "74.2",
    "scie_2023": "76.5",
    "scie_2024": "62.6",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "62.0",
    "math_2022": "72.7",
    "math_2023": "75.5",
    "math_2024": "72.3",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "28.9",
    "echec_2022": "16.9",
    "echec_2023": "14.9",
    "echec_2024": "23.9",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "3.9",
    "sures_2022": "1.2",
    "sures_2023": "2.9",
    "sures_2024": "2.7",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "M 4.2",
    "ecart_sexes_lens_2024": "F 3.5",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "M 10.5",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "22.0",
    "prog_2022": "22.9",
    "prog_2023": "33.6",
    "prog_2024": "23.8",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "4.6",
    "cote_2022": "6.5",
    "cote_2023": "5.7",
    "cote_2024": "5.6",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Michael",
    "nom_court": "École secondaire Saint-Michael",
    "adresse": "26, rue Principale",
    "municipalite": "Low",
    "code_postal": "J0X 2C0",
    "lat": 45.80982,
    "lng": -75.94759
  },
  {
    "_id": "319",
    "school_code": "887046",
    "school_name_1": "Royal Vale",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "497",
    "langue": "anglais",
    "secteur": "public",
    "rang": "109",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "7.2",
    "ehdaa_2024": "22.7",
    "rang_2024": "109/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "76.5",
    "lens_2019": "76.6",
    "lens_2022": "80.0",
    "lens_2023": "76.4",
    "lens_2024": "76.4",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "75.3",
    "lsec_2022": "76.4",
    "lsec_2023": "77.2",
    "lsec_2024": "75.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.1",
    "scie_2019": "79.9",
    "scie_2022": "75.1",
    "scie_2023": "77.0",
    "scie_2024": "75.7",
    "scie_trend": "—",
    "math_2018": "79.0",
    "math_2019": "84.7",
    "math_2022": "82.0",
    "math_2023": "77.0",
    "math_2024": "79.3",
    "math_trend": "—",
    "echec_2018": "6.3",
    "echec_2019": "6.0",
    "echec_2022": "8.0",
    "echec_2023": "10.5",
    "echec_2024": "8.3",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "1.4",
    "sures_2022": "1.7",
    "sures_2023": "0.1",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 0.5",
    "ecart_sexes_lens_2019": "F 5.8",
    "ecart_sexes_lens_2022": "F 4.1",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 6.0",
    "ecart_sexes_math_2019": "F 0.6",
    "ecart_sexes_math_2022": "M 5.3",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 0.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "14.9",
    "prog_2019": "7.8",
    "prog_2022": "8.8",
    "prog_2023": "11.3",
    "prog_2024": "5.5",
    "prog_trend": "112233",
    "cote_2018": "7.5",
    "cote_2019": "7.0",
    "cote_2022": "7.6",
    "cote_2023": "7.1",
    "cote_2024": "7.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Royal Vale",
    "nom_court": "École Royal Vale",
    "adresse": "5851, avenue Somerled",
    "municipalite": "Montréal",
    "code_postal": "H3X 2A5",
    "lat": 45.47539,
    "lng": -73.63381
  },
  {
    "_id": "320",
    "school_code": "887047",
    "school_name_1": "F.A.C.E.",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "138",
    "langue": "anglais",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "8.3",
    "ehdaa_2024": "29.7",
    "rang_2024": "277/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "68.6",
    "lens_2019": "75.1",
    "lens_2022": "73.8",
    "lens_2023": "78.2",
    "lens_2024": "75.0",
    "lens_trend": "—",
    "lsec_2018": "77.5",
    "lsec_2019": "76.8",
    "lsec_2022": "69.2",
    "lsec_2023": "69.6",
    "lsec_2024": "72.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.4",
    "scie_2019": "76.0",
    "scie_2022": "64.9",
    "scie_2023": "74.3",
    "scie_2024": "67.6",
    "scie_trend": "—",
    "math_2018": "82.7",
    "math_2019": "87.6",
    "math_2022": "77.0",
    "math_2023": "79.9",
    "math_2024": "82.3",
    "math_trend": "—",
    "echec_2018": "9.4",
    "echec_2019": "6.9",
    "echec_2022": "21.8",
    "echec_2023": "13.8",
    "echec_2024": "14.2",
    "echec_trend": "—",
    "sures_2018": "3.6",
    "sures_2019": "1.8",
    "sures_2022": "3.8",
    "sures_2023": "3.9",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 8.3",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 4.8",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 0.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "6.3",
    "prog_2019": "16.1",
    "prog_2022": "7.1",
    "prog_2023": "12.0",
    "prog_2024": "34.4",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "7.0",
    "cote_2022": "6.1",
    "cote_2023": "6.2",
    "cote_2024": "5.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École F.A.C.E.",
    "nom_court": "École F.A.C.E.",
    "adresse": "3449, rue Université",
    "municipalite": "Montréal",
    "code_postal": "H3A 2A8",
    "lat": 45.505896,
    "lng": -73.574866
  },
  {
    "_id": "321",
    "school_code": "887101",
    "school_name_1": "James Lyng",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "152",
    "langue": "anglais",
    "secteur": "public",
    "rang": "442",
    "rang_5_ans": "431",
    "index": "0.1",
    "en_retard_2024": "35.3",
    "ehdaa_2024": "85.5",
    "rang_2024": "442/470",
    "rang_2019_2024": "431/432",
    "lens_2018": "67.0",
    "lens_2019": "65.2",
    "lens_2022": "65.5",
    "lens_2023": "63.2",
    "lens_2024": "68.2",
    "lens_trend": "—",
    "lsec_2018": "70.8",
    "lsec_2019": "68.0",
    "lsec_2022": "61.9",
    "lsec_2023": "53.9",
    "lsec_2024": "61.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "48.4",
    "scie_2019": "47.6",
    "scie_2022": "52.2",
    "scie_2023": "54.7",
    "scie_2024": "61.3",
    "scie_trend": "112233",
    "math_2018": "37.2",
    "math_2019": "33.0",
    "math_2022": "45.6",
    "math_2023": "58.7",
    "math_2024": "77.3",
    "math_trend": "112233",
    "echec_2018": "44.6",
    "echec_2019": "59.3",
    "echec_2022": "57.6",
    "echec_2023": "53.0",
    "echec_2024": "30.1",
    "echec_trend": "—",
    "sures_2018": "7.4",
    "sures_2019": "10.4",
    "sures_2022": "13.2",
    "sures_2023": "9.7",
    "sures_2024": "3.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "74.4",
    "prog_2019": "70.9",
    "prog_2022": "42.2",
    "prog_2023": "38.2",
    "prog_2024": "68.4",
    "prog_trend": "—",
    "cote_2018": "0.6",
    "cote_2019": "0.0",
    "cote_2022": "0.9",
    "cote_2023": "1.2",
    "cote_2024": "3.4",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École secondaire James Lyng",
    "nom_court": "École secondaire James Lyng",
    "adresse": "5440, rue Notre-Dame Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4C 1T9",
    "lat": 45.46797,
    "lng": -73.59609
  },
  {
    "_id": "322",
    "school_code": "887102",
    "school_name_1": "John F. Kennedy",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "294",
    "langue": "anglais",
    "secteur": "public",
    "rang": "433",
    "rang_5_ans": "409",
    "index": "0.1",
    "en_retard_2024": "44.8",
    "ehdaa_2024": "64.6",
    "rang_2024": "433/470",
    "rang_2019_2024": "409/432",
    "lens_2018": "64.9",
    "lens_2019": "70.6",
    "lens_2022": "67.1",
    "lens_2023": "66.2",
    "lens_2024": "66.0",
    "lens_trend": "—",
    "lsec_2018": "70.9",
    "lsec_2019": "75.6",
    "lsec_2022": "68.7",
    "lsec_2023": "67.4",
    "lsec_2024": "68.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.8",
    "scie_2019": "63.4",
    "scie_2022": "65.0",
    "scie_2023": "64.0",
    "scie_2024": "55.8",
    "scie_trend": "—",
    "math_2018": "70.3",
    "math_2019": "59.8",
    "math_2022": "60.8",
    "math_2023": "48.7",
    "math_2024": "71.1",
    "math_trend": "—",
    "echec_2018": "23.3",
    "echec_2019": "21.2",
    "echec_2022": "27.4",
    "echec_2023": "33.8",
    "echec_2024": "24.0",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "2.9",
    "sures_2022": "7.4",
    "sures_2023": "9.0",
    "sures_2024": "7.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 0.7",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 7.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.7",
    "ecart_sexes_math_2019": "M 6.1",
    "ecart_sexes_math_2022": "F 8.9",
    "ecart_sexes_math_2023": "M 8.6",
    "ecart_sexes_math_2024": "F 4.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "53.4",
    "prog_2019": "38.6",
    "prog_2022": "31.6",
    "prog_2023": "29.9",
    "prog_2024": "34.6",
    "prog_trend": "112233",
    "cote_2018": "3.9",
    "cote_2019": "4.6",
    "cote_2022": "4.0",
    "cote_2023": "2.7",
    "cote_2024": "3.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire John F. Kennedy",
    "nom_court": "École secondaire John F. Kennedy",
    "adresse": "3030, rue Villeray",
    "municipalite": "Montréal",
    "code_postal": "H2A 1E7",
    "lat": 45.55982,
    "lng": -73.60406
  },
  {
    "_id": "323",
    "school_code": "887104",
    "school_name_1": "LaurenHill",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "1049",
    "langue": "anglais",
    "secteur": "public",
    "rang": "260",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "11.4",
    "ehdaa_2024": "33.9",
    "rang_2024": "260/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "71.1",
    "lens_2019": "72.4",
    "lens_2022": "72.4",
    "lens_2023": "72.9",
    "lens_2024": "70.6",
    "lens_trend": "998855",
    "lsec_2018": "70.0",
    "lsec_2019": "73.9",
    "lsec_2022": "73.3",
    "lsec_2023": "74.5",
    "lsec_2024": "73.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.8",
    "scie_2019": "72.2",
    "scie_2022": "70.5",
    "scie_2023": "74.8",
    "scie_2024": "64.2",
    "scie_trend": "—",
    "math_2018": "74.0",
    "math_2019": "77.9",
    "math_2022": "72.5",
    "math_2023": "72.4",
    "math_2024": "76.8",
    "math_trend": "—",
    "echec_2018": "15.9",
    "echec_2019": "12.6",
    "echec_2022": "19.1",
    "echec_2023": "13.2",
    "echec_2024": "18.5",
    "echec_trend": "—",
    "sures_2018": "3.0",
    "sures_2019": "2.6",
    "sures_2022": "5.4",
    "sures_2023": "2.5",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.6",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 3.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.9",
    "ecart_sexes_math_2019": "F 7.1",
    "ecart_sexes_math_2022": "M 5.2",
    "ecart_sexes_math_2023": "M 1.6",
    "ecart_sexes_math_2024": "F 6.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "8.6",
    "prog_2019": "7.4",
    "prog_2022": "5.9",
    "prog_2023": "9.7",
    "prog_2024": "8.8",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "6.2",
    "cote_2022": "6.0",
    "cote_2023": "6.3",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie LaurenHill",
    "nom_court": "Académie LaurenHill",
    "adresse": "2505, boulevard Côte-Vertu",
    "municipalite": "Saint-Laurent",
    "code_postal": "H4R 1P3",
    "lat": 45.50434,
    "lng": -73.69854
  },
  {
    "_id": "324",
    "school_code": "887105",
    "school_name_1": "Laurier MacDonald",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "628",
    "langue": "anglais",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "2.3",
    "ehdaa_2024": "33.9",
    "rang_2024": "277/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "72.0",
    "lens_2019": "69.5",
    "lens_2022": "73.6",
    "lens_2023": "73.4",
    "lens_2024": "73.1",
    "lens_trend": "—",
    "lsec_2018": "70.5",
    "lsec_2019": "70.3",
    "lsec_2022": "74.5",
    "lsec_2023": "73.5",
    "lsec_2024": "74.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.3",
    "scie_2019": "72.6",
    "scie_2022": "61.2",
    "scie_2023": "68.9",
    "scie_2024": "67.1",
    "scie_trend": "—",
    "math_2018": "75.5",
    "math_2019": "71.5",
    "math_2022": "65.7",
    "math_2023": "76.0",
    "math_2024": "69.6",
    "math_trend": "—",
    "echec_2018": "13.9",
    "echec_2019": "17.8",
    "echec_2022": "27.8",
    "echec_2023": "14.7",
    "echec_2024": "19.1",
    "echec_trend": "—",
    "sures_2018": "2.6",
    "sures_2019": "1.7",
    "sures_2022": "5.3",
    "sures_2023": "2.2",
    "sures_2024": "4.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.8",
    "ecart_sexes_lens_2019": "F 1.6",
    "ecart_sexes_lens_2022": "F 9.0",
    "ecart_sexes_lens_2023": "F 7.4",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "E    ",
    "ecart_sexes_math_2019": "F 10.9",
    "ecart_sexes_math_2022": "F 5.8",
    "ecart_sexes_math_2023": "F 0.3",
    "ecart_sexes_math_2024": "F 8.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "12.8",
    "prog_2019": "7.3",
    "prog_2022": "15.5",
    "prog_2023": "8.9",
    "prog_2024": "19.5",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "5.6",
    "cote_2022": "5.1",
    "cote_2023": "6.2",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Laurier Macdonald",
    "nom_court": "École secondaire Laurier Macdonald",
    "adresse": "7355, boulevard Viau",
    "municipalite": "Montréal",
    "code_postal": "H1S 3C2",
    "lat": 45.57684,
    "lng": -73.58549
  },
  {
    "_id": "325",
    "school_code": "887106",
    "school_name_1": "Lester B. Pearson",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "928",
    "langue": "anglais",
    "secteur": "public",
    "rang": "299",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "2.5",
    "ehdaa_2024": "31.5",
    "rang_2024": "299/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "67.4",
    "lens_2019": "69.2",
    "lens_2022": "68.3",
    "lens_2023": "70.0",
    "lens_2024": "68.3",
    "lens_trend": "—",
    "lsec_2018": "72.8",
    "lsec_2019": "78.7",
    "lsec_2022": "77.0",
    "lsec_2023": "77.0",
    "lsec_2024": "75.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.7",
    "scie_2019": "67.8",
    "scie_2022": "67.7",
    "scie_2023": "68.0",
    "scie_2024": "66.7",
    "scie_trend": "—",
    "math_2018": "64.9",
    "math_2019": "65.8",
    "math_2022": "66.7",
    "math_2023": "72.3",
    "math_2024": "68.1",
    "math_trend": "—",
    "echec_2018": "21.8",
    "echec_2019": "16.4",
    "echec_2022": "22.3",
    "echec_2023": "17.2",
    "echec_2024": "21.8",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "1.5",
    "sures_2022": "4.5",
    "sures_2023": "2.3",
    "sures_2024": "4.0",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 6.1",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 3.1",
    "ecart_sexes_math_2019": "F 3.2",
    "ecart_sexes_math_2022": "F 7.4",
    "ecart_sexes_math_2023": "F 5.3",
    "ecart_sexes_math_2024": "F 5.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "18.9",
    "prog_2019": "26.9",
    "prog_2022": "5.6",
    "prog_2023": "11.8",
    "prog_2024": "7.5",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.4",
    "cote_2022": "5.4",
    "cote_2023": "5.7",
    "cote_2024": "5.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Lester B. Pearson",
    "nom_court": "École secondaire Lester B. Pearson",
    "adresse": "11575, rue P.M. Favier",
    "municipalite": "Montréal-Nord",
    "code_postal": "H1G 6E5",
    "lat": 45.61048,
    "lng": -73.61688
  },
  {
    "_id": "326",
    "school_code": "887107",
    "school_name_1": "M.I.N.D.",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "60",
    "langue": "anglais",
    "secteur": "public",
    "rang": "112",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "12.5",
    "ehdaa_2024": "20",
    "rang_2024": "112/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "81.5",
    "lens_2022": "80.2",
    "lens_2023": "nd",
    "lens_2024": "80.8",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "84.1",
    "lsec_2022": "79.6",
    "lsec_2023": "nd",
    "lsec_2024": "80.0",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "69.5",
    "scie_2022": "72.9",
    "scie_2023": "nd",
    "scie_2024": "74.1",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "58.5",
    "math_2022": "78.0",
    "math_2023": "nd",
    "math_2024": "78.8",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "16.9",
    "echec_2022": "15.2",
    "echec_2023": "nd",
    "echec_2024": "10.7",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "1.1",
    "sures_2022": "5.8",
    "sures_2023": "nd",
    "sures_2024": "6.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "61.9",
    "prog_2022": "52.9",
    "prog_2023": "nd",
    "prog_2024": "7.1",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.7",
    "cote_2022": "5.8",
    "cote_2023": "nd",
    "cote_2024": "7.1",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire M.I.N.D.",
    "nom_court": "École secondaire M.I.N.D.",
    "adresse": "4563, rue Saint-Urbain",
    "municipalite": "Montréal",
    "code_postal": "H2T 2V9",
    "lat": 45.51964,
    "lng": -73.58844
  },
  {
    "_id": "327",
    "school_code": "887108",
    "school_name_1": "Marymount",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "481",
    "langue": "anglais",
    "secteur": "public",
    "rang": "335",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "29.1",
    "ehdaa_2024": "29.9",
    "rang_2024": "335/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "70.7",
    "lens_2019": "71.7",
    "lens_2022": "71.1",
    "lens_2023": "75.6",
    "lens_2024": "73.8",
    "lens_trend": "—",
    "lsec_2018": "65.4",
    "lsec_2019": "70.1",
    "lsec_2022": "67.4",
    "lsec_2023": "72.7",
    "lsec_2024": "67.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "68.2",
    "scie_2019": "72.8",
    "scie_2022": "70.3",
    "scie_2023": "70.0",
    "scie_2024": "65.3",
    "scie_trend": "—",
    "math_2018": "66.1",
    "math_2019": "73.3",
    "math_2022": "71.3",
    "math_2023": "71.3",
    "math_2024": "70.5",
    "math_trend": "—",
    "echec_2018": "25.7",
    "echec_2019": "20.8",
    "echec_2022": "23.9",
    "echec_2023": "20.1",
    "echec_2024": "24.7",
    "echec_trend": "—",
    "sures_2018": "3.7",
    "sures_2019": "2.4",
    "sures_2022": "3.0",
    "sures_2023": "0.5",
    "sures_2024": "4.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 0.1",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 2.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.5",
    "ecart_sexes_math_2019": "M 10.5",
    "ecart_sexes_math_2022": "M 5.1",
    "ecart_sexes_math_2023": "F 4.1",
    "ecart_sexes_math_2024": "M 4.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "35.5",
    "prog_2019": "39.9",
    "prog_2022": "27.5",
    "prog_2023": "42.1",
    "prog_2024": "33.0",
    "prog_trend": "—",
    "cote_2018": "4.3",
    "cote_2019": "5.0",
    "cote_2022": "5.3",
    "cote_2023": "5.6",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Internationale Marymount",
    "nom_court": "Académie Internationale Marymount",
    "adresse": "5100, chemin de la Côte-Saint-Luc",
    "municipalite": "Montréal",
    "code_postal": "H3W 2G9",
    "lat": 45.48217,
    "lng": -73.62004
  },
  {
    "_id": "328",
    "school_code": "887110",
    "school_name_1": "Rosemount",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "454",
    "langue": "anglais",
    "secteur": "public",
    "rang": "348",
    "rang_5_ans": "293",
    "index": "0.1",
    "en_retard_2024": "15.4",
    "ehdaa_2024": "38.8",
    "rang_2024": "348/470",
    "rang_2019_2024": "293/432",
    "lens_2018": "68.9",
    "lens_2019": "70.0",
    "lens_2022": "69.4",
    "lens_2023": "70.6",
    "lens_2024": "72.4",
    "lens_trend": "—",
    "lsec_2018": "71.5",
    "lsec_2019": "75.7",
    "lsec_2022": "70.1",
    "lsec_2023": "71.8",
    "lsec_2024": "70.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.4",
    "scie_2019": "67.6",
    "scie_2022": "63.8",
    "scie_2023": "71.9",
    "scie_2024": "66.6",
    "scie_trend": "—",
    "math_2018": "79.4",
    "math_2019": "74.9",
    "math_2022": "69.1",
    "math_2023": "74.7",
    "math_2024": "69.2",
    "math_trend": "998855",
    "echec_2018": "16.9",
    "echec_2019": "17.2",
    "echec_2022": "26.6",
    "echec_2023": "19.9",
    "echec_2024": "21.7",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.9",
    "sures_2022": "1.3",
    "sures_2023": "0.4",
    "sures_2024": "4.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 1.3",
    "ecart_sexes_lens_2022": "F 4.2",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.9",
    "ecart_sexes_math_2019": "M 0.6",
    "ecart_sexes_math_2022": "F 14.4",
    "ecart_sexes_math_2023": "M 1.1",
    "ecart_sexes_math_2024": "M 4.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.9",
    "prog_2019": "35.7",
    "prog_2022": "26.9",
    "prog_2023": "36.0",
    "prog_2024": "35.5",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "5.3",
    "cote_2022": "4.7",
    "cote_2023": "5.4",
    "cote_2024": "4.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Rosemont",
    "nom_court": "École secondaire Rosemont",
    "adresse": "3737, rue Beaubien Est",
    "municipalite": "Montréal",
    "code_postal": "H1X 1H2",
    "lat": 45.55965,
    "lng": -73.58468
  },
  {
    "_id": "329",
    "school_code": "887111",
    "school_name_1": "Royal West",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "860",
    "langue": "anglais",
    "secteur": "public",
    "rang": "40",
    "rang_5_ans": "26",
    "index": "0.1",
    "en_retard_2024": "1.1",
    "ehdaa_2024": "9.2",
    "rang_2024": "40/470",
    "rang_2019_2024": "26/432",
    "lens_2018": "81.5",
    "lens_2019": "82.0",
    "lens_2022": "85.0",
    "lens_2023": "81.9",
    "lens_2024": "82.8",
    "lens_trend": "—",
    "lsec_2018": "85.0",
    "lsec_2019": "86.9",
    "lsec_2022": "88.1",
    "lsec_2023": "83.6",
    "lsec_2024": "84.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "85.3",
    "scie_2019": "86.2",
    "scie_2022": "84.6",
    "scie_2023": "91.7",
    "scie_2024": "85.2",
    "scie_trend": "—",
    "math_2018": "85.6",
    "math_2019": "85.1",
    "math_2022": "83.9",
    "math_2023": "89.2",
    "math_2024": "85.8",
    "math_trend": "—",
    "echec_2018": "2.4",
    "echec_2019": "2.8",
    "echec_2022": "2.9",
    "echec_2023": "2.5",
    "echec_2024": "3.0",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "0.7",
    "sures_2022": "1.8",
    "sures_2023": "1.5",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 2.3",
    "ecart_sexes_lens_2023": "F 2.1",
    "ecart_sexes_lens_2024": "F 4.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.4",
    "ecart_sexes_math_2019": "F 4.8",
    "ecart_sexes_math_2022": "M 0.1",
    "ecart_sexes_math_2023": "M 0.6",
    "ecart_sexes_math_2024": "M 0.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.2",
    "prog_2019": "0.0",
    "prog_2022": "2.2",
    "prog_2023": "2.2",
    "prog_2024": "2.2",
    "prog_trend": "—",
    "cote_2018": "9.1",
    "cote_2019": "8.7",
    "cote_2022": "9.2",
    "cote_2023": "8.6",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Royal West",
    "nom_court": "Académie Royal West",
    "adresse": "189, avenue Easton",
    "municipalite": "Montréal-Ouest",
    "code_postal": "H4X 1L4",
    "lat": 45.45017,
    "lng": -73.64329
  },
  {
    "_id": "330",
    "school_code": "887114",
    "school_name_1": "Vincent Massey",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "801",
    "langue": "anglais",
    "secteur": "public",
    "rang": "80",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "7.9",
    "rang_2024": "80/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "76.5",
    "lens_2019": "76.8",
    "lens_2022": "78.7",
    "lens_2023": "78.4",
    "lens_2024": "76.5",
    "lens_trend": "—",
    "lsec_2018": "83.8",
    "lsec_2019": "87.6",
    "lsec_2022": "87.7",
    "lsec_2023": "84.5",
    "lsec_2024": "82.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.0",
    "scie_2019": "81.7",
    "scie_2022": "80.6",
    "scie_2023": "87.1",
    "scie_2024": "81.8",
    "scie_trend": "112233",
    "math_2018": "79.7",
    "math_2019": "85.7",
    "math_2022": "84.6",
    "math_2023": "87.7",
    "math_2024": "82.7",
    "math_trend": "—",
    "echec_2018": "4.4",
    "echec_2019": "2.2",
    "echec_2022": "4.4",
    "echec_2023": "3.5",
    "echec_2024": "4.2",
    "echec_trend": "998855",
    "sures_2018": "0.6",
    "sures_2019": "0.0",
    "sures_2022": "1.1",
    "sures_2023": "1.6",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 0.1",
    "ecart_sexes_lens_2019": "F 4.5",
    "ecart_sexes_lens_2022": "F 5.7",
    "ecart_sexes_lens_2023": "F 6.0",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.0",
    "ecart_sexes_math_2019": "F 0.5",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 4.6",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "0.6",
    "prog_2022": "0.6",
    "prog_2023": "0.0",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.3",
    "cote_2022": "8.5",
    "cote_2023": "8.0",
    "cote_2024": "7.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Vincent Massey",
    "nom_court": "Collège Vincent Massey",
    "adresse": "5925, 27e Avenue",
    "municipalite": "Montréal",
    "code_postal": "H1T 3J5",
    "lat": 45.56427,
    "lng": -73.5721
  },
  {
    "_id": "331",
    "school_code": "887116",
    "school_name_1": "Westmount",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "835",
    "langue": "anglais",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "11.3",
    "ehdaa_2024": "34",
    "rang_2024": "182/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "71.4",
    "lens_2019": "72.4",
    "lens_2022": "73.0",
    "lens_2023": "74.2",
    "lens_2024": "73.7",
    "lens_trend": "—",
    "lsec_2018": "73.6",
    "lsec_2019": "76.5",
    "lsec_2022": "74.4",
    "lsec_2023": "76.8",
    "lsec_2024": "76.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "69.4",
    "scie_2019": "72.5",
    "scie_2022": "70.7",
    "scie_2023": "78.6",
    "scie_2024": "70.1",
    "scie_trend": "—",
    "math_2018": "74.9",
    "math_2019": "75.5",
    "math_2022": "68.7",
    "math_2023": "77.5",
    "math_2024": "75.8",
    "math_trend": "—",
    "echec_2018": "15.8",
    "echec_2019": "11.9",
    "echec_2022": "17.1",
    "echec_2023": "10.8",
    "echec_2024": "15.6",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.0",
    "sures_2022": "1.2",
    "sures_2023": "0.2",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 0.8",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 3.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.2",
    "ecart_sexes_math_2019": "M 3.3",
    "ecart_sexes_math_2022": "M 5.5",
    "ecart_sexes_math_2023": "M 0.2",
    "ecart_sexes_math_2024": "F 4.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "26.7",
    "prog_2019": "25.6",
    "prog_2022": "15.9",
    "prog_2023": "21.5",
    "prog_2024": "18.8",
    "prog_trend": "112233",
    "cote_2018": "6.0",
    "cote_2019": "6.3",
    "cote_2022": "6.0",
    "cote_2023": "6.9",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Westmount",
    "nom_court": "École secondaire Westmount",
    "adresse": "4350, rue Sainte-Catherine Ouest",
    "municipalite": "Westmount",
    "code_postal": "H3Z 1R1",
    "lat": 45.48336,
    "lng": -73.58978
  },
  {
    "_id": "332",
    "school_code": "887203",
    "school_name_1": "Options",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "31",
    "langue": "anglais",
    "secteur": "public",
    "rang": "390",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "78.9",
    "ehdaa_2024": "83.9",
    "rang_2024": "390/470",
    "rang_2019_2024": "nd",
    "lens_2018": "63.9",
    "lens_2019": "65.3",
    "lens_2022": "70.6",
    "lens_2023": "nd",
    "lens_2024": "67.2",
    "lens_trend": "nd",
    "lsec_2018": "69.9",
    "lsec_2019": "67.3",
    "lsec_2022": "68.6",
    "lsec_2023": "nd",
    "lsec_2024": "67.7",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.7",
    "scie_2019": "60.9",
    "scie_2022": "52.6",
    "scie_2023": "nd",
    "scie_2024": "63.5",
    "scie_trend": "nd",
    "math_2018": "53.3",
    "math_2019": "50.7",
    "math_2022": "52.7",
    "math_2023": "nd",
    "math_2024": "72.7",
    "math_trend": "nd",
    "echec_2018": "28.5",
    "echec_2019": "29.9",
    "echec_2022": "32.2",
    "echec_2023": "nd",
    "echec_2024": "21.4",
    "echec_trend": "nd",
    "sures_2018": "5.7",
    "sures_2019": "5.6",
    "sures_2022": "11.5",
    "sures_2023": "nd",
    "sures_2024": "3.0",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "55.1",
    "prog_2019": "49.4",
    "prog_2022": "37.8",
    "prog_2023": "nd",
    "prog_2024": "46.2",
    "prog_trend": "nd",
    "cote_2018": "2.9",
    "cote_2019": "2.2",
    "cote_2022": "3.2",
    "cote_2023": "nd",
    "cote_2024": "4.4",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Options",
    "nom_court": "École secondaire Options",
    "adresse": "1741, rue de Biencourt",
    "municipalite": "Montréal",
    "code_postal": "H4E 1T4",
    "lat": 45.45883,
    "lng": -73.58736
  },
  {
    "_id": "333",
    "school_code": "887260",
    "school_name_1": "Académie Québec Virtual",
    "admin_body_number": "887000",
    "admin_body_name": "Commission scolaire English-Montréal",
    "area_name": "Montréal ",
    "étudiants": "43",
    "langue": "anglais",
    "secteur": "public",
    "rang": "464",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "28.6",
    "ehdaa_2024": "nd",
    "rang_2024": "464/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "nd",
    "lens_2024": "74.3",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "nd",
    "lsec_2024": "64.8",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "nd",
    "scie_2024": "43.8",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "nd",
    "math_2024": "47.9",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "nd",
    "echec_2024": "50.6",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "nd",
    "sures_2024": "15.5",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "nd",
    "prog_2024": "22.2",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "nd",
    "cote_2024": "1.5",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "Académie Québec Virtual",
    "nom_court": "Académie Québec Virtual",
    "adresse": "6000 avenue Fielding",
    "municipalite": "Montréal",
    "code_postal": "H3X 1T4",
    "lat": 45.61048,
    "lng": -73.61688
  },
  {
    "_id": "334",
    "school_code": "888051",
    "school_name_1": "Beaconsfield",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "852",
    "langue": "anglais",
    "secteur": "public",
    "rang": "149",
    "rang_5_ans": "177",
    "index": "0.1",
    "en_retard_2024": "8.6",
    "ehdaa_2024": "41.1",
    "rang_2024": "149/470",
    "rang_2019_2024": "177/432",
    "lens_2018": "72.0",
    "lens_2019": "74.3",
    "lens_2022": "70.0",
    "lens_2023": "75.9",
    "lens_2024": "75.3",
    "lens_trend": "—",
    "lsec_2018": "73.9",
    "lsec_2019": "76.8",
    "lsec_2022": "71.4",
    "lsec_2023": "75.7",
    "lsec_2024": "71.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.7",
    "scie_2019": "72.6",
    "scie_2022": "70.6",
    "scie_2023": "72.6",
    "scie_2024": "71.9",
    "scie_trend": "—",
    "math_2018": "67.7",
    "math_2019": "74.1",
    "math_2022": "74.1",
    "math_2023": "74.5",
    "math_2024": "76.9",
    "math_trend": "—",
    "echec_2018": "12.8",
    "echec_2019": "8.2",
    "echec_2022": "17.0",
    "echec_2023": "12.8",
    "echec_2024": "11.4",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "1.0",
    "sures_2022": "2.0",
    "sures_2023": "2.3",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.5",
    "ecart_sexes_lens_2019": "F 5.0",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 5.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 6.4",
    "ecart_sexes_math_2019": "F 7.4",
    "ecart_sexes_math_2022": "F 0.3",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "M 0.4",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "17.9",
    "prog_2019": "12.4",
    "prog_2022": "12.8",
    "prog_2023": "18.0",
    "prog_2024": "19.9",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "6.5",
    "cote_2022": "5.8",
    "cote_2023": "6.2",
    "cote_2024": "6.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Beaconsfield",
    "nom_court": "École secondaire Beaconsfield",
    "adresse": "250, promenade Beaurepaire",
    "municipalite": "Beaconsfield",
    "code_postal": "H9W 5G7",
    "lat": 45.42997,
    "lng": -73.8619
  },
  {
    "_id": "335",
    "school_code": "888055",
    "school_name_1": "Westwood",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montérégie ",
    "étudiants": "708",
    "langue": "anglais",
    "secteur": "public",
    "rang": "156",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "5.7",
    "ehdaa_2024": "39.5",
    "rang_2024": "156/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "72.8",
    "lens_2019": "76.2",
    "lens_2022": "74.4",
    "lens_2023": "76.4",
    "lens_2024": "74.6",
    "lens_trend": "—",
    "lsec_2018": "74.2",
    "lsec_2019": "78.7",
    "lsec_2022": "74.3",
    "lsec_2023": "74.6",
    "lsec_2024": "73.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.6",
    "scie_2019": "72.1",
    "scie_2022": "67.8",
    "scie_2023": "74.5",
    "scie_2024": "70.2",
    "scie_trend": "—",
    "math_2018": "72.8",
    "math_2019": "73.5",
    "math_2022": "77.1",
    "math_2023": "77.7",
    "math_2024": "86.4",
    "math_trend": "112233",
    "echec_2018": "12.0",
    "echec_2019": "14.9",
    "echec_2022": "17.0",
    "echec_2023": "12.5",
    "echec_2024": "12.5",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "1.1",
    "sures_2022": "2.3",
    "sures_2023": "1.2",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.5",
    "ecart_sexes_lens_2019": "F 8.0",
    "ecart_sexes_lens_2022": "F 7.2",
    "ecart_sexes_lens_2023": "F 6.5",
    "ecart_sexes_lens_2024": "F 4.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.4",
    "ecart_sexes_math_2019": "F 9.2",
    "ecart_sexes_math_2022": "M 4.9",
    "ecart_sexes_math_2023": "F 0.2",
    "ecart_sexes_math_2024": "M 6.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "17.1",
    "prog_2019": "13.7",
    "prog_2022": "17.0",
    "prog_2023": "18.2",
    "prog_2024": "16.8",
    "prog_trend": "—",
    "cote_2018": "6.5",
    "cote_2019": "6.3",
    "cote_2022": "6.2",
    "cote_2023": "6.6",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Westwood Senior",
    "nom_court": "École secondaire Westwood Senior",
    "adresse": "69, Côte Saint-Charles",
    "municipalite": "Hudson",
    "code_postal": "J0P 1H0",
    "lat": 45.46141,
    "lng": -74.15206
  },
  {
    "_id": "336",
    "school_code": "888057",
    "school_name_1": "John Rennie",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "1319",
    "langue": "anglais",
    "secteur": "public",
    "rang": "137",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "1.2",
    "ehdaa_2024": "31.2",
    "rang_2024": "137/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "76.7",
    "lens_2019": "78.6",
    "lens_2022": "79.3",
    "lens_2023": "77.1",
    "lens_2024": "76.5",
    "lens_trend": "998855",
    "lsec_2018": "77.7",
    "lsec_2019": "80.0",
    "lsec_2022": "80.5",
    "lsec_2023": "77.7",
    "lsec_2024": "78.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "75.5",
    "scie_2022": "72.0",
    "scie_2023": "73.4",
    "scie_2024": "70.8",
    "scie_trend": "—",
    "math_2018": "79.8",
    "math_2019": "82.0",
    "math_2022": "78.8",
    "math_2023": "76.2",
    "math_2024": "84.1",
    "math_trend": "—",
    "echec_2018": "8.0",
    "echec_2019": "6.5",
    "echec_2022": "9.9",
    "echec_2023": "11.8",
    "echec_2024": "13.2",
    "echec_trend": "998855",
    "sures_2018": "1.2",
    "sures_2019": "0.9",
    "sures_2022": "0.9",
    "sures_2023": "1.2",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.9",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 2.8",
    "ecart_sexes_lens_2023": "F 2.2",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.4",
    "ecart_sexes_math_2019": "M 0.2",
    "ecart_sexes_math_2022": "M 1.8",
    "ecart_sexes_math_2023": "M 1.1",
    "ecart_sexes_math_2024": "F 5.5",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "11.3",
    "prog_2019": "7.2",
    "prog_2022": "7.1",
    "prog_2023": "14.2",
    "prog_2024": "20.7",
    "prog_trend": "—",
    "cote_2018": "7.4",
    "cote_2019": "7.6",
    "cote_2022": "7.8",
    "cote_2023": "6.9",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire John-Rennie",
    "nom_court": "École secondaire John-Rennie",
    "adresse": "501, boulevard Saint-Jean",
    "municipalite": "Pointe-Claire",
    "code_postal": "H9R 3J5",
    "lat": 45.45085,
    "lng": -73.81666
  },
  {
    "_id": "337",
    "school_code": "888058",
    "school_name_1": "Lakeside",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "470",
    "langue": "anglais",
    "secteur": "public",
    "rang": "217",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "58.1",
    "rang_2024": "217/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "74.0",
    "lens_2019": "76.8",
    "lens_2022": "74.6",
    "lens_2023": "76.0",
    "lens_2024": "77.8",
    "lens_trend": "—",
    "lsec_2018": "68.6",
    "lsec_2019": "68.3",
    "lsec_2022": "65.3",
    "lsec_2023": "66.7",
    "lsec_2024": "69.9",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.0",
    "scie_2019": "65.8",
    "scie_2022": "63.3",
    "scie_2023": "66.1",
    "scie_2024": "68.3",
    "scie_trend": "—",
    "math_2018": "67.4",
    "math_2019": "66.1",
    "math_2022": "63.9",
    "math_2023": "64.0",
    "math_2024": "75.4",
    "math_trend": "—",
    "echec_2018": "21.2",
    "echec_2019": "22.5",
    "echec_2022": "24.1",
    "echec_2023": "23.2",
    "echec_2024": "14.1",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.6",
    "sures_2022": "3.9",
    "sures_2023": "2.9",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 7.5",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.1",
    "ecart_sexes_math_2019": "M 7.9",
    "ecart_sexes_math_2022": "M 4.8",
    "ecart_sexes_math_2023": "M 5.7",
    "ecart_sexes_math_2024": "M 5.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "38.8",
    "prog_2019": "34.6",
    "prog_2022": "16.8",
    "prog_2023": "33.4",
    "prog_2024": "34.4",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "5.0",
    "cote_2022": "5.2",
    "cote_2023": "4.9",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Lakeside Academy",
    "nom_court": "École secondaire Lakeside Academy",
    "adresse": "5050, rue Sherbrooke",
    "municipalite": "Montréal",
    "code_postal": "H8T 1H8",
    "lat": 45.44636,
    "lng": -73.7142
  },
  {
    "_id": "338",
    "school_code": "888059",
    "school_name_1": "LaSalle",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "798",
    "langue": "anglais",
    "secteur": "public",
    "rang": "277",
    "rang_5_ans": "318",
    "index": "0.1",
    "en_retard_2024": "13.9",
    "ehdaa_2024": "32.3",
    "rang_2024": "277/470",
    "rang_2019_2024": "318/432",
    "lens_2018": "72.9",
    "lens_2019": "71.8",
    "lens_2022": "68.1",
    "lens_2023": "71.5",
    "lens_2024": "75.2",
    "lens_trend": "—",
    "lsec_2018": "72.2",
    "lsec_2019": "69.3",
    "lsec_2022": "69.4",
    "lsec_2023": "70.4",
    "lsec_2024": "69.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.3",
    "scie_2019": "67.3",
    "scie_2022": "66.6",
    "scie_2023": "71.9",
    "scie_2024": "64.3",
    "scie_trend": "—",
    "math_2018": "62.8",
    "math_2019": "66.0",
    "math_2022": "61.4",
    "math_2023": "66.6",
    "math_2024": "70.6",
    "math_trend": "—",
    "echec_2018": "21.2",
    "echec_2019": "21.0",
    "echec_2022": "26.2",
    "echec_2023": "23.1",
    "echec_2024": "22.6",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "0.6",
    "sures_2022": "4.2",
    "sures_2023": "3.3",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.6",
    "ecart_sexes_lens_2019": "F 0.7",
    "ecart_sexes_lens_2022": "F 7.4",
    "ecart_sexes_lens_2023": "F 8.2",
    "ecart_sexes_lens_2024": "F 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "F 7.7",
    "ecart_sexes_math_2023": "F 10.9",
    "ecart_sexes_math_2024": "M 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "19.8",
    "prog_2019": "19.6",
    "prog_2022": "19.5",
    "prog_2023": "19.3",
    "prog_2024": "23.8",
    "prog_trend": "—",
    "cote_2018": "5.3",
    "cote_2019": "5.4",
    "cote_2022": "4.4",
    "cote_2023": "4.8",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Polyvalente LaSalle",
    "nom_court": "Polyvalente LaSalle",
    "adresse": "240, 9e Avenue",
    "municipalite": "Montréal",
    "code_postal": "H8P 2N9",
    "lat": 45.42817,
    "lng": -73.60055
  },
  {
    "_id": "339",
    "school_code": "888061",
    "school_name_1": "MacDonald",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "968",
    "langue": "anglais",
    "secteur": "public",
    "rang": "310",
    "rang_5_ans": "307",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "41.2",
    "rang_2024": "310/470",
    "rang_2019_2024": "307/432",
    "lens_2018": "70.8",
    "lens_2019": "70.5",
    "lens_2022": "68.4",
    "lens_2023": "69.7",
    "lens_2024": "68.0",
    "lens_trend": "—",
    "lsec_2018": "73.8",
    "lsec_2019": "73.1",
    "lsec_2022": "74.4",
    "lsec_2023": "75.0",
    "lsec_2024": "74.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "67.5",
    "scie_2019": "67.9",
    "scie_2022": "65.8",
    "scie_2023": "70.6",
    "scie_2024": "70.9",
    "scie_trend": "112233",
    "math_2018": "69.3",
    "math_2019": "68.9",
    "math_2022": "67.2",
    "math_2023": "70.0",
    "math_2024": "77.5",
    "math_trend": "112233",
    "echec_2018": "18.2",
    "echec_2019": "20.4",
    "echec_2022": "22.0",
    "echec_2023": "20.5",
    "echec_2024": "17.1",
    "echec_trend": "—",
    "sures_2018": "4.6",
    "sures_2019": "5.2",
    "sures_2022": "4.4",
    "sures_2023": "3.3",
    "sures_2024": "3.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "F 7.2",
    "ecart_sexes_lens_2023": "F 7.9",
    "ecart_sexes_lens_2024": "F 4.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.9",
    "ecart_sexes_math_2019": "F 8.5",
    "ecart_sexes_math_2022": "F 4.4",
    "ecart_sexes_math_2023": "F 2.7",
    "ecart_sexes_math_2024": "F 3.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "13.6",
    "prog_2019": "11.0",
    "prog_2022": "7.8",
    "prog_2023": "16.1",
    "prog_2024": "27.7",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "4.9",
    "cote_2022": "5.3",
    "cote_2023": "5.1",
    "cote_2024": "5.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Macdonald",
    "nom_court": "École secondaire Macdonald",
    "adresse": "17, avenue Maple",
    "municipalite": "Sainte-Anne-de-Bellevue",
    "code_postal": "H9X 2E5",
    "lat": 45.40743,
    "lng": -73.94415
  },
  {
    "_id": "340",
    "school_code": "888062",
    "school_name_1": "Pierrefonds",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "875",
    "langue": "anglais",
    "secteur": "public",
    "rang": "182",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "48.7",
    "rang_2024": "182/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "74.4",
    "lens_2019": "77.3",
    "lens_2022": "76.2",
    "lens_2023": "77.2",
    "lens_2024": "74.7",
    "lens_trend": "—",
    "lsec_2018": "73.4",
    "lsec_2019": "75.0",
    "lsec_2022": "71.6",
    "lsec_2023": "74.5",
    "lsec_2024": "71.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.8",
    "scie_2019": "71.9",
    "scie_2022": "66.9",
    "scie_2023": "71.2",
    "scie_2024": "68.6",
    "scie_trend": "—",
    "math_2018": "76.7",
    "math_2019": "78.1",
    "math_2022": "71.4",
    "math_2023": "76.4",
    "math_2024": "82.2",
    "math_trend": "—",
    "echec_2018": "7.8",
    "echec_2019": "8.0",
    "echec_2022": "21.1",
    "echec_2023": "13.4",
    "echec_2024": "16.7",
    "echec_trend": "998855",
    "sures_2018": "0.9",
    "sures_2019": "0.6",
    "sures_2022": "2.4",
    "sures_2023": "1.0",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 7.7",
    "ecart_sexes_lens_2022": "F 7.9",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 7.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.1",
    "ecart_sexes_math_2019": "M 0.7",
    "ecart_sexes_math_2022": "F 4.6",
    "ecart_sexes_math_2023": "M 2.5",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "21.4",
    "prog_2019": "14.7",
    "prog_2022": "18.8",
    "prog_2023": "28.4",
    "prog_2024": "20.9",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.9",
    "cote_2022": "6.1",
    "cote_2023": "6.2",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Pierrefonds",
    "nom_court": "École secondaire Pierrefonds",
    "adresse": "13800, boulevard de Pierrefonds",
    "municipalite": "Montréal",
    "code_postal": "H9A 1A7",
    "lat": 45.49249,
    "lng": -73.84659
  },
  {
    "_id": "341",
    "school_code": "888065",
    "school_name_1": "St. Thomas",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "1160",
    "langue": "anglais",
    "secteur": "public",
    "rang": "96",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "27.3",
    "rang_2024": "96/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "78.9",
    "lens_2019": "81.1",
    "lens_2022": "80.2",
    "lens_2023": "79.0",
    "lens_2024": "78.9",
    "lens_trend": "998855",
    "lsec_2018": "77.1",
    "lsec_2019": "77.7",
    "lsec_2022": "76.0",
    "lsec_2023": "75.6",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.3",
    "scie_2019": "77.8",
    "scie_2022": "72.7",
    "scie_2023": "77.4",
    "scie_2024": "73.8",
    "scie_trend": "—",
    "math_2018": "76.5",
    "math_2019": "80.2",
    "math_2022": "76.0",
    "math_2023": "76.6",
    "math_2024": "84.5",
    "math_trend": "—",
    "echec_2018": "7.1",
    "echec_2019": "7.0",
    "echec_2022": "12.6",
    "echec_2023": "9.4",
    "echec_2024": "10.2",
    "echec_trend": "998855",
    "sures_2018": "0.1",
    "sures_2019": "0.1",
    "sures_2022": "0.9",
    "sures_2023": "1.4",
    "sures_2024": "1.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.9",
    "ecart_sexes_lens_2019": "F 5.0",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.2",
    "ecart_sexes_math_2019": "F 3.6",
    "ecart_sexes_math_2022": "F 0.2",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "8.0",
    "prog_2019": "7.9",
    "prog_2022": "7.0",
    "prog_2023": "6.5",
    "prog_2024": "11.1",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "7.9",
    "cote_2022": "7.6",
    "cote_2023": "7.3",
    "cote_2024": "7.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Thomas",
    "nom_court": "École secondaire Saint-Thomas",
    "adresse": "111, avenue Broadview",
    "municipalite": "Pointe-Claire",
    "code_postal": "H9R 3Z3",
    "lat": 45.45665,
    "lng": -73.79671
  },
  {
    "_id": "342",
    "school_code": "888069",
    "school_name_1": "Beurling",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "241",
    "langue": "anglais",
    "secteur": "public",
    "rang": "451",
    "rang_5_ans": "422",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "56.8",
    "rang_2024": "451/470",
    "rang_2019_2024": "422/432",
    "lens_2018": "64.7",
    "lens_2019": "70.3",
    "lens_2022": "68.0",
    "lens_2023": "71.5",
    "lens_2024": "70.5",
    "lens_trend": "—",
    "lsec_2018": "63.2",
    "lsec_2019": "76.8",
    "lsec_2022": "65.8",
    "lsec_2023": "64.7",
    "lsec_2024": "62.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "57.4",
    "scie_2019": "58.1",
    "scie_2022": "52.9",
    "scie_2023": "59.7",
    "scie_2024": "55.9",
    "scie_trend": "—",
    "math_2018": "58.1",
    "math_2019": "59.2",
    "math_2022": "49.6",
    "math_2023": "68.4",
    "math_2024": "60.2",
    "math_trend": "—",
    "echec_2018": "34.9",
    "echec_2019": "28.7",
    "echec_2022": "46.4",
    "echec_2023": "28.7",
    "echec_2024": "36.3",
    "echec_trend": "—",
    "sures_2018": "7.0",
    "sures_2019": "3.5",
    "sures_2022": "13.4",
    "sures_2023": "2.6",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.2",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 3.6",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 8.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 11.7",
    "ecart_sexes_math_2019": "M 0.8",
    "ecart_sexes_math_2022": "F 3.5",
    "ecart_sexes_math_2023": "F 10.6",
    "ecart_sexes_math_2024": "M 10.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "36.0",
    "prog_2019": "53.5",
    "prog_2022": "34.5",
    "prog_2023": "41.5",
    "prog_2024": "47.6",
    "prog_trend": "—",
    "cote_2018": "2.3",
    "cote_2019": "3.9",
    "cote_2022": "2.3",
    "cote_2023": "4.1",
    "cote_2024": "2.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Beurling Academy",
    "nom_court": "École secondaire Beurling Academy",
    "adresse": "6100, boulevard Champlain",
    "municipalite": "Montréal",
    "code_postal": "H4H 1A5",
    "lat": 45.44828,
    "lng": -73.58762
  },
  {
    "_id": "343",
    "school_code": "888079",
    "school_name_1": "Horizon",
    "admin_body_number": "888000",
    "admin_body_name": "Commission scolaire Lester-B.-Pearson",
    "area_name": "Montréal ",
    "étudiants": "95",
    "langue": "anglais",
    "secteur": "public",
    "rang": "467",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "97.9",
    "rang_2024": "467/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "54.8",
    "lens_2022": "nd",
    "lens_2023": "67.9",
    "lens_2024": "65.0",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "63.4",
    "lsec_2022": "nd",
    "lsec_2023": "72.8",
    "lsec_2024": "62.6",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "58.4",
    "scie_2022": "nd",
    "scie_2023": "60.4",
    "scie_2024": "55.9",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "57.5",
    "math_2022": "nd",
    "math_2023": "59.8",
    "math_2024": "51.4",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "32.6",
    "echec_2022": "nd",
    "echec_2023": "24.2",
    "echec_2024": "38.7",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "9.0",
    "sures_2022": "nd",
    "sures_2023": "4.2",
    "sures_2024": "6.2",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "88.8",
    "prog_2022": "nd",
    "prog_2023": "95.3",
    "prog_2024": "91.1",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "0.0",
    "cote_2022": "nd",
    "cote_2023": "2.2",
    "cote_2024": "0.7",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Horizon",
    "nom_court": "École secondaire Horizon",
    "adresse": "90, avenue de Jubilee Square",
    "municipalite": "Pointe-Claire",
    "code_postal": "H9R 1M3",
    "lat": 45.46406,
    "lng": -73.80418
  },
  {
    "_id": "344",
    "school_code": "889014",
    "school_name_1": "Châteauguay Valley",
    "admin_body_number": "889000",
    "admin_body_name": "Commission scolaire New Frontiers",
    "area_name": "Montérégie ",
    "étudiants": "679",
    "langue": "anglais",
    "secteur": "public",
    "rang": "323",
    "rang_5_ans": "327",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "43.3",
    "rang_2024": "323/470",
    "rang_2019_2024": "327/432",
    "lens_2018": "72.6",
    "lens_2019": "72.6",
    "lens_2022": "73.8",
    "lens_2023": "72.2",
    "lens_2024": "70.6",
    "lens_trend": "998855",
    "lsec_2018": "73.5",
    "lsec_2019": "73.2",
    "lsec_2022": "70.9",
    "lsec_2023": "70.7",
    "lsec_2024": "71.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "63.9",
    "scie_2019": "67.6",
    "scie_2022": "66.0",
    "scie_2023": "64.9",
    "scie_2024": "64.4",
    "scie_trend": "—",
    "math_2018": "61.9",
    "math_2019": "67.1",
    "math_2022": "70.1",
    "math_2023": "74.2",
    "math_2024": "77.6",
    "math_trend": "112233",
    "echec_2018": "25.8",
    "echec_2019": "22.9",
    "echec_2022": "23.8",
    "echec_2023": "23.3",
    "echec_2024": "22.2",
    "echec_trend": "112233",
    "sures_2018": "0.8",
    "sures_2019": "1.1",
    "sures_2022": "0.8",
    "sures_2023": "2.4",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.0",
    "ecart_sexes_lens_2019": "F 8.9",
    "ecart_sexes_lens_2022": "F 10.8",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 6.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.3",
    "ecart_sexes_math_2019": "F 6.4",
    "ecart_sexes_math_2022": "F 3.6",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "F 5.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "27.3",
    "prog_2019": "36.5",
    "prog_2022": "30.0",
    "prog_2023": "36.5",
    "prog_2024": "27.4",
    "prog_trend": "—",
    "cote_2018": "5.0",
    "cote_2019": "4.6",
    "cote_2022": "5.2",
    "cote_2023": "5.1",
    "cote_2024": "5.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Châteauguay Valley",
    "nom_court": "École secondaire Châteauguay Valley",
    "adresse": "1597, route 138A",
    "municipalite": "Ormstown",
    "code_postal": "J0S 1K0",
    "lat": 45.12477,
    "lng": -74.01392
  },
  {
    "_id": "345",
    "school_code": "889016",
    "school_name_1": "Howard S. Billings",
    "admin_body_number": "889000",
    "admin_body_name": "Commission scolaire New Frontiers",
    "area_name": "Montérégie ",
    "étudiants": "858",
    "langue": "anglais",
    "secteur": "public",
    "rang": "387",
    "rang_5_ans": "377",
    "index": "0.1",
    "en_retard_2024": "nd",
    "ehdaa_2024": "36.7",
    "rang_2024": "387/470",
    "rang_2019_2024": "377/432",
    "lens_2018": "66.1",
    "lens_2019": "67.8",
    "lens_2022": "69.1",
    "lens_2023": "72.2",
    "lens_2024": "66.4",
    "lens_trend": "—",
    "lsec_2018": "75.4",
    "lsec_2019": "75.2",
    "lsec_2022": "75.8",
    "lsec_2023": "74.8",
    "lsec_2024": "76.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "64.2",
    "scie_2019": "66.3",
    "scie_2022": "59.9",
    "scie_2023": "64.9",
    "scie_2024": "61.9",
    "scie_trend": "—",
    "math_2018": "56.5",
    "math_2019": "59.8",
    "math_2022": "68.9",
    "math_2023": "65.2",
    "math_2024": "69.7",
    "math_trend": "—",
    "echec_2018": "28.4",
    "echec_2019": "24.3",
    "echec_2022": "27.5",
    "echec_2023": "21.0",
    "echec_2024": "26.4",
    "echec_trend": "—",
    "sures_2018": "4.5",
    "sures_2019": "2.6",
    "sures_2022": "4.8",
    "sures_2023": "2.8",
    "sures_2024": "4.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.9",
    "ecart_sexes_lens_2019": "F 7.4",
    "ecart_sexes_lens_2022": "F 9.6",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.0",
    "ecart_sexes_math_2019": "F 9.2",
    "ecart_sexes_math_2022": "F 5.6",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "M 5.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "31.1",
    "prog_2019": "36.3",
    "prog_2022": "23.3",
    "prog_2023": "36.4",
    "prog_2024": "26.6",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "3.9",
    "cote_2022": "4.6",
    "cote_2023": "4.9",
    "cote_2024": "4.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire régionale Howard S. Billings",
    "nom_court": "École secondaire Howard S. Billings",
    "adresse": "210, rue McLeod",
    "municipalite": "Châteauguay",
    "code_postal": "J6J 2H4",
    "lat": 45.36306,
    "lng": -73.73092
  },
  {
    "_id": "346",
    "school_code": "1501",
    "school_name_1": "Antoine Manseau",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Lanaudière ",
    "étudiants": "608",
    "langue": "français",
    "secteur": "privé",
    "rang": "63",
    "rang_5_ans": "64",
    "index": "0.1",
    "en_retard_2024": "2.1",
    "ehdaa_2024": "27.1",
    "rang_2024": "63/470",
    "rang_2019_2024": "64/432",
    "lens_2018": "73.4",
    "lens_2019": "77.7",
    "lens_2022": "78.2",
    "lens_2023": "78.4",
    "lens_2024": "77.9",
    "lens_trend": "112233",
    "lsec_2018": "78.3",
    "lsec_2019": "79.9",
    "lsec_2022": "79.3",
    "lsec_2023": "77.5",
    "lsec_2024": "81.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.4",
    "scie_2019": "77.7",
    "scie_2022": "76.8",
    "scie_2023": "83.1",
    "scie_2024": "77.8",
    "scie_trend": "—",
    "math_2018": "79.1",
    "math_2019": "80.8",
    "math_2022": "75.2",
    "math_2023": "80.2",
    "math_2024": "81.9",
    "math_trend": "—",
    "echec_2018": "3.5",
    "echec_2019": "4.8",
    "echec_2022": "7.5",
    "echec_2023": "4.9",
    "echec_2024": "4.6",
    "echec_trend": "—",
    "sures_2018": "1.6",
    "sures_2019": "1.6",
    "sures_2022": "2.7",
    "sures_2023": "1.1",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 6.9",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 6.0",
    "ecart_sexes_math_2019": "F 4.7",
    "ecart_sexes_math_2022": "F 6.0",
    "ecart_sexes_math_2023": "F 1.5",
    "ecart_sexes_math_2024": "F 5.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "4.7",
    "prog_2022": "6.1",
    "prog_2023": "5.7",
    "prog_2024": "6.7",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "8.0",
    "cote_2022": "7.7",
    "cote_2023": "8.0",
    "cote_2024": "8.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Antoine Manseau",
    "nom_court": "Ac. Antoine Manseau",
    "adresse": "20, St-Charles-Borromée Sud C.P. 410",
    "municipalite": "Joliette",
    "code_postal": "J6E 3Z9",
    "lat": 46.02699,
    "lng": -73.43541
  },
  {
    "_id": "347",
    "school_code": "3501",
    "school_name_1": "Beth Rivkah",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "123",
    "langue": "français",
    "secteur": "privé",
    "rang": "21",
    "rang_5_ans": "32",
    "index": "0.1",
    "en_retard_2024": "5",
    "ehdaa_2024": "nd",
    "rang_2024": "21/470",
    "rang_2019_2024": "32/432",
    "lens_2018": "80.2",
    "lens_2019": "78.6",
    "lens_2022": "72.6",
    "lens_2023": "78.4",
    "lens_2024": "77.3",
    "lens_trend": "—",
    "lsec_2018": "85.5",
    "lsec_2019": "82.9",
    "lsec_2022": "85.9",
    "lsec_2023": "86.2",
    "lsec_2024": "86.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.2",
    "scie_2019": "74.6",
    "scie_2022": "80.3",
    "scie_2023": "79.9",
    "scie_2024": "75.6",
    "scie_trend": "—",
    "math_2018": "76.1",
    "math_2019": "84.1",
    "math_2022": "84.5",
    "math_2023": "85.3",
    "math_2024": "88.0",
    "math_trend": "112233",
    "echec_2018": "7.6",
    "echec_2019": "3.3",
    "echec_2022": "10.0",
    "echec_2023": "4.4",
    "echec_2024": "1.1",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "2.0",
    "sures_2022": "1.7",
    "sures_2023": "0.8",
    "sures_2024": "0.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "8.0",
    "prog_2019": "8.7",
    "prog_2022": "16.7",
    "prog_2023": "0.0",
    "prog_2024": "5.0",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "8.4",
    "cote_2022": "8.3",
    "cote_2023": "9.1",
    "cote_2024": "9.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "L'Académie Beth Rivkah pour filles",
    "nom_court": "L'Académie Beth Rivkah pour filles",
    "adresse": "5001, rue Vézina",
    "municipalite": "Montréal",
    "code_postal": "H3W 1C2",
    "lat": 45.49479,
    "lng": -73.64569
  },
  {
    "_id": "348",
    "school_code": "7502",
    "school_name_1": "Ibn Sina",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "100",
    "langue": "français",
    "secteur": "privé",
    "rang": "33",
    "rang_5_ans": "106",
    "index": "0.1",
    "en_retard_2024": "12.5",
    "ehdaa_2024": "nd",
    "rang_2024": "33/470",
    "rang_2019_2024": "106/432",
    "lens_2018": "69.8",
    "lens_2019": "65.0",
    "lens_2022": "61.2",
    "lens_2023": "70.6",
    "lens_2024": "67.1",
    "lens_trend": "—",
    "lsec_2018": "81.3",
    "lsec_2019": "77.6",
    "lsec_2022": "88.2",
    "lsec_2023": "91.9",
    "lsec_2024": "87.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.7",
    "scie_2019": "80.4",
    "scie_2022": "83.4",
    "scie_2023": "77.9",
    "scie_2024": "87.1",
    "scie_trend": "—",
    "math_2018": "86.2",
    "math_2019": "87.8",
    "math_2022": "78.5",
    "math_2023": "74.4",
    "math_2024": "93.9",
    "math_trend": "—",
    "echec_2018": "6.6",
    "echec_2019": "14.8",
    "echec_2022": "21.4",
    "echec_2023": "11.7",
    "echec_2024": "4.8",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "7.6",
    "sures_2022": "5.3",
    "sures_2023": "3.6",
    "sures_2024": "4.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "18.6",
    "prog_2019": "6.3",
    "prog_2022": "10.0",
    "prog_2023": "21.4",
    "prog_2024": "13.5",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "5.5",
    "cote_2022": "7.0",
    "cote_2023": "6.7",
    "cote_2024": "8.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Ibn Sina, Campus secondaire",
    "nom_court": "Académie Ibn Sina, Campus secondaire",
    "adresse": "5872, boulevard Léger, bureau 200",
    "municipalite": "Montréal",
    "code_postal": "H1G 5X5",
    "lat": 45.60964,
    "lng": -73.63593
  },
  {
    "_id": "349",
    "school_code": "9502",
    "school_name_1": "Kells",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "134",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "217",
    "rang_5_ans": "278",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "15.7",
    "rang_2024": "217/470",
    "rang_2019_2024": "278/432",
    "lens_2018": "70.6",
    "lens_2019": "67.9",
    "lens_2022": "67.9",
    "lens_2023": "74.4",
    "lens_2024": "74.2",
    "lens_trend": "—",
    "lsec_2018": "66.5",
    "lsec_2019": "70.1",
    "lsec_2022": "66.5",
    "lsec_2023": "71.9",
    "lsec_2024": "79.3",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.1",
    "scie_2019": "77.2",
    "scie_2022": "74.5",
    "scie_2023": "76.3",
    "scie_2024": "75.2",
    "scie_trend": "—",
    "math_2018": "81.7",
    "math_2019": "84.2",
    "math_2022": "83.2",
    "math_2023": "82.3",
    "math_2024": "87.1",
    "math_trend": "—",
    "echec_2018": "11.3",
    "echec_2019": "11.3",
    "echec_2022": "19.0",
    "echec_2023": "13.9",
    "echec_2024": "9.4",
    "echec_trend": "—",
    "sures_2018": "3.5",
    "sures_2019": "4.0",
    "sures_2022": "4.5",
    "sures_2023": "3.6",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.8",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 2.5",
    "ecart_sexes_lens_2024": "F 6.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.6",
    "ecart_sexes_math_2019": "M 1.4",
    "ecart_sexes_math_2022": "M 0.2",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "F 8.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.3",
    "prog_2019": "18.5",
    "prog_2022": "29.4",
    "prog_2023": "46.9",
    "prog_2024": "38.0",
    "prog_trend": "—",
    "cote_2018": "5.5",
    "cote_2019": "5.5",
    "cote_2022": "4.8",
    "cote_2023": "5.2",
    "cote_2024": "6.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Kells, campus secondaire",
    "nom_court": "Académie Kells, campus secondaire",
    "adresse": "6865, boulevard De Maisonneuve Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4B 1T1",
    "lat": 45.45948,
    "lng": -73.63129
  },
  {
    "_id": "350",
    "school_code": "15503",
    "school_name_1": "Kuper",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "593",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "63",
    "rang_5_ans": "43",
    "index": "0.1",
    "en_retard_2024": "19.8",
    "ehdaa_2024": "nd",
    "rang_2024": "63/470",
    "rang_2019_2024": "43/432",
    "lens_2018": "75.0",
    "lens_2019": "79.3",
    "lens_2022": "81.0",
    "lens_2023": "84.0",
    "lens_2024": "80.3",
    "lens_trend": "—",
    "lsec_2018": "77.3",
    "lsec_2019": "79.4",
    "lsec_2022": "81.0",
    "lsec_2023": "79.7",
    "lsec_2024": "78.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.4",
    "scie_2019": "83.9",
    "scie_2022": "85.5",
    "scie_2023": "86.4",
    "scie_2024": "82.6",
    "scie_trend": "—",
    "math_2018": "89.9",
    "math_2019": "90.8",
    "math_2022": "93.9",
    "math_2023": "89.7",
    "math_2024": "89.8",
    "math_trend": "998855",
    "echec_2018": "4.6",
    "echec_2019": "1.9",
    "echec_2022": "2.4",
    "echec_2023": "1.9",
    "echec_2024": "4.3",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "0.3",
    "sures_2022": "0.0",
    "sures_2023": "0.7",
    "sures_2024": "0.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.3",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 5.2",
    "ecart_sexes_lens_2023": "M 0.1",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.6",
    "ecart_sexes_math_2019": "F 3.4",
    "ecart_sexes_math_2022": "F 1.7",
    "ecart_sexes_math_2023": "F 2.2",
    "ecart_sexes_math_2024": "M 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.7",
    "prog_2019": "13.1",
    "prog_2022": "9.3",
    "prog_2023": "4.4",
    "prog_2024": "12.6",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.0",
    "cote_2022": "8.5",
    "cote_2023": "8.7",
    "cote_2024": "8.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Kuper, secondaire",
    "nom_court": "Académie Kuper, secondaire",
    "adresse": "2975, rue Edmond",
    "municipalite": "Kirkland",
    "code_postal": "H9H 5K5",
    "lat": 45.45247,
    "lng": -73.83917
  },
  {
    "_id": "351",
    "school_code": "16501",
    "school_name_1": "Lafontaine",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "1221",
    "langue": "français",
    "secteur": "privé",
    "rang": "35",
    "rang_5_ans": "37",
    "index": "0.1",
    "en_retard_2024": "1.6",
    "ehdaa_2024": "26.3",
    "rang_2024": "35/470",
    "rang_2019_2024": "37/432",
    "lens_2018": "76.1",
    "lens_2019": "76.1",
    "lens_2022": "69.8",
    "lens_2023": "71.1",
    "lens_2024": "73.8",
    "lens_trend": "—",
    "lsec_2018": "83.1",
    "lsec_2019": "84.7",
    "lsec_2022": "85.0",
    "lsec_2023": "80.1",
    "lsec_2024": "82.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.7",
    "scie_2019": "81.2",
    "scie_2022": "79.9",
    "scie_2023": "85.4",
    "scie_2024": "84.3",
    "scie_trend": "—",
    "math_2018": "84.9",
    "math_2019": "84.4",
    "math_2022": "82.8",
    "math_2023": "89.3",
    "math_2024": "87.7",
    "math_trend": "—",
    "echec_2018": "4.1",
    "echec_2019": "4.5",
    "echec_2022": "9.7",
    "echec_2023": "6.9",
    "echec_2024": "6.2",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.0",
    "sures_2022": "3.2",
    "sures_2023": "2.0",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.8",
    "ecart_sexes_math_2019": "F 5.7",
    "ecart_sexes_math_2022": "F 3.7",
    "ecart_sexes_math_2023": "F 3.8",
    "ecart_sexes_math_2024": "F 4.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.6",
    "prog_2019": "2.1",
    "prog_2022": "0.8",
    "prog_2023": "4.5",
    "prog_2024": "3.5",
    "prog_trend": "—",
    "cote_2018": "8.8",
    "cote_2019": "8.8",
    "cote_2022": "8.2",
    "cote_2023": "8.1",
    "cote_2024": "8.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Lafontaine inc.",
    "nom_court": "Académie Lafontaine",
    "adresse": "2171, boulevard Maurice",
    "municipalite": "Saint-Jérôme",
    "code_postal": "J7Y 4M7",
    "lat": 45.80326,
    "lng": -74.00708
  },
  {
    "_id": "352",
    "school_code": "17501",
    "school_name_1": "Laurentien",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "266",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "93",
    "index": "0.1",
    "en_retard_2024": "4.4",
    "ehdaa_2024": "38.7",
    "rang_2024": "40/470",
    "rang_2019_2024": "93/432",
    "lens_2018": "71.5",
    "lens_2019": "74.9",
    "lens_2022": "76.0",
    "lens_2023": "75.2",
    "lens_2024": "71.4",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "88.3",
    "lsec_2022": "79.8",
    "lsec_2023": "84.5",
    "lsec_2024": "90.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.7",
    "scie_2019": "79.8",
    "scie_2022": "79.0",
    "scie_2023": "78.7",
    "scie_2024": "77.9",
    "scie_trend": "—",
    "math_2018": "66.1",
    "math_2019": "67.7",
    "math_2022": "77.5",
    "math_2023": "79.6",
    "math_2024": "83.3",
    "math_trend": "112233",
    "echec_2018": "14.8",
    "echec_2019": "12.3",
    "echec_2022": "10.2",
    "echec_2023": "9.2",
    "echec_2024": "9.7",
    "echec_trend": "112233",
    "sures_2018": "2.4",
    "sures_2019": "2.2",
    "sures_2022": "1.1",
    "sures_2023": "0.2",
    "sures_2024": "0.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 3.7",
    "ecart_sexes_lens_2022": "F 11.3",
    "ecart_sexes_lens_2023": "F 0.5",
    "ecart_sexes_lens_2024": "F 0.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 9.4",
    "ecart_sexes_math_2022": "M 3.8",
    "ecart_sexes_math_2023": "F 4.2",
    "ecart_sexes_math_2024": "F 6.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "18.3",
    "prog_2019": "20.6",
    "prog_2022": "11.0",
    "prog_2023": "11.0",
    "prog_2024": "7.4",
    "prog_trend": "112233",
    "cote_2018": "6.1",
    "cote_2019": "7.1",
    "cote_2022": "7.4",
    "cote_2023": "7.9",
    "cote_2024": "8.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Laurentien",
    "nom_court": "Collège Laurentien",
    "adresse": "1200, 14e Avenue",
    "municipalite": "Val-Morin",
    "code_postal": "J0T 2R0",
    "lat": 46.01474,
    "lng": -74.19664
  },
  {
    "_id": "353",
    "school_code": "26501",
    "school_name_1": "Michèle-Provost",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "220",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "114",
    "index": "0.1",
    "en_retard_2024": "3.8",
    "ehdaa_2024": "12.7",
    "rang_2024": "69/470",
    "rang_2019_2024": "114/432",
    "lens_2018": "61.3",
    "lens_2019": "64.3",
    "lens_2022": "64.1",
    "lens_2023": "67.3",
    "lens_2024": "65.0",
    "lens_trend": "112233",
    "lsec_2018": "89.1",
    "lsec_2019": "85.3",
    "lsec_2022": "91.4",
    "lsec_2023": "90.9",
    "lsec_2024": "90.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.6",
    "scie_2019": "71.0",
    "scie_2022": "76.4",
    "scie_2023": "79.6",
    "scie_2024": "74.2",
    "scie_trend": "—",
    "math_2018": "70.3",
    "math_2019": "77.3",
    "math_2022": "76.1",
    "math_2023": "75.6",
    "math_2024": "83.4",
    "math_trend": "—",
    "echec_2018": "18.9",
    "echec_2019": "15.4",
    "echec_2022": "12.9",
    "echec_2023": "7.0",
    "echec_2024": "12.5",
    "echec_trend": "112233",
    "sures_2018": "2.8",
    "sures_2019": "1.9",
    "sures_2022": "4.8",
    "sures_2023": "3.0",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.0",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 0.7",
    "ecart_sexes_lens_2023": "F 9.6",
    "ecart_sexes_lens_2024": "M 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.3",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "M 2.7",
    "ecart_sexes_math_2024": "M 0.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "19.1",
    "prog_2019": "17.9",
    "prog_2022": "9.4",
    "prog_2023": "10.8",
    "prog_2024": "6.7",
    "prog_trend": "112233",
    "cote_2018": "5.8",
    "cote_2019": "6.3",
    "cote_2022": "7.6",
    "cote_2023": "7.2",
    "cote_2024": "7.9",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Académie Michèle-Provost",
    "nom_court": "Académie Michèle-Provost",
    "adresse": "1517, avenue Des Pins Ouest",
    "municipalite": "Montréal",
    "code_postal": "H3G 1B3",
    "lat": 45.49846,
    "lng": -73.58676
  },
  {
    "_id": "354",
    "school_code": "27501",
    "school_name_1": "Académie Saint-Louis",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1245",
    "langue": "français",
    "secteur": "privé",
    "rang": "169",
    "rang_5_ans": "93",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "16.4",
    "rang_2024": "169/470",
    "rang_2019_2024": "93/432",
    "lens_2018": "76.3",
    "lens_2019": "74.1",
    "lens_2022": "71.4",
    "lens_2023": "74.0",
    "lens_2024": "70.0",
    "lens_trend": "—",
    "lsec_2018": "78.3",
    "lsec_2019": "76.5",
    "lsec_2022": "77.5",
    "lsec_2023": "76.4",
    "lsec_2024": "71.4",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.5",
    "scie_2019": "80.3",
    "scie_2022": "79.1",
    "scie_2023": "86.1",
    "scie_2024": "76.7",
    "scie_trend": "—",
    "math_2018": "78.2",
    "math_2019": "84.5",
    "math_2022": "82.7",
    "math_2023": "82.6",
    "math_2024": "82.9",
    "math_trend": "—",
    "echec_2018": "4.5",
    "echec_2019": "4.2",
    "echec_2022": "7.5",
    "echec_2023": "6.2",
    "echec_2024": "11.3",
    "echec_trend": "998855",
    "sures_2018": "0.6",
    "sures_2019": "0.6",
    "sures_2022": "3.3",
    "sures_2023": "2.0",
    "sures_2024": "4.9",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 2.7",
    "ecart_sexes_lens_2019": "F 1.1",
    "ecart_sexes_lens_2022": "F 11.0",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 7.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.0",
    "ecart_sexes_math_2019": "F 1.2",
    "ecart_sexes_math_2022": "F 3.8",
    "ecart_sexes_math_2023": "F 2.4",
    "ecart_sexes_math_2024": "M 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.9",
    "prog_2019": "2.3",
    "prog_2022": "1.3",
    "prog_2023": "4.1",
    "prog_2024": "3.6",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "8.1",
    "cote_2022": "7.3",
    "cote_2023": "7.5",
    "cote_2024": "6.4",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Académie Saint-Louis",
    "nom_court": "Académie Saint-Louis",
    "adresse": "1500, rue de la Rive-Boisée Sud",
    "municipalite": "Québec",
    "code_postal": "G2C 2B3",
    "lat": 46.82996,
    "lng": -71.31534
  },
  {
    "_id": "355",
    "school_code": "29501",
    "school_name_1": "Académie Ste-Thérèse",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "1086",
    "langue": "français",
    "secteur": "privé",
    "rang": "21",
    "rang_5_ans": "23",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "15.9",
    "rang_2024": "21/470",
    "rang_2019_2024": "23/432",
    "lens_2018": "75.8",
    "lens_2019": "73.4",
    "lens_2022": "77.3",
    "lens_2023": "80.0",
    "lens_2024": "78.1",
    "lens_trend": "112233",
    "lsec_2018": "87.3",
    "lsec_2019": "87.6",
    "lsec_2022": "86.9",
    "lsec_2023": "87.6",
    "lsec_2024": "89.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.3",
    "scie_2019": "80.6",
    "scie_2022": "83.0",
    "scie_2023": "85.0",
    "scie_2024": "80.9",
    "scie_trend": "—",
    "math_2018": "82.4",
    "math_2019": "82.0",
    "math_2022": "86.5",
    "math_2023": "86.1",
    "math_2024": "88.0",
    "math_trend": "—",
    "echec_2018": "3.4",
    "echec_2019": "4.2",
    "echec_2022": "3.2",
    "echec_2023": "2.1",
    "echec_2024": "3.6",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "1.4",
    "sures_2022": "1.3",
    "sures_2023": "0.4",
    "sures_2024": "0.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.7",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 6.3",
    "ecart_sexes_lens_2023": "F 2.9",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.8",
    "ecart_sexes_math_2019": "M 1.5",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "F 0.1",
    "ecart_sexes_math_2024": "F 5.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.2",
    "prog_2019": "1.7",
    "prog_2022": "2.1",
    "prog_2023": "3.1",
    "prog_2024": "1.5",
    "prog_trend": "—",
    "cote_2018": "8.7",
    "cote_2019": "8.5",
    "cote_2022": "9.2",
    "cote_2023": "9.4",
    "cote_2024": "9.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Académie Ste-Thérèse, Campus Jacques-About",
    "nom_court": "Ac. Ste-Thérèse, Campus Jacques-About",
    "adresse": "425, rue Blainville Est",
    "municipalite": "Sainte-Thérèse",
    "code_postal": "J7E 1N7",
    "lat": 45.6402,
    "lng": -73.81627
  },
  {
    "_id": "356",
    "school_code": "56501",
    "school_name_1": "Beaubois",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "893",
    "langue": "français",
    "secteur": "privé",
    "rang": "12",
    "rang_5_ans": "14",
    "index": "0.1",
    "en_retard_2024": "1.7",
    "ehdaa_2024": "12.5",
    "rang_2024": "12/470",
    "rang_2019_2024": "14/432",
    "lens_2018": "79.4",
    "lens_2019": "79.0",
    "lens_2022": "77.1",
    "lens_2023": "80.0",
    "lens_2024": "77.8",
    "lens_trend": "112233",
    "lsec_2018": "84.0",
    "lsec_2019": "86.7",
    "lsec_2022": "91.8",
    "lsec_2023": "86.1",
    "lsec_2024": "89.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.1",
    "scie_2019": "83.1",
    "scie_2022": "86.4",
    "scie_2023": "88.0",
    "scie_2024": "87.2",
    "scie_trend": "—",
    "math_2018": "81.4",
    "math_2019": "85.2",
    "math_2022": "89.4",
    "math_2023": "88.2",
    "math_2024": "89.1",
    "math_trend": "112233",
    "echec_2018": "1.7",
    "echec_2019": "2.2",
    "echec_2022": "2.6",
    "echec_2023": "1.4",
    "echec_2024": "2.3",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "0.2",
    "sures_2022": "0.3",
    "sures_2023": "0.8",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.3",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 1.0",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.6",
    "ecart_sexes_math_2019": "M 0.1",
    "ecart_sexes_math_2022": "F 1.1",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "M 1.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.9",
    "prog_2019": "0.8",
    "prog_2022": "0.6",
    "prog_2023": "2.8",
    "prog_2024": "3.9",
    "prog_trend": "—",
    "cote_2018": "9.1",
    "cote_2019": "9.5",
    "cote_2022": "10.0",
    "cote_2023": "9.3",
    "cote_2024": "9.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Beaubois",
    "nom_court": "Collège Beaubois",
    "adresse": "4901, rue du Collège-Beaubois",
    "municipalite": "Montréal",
    "code_postal": "H8Y 3T4",
    "lat": 45.50775,
    "lng": -73.77959
  },
  {
    "_id": "357",
    "school_code": "57501",
    "school_name_1": "Bourget",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1421",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "6.3",
    "ehdaa_2024": "29.3",
    "rang_2024": "40/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "73.2",
    "lens_2019": "72.2",
    "lens_2022": "69.0",
    "lens_2023": "73.4",
    "lens_2024": "70.9",
    "lens_trend": "—",
    "lsec_2018": "81.4",
    "lsec_2019": "84.1",
    "lsec_2022": "86.8",
    "lsec_2023": "89.0",
    "lsec_2024": "88.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.7",
    "scie_2019": "76.1",
    "scie_2022": "72.9",
    "scie_2023": "78.4",
    "scie_2024": "76.2",
    "scie_trend": "—",
    "math_2018": "74.6",
    "math_2019": "72.4",
    "math_2022": "82.4",
    "math_2023": "80.5",
    "math_2024": "86.4",
    "math_trend": "—",
    "echec_2018": "9.1",
    "echec_2019": "11.7",
    "echec_2022": "11.8",
    "echec_2023": "6.6",
    "echec_2024": "7.2",
    "echec_trend": "112233",
    "sures_2018": "0.8",
    "sures_2019": "1.4",
    "sures_2022": "1.1",
    "sures_2023": "0.6",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.6",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 5.7",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.4",
    "ecart_sexes_math_2019": "F 2.1",
    "ecart_sexes_math_2022": "F 3.3",
    "ecart_sexes_math_2023": "F 3.0",
    "ecart_sexes_math_2024": "M 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "6.8",
    "prog_2019": "7.2",
    "prog_2022": "6.9",
    "prog_2023": "10.4",
    "prog_2024": "2.6",
    "prog_trend": "—",
    "cote_2018": "7.5",
    "cote_2019": "7.1",
    "cote_2022": "7.8",
    "cote_2023": "8.0",
    "cote_2024": "8.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Bourget",
    "nom_court": "Collège Bourget",
    "adresse": "65, rue Saint-Pierre",
    "municipalite": "Rigaud",
    "code_postal": "J0P 1P0",
    "lat": 45.474201,
    "lng": -74.307857
  },
  {
    "_id": "358",
    "school_code": "57502",
    "school_name_1": "Bourget, anglaise",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "56",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "252",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "41.1",
    "rang_2024": "252/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "75.3",
    "lens_2023": "77.5",
    "lens_2024": "77.3",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "72.6",
    "lsec_2023": "78.7",
    "lsec_2024": "82.5",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "68.4",
    "scie_2023": "80.5",
    "scie_2024": "68.6",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "45.5",
    "math_2023": "75.1",
    "math_2024": "79.0",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "19.1",
    "echec_2023": "5.7",
    "echec_2024": "9.8",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "9.5",
    "sures_2023": "3.1",
    "sures_2024": "2.9",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "54.5",
    "prog_2023": "52.7",
    "prog_2024": "53.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "3.7",
    "cote_2023": "5.7",
    "cote_2024": "5.7",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "Collège Bourget, section anglaise",
    "nom_court": "Collège Bourget, section anglaise",
    "adresse": "65, rue Saint-Pierre",
    "municipalite": "Rigaud",
    "code_postal": "J0P 1P0",
    "lat": 45.473676,
    "lng": -74.309274
  },
  {
    "_id": "359",
    "school_code": "58501",
    "school_name_1": "Champagneur",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Lanaudière ",
    "étudiants": "396",
    "langue": "français",
    "secteur": "privé",
    "rang": "335",
    "rang_5_ans": "208",
    "index": "0.1",
    "en_retard_2024": "2.5",
    "ehdaa_2024": "51.8",
    "rang_2024": "335/470",
    "rang_2019_2024": "208/432",
    "lens_2018": "71.1",
    "lens_2019": "65.3",
    "lens_2022": "64.6",
    "lens_2023": "69.3",
    "lens_2024": "67.2",
    "lens_trend": "—",
    "lsec_2018": "81.3",
    "lsec_2019": "85.0",
    "lsec_2022": "85.6",
    "lsec_2023": "81.8",
    "lsec_2024": "82.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "70.8",
    "scie_2019": "68.5",
    "scie_2022": "74.6",
    "scie_2023": "73.7",
    "scie_2024": "65.6",
    "scie_trend": "—",
    "math_2018": "73.0",
    "math_2019": "73.2",
    "math_2022": "81.3",
    "math_2023": "69.7",
    "math_2024": "68.5",
    "math_trend": "—",
    "echec_2018": "11.4",
    "echec_2019": "17.8",
    "echec_2022": "15.2",
    "echec_2023": "14.2",
    "echec_2024": "25.6",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "4.9",
    "sures_2022": "5.4",
    "sures_2023": "2.1",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 7.7",
    "ecart_sexes_lens_2022": "F 6.3",
    "ecart_sexes_lens_2023": "M 0.8",
    "ecart_sexes_lens_2024": "F 0.6",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 0.5",
    "ecart_sexes_math_2022": "F 3.5",
    "ecart_sexes_math_2023": "F 6.1",
    "ecart_sexes_math_2024": "M 5.5",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "19.9",
    "prog_2019": "5.4",
    "prog_2022": "14.7",
    "prog_2023": "11.4",
    "prog_2024": "17.3",
    "prog_trend": "—",
    "cote_2018": "6.3",
    "cote_2019": "5.5",
    "cote_2022": "6.8",
    "cote_2023": "6.3",
    "cote_2024": "5.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Champagneur",
    "nom_court": "Collège Champagneur",
    "adresse": "3713, rue Queen",
    "municipalite": "Rawdon",
    "code_postal": "J0K 1S0",
    "lat": 46.04378,
    "lng": -73.71073
  },
  {
    "_id": "360",
    "school_code": "59501",
    "school_name_1": "Charlemagne",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "648",
    "langue": "français",
    "secteur": "privé",
    "rang": "12",
    "rang_5_ans": "7",
    "index": "0.1",
    "en_retard_2024": "3.1",
    "ehdaa_2024": "8.3",
    "rang_2024": "12/470",
    "rang_2019_2024": "7/432",
    "lens_2018": "78.6",
    "lens_2019": "78.6",
    "lens_2022": "75.4",
    "lens_2023": "75.4",
    "lens_2024": "71.5",
    "lens_trend": "998855",
    "lsec_2018": "81.9",
    "lsec_2019": "86.3",
    "lsec_2022": "90.0",
    "lsec_2023": "92.0",
    "lsec_2024": "91.5",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.5",
    "scie_2019": "87.1",
    "scie_2022": "86.2",
    "scie_2023": "88.2",
    "scie_2024": "88.0",
    "scie_trend": "—",
    "math_2018": "84.7",
    "math_2019": "93.0",
    "math_2022": "91.8",
    "math_2023": "91.8",
    "math_2024": "92.7",
    "math_trend": "—",
    "echec_2018": "3.4",
    "echec_2019": "0.2",
    "echec_2022": "2.2",
    "echec_2023": "2.4",
    "echec_2024": "5.5",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "0.0",
    "sures_2022": "0.0",
    "sures_2023": "0.0",
    "sures_2024": "0.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.9",
    "ecart_sexes_lens_2019": "F 2.3",
    "ecart_sexes_lens_2022": "F 1.4",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "F 1.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.9",
    "ecart_sexes_math_2019": "M 1.8",
    "ecart_sexes_math_2022": "M 0.3",
    "ecart_sexes_math_2023": "M 1.7",
    "ecart_sexes_math_2024": "F 0.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.7",
    "prog_2019": "3.4",
    "prog_2022": "1.5",
    "prog_2023": "1.6",
    "prog_2024": "2.3",
    "prog_trend": "—",
    "cote_2018": "9.1",
    "cote_2019": "10.0",
    "cote_2022": "10.0",
    "cote_2023": "9.6",
    "cote_2024": "9.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Charlemagne inc.",
    "nom_court": "Collège Charlemagne",
    "adresse": "5000, rue Pilon",
    "municipalite": "Montréal",
    "code_postal": "H9K 1G4",
    "lat": 45.459,
    "lng": -73.91828
  },
  {
    "_id": "361",
    "school_code": "65501",
    "school_name_1": "Charles-Lemoyne Sainte-Catherine",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1566",
    "langue": "français",
    "secteur": "privé",
    "rang": "96",
    "rang_5_ans": "89",
    "index": "0.1",
    "en_retard_2024": "4.1",
    "ehdaa_2024": "31.8",
    "rang_2024": "96/470",
    "rang_2019_2024": "89/432",
    "lens_2018": "71.4",
    "lens_2019": "73.2",
    "lens_2022": "66.0",
    "lens_2023": "71.8",
    "lens_2024": "68.2",
    "lens_trend": "—",
    "lsec_2018": "81.4",
    "lsec_2019": "81.7",
    "lsec_2022": "85.1",
    "lsec_2023": "88.2",
    "lsec_2024": "82.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "72.0",
    "scie_2019": "72.1",
    "scie_2022": "72.7",
    "scie_2023": "77.2",
    "scie_2024": "73.4",
    "scie_trend": "112233",
    "math_2018": "75.2",
    "math_2019": "78.8",
    "math_2022": "81.5",
    "math_2023": "80.9",
    "math_2024": "81.9",
    "math_trend": "—",
    "echec_2018": "12.5",
    "echec_2019": "8.8",
    "echec_2022": "13.1",
    "echec_2023": "6.8",
    "echec_2024": "10.5",
    "echec_trend": "112233",
    "sures_2018": "0.8",
    "sures_2019": "1.5",
    "sures_2022": "2.2",
    "sures_2023": "1.9",
    "sures_2024": "3.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.4",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 7.8",
    "ecart_sexes_lens_2023": "F 6.5",
    "ecart_sexes_lens_2024": "F 3.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.5",
    "ecart_sexes_math_2019": "F 9.6",
    "ecart_sexes_math_2022": "F 2.9",
    "ecart_sexes_math_2023": "F 1.3",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.0",
    "prog_2019": "3.8",
    "prog_2022": "4.2",
    "prog_2023": "8.7",
    "prog_2024": "5.3",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "7.4",
    "cote_2022": "7.7",
    "cote_2023": "8.1",
    "cote_2024": "7.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Charles-Lemoyne, Campus Ville de Sainte-Catherine",
    "nom_court": "Col. Charles-L., C.Ville Ste-Catherine",
    "adresse": "125, Place Charles-Lemoyne",
    "municipalite": "Sainte-Catherine",
    "code_postal": "J5C 0A1",
    "lat": 45.39935,
    "lng": -73.54862
  },
  {
    "_id": "362",
    "school_code": "65505",
    "school_name_1": "Charles-Lemoyne Saint-Lambert",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1326",
    "langue": "français",
    "secteur": "privé",
    "rang": "49",
    "rang_5_ans": "55",
    "index": "0.1",
    "en_retard_2024": "6.6",
    "ehdaa_2024": "44.3",
    "rang_2024": "49/470",
    "rang_2019_2024": "55/432",
    "lens_2018": "77.4",
    "lens_2019": "73.7",
    "lens_2022": "71.7",
    "lens_2023": "73.4",
    "lens_2024": "70.2",
    "lens_trend": "—",
    "lsec_2018": "81.1",
    "lsec_2019": "82.6",
    "lsec_2022": "85.7",
    "lsec_2023": "80.0",
    "lsec_2024": "86.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.3",
    "scie_2019": "73.2",
    "scie_2022": "71.9",
    "scie_2023": "77.9",
    "scie_2024": "72.9",
    "scie_trend": "—",
    "math_2018": "82.3",
    "math_2019": "82.3",
    "math_2022": "79.3",
    "math_2023": "78.8",
    "math_2024": "84.5",
    "math_trend": "—",
    "echec_2018": "3.8",
    "echec_2019": "7.0",
    "echec_2022": "11.8",
    "echec_2023": "9.2",
    "echec_2024": "9.9",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "1.6",
    "sures_2022": "1.5",
    "sures_2023": "3.5",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 4.4",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "M 1.1",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "F 7.7",
    "ecart_sexes_math_2024": "M 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.6",
    "prog_2019": "3.2",
    "prog_2022": "2.7",
    "prog_2023": "3.4",
    "prog_2024": "3.0",
    "prog_trend": "112233",
    "cote_2018": "8.4",
    "cote_2019": "8.1",
    "cote_2022": "8.2",
    "cote_2023": "7.3",
    "cote_2024": "8.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Charles-Lemoyne, Campus Longueuil Saint-Lambert",
    "nom_court": "C. Ch.-Lemoyne, C. Longueuil-St-Lambert",
    "adresse": "901, chemin Tiffin",
    "municipalite": "Longueuil",
    "code_postal": "J4P 3G6",
    "lat": 45.51437,
    "lng": -73.50985
  },
  {
    "_id": "363",
    "school_code": "66501",
    "school_name_1": "Clarétain",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Centre-du-Québec ",
    "étudiants": "468",
    "langue": "français",
    "secteur": "privé",
    "rang": "260",
    "rang_5_ans": "155",
    "index": "0.1",
    "en_retard_2024": "2.9",
    "ehdaa_2024": "29.3",
    "rang_2024": "260/470",
    "rang_2019_2024": "155/432",
    "lens_2018": "72.5",
    "lens_2019": "72.9",
    "lens_2022": "71.6",
    "lens_2023": "69.2",
    "lens_2024": "70.7",
    "lens_trend": "—",
    "lsec_2018": "81.6",
    "lsec_2019": "80.1",
    "lsec_2022": "77.0",
    "lsec_2023": "80.2",
    "lsec_2024": "74.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.6",
    "scie_2019": "76.1",
    "scie_2022": "73.6",
    "scie_2023": "79.1",
    "scie_2024": "72.5",
    "scie_trend": "—",
    "math_2018": "72.9",
    "math_2019": "68.3",
    "math_2022": "77.3",
    "math_2023": "76.3",
    "math_2024": "75.5",
    "math_trend": "—",
    "echec_2018": "10.4",
    "echec_2019": "14.2",
    "echec_2022": "10.6",
    "echec_2023": "11.9",
    "echec_2024": "16.8",
    "echec_trend": "—",
    "sures_2018": "3.8",
    "sures_2019": "4.1",
    "sures_2022": "2.5",
    "sures_2023": "2.0",
    "sures_2024": "2.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 6.1",
    "ecart_sexes_lens_2023": "F 8.3",
    "ecart_sexes_lens_2024": "F 2.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.3",
    "ecart_sexes_math_2019": "F 5.7",
    "ecart_sexes_math_2022": "F 3.6",
    "ecart_sexes_math_2023": "M 4.2",
    "ecart_sexes_math_2024": "F 17.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.1",
    "prog_2019": "5.1",
    "prog_2022": "7.2",
    "prog_2023": "10.1",
    "prog_2024": "12.6",
    "prog_trend": "998855",
    "cote_2018": "6.9",
    "cote_2019": "6.3",
    "cote_2022": "6.9",
    "cote_2023": "6.5",
    "cote_2024": "5.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Clarétain de Victoriaville",
    "nom_court": "Collège Clarétain de Victoriaville",
    "adresse": "663, rue Gamache",
    "municipalite": "Victoriaville",
    "code_postal": "G6R 0W3",
    "lat": 46.04185,
    "lng": -71.96921
  },
  {
    "_id": "364",
    "school_code": "69501",
    "school_name_1": "de Champigny",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "714",
    "langue": "français",
    "secteur": "privé",
    "rang": "156",
    "rang_5_ans": "114",
    "index": "0.1",
    "en_retard_2024": "16.5",
    "ehdaa_2024": "30",
    "rang_2024": "156/470",
    "rang_2019_2024": "114/432",
    "lens_2018": "72.8",
    "lens_2019": "68.4",
    "lens_2022": "70.9",
    "lens_2023": "71.8",
    "lens_2024": "69.1",
    "lens_trend": "—",
    "lsec_2018": "80.3",
    "lsec_2019": "83.2",
    "lsec_2022": "83.3",
    "lsec_2023": "78.0",
    "lsec_2024": "82.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "75.9",
    "scie_2022": "73.4",
    "scie_2023": "74.9",
    "scie_2024": "68.6",
    "scie_trend": "—",
    "math_2018": "75.4",
    "math_2019": "79.7",
    "math_2022": "81.4",
    "math_2023": "79.0",
    "math_2024": "79.7",
    "math_trend": "—",
    "echec_2018": "10.6",
    "echec_2019": "9.2",
    "echec_2022": "12.0",
    "echec_2023": "9.1",
    "echec_2024": "12.4",
    "echec_trend": "—",
    "sures_2018": "2.4",
    "sures_2019": "2.7",
    "sures_2022": "1.6",
    "sures_2023": "0.7",
    "sures_2024": "3.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 2.5",
    "ecart_sexes_lens_2022": "F 5.9",
    "ecart_sexes_lens_2023": "F 5.1",
    "ecart_sexes_lens_2024": "F 6.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.4",
    "ecart_sexes_math_2019": "F 2.1",
    "ecart_sexes_math_2022": "M 3.5",
    "ecart_sexes_math_2023": "F 4.4",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "7.9",
    "prog_2019": "7.6",
    "prog_2022": "4.8",
    "prog_2023": "12.3",
    "prog_2024": "9.1",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "7.0",
    "cote_2022": "7.6",
    "cote_2023": "6.9",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège de Champigny",
    "nom_court": "Collège de Champigny",
    "adresse": "1400, route de l'Aéroport",
    "municipalite": "Québec",
    "code_postal": "G2G 1G6",
    "lat": 46.79087,
    "lng": -71.36185
  },
  {
    "_id": "365",
    "school_code": "74501",
    "school_name_1": "L'Assomption",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Lanaudière ",
    "étudiants": "1387",
    "langue": "français",
    "secteur": "privé",
    "rang": "29",
    "rang_5_ans": "24",
    "index": "0.1",
    "en_retard_2024": "0.4",
    "ehdaa_2024": "18",
    "rang_2024": "29/470",
    "rang_2019_2024": "24/432",
    "lens_2018": "78.6",
    "lens_2019": "79.3",
    "lens_2022": "76.2",
    "lens_2023": "77.1",
    "lens_2024": "75.9",
    "lens_trend": "—",
    "lsec_2018": "81.9",
    "lsec_2019": "82.3",
    "lsec_2022": "84.6",
    "lsec_2023": "86.1",
    "lsec_2024": "84.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "85.5",
    "scie_2019": "80.5",
    "scie_2022": "74.4",
    "scie_2023": "85.0",
    "scie_2024": "80.2",
    "scie_trend": "—",
    "math_2018": "80.9",
    "math_2019": "82.6",
    "math_2022": "86.4",
    "math_2023": "85.1",
    "math_2024": "84.2",
    "math_trend": "—",
    "echec_2018": "3.1",
    "echec_2019": "4.0",
    "echec_2022": "7.2",
    "echec_2023": "3.2",
    "echec_2024": "4.8",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.9",
    "sures_2022": "2.2",
    "sures_2023": "0.1",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.5",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 0.5",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "F 0.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.5",
    "ecart_sexes_math_2019": "F 0.4",
    "ecart_sexes_math_2022": "F 1.1",
    "ecart_sexes_math_2023": "F 0.8",
    "ecart_sexes_math_2024": "F 2.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.0",
    "prog_2019": "0.0",
    "prog_2022": "1.0",
    "prog_2023": "1.7",
    "prog_2024": "4.5",
    "prog_trend": "—",
    "cote_2018": "8.9",
    "cote_2019": "8.8",
    "cote_2022": "8.8",
    "cote_2023": "9.1",
    "cote_2024": "8.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège de l'Assomption ",
    "nom_court": "Col. de l'Assomption",
    "adresse": "270, boulevard de l'Ange-Gardien",
    "municipalite": "L'Assomption",
    "code_postal": "J5W 1R7",
    "lat": 45.82766,
    "lng": -73.42077
  },
  {
    "_id": "366",
    "school_code": "75501",
    "school_name_1": "Collège de l'Ouest de l'Île",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "216",
    "langue": "français",
    "secteur": "privé",
    "rang": "35",
    "rang_5_ans": "43",
    "index": "0.1",
    "en_retard_2024": "2.1",
    "ehdaa_2024": "6",
    "rang_2024": "35/470",
    "rang_2019_2024": "43/432",
    "lens_2018": "70.3",
    "lens_2019": "72.6",
    "lens_2022": "72.4",
    "lens_2023": "66.9",
    "lens_2024": "69.5",
    "lens_trend": "—",
    "lsec_2018": "77.9",
    "lsec_2019": "83.0",
    "lsec_2022": "85.8",
    "lsec_2023": "85.1",
    "lsec_2024": "85.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "89.4",
    "scie_2019": "83.6",
    "scie_2022": "78.7",
    "scie_2023": "82.0",
    "scie_2024": "85.1",
    "scie_trend": "—",
    "math_2018": "88.4",
    "math_2019": "88.7",
    "math_2022": "79.7",
    "math_2023": "79.8",
    "math_2024": "89.8",
    "math_trend": "—",
    "echec_2018": "2.7",
    "echec_2019": "3.7",
    "echec_2022": "8.2",
    "echec_2023": "8.9",
    "echec_2024": "5.1",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.2",
    "sures_2022": "0.8",
    "sures_2023": "2.6",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "M 2.1",
    "ecart_sexes_lens_2023": "F 12.0",
    "ecart_sexes_lens_2024": "F 8.7",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 2.1",
    "ecart_sexes_math_2022": "F 2.3",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.1",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "3.8",
    "prog_2024": "8.3",
    "prog_trend": "—",
    "cote_2018": "8.6",
    "cote_2019": "8.7",
    "cote_2022": "8.6",
    "cote_2023": "7.0",
    "cote_2024": "8.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège de l'Ouest de l'Île, section française",
    "nom_court": "Coll. de l'Ouest de l'Île, s. française",
    "adresse": "851, rue Tecumseh",
    "municipalite": "Dollard-des-Ormeaux",
    "code_postal": "H9B 2L2",
    "lat": 45.47874,
    "lng": -73.81483
  },
  {
    "_id": "367",
    "school_code": "75502",
    "school_name_1": "West Island College",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "255",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "101",
    "rang_5_ans": "55",
    "index": "0.1",
    "en_retard_2024": "2.1",
    "ehdaa_2024": "12.5",
    "rang_2024": "101/470",
    "rang_2019_2024": "55/432",
    "lens_2018": "78.7",
    "lens_2019": "84.0",
    "lens_2022": "83.6",
    "lens_2023": "85.2",
    "lens_2024": "82.0",
    "lens_trend": "—",
    "lsec_2018": "81.3",
    "lsec_2019": "83.2",
    "lsec_2022": "79.5",
    "lsec_2023": "83.9",
    "lsec_2024": "81.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.5",
    "scie_2019": "80.5",
    "scie_2022": "79.2",
    "scie_2023": "83.9",
    "scie_2024": "77.2",
    "scie_trend": "—",
    "math_2018": "83.1",
    "math_2019": "84.0",
    "math_2022": "76.8",
    "math_2023": "82.7",
    "math_2024": "86.3",
    "math_trend": "—",
    "echec_2018": "2.4",
    "echec_2019": "3.8",
    "echec_2022": "7.1",
    "echec_2023": "2.4",
    "echec_2024": "7.9",
    "echec_trend": "998855",
    "sures_2018": "1.5",
    "sures_2019": "1.2",
    "sures_2022": "3.9",
    "sures_2023": "0.9",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 0.2",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 7.3",
    "ecart_sexes_lens_2023": "F 6.4",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.0",
    "ecart_sexes_math_2019": "M 7.7",
    "ecart_sexes_math_2022": "F 1.7",
    "ecart_sexes_math_2023": "F 6.2",
    "ecart_sexes_math_2024": "M 10.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "0.0",
    "prog_2022": "1.6",
    "prog_2023": "0.0",
    "prog_2024": "2.1",
    "prog_trend": "—",
    "cote_2018": "8.5",
    "cote_2019": "8.4",
    "cote_2022": "8.0",
    "cote_2023": "8.3",
    "cote_2024": "7.4",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Collège de l'Ouest de l'Île, section anglaise",
    "nom_court": "Coll. de l'Ouest de l'Île, s. anglaise",
    "adresse": "851, rue Tecumseh",
    "municipalite": "Dollard-des-Ormeaux",
    "code_postal": "H9B 2L2",
    "lat": 45.47874,
    "lng": -73.81483
  },
  {
    "_id": "368",
    "school_code": "76501",
    "school_name_1": "Lévis",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "980",
    "langue": "français",
    "secteur": "privé",
    "rang": "80",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "0.6",
    "ehdaa_2024": "11.9",
    "rang_2024": "80/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "74.5",
    "lens_2019": "76.6",
    "lens_2022": "69.2",
    "lens_2023": "73.0",
    "lens_2024": "72.2",
    "lens_trend": "—",
    "lsec_2018": "78.9",
    "lsec_2019": "78.4",
    "lsec_2022": "80.1",
    "lsec_2023": "82.4",
    "lsec_2024": "76.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.2",
    "scie_2019": "86.0",
    "scie_2022": "80.9",
    "scie_2023": "89.0",
    "scie_2024": "85.3",
    "scie_trend": "—",
    "math_2018": "81.6",
    "math_2019": "87.3",
    "math_2022": "79.5",
    "math_2023": "85.5",
    "math_2024": "83.4",
    "math_trend": "—",
    "echec_2018": "5.0",
    "echec_2019": "2.2",
    "echec_2022": "9.4",
    "echec_2023": "4.8",
    "echec_2024": "7.2",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "0.2",
    "sures_2022": "2.6",
    "sures_2023": "1.5",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.4",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 5.6",
    "ecart_sexes_lens_2023": "F 4.6",
    "ecart_sexes_lens_2024": "F 6.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.5",
    "ecart_sexes_math_2019": "F 1.7",
    "ecart_sexes_math_2022": "M 1.6",
    "ecart_sexes_math_2023": "F 5.6",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.0",
    "prog_2019": "3.0",
    "prog_2022": "2.1",
    "prog_2023": "4.8",
    "prog_2024": "1.2",
    "prog_trend": "112233",
    "cote_2018": "8.1",
    "cote_2019": "9.0",
    "cote_2022": "7.7",
    "cote_2023": "8.2",
    "cote_2024": "7.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège de Lévis",
    "nom_court": "Collège de Lévis",
    "adresse": "9, rue Monseigneur-Gosselin",
    "municipalite": "Lévis",
    "code_postal": "G6V 5K1",
    "lat": 46.81241,
    "lng": -71.18177
  },
  {
    "_id": "369",
    "school_code": "77501",
    "school_name_1": "Collège de Montréal",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1523",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "4.7",
    "ehdaa_2024": "21.2",
    "rang_2024": "69/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "73.4",
    "lens_2019": "73.9",
    "lens_2022": "73.5",
    "lens_2023": "75.6",
    "lens_2024": "73.9",
    "lens_trend": "112233",
    "lsec_2018": "75.1",
    "lsec_2019": "76.3",
    "lsec_2022": "74.1",
    "lsec_2023": "75.7",
    "lsec_2024": "76.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.2",
    "scie_2019": "79.3",
    "scie_2022": "79.2",
    "scie_2023": "82.9",
    "scie_2024": "80.4",
    "scie_trend": "112233",
    "math_2018": "80.6",
    "math_2019": "82.1",
    "math_2022": "81.7",
    "math_2023": "84.0",
    "math_2024": "82.0",
    "math_trend": "—",
    "echec_2018": "4.7",
    "echec_2019": "6.7",
    "echec_2022": "8.8",
    "echec_2023": "5.4",
    "echec_2024": "7.7",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "2.2",
    "sures_2022": "3.2",
    "sures_2023": "1.9",
    "sures_2024": "1.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 4.6",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.3",
    "ecart_sexes_math_2019": "F 2.5",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.2",
    "prog_2019": "3.4",
    "prog_2022": "4.1",
    "prog_2023": "5.6",
    "prog_2024": "2.8",
    "prog_trend": "—",
    "cote_2018": "7.4",
    "cote_2019": "7.5",
    "cote_2022": "7.4",
    "cote_2023": "7.6",
    "cote_2024": "7.9",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège de Montréal",
    "nom_court": "Col. de Montréal",
    "adresse": "1931, rue Sherbrooke Ouest",
    "municipalite": "Montréal",
    "code_postal": "H3H 1E3",
    "lat": 45.49517,
    "lng": -73.58451
  },
  {
    "_id": "370",
    "school_code": "79501",
    "school_name_1": "Sainte-Anne de La Pocatière",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "454",
    "langue": "français",
    "secteur": "privé",
    "rang": "120",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "12.1",
    "rang_2024": "120/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "73.7",
    "lens_2019": "75.5",
    "lens_2022": "71.6",
    "lens_2023": "73.5",
    "lens_2024": "68.4",
    "lens_trend": "—",
    "lsec_2018": "80.4",
    "lsec_2019": "81.1",
    "lsec_2022": "80.0",
    "lsec_2023": "79.6",
    "lsec_2024": "76.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.2",
    "scie_2019": "82.6",
    "scie_2022": "78.5",
    "scie_2023": "80.2",
    "scie_2024": "79.8",
    "scie_trend": "—",
    "math_2018": "81.2",
    "math_2019": "78.1",
    "math_2022": "82.9",
    "math_2023": "84.4",
    "math_2024": "81.1",
    "math_trend": "—",
    "echec_2018": "5.5",
    "echec_2019": "4.9",
    "echec_2022": "8.2",
    "echec_2023": "9.7",
    "echec_2024": "10.0",
    "echec_trend": "998855",
    "sures_2018": "1.6",
    "sures_2019": "0.9",
    "sures_2022": "1.4",
    "sures_2023": "1.4",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.5",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 5.4",
    "ecart_sexes_lens_2023": "F 3.6",
    "ecart_sexes_lens_2024": "F 3.1",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "F 3.2",
    "ecart_sexes_math_2019": "F 6.0",
    "ecart_sexes_math_2022": "M 2.9",
    "ecart_sexes_math_2023": "F 2.1",
    "ecart_sexes_math_2024": "F 4.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.6",
    "prog_2019": "11.6",
    "prog_2022": "8.3",
    "prog_2023": "7.7",
    "prog_2024": "6.1",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "7.7",
    "cote_2022": "7.7",
    "cote_2023": "7.5",
    "cote_2024": "7.0",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Collège de Sainte-Anne-de-La-Pocatière",
    "nom_court": "Collège de Sainte-Anne-de-La-Pocatière",
    "adresse": "100, 4e Avenue",
    "municipalite": "La Pocatière",
    "code_postal": "G0R 1Z0",
    "lat": 47.36684,
    "lng": -70.04093
  },
  {
    "_id": "371",
    "school_code": "85501",
    "school_name_1": "Jésus-Marie Bellechasse",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "258",
    "langue": "français",
    "secteur": "privé",
    "rang": "367",
    "rang_5_ans": "268",
    "index": "0.1",
    "en_retard_2024": "32.5",
    "ehdaa_2024": "26.7",
    "rang_2024": "367/470",
    "rang_2019_2024": "268/432",
    "lens_2018": "68.9",
    "lens_2019": "69.9",
    "lens_2022": "71.8",
    "lens_2023": "75.3",
    "lens_2024": "63.2",
    "lens_trend": "—",
    "lsec_2018": "69.8",
    "lsec_2019": "71.5",
    "lsec_2022": "73.6",
    "lsec_2023": "76.9",
    "lsec_2024": "78.6",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.1",
    "scie_2019": "66.8",
    "scie_2022": "71.0",
    "scie_2023": "67.8",
    "scie_2024": "68.2",
    "scie_trend": "—",
    "math_2018": "76.1",
    "math_2019": "76.4",
    "math_2022": "78.1",
    "math_2023": "67.7",
    "math_2024": "71.5",
    "math_trend": "—",
    "echec_2018": "13.1",
    "echec_2019": "16.7",
    "echec_2022": "16.2",
    "echec_2023": "20.1",
    "echec_2024": "23.1",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.4",
    "sures_2022": "2.4",
    "sures_2023": "2.1",
    "sures_2024": "7.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.9",
    "ecart_sexes_lens_2019": "F 1.1",
    "ecart_sexes_lens_2022": "F 10.5",
    "ecart_sexes_lens_2023": "F 6.8",
    "ecart_sexes_lens_2024": "F 0.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.2",
    "ecart_sexes_math_2019": "F 4.1",
    "ecart_sexes_math_2022": "F 2.1",
    "ecart_sexes_math_2023": "M 1.2",
    "ecart_sexes_math_2024": "F 2.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "21.2",
    "prog_2019": "16.8",
    "prog_2022": "6.2",
    "prog_2023": "21.1",
    "prog_2024": "12.9",
    "prog_trend": "—",
    "cote_2018": "5.7",
    "cote_2019": "5.5",
    "cote_2022": "6.4",
    "cote_2023": "5.4",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Jésus-Marie de Bellechasse",
    "nom_court": "Collège Jésus-Marie de Bellechasse",
    "adresse": "1, rue Saint-Georges",
    "municipalite": "Saint-Michel-de-Bellechasse",
    "code_postal": "G0R 3S0",
    "lat": 46.87684,
    "lng": -70.90643
  },
  {
    "_id": "372",
    "school_code": "86501",
    "school_name_1": "Mont-Sainte-Anne",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "278",
    "langue": "français",
    "secteur": "privé",
    "rang": "238",
    "rang_5_ans": "355",
    "index": "0.1",
    "en_retard_2024": "17.8",
    "ehdaa_2024": "41",
    "rang_2024": "238/470",
    "rang_2019_2024": "355/432",
    "lens_2018": "66.9",
    "lens_2019": "71.3",
    "lens_2022": "55.6",
    "lens_2023": "69.6",
    "lens_2024": "64.1",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "77.4",
    "lsec_2022": "80.8",
    "lsec_2023": "71.4",
    "lsec_2024": "77.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.7",
    "scie_2019": "72.5",
    "scie_2022": "73.9",
    "scie_2023": "68.6",
    "scie_2024": "69.7",
    "scie_trend": "—",
    "math_2018": "71.0",
    "math_2019": "66.7",
    "math_2022": "58.6",
    "math_2023": "57.6",
    "math_2024": "75.8",
    "math_trend": "—",
    "echec_2018": "15.8",
    "echec_2019": "18.5",
    "echec_2022": "28.5",
    "echec_2023": "27.6",
    "echec_2024": "15.6",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "3.5",
    "sures_2022": "5.4",
    "sures_2023": "4.4",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "16.3",
    "prog_2019": "11.4",
    "prog_2022": "33.9",
    "prog_2023": "43.2",
    "prog_2024": "11.6",
    "prog_trend": "—",
    "cote_2018": "5.6",
    "cote_2019": "5.3",
    "cote_2022": "3.9",
    "cote_2023": "2.9",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège du Mont-Sainte-Anne",
    "nom_court": "Collège du Mont-Sainte-Anne",
    "adresse": "2100, chemin Sainte-Catherine",
    "municipalite": "Sherbrooke",
    "code_postal": "J1N 3V5",
    "lat": 45.37123,
    "lng": -71.93091
  },
  {
    "_id": "373",
    "school_code": "88501",
    "school_name_1": "Durocher Saint-Lambert",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1468",
    "langue": "français",
    "secteur": "privé",
    "rang": "28",
    "rang_5_ans": "24",
    "index": "0.1",
    "en_retard_2024": "1.2",
    "ehdaa_2024": "15.3",
    "rang_2024": "28/470",
    "rang_2019_2024": "24/432",
    "lens_2018": "73.0",
    "lens_2019": "75.5",
    "lens_2022": "68.7",
    "lens_2023": "73.7",
    "lens_2024": "70.6",
    "lens_trend": "—",
    "lsec_2018": "86.2",
    "lsec_2019": "89.2",
    "lsec_2022": "90.1",
    "lsec_2023": "87.4",
    "lsec_2024": "90.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.3",
    "scie_2019": "82.5",
    "scie_2022": "84.4",
    "scie_2023": "87.6",
    "scie_2024": "84.6",
    "scie_trend": "—",
    "math_2018": "83.9",
    "math_2019": "84.2",
    "math_2022": "85.5",
    "math_2023": "85.7",
    "math_2024": "86.9",
    "math_trend": "—",
    "echec_2018": "4.6",
    "echec_2019": "4.1",
    "echec_2022": "7.6",
    "echec_2023": "4.4",
    "echec_2024": "5.5",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "0.7",
    "sures_2022": "3.5",
    "sures_2023": "1.8",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.1",
    "ecart_sexes_lens_2019": "F 5.0",
    "ecart_sexes_lens_2022": "F 6.4",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 2.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.0",
    "ecart_sexes_math_2019": "F 0.1",
    "ecart_sexes_math_2022": "F 1.5",
    "ecart_sexes_math_2023": "F 1.8",
    "ecart_sexes_math_2024": "F 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.7",
    "prog_2019": "1.1",
    "prog_2022": "0.6",
    "prog_2023": "4.3",
    "prog_2024": "1.5",
    "prog_trend": "—",
    "cote_2018": "8.8",
    "cote_2019": "9.2",
    "cote_2022": "8.7",
    "cote_2023": "8.7",
    "cote_2024": "9.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Durocher Saint-Lambert (pavillon Durocher)",
    "nom_court": "Col. Durocher St-Lambert (p. Durocher)",
    "adresse": "857, rue Riverside",
    "municipalite": "Saint-Lambert",
    "code_postal": "J4P 1C2",
    "lat": 45.51568,
    "lng": -73.51767
  },
  {
    "_id": "374",
    "school_code": "89501",
    "school_name_1": "Esther Blondin",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Lanaudière ",
    "étudiants": "1358",
    "langue": "français",
    "secteur": "privé",
    "rang": "112",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "17.1",
    "rang_2024": "112/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "76.1",
    "lens_2019": "75.2",
    "lens_2022": "71.3",
    "lens_2023": "72.6",
    "lens_2024": "68.1",
    "lens_trend": "998855",
    "lsec_2018": "76.1",
    "lsec_2019": "76.4",
    "lsec_2022": "78.4",
    "lsec_2023": "80.1",
    "lsec_2024": "79.7",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.5",
    "scie_2019": "77.4",
    "scie_2022": "73.9",
    "scie_2023": "80.0",
    "scie_2024": "74.4",
    "scie_trend": "—",
    "math_2018": "82.7",
    "math_2019": "82.8",
    "math_2022": "79.1",
    "math_2023": "81.6",
    "math_2024": "85.1",
    "math_trend": "—",
    "echec_2018": "6.5",
    "echec_2019": "5.0",
    "echec_2022": "13.4",
    "echec_2023": "5.5",
    "echec_2024": "11.1",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "1.2",
    "sures_2022": "2.0",
    "sures_2023": "0.2",
    "sures_2024": "2.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.7",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 3.1",
    "ecart_sexes_lens_2024": "F 4.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.8",
    "ecart_sexes_math_2019": "F 5.1",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "F 4.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.7",
    "prog_2019": "3.3",
    "prog_2022": "5.0",
    "prog_2023": "8.9",
    "prog_2024": "5.6",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "7.7",
    "cote_2022": "7.4",
    "cote_2023": "8.0",
    "cote_2024": "7.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Esther Blondin ",
    "nom_court": "Col. Esther Blondin",
    "adresse": "101, rue Sainte-Anne",
    "municipalite": "Saint-Jacques",
    "code_postal": "J0K 2R0",
    "lat": 45.95728,
    "lng": -73.56353
  },
  {
    "_id": "375",
    "school_code": "96502",
    "school_name_1": "Collège Français",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1040",
    "langue": "français",
    "secteur": "privé",
    "rang": "59",
    "rang_5_ans": "43",
    "index": "0.1",
    "en_retard_2024": "2.1",
    "ehdaa_2024": "17.4",
    "rang_2024": "59/470",
    "rang_2019_2024": "43/432",
    "lens_2018": "75.3",
    "lens_2019": "75.5",
    "lens_2022": "73.4",
    "lens_2023": "75.4",
    "lens_2024": "73.9",
    "lens_trend": "112233",
    "lsec_2018": "83.7",
    "lsec_2019": "82.5",
    "lsec_2022": "82.5",
    "lsec_2023": "82.8",
    "lsec_2024": "82.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.9",
    "scie_2019": "76.9",
    "scie_2022": "78.9",
    "scie_2023": "83.4",
    "scie_2024": "75.6",
    "scie_trend": "—",
    "math_2018": "78.1",
    "math_2019": "79.8",
    "math_2022": "84.1",
    "math_2023": "85.7",
    "math_2024": "84.5",
    "math_trend": "—",
    "echec_2018": "5.2",
    "echec_2019": "5.1",
    "echec_2022": "7.3",
    "echec_2023": "3.0",
    "echec_2024": "5.6",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "2.6",
    "sures_2022": "0.8",
    "sures_2023": "0.6",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.0",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 4.7",
    "ecart_sexes_lens_2023": "F 1.7",
    "ecart_sexes_lens_2024": "F 4.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "F 0.6",
    "ecart_sexes_math_2022": "F 0.2",
    "ecart_sexes_math_2023": "M 0.5",
    "ecart_sexes_math_2024": "F 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.2",
    "prog_2019": "2.1",
    "prog_2022": "5.0",
    "prog_2023": "1.8",
    "prog_2024": "1.0",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "7.8",
    "cote_2022": "8.4",
    "cote_2023": "8.8",
    "cote_2024": "8.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Français, Campus de Longueuil",
    "nom_court": "Collège Français, Campus de Longueuil",
    "adresse": "1340, boulevard Nobert",
    "municipalite": "Longueuil",
    "code_postal": "J4K 2P4",
    "lat": 45.50792,
    "lng": -73.48393
  },
  {
    "_id": "376",
    "school_code": "99501",
    "school_name_1": "Collège Héritage",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "567",
    "langue": "français",
    "secteur": "privé",
    "rang": "80",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "3.8",
    "ehdaa_2024": "22.9",
    "rang_2024": "80/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "78.0",
    "lens_2019": "78.7",
    "lens_2022": "73.8",
    "lens_2023": "74.4",
    "lens_2024": "72.9",
    "lens_trend": "998855",
    "lsec_2018": "88.5",
    "lsec_2019": "85.9",
    "lsec_2022": "84.3",
    "lsec_2023": "85.0",
    "lsec_2024": "83.6",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.1",
    "scie_2019": "75.2",
    "scie_2022": "78.2",
    "scie_2023": "82.0",
    "scie_2024": "75.5",
    "scie_trend": "—",
    "math_2018": "75.0",
    "math_2019": "77.4",
    "math_2022": "82.8",
    "math_2023": "76.2",
    "math_2024": "78.8",
    "math_trend": "—",
    "echec_2018": "5.8",
    "echec_2019": "6.8",
    "echec_2022": "8.4",
    "echec_2023": "7.6",
    "echec_2024": "8.8",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.7",
    "sures_2022": "1.7",
    "sures_2023": "1.7",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.1",
    "ecart_sexes_lens_2019": "M 0.4",
    "ecart_sexes_lens_2022": "F 1.6",
    "ecart_sexes_lens_2023": "F 6.9",
    "ecart_sexes_lens_2024": "F 3.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.0",
    "ecart_sexes_math_2019": "M 0.4",
    "ecart_sexes_math_2022": "M 0.1",
    "ecart_sexes_math_2023": "M 5.1",
    "ecart_sexes_math_2024": "M 1.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "3.2",
    "prog_2019": "3.6",
    "prog_2022": "3.2",
    "prog_2023": "5.2",
    "prog_2024": "5.1",
    "prog_trend": "—",
    "cote_2018": "8.5",
    "cote_2019": "8.5",
    "cote_2022": "8.5",
    "cote_2023": "7.5",
    "cote_2024": "7.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Héritage de Châteauguay inc.",
    "nom_court": "Collège Héritage de Châteauguay",
    "adresse": "270, boulevard d'Youville",
    "municipalite": "Châteauguay",
    "code_postal": "J6J 4R6",
    "lat": 45.37398,
    "lng": -73.7533
  },
  {
    "_id": "377",
    "school_code": "106501",
    "school_name_1": "Jean-de-Brébeuf",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1216",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "2",
    "index": "0.1",
    "en_retard_2024": "1.7",
    "ehdaa_2024": "9",
    "rang_2024": "1/470",
    "rang_2019_2024": "2/432",
    "lens_2018": "82.2",
    "lens_2019": "81.1",
    "lens_2022": "78.4",
    "lens_2023": "81.5",
    "lens_2024": "78.1",
    "lens_trend": "—",
    "lsec_2018": "84.1",
    "lsec_2019": "84.4",
    "lsec_2022": "88.9",
    "lsec_2023": "86.6",
    "lsec_2024": "86.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.7",
    "scie_2019": "85.8",
    "scie_2022": "90.0",
    "scie_2023": "92.2",
    "scie_2024": "91.8",
    "scie_trend": "—",
    "math_2018": "92.8",
    "math_2019": "92.4",
    "math_2022": "94.3",
    "math_2023": "94.2",
    "math_2024": "95.5",
    "math_trend": "—",
    "echec_2018": "0.9",
    "echec_2019": "1.2",
    "echec_2022": "1.8",
    "echec_2023": "0.7",
    "echec_2024": "1.0",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.1",
    "sures_2022": "0.3",
    "sures_2023": "0.2",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.7",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 3.4",
    "ecart_sexes_lens_2023": "F 3.4",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.7",
    "ecart_sexes_math_2019": "F 3.0",
    "ecart_sexes_math_2022": "F 1.0",
    "ecart_sexes_math_2023": "F 0.7",
    "ecart_sexes_math_2024": "F 1.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.6",
    "prog_2019": "0.9",
    "prog_2022": "0.9",
    "prog_2023": "1.4",
    "prog_2024": "1.4",
    "prog_trend": "—",
    "cote_2018": "9.9",
    "cote_2019": "9.8",
    "cote_2022": "10.0",
    "cote_2023": "9.9",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Jean-de-Brébeuf",
    "nom_court": "Collège Jean-de-Brébeuf",
    "adresse": "3200, ch. Côte Ste-Catherine",
    "municipalite": "Montréal",
    "code_postal": "H3T 1C1",
    "lat": 45.50161,
    "lng": -73.62281
  },
  {
    "_id": "378",
    "school_code": "107501",
    "school_name_1": "Jean de la Mennais",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1556",
    "langue": "français",
    "secteur": "privé",
    "rang": "12",
    "rang_5_ans": "11",
    "index": "0.1",
    "en_retard_2024": "1",
    "ehdaa_2024": "5",
    "rang_2024": "12/470",
    "rang_2019_2024": "11/432",
    "lens_2018": "80.7",
    "lens_2019": "80.4",
    "lens_2022": "78.7",
    "lens_2023": "79.8",
    "lens_2024": "77.8",
    "lens_trend": "—",
    "lsec_2018": "82.8",
    "lsec_2019": "84.9",
    "lsec_2022": "81.2",
    "lsec_2023": "83.6",
    "lsec_2024": "81.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "91.0",
    "scie_2019": "84.1",
    "scie_2022": "84.8",
    "scie_2023": "89.3",
    "scie_2024": "86.6",
    "scie_trend": "—",
    "math_2018": "88.6",
    "math_2019": "88.9",
    "math_2022": "90.7",
    "math_2023": "91.9",
    "math_2024": "91.6",
    "math_trend": "—",
    "echec_2018": "1.0",
    "echec_2019": "1.7",
    "echec_2022": "2.7",
    "echec_2023": "0.8",
    "echec_2024": "1.8",
    "echec_trend": "112233",
    "sures_2018": "0.0",
    "sures_2019": "0.1",
    "sures_2022": "0.1",
    "sures_2023": "0.0",
    "sures_2024": "0.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.6",
    "ecart_sexes_lens_2019": "F 5.1",
    "ecart_sexes_lens_2022": "F 3.3",
    "ecart_sexes_lens_2023": "F 3.0",
    "ecart_sexes_lens_2024": "F 2.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.2",
    "ecart_sexes_math_2019": "F 3.5",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "F 0.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "0.3",
    "prog_2022": "0.3",
    "prog_2023": "1.3",
    "prog_2024": "0.7",
    "prog_trend": "—",
    "cote_2018": "9.8",
    "cote_2019": "9.5",
    "cote_2022": "9.5",
    "cote_2023": "9.6",
    "cote_2024": "9.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Jean de la Mennais - secondaire",
    "nom_court": "Collège Jean de la Mennais",
    "adresse": "870, chemin de Saint-Jean",
    "municipalite": "La Prairie",
    "code_postal": "J5R 2L5",
    "lat": 45.41114,
    "lng": -73.48519
  },
  {
    "_id": "379",
    "school_code": "114501",
    "school_name_1": "Jean-Eudes",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1788",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "2",
    "index": "0.1",
    "en_retard_2024": "3.1",
    "ehdaa_2024": "6.4",
    "rang_2024": "1/470",
    "rang_2019_2024": "2/432",
    "lens_2018": "81.9",
    "lens_2019": "78.9",
    "lens_2022": "80.8",
    "lens_2023": "80.5",
    "lens_2024": "79.6",
    "lens_trend": "—",
    "lsec_2018": "89.7",
    "lsec_2019": "87.0",
    "lsec_2022": "88.1",
    "lsec_2023": "86.5",
    "lsec_2024": "88.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "85.1",
    "scie_2019": "85.4",
    "scie_2022": "89.9",
    "scie_2023": "92.1",
    "scie_2024": "91.4",
    "scie_trend": "112233",
    "math_2018": "88.2",
    "math_2019": "88.0",
    "math_2022": "89.3",
    "math_2023": "94.2",
    "math_2024": "93.1",
    "math_trend": "—",
    "echec_2018": "0.4",
    "echec_2019": "2.0",
    "echec_2022": "1.7",
    "echec_2023": "1.0",
    "echec_2024": "1.2",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "0.2",
    "sures_2023": "0.3",
    "sures_2024": "0.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 4.3",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 4.3",
    "ecart_sexes_lens_2024": "F 3.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.1",
    "ecart_sexes_math_2019": "F 1.4",
    "ecart_sexes_math_2022": "F 1.7",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.9",
    "prog_2019": "1.2",
    "prog_2022": "0.5",
    "prog_2023": "1.1",
    "prog_2024": "0.8",
    "prog_trend": "—",
    "cote_2018": "9.9",
    "cote_2019": "9.7",
    "cote_2022": "10.0",
    "cote_2023": "9.9",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Jean-Eudes",
    "nom_court": "Col. Jean-Eudes",
    "adresse": "3535, boul. Rosemont",
    "municipalite": "Montréal",
    "code_postal": "H1X 1K7",
    "lat": 45.5554,
    "lng": -73.57919
  },
  {
    "_id": "380",
    "school_code": "115501",
    "school_name_1": "Jésus-Marie de Sillery",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "665",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "59",
    "index": "0.1",
    "en_retard_2024": "5.6",
    "ehdaa_2024": "18.6",
    "rang_2024": "69/470",
    "rang_2019_2024": "59/432",
    "lens_2018": "69.7",
    "lens_2019": "76.5",
    "lens_2022": "73.6",
    "lens_2023": "73.0",
    "lens_2024": "72.6",
    "lens_trend": "—",
    "lsec_2018": "86.2",
    "lsec_2019": "84.5",
    "lsec_2022": "78.6",
    "lsec_2023": "78.5",
    "lsec_2024": "76.3",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "89.1",
    "scie_2019": "86.8",
    "scie_2022": "81.5",
    "scie_2023": "89.6",
    "scie_2024": "84.8",
    "scie_trend": "—",
    "math_2018": "85.5",
    "math_2019": "85.4",
    "math_2022": "80.7",
    "math_2023": "87.9",
    "math_2024": "86.2",
    "math_trend": "—",
    "echec_2018": "4.9",
    "echec_2019": "3.2",
    "echec_2022": "6.6",
    "echec_2023": "5.9",
    "echec_2024": "5.6",
    "echec_trend": "—",
    "sures_2018": "2.5",
    "sures_2019": "2.4",
    "sures_2022": "5.2",
    "sures_2023": "3.1",
    "sures_2024": "3.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 4.8",
    "ecart_sexes_lens_2022": "F 1.3",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "M 1.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 7.0",
    "ecart_sexes_math_2022": "F 7.9",
    "ecart_sexes_math_2023": "M 6.2",
    "ecart_sexes_math_2024": "F 0.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.1",
    "prog_2019": "5.7",
    "prog_2022": "1.1",
    "prog_2023": "0.0",
    "prog_2024": "3.2",
    "prog_trend": "—",
    "cote_2018": "8.5",
    "cote_2019": "8.5",
    "cote_2022": "7.5",
    "cote_2023": "7.7",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Jésus-Marie de Sillery",
    "nom_court": "Collège Jésus-Marie de Sillery",
    "adresse": "2047, chemin Saint-Louis",
    "municipalite": "Québec",
    "code_postal": "G1T 1P3",
    "lat": 46.77642,
    "lng": -71.25007
  },
  {
    "_id": "381",
    "school_code": "116501",
    "school_name_1": "Collège Laval",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laval ",
    "étudiants": "2074",
    "langue": "français",
    "secteur": "privé",
    "rang": "15",
    "rang_5_ans": "11",
    "index": "0.1",
    "en_retard_2024": "0.2",
    "ehdaa_2024": "6.3",
    "rang_2024": "15/470",
    "rang_2019_2024": "11/432",
    "lens_2018": "80.0",
    "lens_2019": "79.0",
    "lens_2022": "78.4",
    "lens_2023": "77.4",
    "lens_2024": "76.6",
    "lens_trend": "—",
    "lsec_2018": "86.0",
    "lsec_2019": "87.2",
    "lsec_2022": "90.5",
    "lsec_2023": "88.4",
    "lsec_2024": "85.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.1",
    "scie_2019": "83.4",
    "scie_2022": "88.5",
    "scie_2023": "87.9",
    "scie_2024": "86.4",
    "scie_trend": "—",
    "math_2018": "84.2",
    "math_2019": "82.3",
    "math_2022": "88.5",
    "math_2023": "90.6",
    "math_2024": "89.9",
    "math_trend": "—",
    "echec_2018": "1.5",
    "echec_2019": "3.6",
    "echec_2022": "2.0",
    "echec_2023": "1.6",
    "echec_2024": "2.3",
    "echec_trend": "—",
    "sures_2018": "0.3",
    "sures_2019": "0.3",
    "sures_2022": "0.0",
    "sures_2023": "0.0",
    "sures_2024": "0.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.0",
    "ecart_sexes_math_2019": "F 1.2",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.0",
    "prog_2019": "0.8",
    "prog_2022": "1.0",
    "prog_2023": "1.2",
    "prog_2024": "1.2",
    "prog_trend": "—",
    "cote_2018": "9.4",
    "cote_2019": "9.3",
    "cote_2022": "10.0",
    "cote_2023": "9.5",
    "cote_2024": "9.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Laval",
    "nom_court": "Collège Laval",
    "adresse": "1275, avenue du Collège",
    "municipalite": "Laval",
    "code_postal": "H7C 1W8",
    "lat": 45.61516,
    "lng": -73.64904
  },
  {
    "_id": "382",
    "school_code": "118501",
    "school_name_1": "Marie-de-l'Incarnation",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Mauricie ",
    "étudiants": "140",
    "langue": "français",
    "secteur": "privé",
    "rang": "137",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "4.2",
    "ehdaa_2024": "30",
    "rang_2024": "137/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "72.1",
    "lens_2019": "71.7",
    "lens_2022": "74.4",
    "lens_2023": "74.9",
    "lens_2024": "69.8",
    "lens_trend": "—",
    "lsec_2018": "82.8",
    "lsec_2019": "85.7",
    "lsec_2022": "83.4",
    "lsec_2023": "81.2",
    "lsec_2024": "77.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.2",
    "scie_2019": "79.8",
    "scie_2022": "75.9",
    "scie_2023": "83.5",
    "scie_2024": "74.3",
    "scie_trend": "—",
    "math_2018": "80.0",
    "math_2019": "85.5",
    "math_2022": "85.3",
    "math_2023": "80.9",
    "math_2024": "81.1",
    "math_trend": "—",
    "echec_2018": "7.8",
    "echec_2019": "9.2",
    "echec_2022": "8.5",
    "echec_2023": "5.8",
    "echec_2024": "7.1",
    "echec_trend": "—",
    "sures_2018": "3.0",
    "sures_2019": "2.9",
    "sures_2022": "1.9",
    "sures_2023": "0.7",
    "sures_2024": "5.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "5.9",
    "prog_2019": "6.2",
    "prog_2022": "4.0",
    "prog_2023": "8.3",
    "prog_2024": "16.0",
    "prog_trend": "—",
    "cote_2018": "7.4",
    "cote_2019": "7.9",
    "cote_2022": "8.5",
    "cote_2023": "8.1",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Marie-de-l'Incarnation",
    "nom_court": "Collège Marie-de-l'Incarnation",
    "adresse": "725, rue Hart",
    "municipalite": "Trois-Rivières",
    "code_postal": "G9A 4R9",
    "lat": 46.34557,
    "lng": -72.53694
  },
  {
    "_id": "383",
    "school_code": "119501",
    "school_name_1": "Mont Notre-Dame",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "491",
    "langue": "français",
    "secteur": "privé",
    "rang": "33",
    "rang_5_ans": "37",
    "index": "0.1",
    "en_retard_2024": "2.2",
    "ehdaa_2024": "12.8",
    "rang_2024": "33/470",
    "rang_2019_2024": "37/432",
    "lens_2018": "75.0",
    "lens_2019": "75.0",
    "lens_2022": "74.4",
    "lens_2023": "76.8",
    "lens_2024": "74.3",
    "lens_trend": "112233",
    "lsec_2018": "86.7",
    "lsec_2019": "89.1",
    "lsec_2022": "81.9",
    "lsec_2023": "76.4",
    "lsec_2024": "80.3",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.9",
    "scie_2019": "77.0",
    "scie_2022": "77.9",
    "scie_2023": "81.7",
    "scie_2024": "78.9",
    "scie_trend": "—",
    "math_2018": "81.1",
    "math_2019": "84.2",
    "math_2022": "85.4",
    "math_2023": "85.0",
    "math_2024": "89.3",
    "math_trend": "—",
    "echec_2018": "8.2",
    "echec_2019": "7.0",
    "echec_2022": "7.0",
    "echec_2023": "3.8",
    "echec_2024": "4.1",
    "echec_trend": "112233",
    "sures_2018": "2.1",
    "sures_2019": "2.8",
    "sures_2022": "4.6",
    "sures_2023": "2.6",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.5",
    "prog_2019": "0.0",
    "prog_2022": "2.2",
    "prog_2023": "6.4",
    "prog_2024": "2.1",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.7",
    "cote_2022": "8.8",
    "cote_2023": "8.1",
    "cote_2024": "8.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Mont Notre-Dame",
    "nom_court": "Mont Notre-Dame",
    "adresse": "114, rue de la Cathédrale",
    "municipalite": "Sherbrooke",
    "code_postal": "J1H 4M1",
    "lat": 45.40156,
    "lng": -71.89198
  },
  {
    "_id": "384",
    "school_code": "123501",
    "school_name_1": "Mont-Sacré-Coeur",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "712",
    "langue": "français",
    "secteur": "privé",
    "rang": "126",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "5.6",
    "ehdaa_2024": "28.2",
    "rang_2024": "126/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "74.1",
    "lens_2019": "73.3",
    "lens_2022": "68.1",
    "lens_2023": "71.9",
    "lens_2024": "68.5",
    "lens_trend": "—",
    "lsec_2018": "82.8",
    "lsec_2019": "79.4",
    "lsec_2022": "86.0",
    "lsec_2023": "85.3",
    "lsec_2024": "79.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.9",
    "scie_2019": "77.1",
    "scie_2022": "68.9",
    "scie_2023": "74.1",
    "scie_2024": "69.3",
    "scie_trend": "998855",
    "math_2018": "77.6",
    "math_2019": "79.7",
    "math_2022": "78.0",
    "math_2023": "79.4",
    "math_2024": "83.1",
    "math_trend": "—",
    "echec_2018": "7.9",
    "echec_2019": "9.4",
    "echec_2022": "16.4",
    "echec_2023": "7.8",
    "echec_2024": "12.8",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.5",
    "sures_2022": "4.9",
    "sures_2023": "1.6",
    "sures_2024": "4.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 7.1",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 1.5",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 6.4",
    "ecart_sexes_math_2022": "F 1.2",
    "ecart_sexes_math_2023": "M 2.7",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.2",
    "prog_2019": "4.6",
    "prog_2022": "2.6",
    "prog_2023": "5.3",
    "prog_2024": "3.4",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "7.1",
    "cote_2022": "7.0",
    "cote_2023": "7.5",
    "cote_2024": "6.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Mont-Sacré-Coeur",
    "nom_court": "Collège Mont-Sacré-Coeur",
    "adresse": "210, rue Denison Est",
    "municipalite": "Granby",
    "code_postal": "J2H 2R6",
    "lat": 45.39082,
    "lng": -72.70549
  },
  {
    "_id": "385",
    "school_code": "124501",
    "school_name_1": "Mont-Royal",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "530",
    "langue": "français",
    "secteur": "privé",
    "rang": "156",
    "rang_5_ans": "125",
    "index": "0.1",
    "en_retard_2024": "3.8",
    "ehdaa_2024": "13.8",
    "rang_2024": "156/470",
    "rang_2019_2024": "125/432",
    "lens_2018": "67.4",
    "lens_2019": "72.8",
    "lens_2022": "68.9",
    "lens_2023": "68.4",
    "lens_2024": "69.3",
    "lens_trend": "—",
    "lsec_2018": "77.7",
    "lsec_2019": "75.3",
    "lsec_2022": "80.6",
    "lsec_2023": "78.0",
    "lsec_2024": "78.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.3",
    "scie_2019": "75.7",
    "scie_2022": "75.7",
    "scie_2023": "78.6",
    "scie_2024": "75.2",
    "scie_trend": "—",
    "math_2018": "75.4",
    "math_2019": "80.3",
    "math_2022": "87.2",
    "math_2023": "77.3",
    "math_2024": "74.1",
    "math_trend": "—",
    "echec_2018": "15.1",
    "echec_2019": "7.7",
    "echec_2022": "11.4",
    "echec_2023": "15.5",
    "echec_2024": "14.1",
    "echec_trend": "—",
    "sures_2018": "2.8",
    "sures_2019": "1.1",
    "sures_2022": "3.3",
    "sures_2023": "2.9",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 1.5",
    "ecart_sexes_lens_2023": "F 1.1",
    "ecart_sexes_lens_2024": "F 5.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.2",
    "ecart_sexes_math_2019": "F 3.8",
    "ecart_sexes_math_2022": "M 1.2",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.4",
    "prog_2019": "9.1",
    "prog_2022": "5.7",
    "prog_2023": "5.1",
    "prog_2024": "8.8",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "7.0",
    "cote_2022": "7.7",
    "cote_2023": "6.6",
    "cote_2024": "6.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Mont-Royal",
    "nom_court": "Col. Mont-Royal",
    "adresse": "2165, rue Baldwin",
    "municipalite": "Montréal",
    "code_postal": "H1L 5A7",
    "lat": 45.59906,
    "lng": -73.51597
  },
  {
    "_id": "386",
    "school_code": "125501",
    "school_name_1": "Mont-Saint-Louis",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1451",
    "langue": "français",
    "secteur": "privé",
    "rang": "24",
    "rang_5_ans": "21",
    "index": "0.1",
    "en_retard_2024": "2.2",
    "ehdaa_2024": "17.6",
    "rang_2024": "24/470",
    "rang_2019_2024": "21/432",
    "lens_2018": "80.4",
    "lens_2019": "80.2",
    "lens_2022": "76.1",
    "lens_2023": "75.4",
    "lens_2024": "77.2",
    "lens_trend": "—",
    "lsec_2018": "86.8",
    "lsec_2019": "87.1",
    "lsec_2022": "86.1",
    "lsec_2023": "84.8",
    "lsec_2024": "85.2",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.0",
    "scie_2019": "79.6",
    "scie_2022": "77.9",
    "scie_2023": "84.4",
    "scie_2024": "82.6",
    "scie_trend": "—",
    "math_2018": "80.4",
    "math_2019": "84.5",
    "math_2022": "84.1",
    "math_2023": "87.1",
    "math_2024": "87.5",
    "math_trend": "112233",
    "echec_2018": "1.9",
    "echec_2019": "1.9",
    "echec_2022": "4.6",
    "echec_2023": "3.5",
    "echec_2024": "3.0",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.1",
    "sures_2022": "0.9",
    "sures_2023": "0.5",
    "sures_2024": "0.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.2",
    "ecart_sexes_lens_2019": "F 2.1",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 4.9",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "F 4.5",
    "ecart_sexes_math_2022": "F 3.9",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 5.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.1",
    "prog_2019": "1.9",
    "prog_2022": "1.5",
    "prog_2023": "1.5",
    "prog_2024": "2.1",
    "prog_trend": "—",
    "cote_2018": "9.2",
    "cote_2019": "9.3",
    "cote_2022": "8.9",
    "cote_2023": "8.8",
    "cote_2024": "9.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Mont-Saint-Louis",
    "nom_court": "Collège Mont-Saint-Louis",
    "adresse": "1700, boulevard Henri-Bourassa Est",
    "municipalite": "Montréal",
    "code_postal": "H2C 1J3",
    "lat": 45.56871,
    "lng": -73.65866
  },
  {
    "_id": "387",
    "school_code": "126501",
    "school_name_1": "Notre-Dame",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1788",
    "langue": "français",
    "secteur": "privé",
    "rang": "31",
    "rang_5_ans": "32",
    "index": "0.1",
    "en_retard_2024": "0.9",
    "ehdaa_2024": "11.1",
    "rang_2024": "31/470",
    "rang_2019_2024": "32/432",
    "lens_2018": "75.4",
    "lens_2019": "74.6",
    "lens_2022": "75.8",
    "lens_2023": "75.4",
    "lens_2024": "73.6",
    "lens_trend": "—",
    "lsec_2018": "80.5",
    "lsec_2019": "77.9",
    "lsec_2022": "81.9",
    "lsec_2023": "81.6",
    "lsec_2024": "81.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.8",
    "scie_2019": "79.4",
    "scie_2022": "82.9",
    "scie_2023": "87.3",
    "scie_2024": "82.5",
    "scie_trend": "—",
    "math_2018": "79.8",
    "math_2019": "82.1",
    "math_2022": "88.8",
    "math_2023": "89.3",
    "math_2024": "90.8",
    "math_trend": "112233",
    "echec_2018": "4.7",
    "echec_2019": "5.9",
    "echec_2022": "3.9",
    "echec_2023": "3.9",
    "echec_2024": "4.5",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "0.4",
    "sures_2022": "0.3",
    "sures_2023": "0.8",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.2",
    "ecart_sexes_lens_2019": "F 3.3",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 3.0",
    "ecart_sexes_lens_2024": "F 2.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 4.0",
    "ecart_sexes_math_2019": "F 6.1",
    "ecart_sexes_math_2022": "M 0.4",
    "ecart_sexes_math_2023": "F 1.6",
    "ecart_sexes_math_2024": "F 2.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "3.9",
    "prog_2019": "1.0",
    "prog_2022": "0.7",
    "prog_2023": "1.6",
    "prog_2024": "2.4",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "8.0",
    "cote_2022": "9.2",
    "cote_2023": "8.8",
    "cote_2024": "8.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Notre-Dame",
    "nom_court": "Collège Notre-Dame",
    "adresse": "3791, chemin Queen-Mary",
    "municipalite": "Montréal",
    "code_postal": "H3V 1A8",
    "lat": 45.49327,
    "lng": -73.62249
  },
  {
    "_id": "388",
    "school_code": "127501",
    "school_name_1": "Notre-Dame-de-l'Assomption",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Centre-du-Québec ",
    "étudiants": "339",
    "langue": "français",
    "secteur": "privé",
    "rang": "207",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "13",
    "ehdaa_2024": "44.2",
    "rang_2024": "207/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "69.7",
    "lens_2019": "70.9",
    "lens_2022": "70.4",
    "lens_2023": "73.1",
    "lens_2024": "66.5",
    "lens_trend": "—",
    "lsec_2018": "75.2",
    "lsec_2019": "74.9",
    "lsec_2022": "74.4",
    "lsec_2023": "74.6",
    "lsec_2024": "73.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.5",
    "scie_2019": "69.8",
    "scie_2022": "70.8",
    "scie_2023": "75.9",
    "scie_2024": "72.5",
    "scie_trend": "—",
    "math_2018": "77.6",
    "math_2019": "72.7",
    "math_2022": "77.3",
    "math_2023": "77.9",
    "math_2024": "88.1",
    "math_trend": "—",
    "echec_2018": "15.4",
    "echec_2019": "18.3",
    "echec_2022": "16.7",
    "echec_2023": "11.7",
    "echec_2024": "12.3",
    "echec_trend": "112233",
    "sures_2018": "1.8",
    "sures_2019": "3.4",
    "sures_2022": "2.9",
    "sures_2023": "0.9",
    "sures_2024": "3.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 10.4",
    "ecart_sexes_lens_2022": "F 13.3",
    "ecart_sexes_lens_2023": "F 9.6",
    "ecart_sexes_lens_2024": "F 4.5",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 4.8",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "M 0.4",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "18.5",
    "prog_2019": "15.2",
    "prog_2022": "14.1",
    "prog_2023": "30.2",
    "prog_2024": "20.4",
    "prog_trend": "—",
    "cote_2018": "5.9",
    "cote_2019": "5.0",
    "cote_2022": "6.0",
    "cote_2023": "6.3",
    "cote_2024": "6.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Notre-Dame-de-l'Assomption, campus français",
    "nom_court": "Collège N.-D.-de-l'Assomption, campus f.",
    "adresse": "225, rue St-Jean Baptiste",
    "municipalite": "Nicolet",
    "code_postal": "J3T 0A2",
    "lat": 46.22862,
    "lng": -72.62172
  },
  {
    "_id": "389",
    "school_code": "128501",
    "school_name_1": "Notre-Dame-de-Lourdes",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1127",
    "langue": "français",
    "secteur": "privé",
    "rang": "49",
    "rang_5_ans": "40",
    "index": "0.1",
    "en_retard_2024": "1.8",
    "ehdaa_2024": "22",
    "rang_2024": "49/470",
    "rang_2019_2024": "40/432",
    "lens_2018": "76.0",
    "lens_2019": "78.1",
    "lens_2022": "72.5",
    "lens_2023": "75.0",
    "lens_2024": "72.5",
    "lens_trend": "—",
    "lsec_2018": "83.2",
    "lsec_2019": "79.8",
    "lsec_2022": "84.6",
    "lsec_2023": "83.7",
    "lsec_2024": "82.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.0",
    "scie_2019": "77.7",
    "scie_2022": "78.0",
    "scie_2023": "84.1",
    "scie_2024": "81.0",
    "scie_trend": "112233",
    "math_2018": "81.5",
    "math_2019": "81.2",
    "math_2022": "82.1",
    "math_2023": "85.7",
    "math_2024": "86.3",
    "math_trend": "—",
    "echec_2018": "4.9",
    "echec_2019": "4.8",
    "echec_2022": "7.2",
    "echec_2023": "4.9",
    "echec_2024": "4.6",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "1.1",
    "sures_2022": "2.8",
    "sures_2023": "1.3",
    "sures_2024": "2.2",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 4.7",
    "ecart_sexes_lens_2022": "F 3.4",
    "ecart_sexes_lens_2023": "F 3.2",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.8",
    "ecart_sexes_math_2019": "F 1.3",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "M 0.8",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.8",
    "prog_2019": "4.1",
    "prog_2022": "1.0",
    "prog_2023": "1.4",
    "prog_2024": "1.5",
    "prog_trend": "—",
    "cote_2018": "8.4",
    "cote_2019": "8.2",
    "cote_2022": "8.4",
    "cote_2023": "8.6",
    "cote_2024": "8.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Notre-Dame-de-Lourdes",
    "nom_court": "Collège Notre-Dame-de-Lourdes",
    "adresse": "845, chemin Tiffin",
    "municipalite": "Longueuil",
    "code_postal": "J4P 3G5",
    "lat": 45.51521,
    "lng": -73.51233
  },
  {
    "_id": "390",
    "school_code": "136501",
    "school_name_1": "College Prep International",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "63",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "96",
    "rang_5_ans": "89",
    "index": "0.1",
    "en_retard_2024": "22.2",
    "ehdaa_2024": "nd",
    "rang_2024": "96/470",
    "rang_2019_2024": "89/432",
    "lens_2018": "78.5",
    "lens_2019": "75.5",
    "lens_2022": "77.2",
    "lens_2023": "72.3",
    "lens_2024": "75.8",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "75.1",
    "lsec_2022": "91.8",
    "lsec_2023": "90.1",
    "lsec_2024": "80.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.0",
    "scie_2019": "81.8",
    "scie_2022": "87.4",
    "scie_2023": "86.5",
    "scie_2024": "85.2",
    "scie_trend": "—",
    "math_2018": "85.5",
    "math_2019": "82.4",
    "math_2022": "87.8",
    "math_2023": "83.6",
    "math_2024": "84.9",
    "math_trend": "—",
    "echec_2018": "3.9",
    "echec_2019": "8.5",
    "echec_2022": "1.1",
    "echec_2023": "5.3",
    "echec_2024": "4.5",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.6",
    "sures_2022": "1.8",
    "sures_2023": "3.3",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.0",
    "ecart_sexes_lens_2019": "F 1.4",
    "ecart_sexes_lens_2022": "F 5.7",
    "ecart_sexes_lens_2023": "M 3.3",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "F 5.2",
    "ecart_sexes_math_2019": "F 12.0",
    "ecart_sexes_math_2022": "F 8.4",
    "ecart_sexes_math_2023": "F 0.2",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "11.9",
    "prog_2019": "7.8",
    "prog_2022": "15.8",
    "prog_2023": "9.5",
    "prog_2024": "14.8",
    "prog_trend": "—",
    "cote_2018": "7.7",
    "cote_2019": "6.9",
    "cote_2022": "8.0",
    "cote_2023": "7.2",
    "cote_2024": "7.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Prep International",
    "nom_court": "Collège Prep International",
    "adresse": "7475, rue Sherbrooke Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4B 1S3",
    "lat": 45.45428,
    "lng": -73.64254
  },
  {
    "_id": "391",
    "school_code": "138501",
    "school_name_1": "Citoyen",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laval ",
    "étudiants": "901",
    "langue": "français",
    "secteur": "privé",
    "rang": "80",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "6",
    "ehdaa_2024": "27.9",
    "rang_2024": "80/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "71.9",
    "lens_2019": "68.6",
    "lens_2022": "66.8",
    "lens_2023": "70.7",
    "lens_2024": "68.8",
    "lens_trend": "—",
    "lsec_2018": "82.8",
    "lsec_2019": "78.2",
    "lsec_2022": "80.3",
    "lsec_2023": "80.1",
    "lsec_2024": "81.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.3",
    "scie_2019": "73.7",
    "scie_2022": "71.6",
    "scie_2023": "78.6",
    "scie_2024": "80.7",
    "scie_trend": "—",
    "math_2018": "78.0",
    "math_2019": "82.6",
    "math_2022": "74.0",
    "math_2023": "79.9",
    "math_2024": "83.7",
    "math_trend": "—",
    "echec_2018": "7.9",
    "echec_2019": "8.6",
    "echec_2022": "15.9",
    "echec_2023": "7.4",
    "echec_2024": "9.4",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "1.7",
    "sures_2022": "4.7",
    "sures_2023": "1.5",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 7.7",
    "ecart_sexes_lens_2019": "M 0.1",
    "ecart_sexes_lens_2022": "F 8.4",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 3.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 9.3",
    "ecart_sexes_math_2019": "F 2.6",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "F 0.9",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.5",
    "prog_2019": "2.1",
    "prog_2022": "1.8",
    "prog_2023": "7.7",
    "prog_2024": "2.1",
    "prog_trend": "—",
    "cote_2018": "7.3",
    "cote_2019": "7.5",
    "cote_2022": "6.5",
    "cote_2023": "7.5",
    "cote_2024": "7.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Citoyen",
    "nom_court": "Collège Citoyen",
    "adresse": "4001, boulevard Sainte-Rose",
    "municipalite": "Laval",
    "code_postal": "H7R 1W6",
    "lat": 45.57204,
    "lng": -73.83119
  },
  {
    "_id": "392",
    "school_code": "139501",
    "school_name_1": "Regina Assumpta",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "2263",
    "langue": "français",
    "secteur": "privé",
    "rang": "24",
    "rang_5_ans": "18",
    "index": "0.1",
    "en_retard_2024": "1.1",
    "ehdaa_2024": "5.1",
    "rang_2024": "24/470",
    "rang_2019_2024": "18/432",
    "lens_2018": "74.9",
    "lens_2019": "73.8",
    "lens_2022": "71.0",
    "lens_2023": "74.3",
    "lens_2024": "71.1",
    "lens_trend": "—",
    "lsec_2018": "88.9",
    "lsec_2019": "88.1",
    "lsec_2022": "87.1",
    "lsec_2023": "85.9",
    "lsec_2024": "87.5",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.5",
    "scie_2019": "85.5",
    "scie_2022": "81.7",
    "scie_2023": "86.1",
    "scie_2024": "85.9",
    "scie_trend": "—",
    "math_2018": "85.2",
    "math_2019": "89.7",
    "math_2022": "87.3",
    "math_2023": "90.0",
    "math_2024": "92.3",
    "math_trend": "—",
    "echec_2018": "2.7",
    "echec_2019": "3.1",
    "echec_2022": "6.9",
    "echec_2023": "3.0",
    "echec_2024": "5.5",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.7",
    "sures_2022": "1.1",
    "sures_2023": "0.8",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "F 1.0",
    "ecart_sexes_lens_2023": "M 0.4",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.2",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "M 1.1",
    "ecart_sexes_math_2023": "M 0.2",
    "ecart_sexes_math_2024": "M 0.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.9",
    "prog_2019": "0.5",
    "prog_2022": "1.0",
    "prog_2023": "1.4",
    "prog_2024": "0.7",
    "prog_trend": "—",
    "cote_2018": "9.3",
    "cote_2019": "9.4",
    "cote_2022": "9.1",
    "cote_2023": "9.2",
    "cote_2024": "9.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Regina Assumpta",
    "nom_court": "Collège Regina Assumpta",
    "adresse": "1750, rue Sauriol Est",
    "municipalite": "Montréal",
    "code_postal": "H2C 1X4",
    "lat": 45.56529,
    "lng": -73.65016
  },
  {
    "_id": "393",
    "school_code": "144501",
    "school_name_1": "Rivier",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "105",
    "langue": "français",
    "secteur": "privé",
    "rang": "277",
    "rang_5_ans": "238",
    "index": "0.1",
    "en_retard_2024": "4.8",
    "ehdaa_2024": "nd",
    "rang_2024": "277/470",
    "rang_2019_2024": "238/432",
    "lens_2018": "70.5",
    "lens_2019": "70.8",
    "lens_2022": "68.9",
    "lens_2023": "63.3",
    "lens_2024": "65.0",
    "lens_trend": "—",
    "lsec_2018": "76.1",
    "lsec_2019": "81.7",
    "lsec_2022": "78.7",
    "lsec_2023": "86.0",
    "lsec_2024": "82.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.5",
    "scie_2019": "73.9",
    "scie_2022": "69.4",
    "scie_2023": "69.9",
    "scie_2024": "70.9",
    "scie_trend": "—",
    "math_2018": "74.0",
    "math_2019": "71.2",
    "math_2022": "70.2",
    "math_2023": "59.3",
    "math_2024": "76.7",
    "math_trend": "—",
    "echec_2018": "7.2",
    "echec_2019": "11.2",
    "echec_2022": "17.6",
    "echec_2023": "17.6",
    "echec_2024": "14.2",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.2",
    "sures_2022": "1.9",
    "sures_2023": "6.6",
    "sures_2024": "1.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "8.3",
    "prog_2019": "31.8",
    "prog_2022": "12.5",
    "prog_2023": "20.1",
    "prog_2024": "44.1",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "6.1",
    "cote_2022": "6.2",
    "cote_2023": "4.3",
    "cote_2024": "5.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Rivier",
    "nom_court": "Collège Rivier",
    "adresse": "343, rue Saint-Jacques Nord",
    "municipalite": "Coaticook",
    "code_postal": "J1A 2R2",
    "lat": 45.13796,
    "lng": -71.79611
  },
  {
    "_id": "394",
    "school_code": "145501",
    "school_name_1": "Saint-Alexandre",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Outaouais ",
    "étudiants": "1033",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "5",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "20.7",
    "rang_2024": "1/470",
    "rang_2019_2024": "5/432",
    "lens_2018": "81.6",
    "lens_2019": "80.4",
    "lens_2022": "78.6",
    "lens_2023": "79.9",
    "lens_2024": "79.5",
    "lens_trend": "—",
    "lsec_2018": "80.2",
    "lsec_2019": "83.5",
    "lsec_2022": "87.2",
    "lsec_2023": "89.9",
    "lsec_2024": "88.3",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.7",
    "scie_2019": "84.9",
    "scie_2022": "88.7",
    "scie_2023": "90.2",
    "scie_2024": "88.3",
    "scie_trend": "—",
    "math_2018": "86.8",
    "math_2019": "87.3",
    "math_2022": "91.4",
    "math_2023": "91.7",
    "math_2024": "91.8",
    "math_trend": "—",
    "echec_2018": "1.3",
    "echec_2019": "2.1",
    "echec_2022": "1.6",
    "echec_2023": "1.1",
    "echec_2024": "1.0",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.0",
    "sures_2022": "0.8",
    "sures_2023": "0.0",
    "sures_2024": "0.3",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 3.1",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 5.8",
    "ecart_sexes_lens_2023": "F 3.0",
    "ecart_sexes_lens_2024": "F 1.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.8",
    "ecart_sexes_math_2019": "F 5.5",
    "ecart_sexes_math_2022": "M 0.2",
    "ecart_sexes_math_2023": "F 0.7",
    "ecart_sexes_math_2024": "F 1.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.5",
    "prog_2019": "1.5",
    "prog_2022": "1.5",
    "prog_2023": "0.5",
    "prog_2024": "0.5",
    "prog_trend": "—",
    "cote_2018": "9.4",
    "cote_2019": "9.5",
    "cote_2022": "10.0",
    "cote_2023": "10.0",
    "cote_2024": "10.0",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Saint-Alexandre de la Gatineau",
    "nom_court": "Col. Saint-Alexandre",
    "adresse": "2425, rue Saint-Louis",
    "municipalite": "Gatineau",
    "code_postal": "J8V 1E7",
    "lat": 45.49355,
    "lng": -75.7506
  },
  {
    "_id": "395",
    "school_code": "147501",
    "school_name_1": "Saint-Bernard",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Centre-du-Québec ",
    "étudiants": "835",
    "langue": "français",
    "secteur": "privé",
    "rang": "238",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "5.5",
    "ehdaa_2024": "40",
    "rang_2024": "238/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "72.7",
    "lens_2019": "69.3",
    "lens_2022": "65.0",
    "lens_2023": "71.2",
    "lens_2024": "68.8",
    "lens_trend": "—",
    "lsec_2018": "79.2",
    "lsec_2019": "75.1",
    "lsec_2022": "82.2",
    "lsec_2023": "80.1",
    "lsec_2024": "75.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.1",
    "scie_2019": "76.7",
    "scie_2022": "75.5",
    "scie_2023": "76.5",
    "scie_2024": "73.0",
    "scie_trend": "—",
    "math_2018": "69.8",
    "math_2019": "69.8",
    "math_2022": "73.0",
    "math_2023": "71.3",
    "math_2024": "71.6",
    "math_trend": "—",
    "echec_2018": "13.1",
    "echec_2019": "16.7",
    "echec_2022": "17.7",
    "echec_2023": "15.2",
    "echec_2024": "17.5",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "4.2",
    "sures_2022": "5.5",
    "sures_2023": "4.9",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 6.5",
    "ecart_sexes_lens_2022": "F 4.2",
    "ecart_sexes_lens_2023": "F 6.6",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 11.4",
    "ecart_sexes_math_2019": "F 2.5",
    "ecart_sexes_math_2022": "F 2.3",
    "ecart_sexes_math_2023": "F 1.5",
    "ecart_sexes_math_2024": "F 7.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "14.2",
    "prog_2019": "12.1",
    "prog_2022": "7.3",
    "prog_2023": "20.9",
    "prog_2024": "9.8",
    "prog_trend": "—",
    "cote_2018": "6.1",
    "cote_2019": "5.3",
    "cote_2022": "6.4",
    "cote_2023": "5.7",
    "cote_2024": "5.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Bernard",
    "nom_court": "Collège Saint-Bernard",
    "adresse": "25, avenue des Frères",
    "municipalite": "Drummondville",
    "code_postal": "J2B 6A2",
    "lat": 45.88204,
    "lng": -72.47589
  },
  {
    "_id": "396",
    "school_code": "148501",
    "school_name_1": "Saint-Charles-Garnier",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "855",
    "langue": "français",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "64",
    "index": "0.1",
    "en_retard_2024": "0.6",
    "ehdaa_2024": "14.6",
    "rang_2024": "53/470",
    "rang_2019_2024": "64/432",
    "lens_2018": "72.0",
    "lens_2019": "74.2",
    "lens_2022": "73.2",
    "lens_2023": "71.1",
    "lens_2024": "71.5",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "79.9",
    "lsec_2022": "83.5",
    "lsec_2023": "82.4",
    "lsec_2024": "81.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.0",
    "scie_2019": "82.0",
    "scie_2022": "81.1",
    "scie_2023": "87.2",
    "scie_2024": "86.9",
    "scie_trend": "112233",
    "math_2018": "77.9",
    "math_2019": "83.2",
    "math_2022": "77.7",
    "math_2023": "80.4",
    "math_2024": "86.9",
    "math_trend": "—",
    "echec_2018": "6.9",
    "echec_2019": "6.3",
    "echec_2022": "8.0",
    "echec_2023": "5.9",
    "echec_2024": "5.2",
    "echec_trend": "112233",
    "sures_2018": "1.2",
    "sures_2019": "1.2",
    "sures_2022": "3.8",
    "sures_2023": "2.9",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.2",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 6.3",
    "ecart_sexes_lens_2023": "F 1.7",
    "ecart_sexes_lens_2024": "F 6.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.5",
    "ecart_sexes_math_2019": "F 2.8",
    "ecart_sexes_math_2022": "M 0.4",
    "ecart_sexes_math_2023": "F 1.0",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "3.2",
    "prog_2019": "8.7",
    "prog_2022": "4.3",
    "prog_2023": "5.8",
    "prog_2024": "5.5",
    "prog_trend": "—",
    "cote_2018": "7.3",
    "cote_2019": "8.0",
    "cote_2022": "7.9",
    "cote_2023": "7.9",
    "cote_2024": "8.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Charles-Garnier ",
    "nom_court": "Col. Saint-Charles-Garnier",
    "adresse": "1150, boul René Lévesque Ouest",
    "municipalite": "Québec",
    "code_postal": "G1S 1V7",
    "lat": 46.79524,
    "lng": -71.24557
  },
  {
    "_id": "397",
    "school_code": "149501",
    "school_name_1": "Saint-Hilaire",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "685",
    "langue": "français",
    "secteur": "privé",
    "rang": "49",
    "rang_5_ans": "32",
    "index": "0.1",
    "en_retard_2024": "0.8",
    "ehdaa_2024": "12.6",
    "rang_2024": "49/470",
    "rang_2019_2024": "32/432",
    "lens_2018": "81.0",
    "lens_2019": "75.3",
    "lens_2022": "74.2",
    "lens_2023": "78.2",
    "lens_2024": "76.4",
    "lens_trend": "—",
    "lsec_2018": "82.2",
    "lsec_2019": "80.9",
    "lsec_2022": "81.3",
    "lsec_2023": "80.4",
    "lsec_2024": "78.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.5",
    "scie_2019": "83.5",
    "scie_2022": "83.6",
    "scie_2023": "79.8",
    "scie_2024": "85.7",
    "scie_trend": "—",
    "math_2018": "83.2",
    "math_2019": "82.3",
    "math_2022": "85.0",
    "math_2023": "80.0",
    "math_2024": "81.4",
    "math_trend": "998855",
    "echec_2018": "1.6",
    "echec_2019": "4.1",
    "echec_2022": "5.1",
    "echec_2023": "4.9",
    "echec_2024": "3.9",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.2",
    "sures_2022": "0.9",
    "sures_2023": "0.7",
    "sures_2024": "0.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.6",
    "ecart_sexes_lens_2019": "F 4.8",
    "ecart_sexes_lens_2022": "F 3.2",
    "ecart_sexes_lens_2023": "F 1.6",
    "ecart_sexes_lens_2024": "F 8.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.2",
    "ecart_sexes_math_2019": "E",
    "ecart_sexes_math_2022": "F 3.0",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "F 4.3",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "4.8",
    "prog_2019": "3.3",
    "prog_2022": "2.4",
    "prog_2023": "4.2",
    "prog_2024": "2.3",
    "prog_trend": "112233",
    "cote_2018": "9.2",
    "cote_2019": "8.5",
    "cote_2022": "8.8",
    "cote_2023": "8.2",
    "cote_2024": "8.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Hilaire",
    "nom_court": "Collège Saint-Hilaire",
    "adresse": "800, rue Rouillard",
    "municipalite": "Mont-Saint-Hilaire",
    "code_postal": "J3H 0K4",
    "lat": 45.5686,
    "lng": -73.15768
  },
  {
    "_id": "398",
    "school_code": "157501",
    "school_name_1": "Saint-Jean-Vianney",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1519",
    "langue": "français",
    "secteur": "privé",
    "rang": "101",
    "rang_5_ans": "93",
    "index": "0.1",
    "en_retard_2024": "1.1",
    "ehdaa_2024": "15.2",
    "rang_2024": "101/470",
    "rang_2019_2024": "93/432",
    "lens_2018": "77.9",
    "lens_2019": "74.5",
    "lens_2022": "69.3",
    "lens_2023": "74.6",
    "lens_2024": "70.9",
    "lens_trend": "—",
    "lsec_2018": "82.4",
    "lsec_2019": "81.7",
    "lsec_2022": "82.2",
    "lsec_2023": "83.3",
    "lsec_2024": "83.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.9",
    "scie_2019": "70.4",
    "scie_2022": "73.5",
    "scie_2023": "77.9",
    "scie_2024": "75.2",
    "scie_trend": "112233",
    "math_2018": "76.8",
    "math_2019": "73.6",
    "math_2022": "76.5",
    "math_2023": "74.4",
    "math_2024": "76.0",
    "math_trend": "—",
    "echec_2018": "5.7",
    "echec_2019": "11.3",
    "echec_2022": "13.0",
    "echec_2023": "9.3",
    "echec_2024": "12.4",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "1.6",
    "sures_2022": "2.0",
    "sures_2023": "0.9",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.9",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 4.2",
    "ecart_sexes_lens_2024": "F 1.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.5",
    "ecart_sexes_math_2019": "F 1.1",
    "ecart_sexes_math_2022": "F 3.5",
    "ecart_sexes_math_2023": "F 0.4",
    "ecart_sexes_math_2024": "F 7.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.5",
    "prog_2019": "0.5",
    "prog_2022": "2.9",
    "prog_2023": "3.9",
    "prog_2024": "2.0",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "7.0",
    "cote_2022": "7.3",
    "cote_2023": "7.5",
    "cote_2024": "7.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège St-Jean-Vianney",
    "nom_court": "Collège St-Jean-Vianney",
    "adresse": "12630, boulevard Gouin Est",
    "municipalite": "Montréal",
    "code_postal": "H1C 1B9",
    "lat": 45.69177,
    "lng": -73.51986
  },
  {
    "_id": "399",
    "school_code": "158501",
    "school_name_1": "Saint-Maurice",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "871",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "4.3",
    "ehdaa_2024": "31.2",
    "rang_2024": "69/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "77.4",
    "lens_2019": "77.7",
    "lens_2022": "74.6",
    "lens_2023": "74.7",
    "lens_2024": "72.1",
    "lens_trend": "998855",
    "lsec_2018": "83.3",
    "lsec_2019": "81.8",
    "lsec_2022": "83.3",
    "lsec_2023": "80.0",
    "lsec_2024": "83.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.3",
    "scie_2019": "72.0",
    "scie_2022": "73.8",
    "scie_2023": "77.5",
    "scie_2024": "76.1",
    "scie_trend": "112233",
    "math_2018": "83.8",
    "math_2019": "81.9",
    "math_2022": "82.8",
    "math_2023": "80.5",
    "math_2024": "84.6",
    "math_trend": "998855",
    "echec_2018": "6.4",
    "echec_2019": "9.8",
    "echec_2022": "7.7",
    "echec_2023": "7.9",
    "echec_2024": "7.9",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "1.8",
    "sures_2022": "3.9",
    "sures_2023": "3.0",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 2.4",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 2.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 3.9",
    "ecart_sexes_math_2023": "M 2.0",
    "ecart_sexes_math_2024": "M 0.8",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.8",
    "prog_2019": "4.8",
    "prog_2022": "2.3",
    "prog_2023": "4.6",
    "prog_2024": "4.9",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "7.7",
    "cote_2022": "8.0",
    "cote_2023": "7.4",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Maurice ",
    "nom_court": "Col. Saint-Maurice",
    "adresse": "630, rue Girouard Ouest",
    "municipalite": "Saint-Hyacinthe",
    "code_postal": "J2S 2Y3",
    "lat": 45.63141,
    "lng": -72.94545
  },
  {
    "_id": "400",
    "school_code": "159501",
    "school_name_1": "Saint-Paul",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1088",
    "langue": "français",
    "secteur": "privé",
    "rang": "59",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "2.9",
    "ehdaa_2024": "42.9",
    "rang_2024": "59/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "74.8",
    "lens_2019": "73.5",
    "lens_2022": "76.7",
    "lens_2023": "76.2",
    "lens_2024": "74.6",
    "lens_trend": "—",
    "lsec_2018": "80.9",
    "lsec_2019": "78.5",
    "lsec_2022": "87.5",
    "lsec_2023": "90.1",
    "lsec_2024": "87.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.8",
    "scie_2019": "81.4",
    "scie_2022": "76.2",
    "scie_2023": "81.1",
    "scie_2024": "74.6",
    "scie_trend": "—",
    "math_2018": "76.5",
    "math_2019": "78.9",
    "math_2022": "77.0",
    "math_2023": "78.0",
    "math_2024": "78.0",
    "math_trend": "998855",
    "echec_2018": "5.1",
    "echec_2019": "7.4",
    "echec_2022": "8.3",
    "echec_2023": "7.0",
    "echec_2024": "9.3",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.4",
    "sures_2022": "1.5",
    "sures_2023": "0.4",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.8",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 3.8",
    "ecart_sexes_lens_2023": "F 4.5",
    "ecart_sexes_lens_2024": "F 2.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.4",
    "ecart_sexes_math_2019": "F 1.6",
    "ecart_sexes_math_2022": "F 4.0",
    "ecart_sexes_math_2023": "F 2.9",
    "ecart_sexes_math_2024": "F 2.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.7",
    "prog_2019": "0.6",
    "prog_2022": "3.4",
    "prog_2023": "4.0",
    "prog_2024": "2.3",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "8.0",
    "cote_2022": "8.5",
    "cote_2023": "8.5",
    "cote_2024": "8.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Paul",
    "nom_court": "Col. Saint-Paul",
    "adresse": "235, rue Sainte-Anne",
    "municipalite": "Varennes",
    "code_postal": "J3X 1P9",
    "lat": 45.68484,
    "lng": -73.4421
  },
  {
    "_id": "401",
    "school_code": "164501",
    "school_name_1": "Sainte-Marcelline",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "543",
    "langue": "français",
    "secteur": "privé",
    "rang": "10",
    "rang_5_ans": "14",
    "index": "0.1",
    "en_retard_2024": "3.9",
    "ehdaa_2024": "13.6",
    "rang_2024": "10/470",
    "rang_2019_2024": "14/432",
    "lens_2018": "79.2",
    "lens_2019": "76.5",
    "lens_2022": "74.8",
    "lens_2023": "74.5",
    "lens_2024": "77.8",
    "lens_trend": "—",
    "lsec_2018": "87.7",
    "lsec_2019": "87.1",
    "lsec_2022": "88.5",
    "lsec_2023": "89.6",
    "lsec_2024": "91.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.0",
    "scie_2019": "79.5",
    "scie_2022": "80.5",
    "scie_2023": "86.2",
    "scie_2024": "78.1",
    "scie_trend": "—",
    "math_2018": "87.1",
    "math_2019": "88.6",
    "math_2022": "85.4",
    "math_2023": "90.1",
    "math_2024": "90.1",
    "math_trend": "—",
    "echec_2018": "1.7",
    "echec_2019": "3.5",
    "echec_2022": "2.4",
    "echec_2023": "1.6",
    "echec_2024": "2.1",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "0.4",
    "sures_2022": "1.1",
    "sures_2023": "0.8",
    "sures_2024": "1.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "1.1",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "1.1",
    "prog_2024": "1.0",
    "prog_trend": "112233",
    "cote_2018": "9.4",
    "cote_2019": "9.4",
    "cote_2022": "9.5",
    "cote_2023": "9.5",
    "cote_2024": "9.9",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Sainte-Marcelline",
    "nom_court": "Collège Sainte-Marcelline",
    "adresse": "9155, boulevard Gouin Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4K 1C3",
    "lat": 45.51663,
    "lng": -73.74683
  },
  {
    "_id": "402",
    "school_code": "166501",
    "school_name_1": "Ville-Marie",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "823",
    "langue": "français",
    "secteur": "privé",
    "rang": "103",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "1.9",
    "ehdaa_2024": "26.2",
    "rang_2024": "103/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "66.5",
    "lens_2019": "69.6",
    "lens_2022": "64.2",
    "lens_2023": "71.0",
    "lens_2024": "71.4",
    "lens_trend": "112233",
    "lsec_2018": "81.7",
    "lsec_2019": "83.5",
    "lsec_2022": "89.0",
    "lsec_2023": "88.0",
    "lsec_2024": "84.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.1",
    "scie_2019": "71.2",
    "scie_2022": "67.9",
    "scie_2023": "75.9",
    "scie_2024": "72.9",
    "scie_trend": "—",
    "math_2018": "69.0",
    "math_2019": "66.5",
    "math_2022": "73.2",
    "math_2023": "78.7",
    "math_2024": "78.7",
    "math_trend": "—",
    "echec_2018": "15.7",
    "echec_2019": "15.4",
    "echec_2022": "21.8",
    "echec_2023": "10.4",
    "echec_2024": "9.8",
    "echec_trend": "112233",
    "sures_2018": "4.8",
    "sures_2019": "3.8",
    "sures_2022": "8.1",
    "sures_2023": "1.0",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.4",
    "ecart_sexes_lens_2019": "F 5.3",
    "ecart_sexes_lens_2022": "F 5.9",
    "ecart_sexes_lens_2023": "M 0.8",
    "ecart_sexes_lens_2024": "F 5.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 7.2",
    "ecart_sexes_math_2019": "M 1.1",
    "ecart_sexes_math_2022": "M 1.5",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "F 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "12.7",
    "prog_2019": "6.3",
    "prog_2022": "3.9",
    "prog_2023": "9.9",
    "prog_2024": "8.7",
    "prog_trend": "—",
    "cote_2018": "5.4",
    "cote_2019": "5.8",
    "cote_2022": "6.2",
    "cote_2023": "7.6",
    "cote_2024": "7.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Ville-Marie",
    "nom_court": "Col. Ville-Marie",
    "adresse": "2850, rue Sherbrooke Est",
    "municipalite": "Montréal",
    "code_postal": "H2K 1H3",
    "lat": 45.53963,
    "lng": -73.55881
  },
  {
    "_id": "403",
    "school_code": "188501",
    "school_name_1": "Beth Jacob D’Rav Hirschprung",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "171",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "49",
    "rang_5_ans": "93",
    "index": "0.1",
    "en_retard_2024": "8.1",
    "ehdaa_2024": "36.3",
    "rang_2024": "49/470",
    "rang_2019_2024": "93/432",
    "lens_2018": "81.9",
    "lens_2019": "78.0",
    "lens_2022": "76.5",
    "lens_2023": "78.2",
    "lens_2024": "85.8",
    "lens_trend": "—",
    "lsec_2018": "83.0",
    "lsec_2019": "79.6",
    "lsec_2022": "73.9",
    "lsec_2023": "85.0",
    "lsec_2024": "84.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "76.8",
    "scie_2022": "64.8",
    "scie_2023": "79.1",
    "scie_2024": "72.9",
    "scie_trend": "—",
    "math_2018": "78.6",
    "math_2019": "83.2",
    "math_2022": "76.7",
    "math_2023": "88.1",
    "math_2024": "87.4",
    "math_trend": "—",
    "echec_2018": "6.4",
    "echec_2019": "6.1",
    "echec_2022": "19.7",
    "echec_2023": "2.3",
    "echec_2024": "6.2",
    "echec_trend": "—",
    "sures_2018": "2.1",
    "sures_2019": "1.0",
    "sures_2022": "5.3",
    "sures_2023": "1.8",
    "sures_2024": "0.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "22.9",
    "prog_2019": "13.3",
    "prog_2022": "21.2",
    "prog_2023": "22.7",
    "prog_2024": "17.4",
    "prog_trend": "—",
    "cote_2018": "7.6",
    "cote_2019": "7.5",
    "cote_2022": "6.0",
    "cote_2023": "7.6",
    "cote_2024": "8.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Bais Yaakov D'Rav Hirschprung, section anglaise",
    "nom_court": "Éc. Bais Yaakov D'Rav Hirschprung, s.a.",
    "adresse": "1750, avenue Glendale",
    "municipalite": "Montréal",
    "code_postal": "H2V 1B3",
    "lat": 45.51732,
    "lng": -73.62365
  },
  {
    "_id": "404",
    "school_code": "198503",
    "school_name_1": "Emmanuel Christian",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "179",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "260",
    "rang_5_ans": "119",
    "index": "0.1",
    "en_retard_2024": "20",
    "ehdaa_2024": "nd",
    "rang_2024": "260/470",
    "rang_2019_2024": "119/432",
    "lens_2018": "78.7",
    "lens_2019": "81.7",
    "lens_2022": "82.4",
    "lens_2023": "80.3",
    "lens_2024": "78.2",
    "lens_trend": "—",
    "lsec_2018": "74.5",
    "lsec_2019": "80.2",
    "lsec_2022": "69.6",
    "lsec_2023": "76.6",
    "lsec_2024": "71.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "73.5",
    "scie_2019": "80.0",
    "scie_2022": "73.3",
    "scie_2023": "72.3",
    "scie_2024": "65.9",
    "scie_trend": "—",
    "math_2018": "79.0",
    "math_2019": "85.8",
    "math_2022": "86.5",
    "math_2023": "74.7",
    "math_2024": "76.5",
    "math_trend": "—",
    "echec_2018": "10.1",
    "echec_2019": "7.1",
    "echec_2022": "14.5",
    "echec_2023": "12.9",
    "echec_2024": "21.3",
    "echec_trend": "998855",
    "sures_2018": "3.2",
    "sures_2019": "0.7",
    "sures_2022": "4.5",
    "sures_2023": "3.8",
    "sures_2024": "6.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 7.7",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 1.3",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 14.8",
    "ecart_sexes_math_2024": "M 5.5",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "0.0",
    "prog_2019": "17.4",
    "prog_2022": "6.3",
    "prog_2023": "6.2",
    "prog_2024": "14.1",
    "prog_trend": "—",
    "cote_2018": "7.2",
    "cote_2019": "7.5",
    "cote_2022": "7.6",
    "cote_2023": "6.4",
    "cote_2024": "5.6",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École chrétienne Emmanuel, section anglaise - secondaire",
    "nom_court": "École chrétienne Emmanuel, s. ang. - sec",
    "adresse": "4698, boulevard Saint-Jean",
    "municipalite": "Dollard-des-Ormeaux",
    "code_postal": "H9H 4S5",
    "lat": 45.48683,
    "lng": -73.84978
  },
  {
    "_id": "405",
    "school_code": "204506",
    "school_name_1": "Belz, Campus Jeanne-Mance",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "208",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "96",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "16.7",
    "ehdaa_2024": "nd",
    "rang_2024": "96/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "78.4",
    "lens_2022": "73.0",
    "lens_2023": "73.9",
    "lens_2024": "73.6",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "80.8",
    "lsec_2022": "78.0",
    "lsec_2023": "78.9",
    "lsec_2024": "79.6",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "68.7",
    "scie_2022": "78.2",
    "scie_2023": "83.1",
    "scie_2024": "73.7",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "74.2",
    "math_2022": "86.2",
    "math_2023": "81.3",
    "math_2024": "83.9",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "19.5",
    "echec_2022": "8.3",
    "echec_2023": "5.7",
    "echec_2024": "7.9",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "5.5",
    "sures_2022": "1.3",
    "sures_2023": "1.1",
    "sures_2024": "0.2",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "48.2",
    "prog_2022": "8.7",
    "prog_2023": "2.5",
    "prog_2024": "5.6",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "5.4",
    "cote_2022": "7.3",
    "cote_2023": "7.5",
    "cote_2024": "7.5",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École communautaire Belz, Campus Jeanne-Mance, section anglaise",
    "nom_court": "École comm. Belz, C. Jeanne-Mance, s. a.",
    "adresse": "5030, rue Jeanne-Mance",
    "municipalite": "Montréal",
    "code_postal": "H2V 4J8",
    "lat": 45.51979,
    "lng": -73.59471
  },
  {
    "_id": "406",
    "school_code": "219501",
    "school_name_1": "Miss Edgar's & Miss Cramp's",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "133",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "26",
    "rang_5_ans": "26",
    "index": "0.1",
    "en_retard_2024": "19.2",
    "ehdaa_2024": "24.1",
    "rang_2024": "26/470",
    "rang_2019_2024": "26/432",
    "lens_2018": "80.7",
    "lens_2019": "80.8",
    "lens_2022": "83.1",
    "lens_2023": "78.9",
    "lens_2024": "83.5",
    "lens_trend": "—",
    "lsec_2018": "85.3",
    "lsec_2019": "84.4",
    "lsec_2022": "85.1",
    "lsec_2023": "86.0",
    "lsec_2024": "89.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.3",
    "scie_2019": "87.7",
    "scie_2022": "84.0",
    "scie_2023": "87.8",
    "scie_2024": "85.4",
    "scie_trend": "—",
    "math_2018": "87.5",
    "math_2019": "84.8",
    "math_2022": "92.0",
    "math_2023": "89.6",
    "math_2024": "90.9",
    "math_trend": "—",
    "echec_2018": "1.0",
    "echec_2019": "1.3",
    "echec_2022": "1.0",
    "echec_2023": "2.1",
    "echec_2024": "0.8",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "2.2",
    "sures_2022": "0.7",
    "sures_2023": "1.8",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "0.0",
    "prog_2019": "2.8",
    "prog_2022": "4.0",
    "prog_2023": "0.0",
    "prog_2024": "7.7",
    "prog_trend": "—",
    "cote_2018": "9.0",
    "cote_2019": "8.4",
    "cote_2022": "9.2",
    "cote_2023": "8.3",
    "cote_2024": "9.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Miss Edgar et Miss Cramp",
    "nom_court": "École Miss Edgar et Miss Cramp",
    "adresse": "525, avenue Mount Pleasant",
    "municipalite": "Westmount",
    "code_postal": "H3Y 3H6",
    "lat": 45.49121,
    "lng": -73.59676
  },
  {
    "_id": "407",
    "school_code": "226501",
    "school_name_1": "Jésus-Marie",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "415",
    "langue": "français",
    "secteur": "privé",
    "rang": "109",
    "rang_5_ans": "139",
    "index": "0.1",
    "en_retard_2024": "1.5",
    "ehdaa_2024": "19.8",
    "rang_2024": "109/470",
    "rang_2019_2024": "139/432",
    "lens_2018": "74.5",
    "lens_2019": "73.1",
    "lens_2022": "68.8",
    "lens_2023": "66.7",
    "lens_2024": "70.3",
    "lens_trend": "—",
    "lsec_2018": "74.6",
    "lsec_2019": "74.5",
    "lsec_2022": "76.7",
    "lsec_2023": "79.8",
    "lsec_2024": "80.4",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.1",
    "scie_2019": "74.6",
    "scie_2022": "71.7",
    "scie_2023": "81.5",
    "scie_2024": "78.0",
    "scie_trend": "—",
    "math_2018": "68.2",
    "math_2019": "76.8",
    "math_2022": "82.4",
    "math_2023": "82.3",
    "math_2024": "83.1",
    "math_trend": "—",
    "echec_2018": "11.9",
    "echec_2019": "11.8",
    "echec_2022": "11.7",
    "echec_2023": "11.0",
    "echec_2024": "9.3",
    "echec_trend": "112233",
    "sures_2018": "3.1",
    "sures_2019": "1.9",
    "sures_2022": "4.5",
    "sures_2023": "2.7",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.4",
    "ecart_sexes_lens_2019": "F 9.8",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 3.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.0",
    "ecart_sexes_math_2019": "F 4.9",
    "ecart_sexes_math_2022": "F 0.3",
    "ecart_sexes_math_2023": "F 4.7",
    "ecart_sexes_math_2024": "F 5.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "8.4",
    "prog_2019": "9.4",
    "prog_2022": "11.1",
    "prog_2023": "6.3",
    "prog_2024": "14.1",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "6.3",
    "cote_2022": "6.7",
    "cote_2023": "6.9",
    "cote_2024": "7.2",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École Jésus-Marie de Beauceville ",
    "nom_court": "Éc. Jésus-Marie Beauceville",
    "adresse": "670, 9e Avenue",
    "municipalite": "Beauceville",
    "code_postal": "G5X 3P6",
    "lat": 46.20352,
    "lng": -70.76495
  },
  {
    "_id": "408",
    "school_code": "229501",
    "school_name_1": "Maïmonide (Jacob Safra)",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "142",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "64",
    "index": "0.1",
    "en_retard_2024": "6.6",
    "ehdaa_2024": "34.5",
    "rang_2024": "40/470",
    "rang_2019_2024": "64/432",
    "lens_2018": "67.0",
    "lens_2019": "70.0",
    "lens_2022": "59.1",
    "lens_2023": "66.8",
    "lens_2024": "67.2",
    "lens_trend": "—",
    "lsec_2018": "90.9",
    "lsec_2019": "89.8",
    "lsec_2022": "85.3",
    "lsec_2023": "90.0",
    "lsec_2024": "93.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.8",
    "scie_2019": "74.5",
    "scie_2022": "77.0",
    "scie_2023": "85.8",
    "scie_2024": "82.6",
    "scie_trend": "—",
    "math_2018": "89.9",
    "math_2019": "79.0",
    "math_2022": "83.1",
    "math_2023": "86.3",
    "math_2024": "91.3",
    "math_trend": "—",
    "echec_2018": "11.0",
    "echec_2019": "12.5",
    "echec_2022": "15.3",
    "echec_2023": "6.3",
    "echec_2024": "9.2",
    "echec_trend": "112233",
    "sures_2018": "1.4",
    "sures_2019": "4.5",
    "sures_2022": "5.5",
    "sures_2023": "1.2",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "E",
    "ecart_sexes_lens_2023": "F 2.8",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "M 9.3",
    "ecart_sexes_math_2023": "M 2.7",
    "ecart_sexes_math_2024": "F 7.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.7",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "16.1",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "7.4",
    "cote_2022": "7.2",
    "cote_2023": "8.3",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Maïmonide, Campus Jacob Safra",
    "nom_court": "École Maïmonide, Campus Jacob Safra",
    "adresse": "1900, rue Bourdon",
    "municipalite": "Montréal",
    "code_postal": "H4M 2X7",
    "lat": 45.50048,
    "lng": -73.67366
  },
  {
    "_id": "409",
    "school_code": "237501",
    "school_name_1": "Marcelle-Mallet",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "710",
    "langue": "français",
    "secteur": "privé",
    "rang": "169",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "4.3",
    "ehdaa_2024": "17",
    "rang_2024": "169/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "75.2",
    "lens_2019": "75.5",
    "lens_2022": "66.1",
    "lens_2023": "73.0",
    "lens_2024": "69.6",
    "lens_trend": "—",
    "lsec_2018": "77.0",
    "lsec_2019": "77.1",
    "lsec_2022": "78.1",
    "lsec_2023": "78.4",
    "lsec_2024": "72.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.8",
    "scie_2019": "81.2",
    "scie_2022": "74.3",
    "scie_2023": "81.3",
    "scie_2024": "76.2",
    "scie_trend": "—",
    "math_2018": "74.7",
    "math_2019": "79.5",
    "math_2022": "74.8",
    "math_2023": "77.7",
    "math_2024": "81.9",
    "math_trend": "—",
    "echec_2018": "9.9",
    "echec_2019": "5.8",
    "echec_2022": "18.0",
    "echec_2023": "8.0",
    "echec_2024": "14.5",
    "echec_trend": "—",
    "sures_2018": "3.1",
    "sures_2019": "2.5",
    "sures_2022": "6.7",
    "sures_2023": "3.6",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.4",
    "ecart_sexes_lens_2019": "F 2.4",
    "ecart_sexes_lens_2022": "F 9.7",
    "ecart_sexes_lens_2023": "F 4.3",
    "ecart_sexes_lens_2024": "F 6.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.1",
    "ecart_sexes_math_2019": "F 3.2",
    "ecart_sexes_math_2022": "F 10.9",
    "ecart_sexes_math_2023": "M 1.5",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.0",
    "prog_2019": "1.2",
    "prog_2022": "2.3",
    "prog_2023": "10.0",
    "prog_2024": "2.8",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "7.8",
    "cote_2022": "5.7",
    "cote_2023": "7.0",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Marcelle-Mallet",
    "nom_court": "Éc. Marcelle-Mallet",
    "adresse": "51, rue Déziel",
    "municipalite": "Lévis",
    "code_postal": "G6V 3T7",
    "lat": 46.81013,
    "lng": -71.18526
  },
  {
    "_id": "410",
    "school_code": "244503",
    "school_name_1": "Marie-Clarac",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "450",
    "langue": "français",
    "secteur": "privé",
    "rang": "207",
    "rang_5_ans": "129",
    "index": "0.1",
    "en_retard_2024": "7.1",
    "ehdaa_2024": "22",
    "rang_2024": "207/470",
    "rang_2019_2024": "129/432",
    "lens_2018": "74.3",
    "lens_2019": "73.9",
    "lens_2022": "64.5",
    "lens_2023": "66.6",
    "lens_2024": "67.8",
    "lens_trend": "—",
    "lsec_2018": "79.1",
    "lsec_2019": "76.9",
    "lsec_2022": "78.1",
    "lsec_2023": "79.2",
    "lsec_2024": "72.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.7",
    "scie_2019": "71.8",
    "scie_2022": "72.4",
    "scie_2023": "74.8",
    "scie_2024": "73.9",
    "scie_trend": "—",
    "math_2018": "80.2",
    "math_2019": "73.4",
    "math_2022": "76.0",
    "math_2023": "77.1",
    "math_2024": "78.8",
    "math_trend": "—",
    "echec_2018": "4.9",
    "echec_2019": "7.0",
    "echec_2022": "15.7",
    "echec_2023": "12.2",
    "echec_2024": "14.1",
    "echec_trend": "998855",
    "sures_2018": "0.9",
    "sures_2019": "3.6",
    "sures_2022": "3.6",
    "sures_2023": "2.1",
    "sures_2024": "3.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "6.8",
    "prog_2019": "0.0",
    "prog_2022": "3.6",
    "prog_2023": "12.9",
    "prog_2024": "5.0",
    "prog_trend": "—",
    "cote_2018": "7.7",
    "cote_2019": "6.9",
    "cote_2022": "6.4",
    "cote_2023": "6.4",
    "cote_2024": "6.1",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École Marie-Clarac (Claudette Mackay-Lassonde)",
    "nom_court": "École Marie-Clarac",
    "adresse": "3641, boulevard Gouin Est",
    "municipalite": "Montréal",
    "code_postal": "H1H 5L8",
    "lat": 45.59228,
    "lng": -73.64944
  },
  {
    "_id": "411",
    "school_code": "266501",
    "school_name_1": "Notre Dame de Nareg",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laval ",
    "étudiants": "97",
    "langue": "français",
    "secteur": "privé",
    "rang": "169",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "22.7",
    "ehdaa_2024": "nd",
    "rang_2024": "169/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "73.6",
    "lens_2019": "64.9",
    "lens_2022": "72.1",
    "lens_2023": "61.6",
    "lens_2024": "67.9",
    "lens_trend": "—",
    "lsec_2018": "75.6",
    "lsec_2019": "88.5",
    "lsec_2022": "85.8",
    "lsec_2023": "85.9",
    "lsec_2024": "85.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.1",
    "scie_2019": "67.3",
    "scie_2022": "67.8",
    "scie_2023": "59.4",
    "scie_2024": "69.2",
    "scie_trend": "—",
    "math_2018": "84.8",
    "math_2019": "81.6",
    "math_2022": "62.2",
    "math_2023": "65.0",
    "math_2024": "74.4",
    "math_trend": "—",
    "echec_2018": "1.5",
    "echec_2019": "15.4",
    "echec_2022": "16.7",
    "echec_2023": "29.4",
    "echec_2024": "15.1",
    "echec_trend": "—",
    "sures_2018": "0.4",
    "sures_2019": "3.5",
    "sures_2022": "3.6",
    "sures_2023": "5.2",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 12.6",
    "ecart_sexes_lens_2022": "F 2.4",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 8.5",
    "ecart_sexes_math_2022": "M 7.6",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "F 1.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "0.0",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "0.0",
    "prog_2024": "10.9",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "6.3",
    "cote_2022": "7.1",
    "cote_2023": "4.5",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Notre Dame de Nareg",
    "nom_court": "École Notre Dame de Nareg",
    "adresse": "500, 67e Avenue",
    "municipalite": "Laval",
    "code_postal": "H7V 2N2",
    "lat": 45.54221,
    "lng": -73.73281
  },
  {
    "_id": "412",
    "school_code": "269501",
    "school_name_1": "Pasteur",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "321",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "7",
    "index": "0.1",
    "en_retard_2024": "1.6",
    "ehdaa_2024": "6.5",
    "rang_2024": "1/470",
    "rang_2019_2024": "7/432",
    "lens_2018": "80.1",
    "lens_2019": "76.1",
    "lens_2022": "81.2",
    "lens_2023": "81.5",
    "lens_2024": "81.2",
    "lens_trend": "—",
    "lsec_2018": "82.0",
    "lsec_2019": "83.0",
    "lsec_2022": "88.2",
    "lsec_2023": "91.5",
    "lsec_2024": "83.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "87.0",
    "scie_2019": "88.1",
    "scie_2022": "90.1",
    "scie_2023": "93.1",
    "scie_2024": "94.1",
    "scie_trend": "112233",
    "math_2018": "81.5",
    "math_2019": "89.4",
    "math_2022": "92.5",
    "math_2023": "92.2",
    "math_2024": "94.7",
    "math_trend": "112233",
    "echec_2018": "1.7",
    "echec_2019": "0.9",
    "echec_2022": "0.0",
    "echec_2023": "0.4",
    "echec_2024": "1.5",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "0.1",
    "sures_2023": "0.0",
    "sures_2024": "0.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.9",
    "ecart_sexes_lens_2019": "F 0.7",
    "ecart_sexes_lens_2022": "M 0.6",
    "ecart_sexes_lens_2023": "F 0.2",
    "ecart_sexes_lens_2024": "F 7.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 5.0",
    "ecart_sexes_math_2019": "M 3.1",
    "ecart_sexes_math_2022": "M 0.3",
    "ecart_sexes_math_2023": "F 0.3",
    "ecart_sexes_math_2024": "F 1.0",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "0.0",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "0.0",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "9.1",
    "cote_2019": "9.6",
    "cote_2022": "10.0",
    "cote_2023": "10.0",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Pasteur, Pavillon Khalil Gibran",
    "nom_court": "Collège Pasteur, Pavillon Khalil Gibran",
    "adresse": "12345, avenue de la Miséricorde",
    "municipalite": "Montréal",
    "code_postal": "H4J 2E8",
    "lat": 45.53433,
    "lng": -73.71843
  },
  {
    "_id": "413",
    "school_code": "304501",
    "school_name_1": "Les Trois Saisons",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "83",
    "langue": "français",
    "secteur": "privé",
    "rang": "229",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "68.7",
    "rang_2024": "229/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "68.5",
    "lens_2023": "nd",
    "lens_2024": "71.6",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "84.4",
    "lsec_2023": "nd",
    "lsec_2024": "83.1",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "71.5",
    "scie_2023": "nd",
    "scie_2024": "65.7",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "69.9",
    "math_2023": "nd",
    "math_2024": "66.4",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "16.8",
    "echec_2023": "nd",
    "echec_2024": "18.9",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "1.1",
    "sures_2023": "nd",
    "sures_2024": "0.6",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "26.7",
    "prog_2023": "nd",
    "prog_2024": "10.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "6.6",
    "cote_2023": "nd",
    "cote_2024": "5.9",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École Les Trois Saisons",
    "nom_court": "École Les Trois Saisons",
    "adresse": "570, boulevard de Mortagne",
    "municipalite": "Boucherville",
    "code_postal": "J4B 5E4",
    "lat": 45.59369,
    "lng": -73.43266
  },
  {
    "_id": "414",
    "school_code": "308501",
    "school_name_1": "St. George's",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "263",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "63",
    "rang_5_ans": "40",
    "index": "0.1",
    "en_retard_2024": "3.8",
    "ehdaa_2024": "nd",
    "rang_2024": "63/470",
    "rang_2019_2024": "40/432",
    "lens_2018": "86.2",
    "lens_2019": "85.6",
    "lens_2022": "85.9",
    "lens_2023": "86.0",
    "lens_2024": "85.6",
    "lens_trend": "998855",
    "lsec_2018": "81.9",
    "lsec_2019": "79.7",
    "lsec_2022": "78.2",
    "lsec_2023": "80.8",
    "lsec_2024": "80.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.8",
    "scie_2019": "80.0",
    "scie_2022": "82.7",
    "scie_2023": "89.1",
    "scie_2024": "83.9",
    "scie_trend": "—",
    "math_2018": "82.8",
    "math_2019": "82.2",
    "math_2022": "88.4",
    "math_2023": "84.9",
    "math_2024": "83.5",
    "math_trend": "—",
    "echec_2018": "2.8",
    "echec_2019": "3.2",
    "echec_2022": "2.7",
    "echec_2023": "3.6",
    "echec_2024": "2.4",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.7",
    "sures_2022": "1.3",
    "sures_2023": "2.9",
    "sures_2024": "1.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 3.4",
    "ecart_sexes_lens_2022": "F 2.9",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "F 2.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.7",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 3.5",
    "ecart_sexes_math_2023": "F 1.9",
    "ecart_sexes_math_2024": "F 13.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "11.8",
    "prog_2019": "7.0",
    "prog_2022": "10.2",
    "prog_2023": "10.8",
    "prog_2024": "7.2",
    "prog_trend": "—",
    "cote_2018": "8.5",
    "cote_2019": "8.4",
    "cote_2022": "8.7",
    "cote_2023": "8.2",
    "cote_2024": "8.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "L'École St-Georges de Montréal inc. (campus I)",
    "nom_court": "Éc. St-Georges de Montréal (Campus I)",
    "adresse": "3100, Le Boulevard",
    "municipalite": "Montréal",
    "code_postal": "H3Y 1R9",
    "lat": 45.49373,
    "lng": -73.59673
  },
  {
    "_id": "415",
    "school_code": "314501",
    "school_name_1": "Bromptonville",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "534",
    "langue": "français",
    "secteur": "privé",
    "rang": "137",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "13.2",
    "ehdaa_2024": "43.1",
    "rang_2024": "137/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "70.2",
    "lens_2019": "68.7",
    "lens_2022": "63.2",
    "lens_2023": "62.6",
    "lens_2024": "67.7",
    "lens_trend": "—",
    "lsec_2018": "82.0",
    "lsec_2019": "79.0",
    "lsec_2022": "82.4",
    "lsec_2023": "80.8",
    "lsec_2024": "82.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "70.1",
    "scie_2022": "72.9",
    "scie_2023": "73.3",
    "scie_2024": "73.2",
    "scie_trend": "—",
    "math_2018": "71.9",
    "math_2019": "65.9",
    "math_2022": "70.1",
    "math_2023": "66.6",
    "math_2024": "76.9",
    "math_trend": "—",
    "echec_2018": "13.8",
    "echec_2019": "20.8",
    "echec_2022": "19.4",
    "echec_2023": "21.2",
    "echec_2024": "13.3",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "0.3",
    "sures_2022": "2.5",
    "sures_2023": "5.4",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.2",
    "ecart_sexes_lens_2019": "F 5.5",
    "ecart_sexes_lens_2022": "F 3.4",
    "ecart_sexes_lens_2023": "M 0.1",
    "ecart_sexes_lens_2024": "F 4.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.3",
    "ecart_sexes_math_2019": "F 1.9",
    "ecart_sexes_math_2022": "F 16.5",
    "ecart_sexes_math_2023": "F 2.8",
    "ecart_sexes_math_2024": "F 0.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "10.4",
    "prog_2019": "5.2",
    "prog_2022": "5.6",
    "prog_2023": "16.9",
    "prog_2024": "17.1",
    "prog_trend": "—",
    "cote_2018": "6.8",
    "cote_2019": "5.7",
    "cote_2022": "6.2",
    "cote_2023": "5.1",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire de Bromptonville ",
    "nom_court": "Éc. sec. de Bromptonville",
    "adresse": "125, rue du Frère-Théode",
    "municipalite": "Sherbrooke",
    "code_postal": "J1C 0S3",
    "lat": 45.47155,
    "lng": -71.95311
  },
  {
    "_id": "416",
    "school_code": "315501",
    "school_name_1": "du Verbe Divin",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "623",
    "langue": "français",
    "secteur": "privé",
    "rang": "126",
    "rang_5_ans": "106",
    "index": "0.1",
    "en_retard_2024": "4.2",
    "ehdaa_2024": "25.7",
    "rang_2024": "126/470",
    "rang_2019_2024": "106/432",
    "lens_2018": "78.9",
    "lens_2019": "73.3",
    "lens_2022": "70.3",
    "lens_2023": "70.5",
    "lens_2024": "73.1",
    "lens_trend": "—",
    "lsec_2018": "79.6",
    "lsec_2019": "77.8",
    "lsec_2022": "79.9",
    "lsec_2023": "78.2",
    "lsec_2024": "75.1",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "76.1",
    "scie_2019": "76.2",
    "scie_2022": "74.7",
    "scie_2023": "79.0",
    "scie_2024": "75.6",
    "scie_trend": "—",
    "math_2018": "75.0",
    "math_2019": "80.2",
    "math_2022": "75.3",
    "math_2023": "80.8",
    "math_2024": "77.3",
    "math_trend": "—",
    "echec_2018": "5.0",
    "echec_2019": "8.7",
    "echec_2022": "10.7",
    "echec_2023": "11.1",
    "echec_2024": "11.1",
    "echec_trend": "998855",
    "sures_2018": "0.6",
    "sures_2019": "0.7",
    "sures_2022": "1.8",
    "sures_2023": "1.2",
    "sures_2024": "2.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.7",
    "ecart_sexes_lens_2019": "F 3.8",
    "ecart_sexes_lens_2022": "F 3.9",
    "ecart_sexes_lens_2023": "F 9.4",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 9.0",
    "ecart_sexes_math_2019": "F 1.2",
    "ecart_sexes_math_2022": "F 0.4",
    "ecart_sexes_math_2023": "M 1.1",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "11.7",
    "prog_2019": "6.5",
    "prog_2022": "7.8",
    "prog_2023": "6.2",
    "prog_2024": "9.4",
    "prog_trend": "—",
    "cote_2018": "7.4",
    "cote_2019": "7.4",
    "cote_2022": "7.3",
    "cote_2023": "6.9",
    "cote_2024": "6.9",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "École secondaire du Verbe Divin",
    "nom_court": "École secondaire du Verbe Divin",
    "adresse": "1021, rue Cowie C.P. 786",
    "municipalite": "Granby",
    "code_postal": "J2G 8W8",
    "lat": 45.39651,
    "lng": -72.77321
  },
  {
    "_id": "417",
    "school_code": "317501",
    "school_name_1": "François-Bourrin",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "514",
    "langue": "français",
    "secteur": "privé",
    "rang": "86",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "5.3",
    "ehdaa_2024": "28.6",
    "rang_2024": "86/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "72.4",
    "lens_2019": "73.8",
    "lens_2022": "77.0",
    "lens_2023": "71.8",
    "lens_2024": "71.5",
    "lens_trend": "—",
    "lsec_2018": "80.7",
    "lsec_2019": "78.9",
    "lsec_2022": "79.4",
    "lsec_2023": "80.4",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.7",
    "scie_2019": "74.0",
    "scie_2022": "78.0",
    "scie_2023": "81.6",
    "scie_2024": "75.6",
    "scie_trend": "—",
    "math_2018": "84.0",
    "math_2019": "79.9",
    "math_2022": "81.3",
    "math_2023": "82.4",
    "math_2024": "83.7",
    "math_trend": "—",
    "echec_2018": "6.0",
    "echec_2019": "10.7",
    "echec_2022": "5.8",
    "echec_2023": "5.4",
    "echec_2024": "8.1",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "0.9",
    "sures_2022": "1.8",
    "sures_2023": "1.4",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 0.8",
    "ecart_sexes_lens_2023": "M 1.6",
    "ecart_sexes_lens_2024": "F 6.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.7",
    "ecart_sexes_math_2019": "F 4.0",
    "ecart_sexes_math_2022": "F 4.3",
    "ecart_sexes_math_2023": "F 2.6",
    "ecart_sexes_math_2024": "F 1.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "13.4",
    "prog_2019": "0.0",
    "prog_2022": "9.1",
    "prog_2023": "1.3",
    "prog_2024": "3.9",
    "prog_trend": "—",
    "cote_2018": "7.8",
    "cote_2019": "7.1",
    "cote_2022": "8.2",
    "cote_2023": "7.9",
    "cote_2024": "7.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire privée François-Bourrin",
    "nom_court": "École secondaire privée François-Bourrin",
    "adresse": "50, avenue des Cascades",
    "municipalite": "Québec",
    "code_postal": "G1E 2J7",
    "lat": 46.86163,
    "lng": -71.1961
  },
  {
    "_id": "418",
    "school_code": "321501",
    "school_name_1": "Boisbriand",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "782",
    "langue": "français",
    "secteur": "privé",
    "rang": "229",
    "rang_5_ans": "222",
    "index": "0.1",
    "en_retard_2024": "6.2",
    "ehdaa_2024": "34.3",
    "rang_2024": "229/470",
    "rang_2019_2024": "222/432",
    "lens_2018": "58.0",
    "lens_2019": "60.3",
    "lens_2022": "61.0",
    "lens_2023": "67.6",
    "lens_2024": "64.6",
    "lens_trend": "112233",
    "lsec_2018": "82.6",
    "lsec_2019": "77.9",
    "lsec_2022": "87.4",
    "lsec_2023": "78.2",
    "lsec_2024": "76.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.6",
    "scie_2019": "72.7",
    "scie_2022": "72.3",
    "scie_2023": "78.1",
    "scie_2024": "72.6",
    "scie_trend": "—",
    "math_2018": "71.4",
    "math_2019": "79.0",
    "math_2022": "76.0",
    "math_2023": "80.0",
    "math_2024": "77.1",
    "math_trend": "—",
    "echec_2018": "19.9",
    "echec_2019": "18.9",
    "echec_2022": "17.7",
    "echec_2023": "8.7",
    "echec_2024": "14.5",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.4",
    "sures_2022": "1.7",
    "sures_2023": "1.1",
    "sures_2024": "3.9",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "M 1.5",
    "ecart_sexes_lens_2023": "M 2.3",
    "ecart_sexes_lens_2024": "F 5.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 2.3",
    "ecart_sexes_math_2023": "F 0.7",
    "ecart_sexes_math_2024": "M 4.7",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "46.0",
    "prog_2019": "21.4",
    "prog_2022": "10.2",
    "prog_2023": "11.5",
    "prog_2024": "7.9",
    "prog_trend": "112233",
    "cote_2018": "4.5",
    "cote_2019": "5.1",
    "cote_2022": "7.0",
    "cote_2023": "7.2",
    "cote_2024": "5.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Boisbriand 2016",
    "nom_court": "Collège Boisbriand 2016",
    "adresse": "4747, rue Ambroise-Lafortune",
    "municipalite": "Boisbriand",
    "code_postal": "J7H 0A4",
    "lat": 45.64072,
    "lng": -73.86801
  },
  {
    "_id": "419",
    "school_code": "322501",
    "school_name_1": "Letendre",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laval ",
    "étudiants": "1945",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "1.5",
    "ehdaa_2024": "26",
    "rang_2024": "69/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "70.0",
    "lens_2019": "70.2",
    "lens_2022": "66.4",
    "lens_2023": "69.5",
    "lens_2024": "67.1",
    "lens_trend": "—",
    "lsec_2018": "80.0",
    "lsec_2019": "81.5",
    "lsec_2022": "81.2",
    "lsec_2023": "81.6",
    "lsec_2024": "83.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.7",
    "scie_2019": "75.1",
    "scie_2022": "73.6",
    "scie_2023": "79.9",
    "scie_2024": "78.2",
    "scie_trend": "—",
    "math_2018": "80.3",
    "math_2019": "80.3",
    "math_2022": "81.4",
    "math_2023": "83.6",
    "math_2024": "83.6",
    "math_trend": "—",
    "echec_2018": "9.0",
    "echec_2019": "9.7",
    "echec_2022": "12.8",
    "echec_2023": "8.0",
    "echec_2024": "9.8",
    "echec_trend": "112233",
    "sures_2018": "1.0",
    "sures_2019": "1.2",
    "sures_2022": "4.2",
    "sures_2023": "1.5",
    "sures_2024": "2.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 1.9",
    "ecart_sexes_lens_2022": "F 2.6",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "F 1.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.7",
    "ecart_sexes_math_2019": "F 1.7",
    "ecart_sexes_math_2022": "F 5.1",
    "ecart_sexes_math_2023": "F 1.6",
    "ecart_sexes_math_2024": "F 0.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.3",
    "prog_2019": "2.8",
    "prog_2022": "1.8",
    "prog_2023": "6.8",
    "prog_2024": "2.4",
    "prog_trend": "—",
    "cote_2018": "7.4",
    "cote_2019": "7.6",
    "cote_2022": "7.3",
    "cote_2023": "7.6",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Letendre",
    "nom_court": "Collège Letendre",
    "adresse": "1000, boulevard de l'Avenir",
    "municipalite": "Laval",
    "code_postal": "H7N 6J6",
    "lat": 45.56021,
    "lng": -73.72202
  },
  {
    "_id": "420",
    "school_code": "323501",
    "school_name_1": "Marcellin-Champagnat",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1226",
    "langue": "français",
    "secteur": "privé",
    "rang": "31",
    "rang_5_ans": "30",
    "index": "0.1",
    "en_retard_2024": "2.8",
    "ehdaa_2024": "21.4",
    "rang_2024": "31/470",
    "rang_2019_2024": "30/432",
    "lens_2018": "79.4",
    "lens_2019": "75.3",
    "lens_2022": "71.2",
    "lens_2023": "75.5",
    "lens_2024": "76.9",
    "lens_trend": "—",
    "lsec_2018": "88.0",
    "lsec_2019": "83.3",
    "lsec_2022": "80.7",
    "lsec_2023": "82.2",
    "lsec_2024": "82.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.2",
    "scie_2019": "78.3",
    "scie_2022": "82.4",
    "scie_2023": "84.9",
    "scie_2024": "80.4",
    "scie_trend": "—",
    "math_2018": "87.6",
    "math_2019": "80.3",
    "math_2022": "88.2",
    "math_2023": "87.3",
    "math_2024": "86.3",
    "math_trend": "—",
    "echec_2018": "3.4",
    "echec_2019": "6.5",
    "echec_2022": "7.6",
    "echec_2023": "4.0",
    "echec_2024": "4.5",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "1.4",
    "sures_2022": "1.9",
    "sures_2023": "2.0",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 4.4",
    "ecart_sexes_lens_2023": "F 5.0",
    "ecart_sexes_lens_2024": "F 5.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 1.2",
    "ecart_sexes_math_2019": "F 4.6",
    "ecart_sexes_math_2022": "F 2.6",
    "ecart_sexes_math_2023": "F 2.3",
    "ecart_sexes_math_2024": "F 2.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.6",
    "prog_2019": "2.3",
    "prog_2022": "2.6",
    "prog_2023": "2.7",
    "prog_2024": "0.9",
    "prog_trend": "—",
    "cote_2018": "9.2",
    "cote_2019": "8.4",
    "cote_2022": "8.5",
    "cote_2023": "8.5",
    "cote_2024": "8.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Marcellin-Champagnat ",
    "nom_court": "Éc. sec. Marcellin-Champagnat",
    "adresse": "14, chemin des Patriotes Est",
    "municipalite": "Saint-Jean-sur-Richelieu",
    "code_postal": "J2X 5P9",
    "lat": 45.31784,
    "lng": -73.24741
  },
  {
    "_id": "421",
    "school_code": "324501",
    "school_name_1": "Collège d'Anjou",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "731",
    "langue": "français",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "106",
    "index": "0.1",
    "en_retard_2024": "1.4",
    "ehdaa_2024": "12.2",
    "rang_2024": "53/470",
    "rang_2019_2024": "106/432",
    "lens_2018": "66.6",
    "lens_2019": "65.5",
    "lens_2022": "61.0",
    "lens_2023": "66.1",
    "lens_2024": "70.0",
    "lens_trend": "—",
    "lsec_2018": "84.5",
    "lsec_2019": "86.0",
    "lsec_2022": "91.2",
    "lsec_2023": "88.9",
    "lsec_2024": "91.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.4",
    "scie_2019": "77.6",
    "scie_2022": "73.8",
    "scie_2023": "82.2",
    "scie_2024": "77.2",
    "scie_trend": "—",
    "math_2018": "69.6",
    "math_2019": "74.7",
    "math_2022": "79.3",
    "math_2023": "80.5",
    "math_2024": "82.1",
    "math_trend": "112233",
    "echec_2018": "15.1",
    "echec_2019": "13.7",
    "echec_2022": "16.2",
    "echec_2023": "10.8",
    "echec_2024": "9.4",
    "echec_trend": "112233",
    "sures_2018": "3.6",
    "sures_2019": "3.0",
    "sures_2022": "4.1",
    "sures_2023": "2.3",
    "sures_2024": "0.8",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 0.5",
    "ecart_sexes_lens_2019": "F 4.1",
    "ecart_sexes_lens_2022": "F 7.3",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "F 4.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.3",
    "ecart_sexes_math_2019": "F 3.5",
    "ecart_sexes_math_2022": "M 2.4",
    "ecart_sexes_math_2023": "F 3.3",
    "ecart_sexes_math_2024": "F 2.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "6.7",
    "prog_2019": "7.7",
    "prog_2022": "5.0",
    "prog_2023": "14.4",
    "prog_2024": "4.9",
    "prog_trend": "—",
    "cote_2018": "6.2",
    "cote_2019": "6.7",
    "cote_2022": "7.2",
    "cote_2023": "7.4",
    "cote_2024": "8.3",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège d'Anjou",
    "nom_court": "Collège d'Anjou",
    "adresse": "11000, rue Renaude-Lapointe",
    "municipalite": "Montréal",
    "code_postal": "H1J 2V7",
    "lat": 45.61162,
    "lng": -73.59236
  },
  {
    "_id": "422",
    "school_code": "326501",
    "school_name_1": "Mont-Saint-Sacrement",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "882",
    "langue": "français",
    "secteur": "privé",
    "rang": "67",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "1.1",
    "ehdaa_2024": "15.9",
    "rang_2024": "67/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "78.0",
    "lens_2019": "78.2",
    "lens_2022": "72.3",
    "lens_2023": "75.2",
    "lens_2024": "72.8",
    "lens_trend": "—",
    "lsec_2018": "81.0",
    "lsec_2019": "82.6",
    "lsec_2022": "80.4",
    "lsec_2023": "79.9",
    "lsec_2024": "81.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.9",
    "scie_2019": "77.1",
    "scie_2022": "77.5",
    "scie_2023": "85.1",
    "scie_2024": "78.2",
    "scie_trend": "—",
    "math_2018": "85.0",
    "math_2019": "79.9",
    "math_2022": "84.4",
    "math_2023": "85.4",
    "math_2024": "85.7",
    "math_trend": "—",
    "echec_2018": "5.2",
    "echec_2019": "5.1",
    "echec_2022": "9.8",
    "echec_2023": "3.7",
    "echec_2024": "7.6",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "0.9",
    "sures_2022": "3.4",
    "sures_2023": "1.3",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.2",
    "ecart_sexes_lens_2019": "F 3.9",
    "ecart_sexes_lens_2022": "F 3.0",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 3.0",
    "ecart_sexes_math_2019": "F 5.0",
    "ecart_sexes_math_2022": "F 4.5",
    "ecart_sexes_math_2023": "F 2.4",
    "ecart_sexes_math_2024": "E",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.9",
    "prog_2019": "4.3",
    "prog_2022": "1.2",
    "prog_2023": "4.2",
    "prog_2024": "3.0",
    "prog_trend": "—",
    "cote_2018": "8.4",
    "cote_2019": "8.3",
    "cote_2022": "7.8",
    "cote_2023": "8.4",
    "cote_2024": "8.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Mont-Saint-Sacrement",
    "nom_court": "École secondaire Mont-Saint-Sacrement",
    "adresse": "200, boulevard Saint-Sacrement",
    "municipalite": "Saint-Gabriel-de-Valcartier",
    "code_postal": "G0A 4S0",
    "lat": 46.97858,
    "lng": -71.50747
  },
  {
    "_id": "423",
    "school_code": "327501",
    "school_name_1": "Notre-Dame",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Bas-Saint-Laurent ",
    "étudiants": "564",
    "langue": "français",
    "secteur": "privé",
    "rang": "86",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "3.5",
    "ehdaa_2024": "27.3",
    "rang_2024": "86/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "76.1",
    "lens_2019": "73.8",
    "lens_2022": "70.4",
    "lens_2023": "72.0",
    "lens_2024": "70.8",
    "lens_trend": "—",
    "lsec_2018": "80.1",
    "lsec_2019": "80.6",
    "lsec_2022": "83.0",
    "lsec_2023": "84.0",
    "lsec_2024": "82.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.4",
    "scie_2019": "81.4",
    "scie_2022": "77.3",
    "scie_2023": "84.3",
    "scie_2024": "82.7",
    "scie_trend": "—",
    "math_2018": "77.6",
    "math_2019": "79.4",
    "math_2022": "72.6",
    "math_2023": "71.2",
    "math_2024": "81.7",
    "math_trend": "—",
    "echec_2018": "5.0",
    "echec_2019": "8.4",
    "echec_2022": "14.6",
    "echec_2023": "11.9",
    "echec_2024": "8.2",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.5",
    "sures_2022": "4.4",
    "sures_2023": "5.4",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.2",
    "ecart_sexes_lens_2019": "F 6.9",
    "ecart_sexes_lens_2022": "F 7.0",
    "ecart_sexes_lens_2023": "F 5.9",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.1",
    "ecart_sexes_math_2019": "F 3.2",
    "ecart_sexes_math_2022": "F 2.0",
    "ecart_sexes_math_2023": "F 12.7",
    "ecart_sexes_math_2024": "F 4.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.3",
    "prog_2019": "6.6",
    "prog_2022": "6.4",
    "prog_2023": "7.6",
    "prog_2024": "9.7",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "7.8",
    "cote_2022": "7.0",
    "cote_2023": "6.3",
    "cote_2024": "7.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Notre-Dame de Rivière-du-Loup",
    "nom_court": "Collège Notre-Dame de Rivière-du-Loup",
    "adresse": "56, rue Saint-Henri",
    "municipalite": "Rivière-du-Loup",
    "code_postal": "G5R 2A1",
    "lat": 47.82224,
    "lng": -69.53605
  },
  {
    "_id": "424",
    "school_code": "335501",
    "school_name_1": "Saint-Joseph de Hull",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Outaouais ",
    "étudiants": "864",
    "langue": "français",
    "secteur": "privé",
    "rang": "10",
    "rang_5_ans": "7",
    "index": "0.1",
    "en_retard_2024": "1.8",
    "ehdaa_2024": "14.8",
    "rang_2024": "10/470",
    "rang_2019_2024": "7/432",
    "lens_2018": "77.4",
    "lens_2019": "78.1",
    "lens_2022": "73.2",
    "lens_2023": "79.2",
    "lens_2024": "77.8",
    "lens_trend": "—",
    "lsec_2018": "85.1",
    "lsec_2019": "82.6",
    "lsec_2022": "81.1",
    "lsec_2023": "80.5",
    "lsec_2024": "81.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "89.2",
    "scie_2019": "90.9",
    "scie_2022": "89.3",
    "scie_2023": "88.6",
    "scie_2024": "88.2",
    "scie_trend": "—",
    "math_2018": "83.5",
    "math_2019": "88.2",
    "math_2022": "91.2",
    "math_2023": "87.5",
    "math_2024": "89.7",
    "math_trend": "—",
    "echec_2018": "3.1",
    "echec_2019": "2.0",
    "echec_2022": "3.2",
    "echec_2023": "1.6",
    "echec_2024": "2.6",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "0.3",
    "sures_2022": "2.4",
    "sures_2023": "0.4",
    "sures_2024": "0.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "2.8",
    "prog_2019": "3.8",
    "prog_2022": "1.2",
    "prog_2023": "3.1",
    "prog_2024": "1.8",
    "prog_trend": "—",
    "cote_2018": "9.5",
    "cote_2019": "10.0",
    "cote_2022": "9.5",
    "cote_2023": "9.5",
    "cote_2024": "9.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Saint-Joseph de Hull",
    "nom_court": "Coll. St-Joseph de Hull",
    "adresse": "174, rue Notre-Dame-de-l'Île",
    "municipalite": "Gatineau",
    "code_postal": "J8X 3T4",
    "lat": 45.4314,
    "lng": -75.71038
  },
  {
    "_id": "425",
    "school_code": "336501",
    "school_name_1": "Saint-Joseph",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "1132",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "59",
    "index": "0.1",
    "en_retard_2024": "10.1",
    "ehdaa_2024": "39.8",
    "rang_2024": "69/470",
    "rang_2019_2024": "59/432",
    "lens_2018": "76.6",
    "lens_2019": "76.8",
    "lens_2022": "72.3",
    "lens_2023": "74.5",
    "lens_2024": "72.2",
    "lens_trend": "—",
    "lsec_2018": "80.1",
    "lsec_2019": "78.7",
    "lsec_2022": "78.5",
    "lsec_2023": "79.3",
    "lsec_2024": "79.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.2",
    "scie_2019": "75.1",
    "scie_2022": "74.7",
    "scie_2023": "79.5",
    "scie_2024": "76.6",
    "scie_trend": "—",
    "math_2018": "78.5",
    "math_2019": "80.2",
    "math_2022": "82.9",
    "math_2023": "80.8",
    "math_2024": "86.7",
    "math_trend": "112233",
    "echec_2018": "7.2",
    "echec_2019": "6.4",
    "echec_2022": "8.8",
    "echec_2023": "6.0",
    "echec_2024": "7.8",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.3",
    "sures_2022": "0.3",
    "sures_2023": "0.0",
    "sures_2024": "0.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.7",
    "ecart_sexes_lens_2019": "F 2.3",
    "ecart_sexes_lens_2022": "M 0.3",
    "ecart_sexes_lens_2023": "F 1.8",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.3",
    "ecart_sexes_math_2019": "F 3.9",
    "ecart_sexes_math_2022": "M 3.5",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "M 2.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.7",
    "prog_2019": "8.1",
    "prog_2022": "9.8",
    "prog_2023": "12.5",
    "prog_2024": "14.6",
    "prog_trend": "998855",
    "cote_2018": "8.0",
    "cote_2019": "8.0",
    "cote_2022": "8.0",
    "cote_2023": "8.0",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Saint-Joseph de Saint-Hyacinthe",
    "nom_court": "Éc. sec. Saint-Joseph",
    "adresse": "2875, ave Bourdages Nord",
    "municipalite": "Saint-Hyacinthe",
    "code_postal": "J2S 5S3",
    "lat": 45.63277,
    "lng": -72.96422
  },
  {
    "_id": "426",
    "school_code": "337501",
    "school_name_1": "Saint-Sacrement",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Lanaudière ",
    "étudiants": "1622",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "7",
    "index": "0.1",
    "en_retard_2024": "1.3",
    "ehdaa_2024": "4.9",
    "rang_2024": "1/470",
    "rang_2019_2024": "7/432",
    "lens_2018": "80.9",
    "lens_2019": "78.4",
    "lens_2022": "78.1",
    "lens_2023": "80.8",
    "lens_2024": "77.4",
    "lens_trend": "—",
    "lsec_2018": "83.2",
    "lsec_2019": "83.0",
    "lsec_2022": "83.1",
    "lsec_2023": "82.5",
    "lsec_2024": "84.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "85.8",
    "scie_2019": "81.6",
    "scie_2022": "86.7",
    "scie_2023": "91.0",
    "scie_2024": "88.8",
    "scie_trend": "112233",
    "math_2018": "87.4",
    "math_2019": "90.9",
    "math_2022": "91.0",
    "math_2023": "92.3",
    "math_2024": "94.4",
    "math_trend": "—",
    "echec_2018": "1.0",
    "echec_2019": "2.0",
    "echec_2022": "1.3",
    "echec_2023": "0.9",
    "echec_2024": "1.3",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.8",
    "sures_2022": "0.3",
    "sures_2023": "0.3",
    "sures_2024": "0.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.0",
    "ecart_sexes_lens_2019": "F 2.6",
    "ecart_sexes_lens_2022": "F 2.2",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.3",
    "ecart_sexes_math_2019": "F 2.1",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "M 1.3",
    "ecart_sexes_math_2024": "F 1.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.7",
    "prog_2019": "1.1",
    "prog_2022": "0.7",
    "prog_2023": "0.7",
    "prog_2024": "1.6",
    "prog_trend": "—",
    "cote_2018": "9.5",
    "cote_2019": "9.3",
    "cote_2022": "9.8",
    "cote_2023": "9.7",
    "cote_2024": "10.0",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Saint-Sacrement",
    "nom_court": "Collège Saint-Sacrement",
    "adresse": "901, rue Saint-Louis",
    "municipalite": "Terrebonne",
    "code_postal": "J6W 1K1",
    "lat": 45.69624,
    "lng": -73.63762
  },
  {
    "_id": "427",
    "school_code": "338502",
    "school_name_1": "Selwyn House",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "199",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "67",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "2.9",
    "ehdaa_2024": "nd",
    "rang_2024": "67/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "84.1",
    "lens_2019": "81.9",
    "lens_2022": "85.4",
    "lens_2023": "82.9",
    "lens_2024": "81.5",
    "lens_trend": "—",
    "lsec_2018": "84.3",
    "lsec_2019": "84.8",
    "lsec_2022": "86.6",
    "lsec_2023": "82.7",
    "lsec_2024": "81.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.5",
    "scie_2019": "76.2",
    "scie_2022": "77.2",
    "scie_2023": "81.6",
    "scie_2024": "79.8",
    "scie_trend": "112233",
    "math_2018": "78.6",
    "math_2019": "80.1",
    "math_2022": "83.4",
    "math_2023": "84.8",
    "math_2024": "84.5",
    "math_trend": "—",
    "echec_2018": "5.5",
    "echec_2019": "6.6",
    "echec_2022": "3.7",
    "echec_2023": "1.8",
    "echec_2024": "4.2",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "2.5",
    "sures_2022": "1.4",
    "sures_2023": "2.0",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "4.7",
    "prog_2019": "4.8",
    "prog_2022": "9.1",
    "prog_2023": "7.5",
    "prog_2024": "8.8",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "7.9",
    "cote_2022": "8.8",
    "cote_2023": "8.1",
    "cote_2024": "8.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École Selwyn House, Campus 2",
    "nom_court": "École Selwyn House, Campus 2",
    "adresse": "101, chemin de la Côte-Saint-Antoine",
    "municipalite": "Westmount",
    "code_postal": "H3Y 2H8",
    "lat": 45.48569,
    "lng": -73.59823
  },
  {
    "_id": "428",
    "school_code": "350501",
    "school_name_1": "Externat Sacré-Coeur",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "1229",
    "langue": "français",
    "secteur": "privé",
    "rang": "26",
    "rang_5_ans": "26",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "15.1",
    "rang_2024": "26/470",
    "rang_2019_2024": "26/432",
    "lens_2018": "76.9",
    "lens_2019": "78.1",
    "lens_2022": "76.0",
    "lens_2023": "75.9",
    "lens_2024": "75.3",
    "lens_trend": "—",
    "lsec_2018": "84.1",
    "lsec_2019": "83.2",
    "lsec_2022": "86.3",
    "lsec_2023": "87.3",
    "lsec_2024": "86.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.8",
    "scie_2019": "77.7",
    "scie_2022": "78.2",
    "scie_2023": "86.6",
    "scie_2024": "82.2",
    "scie_trend": "—",
    "math_2018": "81.2",
    "math_2019": "84.2",
    "math_2022": "79.7",
    "math_2023": "81.4",
    "math_2024": "82.3",
    "math_trend": "—",
    "echec_2018": "3.8",
    "echec_2019": "4.9",
    "echec_2022": "6.4",
    "echec_2023": "3.9",
    "echec_2024": "3.8",
    "echec_trend": "112233",
    "sures_2018": "0.4",
    "sures_2019": "0.3",
    "sures_2022": "0.2",
    "sures_2023": "0.2",
    "sures_2024": "0.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 1.9",
    "ecart_sexes_lens_2019": "F 2.6",
    "ecart_sexes_lens_2022": "F 4.1",
    "ecart_sexes_lens_2023": "F 5.6",
    "ecart_sexes_lens_2024": "F 3.6",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 7.3",
    "ecart_sexes_math_2019": "F 0.3",
    "ecart_sexes_math_2022": "F 4.1",
    "ecart_sexes_math_2023": "F 0.3",
    "ecart_sexes_math_2024": "M 0.2",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "0.5",
    "prog_2022": "1.8",
    "prog_2023": "1.3",
    "prog_2024": "0.4",
    "prog_trend": "—",
    "cote_2018": "8.6",
    "cote_2019": "8.8",
    "cote_2022": "8.7",
    "cote_2023": "8.9",
    "cote_2024": "9.1",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Externat Sacré-Coeur",
    "nom_court": "Externat Sacré-Coeur",
    "adresse": "535, rue Lefrançois",
    "municipalite": "Rosemère",
    "code_postal": "J7A 4R5",
    "lat": 45.65446,
    "lng": -73.79013
  },
  {
    "_id": "429",
    "school_code": "352501",
    "school_name_1": "Saint-Jean-Eudes",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1194",
    "langue": "français",
    "secteur": "privé",
    "rang": "91",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "3.1",
    "ehdaa_2024": "17.9",
    "rang_2024": "91/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "76.2",
    "lens_2019": "75.1",
    "lens_2022": "70.1",
    "lens_2023": "69.4",
    "lens_2024": "70.2",
    "lens_trend": "—",
    "lsec_2018": "78.0",
    "lsec_2019": "77.8",
    "lsec_2022": "78.5",
    "lsec_2023": "78.5",
    "lsec_2024": "78.7",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.0",
    "scie_2019": "80.1",
    "scie_2022": "76.0",
    "scie_2023": "82.1",
    "scie_2024": "77.8",
    "scie_trend": "—",
    "math_2018": "81.7",
    "math_2019": "85.6",
    "math_2022": "80.5",
    "math_2023": "82.7",
    "math_2024": "85.7",
    "math_trend": "—",
    "echec_2018": "3.9",
    "echec_2019": "5.0",
    "echec_2022": "9.1",
    "echec_2023": "8.4",
    "echec_2024": "8.6",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "1.1",
    "sures_2022": "2.5",
    "sures_2023": "1.9",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 6.6",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.4",
    "ecart_sexes_math_2019": "F 1.8",
    "ecart_sexes_math_2022": "M 1.4",
    "ecart_sexes_math_2023": "F 4.7",
    "ecart_sexes_math_2024": "F 2.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.8",
    "prog_2019": "3.1",
    "prog_2022": "1.6",
    "prog_2023": "5.3",
    "prog_2024": "7.9",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.1",
    "cote_2022": "7.4",
    "cote_2023": "7.3",
    "cote_2024": "7.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Saint-Jean-Eudes",
    "nom_court": "Saint-Jean-Eudes",
    "adresse": "650, avenue du Bourg-Royal",
    "municipalite": "Québec",
    "code_postal": "G2L 1M8",
    "lat": 46.87696,
    "lng": -71.24345
  },
  {
    "_id": "430",
    "school_code": "364501",
    "school_name_1": "Greaves Adventist",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "65",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "367",
    "rang_5_ans": "403",
    "index": "0.1",
    "en_retard_2024": "25",
    "ehdaa_2024": "nd",
    "rang_2024": "367/470",
    "rang_2019_2024": "403/432",
    "lens_2018": "75.9",
    "lens_2019": "74.7",
    "lens_2022": "76.8",
    "lens_2023": "72.8",
    "lens_2024": "76.3",
    "lens_trend": "—",
    "lsec_2018": "77.1",
    "lsec_2019": "72.1",
    "lsec_2022": "76.6",
    "lsec_2023": "77.6",
    "lsec_2024": "80.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.3",
    "scie_2019": "58.9",
    "scie_2022": "72.1",
    "scie_2023": "68.6",
    "scie_2024": "71.8",
    "scie_trend": "112233",
    "math_2018": "53.9",
    "math_2019": "50.0",
    "math_2022": "33.6",
    "math_2023": "53.8",
    "math_2024": "53.6",
    "math_trend": "—",
    "echec_2018": "24.7",
    "echec_2019": "35.5",
    "echec_2022": "32.8",
    "echec_2023": "30.4",
    "echec_2024": "19.4",
    "echec_trend": "—",
    "sures_2018": "6.4",
    "sures_2019": "11.8",
    "sures_2022": "13.8",
    "sures_2023": "6.4",
    "sures_2024": "6.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 12.8",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 19.5",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "25.0",
    "prog_2019": "23.6",
    "prog_2022": "35.7",
    "prog_2023": "9.2",
    "prog_2024": "50.9",
    "prog_trend": "—",
    "cote_2018": "4.3",
    "cote_2019": "3.0",
    "cote_2022": "3.6",
    "cote_2023": "3.9",
    "cote_2024": "4.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie adventiste Greaves, Campus de Montréal",
    "nom_court": "Académie adventiste Greaves, Campus Mtl",
    "adresse": "2330, avenue West Hill",
    "municipalite": "Montréal",
    "code_postal": "H4B 2S4",
    "lat": 45.46391,
    "lng": -73.62318
  },
  {
    "_id": "431",
    "school_code": "365501",
    "school_name_1": "Institut d'Enseignement",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Côte-Nord ",
    "étudiants": "196",
    "langue": "français",
    "secteur": "privé",
    "rang": "427",
    "rang_5_ans": "409",
    "index": "0.1",
    "en_retard_2024": "12.8",
    "ehdaa_2024": "19.4",
    "rang_2024": "427/470",
    "rang_2019_2024": "409/432",
    "lens_2018": "69.4",
    "lens_2019": "65.9",
    "lens_2022": "57.4",
    "lens_2023": "65.6",
    "lens_2024": "66.3",
    "lens_trend": "—",
    "lsec_2018": "82.7",
    "lsec_2019": "78.1",
    "lsec_2022": "81.4",
    "lsec_2023": "67.1",
    "lsec_2024": "77.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.6",
    "scie_2019": "65.6",
    "scie_2022": "58.1",
    "scie_2023": "56.0",
    "scie_2024": "60.5",
    "scie_trend": "—",
    "math_2018": "76.4",
    "math_2019": "69.9",
    "math_2022": "56.2",
    "math_2023": "57.5",
    "math_2024": "77.0",
    "math_trend": "—",
    "echec_2018": "13.3",
    "echec_2019": "27.6",
    "echec_2022": "41.3",
    "echec_2023": "43.1",
    "echec_2024": "26.2",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "4.8",
    "sures_2022": "11.9",
    "sures_2023": "5.2",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.9",
    "ecart_sexes_lens_2019": "F 8.3",
    "ecart_sexes_lens_2022": "M 0.8",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "M 5.4",
    "ecart_sexes_math_2019": "F 9.1",
    "ecart_sexes_math_2022": "F 1.7",
    "ecart_sexes_math_2023": "F 1.4",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "6.9",
    "prog_2019": "10.7",
    "prog_2022": "24.3",
    "prog_2023": "34.7",
    "prog_2024": "36.4",
    "prog_trend": "998855",
    "cote_2018": "6.5",
    "cote_2019": "3.9",
    "cote_2022": "2.8",
    "cote_2023": "1.8",
    "cote_2024": "3.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Institut d'enseignement de Sept-Îles",
    "nom_court": "Institut d'enseignement de Sept-Îles",
    "adresse": "737, avenue Gamache",
    "municipalite": "Sept-Îles",
    "code_postal": "G4R 2J8",
    "lat": 50.21753,
    "lng": -66.39035
  },
  {
    "_id": "432",
    "school_code": "367501",
    "school_name_1": "Reine-Marie",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1498",
    "langue": "français",
    "secteur": "privé",
    "rang": "35",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "3.6",
    "ehdaa_2024": "22.8",
    "rang_2024": "35/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "74.9",
    "lens_2019": "69.4",
    "lens_2022": "66.6",
    "lens_2023": "70.3",
    "lens_2024": "69.7",
    "lens_trend": "—",
    "lsec_2018": "79.9",
    "lsec_2019": "74.9",
    "lsec_2022": "85.3",
    "lsec_2023": "87.3",
    "lsec_2024": "89.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.5",
    "scie_2019": "72.9",
    "scie_2022": "74.9",
    "scie_2023": "77.9",
    "scie_2024": "77.5",
    "scie_trend": "112233",
    "math_2018": "75.5",
    "math_2019": "77.0",
    "math_2022": "80.3",
    "math_2023": "80.0",
    "math_2024": "83.1",
    "math_trend": "112233",
    "echec_2018": "9.4",
    "echec_2019": "12.1",
    "echec_2022": "14.1",
    "echec_2023": "7.7",
    "echec_2024": "7.9",
    "echec_trend": "112233",
    "sures_2018": "0.4",
    "sures_2019": "1.6",
    "sures_2022": "1.6",
    "sures_2023": "0.4",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 6.9",
    "ecart_sexes_lens_2019": "F 5.7",
    "ecart_sexes_lens_2022": "F 4.5",
    "ecart_sexes_lens_2023": "F 2.3",
    "ecart_sexes_lens_2024": "F 1.0",
    "ecart_sexes_lens_trend": "112233",
    "ecart_sexes_math_2018": "M 1.9",
    "ecart_sexes_math_2019": "F 7.5",
    "ecart_sexes_math_2022": "F 2.1",
    "ecart_sexes_math_2023": "M 0.9",
    "ecart_sexes_math_2024": "M 0.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "8.5",
    "prog_2019": "1.7",
    "prog_2022": "0.8",
    "prog_2023": "5.5",
    "prog_2024": "4.5",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "6.3",
    "cote_2022": "7.8",
    "cote_2023": "8.1",
    "cote_2024": "8.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Collège Reine-Marie",
    "nom_court": "Collège Reine-Marie",
    "adresse": "9300, boulevard Saint-Michel",
    "municipalite": "Montréal",
    "code_postal": "H1Z 3H1",
    "lat": 45.57266,
    "lng": -73.63272
  },
  {
    "_id": "433",
    "school_code": "374501",
    "school_name_1": "Keranna",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Mauricie ",
    "étudiants": "667",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "40",
    "index": "0.1",
    "en_retard_2024": "3",
    "ehdaa_2024": "23.8",
    "rang_2024": "40/470",
    "rang_2019_2024": "40/432",
    "lens_2018": "82.8",
    "lens_2019": "80.9",
    "lens_2022": "78.2",
    "lens_2023": "78.8",
    "lens_2024": "77.6",
    "lens_trend": "998855",
    "lsec_2018": "85.7",
    "lsec_2019": "79.6",
    "lsec_2022": "79.6",
    "lsec_2023": "80.5",
    "lsec_2024": "82.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.0",
    "scie_2019": "77.2",
    "scie_2022": "81.8",
    "scie_2023": "83.5",
    "scie_2024": "81.0",
    "scie_trend": "—",
    "math_2018": "77.8",
    "math_2019": "80.0",
    "math_2022": "78.6",
    "math_2023": "79.5",
    "math_2024": "83.6",
    "math_trend": "—",
    "echec_2018": "3.6",
    "echec_2019": "4.3",
    "echec_2022": "7.1",
    "echec_2023": "5.0",
    "echec_2024": "5.3",
    "echec_trend": "—",
    "sures_2018": "0.5",
    "sures_2019": "0.7",
    "sures_2022": "2.9",
    "sures_2023": "2.5",
    "sures_2024": "1.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.7",
    "ecart_sexes_lens_2019": "F 3.5",
    "ecart_sexes_lens_2022": "F 4.8",
    "ecart_sexes_lens_2023": "F 5.4",
    "ecart_sexes_lens_2024": "F 3.8",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.7",
    "ecart_sexes_math_2019": "F 3.4",
    "ecart_sexes_math_2022": "M 0.7",
    "ecart_sexes_math_2023": "F 1.1",
    "ecart_sexes_math_2024": "F 3.6",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.7",
    "prog_2019": "0.8",
    "prog_2022": "2.4",
    "prog_2023": "3.2",
    "prog_2024": "5.4",
    "prog_trend": "998855",
    "cote_2018": "8.7",
    "cote_2019": "8.4",
    "cote_2022": "8.3",
    "cote_2023": "8.1",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Institut secondaire Keranna",
    "nom_court": "Institut secondaire Keranna",
    "adresse": "6205, boulevard des Chenaux",
    "municipalite": "Trois-Rivières",
    "code_postal": "G8Y 6Z1",
    "lat": 46.3577,
    "lng": -72.60485
  },
  {
    "_id": "434",
    "school_code": "377501",
    "school_name_1": "Juvénat Notre-Dame du Saint-Laurent",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Chaudière-Appalaches ",
    "étudiants": "887",
    "langue": "français",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "43",
    "index": "0.1",
    "en_retard_2024": "2.3",
    "ehdaa_2024": "10",
    "rang_2024": "53/470",
    "rang_2019_2024": "43/432",
    "lens_2018": "75.5",
    "lens_2019": "78.1",
    "lens_2022": "75.5",
    "lens_2023": "76.6",
    "lens_2024": "75.1",
    "lens_trend": "—",
    "lsec_2018": "83.2",
    "lsec_2019": "83.3",
    "lsec_2022": "79.9",
    "lsec_2023": "79.8",
    "lsec_2024": "78.9",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.0",
    "scie_2019": "81.6",
    "scie_2022": "80.5",
    "scie_2023": "83.8",
    "scie_2024": "81.4",
    "scie_trend": "—",
    "math_2018": "79.8",
    "math_2019": "81.3",
    "math_2022": "87.2",
    "math_2023": "81.2",
    "math_2024": "89.2",
    "math_trend": "—",
    "echec_2018": "3.6",
    "echec_2019": "3.4",
    "echec_2022": "5.2",
    "echec_2023": "5.0",
    "echec_2024": "5.4",
    "echec_trend": "—",
    "sures_2018": "1.1",
    "sures_2019": "0.8",
    "sures_2022": "1.3",
    "sures_2023": "0.7",
    "sures_2024": "1.0",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 6.0",
    "ecart_sexes_lens_2019": "F 1.0",
    "ecart_sexes_lens_2022": "F 3.9",
    "ecart_sexes_lens_2023": "F 4.9",
    "ecart_sexes_lens_2024": "F 6.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 4.2",
    "ecart_sexes_math_2019": "F 1.4",
    "ecart_sexes_math_2022": "F 4.6",
    "ecart_sexes_math_2023": "F 1.6",
    "ecart_sexes_math_2024": "F 2.3",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.6",
    "prog_2019": "1.8",
    "prog_2022": "1.1",
    "prog_2023": "2.1",
    "prog_2024": "1.6",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "8.8",
    "cote_2022": "8.4",
    "cote_2023": "8.2",
    "cote_2024": "8.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Juvénat Notre-Dame du Saint-Laurent",
    "nom_court": "Juvénat Notre-Dame du Saint-Laurent",
    "adresse": "30, rue du Juvénat",
    "municipalite": "Lévis",
    "code_postal": "G6W 7X2",
    "lat": 46.76189,
    "lng": -71.2355
  },
  {
    "_id": "435",
    "school_code": "382501",
    "school_name_1": "Hebrew Academy",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "198",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "103",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "6.1",
    "ehdaa_2024": "18.7",
    "rang_2024": "103/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "84.1",
    "lens_2019": "79.9",
    "lens_2022": "78.9",
    "lens_2023": "83.0",
    "lens_2024": "78.8",
    "lens_trend": "—",
    "lsec_2018": "81.7",
    "lsec_2019": "81.4",
    "lsec_2022": "74.9",
    "lsec_2023": "78.1",
    "lsec_2024": "78.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.4",
    "scie_2019": "83.5",
    "scie_2022": "76.7",
    "scie_2023": "89.8",
    "scie_2024": "79.8",
    "scie_trend": "—",
    "math_2018": "83.1",
    "math_2019": "88.1",
    "math_2022": "74.0",
    "math_2023": "89.0",
    "math_2024": "81.7",
    "math_trend": "—",
    "echec_2018": "2.4",
    "echec_2019": "4.1",
    "echec_2022": "16.5",
    "echec_2023": "2.3",
    "echec_2024": "6.1",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "1.3",
    "sures_2022": "4.4",
    "sures_2023": "1.4",
    "sures_2024": "1.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.8",
    "ecart_sexes_lens_2019": "F 2.2",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 10.2",
    "ecart_sexes_lens_trend": "998855",
    "ecart_sexes_math_2018": "M 1.3",
    "ecart_sexes_math_2019": "F 1.5",
    "ecart_sexes_math_2022": "F 5.0",
    "ecart_sexes_math_2023": "F 2.5",
    "ecart_sexes_math_2024": "F 10.6",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "2.4",
    "prog_2019": "2.8",
    "prog_2022": "5.0",
    "prog_2023": "6.0",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.2",
    "cote_2022": "6.8",
    "cote_2023": "8.0",
    "cote_2024": "7.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie hébraïque inc., section anglaise",
    "nom_court": "Ac. hébraïque inc., section anglaise",
    "adresse": "5700, avenue Kellert",
    "municipalite": "Côte-Saint-Luc",
    "code_postal": "H4W 1T4",
    "lat": 45.47258,
    "lng": -73.66163
  },
  {
    "_id": "436",
    "school_code": "384501",
    "school_name_1": "Ali Ibn Abi Talib",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "136",
    "langue": "français",
    "secteur": "privé",
    "rang": "19",
    "rang_5_ans": "26",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "nd",
    "rang_2024": "19/470",
    "rang_2019_2024": "26/432",
    "lens_2018": "80.6",
    "lens_2019": "75.9",
    "lens_2022": "68.9",
    "lens_2023": "74.9",
    "lens_2024": "77.1",
    "lens_trend": "—",
    "lsec_2018": "79.8",
    "lsec_2019": "79.9",
    "lsec_2022": "82.7",
    "lsec_2023": "80.9",
    "lsec_2024": "82.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.6",
    "scie_2019": "79.6",
    "scie_2022": "76.9",
    "scie_2023": "86.6",
    "scie_2024": "82.8",
    "scie_trend": "—",
    "math_2018": "83.3",
    "math_2019": "89.2",
    "math_2022": "88.4",
    "math_2023": "89.1",
    "math_2024": "87.7",
    "math_trend": "—",
    "echec_2018": "0.0",
    "echec_2019": "3.8",
    "echec_2022": "10.4",
    "echec_2023": "2.1",
    "echec_2024": "2.1",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.8",
    "sures_2022": "3.8",
    "sures_2023": "0.9",
    "sures_2024": "0.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 7.1",
    "ecart_sexes_lens_2022": "F 13.2",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 2.2",
    "ecart_sexes_math_2022": "M 1.8",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "0.0",
    "prog_2019": "6.3",
    "prog_2022": "0.0",
    "prog_2023": "0.0",
    "prog_2024": "3.4",
    "prog_trend": "—",
    "cote_2018": "9.5",
    "cote_2019": "8.3",
    "cote_2022": "7.6",
    "cote_2023": "9.0",
    "cote_2024": "9.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "L'École Ali Ibn Abi Talib",
    "nom_court": "L'École Ali Ibn Abi Talib",
    "adresse": "1610, rue De Beauharnois Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4N 1J5",
    "lat": 45.52877,
    "lng": -73.65239
  },
  {
    "_id": "437",
    "school_code": "385501",
    "school_name_1": "Arménienne Sourp Hagop",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "229",
    "langue": "français",
    "secteur": "privé",
    "rang": "103",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "5.9",
    "ehdaa_2024": "5.2",
    "rang_2024": "103/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "71.3",
    "lens_2019": "70.4",
    "lens_2022": "68.4",
    "lens_2023": "69.9",
    "lens_2024": "70.2",
    "lens_trend": "112233",
    "lsec_2018": "80.2",
    "lsec_2019": "82.8",
    "lsec_2022": "80.4",
    "lsec_2023": "86.7",
    "lsec_2024": "82.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.3",
    "scie_2019": "80.6",
    "scie_2022": "77.6",
    "scie_2023": "81.1",
    "scie_2024": "79.4",
    "scie_trend": "—",
    "math_2018": "73.8",
    "math_2019": "73.9",
    "math_2022": "79.0",
    "math_2023": "83.5",
    "math_2024": "76.7",
    "math_trend": "—",
    "echec_2018": "9.4",
    "echec_2019": "10.0",
    "echec_2022": "9.4",
    "echec_2023": "6.7",
    "echec_2024": "8.1",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "0.6",
    "sures_2022": "0.7",
    "sures_2023": "0.0",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.5",
    "ecart_sexes_lens_2019": "M 0.7",
    "ecart_sexes_lens_2022": "F 6.0",
    "ecart_sexes_lens_2023": "F 4.7",
    "ecart_sexes_lens_2024": "F 6.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.3",
    "ecart_sexes_math_2019": "F 4.3",
    "ecart_sexes_math_2022": "M 3.1",
    "ecart_sexes_math_2023": "F 3.8",
    "ecart_sexes_math_2024": "M 0.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "37.2",
    "prog_2019": "7.2",
    "prog_2022": "2.7",
    "prog_2023": "2.5",
    "prog_2024": "7.4",
    "prog_trend": "—",
    "cote_2018": "6.0",
    "cote_2019": "7.4",
    "cote_2022": "7.7",
    "cote_2023": "8.2",
    "cote_2024": "7.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "L'École arménienne Sourp Hagop",
    "nom_court": "L'École arménienne Sourp Hagop",
    "adresse": "3400, rue Nadon",
    "municipalite": "Montréal",
    "code_postal": "H4J 1P5",
    "lat": 45.53136,
    "lng": -73.69595
  },
  {
    "_id": "438",
    "school_code": "388501",
    "school_name_1": "Sacred Heart",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "188",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "91",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "4.9",
    "ehdaa_2024": "23.9",
    "rang_2024": "91/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "77.7",
    "lens_2019": "79.9",
    "lens_2022": "81.8",
    "lens_2023": "78.2",
    "lens_2024": "81.8",
    "lens_trend": "—",
    "lsec_2018": "78.4",
    "lsec_2019": "82.6",
    "lsec_2022": "74.2",
    "lsec_2023": "79.5",
    "lsec_2024": "74.6",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.1",
    "scie_2019": "83.0",
    "scie_2022": "73.2",
    "scie_2023": "86.0",
    "scie_2024": "74.1",
    "scie_trend": "—",
    "math_2018": "83.8",
    "math_2019": "87.4",
    "math_2022": "78.1",
    "math_2023": "82.9",
    "math_2024": "85.8",
    "math_trend": "—",
    "echec_2018": "3.4",
    "echec_2019": "3.0",
    "echec_2022": "11.3",
    "echec_2023": "5.6",
    "echec_2024": "7.4",
    "echec_trend": "—",
    "sures_2018": "3.2",
    "sures_2019": "1.5",
    "sures_2022": "6.4",
    "sures_2023": "3.8",
    "sures_2024": "4.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "2.5",
    "prog_2019": "5.7",
    "prog_2022": "2.9",
    "prog_2023": "6.7",
    "prog_2024": "4.9",
    "prog_trend": "—",
    "cote_2018": "8.4",
    "cote_2019": "8.4",
    "cote_2022": "7.4",
    "cote_2023": "7.4",
    "cote_2024": "7.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "L'École Sacré-Coeur de Montréal",
    "nom_court": "L'École Sacré-Coeur de Montréal",
    "adresse": "3635, avenue Atwater",
    "municipalite": "Montréal",
    "code_postal": "H3H 1Y4",
    "lat": 45.4952,
    "lng": -73.58756
  },
  {
    "_id": "439",
    "school_code": "401501",
    "school_name_1": "Collège François-de-Laval",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "704",
    "langue": "français",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "59",
    "index": "0.1",
    "en_retard_2024": "1.7",
    "ehdaa_2024": "25.1",
    "rang_2024": "53/470",
    "rang_2019_2024": "59/432",
    "lens_2018": "74.5",
    "lens_2019": "73.3",
    "lens_2022": "71.6",
    "lens_2023": "76.0",
    "lens_2024": "72.0",
    "lens_trend": "—",
    "lsec_2018": "82.6",
    "lsec_2019": "79.9",
    "lsec_2022": "80.1",
    "lsec_2023": "80.0",
    "lsec_2024": "81.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.0",
    "scie_2019": "78.6",
    "scie_2022": "80.1",
    "scie_2023": "79.4",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "81.5",
    "math_2019": "86.0",
    "math_2022": "87.3",
    "math_2023": "81.4",
    "math_2024": "86.8",
    "math_trend": "—",
    "echec_2018": "6.1",
    "echec_2019": "5.4",
    "echec_2022": "7.1",
    "echec_2023": "6.2",
    "echec_2024": "6.3",
    "echec_trend": "—",
    "sures_2018": "0.8",
    "sures_2019": "1.4",
    "sures_2022": "2.6",
    "sures_2023": "1.3",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.0",
    "ecart_sexes_lens_2019": "F 1.8",
    "ecart_sexes_lens_2022": "F 1.4",
    "ecart_sexes_lens_2023": "F 3.5",
    "ecart_sexes_lens_2024": "F 0.1",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.6",
    "ecart_sexes_math_2019": "F 2.6",
    "ecart_sexes_math_2022": "F 6.6",
    "ecart_sexes_math_2023": "F 3.6",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "4.4",
    "prog_2019": "1.4",
    "prog_2022": "6.4",
    "prog_2023": "4.5",
    "prog_2024": "1.6",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "8.1",
    "cote_2022": "8.0",
    "cote_2023": "7.7",
    "cote_2024": "8.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège François-de-Laval",
    "nom_court": "Collège François-de-Laval",
    "adresse": "6, rue de la Vieille-Université",
    "municipalite": "Québec",
    "code_postal": "G1R 5X8",
    "lat": 46.81529,
    "lng": -71.20634
  },
  {
    "_id": "440",
    "school_code": "403504",
    "school_name_1": "Skver, section française",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "105",
    "langue": "français",
    "secteur": "privé",
    "rang": "19",
    "rang_5_ans": "21",
    "index": "0.1",
    "en_retard_2024": "11.1",
    "ehdaa_2024": "nd",
    "rang_2024": "19/470",
    "rang_2019_2024": "21/432",
    "lens_2018": "69.6",
    "lens_2019": "78.5",
    "lens_2022": "68.4",
    "lens_2023": "79.2",
    "lens_2024": "68.8",
    "lens_trend": "—",
    "lsec_2018": "90.8",
    "lsec_2019": "93.0",
    "lsec_2022": "90.2",
    "lsec_2023": "92.0",
    "lsec_2024": "92.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.6",
    "scie_2019": "75.0",
    "scie_2022": "78.2",
    "scie_2023": "77.5",
    "scie_2024": "79.7",
    "scie_trend": "—",
    "math_2018": "90.4",
    "math_2019": "81.8",
    "math_2022": "90.8",
    "math_2023": "81.7",
    "math_2024": "95.3",
    "math_trend": "—",
    "echec_2018": "2.9",
    "echec_2019": "2.7",
    "echec_2022": "7.6",
    "echec_2023": "4.9",
    "echec_2024": "4.6",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "1.9",
    "sures_2022": "2.9",
    "sures_2023": "3.0",
    "sures_2024": "3.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "20.0",
    "prog_2019": "20.0",
    "prog_2022": "17.9",
    "prog_2023": "5.6",
    "prog_2024": "0.0",
    "prog_trend": "112233",
    "cote_2018": "8.7",
    "cote_2019": "9.2",
    "cote_2022": "8.8",
    "cote_2023": "9.4",
    "cote_2024": "9.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "Les écoles communautaires Skver, section française",
    "nom_court": "Les écoles comm. Skver, sect. française",
    "adresse": "940, avenue Outremont",
    "municipalite": "Montréal",
    "code_postal": "H2V 4P8",
    "lat": 45.52229,
    "lng": -73.61691
  },
  {
    "_id": "441",
    "school_code": "404503",
    "school_name_1": "Bialik",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "353",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "55",
    "index": "0.1",
    "en_retard_2024": "6.7",
    "ehdaa_2024": "42.5",
    "rang_2024": "40/470",
    "rang_2019_2024": "55/432",
    "lens_2018": "76.2",
    "lens_2019": "76.9",
    "lens_2022": "73.9",
    "lens_2023": "77.4",
    "lens_2024": "76.2",
    "lens_trend": "—",
    "lsec_2018": "77.2",
    "lsec_2019": "79.5",
    "lsec_2022": "76.9",
    "lsec_2023": "81.5",
    "lsec_2024": "80.4",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.8",
    "scie_2019": "83.4",
    "scie_2022": "81.7",
    "scie_2023": "83.0",
    "scie_2024": "82.1",
    "scie_trend": "—",
    "math_2018": "89.8",
    "math_2019": "91.8",
    "math_2022": "90.4",
    "math_2023": "88.8",
    "math_2024": "92.8",
    "math_trend": "998855",
    "echec_2018": "1.8",
    "echec_2019": "3.0",
    "echec_2022": "6.8",
    "echec_2023": "2.9",
    "echec_2024": "1.5",
    "echec_trend": "—",
    "sures_2018": "0.7",
    "sures_2019": "1.5",
    "sures_2022": "2.4",
    "sures_2023": "1.9",
    "sures_2024": "0.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 3.8",
    "ecart_sexes_lens_2019": "F 0.4",
    "ecart_sexes_lens_2022": "F 2.3",
    "ecart_sexes_lens_2023": "F 6.3",
    "ecart_sexes_lens_2024": "M 1.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.0",
    "ecart_sexes_math_2019": "F 2.9",
    "ecart_sexes_math_2022": "F 1.0",
    "ecart_sexes_math_2023": "M 9.7",
    "ecart_sexes_math_2024": "F 4.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.0",
    "prog_2019": "0.0",
    "prog_2022": "4.9",
    "prog_2023": "3.0",
    "prog_2024": "2.2",
    "prog_trend": "—",
    "cote_2018": "8.6",
    "cote_2019": "8.2",
    "cote_2022": "7.8",
    "cote_2023": "7.4",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Les Écoles juives populaires et les Écoles Peretz inc., section anglaise",
    "nom_court": "Écoles juives et Peretz, sect. anglaise",
    "adresse": "6500, chemin Kildare",
    "municipalite": "Côte-Saint-Luc",
    "code_postal": "H4W 3B8",
    "lat": 45.47907,
    "lng": -73.65763
  },
  {
    "_id": "442",
    "school_code": "407501",
    "school_name_1": "Marie-Reine-du-Clergé",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "318",
    "langue": "français",
    "secteur": "privé",
    "rang": "390",
    "rang_5_ans": "362",
    "index": "0.1",
    "en_retard_2024": "12.8",
    "ehdaa_2024": "24.5",
    "rang_2024": "390/470",
    "rang_2019_2024": "362/432",
    "lens_2018": "69.6",
    "lens_2019": "69.7",
    "lens_2022": "58.8",
    "lens_2023": "64.7",
    "lens_2024": "63.9",
    "lens_trend": "—",
    "lsec_2018": "76.8",
    "lsec_2019": "78.8",
    "lsec_2022": "72.3",
    "lsec_2023": "73.3",
    "lsec_2024": "73.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "75.5",
    "scie_2019": "68.7",
    "scie_2022": "66.5",
    "scie_2023": "72.6",
    "scie_2024": "69.8",
    "scie_trend": "—",
    "math_2018": "68.4",
    "math_2019": "73.7",
    "math_2022": "63.3",
    "math_2023": "65.9",
    "math_2024": "73.2",
    "math_trend": "—",
    "echec_2018": "16.4",
    "echec_2019": "17.6",
    "echec_2022": "35.1",
    "echec_2023": "28.5",
    "echec_2024": "20.4",
    "echec_trend": "—",
    "sures_2018": "1.5",
    "sures_2019": "2.8",
    "sures_2022": "9.1",
    "sures_2023": "5.5",
    "sures_2024": "4.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.1",
    "ecart_sexes_lens_2019": "F 6.0",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 7.2",
    "ecart_sexes_lens_2024": "F 1.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 1.4",
    "ecart_sexes_math_2019": "M 4.9",
    "ecart_sexes_math_2022": "M 11.2",
    "ecart_sexes_math_2023": "M 5.8",
    "ecart_sexes_math_2024": "M 14.6",
    "ecart_sexes_math_trend": "998855",
    "prog_2018": "18.5",
    "prog_2019": "10.7",
    "prog_2022": "3.9",
    "prog_2023": "26.9",
    "prog_2024": "21.4",
    "prog_trend": "—",
    "cote_2018": "5.8",
    "cote_2019": "5.7",
    "cote_2022": "3.7",
    "cote_2023": "3.6",
    "cote_2024": "4.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Séminaire Marie-Reine-du-Clergé",
    "nom_court": "Séminaire Marie-Reine-du-Clergé",
    "adresse": "1569, route 169",
    "municipalite": "Métabetchouan–Lac-à-la-Croix",
    "code_postal": "G8G 1A8",
    "lat": 48.43892,
    "lng": -71.84267
  },
  {
    "_id": "443",
    "school_code": "410501",
    "school_name_1": "Loyola",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "724",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "32",
    "index": "0.1",
    "en_retard_2024": "1.4",
    "ehdaa_2024": "14.2",
    "rang_2024": "53/470",
    "rang_2019_2024": "32/432",
    "lens_2018": "78.1",
    "lens_2019": "76.5",
    "lens_2022": "80.6",
    "lens_2023": "80.9",
    "lens_2024": "80.1",
    "lens_trend": "—",
    "lsec_2018": "76.0",
    "lsec_2019": "77.2",
    "lsec_2022": "80.8",
    "lsec_2023": "78.3",
    "lsec_2024": "75.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.7",
    "scie_2019": "79.1",
    "scie_2022": "83.8",
    "scie_2023": "83.0",
    "scie_2024": "79.1",
    "scie_trend": "—",
    "math_2018": "88.8",
    "math_2019": "91.1",
    "math_2022": "91.3",
    "math_2023": "94.7",
    "math_2024": "92.5",
    "math_trend": "—",
    "echec_2018": "5.3",
    "echec_2019": "4.2",
    "echec_2022": "2.9",
    "echec_2023": "4.7",
    "echec_2024": "8.3",
    "echec_trend": "998855",
    "sures_2018": "1.0",
    "sures_2019": "0.9",
    "sures_2022": "0.9",
    "sures_2023": "1.9",
    "sures_2024": "3.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "0.7",
    "prog_2019": "0.7",
    "prog_2022": "3.5",
    "prog_2023": "0.0",
    "prog_2024": "1.4",
    "prog_trend": "—",
    "cote_2018": "8.9",
    "cote_2019": "8.3",
    "cote_2022": "9.1",
    "cote_2023": "8.6",
    "cote_2024": "8.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "École secondaire Loyola",
    "nom_court": "École secondaire Loyola",
    "adresse": "7272, rue Sherbrooke Ouest",
    "municipalite": "Montréal",
    "code_postal": "H4B 1R2",
    "lat": 45.45668,
    "lng": -73.63895
  },
  {
    "_id": "444",
    "school_code": "434501",
    "school_name_1": "Saint-Nom-de-Marie",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1321",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "5",
    "index": "0.1",
    "en_retard_2024": "3",
    "ehdaa_2024": "14.5",
    "rang_2024": "1/470",
    "rang_2019_2024": "5/432",
    "lens_2018": "79.6",
    "lens_2019": "80.8",
    "lens_2022": "80.6",
    "lens_2023": "79.6",
    "lens_2024": "78.7",
    "lens_trend": "—",
    "lsec_2018": "84.5",
    "lsec_2019": "86.9",
    "lsec_2022": "84.6",
    "lsec_2023": "83.7",
    "lsec_2024": "86.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.0",
    "scie_2019": "86.3",
    "scie_2022": "87.1",
    "scie_2023": "90.3",
    "scie_2024": "88.2",
    "scie_trend": "—",
    "math_2018": "85.7",
    "math_2019": "87.3",
    "math_2022": "90.3",
    "math_2023": "89.7",
    "math_2024": "92.3",
    "math_trend": "—",
    "echec_2018": "2.0",
    "echec_2019": "1.5",
    "echec_2022": "2.2",
    "echec_2023": "2.5",
    "echec_2024": "2.3",
    "echec_trend": "—",
    "sures_2018": "0.1",
    "sures_2019": "0.0",
    "sures_2022": "0.8",
    "sures_2023": "1.7",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "2.8",
    "prog_2019": "0.4",
    "prog_2022": "2.2",
    "prog_2023": "1.8",
    "prog_2024": "0.4",
    "prog_trend": "—",
    "cote_2018": "9.6",
    "cote_2019": "10.0",
    "cote_2022": "10.0",
    "cote_2023": "9.3",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Pensionnat du Saint-Nom-de-Marie ",
    "nom_court": "Pens. du St-Nom-de-Marie",
    "adresse": "628, chemin de la Côte-Sainte-Catherine",
    "municipalite": "Montréal",
    "code_postal": "H2V 2C5",
    "lat": 45.51211,
    "lng": -73.61317
  },
  {
    "_id": "445",
    "school_code": "444501",
    "school_name_1": "Chicoutimi",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Saguenay--Lac-Saint-Jean ",
    "étudiants": "552",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "83",
    "index": "0.1",
    "en_retard_2024": "6.3",
    "ehdaa_2024": "14.9",
    "rang_2024": "40/470",
    "rang_2019_2024": "83/432",
    "lens_2018": "77.8",
    "lens_2019": "79.8",
    "lens_2022": "77.8",
    "lens_2023": "77.9",
    "lens_2024": "80.8",
    "lens_trend": "—",
    "lsec_2018": "80.5",
    "lsec_2019": "78.5",
    "lsec_2022": "78.2",
    "lsec_2023": "79.7",
    "lsec_2024": "79.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.5",
    "scie_2019": "75.1",
    "scie_2022": "73.3",
    "scie_2023": "82.0",
    "scie_2024": "80.4",
    "scie_trend": "—",
    "math_2018": "72.9",
    "math_2019": "65.4",
    "math_2022": "72.8",
    "math_2023": "82.2",
    "math_2024": "78.3",
    "math_trend": "—",
    "echec_2018": "6.7",
    "echec_2019": "11.7",
    "echec_2022": "12.7",
    "echec_2023": "5.3",
    "echec_2024": "5.6",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "2.3",
    "sures_2022": "2.6",
    "sures_2023": "0.6",
    "sures_2024": "0.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 8.2",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 8.3",
    "ecart_sexes_lens_2023": "F 2.4",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 0.8",
    "ecart_sexes_math_2019": "F 10.6",
    "ecart_sexes_math_2022": "F 0.4",
    "ecart_sexes_math_2023": "M 0.7",
    "ecart_sexes_math_2024": "M 4.5",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "6.4",
    "prog_2019": "5.3",
    "prog_2022": "5.1",
    "prog_2023": "8.7",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "7.5",
    "cote_2019": "6.7",
    "cote_2022": "7.2",
    "cote_2023": "8.1",
    "cote_2024": "8.5",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Séminaire de Chicoutimi - services éducatifs",
    "nom_court": "Séminaire de Chicoutimi",
    "adresse": "679, rue Chabanel",
    "municipalite": "Saguenay",
    "code_postal": "G7H 1Z7",
    "lat": 48.41814,
    "lng": -71.03712
  },
  {
    "_id": "446",
    "school_code": "445501",
    "school_name_1": "Collège Trinité",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montérégie ",
    "étudiants": "844",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "64",
    "index": "0.1",
    "en_retard_2024": "2.3",
    "ehdaa_2024": "31.6",
    "rang_2024": "69/470",
    "rang_2019_2024": "64/432",
    "lens_2018": "73.1",
    "lens_2019": "72.0",
    "lens_2022": "71.5",
    "lens_2023": "71.9",
    "lens_2024": "70.7",
    "lens_trend": "—",
    "lsec_2018": "76.1",
    "lsec_2019": "74.5",
    "lsec_2022": "80.9",
    "lsec_2023": "82.3",
    "lsec_2024": "79.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.6",
    "scie_2019": "81.8",
    "scie_2022": "80.6",
    "scie_2023": "86.5",
    "scie_2024": "80.0",
    "scie_trend": "—",
    "math_2018": "81.1",
    "math_2019": "86.0",
    "math_2022": "84.2",
    "math_2023": "85.6",
    "math_2024": "83.0",
    "math_trend": "—",
    "echec_2018": "6.7",
    "echec_2019": "8.9",
    "echec_2022": "9.1",
    "echec_2023": "6.5",
    "echec_2024": "9.2",
    "echec_trend": "—",
    "sures_2018": "1.0",
    "sures_2019": "1.8",
    "sures_2022": "2.3",
    "sures_2023": "2.5",
    "sures_2024": "2.2",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.4",
    "ecart_sexes_lens_2019": "F 3.1",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 5.1",
    "ecart_sexes_lens_2024": "F 2.7",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 2.6",
    "ecart_sexes_math_2019": "F 3.1",
    "ecart_sexes_math_2022": "F 1.3",
    "ecart_sexes_math_2023": "F 2.0",
    "ecart_sexes_math_2024": "F 0.1",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.5",
    "prog_2019": "2.2",
    "prog_2022": "3.0",
    "prog_2023": "0.6",
    "prog_2024": "1.7",
    "prog_trend": "—",
    "cote_2018": "7.7",
    "cote_2019": "7.4",
    "cote_2022": "8.2",
    "cote_2023": "8.2",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Trinité",
    "nom_court": "Collège Trinité",
    "adresse": "1475, chemin des Vingt",
    "municipalite": "Saint-Bruno-de-Montarville",
    "code_postal": "J3V 4P6",
    "lat": 45.5356,
    "lng": -73.30232
  },
  {
    "_id": "447",
    "school_code": "446501",
    "school_name_1": "Sherbrooke",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "1373",
    "langue": "français",
    "secteur": "privé",
    "rang": "80",
    "rang_5_ans": "55",
    "index": "0.1",
    "en_retard_2024": "4",
    "ehdaa_2024": "15.1",
    "rang_2024": "80/470",
    "rang_2019_2024": "55/432",
    "lens_2018": "76.4",
    "lens_2019": "74.9",
    "lens_2022": "70.8",
    "lens_2023": "73.0",
    "lens_2024": "70.1",
    "lens_trend": "998855",
    "lsec_2018": "82.0",
    "lsec_2019": "82.0",
    "lsec_2022": "83.4",
    "lsec_2023": "85.2",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.3",
    "scie_2019": "79.5",
    "scie_2022": "79.8",
    "scie_2023": "84.7",
    "scie_2024": "82.6",
    "scie_trend": "—",
    "math_2018": "81.3",
    "math_2019": "85.2",
    "math_2022": "80.2",
    "math_2023": "79.9",
    "math_2024": "81.3",
    "math_trend": "—",
    "echec_2018": "3.3",
    "echec_2019": "3.3",
    "echec_2022": "9.3",
    "echec_2023": "6.1",
    "echec_2024": "9.0",
    "echec_trend": "998855",
    "sures_2018": "1.1",
    "sures_2019": "1.0",
    "sures_2022": "2.0",
    "sures_2023": "0.9",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.3",
    "ecart_sexes_lens_2019": "F 7.2",
    "ecart_sexes_lens_2022": "F 6.5",
    "ecart_sexes_lens_2023": "F 4.4",
    "ecart_sexes_lens_2024": "F 1.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.8",
    "ecart_sexes_math_2019": "M 3.2",
    "ecart_sexes_math_2022": "F 0.9",
    "ecart_sexes_math_2023": "M 2.5",
    "ecart_sexes_math_2024": "F 0.8",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "0.6",
    "prog_2019": "1.9",
    "prog_2022": "1.0",
    "prog_2023": "6.1",
    "prog_2024": "4.8",
    "prog_trend": "—",
    "cote_2018": "8.3",
    "cote_2019": "8.3",
    "cote_2022": "8.1",
    "cote_2023": "8.1",
    "cote_2024": "7.8",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Séminaire de Sherbrooke ",
    "nom_court": "Sém. de Sherbrooke",
    "adresse": "195, rue Marquette",
    "municipalite": "Sherbrooke",
    "code_postal": "J1H 1L6",
    "lat": 45.40301,
    "lng": -71.89452
  },
  {
    "_id": "448",
    "school_code": "447501",
    "school_name_1": "des Pères Maristes",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "720",
    "langue": "français",
    "secteur": "privé",
    "rang": "59",
    "rang_5_ans": "47",
    "index": "0.1",
    "en_retard_2024": "4.9",
    "ehdaa_2024": "25.3",
    "rang_2024": "59/470",
    "rang_2019_2024": "47/432",
    "lens_2018": "72.3",
    "lens_2019": "77.5",
    "lens_2022": "75.6",
    "lens_2023": "77.0",
    "lens_2024": "74.6",
    "lens_trend": "—",
    "lsec_2018": "81.0",
    "lsec_2019": "79.8",
    "lsec_2022": "81.1",
    "lsec_2023": "77.9",
    "lsec_2024": "80.9",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.7",
    "scie_2019": "80.7",
    "scie_2022": "78.7",
    "scie_2023": "86.5",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "82.6",
    "math_2019": "83.2",
    "math_2022": "84.9",
    "math_2023": "86.9",
    "math_2024": "87.9",
    "math_trend": "—",
    "echec_2018": "5.6",
    "echec_2019": "3.9",
    "echec_2022": "5.7",
    "echec_2023": "4.3",
    "echec_2024": "5.5",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "0.4",
    "sures_2022": "2.5",
    "sures_2023": "0.9",
    "sures_2024": "2.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.6",
    "ecart_sexes_lens_2019": "F 1.0",
    "ecart_sexes_lens_2022": "F 6.5",
    "ecart_sexes_lens_2023": "F 4.8",
    "ecart_sexes_lens_2024": "F 5.3",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.3",
    "ecart_sexes_math_2019": "F 1.6",
    "ecart_sexes_math_2022": "F 3.1",
    "ecart_sexes_math_2023": "M 0.1",
    "ecart_sexes_math_2024": "F 2.9",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "5.2",
    "prog_2019": "3.6",
    "prog_2022": "7.2",
    "prog_2023": "3.0",
    "prog_2024": "2.3",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "8.5",
    "cote_2022": "8.1",
    "cote_2023": "8.2",
    "cote_2024": "8.2",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège mariste de Québec",
    "nom_court": "Collège mariste de Québec",
    "adresse": "2315, chemin Saint-Louis",
    "municipalite": "Québec",
    "code_postal": "G1T 1R5",
    "lat": 46.77,
    "lng": -71.26022
  },
  {
    "_id": "449",
    "school_code": "448501",
    "school_name_1": "Sacré-Coeur",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laurentides ",
    "étudiants": "418",
    "langue": "français",
    "secteur": "privé",
    "rang": "277",
    "rang_5_ans": "164",
    "index": "0.1",
    "en_retard_2024": "1.8",
    "ehdaa_2024": "23",
    "rang_2024": "277/470",
    "rang_2019_2024": "164/432",
    "lens_2018": "73.8",
    "lens_2019": "74.6",
    "lens_2022": "68.2",
    "lens_2023": "67.4",
    "lens_2024": "65.9",
    "lens_trend": "998855",
    "lsec_2018": "75.7",
    "lsec_2019": "78.6",
    "lsec_2022": "80.5",
    "lsec_2023": "82.4",
    "lsec_2024": "82.0",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.3",
    "scie_2019": "76.4",
    "scie_2022": "70.1",
    "scie_2023": "75.3",
    "scie_2024": "67.8",
    "scie_trend": "998855",
    "math_2018": "69.6",
    "math_2019": "71.6",
    "math_2022": "68.5",
    "math_2023": "70.4",
    "math_2024": "71.1",
    "math_trend": "998855",
    "echec_2018": "11.8",
    "echec_2019": "8.9",
    "echec_2022": "14.9",
    "echec_2023": "16.7",
    "echec_2024": "18.6",
    "echec_trend": "—",
    "sures_2018": "2.7",
    "sures_2019": "1.8",
    "sures_2022": "3.3",
    "sures_2023": "2.6",
    "sures_2024": "6.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "M 0.9",
    "ecart_sexes_lens_2019": "F 3.2",
    "ecart_sexes_lens_2022": "F 7.7",
    "ecart_sexes_lens_2023": "F 7.3",
    "ecart_sexes_lens_2024": "F 2.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "M 2.3",
    "ecart_sexes_math_2019": "F 4.3",
    "ecart_sexes_math_2022": "M 0.2",
    "ecart_sexes_math_2023": "M 6.3",
    "ecart_sexes_math_2024": "M 1.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "7.7",
    "prog_2019": "0.0",
    "prog_2022": "5.9",
    "prog_2023": "13.5",
    "prog_2024": "8.0",
    "prog_trend": "—",
    "cote_2018": "6.6",
    "cote_2019": "7.1",
    "cote_2022": "6.5",
    "cote_2023": "5.7",
    "cote_2024": "5.5",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Séminaire du Sacré Coeur",
    "nom_court": "Séminaire du Sacré Coeur",
    "adresse": "2738, route 148",
    "municipalite": "Grenville-sur-la-Rouge",
    "code_postal": "J0V 1B0",
    "lat": 45.64639,
    "lng": -74.74994
  },
  {
    "_id": "450",
    "school_code": "449501",
    "school_name_1": "des Hauts Sommets",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "103",
    "langue": "français",
    "secteur": "privé",
    "rang": "459",
    "rang_5_ans": "430",
    "index": "0.1",
    "en_retard_2024": "30",
    "ehdaa_2024": "93.2",
    "rang_2024": "459/470",
    "rang_2019_2024": "430/432",
    "lens_2018": "60.3",
    "lens_2019": "58.9",
    "lens_2022": "58.5",
    "lens_2023": "60.3",
    "lens_2024": "59.9",
    "lens_trend": "—",
    "lsec_2018": "76.8",
    "lsec_2019": "77.3",
    "lsec_2022": "74.6",
    "lsec_2023": "76.6",
    "lsec_2024": "81.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "62.7",
    "scie_2019": "53.2",
    "scie_2022": "63.3",
    "scie_2023": "65.3",
    "scie_2024": "55.7",
    "scie_trend": "—",
    "math_2018": "65.7",
    "math_2019": "55.6",
    "math_2022": "54.0",
    "math_2023": "50.7",
    "math_2024": "63.9",
    "math_trend": "—",
    "echec_2018": "36.1",
    "echec_2019": "41.8",
    "echec_2022": "34.3",
    "echec_2023": "28.2",
    "echec_2024": "35.5",
    "echec_trend": "—",
    "sures_2018": "3.6",
    "sures_2019": "10.4",
    "sures_2022": "8.3",
    "sures_2023": "8.7",
    "sures_2024": "8.3",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "M 1.8",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 4.3",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "46.6",
    "prog_2019": "35.4",
    "prog_2022": "29.5",
    "prog_2023": "39.7",
    "prog_2024": "36.4",
    "prog_trend": "—",
    "cote_2018": "1.8",
    "cote_2019": "0.0",
    "cote_2022": "2.4",
    "cote_2023": "1.7",
    "cote_2024": "2.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège des Hauts Sommets",
    "nom_court": "Collège des Hauts Sommets",
    "adresse": "97, avenue de la Montagne",
    "municipalite": "Saint-Tite-des-Caps",
    "code_postal": "G0A 4J0",
    "lat": 47.10998,
    "lng": -70.79567
  },
  {
    "_id": "451",
    "school_code": "454501",
    "school_name_1": "Saint-François",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "1311",
    "langue": "français",
    "secteur": "privé",
    "rang": "91",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "4",
    "ehdaa_2024": "21.5",
    "rang_2024": "91/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "76.5",
    "lens_2019": "73.8",
    "lens_2022": "68.4",
    "lens_2023": "70.7",
    "lens_2024": "70.3",
    "lens_trend": "—",
    "lsec_2018": "82.3",
    "lsec_2019": "82.5",
    "lsec_2022": "81.9",
    "lsec_2023": "85.0",
    "lsec_2024": "82.8",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.0",
    "scie_2019": "78.5",
    "scie_2022": "75.0",
    "scie_2023": "84.9",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "82.2",
    "math_2019": "82.1",
    "math_2022": "85.7",
    "math_2023": "83.0",
    "math_2024": "81.3",
    "math_trend": "998855",
    "echec_2018": "4.6",
    "echec_2019": "5.7",
    "echec_2022": "10.9",
    "echec_2023": "6.0",
    "echec_2024": "7.7",
    "echec_trend": "—",
    "sures_2018": "0.6",
    "sures_2019": "1.8",
    "sures_2022": "5.4",
    "sures_2023": "1.9",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 9.0",
    "ecart_sexes_lens_2019": "F 4.8",
    "ecart_sexes_lens_2022": "F 7.5",
    "ecart_sexes_lens_2023": "F 5.8",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.3",
    "ecart_sexes_math_2019": "F 3.3",
    "ecart_sexes_math_2022": "F 0.6",
    "ecart_sexes_math_2023": "F 0.8",
    "ecart_sexes_math_2024": "F 5.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.2",
    "prog_2019": "3.8",
    "prog_2022": "3.6",
    "prog_2023": "5.5",
    "prog_2024": "2.4",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "8.0",
    "cote_2022": "7.4",
    "cote_2023": "8.0",
    "cote_2024": "7.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Séminaire Saint-François",
    "nom_court": "Séminaire Saint-François",
    "adresse": "4900, rue Saint-Félix",
    "municipalite": "Saint-Augustin-de-Desmaures",
    "code_postal": "G3A 0L4",
    "lat": 46.73635,
    "lng": -71.3916
  },
  {
    "_id": "452",
    "school_code": "455501",
    "school_name_1": "Saint-Joseph",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Mauricie ",
    "étudiants": "795",
    "langue": "français",
    "secteur": "privé",
    "rang": "169",
    "rang_5_ans": "147",
    "index": "0.1",
    "en_retard_2024": "4.9",
    "ehdaa_2024": "24.4",
    "rang_2024": "169/470",
    "rang_2019_2024": "147/432",
    "lens_2018": "74.8",
    "lens_2019": "75.2",
    "lens_2022": "69.4",
    "lens_2023": "72.5",
    "lens_2024": "70.3",
    "lens_trend": "—",
    "lsec_2018": "77.8",
    "lsec_2019": "80.5",
    "lsec_2022": "78.2",
    "lsec_2023": "79.2",
    "lsec_2024": "80.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.3",
    "scie_2019": "72.0",
    "scie_2022": "69.8",
    "scie_2023": "73.3",
    "scie_2024": "69.6",
    "scie_trend": "998855",
    "math_2018": "73.9",
    "math_2019": "71.8",
    "math_2022": "73.3",
    "math_2023": "71.4",
    "math_2024": "76.2",
    "math_trend": "—",
    "echec_2018": "9.4",
    "echec_2019": "11.2",
    "echec_2022": "16.6",
    "echec_2023": "15.8",
    "echec_2024": "15.8",
    "echec_trend": "998855",
    "sures_2018": "1.5",
    "sures_2019": "0.5",
    "sures_2022": "2.1",
    "sures_2023": "1.7",
    "sures_2024": "2.6",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 2.6",
    "ecart_sexes_lens_2019": "F 6.7",
    "ecart_sexes_lens_2022": "F 8.6",
    "ecart_sexes_lens_2023": "F 5.2",
    "ecart_sexes_lens_2024": "F 0.9",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 8.3",
    "ecart_sexes_math_2019": "F 6.5",
    "ecart_sexes_math_2022": "F 7.7",
    "ecart_sexes_math_2023": "F 5.8",
    "ecart_sexes_math_2024": "F 3.0",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.6",
    "prog_2019": "6.3",
    "prog_2022": "5.1",
    "prog_2023": "15.5",
    "prog_2024": "13.2",
    "prog_trend": "998855",
    "cote_2018": "7.0",
    "cote_2019": "6.7",
    "cote_2022": "6.4",
    "cote_2023": "6.0",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Séminaire Saint-Joseph de Trois-Rivières",
    "nom_court": "Sém. Saint-Joseph Trois-Riv.",
    "adresse": "858, rue Laviolette",
    "municipalite": "Trois-Rivières",
    "code_postal": "G9A 5S3",
    "lat": 46.34907,
    "lng": -72.54477
  },
  {
    "_id": "453",
    "school_code": "456501",
    "school_name_1": "Sainte-Marie",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Mauricie ",
    "étudiants": "361",
    "langue": "français",
    "secteur": "privé",
    "rang": "137",
    "rang_5_ans": "125",
    "index": "0.1",
    "en_retard_2024": "12.7",
    "ehdaa_2024": "nd",
    "rang_2024": "137/470",
    "rang_2019_2024": "125/432",
    "lens_2018": "71.2",
    "lens_2019": "69.7",
    "lens_2022": "60.9",
    "lens_2023": "68.6",
    "lens_2024": "67.0",
    "lens_trend": "—",
    "lsec_2018": "85.8",
    "lsec_2019": "84.2",
    "lsec_2022": "79.5",
    "lsec_2023": "78.4",
    "lsec_2024": "82.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.8",
    "scie_2019": "80.5",
    "scie_2022": "74.7",
    "scie_2023": "83.5",
    "scie_2024": "76.2",
    "scie_trend": "—",
    "math_2018": "79.5",
    "math_2019": "77.2",
    "math_2022": "71.6",
    "math_2023": "76.9",
    "math_2024": "79.9",
    "math_trend": "—",
    "echec_2018": "9.3",
    "echec_2019": "8.6",
    "echec_2022": "24.4",
    "echec_2023": "12.1",
    "echec_2024": "11.8",
    "echec_trend": "—",
    "sures_2018": "1.9",
    "sures_2019": "2.3",
    "sures_2022": "4.5",
    "sures_2023": "3.5",
    "sures_2024": "3.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 5.6",
    "ecart_sexes_lens_2022": "F 3.7",
    "ecart_sexes_lens_2023": "F 7.1",
    "ecart_sexes_lens_2024": "F 4.4",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 8.4",
    "ecart_sexes_math_2022": "F 14.0",
    "ecart_sexes_math_2023": "M 2.7",
    "ecart_sexes_math_2024": "M 4.6",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "6.4",
    "prog_2019": "0.0",
    "prog_2022": "13.4",
    "prog_2023": "16.3",
    "prog_2024": "14.9",
    "prog_trend": "—",
    "cote_2018": "7.9",
    "cote_2019": "7.4",
    "cote_2022": "5.4",
    "cote_2023": "6.5",
    "cote_2024": "6.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Le Séminaire Sainte-Marie",
    "nom_court": "Le Séminaire Sainte-Marie",
    "adresse": "5655, boulevard des Hêtres",
    "municipalite": "Shawinigan",
    "code_postal": "G9N 4V9",
    "lat": 46.57501,
    "lng": -72.72882
  },
  {
    "_id": "454",
    "school_code": "457501",
    "school_name_1": "Salésien",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "940",
    "langue": "français",
    "secteur": "privé",
    "rang": "112",
    "rang_5_ans": "111",
    "index": "0.1",
    "en_retard_2024": "3.7",
    "ehdaa_2024": "20.3",
    "rang_2024": "112/470",
    "rang_2019_2024": "111/432",
    "lens_2018": "73.5",
    "lens_2019": "69.8",
    "lens_2022": "68.4",
    "lens_2023": "73.9",
    "lens_2024": "72.7",
    "lens_trend": "—",
    "lsec_2018": "80.8",
    "lsec_2019": "77.4",
    "lsec_2022": "78.6",
    "lsec_2023": "80.1",
    "lsec_2024": "79.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "77.6",
    "scie_2019": "74.8",
    "scie_2022": "74.2",
    "scie_2023": "79.4",
    "scie_2024": "76.5",
    "scie_trend": "112233",
    "math_2018": "77.8",
    "math_2019": "81.4",
    "math_2022": "75.6",
    "math_2023": "78.7",
    "math_2024": "77.3",
    "math_trend": "—",
    "echec_2018": "6.5",
    "echec_2019": "11.1",
    "echec_2022": "16.2",
    "echec_2023": "6.8",
    "echec_2024": "8.3",
    "echec_trend": "—",
    "sures_2018": "0.2",
    "sures_2019": "2.7",
    "sures_2022": "4.5",
    "sures_2023": "1.1",
    "sures_2024": "2.7",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 4.0",
    "ecart_sexes_lens_2019": "F 0.5",
    "ecart_sexes_lens_2022": "F 5.1",
    "ecart_sexes_lens_2023": "F 3.8",
    "ecart_sexes_lens_2024": "F 5.6",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 5.3",
    "ecart_sexes_math_2019": "F 2.3",
    "ecart_sexes_math_2022": "F 7.2",
    "ecart_sexes_math_2023": "F 0.3",
    "ecart_sexes_math_2024": "F 0.7",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "2.2",
    "prog_2019": "0.7",
    "prog_2022": "4.3",
    "prog_2023": "8.0",
    "prog_2024": "4.9",
    "prog_trend": "—",
    "cote_2018": "7.7",
    "cote_2019": "6.9",
    "cote_2022": "6.4",
    "cote_2023": "7.6",
    "cote_2024": "7.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Le Salésien",
    "nom_court": "Le Salésien",
    "adresse": "135, rue Don Bosco Nord",
    "municipalite": "Sherbrooke",
    "code_postal": "J1L 1E5",
    "lat": 45.39789,
    "lng": -71.95199
  },
  {
    "_id": "455",
    "school_code": "464501",
    "school_name_1": "Herzliah High School",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "244",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "80",
    "rang_5_ans": "59",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "36.5",
    "rang_2024": "80/470",
    "rang_2019_2024": "59/432",
    "lens_2018": "82.4",
    "lens_2019": "78.6",
    "lens_2022": "80.4",
    "lens_2023": "81.7",
    "lens_2024": "80.1",
    "lens_trend": "—",
    "lsec_2018": "81.4",
    "lsec_2019": "75.8",
    "lsec_2022": "74.2",
    "lsec_2023": "80.6",
    "lsec_2024": "79.4",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "83.0",
    "scie_2019": "80.9",
    "scie_2022": "78.1",
    "scie_2023": "84.8",
    "scie_2024": "79.5",
    "scie_trend": "—",
    "math_2018": "87.3",
    "math_2019": "79.8",
    "math_2022": "81.9",
    "math_2023": "85.0",
    "math_2024": "87.1",
    "math_trend": "—",
    "echec_2018": "1.2",
    "echec_2019": "6.7",
    "echec_2022": "10.4",
    "echec_2023": "5.1",
    "echec_2024": "5.1",
    "echec_trend": "—",
    "sures_2018": "1.3",
    "sures_2019": "2.4",
    "sures_2022": "4.1",
    "sures_2023": "3.1",
    "sures_2024": "4.2",
    "sures_trend": "998855",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "F 6.1",
    "ecart_sexes_lens_2022": "F 3.1",
    "ecart_sexes_lens_2023": "F 4.3",
    "ecart_sexes_lens_2024": "F 5.2",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 0.3",
    "ecart_sexes_math_2022": "F 2.6",
    "ecart_sexes_math_2023": "F 5.1",
    "ecart_sexes_math_2024": "F 4.9",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "1.8",
    "prog_2019": "0.0",
    "prog_2022": "5.1",
    "prog_2023": "0.0",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "9.0",
    "cote_2019": "7.7",
    "cote_2022": "7.8",
    "cote_2023": "7.9",
    "cote_2024": "7.8",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Les écoles Azrieli Talmud Torah - Herzliah, Campus Adams, section anglaise",
    "nom_court": "Talmud Torah-Herzliah, C. Adams, s. a.",
    "adresse": "5475, avenue Mountain Sights",
    "municipalite": "Montréal",
    "code_postal": "H3W 2Y8",
    "lat": 45.48775,
    "lng": -73.63409
  },
  {
    "_id": "456",
    "school_code": "464503",
    "school_name_1": "école secondaire Herzliah",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "207",
    "langue": "français",
    "secteur": "privé",
    "rang": "69",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "25.6",
    "rang_2024": "69/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "71.6",
    "lens_2019": "70.9",
    "lens_2022": "66.7",
    "lens_2023": "67.8",
    "lens_2024": "67.6",
    "lens_trend": "—",
    "lsec_2018": "83.5",
    "lsec_2019": "80.3",
    "lsec_2022": "81.4",
    "lsec_2023": "86.7",
    "lsec_2024": "88.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "85.0",
    "scie_2019": "79.8",
    "scie_2022": "75.2",
    "scie_2023": "80.1",
    "scie_2024": "80.0",
    "scie_trend": "—",
    "math_2018": "82.7",
    "math_2019": "82.1",
    "math_2022": "81.8",
    "math_2023": "82.6",
    "math_2024": "81.0",
    "math_trend": "998855",
    "echec_2018": "4.1",
    "echec_2019": "6.2",
    "echec_2022": "12.9",
    "echec_2023": "7.8",
    "echec_2024": "8.1",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "2.6",
    "sures_2022": "7.2",
    "sures_2023": "3.6",
    "sures_2024": "4.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "M 2.0",
    "ecart_sexes_lens_2022": "F 1.3",
    "ecart_sexes_lens_2023": "F 0.7",
    "ecart_sexes_lens_2024": "F 3.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "M 6.7",
    "ecart_sexes_math_2022": "M 1.2",
    "ecart_sexes_math_2023": "M 7.4",
    "ecart_sexes_math_2024": "M 1.1",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "4.3",
    "prog_2019": "4.3",
    "prog_2022": "2.2",
    "prog_2023": "8.9",
    "prog_2024": "6.7",
    "prog_trend": "—",
    "cote_2018": "8.4",
    "cote_2019": "7.5",
    "cote_2022": "7.3",
    "cote_2023": "7.4",
    "cote_2024": "7.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Les écoles Azrieli Talmud Torah - Herzliah, Campus Adams, section française",
    "nom_court": "Talmud Torah-Herzliah, C. Adams, s. f.",
    "adresse": "5475, avenue Mountain Sights",
    "municipalite": "Montréal",
    "code_postal": "H3W 2Y8",
    "lat": 45.48775,
    "lng": -73.63409
  },
  {
    "_id": "457",
    "school_code": "466502",
    "school_name_1": "The Study",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "189",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "15",
    "rang_5_ans": "18",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "nd",
    "rang_2024": "15/470",
    "rang_2019_2024": "18/432",
    "lens_2018": "81.7",
    "lens_2019": "81.9",
    "lens_2022": "80.8",
    "lens_2023": "84.0",
    "lens_2024": "85.0",
    "lens_trend": "—",
    "lsec_2018": "85.6",
    "lsec_2019": "87.9",
    "lsec_2022": "85.8",
    "lsec_2023": "88.5",
    "lsec_2024": "83.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "88.4",
    "scie_2019": "87.0",
    "scie_2022": "94.0",
    "scie_2023": "89.9",
    "scie_2024": "91.3",
    "scie_trend": "—",
    "math_2018": "93.3",
    "math_2019": "94.7",
    "math_2022": "96.7",
    "math_2023": "94.6",
    "math_2024": "96.2",
    "math_trend": "998855",
    "echec_2018": "0.5",
    "echec_2019": "0.0",
    "echec_2022": "0.6",
    "echec_2023": "0.0",
    "echec_2024": "0.6",
    "echec_trend": "—",
    "sures_2018": "0.9",
    "sures_2019": "1.0",
    "sures_2022": "2.7",
    "sures_2023": "1.5",
    "sures_2024": "1.0",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "10.3",
    "prog_2019": "6.9",
    "prog_2022": "7.3",
    "prog_2023": "17.1",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "9.3",
    "cote_2019": "9.1",
    "cote_2022": "9.4",
    "cote_2023": "8.7",
    "cote_2024": "9.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "The Study, section secondaire",
    "nom_court": "The Study, section secondaire",
    "adresse": "3233, The Boulevard",
    "municipalite": "Westmount",
    "code_postal": "H3Y 1S4",
    "lat": 45.49085,
    "lng": -73.60073
  },
  {
    "_id": "458",
    "school_code": "467501",
    "school_name_1": "Trafalgar",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "86",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "91",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "5.6",
    "ehdaa_2024": "nd",
    "rang_2024": "91/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "78.0",
    "lens_2019": "76.2",
    "lens_2022": "81.9",
    "lens_2023": "77.5",
    "lens_2024": "82.5",
    "lens_trend": "—",
    "lsec_2018": "79.4",
    "lsec_2019": "78.6",
    "lsec_2022": "79.9",
    "lsec_2023": "78.2",
    "lsec_2024": "81.0",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "79.0",
    "scie_2019": "82.8",
    "scie_2022": "75.4",
    "scie_2023": "83.6",
    "scie_2024": "78.3",
    "scie_trend": "—",
    "math_2018": "83.7",
    "math_2019": "89.8",
    "math_2022": "78.9",
    "math_2023": "82.8",
    "math_2024": "80.5",
    "math_trend": "998855",
    "echec_2018": "1.3",
    "echec_2019": "2.5",
    "echec_2022": "11.9",
    "echec_2023": "6.2",
    "echec_2024": "5.8",
    "echec_trend": "—",
    "sures_2018": "2.0",
    "sures_2019": "1.0",
    "sures_2022": "2.3",
    "sures_2023": "1.3",
    "sures_2024": "2.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "6.5",
    "prog_2019": "0.0",
    "prog_2022": "10.6",
    "prog_2023": "8.0",
    "prog_2024": "18.4",
    "prog_trend": "—",
    "cote_2018": "8.2",
    "cote_2019": "8.0",
    "cote_2022": "7.8",
    "cote_2023": "7.5",
    "cote_2024": "7.6",
    "cote_trend": "998855",
    "valid": true,
    "nom_offcl": "Collège Trafalgar pour filles",
    "nom_court": "Collège Trafalgar pour filles",
    "adresse": "3495, rue Simpson",
    "municipalite": "Montréal",
    "code_postal": "H3G 2J7",
    "lat": 45.49871,
    "lng": -73.5837
  },
  {
    "_id": "459",
    "school_code": "469501",
    "school_name_1": "Villa Maria",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1866",
    "langue": "français, anglais",
    "secteur": "privé",
    "rang": "86",
    "rang_5_ans": "69",
    "index": "0.1",
    "en_retard_2024": "0.3",
    "ehdaa_2024": "12",
    "rang_2024": "86/470",
    "rang_2019_2024": "69/432",
    "lens_2018": "75.4",
    "lens_2019": "76.3",
    "lens_2022": "68.6",
    "lens_2023": "71.9",
    "lens_2024": "72.9",
    "lens_trend": "—",
    "lsec_2018": "83.8",
    "lsec_2019": "80.5",
    "lsec_2022": "78.9",
    "lsec_2023": "78.7",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "81.9",
    "scie_2019": "82.4",
    "scie_2022": "78.2",
    "scie_2023": "85.3",
    "scie_2024": "79.6",
    "scie_trend": "—",
    "math_2018": "82.5",
    "math_2019": "84.7",
    "math_2022": "83.1",
    "math_2023": "85.1",
    "math_2024": "85.0",
    "math_trend": "—",
    "echec_2018": "3.4",
    "echec_2019": "3.3",
    "echec_2022": "12.2",
    "echec_2023": "6.7",
    "echec_2024": "5.5",
    "echec_trend": "—",
    "sures_2018": "1.4",
    "sures_2019": "1.4",
    "sures_2022": "4.2",
    "sures_2023": "2.5",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 2.7",
    "ecart_sexes_lens_2023": "F 2.7",
    "ecart_sexes_lens_2024": "F 5.0",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 1.1",
    "ecart_sexes_math_2023": "M 3.1",
    "ecart_sexes_math_2024": "F 4.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.4",
    "prog_2019": "1.6",
    "prog_2022": "2.4",
    "prog_2023": "7.4",
    "prog_2024": "5.7",
    "prog_trend": "—",
    "cote_2018": "8.4",
    "cote_2019": "8.3",
    "cote_2022": "7.3",
    "cote_2023": "7.3",
    "cote_2024": "7.7",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Villa Maria",
    "nom_court": "Villa Maria",
    "adresse": "4245, boulevard Décarie",
    "municipalite": "Montréal",
    "code_postal": "H4A 3K4",
    "lat": 45.48187,
    "lng": -73.61672
  },
  {
    "_id": "460",
    "school_code": "477501",
    "school_name_1": "Villa Sainte-Marcelline",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "206",
    "langue": "français",
    "secteur": "privé",
    "rang": "29",
    "rang_5_ans": "32",
    "index": "0.1",
    "en_retard_2024": "9.8",
    "ehdaa_2024": "14.1",
    "rang_2024": "29/470",
    "rang_2019_2024": "32/432",
    "lens_2018": "68.2",
    "lens_2019": "75.7",
    "lens_2022": "74.6",
    "lens_2023": "78.6",
    "lens_2024": "75.4",
    "lens_trend": "112233",
    "lsec_2018": "81.1",
    "lsec_2019": "78.9",
    "lsec_2022": "84.8",
    "lsec_2023": "85.9",
    "lsec_2024": "87.1",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "78.2",
    "scie_2019": "80.2",
    "scie_2022": "81.0",
    "scie_2023": "85.1",
    "scie_2024": "77.2",
    "scie_trend": "—",
    "math_2018": "79.1",
    "math_2019": "88.4",
    "math_2022": "89.4",
    "math_2023": "90.2",
    "math_2024": "87.2",
    "math_trend": "—",
    "echec_2018": "8.2",
    "echec_2019": "4.1",
    "echec_2022": "4.6",
    "echec_2023": "2.0",
    "echec_2024": "4.6",
    "echec_trend": "—",
    "sures_2018": "2.6",
    "sures_2019": "0.8",
    "sures_2022": "1.9",
    "sures_2023": "0.4",
    "sures_2024": "3.1",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "2.1",
    "prog_2019": "4.4",
    "prog_2022": "1.9",
    "prog_2023": "4.2",
    "prog_2024": "0.0",
    "prog_trend": "—",
    "cote_2018": "7.1",
    "cote_2019": "8.4",
    "cote_2022": "9.2",
    "cote_2023": "9.3",
    "cote_2024": "8.9",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Villa Sainte-Marcelline",
    "nom_court": "Villa Sainte-Marcelline",
    "adresse": "815, avenue Upper Belmont",
    "municipalite": "Westmount",
    "code_postal": "H3Y 1K5",
    "lat": 45.48962,
    "lng": -73.61745
  },
  {
    "_id": "461",
    "school_code": "478502",
    "school_name_1": "Yéshiva Yavné",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "178",
    "langue": "français",
    "secteur": "privé",
    "rang": "63",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "14.3",
    "ehdaa_2024": "nd",
    "rang_2024": "63/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "71.9",
    "lens_2019": "65.2",
    "lens_2022": "65.7",
    "lens_2023": "71.7",
    "lens_2024": "69.8",
    "lens_trend": "—",
    "lsec_2018": "90.6",
    "lsec_2019": "86.1",
    "lsec_2022": "89.2",
    "lsec_2023": "89.4",
    "lsec_2024": "92.2",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "80.3",
    "scie_2019": "83.7",
    "scie_2022": "82.3",
    "scie_2023": "81.8",
    "scie_2024": "84.2",
    "scie_trend": "—",
    "math_2018": "84.1",
    "math_2019": "82.2",
    "math_2022": "82.8",
    "math_2023": "75.7",
    "math_2024": "87.3",
    "math_trend": "—",
    "echec_2018": "8.6",
    "echec_2019": "9.2",
    "echec_2022": "14.8",
    "echec_2023": "10.7",
    "echec_2024": "10.3",
    "echec_trend": "—",
    "sures_2018": "0.0",
    "sures_2019": "0.8",
    "sures_2022": "5.8",
    "sures_2023": "0.7",
    "sures_2024": "1.8",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "M 5.6",
    "ecart_sexes_lens_2022": "F 7.5",
    "ecart_sexes_lens_2023": "F 16.1",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "F 7.8",
    "ecart_sexes_math_2022": "M 6.9",
    "ecart_sexes_math_2023": "F 1.2",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "27.2",
    "prog_2019": "13.2",
    "prog_2022": "7.4",
    "prog_2023": "5.0",
    "prog_2024": "38.8",
    "prog_trend": "—",
    "cote_2018": "8.0",
    "cote_2019": "7.5",
    "cote_2022": "7.5",
    "cote_2023": "7.5",
    "cote_2024": "8.1",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Yéshiva Yavné",
    "nom_court": "Académie Yéshiva Yavné",
    "adresse": "7946, chemin Wavell",
    "municipalite": "Côte-Saint-Luc",
    "code_postal": "H4W 1L7",
    "lat": 45.46113,
    "lng": -73.66446
  },
  {
    "_id": "462",
    "school_code": "479501",
    "school_name_1": "Yeshiva Gedola Merkaz Hatorah (section anglaise)",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "110",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "120",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "12",
    "ehdaa_2024": "nd",
    "rang_2024": "120/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "80.7",
    "lens_2022": "77.7",
    "lens_2023": "78.5",
    "lens_2024": "78.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "78.6",
    "lsec_2022": "77.4",
    "lsec_2023": "76.5",
    "lsec_2024": "82.2",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "74.4",
    "scie_2022": "57.9",
    "scie_2023": "79.8",
    "scie_2024": "74.2",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "87.0",
    "math_2022": "62.3",
    "math_2023": "80.4",
    "math_2024": "86.7",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "9.6",
    "echec_2022": "21.7",
    "echec_2023": "3.6",
    "echec_2024": "0.0",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "1.4",
    "sures_2022": "7.8",
    "sures_2023": "3.7",
    "sures_2024": "2.1",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "18.8",
    "prog_2022": "7.1",
    "prog_2023": "24.0",
    "prog_2024": "40.0",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "7.4",
    "cote_2022": "6.1",
    "cote_2023": "6.9",
    "cote_2024": "7.0",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "Yeshiva Gedola-Merkaz Hatorah de Montréal, section anglaise",
    "nom_court": "Yeshiva Gedola-Merkaz Hatorah, s. angl.",
    "adresse": "6155, chemin Deacon",
    "municipalite": "Montréal",
    "code_postal": "H3S 2P4",
    "lat": 45.51277,
    "lng": -73.62026
  },
  {
    "_id": "463",
    "school_code": "511501",
    "school_name_1": "Jeunes Musulmans Canadiens",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "247",
    "langue": "français",
    "secteur": "privé",
    "rang": "40",
    "rang_5_ans": "98",
    "index": "0.1",
    "en_retard_2024": "8",
    "ehdaa_2024": "nd",
    "rang_2024": "40/470",
    "rang_2019_2024": "98/432",
    "lens_2018": "68.7",
    "lens_2019": "66.2",
    "lens_2022": "61.9",
    "lens_2023": "67.6",
    "lens_2024": "73.5",
    "lens_trend": "—",
    "lsec_2018": "89.5",
    "lsec_2019": "87.1",
    "lsec_2022": "86.9",
    "lsec_2023": "87.2",
    "lsec_2024": "83.8",
    "lsec_trend": "998855",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "74.9",
    "scie_2019": "76.1",
    "scie_2022": "73.1",
    "scie_2023": "85.3",
    "scie_2024": "83.0",
    "scie_trend": "112233",
    "math_2018": "81.5",
    "math_2019": "85.6",
    "math_2022": "82.2",
    "math_2023": "84.3",
    "math_2024": "88.3",
    "math_trend": "—",
    "echec_2018": "11.7",
    "echec_2019": "8.6",
    "echec_2022": "16.4",
    "echec_2023": "8.6",
    "echec_2024": "4.4",
    "echec_trend": "112233",
    "sures_2018": "8.4",
    "sures_2019": "6.6",
    "sures_2022": "3.6",
    "sures_2023": "1.8",
    "sures_2024": "0.5",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "F 18.3",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "F 5.3",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "F 4.1",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "M 2.2",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "3.4",
    "prog_2019": "11.8",
    "prog_2022": "0.0",
    "prog_2023": "26.3",
    "prog_2024": "23.4",
    "prog_trend": "—",
    "cote_2018": "6.7",
    "cote_2019": "7.1",
    "cote_2022": "6.8",
    "cote_2023": "7.6",
    "cote_2024": "8.5",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École JMC",
    "nom_court": "École JMC",
    "adresse": "2205, rue de l'Église",
    "municipalite": "Montréal",
    "code_postal": "H4M 1G5",
    "lat": 45.50369,
    "lng": -73.6895
  },
  {
    "_id": "464",
    "school_code": "515501",
    "school_name_1": "l'Eau-Vive",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Capitale-Nationale ",
    "étudiants": "181",
    "langue": "français",
    "secteur": "privé",
    "rang": "169",
    "rang_5_ans": "190",
    "index": "0.1",
    "en_retard_2024": "9.4",
    "ehdaa_2024": "28.7",
    "rang_2024": "169/470",
    "rang_2019_2024": "190/432",
    "lens_2018": "73.0",
    "lens_2019": "75.0",
    "lens_2022": "65.3",
    "lens_2023": "68.5",
    "lens_2024": "71.6",
    "lens_trend": "—",
    "lsec_2018": "83.5",
    "lsec_2019": "78.4",
    "lsec_2022": "75.4",
    "lsec_2023": "78.8",
    "lsec_2024": "80.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "71.5",
    "scie_2019": "76.7",
    "scie_2022": "66.9",
    "scie_2023": "74.6",
    "scie_2024": "68.9",
    "scie_trend": "—",
    "math_2018": "74.0",
    "math_2019": "74.8",
    "math_2022": "69.3",
    "math_2023": "73.8",
    "math_2024": "74.2",
    "math_trend": "—",
    "echec_2018": "12.0",
    "echec_2019": "11.6",
    "echec_2022": "21.5",
    "echec_2023": "13.4",
    "echec_2024": "15.4",
    "echec_trend": "—",
    "sures_2018": "2.3",
    "sures_2019": "0.0",
    "sures_2022": "5.9",
    "sures_2023": "2.1",
    "sures_2024": "1.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 1.4",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "M 15.5",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "27.4",
    "prog_2019": "21.1",
    "prog_2022": "16.7",
    "prog_2023": "16.9",
    "prog_2024": "19.6",
    "prog_trend": "112233",
    "cote_2018": "6.3",
    "cote_2019": "6.9",
    "cote_2022": "4.9",
    "cote_2023": "5.9",
    "cote_2024": "6.4",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "L'École l'Eau-Vive",
    "nom_court": "L'École l'Eau-Vive",
    "adresse": "4690, avenue Chauveau",
    "municipalite": "Québec",
    "code_postal": "G2C 1A7",
    "lat": 46.82612,
    "lng": -71.35959
  },
  {
    "_id": "465",
    "school_code": "524501",
    "school_name_1": "Nouvelles Frontières",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Outaouais ",
    "étudiants": "1050",
    "langue": "français",
    "secteur": "privé",
    "rang": "53",
    "rang_5_ans": "37",
    "index": "0.1",
    "en_retard_2024": "2.5",
    "ehdaa_2024": "32.2",
    "rang_2024": "53/470",
    "rang_2019_2024": "37/432",
    "lens_2018": "73.9",
    "lens_2019": "74.1",
    "lens_2022": "69.3",
    "lens_2023": "71.7",
    "lens_2024": "70.3",
    "lens_trend": "—",
    "lsec_2018": "84.6",
    "lsec_2019": "86.7",
    "lsec_2022": "88.1",
    "lsec_2023": "89.1",
    "lsec_2024": "88.5",
    "lsec_trend": "112233",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "82.3",
    "scie_2019": "80.1",
    "scie_2022": "77.1",
    "scie_2023": "80.2",
    "scie_2024": "75.5",
    "scie_trend": "998855",
    "math_2018": "85.3",
    "math_2019": "84.5",
    "math_2022": "80.5",
    "math_2023": "85.7",
    "math_2024": "84.6",
    "math_trend": "—",
    "echec_2018": "3.2",
    "echec_2019": "3.8",
    "echec_2022": "8.4",
    "echec_2023": "5.8",
    "echec_2024": "9.4",
    "echec_trend": "998855",
    "sures_2018": "0.0",
    "sures_2019": "0.0",
    "sures_2022": "0.2",
    "sures_2023": "0.8",
    "sures_2024": "2.4",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "F 5.6",
    "ecart_sexes_lens_2019": "F 0.7",
    "ecart_sexes_lens_2022": "F 6.7",
    "ecart_sexes_lens_2023": "F 6.9",
    "ecart_sexes_lens_2024": "F 2.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 0.4",
    "ecart_sexes_math_2019": "F 2.8",
    "ecart_sexes_math_2022": "F 0.5",
    "ecart_sexes_math_2023": "M 2.4",
    "ecart_sexes_math_2024": "F 1.4",
    "ecart_sexes_math_trend": "—",
    "prog_2018": "1.9",
    "prog_2019": "2.4",
    "prog_2022": "5.7",
    "prog_2023": "4.0",
    "prog_2024": "1.1",
    "prog_trend": "—",
    "cote_2018": "8.7",
    "cote_2019": "9.0",
    "cote_2022": "8.3",
    "cote_2023": "8.4",
    "cote_2024": "8.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Nouvelles Frontières",
    "nom_court": "Collège Nouvelles Frontières",
    "adresse": "250, rue Gamelin",
    "municipalite": "Gatineau",
    "code_postal": "J8Y 1W9",
    "lat": 45.44395,
    "lng": -75.749
  },
  {
    "_id": "466",
    "school_code": "589501",
    "school_name_1": "Le Savoir",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "139",
    "langue": "français",
    "secteur": "privé",
    "rang": "35",
    "rang_5_ans": "75",
    "index": "0.1",
    "en_retard_2024": "0",
    "ehdaa_2024": "nd",
    "rang_2024": "35/470",
    "rang_2019_2024": "75/432",
    "lens_2018": "68.9",
    "lens_2019": "65.8",
    "lens_2022": "63.3",
    "lens_2023": "68.1",
    "lens_2024": "70.7",
    "lens_trend": "—",
    "lsec_2018": "76.8",
    "lsec_2019": "88.7",
    "lsec_2022": "81.3",
    "lsec_2023": "92.4",
    "lsec_2024": "95.1",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "86.3",
    "scie_2019": "78.5",
    "scie_2022": "77.1",
    "scie_2023": "81.3",
    "scie_2024": "75.3",
    "scie_trend": "998855",
    "math_2018": "73.6",
    "math_2019": "77.6",
    "math_2022": "88.0",
    "math_2023": "87.7",
    "math_2024": "85.1",
    "math_trend": "—",
    "echec_2018": "9.9",
    "echec_2019": "12.5",
    "echec_2022": "14.9",
    "echec_2023": "7.1",
    "echec_2024": "11.7",
    "echec_trend": "—",
    "sures_2018": "2.2",
    "sures_2019": "2.1",
    "sures_2022": "2.3",
    "sures_2023": "0.1",
    "sures_2024": "0.0",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "M 5.1",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 3.7",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "11.8",
    "prog_2019": "0.0",
    "prog_2022": "0.0",
    "prog_2023": "27.4",
    "prog_2024": "12.2",
    "prog_trend": "—",
    "cote_2018": "6.9",
    "cote_2019": "7.3",
    "cote_2022": "7.6",
    "cote_2023": "8.1",
    "cote_2024": "8.6",
    "cote_trend": "112233",
    "valid": true,
    "nom_offcl": "École le Savoir",
    "nom_court": "École le Savoir",
    "adresse": "11950, boulevard Gouin Ouest",
    "municipalite": "Montréal",
    "code_postal": "H8Z 1V6",
    "lat": 45.50674,
    "lng": -73.8257
  },
  {
    "_id": "467",
    "school_code": "602501",
    "school_name_1": "Centre académique de l'Outaouais",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Outaouais ",
    "étudiants": "73",
    "langue": "français, anglais",
    "secteur": "privé",
    "rang": "376",
    "rang_5_ans": "382",
    "index": "0.1",
    "en_retard_2024": "33.3",
    "ehdaa_2024": "nd",
    "rang_2024": "376/470",
    "rang_2019_2024": "382/432",
    "lens_2018": "60.1",
    "lens_2019": "65.6",
    "lens_2022": "61.5",
    "lens_2023": "57.6",
    "lens_2024": "61.7",
    "lens_trend": "—",
    "lsec_2018": "79.3",
    "lsec_2019": "84.7",
    "lsec_2022": "78.1",
    "lsec_2023": "81.5",
    "lsec_2024": "81.3",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.5",
    "scie_2019": "61.8",
    "scie_2022": "62.4",
    "scie_2023": "67.3",
    "scie_2024": "68.4",
    "scie_trend": "—",
    "math_2018": "71.7",
    "math_2019": "60.8",
    "math_2022": "74.0",
    "math_2023": "64.3",
    "math_2024": "70.5",
    "math_trend": "—",
    "echec_2018": "28.1",
    "echec_2019": "22.8",
    "echec_2022": "20.8",
    "echec_2023": "28.6",
    "echec_2024": "19.3",
    "echec_trend": "—",
    "sures_2018": "6.3",
    "sures_2019": "4.6",
    "sures_2022": "7.3",
    "sures_2023": "7.0",
    "sures_2024": "4.5",
    "sures_trend": "—",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "23.3",
    "prog_2019": "21.1",
    "prog_2022": "9.5",
    "prog_2023": "20.8",
    "prog_2024": "34.5",
    "prog_trend": "—",
    "cote_2018": "4.0",
    "cote_2019": "4.1",
    "cote_2022": "5.3",
    "cote_2023": "3.4",
    "cote_2024": "4.6",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Centre académique de l'Outaouais",
    "nom_court": "Centre académique de l'Outaouais",
    "adresse": "858, boulevard Maloney Est",
    "municipalite": "Gatineau",
    "code_postal": "J8P 1H1",
    "lat": 45.48504,
    "lng": -75.60595
  },
  {
    "_id": "468",
    "school_code": "605502",
    "school_name_1": "Montessori Orford",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Estrie ",
    "étudiants": "103",
    "langue": "français",
    "secteur": "privé",
    "rang": "299",
    "rang_5_ans": "nd",
    "index": "0.1",
    "en_retard_2024": "26.3",
    "ehdaa_2024": "13.6",
    "rang_2024": "299/470",
    "rang_2019_2024": "nd",
    "lens_2018": "nd",
    "lens_2019": "nd",
    "lens_2022": "nd",
    "lens_2023": "nd",
    "lens_2024": "66.2",
    "lens_trend": "nd",
    "lsec_2018": "nd",
    "lsec_2019": "nd",
    "lsec_2022": "nd",
    "lsec_2023": "nd",
    "lsec_2024": "70.5",
    "lsec_trend": "nd",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "nd",
    "scie_2019": "nd",
    "scie_2022": "nd",
    "scie_2023": "nd",
    "scie_2024": "72.7",
    "scie_trend": "nd",
    "math_2018": "nd",
    "math_2019": "nd",
    "math_2022": "nd",
    "math_2023": "nd",
    "math_2024": "75",
    "math_trend": "nd",
    "echec_2018": "nd",
    "echec_2019": "nd",
    "echec_2022": "nd",
    "echec_2023": "nd",
    "echec_2024": "20.4",
    "echec_trend": "nd",
    "sures_2018": "nd",
    "sures_2019": "nd",
    "sures_2022": "nd",
    "sures_2023": "nd",
    "sures_2024": "3",
    "sures_trend": "nd",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "nd",
    "ecart_sexes_lens_2024": "nd",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "nd",
    "ecart_sexes_math_2024": "nd",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "nd",
    "prog_2019": "nd",
    "prog_2022": "nd",
    "prog_2023": "nd",
    "prog_2024": "10.5",
    "prog_trend": "nd",
    "cote_2018": "nd",
    "cote_2019": "nd",
    "cote_2022": "nd",
    "cote_2023": "nd",
    "cote_2024": "5.3",
    "cote_trend": "nd",
    "valid": true,
    "nom_offcl": "École secondaire Montessori Orford",
    "nom_court": "École secondaire Montessori Orford",
    "adresse": "3165, chemin du Parc",
    "municipalite": "Orford",
    "code_postal": "J1X 7A2",
    "lat": 45.32684,
    "lng": -72.18066
  },
  {
    "_id": "469",
    "school_code": "635501",
    "school_name_1": "North Star",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Laval ",
    "étudiants": "146",
    "langue": "anglais",
    "secteur": "privé",
    "rang": "182",
    "rang_5_ans": "248",
    "index": "0.1",
    "en_retard_2024": "14.7",
    "ehdaa_2024": "15.8",
    "rang_2024": "182/470",
    "rang_2019_2024": "248/432",
    "lens_2018": "68.8",
    "lens_2019": "74.7",
    "lens_2022": "75.3",
    "lens_2023": "75.4",
    "lens_2024": "70.7",
    "lens_trend": "—",
    "lsec_2018": "80.9",
    "lsec_2019": "82.6",
    "lsec_2022": "84.6",
    "lsec_2023": "83.2",
    "lsec_2024": "78.6",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "65.3",
    "scie_2019": "78.3",
    "scie_2022": "76",
    "scie_2023": "85.2",
    "scie_2024": "78",
    "scie_trend": "—",
    "math_2018": "71.4",
    "math_2019": "77",
    "math_2022": "77.9",
    "math_2023": "75.8",
    "math_2024": "88.4",
    "math_trend": "112233",
    "echec_2018": "20.1",
    "echec_2019": "2.9",
    "echec_2022": "9.2",
    "echec_2023": "6.1",
    "echec_2024": "4",
    "echec_trend": "—",
    "sures_2018": "9.7",
    "sures_2019": "1.7",
    "sures_2022": "2.9",
    "sures_2023": "0.6",
    "sures_2024": "0.9",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "nd",
    "ecart_sexes_lens_2019": "nd",
    "ecart_sexes_lens_2022": "nd",
    "ecart_sexes_lens_2023": "F 16.7",
    "ecart_sexes_lens_2024": "F 10.9",
    "ecart_sexes_lens_trend": "nd",
    "ecart_sexes_math_2018": "nd",
    "ecart_sexes_math_2019": "nd",
    "ecart_sexes_math_2022": "nd",
    "ecart_sexes_math_2023": "F 18.5",
    "ecart_sexes_math_2024": "F 4.0",
    "ecart_sexes_math_trend": "nd",
    "prog_2018": "46.7",
    "prog_2019": "32.3",
    "prog_2022": "30.8",
    "prog_2023": "37.3",
    "prog_2024": "30.9",
    "prog_trend": "—",
    "cote_2018": "3.7",
    "cote_2019": "6.5",
    "cote_2022": "6.6",
    "cote_2023": "5.5",
    "cote_2024": "6.3",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Académie Étoile du Nord Laval",
    "nom_court": "Académie Étoile du Nord Laval",
    "adresse": "950, rue Élodie-Boucher",
    "municipalite": "Laval",
    "code_postal": "H7W 0C6",
    "lat": 45.53044,
    "lng": -73.78068
  },
  {
    "_id": "470",
    "school_code": "640501",
    "school_name_1": "Sainte-Anne de Lachine",
    "admin_body_number": "",
    "admin_body_name": "",
    "area_name": "Montréal ",
    "étudiants": "1961",
    "langue": "français",
    "secteur": "privé",
    "rang": "1",
    "rang_5_ans": "11",
    "index": "0.1",
    "en_retard_2024": "1.6",
    "ehdaa_2024": "8.8",
    "rang_2024": "1/470",
    "rang_2019_2024": "11/432",
    "lens_2018": "75",
    "lens_2019": "74.6",
    "lens_2022": "75.1",
    "lens_2023": "75.1",
    "lens_2024": "75.1",
    "lens_trend": "—",
    "lsec_2018": "92.4",
    "lsec_2019": "93.1",
    "lsec_2022": "89.5",
    "lsec_2023": "87.7",
    "lsec_2024": "91.5",
    "lsec_trend": "—",
    "hist_2018": "nd",
    "hist_2019": "nd",
    "hist_2022": "nd",
    "hist_2023": "nd",
    "hist_2024": "nd",
    "hist_trend": "nd",
    "scie_2018": "84.4",
    "scie_2019": "83.4",
    "scie_2022": "85.4",
    "scie_2023": "90.8",
    "scie_2024": "85.9",
    "scie_trend": "—",
    "math_2018": "86.1",
    "math_2019": "88.5",
    "math_2022": "90.6",
    "math_2023": "90.7",
    "math_2024": "91.9",
    "math_trend": "112233",
    "echec_2018": "2.2",
    "echec_2019": "2.9",
    "echec_2022": "2.2",
    "echec_2023": "2.1",
    "echec_2024": "2.8",
    "echec_trend": "—",
    "sures_2018": "1.2",
    "sures_2019": "1.3",
    "sures_2022": "1.7",
    "sures_2023": "0.9",
    "sures_2024": "0.7",
    "sures_trend": "112233",
    "ecart_sexes_lens_2018": "F 3.4",
    "ecart_sexes_lens_2019": "F 4.0",
    "ecart_sexes_lens_2022": "F 3.6",
    "ecart_sexes_lens_2023": "F 3.3",
    "ecart_sexes_lens_2024": "F 0.2",
    "ecart_sexes_lens_trend": "—",
    "ecart_sexes_math_2018": "F 3.7",
    "ecart_sexes_math_2019": "F 3.5",
    "ecart_sexes_math_2022": "F 1.4",
    "ecart_sexes_math_2023": "M 0.3",
    "ecart_sexes_math_2024": "F 0.2",
    "ecart_sexes_math_trend": "112233",
    "prog_2018": "0.8",
    "prog_2019": "1.3",
    "prog_2022": "0.3",
    "prog_2023": "1.6",
    "prog_2024": "1.3",
    "prog_trend": "—",
    "cote_2018": "9.3",
    "cote_2019": "9.6",
    "cote_2022": "9.7",
    "cote_2023": "9.4",
    "cote_2024": "10.0",
    "cote_trend": "—",
    "valid": true,
    "nom_offcl": "Collège Sainte-Anne, Lachine",
    "nom_court": "Collège Sainte-Anne, Lachine",
    "adresse": "1250, boulevard Saint-Joseph",
    "municipalite": "Montréal",
    "code_postal": "H8S 2M8",
    "lat": 45.43243,
    "lng": -73.67581
  }
]
